'use strict';
angular.module('userApp', ['LocalStorageModule', 'tmh.dynamicLocale', 'pascalprecht.translate',
	'ngResource', 'ngCookies', 'ngAria', 'ngCacheBuster', 'ngMessageFormat',
	'ngAnimate', 'ui.bootstrap', 'ui.router', 'ui.router.state.events', 'infinite-scroll', 'smart-table', 'checklist-model', 'ui.sortable',
	'ngSanitize', 'ui.bootstrap.contextMenu', 'angular.filter', 'ngTagsInput', 'ngMaterial', 'ngStorage', 'ngFileUpload',
	'kendo.directives', 'blockUI', 'isteven-multi-select', 'ui.tree', 'ngStomp', 'angular-click-outside', 'perfect_scrollbar',
	'ui.select', 'angularMoment', 'ui.tinymce', 'ui.toggle', 'multipleDatePicker', 'ngFileSaver', angularDragula(angular), 'angularjs-dropdown-multiselect', 'toastr',
	'ng-sie-ecm-tiny-editor'
])

	.run(function ($trace, $transitions, $rootScope, $location, $window, $http, $state, $translate, $uibModalStack, Language, Auth, Principal, pageTitleService, ENV, VERSION, BUILD_TIME, TAG, LANGUAGESMAP, blockUI, tmhDynamicLocale, validateEntityService, userPreferenceService) {
		$trace.enable('TRANSITION');
		var titleKey, paramsKey;
		// update the window title using params in the following
		// precendence

		$rootScope.ENV = ENV;
		$rootScope.VERSION = VERSION;
		$rootScope.TAG = TAG;
		$rootScope.BUILD_TIME = BUILD_TIME;

		// handle loading transition
		$transitions.onStart({}, function (transition) {
			blockUI.start();
			transition.promise.finally(blockUI.stop);
			//List of all states and sub-states that we need to check the existence of the entity before the transition to it.
			if ((transition.$to().name.startsWith('editorialEntity') || transition.$to().name === 'treeEEEdition') && transition.params('to').id) {
				return validateEntityService.checkIfExist(transition.params('to').id);
			}
		});

		/*
		* NOTE : Events $stateChange*** are deprectaed since ui-router 1.0.0
		* See https://ui-router.github.io/ng1/docs/latest/modules/ng1_state_events.html
		*
		* It does still work thanks to the polyfill stateEvents.js
		* (commit dec58d7213fa0c19ca6)
		*
		* We should use $transitions instead.
		*/
		$rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
			$rootScope.toState = toState;
			$rootScope.toStateParams = toStateParams;

			$rootScope.navigating = true;
			if (Principal.isIdentityResolved()) {
				Auth.authorize();
			}

			// Update the language
			Language.getCurrent().then(function (language) {
				language = language || 'fr';
				$translate.use(language);
				$rootScope.currentLang = language;
				$rootScope.currentLangFull = LANGUAGESMAP[language];
				tmhDynamicLocale.set(language);
			});

			//closing opened modals when the user click back button
			if ($uibModalStack) {
				$uibModalStack.dismissAll();
			}

		});

		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			$rootScope.navigating = false;
			// Remember previous state unless we've been redirected to login or we've just
			// reset the state memory after logout. If we're redirected to login, our
			// previousState is already set in the authExpiredInterceptor. If we're going
			// to login directly, we don't want to be sent to some previous state anyway
			if (toState.name !== 'login') {
				$rootScope.previousStateName = fromState.name;
				$rootScope.previousStateNameParams = fromParams;
			}
			// Set the page title key to the one configured in state or use default one
			titleKey = toState.data.pageTitle ? toState.data.pageTitle : 'global.title';
			paramsKey = $rootScope.pageTitleParams ? $rootScope.pageTitleParams : null;
			pageTitleService.update(titleKey, paramsKey);
		});

		// if the current translation changes, update the window title
		$rootScope.$on('$translateChangeSuccess', function () {
			pageTitleService.update(titleKey, paramsKey);
			var language = $translate.use() || 'fr';
			$rootScope.currentLang = language;
			$rootScope.currentLangFull = LANGUAGESMAP[language];
		});

		//Menu side
		$rootScope.menuLock = true;

		$rootScope.lockMenu = function () {

			if ($rootScope.menuLock) {
				$rootScope.menuLock = false;

			} else {
				$rootScope.menuLock = true;
			}

		};
		$rootScope.hoverNavLeft = function () {
			if ($rootScope.menuLock === false) {
				$rootScope.classfixmenu = true;
			}
		};


		$rootScope.outNavLeft = function () {
			if ($rootScope.menuLock === false) {
				$rootScope.classfixmenu = false;
			}
		};

	});

'use strict';

angular.module('userApp')
	.value('defaultSvgDuration', {
		client_duration: '10000',
		server_duration: '300000'
	})
	.config(function ($stateProvider) {
		$stateProvider
			.state('editorialEntity', {
				parent: 'main',
				url: "/editorialEntity/:id?editEntity&contentType",
				views: {
					'content@mainLayout': {
						templateUrl: 'scripts/app/entities/editorialEntity/editorialEntityEdit.html',
						controller: 'editorialEntityEditController'
					}
				},
				resolve: {
					editorialEntity: function ($stateParams, blockUI, EditorialEntityService) {
						return EditorialEntityService.getEEById({
							id: $stateParams.id
						}).$promise;
					},
					eEpermissions: function ($stateParams, entityAuthorizeService) {
						return entityAuthorizeService.permissions($stateParams.id);
					},
					metaInstanceByMetaGroup: function ($stateParams, EditorialEntityService, metadataResource) {
						return metadataResource.getMetaInstanceByGroup({
							id: $stateParams.id
						}).$promise;
					},
					editEntity: function ($stateParams) {
						return $stateParams.editEntity;
					},
					mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('treeFlatView');
						$translatePartialLoader.addPart('treeEeedition');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('eeLinkInfos');
						$translatePartialLoader.addPart('publish');
						$translatePartialLoader.addPart('searchInterfaceTemplate');
						$translatePartialLoader.addPart('daterangepicker');
						$translatePartialLoader.addPart('datepicker');
						return $translate.refresh();
					}]
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.defaultTitle"
				}
			})
			//TEMP STATE for treeview v2
			.state('editorialEntity.treeview', {
				url: '/treeview',
			})
			.state('editorialEntityEdit', {
				parent: 'connect',
				url: "/editor/:id?readOnly",
				component: "fullPageEditorComponent",
				resolve: {
					saveIntervals: function (EditorResource, defaultSvgDuration) {
						return EditorResource.getTempoSvgAuto().$promise.then(
							function (data) {
								data = angular.fromJson(data);
								data.client_duration = data.client_duration || defaultSvgDuration.client_duration;
								data.server_duration = data.server_duration || defaultSvgDuration.server_duration;
								return data;
							},
							function (error) {
								return defaultSvgDuration;
							});
					},
					author: function (Principal) {
						return Principal.identity();
					},
					prolexisWsUrl: function (EditorResource) {
						return EditorResource.getProlexisWsUrl().$promise.then(
							function (data) {
								return data.url;
							},
							function () { });
					},
					entityEdited: function (EditorResource, $stateParams, blockUI, $uibModal, $state, $log, entityEditorService) {
						blockUI.start();
						var ee_id = $stateParams.id;
						var readOnly = $stateParams.readOnly;
						if (readOnly) {
							return EditorResource.editReadonly({
								id: ee_id
							}).$promise.then(
								function (response) {
									return entityEditorService.handleStartEditionResponse(response, ee_id);
								}, function (err) {
									return entityEditorService.handleStartEditionError(err, ee_id);
								});
						} else {
							return EditorResource.startEdition({
								id: ee_id
							}).$promise.then(
								function (response) {
									return entityEditorService.handleStartEditionResponse(response, ee_id);
								}, function (err) {
									return entityEditorService.handleStartEditionError(err, ee_id);
								});
						}
					}
				}
			})
			.state('editorialEntityEditTreeNode', {
				parent: 'connect',
				url: "/editor/:id/:subid",
				component: "fullPageEditorComponent",
				resolve: {
					saveIntervals: function (EditorResource, defaultSvgDuration) {
						return EditorResource.getTempoSvgAuto().$promise.then(
							function (data) {
								data = angular.fromJson(data);
								data.client_duration = data.client_duration || defaultSvgDuration.client_duration;
								data.server_duration = data.server_duration || defaultSvgDuration.server_duration;
								return data;
							},
							function (error) {
								return defaultSvgDuration;
							});
					},
					author: function (Principal) {
						return Principal.identity();
					},
					prolexisWsUrl: function (EditorResource) {
						return EditorResource.getProlexisWsUrl().$promise.then(
							function (data) {
								return data.url;
							},
							function () {

							});
					},
					entityEdited: function (EditorResource, $stateParams, blockUI, $uibModal, $state, $log, entityEditorService) {
						blockUI.start();
						var ee_id = $stateParams.id;
						var ee_subid = $stateParams.subid;
						return EditorResource.startEdition({
							id: ee_id,
							subid: ee_subid
						}).$promise.then(
							function (response) {
								blockUI.stop();
								if (response.forceEdition !== true && response.editionStatus === "TECHNICAL_ERROR" ||
									response.forceEdition !== true && response.editionStatus === "INVALID") {
									var result = {};
									result.editionStatus = response.editionStatus;
									result.error = response.error;
									result.id = ee_id;
									entityEditorService.errorXmlToHtmlModal(result);
									blockUI.stop();
									throw "error transformation xml to html from entity flash id : " + ee_id;
								} else {
									return response;
								}
							},
							function (err) {
								blockUI.stop();
								$log.error("failed to start edition of entity " + ee_id);
								$state.go('editorialEntity', {
									"id": ee_id
								});
							});
					}
				}
			})

			.state('shortId', {
				url: "/editorialEntity/shortId/:id",
				parent: 'connect',
				controller: function ($state, entityFetchResource, shortId) {
					entityFetchResource.getByShortId({ shortId: shortId }).$promise.then(function (shortIdMapping) {
						$state.go('editorialEntity', {
							"id": shortIdMapping.flashId
						});
					});
				},
				resolve: {
					shortId: function ($stateParams) {
						return $stateParams.id;
					}
				}
			});
	});

'use strict';


angular.module('userApp').controller(
	'editorialEntityEditController',
	function (EDITORIAL_ELEMENT_TYPE, entityLockResource, htmlPreviewService, HTML_PREVIEW_TYPE, $scope, $sce,
		$filter, $state, currentUser, $rootScope, pageTitleService, editMetaDataModalService, workflowHistoryResource, entityAuthorizeService, ermService,
		ENTITY_RESOURCE_TYPE, editorialEntity, metaInstanceByMetaGroup, eEpermissions, userPreferenceService, $transitions, editEntity, userGroupResource, $timeout) {

		$scope.lang = $rootScope.currentLang;
		$scope.showOverloadedView = false;
		$scope.currentUser = currentUser;
		$scope.editorialEntity = editorialEntity;
		//created and import media entity
		if (angular.isDefined(editEntity)) {
			$scope.editorialEntity.editingMedia = editEntity;
		}

		// check if current user has the group
		userGroupResource.groupsByUser().$promise.then(function (userGroups) {
			var result = _.find(userGroups, { 'code': editorialEntity.ownerGroup });
			if (result) {
				$rootScope.ownerGroup = editorialEntity.ownerGroup;
			}
		});

		//set title page params
		$rootScope.pageTitleParams = {
			eeLabel: convertHtmltoString(editorialEntity.titleSystem)
		};
		pageTitleService.update($state.$current.data.pageTitle, $rootScope.pageTitleParams);
		$scope.metaDataByMetaGroup = metaInstanceByMetaGroup;
		if ($scope.editorialEntity.metaInstanceList && $scope.editorialEntity.metaInstanceList.length > 0) {
			$scope.editorialEntity.metaInformation = $scope.editorialEntity.metaInstanceList.filter(function (el) {
				return el.information === true;
			});
		}
		$scope.treeViewInstance = null;
		$scope.showNodesMetaData = {
			show: false
		};
		$scope.resize = true;
		$scope.listChannels = [];
		$scope.listChannels = $scope.editorialEntity.editorialEntityTemplate.publicationChannels;
		$scope.container = $scope.editorialEntity.editorialEntityTemplate.container;
		$scope.summaryEE = "";
		//EE default display mode
		$scope.displayMode = 'DISPLAY_METADATA';
		$scope.isTree = $scope.editorialEntity.editorialEntityTemplate.contentType === 'TREE';
		$scope.isMedia = $scope.editorialEntity.editorialEntityTemplate.contentType === 'MEDIA';
		$scope.isForm = $scope.editorialEntity.editorialEntityTemplate.formular;

		$scope.contententDisplay = {
			rightMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedRigthMargin'),
			leftMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedLeftMargin'),
		};
		//If it's a container tree, the flat view will be the default view
		if ($scope.isTree) {
			if ($scope.container) {
				$state.go('.table');
			} else {
				$scope.displayMode = 'DISPLAY_TREE_VIEW';
			}
		}

		if ($scope.isForm) {
			$scope.displayMode = 'DISPLAY_CONTENT_ONLY';
		}

		if ($scope.isMedia) {
			$scope.displayMode = 'DISPLAY_MEDIA';
		}

		$transitions.onSuccess({ to: 'editorialEntity' }, function (transition) {
			if ($scope.displayMode === 'NONE') {
				$scope.displayMode = $scope.isTree ? 'DISPLAY_TREE_VIEW' : 'DISPLAY_METADATA';
				if ($scope.displayMode === 'DISPLAY_METADATA') {
					$scope.displayMode = $scope.isForm ? 'DISPLAY_CONTENT_ONLY' : 'DISPLAY_METADATA';
				}
			}
		});

		$scope.getCurrentState = function () {
			return $state.current.name;
		};

		$scope.eEpermissions = eEpermissions;
		setActionBar();
		$scope.refreshEntity = function (eeFlashId) {
			if (eeFlashId) {
				$scope.editorialEntity.identifier = eeFlashId;
			}
			entityAuthorizeService.permissions($scope.editorialEntity.identifier)
				.then(function (permissions) {
					$scope.eEpermissions = angular.copy(permissions);
					$rootScope.$broadcast("permissions_changed", $scope.eEpermissions);
				});
			entityLockResource.padlock({
				flashId: $scope.editorialEntity.identifier
			}).$promise
				.then(function (dto) {
					$scope.editorialEntity.padlock = dto.padlock;
					$scope.editorialEntity.userLock = dto.userLock;
					$scope.editorialEntity.locked = dto.locked;
					$scope.editorialEntity.updateDate = dto.updateDate;
					$scope.editorialEntity.updater = dto.updater;
					$scope.editorialEntity.titleSystem = dto.titleSystem;
					$scope.editorialEntity.system = dto.system;
				});
			workflowHistoryResource.workflowHistory({
				flashId: $scope.editorialEntity.identifier
			}).$promise
				.then(function (data) {
					$scope.editorialEntity.workFlowHistoryDTO = angular.copy(data);
					$rootScope.$broadcast("version_changed", $scope.editorialEntity.workFlowHistoryDTO);
				});
			var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');	
			htmlPreviewService.getPreview($scope.editorialEntity.identifier, HTML_PREVIEW_TYPE.restricted, false, EDITORIAL_ELEMENT_TYPE.entity, contextProductCode)
				.then(function (result) {
					if (result) {
						$scope.editorialEntity.restrictedHtmlPreview = result.htmlPreview;
					}
				});
			$rootScope.$broadcast("refreshInformationMetaDataInstances");
		};

		$scope.refreshEntity();

		//Listen to event refresh
		$scope.$on('refresh_entity', function (event, data) {
			$scope.refreshEntity(data ? data.eeFlashId : undefined);
		});

		$scope.$on('refresh_overloaded_preview', function (event, data) {
			if ($scope.showOverloadedView) {
				htmlPreviewService.getOverloadPreview($scope.nodeSelected.id, 'REFERENCE', false)
					.then(function (result) {
						if (result) {
							$scope.newHtmlPreview = result;
							$scope.nodeSelected.htmlPreview = result;
						}
					});
			}
		});

		$scope.isMetadataEnabled = function () {
			return entityAuthorizeService.isMetadataEnabled($scope.eEpermissions);
		};

		$scope.isEditContentEnabled = function () {
			return entityAuthorizeService.isEditContentEnabled($scope.eEpermissions);
		};


		$scope.getSummary = function (editorialEntity) {
			var configExist;
			ermService.checkConfigExits($scope.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.summary)
				.then(function (data) {
					configExist = data.exist;
					if (configExist) {
						htmlPreviewService.getPreview(editorialEntity.identifier, HTML_PREVIEW_TYPE.summary)
							.then(function (eePreviewHtml) {
								$scope.summaryEE = eePreviewHtml.htmlPreview;
							});
					}
				});

		};

		$scope.switchDisplay = function (display) {
			$scope.displayMode = display;
			if (display === 'DISPLAY_TOC') {
				$scope.getSummary($scope.editorialEntity);
			}
		};




		// $scope.display =true;
		// Mouse Down Dragbar
		$scope.mdDragBar = function (e) {
			window.angular.element(document).on('mousemove', onResize);
		};

		//show nodes metadata
		$scope.showMetaData = function (show) {
			if ($scope.displayMode === 'DISPLAY_TREE_VIEW') {
				$scope.showNodesMetaData.show = show;
			}
		};
		$scope.isShowNodesMetaData = function () {
			return $scope.showNodesMetaData.show;
		};

		$scope.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};

		function formatSystemTitle() {
			var maxCar = 150;
			var tooltipTitle = $scope.editorialEntity.titleSystem;
			if (tooltipTitle && tooltipTitle.length > maxCar) {
				var posCut = tooltipTitle.indexOf(" ", maxCar);
				if (posCut === -1) { }
				$scope.titleSystemasHTML = tooltipTitle.substring(0, posCut) + "<BR/>" + tooltipTitle.substring(posCut, tooltipTitle.length);
				$scope.titleSystemasHTML = $sce.trustAsHtml($scope.titleSystemasHTML);
			} else {
				$scope.titleSystemasHTML = $sce.trustAsHtml($scope.editorialEntity.titleSystem);
			}
		}

		//Verify the autorisations to link the EE to target tree EE. 
		$scope.authorizationToLinkEE = function () {
			return $scope.eEpermissions.indexOf('LINK_EE') !== -1;
		};
		//launch link ee wizard
		$scope.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};


		// Formattage du titre pour le ToolTip.
		formatSystemTitle();

		window.angular.element(document).on('mouseup', function () {
			window.angular.element(document).off('mousemove', onResize);
		});

		var onResize = function (e) {
			e.preventDefault();
			var winWidth = angular.element(window).width();
			var moveX = winWidth - e.pageX - 20;
			if (moveX > $scope.contententDisplay.leftMargin) {
				moveX = $scope.leftMargin;
			}

			if (moveX < $scope.contententDisplay.rightMargin) {
				moveX = $scope.rightMargin;
			}
			angular.element('#idDivContenu').css({
				'flex-basis': moveX
			});
			$scope.$apply();
		};

		$scope.closePreview = function () {
			$scope.resize = false;
		};

		$scope.handleEditMetaResponse = function (response) {
			if (response) {
				$scope.metaDataByMetaGroup = response.metaDataByMetaGroup;
				//	$scope.editorialEntity.metaInstanceList = response.metadataInstances;
				$scope.updatePreviewFromEntity($scope.editorialEntity.identifier, 'RESTRICTED');
				$scope.refreshEntity();
			}
		};

		// @BLO: REFACTO : ACTION BAR FOR ENTITY
		$scope.openEditMetaModal = function () {
			editMetaDataModalService.openEditEntityMetaModal($scope.editorialEntity.identifier, undefined, $scope.editorialEntity.editorialEntityTemplate.container)
				.then(function (response) {
					$scope.handleEditMetaResponse(response);
				});
		};

		if ($rootScope.showEditModalOnLoad) {
			$rootScope.showEditModalOnLoad = false;
			$scope.openEditMetaModal();
		}

		$scope.updatePreviewFromEntity = function (flashId, typePreview) {
			htmlPreviewService.updatePreview(flashId, typePreview)
				.then(function (result) {
					if (result) {
						$scope.editorialEntity.restrictedHtmlPreview = result.htmlPreview;
					}
				});
		};


		//@BLO: REFACTO : ACTION BAR FOR NODE
		$scope.openEditMetaModalTree = function (flashId, config) {
			editMetaDataModalService.openEditEntityMetaModal(flashId, undefined, undefined, false).then(function () {
				$scope.updatePreview($scope.nodeSelected, 'COMPLETE');
				$scope.refreshEntity();
				$scope.$broadcast('refresh_tree');
			});
		};

		// UPDATE VALUE OF SHOW OVERLOADED VIEW IN THIS CONTROLLER
		$scope.overloadedPreviewSwitched = $rootScope.$on('overload_preview_switched', function (event, overloadedPreview) {
			$scope.showOverloadedView = overloadedPreview;
		});

		$scope.updatePreview = function (node) {
			var flashId;
			var typePreview;
			if (node.type === "CONTENT") {
				flashId = node.id;
				typePreview = "RESTRICTED";
			} else if (node.type === "REFERENCE") {
				flashId = $scope.showOverloadedView ? node.id : node.refNodeId;
				typePreview = $scope.showOverloadedView ? "PROOFREADING" : "COMPLETE";
			}
			if (flashId && typePreview) {
				var service = htmlPreviewService.updatePreview(flashId, typePreview);
				if ($scope.showOverloadedView) {
					service = htmlPreviewService.getOverloadPreview(flashId, 'REFERENCE', false);
				}
				service.then(function (result) {
					if (result) {
						$scope.newHtmlPreview = result;
						$scope.nodeSelected.htmlPreview = $scope.showOverloadedView ? result : result.htmlPreview;
					}
				});
			}
		};

		$scope.openEditor = function (nodeSelected) {
			if (angular.isDefined(nodeSelected) && nodeSelected !== null) {
				if (nodeSelected.type && nodeSelected.type === 'REFERENCE') {
					if (nodeSelected.refNodeTree) {
						$state.go("treeEEEdition", { id: nodeSelected.refNodeId, editionMode: 'STRUCTURE' });
					}
					else {
						$state.go("editorialEntityEdit", { id: nodeSelected.refNodeId });
					}
				}
				else {
					$state.go("editorialEntityEdit", { id: nodeSelected });
				}
			}
		};

		// handle node selection
		$scope.onNodeSelection = function (node, $event) {
			if (typeof $event !== typeof undefined) {
				$event.stopPropagation();
			}
			$scope.nodeSelected = undefined;
			$timeout(function () {
				$scope.resize = true;
				$scope.nodeSelected = node;
			});
		};

		$rootScope.isDisplayMedia = function () {
			return $scope.displayMode === 'DISPLAY_MEDIA' || $scope.displayMode === 'DISPLAY_EDIT_MEDIA';
		};

		function convertHtmltoString(text) {
			return text ? String(text).replace(/<[^>]+>/gm, '') : '';
		}

		function setActionBar() {
			$scope.actionBarConfig = {
				goToEE: {
					visible: false
				}
			};
		}

	})
	;

'use strict';
angular.module('userApp').controller(
    'LinkedEEController', ['$translate', '$sce', '$uibModalInstance', 'alreadyLinkedList', 'hookedToSameProductList', 'hookedToSameEetList', 'hookingFromTarget', 'trSelected', function ($translate, $sce, $uibModalInstance, alreadyLinkedList, hookedToSameProductList, hookedToSameEetList, hookingFromTarget, trSelected) {
        var vm = this;
        //lang
        vm.lang = $translate.use();
        //
        vm.alreadyLinkedList = alreadyLinkedList;
        //
        vm.hookedToSameProductList = hookedToSameProductList;
        //
        vm.hookedToSameEetList = hookedToSameEetList;
        //
        vm.hookingFromTarget = hookingFromTarget;
        //
        vm.confirm = function () {
            $uibModalInstance.close(true);
        };
        //
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };
        //
        vm.trSelected = trSelected;
        //
        vm.deleteHtmlTags = function (html) {
            if (angular.isDefined(html) && html !== null) {
                return html.replace(/(<([^>]+)>)/ig, "");
            }
        };
        //
        vm.trustAsHtml = function (string) {
            return $sce.trustAsHtml(vm.deleteHtmlTags(string));
        };
    }]);
'use strict';

angular.module('userApp')
    .controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
        $scope.changeLanguage = function (languageKey) {                
            $translate.use(languageKey)
            .then(function() {
              $translate.refresh();
            });
            tmhDynamicLocale.set(languageKey);
            $scope.language = languageKey;
        };

        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });
        
        //première initialisation
        if(!$scope.language){
            // Update the language
            Language.getCurrent().then(function (language) {
            	$scope.language = language;
            });
        }
    })
    .filter('findLanguageFromKey', function () {
        return function (lang) {
            return {
                "ca": "Català",
                "da": "Dansk",
                "de": "Deutsch",
                "en": "English",
                "es": "Español",
                "fr": "Français",
                "gl": "Galego",
                "hu": "Magyar",
                "it": "Italiano",
                "ja": "日本語",
                "ko": "한국어",
                "nl": "Nederlands",
                "pl": "Polski",
                "pt-br": "Português (Brasil)",
                "pt-pt": "Português",
                "ro": "Română",
                "ru": "Русский",
                "sv": "Svenska",
                "ta": "தமிழ்",
                "tr": "Türkçe",
                "zh-cn": "中文（简体）",
                "zh-tw": "繁體中文"
            }[lang];
        }
    });

'use strict';

angular.module('userApp')
	.factory('Language', function ($q, $http, $translate, LANGUAGES) {
		return {
			getCurrent: function () {
				var deferred = $q.defer();
				var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

				if (angular.isUndefined(language)) {
					language = 'fr';
				}

				deferred.resolve(language);
				return deferred.promise;
			},
			getAll: function () {
				var deferred = $q.defer();
				deferred.resolve(LANGUAGES);
				return deferred.promise;
			}
		};
	})

/*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
.constant('LANGUAGES', [
		'en', 'fr'
		// jhipster-needle-006 - JHipster will add new languages here
	])
	.constant('LANGUAGESMAP', {
		"en": 'en_US',
		"fr": 'fr_FR'
	});

'use strict';

angular.module('userApp')
    .factory('Auth', function Auth($rootScope, $state, $q, $translate, Principal, AuthServerProvider, Account) {
        return {
            login: function (credentials, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.login(credentials).then(function (data) {
                    // retrieve the logged account information
                    Principal.identity(true).then(function (account) {
                        // After the login the language will be changed to
                        // the language selected by the user during his registration
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                        deferred.resolve(data);
                    });
                    return cb();
                }).catch(function (err) {
                    //this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

                return deferred.promise;
            },

            logout: function () {
                AuthServerProvider.logout();
                Principal.authenticate(null);
                // Reset state memory
                $rootScope.previousStateName = undefined;
                $rootScope.previousStateNameParams = undefined;
                $state.go('login');
            },

            authorize: function (force) {
                return Principal.identity(force)
                    .then(function () {
                        var isAuthenticated = Principal.isAuthenticated();

                        // an authenticated user can't access to login and register pages
                        /* 
                        #SIECACTUS-488 
                        If the connected user has one user group, 
                        he will navigate to the product dashboard 
                        specific to this product 
                        if not he will navigate to home 
                        */
                        if (isAuthenticated && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'home')) {
                            if (Principal.getJoinedUserGroups().length === 1) {
                                var code = Principal.getJoinedUserGroups()[0].code;
                                $state.go('productDashboard', {
                                    'code': code
                                });
                            } else {
                                $state.go('home');
                            }
                        }

                        if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                            if (isAuthenticated) {
                                // user is signed in but not authorized for desired state
                                $state.go('accessdenied');
                            }
                            else {
                                // user is not authenticated. stow the state they wanted before you
                                // send them to the signin state, so you can return them when you're done
                                $rootScope.previousStateName = $rootScope.toState;
                                $rootScope.previousStateNameParams = $rootScope.toStateParams;

                                // now, send them to the signin state so they can log in
                                $state.go('login');
                            }
                        }
                    });
            }
        };
    });

'use strict';

angular.module('userApp')
    .directive('hasAnyAuthority', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = Principal.hasAnyAuthority(authorities);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

                if (authorities.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }])
    .directive('hasAuthority', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {

                        if (reset) {
                            setVisible();
                        }

                        Principal.hasAuthority(authority)
                            .then(function (result) {
                                if (result) {
                                    setVisible();
                                } else {
                                    setHidden();
                                }
                            });
                    },
                    authority = attrs.hasAuthority.replace(/\s+/g, '');

                if (authority.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }]);

'use strict';

angular.module('userApp')
    .factory('Principal', function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        return {
            isIdentityResolved: function () {
                return angular.isDefined(_identity);
            },
            isAuthenticated: function () {
                return _authenticated;
            },
            hasAuthority: function (authority) {
                if (!_authenticated) {
                    return $q.when(false);
                }

                return this.identity().then(function (_id) {
                    return _id.authorities && _id.authorities.indexOf(authority) !== -1;
                }, function (err) {
                    return false;
                });
            },
            hasAnyAuthority: function (authorities) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                for (var i = 0; i < authorities.length; i++) {
                    if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                        return true;
                    }
                }

                return false;
            },
            authenticate: function (identity) {
                _identity = identity;
                _authenticated = identity !== null;
            },
            identity: function (force) {
                var deferred = $q.defer();

                if (force === true) {
                    _identity = undefined;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                Account.get().$promise
                    .then(function (account) {
                        _identity = account.data;
                        _authenticated = true;
                        deferred.resolve(_identity);
                    })
                    .catch(function () {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    });
                return deferred.promise;
            },
            // retrieve the user groups data from current user
            getJoinedUserGroups: function () {
                return _identity.userGroups || [];
            }
        };
    });

'use strict';

angular.module('userApp')
	.controller('StatusBarController', function ($scope, config, TAG, BUILD_TIME) {
		$scope.env = config.environnement;
		$scope.version = config.version;
		$scope.tag = TAG;
		$scope.build_time = BUILD_TIME;
	});

'use strict';

angular.module('userApp')
    .factory('AuthServerProvider', function loginService($http, $cookies, userPreferenceService) {
        return {
            login: function (credentials) {
                var data = "username=" + encodeURIComponent(credentials.username) + "&password="
                    + encodeURIComponent(credentials.password);
                return $http.post('api/authenticate', data, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    }
                }).success(function (response) {
                    userPreferenceService.setUserGlobalPreference('token', response);
                    return response;
                });
            },
            logout: function () {
                $cookies.remove("SESSION");
                //Stateless API : No server logout
                userPreferenceService.removeFromUserGlobalPreference('token');
                //localStorageService.clearAll();
            }
        };
    });

'use strict';

angular.module('userApp').service('ModalAlertService', ['toastr',
	function (toastr) {

		var factory = {

			info: function (title, text) {
				toastr.info(title, text, {
					timeOut: 1000,
					closeButton: false
				});
			},
			error: function (title, text) {
				toastr.error(title, text);
			},
			warn: function (title, text) {
				toastr.warning(title, text);
			},
			success: function (title, text) {
				toastr.success(title, text, {
					timeOut: 1000,
					closeButton: false
				});
			}
		};

		return factory;

	}]);

'use strict';

angular.module('userApp')
    .factory('Account', function Account($resource) {
        return $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    });

'use strict';

angular.module('userApp').service('modalService', ['$uibModal',
    function ($uibModal) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            templateUrl: 'scripts/components/modal/alertModal.html'
        };

        var modalOptions = {
            isConfirm: true,
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            headerText: 'Confirme error?',
            bodyText: 'Something went wrong?'
        };

        this.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) customModalDefaults = {};
            customModalDefaults.backdrop = 'static';
            return this.show(customModalDefaults, customModalOptions);
        };

        this.show = function (customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempModalOptions;
                    $scope.modalOptions.ok = function (result) {
                        $uibModalInstance.close(result);
                    };
                    $scope.modalOptions.close = function (result) {
                        $uibModalInstance.dismiss('cancel');
                    };
                }]
            }

            return $uibModal.open(tempModalDefaults).result;
        };

    }]);

'use strict';

angular.module('userApp').directive('metaDataField', ['Upload', '$uibModal', 'relationTemplateResource', 'createLinkService', 'EditorialEntityService', 'CreateAndHookEeWizardModalService', 'MetadataService', 'blockUI', '$timeout', 'metaDataReferentielService', 'metadataValidationService', function (Upload, $uibModal, relationTemplateResource, createLinkService, EditorialEntityService, CreateAndHookEeWizardModalService, MetadataService, blockUI, $rootScope
) {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			metaDataInstance: '=',
			form: '=',
			lang: '=',
			display: '=',
			readonly: '=',
			maxSizeMedia: '=',
			editmetaee: '=',
			productCode: '<?',

			/**
				* source editorial element flash id (can be an ee or a node)
				*/
			eeSourceFlashId: '=?',
			/**
			* Editorial entity template id
			*/
			eetId: '=?',
			eetCode: '<?',
			currentUser: '=?',
			isCreatingEntity: '<',
			published: '<'

		},
		controller: MetadataFieldController,
		link: function (scope, element, attrs, $filter) {
			scope.$watch('metaDataInstance', function () {
				function isMetaEmpty(meta, display, readonly) {
					if (readonly && display) {
						if (!meta.value && (!meta.multiValuesList || _.isEmpty(meta.multiValuesList)) && (!meta.metaDataMultiValuesList || _.isEmpty(meta.metaDataMultiValuesList)) &&
							(!meta.listFiles || _.isEmpty(meta.listFiles)) && (!meta.relationDTOList || _.isEmpty(meta.relationDTOList)) &&
							(!meta.referentialValueDTOList || _.isEmpty(meta.referentialValueDTOList) &&
								(!meta.referentialTypeListDTOList || _.isEmpty(meta.referentialTypeListDTOList)))) {
							return true;
						}
					}
					return false;
				}

				var type = scope.metaDataInstance.metaDataDTO.metaDataType.toLowerCase();
				scope.dateOperatorOptions = [{ "name": 'CURRENTDATE', "value": 'CURRENTDATE' }];

				if (type === 'numeric') {
					//Numeric field max vaue
					//FIX BACK numeric should be numeric NOT STRING
					scope.metaDataInstance.value = scope.metaDataInstance.value ? _.toNumber(scope.metaDataInstance.value) : scope.metaDataInstance.value;
					scope.numericMetaDataMaxValue = 2147483647;
				}
				// Pattern to validate meta data input field
				scope.metaDataFieldPattern = new RegExp(scope.metaDataInstance.metaDataDTO.metaDataFieldPattern);
				// Create Date instance in case of Date metaData
				if (type === 'date' && scope.metaDataInstance.value) {
					scope.metaDataInstance.value = new Date(scope.metaDataInstance.value);
					if (scope.metaDataInstance.endDateCode) {
						scope.periodModel = {};
						scope.periodModel.startDate = scope.metaDataInstance.value;
						if (scope.metaDataInstance.endDateMetaDataInstanceDTO.value) {
							scope.periodModel.endDate = new Date(scope.metaDataInstance.endDateMetaDataInstanceDTO.value);
						}
					}
				}

				if (type === 'boolean' && scope.metaDataInstance.metaDataDTO.selectionFormat === "CHECKBOX" && angular.isUndefined(scope.metaDataInstance.value)) {
					scope.metaDataInstance.value = 'false';
				}


				// Function that returns the correct template for each field.
				scope.getTemplateUrl = function () {
					if (isMetaEmpty(scope.metaDataInstance, scope.display, scope.readonly)) {
						return 'scripts/components/util/metadata/meta-data-empty.html';
					}
					return 'scripts/components/util/metadata/meta-data-' + type + '.html';
				};


				if (scope.metaDataInstance.relationDTOList.length === 0) {
					scope.metaDataInstance.relationDTOList.push({});
				}

				/**
					* Create a new Target entity : 
					* relation: the relation associated to outstanding relationship meta
					* relationTemplateId: the relationTemplateId confgured on the outstanding relationship meta
					*/
				scope.setNewTargetEntity = function (relation, relationTemplateId) {
					blockUI.start();
					scope.eeSourceFlashId;
					scope.currentUser;
					EditorialEntityService.getEEById({
						id: scope.eeSourceFlashId
					}, function (data) {
						var eeSourceDetails = {
							flashId: data.identifier,
							eetCode: data.editorialEntityTemplate.code,
							container: data.editorialEntityTemplate.container,
							metaInstanceList: data.metaInstanceList,
							subNodesId: data.subNodesId,
							systemTitle: data.titleSystem,
							relationTemplateId: relationTemplateId
						};
						CreateAndHookEeWizardModalService.openModal(eeSourceDetails, null, scope.currentUser, true).then(function (result) {
							var referenceNode = result.referenceNode;
							var targetEntity = result.editorialEntity;
							var newRelation = scope.setRelationFromCreatedTarget(data.identifier, referenceNode, targetEntity);
							var relationToRemove = scope.replaceOldRelation(relation, newRelation);
							if (angular.isDefined(relationToRemove.eeTargetFlashId)) {
								scope.metaDataInstance.relationDTOList.push(relationToRemove);
							}
						});
						blockUI.stop();
					}, function () {
						blockUI.stop();
					});
				};

				function getNotDeletedRelations() {
					return _.filter(scope.metaDataInstance.relationDTOList, function (o) {
						return angular.isUndefined(o.deleted) || !o.deleted;
					});
				}

				scope.canAddRelation = function () {

					if (!scope.metaDataInstance.multipleOccurrences) {
						return false;
					}

					var lastRelation = _.last(getNotDeletedRelations());

					return lastRelation && lastRelation.eeTargetFlashId;
				};

				//Add a new relationship
				scope.addNewRelation = function () {
					scope.metaDataInstance.relationDTOList.push({});
				};

				//Update relationship Metadata 
				scope.updateRelation = function (relation) {

					blockUI.start();
					//Relationship Metadata identifier
					var mdRelationCode = scope.metaDataInstance.metaDataDTO.code;
					scope.relationshipToManage = relation;
					//Get relationship template
					relationTemplateResource.getRelationshipsTemplateInfo({
						mdRelationCode: mdRelationCode,
						eetId: scope.eetId
					}).$promise
						.then(function (trInfo) {
							var modalInstance = $uibModal.open(createLinkService.getConfigForEditorialEntityCreation(scope.eeSourceFlashId, trInfo.code));
							modalInstance.opened.then(function () {
								blockUI.stop();
							});
							modalInstance.result.then(function (linkingWizardRelations) {
								var linkingWizardRelation = linkingWizardRelations[0];
								linkingWizardRelation.strippedWording = String(linkingWizardRelation.wording).replace(/<[^>]+>/gm, '');
								var relationToRemove = scope.replaceOldRelation(relation, linkingWizardRelation);
								if (angular.isDefined(relationToRemove.eeTargetFlashId)) {
									scope.metaDataInstance.relationDTOList.push(relationToRemove);
								}
							});
						});
				};

				scope.deleteRelation = function (relation) {
					relation.deleted = true;

					if (getNotDeletedRelations().length === 0) {
						scope.addNewRelation();
					}
				};

				scope.setRelationFromCreatedTarget = function (eeSourceFlashId, referenceNode, targetEntity) {
					var relationDTO = referenceNode.relationDTO;
					var relation = {};
					var targetTitle = targetEntity.system.systemTitle;
					relation.eeSourceFlashId = eeSourceFlashId;
					relation.trCode = relationDTO.trCode;
					relation.eeTargetFlashId = targetEntity.identifier;
					relation.eeTargetCode = relationDTO.eeTargetCode;
					relation.metaInstanceDTOList = relationDTO.metaInstanceDTOList;
					relation.desiredPublicationDatev = relationDTO.desiredPublicationDate;
					relation.createdFromReferenceNode = false;
					relation.deleted = false;
					relation.subElementEeTargetFlashId = "";
					relation.eeTargetVersionMaj = targetEntity.system.systemVersionMaj;
					relation.eeTargetVersionMin = targetEntity.system.systemVersionMin;
					relation.eeTargetStepVersion = targetEntity.system.systemVersionPatch;
					if (targetTitle) {
						relation.wording = targetTitle;
						relation.strippedWording = String(targetTitle).replace(/<[^>]+>/gm, '');
					} else {
						relation.wording = 'userApp.editorialEntity.home.noTitle';
						relation.strippedWording = 'userApp.editorialEntity.home.noTitle';
					}
					return relation;
				};

				scope.replaceOldRelation = function (oldRelation, newRelation) {
					var relationToRemove = {};
					//Keep copy of old relation
					angular.copy(oldRelation, relationToRemove);
					//Replace old relation by new one
					angular.copy(newRelation, oldRelation);
					//Set up deleted attributed on relation to remove and return it
					relationToRemove.deleted = true;
					return relationToRemove;
				};

				scope.periodChanged = function (startDate, endDate) {
					scope.metaDataInstance.value = startDate;
					scope.metaDataInstance.endDateMetaDataInstanceDTO.value = endDate;
				};

			});


		},
		template: '<div ng-include="getTemplateUrl()"></div>'
	};


}]);

/** @ngInject */
function MetadataFieldController
	($scope, $filter, $uibModal, Upload, $translate, $q, $rootScope, $window, $sce, metaDataReferentielService, metadataValidationService, MetadataService, $timeout) {
	$scope.referentialValueDisplay = [];
	$scope.metaDataMultiValuesDisplay = [];
	// initialize regex from format meta data numeric
	$scope.regex = metadataValidationService.validateMetDataNumeric($scope.metaDataInstance.metaDataDTO);


	$scope.onDateChange = function () {
		$scope.resetErrorMetaDiscriminants($scope.metaDataInstance.discriminant);
	};

	$scope.onEndDateChange = function () {
		$scope.resetErrorMetaDiscriminants($scope.metaDataInstance.endDateMetaDataInstanceDTO.discriminant);
	};

	// IF METADATA NUMERIC OR ALPHANUMERIC CHECK IF VALUE INSERTED UNIQUE OR NOT (NOT ALREADY USED)
	// THIS SOME CHECK IS USED FOR MULTIOCCURRENCE AND MONOOCCURRENCE VALIDATION
	$scope.checkIsValueUnique = function (tag) {

		$scope.resetErrorMetaDiscriminants($scope.metaDataInstance.discriminant);
		$scope.metaDataInstance.displayNotUniqueValueErrorMsg = false;
		var type = $scope.metaDataInstance.metaDataDTO.metaDataType.toLowerCase();
		var metadataValue = (angular.isDefined(tag)) ? tag.text : $scope.metaDataInstance.value;
		if (!!metadataValue && (type === 'numeric' || type === 'alphanumeric') && $scope.metaDataInstance.metaDataDTO.uniqueValue) {
			MetadataService.checkIsValueUnique($scope.eeSourceFlashId, $scope.metaDataInstance.metaDataDTO.code, metadataValue, $rootScope.ownerGroup).then(function (data) {
				//if ngInputTags validation
				if (angular.isDefined(tag)) {
					//Keep display error message if there is already tag in orror or new one is in error
					$scope.metaDataInstance.displayNotUniqueValueErrorMsg = ($scope.metaDataInstance.displayNotUniqueValueErrorMsg || !data.isValueUnique);
					//Set added tag invalid
					tag.isNotUnique = !data.isValueUnique;
				} else {
					$scope.metaDataInstance.displayNotUniqueValueErrorMsg = !data.isValueUnique;
				}
			});
		}
	};

	// IF METADATA NUMERIC OR ALPHANUMERIC AND IS MULTIVALUED, CHECK IF VALUE INSERTED UNIQUE OR NOT (NOT ALREADY USED)
	// CHECK ALL TAGS VALUES WHEN TAG DELETE
	$scope.checkIsAllValuesUnique = function (tag) {

		$scope.resetErrorMetaDiscriminants($scope.metaDataInstance.discriminant);
		var type = $scope.metaDataInstance.metaDataDTO.metaDataType.toLowerCase();
		//create string array of meta values since object tags array
		var metaValues = _.map($scope.metaDataInstance.multiValuesList, 'text');
		if (metaValues.length > 0 && (type === 'numeric' || type === 'alphanumeric') && $scope.metaDataInstance.metaDataDTO.uniqueValue) {
			MetadataService.checkIsAllValuesUnique($scope.eeSourceFlashId, $scope.metaDataInstance.metaDataDTO.code, metaValues, $rootScope.ownerGroup).then(function (data) {
				$scope.metaDataInstance.displayNotUniqueValueErrorMsg = !data.isAllValuesUnique;
				$rootScope.isInputTouched = $scope.metaDataInstance.displayNotUniqueValueErrorMsg;
			});
		} else {
			$scope.metaDataInstance.displayNotUniqueValueErrorMsg = false;
			$rootScope.isInputTouched = false;
		}

	};


	$scope.resetErrorMetaDiscriminants = function (discriminant) {

		if (discriminant) {
			$rootScope.$broadcast("reset_discriminant_meta_value_error_msg", true);
		}
	};

	//meta-data-list.html
	$scope.listSelectedValue = _.find($scope.metaDataInstance.metaDataDTO.listMetaDataValues, ['identifier', $scope.metaDataInstance.value]);
	// when change language
	$scope.$on('$destroy', $scope.$on('$translateChangeSuccess', function () {
		$scope.lang = $translate.use() || 'fr';
	}));

	$scope.addMetaToList = function (meta) {
		$scope.metaDataInstance.referentialTypeListDTOList.push(meta);
	};
	//
	$scope.trustAsHtml = function (string) {
		return $sce.trustAsHtml(string);
	};
	$scope.isInputTouched = function (keycode) {
		if (keycode !== 13) {
			$rootScope.isInputTouched = true;
		}
		else if (keycode === 8) {
			$rootScope.isInputTouched = false;
		}
	};
	/**
		* methods from autocomplete for tag input component
		*/
	$scope.loadTags = function (query) {
		var deferred = $q.defer();
		var autoCompleteTags = $scope.referentialValueList;
		deferred.resolve(autoCompleteTags);
		return deferred.promise;

	};
	$scope.loadTagsForMetaDataList = function (query) {
		var deferred = $q.defer();
		var autoCompleteTags = $scope.metaDataInstance.metaDataDTO.listMetaDataValues;
		deferred.resolve(autoCompleteTags);
		return deferred.promise;
	};

	// A discuter!!
	var type = $scope.metaDataInstance.metaDataDTO.metaDataType.toLowerCase();

	if (type === 'date') {
		$scope.dateFmt = $filter('translate')('global.dateFormat');
	}

	if (type === 'alphanumeric') {
		if ($scope.metaDataInstance.multiValuesList.length <= 0 && !_.isEmpty($scope.metaDataInstance.value) && $scope.metaDataInstance.multipleOccurrences) {
			$scope.metaDataInstance.multiValuesList.push({
				text: $scope.metaDataInstance.value
			});
		}
	}

	// Set up regex for meta data value and explain text to display as placehorlder
	if ($scope.metaDataInstance.metaDataDTO.regex) {
		var regexExplainTextFr = $scope.metaDataInstance.metaDataDTO.regexExplainTextFr;
		var regexExplainTextEn = $scope.metaDataInstance.metaDataDTO.regexExplainTextEn;
		$scope.regexExplainText = $scope.lang === 'fr' ? regexExplainTextFr : regexExplainTextEn;
		if (type === 'numeric') {
			$scope.metaDataInstance.metaDataDTO.placeHolderInfoMsgKey = $scope.regexExplainText;
		}
	}

	$scope.metaDataMultiValuesDisplay = $scope.metaDataInstance.metaDataMultiValuesList;

	$scope.getAlphaMultiName = function (index) {
		return 'alphaMulti' + $scope.metaDataInstance.displayOrder + index;
	};

	$scope.addAlphaElem = function (event, index) {
		var indexToFocus;

		if (event && event.which === 13) {
			event.preventDefault();
			if ($scope.metaDataInstance.multiValuesList[index] && !_.isEmpty($scope.metaDataInstance.multiValuesList[index].text)) {
				$scope.metaDataInstance.multiValuesList.splice(index + 1, 0, { text: '' });
				indexToFocus = index + 1;
			}
		}
		else if (!event) {
			indexToFocus = $scope.metaDataInstance.multiValuesList.length;
			$scope.metaDataInstance.multiValuesList.splice(indexToFocus, 0, { text: '' });
		}

		if (indexToFocus) {
			$timeout(function () { angular.element("[name='" + $scope.getAlphaMultiName(indexToFocus) + "']").focus(); });
		}
	};

	$scope.removeAlphaElem = function (index, event) {
		if (event && event.which === 8 && $scope.metaDataInstance.multiValuesList[index] && _.isEmpty($scope.metaDataInstance.multiValuesList[index].text)) {
			$scope.metaDataInstance.multiValuesList.splice(index, 1);
			$timeout(function () { angular.element("[name='" + $scope.getAlphaMultiName(index - 1) + "']").focus(); });
		}
		else if (!event && $scope.metaDataInstance.multiValuesList.length > index) {
			$scope.metaDataInstance.multiValuesList.splice(index, 1);
		}
	};

	$scope.openCalendarModal = function () {
		$scope.modalInstance = $uibModal.open({
			templateUrl: 'scripts/components/util/metadata/modalCalendar.html',
			scope: $scope,
			controller: 'ModalCalendarController',

			resolve: {

				metaDataInstance: function () {
					return $scope.metaDataInstance;
				}
			},
			size: 'width-calendar',
			backdrop: 'static'
		});
		$scope.modalInstance.result.then(function (selectedItem) {
			$scope.metaDataInstance.multiValuesList = $scope.castToTagDTO(selectedItem.listOfDate);

		});
	};

	$scope.castToTagDTO = function (element) {
		var listOfTagDTO = [];
		for (var i = 0, len = element.length; i <= len - 1; i++) {
			listOfTagDTO.push({ text: element[i].format('YYYY-MM-DDTHH:mm:ss.sssZ') });
		}

		return listOfTagDTO;

	};


	$scope.getTextareaRemainingNumber = function (metaDataInstance, defaultValue) {
		var text = metaDataInstance.value ? metaDataInstance.value.replace(/<[^>]+>/gm, "") : "";
		text = angular.element('<textarea />').html(text).text();
		return $scope.getTextMaxLength(metaDataInstance.metaDataDTO, defaultValue) - text.length;
	};

	$scope.getTextMaxLength = function (metaDataDTO, defaultValue) {
		return metaDataDTO.textLength ? metaDataDTO.textLength : defaultValue;
	};

	$scope.handler = $scope.$on('product-code-change', function () {
		$scope.checkIsValueUnique();
	});

	$scope.$on('$destroy', $scope.$on('metadata_value_changed', function ($event, meta) {
		if ($scope.metaDataInstance.masterLinked && $scope.metaDataInstance.masterCode === meta.metaDataDTO.code) {
			$timeout(function () {
				if (!($scope.published && $scope.metaDataInstance.nonEditableAfterPublication)) {
					$scope.metaDataInstance.value = meta.value;
				}
			});
		}
	}));

	$scope.valueChanged = function () {
		if ($scope.metaDataInstance.master) {
			$rootScope.$broadcast('metadata_value_changed', $scope.metaDataInstance);
		}

		if ($scope.metaDataInstance.masterCode) {
			$scope.metaDataInstance.masterLinked = false;
		}
	};
}



/** @ngInject */
angular.module('userApp').controller('ModalCalendarController', function ($scope, $uibModalInstance, $translate, metaDataInstance, moment) {

	$scope.ListDateToEdit = metaDataInstance.multiValuesList;
	$scope.listOfDate = [];

	if ($scope.ListDateToEdit.length > 0) {
		for (var i = 0, len = $scope.ListDateToEdit.length; i <= len - 1; i++) {
			$scope.listOfDate.push(moment(moment(($scope.ListDateToEdit[i].text)).format('YYYY-MM-DDTHH:mm:ss.sssZ')));
		}


	}


	$scope.ok = function () {

		$uibModalInstance.close($scope);
	};

	$scope.cancel = function () {

		$uibModalInstance.dismiss('cancel');
	};

	$scope.reset = function () {
		$scope.listOfDate = [];

	};





}).filter('booleanMetaReadOnlyLabel', function ($filter) {
	return function (input) {
		if (input === 'true') {
			return $filter('translate')('userApp.editorialEntity.fields.values.yes');
		} else if (input === 'false') {
			return $filter('translate')('userApp.editorialEntity.fields.values.no');
		}
	};
});

(function () {
	'use strict';

	angular
		.module('userApp')
		.controller('ModalTreeRepositoryController', function ($timeout, $scope, $uibModalInstance, $translate, metaDataInstance, referentialValueDisplay, multiple, tree, stringUtil) {

			$scope.isLoading = true;
			var flatMap = [];

			$scope.referentialValueDisplay = referentialValueDisplay;


			function returnChildren(node) {
				if (node && node.children && node.children.length > 0) {
					return [node, _.flatMapDeep(node.children, returnChildren)];
				}
				return [node];
			}



			$scope.treeNodes = _.cloneDeep(tree);
			$scope.filteredNodes = $scope.treeNodes;
			$scope.referentialValueDTOList = _.cloneDeep(metaDataInstance.referentialValueDTOList) || [];
			$scope.isLoading = false;
			$scope.repositoryMetaData = metaDataInstance.metaDataDTO;
			flatMap = _.flatMapDeep($scope.treeNodes, returnChildren);

			$scope.refMap = [];
			$scope.referentialValueDisplay.forEach(function (n) {
				$scope.refMap[n.identifier] = true;
			});

			$scope.lang = $translate.use();

			$scope.filterValues = [];
			if (multiple) {

				angular.forEach(metaDataInstance.multiValuesList, function (refValue) {
					$scope.filterValues.push(refValue.text);
				});
			} else {
				$scope.filterValues.push(metaDataInstance.value);
			}

			$scope.referentialValueDisplay = _.cloneDeep(referentialValueDisplay) || [];

			function copy(o) {
				return Object.assign({}, o);
			}

			$scope.initCollapse = function (node) {
				if (angular.isUndefined(node.collapsed)) {
					node.collapsed = true;
				}
			};

			$scope.trackByRefId = function (node, index) {
				return node.refValueId;
			};

			$scope.filterChanged = function () {
				var textToHighlightList = [];
				var elem = angular.element('#tree-root');
				var isStartsWithSearch = $scope.repositoryMetaData && $scope.repositoryMetaData.searchType && $scope.repositoryMetaData.searchType === "STARTSWITH";
				if ($scope.treeFilter && $scope.treeFilter.length > 2) {
					var textToHilight = $scope.treeFilter;
					$scope.filteredNodes = $scope.treeNodes.map(copy).filter(function f(o) {
						if (o.children) {
							var childrenRes = (o.children = o.children.map(copy).filter(f)).length;
							if (childrenRes > 0) {
								o.collapsed = false;
								return true;
							}
						}

						var ret = false;
						var metaLabel = o.labelFR.toLowerCase();
						var searchText = $scope.treeFilter.toLowerCase();

						if (!stringUtil.hasAccent(searchText)) {
							metaLabel = stringUtil.noAccent(metaLabel);
							searchText = stringUtil.noAccent(searchText);
						}

						if (isStartsWithSearch) {
							if (metaLabel.indexOf(searchText) === 0) {
								ret = true;
							}
						}
						else {
							if (metaLabel.includes(searchText)) {
								ret = true;
							}
						}

						if (ret) {
							var index = metaLabel.search(searchText);
							var length = searchText.length;
							textToHilight = o.labelFR.substr(index, length);
							textToHighlightList.push(textToHilight);
							o.collapsed = false;
						}
						return ret;
					});

					$timeout(function () {
						textToHighlightList = textToHighlightList.filter(function (value, index) {
							return textToHighlightList.indexOf(value) === index;
						});
						elem.unmark({
							done: function () {
								angular.element('#tree-root').mark(textToHighlightList,
									{
										separateWordSearch: false,
										diacritics: false,
										className: 'highlight',
										element: 'ecm-hl',
										filter: function (node, term, totalCounter, counter) {
											var metaLabel = node.textContent ? node.textContent.trim().toLowerCase() : "";
											var searchText = term.toLowerCase();
											if (isStartsWithSearch) {
												if (metaLabel.indexOf(searchText) === 0) {
													return true;
												}
												return false;
											}
											return true;
										}
									});
							}
						});
					});
				}
				else {
					elem.unmark();
					$scope.filteredNodes = $scope.treeNodes;
				}
			};

			$scope.toggleAll = function (value, path) {

				if (!value) {
					value = _.find(flatMap, ['refValueId', path.identifier]);
				}

				if (!multiple) {
					$scope.toggleForOnlyValue(value);
					$scope.addNodeToListNotMultivalues(value);
				} else {

					var path = _.join(value.paths, '/');
					if ($scope.refMap[value.refValueId]) {
						$scope.filterValues.push(value.labelFR);
						$scope.referentialValueDTOList.push(value.refValueId);
						$scope.referentialValueDisplay.push({ "identifier": value.refValueId, "path": path });
					} else {
						_.remove($scope.referentialValueDisplay, function (n) {
							return n.identifier === value.refValueId;
						});
						_.remove($scope.filterValues, function (n) {
							return n === value.labelFR;
						});
						_.remove($scope.referentialValueDTOList, function (n) {
							return n === value.refValueId;
						});
					}
				}
			};

			$scope.getPath = function (value) {
				var path = _.join(value.paths, '->');
				$scope.pathObject = Object.values({ "identifier": value.refValueId, "path": path });
			};

			// add label to list of checked nodes case not multivalue
			$scope.addNodeToListNotMultivalues = function (value) {
				var path = _.join(value.paths, '/');
				if ($scope.refMap[value.refValueId]) {

					$scope.referentialValueDisplay.pop();
					$scope.referentialValueDisplay.push({ "identifier": value.refValueId, "path": path });
					$scope.filterValues = [];
					$scope.filterValues.push(value.labelFR);
					$scope.referentialValueDTOList = [];
					$scope.referentialValueDTOList.push(value.refValueId);
				} else {
					$scope.referentialValueDisplay.pop();
					$scope.filterValues = [];
					$scope.referentialValueDTOList = [];
				}
			};

			//browse  parents for meta not multivalueted unchecked all
			$scope.toggleForOnlyValue = function (value) {
				$scope.refMap = _.mapValues($scope.refMap, function () {
					return false;
				});

				$scope.refMap[value.refValueId] = true;
			};

			$scope.ok = function () {
				$uibModalInstance.close($scope);
			};

			$scope.cancel = function () {
				$uibModalInstance.dismiss('cancel');
			};
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('confirmModalValidation', {
			templateUrl: 'scripts/pre-upgrade/components/commons/confirm-modal/confirm-validation/confirm-validation.html',
			controller: ConfirmModalValidation,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ConfirmModalValidation() {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.includeLinksButtonText = ctrl.resolve.button.includeLinksButtonText;
			ctrl.onlyEeButtonText = ctrl.resolve.button.onlyEeButtonText;
			ctrl.cancelButtontext = ctrl.resolve.button.cancelButtontext;
		};

		ctrl.confirm = function (confirmation) {
			ctrl.close({ $value: confirmation });
		};

		ctrl.cancel = function () {
			ctrl.dismiss();
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('metadataValidationService', MetadataValidationService);


	/** @ngInject */
	function MetadataValidationService(EditorialEntityService, blockUI, $uibModal, entityTemplateResource, $http) {

		var service = {
			isNotTreeAssigned: isNotTreeAssigned,
			isNotAllMediasAssigned: isNotAllMediasAssigned,
			isNotMultiSelectListAssigned: isNotMultiSelectListAssigned,
			validateMetDataNumeric: validateMetDataNumeric,
			isMetadataUniqueValueViolated: isMetadataUniqueValueViolated
		};

		return service;

		function isNotAllMediasAssigned(metaDataByMetaGroup) {
			var listMEDIA = getListMetaInstanceMedia(metaDataByMetaGroup);
			var isAllAssigned;
			var size = 0;
			if (listMEDIA === null || listMEDIA.length === 0) {
				isAllAssigned = false;
			} else if (listMEDIA !== null && listMEDIA.length > 0) {
				for (var i = 0, len = listMEDIA.length; i <= len - 1; i++) {
					var metaInstanceDto = listMEDIA[i];
					if (angular.isDefined(metaInstanceDto.listMediaFiles) && angular.isDefined(metaInstanceDto.temporraryListFile) && (Object.keys(metaInstanceDto.listMediaFiles).length > 0 || metaInstanceDto.temporraryListFile.length > 0)) {
						size++;
					}
				}
				if (size === listMEDIA.length) {
					isAllAssigned = false;
				} else {
					isAllAssigned = true;
				}
			}
			return isAllAssigned;
		}

		/**
		 * Return true if there is one or more metadata where value not unique constraint is violated
		 * @param metaDataByMetaGroup
		 * @returns {boolean}
		 */
		function isMetadataUniqueValueViolated(metaDataByMetaGroup) {
			var metaInstances = _.flatMap(metaDataByMetaGroup, function (metaDataByMetaGroup) {
				return metaDataByMetaGroup.metaDataInstanceDTOList;
			});
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(metaInstances, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		}

		// verify if all the metaDataInstances "MEDIA" are not assigned
		function getListMetaInstanceMedia(metaDataByGroup) {
			var listMEDIA = [];
			if (metaDataByGroup !== null && metaDataByGroup.length > 0) {
				for (var i = 0, len = metaDataByGroup.length; i <= len - 1; i++) {
					var metaInstanceByGrp = metaDataByGroup[i];
					for (var j = 0, lenGrp = metaInstanceByGrp.metaDataInstanceDTOList.length; j <= lenGrp - 1; j++) {
						var metaInstanceDto = metaInstanceByGrp.metaDataInstanceDTOList[j];
						if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA" && metaInstanceDto.mandatory &&
							metaInstanceDto.metaDataDTO.authorized) {
							listMEDIA.push(metaInstanceDto);
						}
					}
				}
			}
			return listMEDIA;
		}

		//verify if all the metaDataInstances "Repository"  type tree are not assigned	
		function isNotTreeAssigned(metaDataByMetaGroup) {
			var authorizedTree = false;
			if (angular.isDefined(metaDataByMetaGroup.metaDataInstanceDTOList)) {
				if (metaDataByMetaGroup.metaDataInstanceDTOList !== null && metaDataByMetaGroup.metaDataInstanceDTOList.length > 0) {
					for (var i = 0, len = metaDataByMetaGroup.metaDataInstanceDTOList.length; i <= len - 1; i++) {
						var metaInstanceDto = metaDataByMetaGroup.metaDataInstanceDTOList[i];
						if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.referential !== null && metaInstanceDto.metaDataDTO.metaDataType === "REPOSITORY"
							&& metaInstanceDto.metaDataDTO.referential.type === "TREE" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized
							&& (metaInstanceDto.referentialValueDTOList === null ||
								!metaInstanceDto.referentialValueDTOList.length > 0 ||
								angular.isDefined(metaInstanceDto.referentialValueDTOList))) {
							authorizedTree = true;
							break;
						}
					}
				}
			}
			return authorizedTree;
		}

		function isNotMultiSelectListAssigned(metaInstanceList) {
			var authorizedList = false;
			if (metaInstanceList !== null && metaInstanceList.length > 0) {
				for (var i = 0, len = metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "REPOSITORY" && metaInstanceDto.metaDataDTO.referential !== null &&
						metaInstanceDto.metaDataDTO.referential.type === "LIST" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized &&
						(metaInstanceDto.referentialTypeListDTOList === null
							|| !metaInstanceDto.referentialTypeListDTOList.length > 0
							|| angular.isDefined(metaInstanceDto.referentialTypeListDTOList))) {
						authorizedList = true;
						break;
					}
				}
			}
			return authorizedList;
		}


		function validateMetDataNumeric(metaData) {
			if (metaData.regex) {
				return metaData.regex;
			} else if (metaData.negativeAllowed) {
				if (metaData.commaAllowed) {
					return /^-?\d*\.?\d+$/;
				} else {
					return /^-?\d+$/;
				}

			} else {
				if (metaData.commaAllowed) {
					return /^\d*\.?\d+$/;
				} else {
					return /^\d+$/;
				}
			}
		}


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('archiveEntityModalService', ArchiveEntityModalService);


	/** @ngInject */
	function ArchiveEntityModalService(relationResource, blockUI, $uibModal, entityOperationResource, ModalAlertService, $filter, $state) {
		var service = {
			openModal: openModal,
			openModalMulti: openModalMulti,
			archiveEditorialEntities: archiveEditorialEntities
		};

		return service;

		function openModal(editorialEntity) {
			blockUI.start();
			//If the editorial entity to archive is the target of a relationship, 
			//it is necessary to display the list of EE sources of the impacted relationships
			relationResource.getByEeTarget({
				eeTargetFlashId: editorialEntity.identifier, trType: 'accrochage'
			}).$promise.then(function (data) {
				var eeSourceList = [];

				angular.forEach(angular.fromJson(angular.toJson(data)), function (value, key) {
					eeSourceList.push({
						flashId: key,
						title: value
					});
				});

				var modalInstance = $uibModal.open({
					component: 'archiveEntityModal',
					resolve: {
						editorialEntity: function () { return editorialEntity; },
						eeSourceList: function () { return eeSourceList; },
						translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('archiveEditorialEntity');
							return $translate.refresh();
						}]
					},
					size: 'lg',
					backdrop: 'static'
				});

				modalInstance.opened.then(function () {
					blockUI.stop();
				});

			});

		}

		function openModalMulti(eeTargetFlashIdList) {
			blockUI.start();
			//If the editorial entities to archive are the target of many relationships, 
			//it is necessary to display the list of EE sources of the impacted relationships
			relationResource.getByTargetEditorialEntities(eeTargetFlashIdList).$promise.then(function (entities) {
				//The list of editorial entities that the user does not have the right to archive
				var eeTargetListNotToArchive = [];
				// The list of entities that has all conditions to be archives (no source link and archive permission allowed)
				var allowedEntitiesToBeArchived = [];
				var allowedEntityIdsToBeArchived = [];
				// The list of entities that are not  allowed to be archives because have source link(s)
				var entitiesLinkedToSource = [];


				_.forEach(entities, function (targetEntity) {
					var eeSourceList = [];
					if (targetEntity.archivePermissionAllowed) {
						_.forEach(targetEntity.sourceEntities, function (sourceEntity) {
							eeSourceList.push({
								eeSourceTitle: sourceEntity.title,
								eeSourceFlashId: sourceEntity.identifier
							});
						});

						if (eeSourceList.length === 0) {
							allowedEntitiesToBeArchived.push({
								eeTargetFlashId: targetEntity.identifier,
								eeTargetTitle: targetEntity.title,
								eeSourceList: eeSourceList
							});
							allowedEntityIdsToBeArchived.push(targetEntity.identifier);
						} else {
							entitiesLinkedToSource.push({
								eeTargetFlashId: targetEntity.identifier,
								eeTargetTitle: targetEntity.title,
								eeSourceList: eeSourceList
							});
						}
					} else {
						eeTargetListNotToArchive.push({
							eeTargetFlashId: targetEntity.identifier,
							eeTargetTitle: targetEntity.title
						});
					}
				});

				var isAnyEntityToArchive = allowedEntitiesToBeArchived.length === 0;

				//If all selected entities can be archived no need to display modal
				if (allowedEntitiesToBeArchived.length === entities.length) {
					blockUI.stop();
					archiveEditorialEntities(allowedEntityIdsToBeArchived);
				} else {
					var archiveModal = $uibModal.open({
						component: 'multiArchiveEntityModal',
						resolve: {
							allowedEntitiesToBeArchived: function () { return allowedEntitiesToBeArchived; },
							entitiesLinkedToSource: function () { return entitiesLinkedToSource; },
							isAnyEntityToArchive: function () { return isAnyEntityToArchive; },
							eeTargetListNotToArchive: function () { return eeTargetListNotToArchive; },
							allowedEntityIdsToBeArchived: function () { return allowedEntityIdsToBeArchived; },
							translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
								$translatePartialLoader.addPart('archiveEditorialEntity');
								$translatePartialLoader.addPart('editorialEntity');
								return $translate.refresh();
							}]
						},
						size: 'lg',
						backdrop: 'static'
					});

					archiveModal.opened.then(function () {
						blockUI.stop();
					});
				}
			});
		}

		function archiveEditorialEntities(allowedEntityIdsToBeArchived) {
			blockUI.start();
			entityOperationResource.archiveEditorialEntities(allowedEntityIdsToBeArchived).$promise.then(function (data) {
				return data;
			}).then(function (ee) {
				blockUI.stop();
				//Display success message
				ModalAlertService.success("'" + $filter('translate')('userApp.archiveEditorialEntity.home.success') + "'", $filter('translate')('userApp.archiveEditorialEntity.home.archivePerformed'), '');
				//Refresh the current page
				$state.reload();
			}).catch(function (error) {
				blockUI.start();
				ModalAlertService.error("'" + $filter('translate')('userApp.archiveEditorialEntity.home.failure') + "'", $filter('translate')('userApp.editorialEntity.msg.ERROR_TECH') + error.data.error, '');
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('cloneEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/clone-entity-modal/clone-entity-modal.html',
			controller: CloneEntityModalController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function CloneEntityModalController($rootScope, $filter, $state, cloneEntityModalService, ModalAlertService, blockUI, $translate, $scope, validateEntityService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.flashId = ctrl.resolve.editorialEntity.identifier;
			ctrl.errorExistEntityWithSomeMetaDiscriminants = false;
			ctrl.initCloningFields();
		};

		ctrl.initCloningFields = function () {
			ctrl.editorialEntity.system.systemTitle = undefined;
			ctrl.lang = $translate.use();
			ctrl.maxSizeMedia = ctrl.resolve.maxSizeMedia.maxSize;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.editorialEntity.metaInstanceList = ctrl.resolve.metaDataInstanceDTOList;
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		//Reset error msg of all discriminant meta data if already shown
		$rootScope.$on('$destroy', $rootScope.$on('reset_discriminant_meta_value_error_msg', function () {

			//if error messages shown, rest all them
			if (ctrl.errorExistEntityWithSomeMetaDiscriminants) {
				_.each(ctrl.editorialEntity.metaInstanceList, function(metaInstance) {
					ctrl.errorExistEntityWithSomeMetaDiscriminants = false;
					if(metaInstance.discriminant === true) {
						metaInstance.errorExistMetaDiscriminants = false;
					}
				});
			}
		}));

		/**
		 * Return true if there is one or more metadata where value not unique constraint is violated
		 */
		ctrl.isMetadataUniqueValueViolated = function () {
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		};

		ctrl.validateAndClone = function() {

			var discriminantsMetas = _.filter(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
				return metaInstance.discriminant === true;
			});

			if (discriminantsMetas.length > 0) {
				validateEntityService.checkIfEntityExistWithSomeDiscriminants(ctrl.editorialEntity.metaInstanceList, ctrl.editorialEntity.editorialEntityTemplate.code)
					.$promise.then(function (data) {
						ctrl.errorExistEntityWithSomeMetaDiscriminants = data.exist;
						if (!ctrl.errorExistEntityWithSomeMetaDiscriminants) {
							ctrl.cloneEditorialEntity();
						} else {
						//set form prestine to force form to be unsubmitted and keep clone button enabled
							$scope.cloneEditorialEntityForm.$setPristine();
							_.each(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
								if (metaInstance.discriminant === true) {
									metaInstance.errorExistMetaDiscriminants = true;
								}
							});
						}
					});
			} else {
				ctrl.cloneEditorialEntity();
			}
		};

		/**
		 * Clone an editorial entity with potential proposal
		 * @param {*} editorialEntity
		 */
		ctrl.cloneEditorialEntity = function () {
			if (_.isEmpty(ctrl.editorialEntity.system.systemTitle)) {
				ctrl.editorialEntity.system.systemTitle = ctrl.resolve.editorialEntity.titleSystem;
			}
			blockUI.start();
			cloneEntityModalService.clone(ctrl.editorialEntity).then(function (result) {
				ctrl.close({ $value: true });
				blockUI.stop();
				//Display success message	
				ModalAlertService.success("'" + $filter('translate')('userApp.cloneEditorialEntity.home.success') + "'", $filter('translate')('userApp.cloneEditorialEntity.home.clonePerformed'), '');
				//Go to the cloned editorial entity
				$state.go('editorialEntity', {
					id: result.eeClonedFlashId
				});
			});
		};

		ctrl.onChangeProductGroup = function (ownerGroup) {
			//emit event to system author component when owner group change
			if (ownerGroup !== ctrl.resolve.editorialEntity.ownerGroup) {
				$scope.$broadcast('ownerGroupUpdated', ownerGroup);
			}
		};

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('cloneEntityModalService', CloneEntityModalService);


	/** @ngInject */
	function CloneEntityModalService(blockUI, duplicateEntityModalService, entityOperationResource, productResource, ModalAlertService, $uibModal, MetadataService, metadataResource, EDITORIAL_ELEMENT_TYPE, entityFetchResource, entityCloneResource) {
		var service = {
			openModal: openModal,
			openValidationModal: openValidationModal,
			clone: clone
		};

		return service;

		function openModal(editorialEntity, currentUser) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'cloneEntityModal',
				resolve: {
					editorialEntity: function () {
						return entityFetchResource.getByFlashId({flashId: editorialEntity.identifier}).$promise;
					},
					metaDataInstanceDTOList: function() {
						return metadataResource.getInstantiationMetaToDuplicate({id: editorialEntity.identifier, type: EDITORIAL_ELEMENT_TYPE.entity}).$promise;
					},
					currentUser: function (userResource) {
						return currentUser;
					},
					maxSizeMedia: function (entityTemplateResource) {
						return entityTemplateResource.getMaxSize().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('cloneEditorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function openValidationModal(editorialEntity, subTreeEntities, subEntitiesWithDiscriminants) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'validationCloneEntityModal',
				resolve: {
					editorialEntity: function () {	return editorialEntity;	},
					subTreeEntities: function () { return subTreeEntities; },
					subEntitiesWithDiscriminants: function () { return subEntitiesWithDiscriminants; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('cloneEditorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}




		function clone(editorialEntity) {

			return entityCloneResource.cloneEE(editorialEntity).$promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('validationCloneEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/clone-entity-modal/validation-clone-entity-modal.html',
			controller: CloneEntityModalController,
			bindings: {
				resolve: '<',
				close: '&'
			}
		});

	/** @ngInject */
	function CloneEntityModalController() {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.subTreeEntities = ctrl.resolve.subTreeEntities;
			ctrl.subEntitiesWithDiscriminants = ctrl.resolve.subEntitiesWithDiscriminants;
		};

		ctrl.ok = function () {
			ctrl.close({ $value: false });
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('declineProposalService', DeclineProposalService);


	/** @ngInject */
	function DeclineProposalService(relationResource, blockUI, $uibModal, productResource, ModalAlertService, $filter, $state, infoModalService, modalService) {
		var service = {
			openModalMulti: openModalMulti,
			declineProposals: declineProposals,
		};

		return service;

		function openModalMulti(productCode, eeFlashIds) {
			blockUI.start();
			//If the editorial entities to archive are the target of many relationships, 
			//it is necessary to display the list of EE sources of the impacted relationships
			productResource.getProposalsByProductCodeAndEntityFlashIds({ productCode: productCode }, eeFlashIds).$promise.then(function (proposals) {
				//The list of editorial entities with pro
				var proposalsNotToBeDecline = _.filter(proposals, function(proposal) {
					return proposal.status !== 'WAITING';
				});
				// The list of entities that has all conditions to be archives (no source link and archive permission allowed)
				var proposalsToBeDecline = _.filter(proposals, function(proposal) {
					return proposal.status === 'WAITING';
				});

				var proposalEntityFlashIds = proposalsToBeDecline.length > 0? _.map(proposalsToBeDecline, function(proposal) {
					return proposal.entityFlashId;
				}) : [];

				var isAnyProposalToBeDecline = proposalsToBeDecline.length === 0;

				//If all selected entities can be declined no need to display modal
				if (proposalsToBeDecline.length === proposals.length) {
					blockUI.stop();
					declineProposals(productCode, proposalEntityFlashIds);
				} else {
					var declineProposalsModal = $uibModal.open({
						component: 'multiDeclineProposalModal',
						resolve: {
							proposalsToBeDecline: function () { return proposalsToBeDecline; },
							isAnyProposalToBeDecline: function () { return isAnyProposalToBeDecline; },
							proposalsNotToBeDecline: function () { return proposalsNotToBeDecline; },
							proposalEntityFlashIds: function () { return proposalEntityFlashIds; },
							productCode: function () { return productCode; },
							translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
								$translatePartialLoader.addPart('product');
								$translatePartialLoader.addPart('editorialEntity');
								return $translate.refresh();
							}]
						},
						size: 'lg',
						backdrop: 'static'
					});

					declineProposalsModal.opened.then(function () {
						blockUI.stop();
					});
				}
			});
		}

		function declineProposals(productCode, eeFlashIds) {

			var modalOptions = {
				isConfirm: false,
				closeButtonText: $filter('translate')('userApp.editorialEntity.action.cancel'),
				actionButtonText: $filter('translate')('userApp.editorialEntity.action.confirm'),
				headerText: $filter('translate')('userApp.editorialEntity.header.alert'),
				bodyText: 'bodyText'
			};

			if (eeFlashIds.length > 0) {
				blockUI.start();
				productResource.declineProposals({ productCode: productCode }, eeFlashIds).$promise.then(function (data) {
					blockUI.stop();
					$state.reload();
				}).catch(function (error) {
					blockUI.stop();
					modalOptions.bodyText = $filter('translate')('userApp.editorialEntity.msg.ERROR_TECH') + error.data.error;
					modalService.showModal({}, modalOptions);
				});
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('multiDeclineProposalModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/decline-proposal/multi-decline-proposal-modal.html',
			controller: MultiDeclineProposalModal,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			}
		});

	/** @ngInject */
	function MultiDeclineProposalModal($state, declineProposalService, $filter) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.proposalsToBeDecline = ctrl.resolve.proposalsToBeDecline;
			ctrl.isAnyProposalToBeDecline = ctrl.resolve.isAnyProposalToBeDecline;
			ctrl.proposalsNotToBeDecline = ctrl.resolve.proposalsNotToBeDecline;
			ctrl.proposalEntityFlashIds = ctrl.resolve.proposalEntityFlashIds;
			ctrl.productCode = ctrl.resolve.productCode;
		};

		ctrl.declineProposals = function () {

			ctrl.close({ $value: false });
			declineProposalService.declineProposals(ctrl.productCode, ctrl.proposalEntityFlashIds);
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};
	}
})();

(function () {
	'use strict';

	// Usage:
	/**
	 * <create-and-hook-ee-wizard 
	 * 			ee-source-details="$ctrl.eeSourceDetails" 
	 * 			current-user="$ctrl.currentUser" 
	 * 			dismiss="$ctrl.dismiss()"
	 * 			close-modal="$ctrl.closeModal(referenceNode)" 
	 * 			sub-element-details="$ctrl.subElementDetails"
	 * 			relationship-meta-case="$ctrl.relationshipMetaCase">
	 * </create-and-hook-ee-wizard>
	 */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('createAndHookEeWizard', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/create-and-hook-ee-wizard.tpl.html',
			controller: CreateAndHookEeWizardController,
			/** 1.API */
			bindings: {
				eeSourceDetails: '<',
				currentUser: '<',
				subElementDetails: '<?',
				relationshipMetaCase: '<',
				editorialEe: '<',
				closeModal: '&',
				dismiss: '&'
			}
		});

	/** @ngInject */
	function CreateAndHookEeWizardController($state, $log, MetadataService, $filter, blockUI, nodeResource, EditorialEntityService, ModalAlertService, entityLockService, relationshipTemplateWizardService, rtEetSelectionService, relationResource) {
		var ctrl = this;
		/** 2. CONFIG */
		ctrl.$onInit = function () {
			ctrl.editorialEeProduct = ctrl.editorialEe.ownerGroup;
			//Contains relationship template all elements selected in steps 1 (TR), 2(EE source) and 3(sub element)
			ctrl.rtStepElementsSelected = [];
			ctrl.rtBreadcrumb = '';
			ctrl.editorialEntity = { identifier: null };
			ctrl.isValidForm = true;
			//
			ctrl.steps = [
				{
					id: 1,
					name: "userApp.linkAndCreateEeWizard.labels.step01"
				},
				{
					id: 2,
					name: "userApp.linkAndCreateEeWizard.labels.step02"
				},
				{
					id: 3,
					name: "userApp.linkAndCreateEeWizard.labels.step03"
				}
			];
			//
			ctrl.relationMetaDatasList = [];
			//Errors
			ctrl.errors = [];
			//
			ctrl.accessedSelectRtEetStep = false;
			//Launch the first step.
			ctrl.currentStep = ctrl.steps[0];
		};

		/**
		 * If there is no RT metadata nor hooking metadata
		 * and if the EE source isn't CONTAINER type
		 * then init step3 with default values and bypass step3 in wizard (as it is last step, wizard will be closed)
		 * @param relationTemplateDetails info details of the selected relationship template
		 */
		function calculateStepsToDisplaySinceStep3(relationTemplateDetails) {
			//Init metadatas to pass to wizard step3
			ctrl.relationMetaDatasList = angular.copy(ctrl.relationTemplateDetails.metaInstanceList);

			//if eesource isn't container type and if there is no RT metadata nor hooking metadata, and only one option, no need to display step 3
			if (!ctrl.eeSourceDetails.container && relationTemplateDetails.metaInstanceList.length === 0) {
				//Check if there are hooking metadata
				relationResource.getHookingMetadata({
					eetCode: ctrl.eeSourceDetails.eetCode
				}).$promise.then(function (hookingMetadata) {
					//update relationTemplate metadata list with hooking metadata
					ctrl.relationMetaDatasList = MetadataService.copyHookingMetadata(ctrl.relationMetaDatasList, hookingMetadata);
					//update relationTemplate metadata list with EE source metadata
					ctrl.relationMetaDatasList = MetadataService.copyEeSourceMetadata(ctrl.relationMetaDatasList, ctrl.eeSourceDetails);

					//2. if there is no hooking metadata too
					if (hookingMetadata.length === 0) {
						//init relation and save TR without going to step 4
						ctrl.targetEntities = [];
						var targetEe = {
							flashId: null,
							eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
							metaInstanceList: ctrl.editorialEntity.metaInstanceList
						};
						ctrl.targetEntities.push(targetEe);
						var relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationTemplateDetails, ctrl.relationMetaDatasList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate);
						var referenceNodes = relationshipTemplateWizardService.initReferenceNodes(ctrl.eeSourceDetails, ctrl.subElementDetails, relations);
						ctrl.onRelationsRefNodesInitialized(relations, false, referenceNodes);
						ctrl.doSave();
					} else {
						ctrl.handleStep(ctrl.currentStep.id + 1);
					}
				});
			} else {
				ctrl.handleStep(ctrl.currentStep.id + 1);
			}
		}

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		/**
		 * Return true if there is one or more metadata where value not unique constraint is violated
		 */
		ctrl.isMetadataUniqueValueViolated = function (metaInstanceList) {
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(metaInstanceList, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		};

		/** 3.OPERATIONS */
		ctrl.onValidForm = function (status) {
			ctrl.isValidForm = status;
		};
		//
		ctrl.onRtEetSelected = function (rtEet, launchNextStep, accessedSelectRtEetStep) {
			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, ctrl.steps[1].id, rtEet.editorialEntityTemplate.wording, accessedSelectRtEetStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			//
			ctrl.rtEet = rtEet;
			//
			ctrl.relationTemplateDetails = {
				id: rtEet.relationshipTemplate.id,
				metaInstanceList: rtEet.relationshipTemplate.metaInstanceList,
				code: rtEet.relationshipTemplate.code
			};
			ctrl.accessedSelectRtEetStep = accessedSelectRtEetStep;
			if (angular.isDefined(launchNextStep) && launchNextStep) {
				//Lauch select source ee step.
				ctrl.currentStep = ctrl.steps[1];
			}
		};
		//
		ctrl.onRelationsRefNodesInitialized = function (relations, accessedRelationsReferenceNodeStep, referenceNodes) {
			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, ctrl.steps[2].id, '', accessedRelationsReferenceNodeStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			ctrl.relations = relations;
			ctrl.referenceNodes = referenceNodes;
		};
		//
		ctrl.onErrors = function (errors) {
			$log.debug('received erros from child component :' + errors);
			ctrl.errors = [].concat(ctrl.errors, errors);
		};
		//
		ctrl.isActiveStep01 = function () {
			return ctrl.currentStep.id === 1;
		};
		ctrl.isActiveStep02 = function () {
			return ctrl.currentStep.id === 2;
		};
		ctrl.isActiveStep03 = function () {
			return ctrl.currentStep.id === 3;
		};
		//
		ctrl.isPrevious = function () {
			return (
				(ctrl.currentStep.id === 2 && ctrl.accessedSelectRtEetStep) ||
				(ctrl.currentStep.id === 3));
		};
		//
		ctrl.isNext = function () {
			return (ctrl.currentStep.id === 1 && angular.isDefined(ctrl.rtEet) &&
				ctrl.rtEet !== null) ||
				(ctrl.currentStep.id === 2 && angular.isDefined(ctrl.editorialEntity) &&
					ctrl.editorialEntity !== null) ||
				(ctrl.currentStep.id === 3);
		};
		//
		ctrl.next = function () {
			switch (ctrl.currentStep.id) {
				case 1:
					ctrl.handleStep(ctrl.currentStep.id + 1);
					break;
				case 2:
					calculateStepsToDisplaySinceStep3(ctrl.relationTemplateDetails);
					break;
				case 3:
					ctrl.doSave();
					break;
			}
		};
		//
		ctrl.doSave = function () {
			//3. Verify if selected EE is locked			
			entityLockService.isLockedByOtherUser(ctrl.eeSourceDetails.flashId)
				.then(function (isLocked) {
					if (!isLocked) {
						ctrl.saveAll();
					} else {
						//selected ee already locked.
						ctrl.errors.push($filter('translate')('userApp.linkEEWizard.labels.eeLocked'));
					}
				});

		};
		//
		ctrl.saveAll = function () {
			//Set Up the relations metadatas
			//Workarround to handle relaion.metaInstanceDTOList updates in a child component <relation-reference-node/>
			//Fix this.
			angular.forEach(ctrl.referenceNodes, function (referenceNode) {
				referenceNode.relationDTO.metaInstanceDTOList = [];
				referenceNode.relationDTO.metaInstanceDTOList = _.concat(referenceNode.relationDTO.metaInstanceDTOList, ctrl.relationMetaDatasList);
			});
			var refNodeTargetEe = {
				editorialEntity: ctrl.editorialEntity,
				referenceNode: ctrl.referenceNodes[0]
			};
			if (ctrl.relationshipMetaCase) {
				blockUI.start();
				// Create entity
				EditorialEntityService.save(refNodeTargetEe.editorialEntity).$promise.then(function (savedEntity) {
					blockUI.stop();
					//Close the wizard
					ctrl.closeModal({ result: { editorialEntity: savedEntity, referenceNode: refNodeTargetEe.referenceNode } });
				}, function () {
					blockUI.stop();
				});
			} else {
				//
				$log.debug("Created reference node and target entity to save :" + refNodeTargetEe);
				// Create entity and reference node
				blockUI.start();
				nodeResource.saveReferenceNodeWithTargetEnity(refNodeTargetEe).$promise.then(function (referenceNode) {
					//
					blockUI.stop();
					ctrl.displaySaveSuccessMsg();
					EditorialEntityService.getEEById({ id: referenceNode.refNodeId }).$promise.then(function (entity) {
						//REDIRECTE TO EDITOR
						ctrl.redirectToEditContent(entity);
					}, function () {
						blockUI.stop();
					});
					//Close the wizard
					ctrl.closeModal({ result: referenceNode });
				}, function () {
					blockUI.stop();
				});
			}
		};
		//
		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};
		//
		ctrl.displaySaveSuccessMsg = function () {
			var msg = $filter('translate')('userApp.linkAndCreateEeWizard.labels.createdAndHookedEe') + ' ' + ctrl.deleteHtmlTags(ctrl.eeSourceDetails.systemTitle);
			if (angular.isDefined(ctrl.eeSourceDetails.subElementSystemTitle) && !_.isEmpty(ctrl.eeSourceDetails.subElementSystemTitle)) {
				msg = msg + '/' + ctrl.deleteHtmlTags(ctrl.eeSourceDetails.subElementSystemTitle);
			}
			ModalAlertService.success(
				$filter('translate')('userApp.linkEEWizard.labels.linkEE'), msg, '');
		};
		//
		ctrl.isFinalStep = function () {
			if (ctrl.currentStep) {
				return ctrl.currentStep.id === 3;
			}
			return false;
		};
		//
		ctrl.handleStep = function (toStep) {
			//
			ctrl.errors = [];
			ctrl.isValidForm = true;
			switch (toStep) {
				case 1:
				default:
					ctrl.rtEet = null;
					ctrl.relationTemplateDetails = null;
					ctrl.currentStep = ctrl.steps[0];
					break;
				case 2:
					ctrl.currentStep = ctrl.steps[1];
					break;
				case 3:
					ctrl.targetEntities = [];
					ctrl.relations = null;
					ctrl.referenceNodes = null;
					ctrl.targetEntities = [];
					var targetEe = {
						flashId: null,
						eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
						metaInstanceList: ctrl.editorialEntity.metaInstanceList
					};
					ctrl.targetEntities.push(targetEe);
					ctrl.currentStep = ctrl.steps[2];
					break;
			}
		};
		//
		ctrl.previous = function () {
			if (ctrl.currentStep.id > 1) {
				var stepId = 1;
				switch (ctrl.currentStep.id) {
					case 2:
						if (ctrl.accessedSelectRtEetStep) {
							stepId = 1;
						}
						break;
					case 3:
						stepId = 2;
						break;
				}
				ctrl.handleStep(stepId);
			}
		};
		//
		ctrl.redirectToEditContent = function (entity) {
			if (entity.editorialEntityTemplate.contentType === 'STRUCTUREDTEXT') {
				$state.go('editorialEntityEdit', { 'id': entity.identifier });
			} else if (ctrl.tree) {
				$state.go('treeEEEdition', { id: entity.identifier, editionMode: 'STRUCTURE' });
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('checkBrokenLinksComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/check-broken-links/check-broken-links.html',
			controller: checkBrokenLinksController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function checkBrokenLinksController(entityLockService, blockUI, workflowHistoryResource, $filter, $rootScope) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.workflowHistoryDTO = ctrl.resolve.workflowHistoryDTO;
		};

		ctrl.isEmptyWording = function (wording) {
			return _.isEmpty(wording);
		};

		ctrl.cancelModal = function () {
			ctrl.close({ $value: true });
		};

		ctrl.cancel = function () {
			ctrl.cancelModal();
			if (ctrl.workflowHistoryDTO && ctrl.workflowHistoryDTO.lockResource) {
				entityLockService.unlock(ctrl.workflowHistoryDTO.eeflashId);
			}
		};

		ctrl.clore = function () {
			blockUI.start();
			workflowHistoryResource.warningWorkFlow(ctrl.workflowHistoryDTO).$promise.then(function (data) {
				blockUI.stop();
				sendEvent();
				ctrl.cancelModal();
			});

		};

		//SEND EVENT TO MENU COMPONENT TO RECALCULATE PERMISSIONS
		function sendEvent() {
			$rootScope.$emit('WfForcedByWarningOrError');
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('checkBrokenLinksService', CheckBrokenLinksService);


	/** @ngInject */
	function CheckBrokenLinksService($q, $log, blockUI, $uibModal, entityValidateResource, ModalAlertService, $filter, confirmModalService) {
		var service = {
			openBrokenLinksReportModal: openBrokenLinksReportModal
		};

		return service;


		//USED BY WORK FLOW HOSTORY TO DISPLAY BROKEN LINKS REPORT, THE REPORT IS AVAILABLE DIRECTLY FROM workFlowHistory OBJECT
		function openBrokenLinksReportModal(workFlowHistory) {
			var modalInstance = $uibModal.open({
				component: 'checkBrokenLinksComponent',
				resolve: {
					workflowHistoryDTO: workFlowHistory,
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('deactivateNodesModalService', DeactivateNodesModalService);


	/** @ngInject */
	function DeactivateNodesModalService(blockUI, confirmModalService, nodeResource) {
		var service = {
			deactivateNodes: deactivateNodes
		};

		return service;

		// Deactivate nodes
		function deactivateNodes(referenceNodesFlashIds) {
			var message = "userApp.editorialEntity.home.deactivateNodesQuestion";
			return confirmModalService.openMessageModal(message)
				.then(function (confirmModalResponse) {
					if (confirmModalResponse) {
						blockUI.start();
						return nodeResource.deactivateReferenceNodes(referenceNodesFlashIds)
							.$promise.then(function () {
								blockUI.stop();
							});
					}
				});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('deleteNodesModalService', DeleteNodesModalService);


	/** @ngInject */
	function DeleteNodesModalService(blockUI, confirmModalService, nodeResource) {
		var service = {
			deleteNodes: deleteNodes
		};

		return service;

		// delete nodes
		function deleteNodes(referenceNodesFlashIds) {
			var message = "userApp.editorialEntity.msg.acceptDeleteNodes";
			return confirmModalService.openMessageModal(message)
				.then(function (confirmModalResponse) {
					if (confirmModalResponse) {
						blockUI.start();
						return nodeResource.deleteNodes({
							nodesIds: referenceNodesFlashIds
						}).$promise.then(function () {
							blockUI.stop();
						});
					}
				});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('duplicateEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/duplicate-entity-modal/duplicate-entity-modal.html',
			controller: DuplicateEntityModalController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function DuplicateEntityModalController($filter, $state, duplicateEntityModalService, ModalAlertService, blockUI, $translate, $scope, validateEntityService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.editOwnerGroup = ctrl.resolve.editOwnerGroup;
			ctrl.productFlashId = ctrl.resolve.productFlashId;
			ctrl.flashId = ctrl.resolve.editorialEntity.identifier;
			ctrl.metasAssociation = ctrl.resolve.metasAssociation;
			ctrl.ownerGroup = ctrl.resolve.productCode;
			ctrl.initDuplicationFields();
		};

		ctrl.initDuplicationFields = function () {
			ctrl.editorialEntity.system.systemTitle = undefined;
			ctrl.lang = $translate.use();
			ctrl.maxSizeMedia = ctrl.resolve.maxSizeMedia.maxSize;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.editorialEntity.metaInstanceList = ctrl.resolve.metaDataInstanceDTOList;

			ctrl.initSystemAuthors();
		};

		ctrl.initSystemAuthors = function () {
			if (!ctrl.editorialEntity.system) {
				ctrl.editorialEntity.system = {};
			}
			ctrl.editorialEntity.system.systemAuthors = [];
			ctrl.editorialEntity.system.systemAuthors.push({
				login: ctrl.currentUser.login,
				fullName: ctrl.currentUser.fullName
			});
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		/**
			* Duplicate an editorial entity with potential proposal
			* @param {*} editorialEntity 
			* @param {*} productFlashId 
			*/
		ctrl.duplicateEditorialEntity = function () {
			if (_.isEmpty(ctrl.editorialEntity.system.systemTitle)) {
				ctrl.editorialEntity.system.systemTitle = ctrl.resolve.editorialEntity.titleSystem;
			}

			validateEntityService.checkIfEntityExistWithSomeDiscriminants(ctrl.editorialEntity.metaInstanceList, ctrl.editorialEntity.editorialEntityTemplate.code)
				.$promise.then(function (data) {
					ctrl.errorExistEntityWithSomeMetaDiscriminants = data.exist;
					if (!ctrl.errorExistEntityWithSomeMetaDiscriminants) {
						blockUI.start();
						duplicateEntityModalService.duplicate(ctrl.editorialEntity, ctrl.productFlashId).then(function (data) {
							return data;
						}).then(function (ee) {
							ctrl.close({ $value: true });
							blockUI.stop();
							//Display success message	
							ModalAlertService.success("'" + $filter('translate')('userApp.duplicateEditorialEntity.home.success') + "'", $filter('translate')('userApp.duplicateEditorialEntity.home.duplicationPerformed'), '');
							//Go to the duplicated editorial entity
							$state.go('editorialEntity', {
								id: ee.identifier
							});
						});
					} else {
						//set form prestine to force form to be unsubmitted and keep duplication button enabled
						$scope.duplicateEditorialEntityForm.$setPristine();
						_.each(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
							if (metaInstance.discriminant === true) {
								metaInstance.errorExistMetaDiscriminants = true;
							}
						});
					}
				});

			//
		};
		ctrl.onChangeProductGroup = function (ownerGroup) {
			//emit event to system author component when owner group change
			$scope.$broadcast('ownerGroupUpdated', ownerGroup);

		};

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('duplicateEntityModalService', DuplicateEntityModalService);


	/** @ngInject */
	function DuplicateEntityModalService(blockUI, entityOperationResource, productResource, ModalAlertService, $uibModal, MetadataService, metadataResource, EDITORIAL_ELEMENT_TYPE, entityFetchResource) {
		var service = {
			openModal: openModal,
			duplicate: duplicate
		};

		return service;

		function openModal(editorialEntity, editOwnerGroup, productFlashId, metasAssociation, productCode) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'duplicateEntityModal',
				resolve: {
					editorialEntity: function () {
						return entityFetchResource.getByFlashId({flashId: editorialEntity.identifier}).$promise;
					},
					editOwnerGroup: function () { return editOwnerGroup; },
					productFlashId: function () { return productFlashId; },
					metaDataInstanceDTOList: function() {
						return metadataResource.getInstantiationMetaToDuplicate({id: editorialEntity.identifier, type: EDITORIAL_ELEMENT_TYPE.entity}).$promise;
					},
					metasAssociation: function(){
						return metasAssociation;
					},
					productCode: function(){
						return productCode;
					},
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					maxSizeMedia: function (entityTemplateResource) {
						return entityTemplateResource.getMaxSize().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('duplicateEditorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}


		function duplicate(editorialEntity, productFlashId) {
			if (productFlashId) {
				return productResource.duplicateEntityWithProposal({ flashId: productFlashId }, editorialEntity).$promise;
			} else {
				return entityOperationResource.duplicateEE(editorialEntity).$promise;
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editWorkflowModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/edit-workflow-modal/edit-workflow-modal.html',
			controller: EditWorkflowModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			}
		});

	/** @ngInject */
	function EditWorkflowModalController(editWorkflowModalService, entityLockService, validateEntityService, checkBrokenLinksService, workflowHistoryResource, $rootScope, $filter, $translate, blockUI, userResource, publishEeFormModalService) {
		var ctrl = this;
		ctrl.$onInit = function () {

			ctrl.isValidUser = true;

			//RESOLVE
			ctrl.editorialEntity = ctrl.resolve.entity;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.nextStep = ctrl.resolve.nextStep;

			// USED FOR CANCEL
			ctrl.initialWorkFlowHistoryDTO = _.cloneDeep(ctrl.editorialEntity.workFlowHistoryDTO);

			//MULTI EDIT
			ctrl.isMulti = ctrl.resolve.isMulti;
			ctrl.entityIds = ctrl.resolve.entityIds;

			//RULE : LOCK ENTITY IF IT'S NOT ALREADY LOCKED
			ctrl.locked = ctrl.editorialEntity.locked;
			if (!ctrl.locked) {
				entityLockService.lock(ctrl.editorialEntity.identifier);
			}
			ctrl.lang = $rootScope.currentLang;
			ctrl.editorialEntity.workFlowHistoryDTO.lockResource = ctrl.resolve.lockResource;
			ctrl.dateFmt = $filter('translate')('global.dateFormat');
			ctrl.userList = [];
			//ROLES
			ctrl.roles = [];
			//initialize user list
			ctrl.selectedUser = '';
			ctrl.selectedRole = null;
			//
			ctrl.roleId = null;
			ctrl.productCode = ctrl.editorialEntity.ownerGroup;
			initStepDefaultValues();


		};

		ctrl.showMultiAutoPublishingInfoMsg = function () {
			return ctrl.isMulti && (angular.isDefined(ctrl.editorialEntity.workFlowHistoryDTO.selectedStep) &&
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.id !== ctrl.editorialEntity.workFlowHistoryDTO.currentStep.id &&
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.autoPublishing);
		};

		ctrl.showAutoPublishingInfoMsg = function () {
			return !ctrl.isMulti && (angular.isDefined(ctrl.editorialEntity.workFlowHistoryDTO.selectedStep) &&
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.id !== ctrl.editorialEntity.workFlowHistoryDTO.currentStep.id
				&& ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.autoPublishing);
		};

		function initStepDefaultValues() {
			if (ctrl.editorialEntity.workFlowHistoryDTO.workflowConstraint) {
				//remove current step from next step list
				_.remove(ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO, function (step) {
					return step.currentStep;
				});

				//nexStep is defined when clic on step button
				if (angular.isDefined(ctrl.nextStep)) {
					ctrl.selectedStep = _.find(ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO, function (step) {
						return step.id === ctrl.nextStep.id;
					});
					ctrl.editorialEntity.workFlowHistoryDTO.selectedStep = ctrl.selectedStep;
				}

				//if there is only one next step, init selected step with it
				if (angular.isUndefined(ctrl.nextStep) && ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO.length === 1) {
					ctrl.editorialEntity.workFlowHistoryDTO.selectedStep = ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO[0];
					ctrl.selectedStep = ctrl.editorialEntity.workFlowHistoryDTO.selectedStep;
				}

				//if selectedStep was initialized
				if (angular.isDefined(ctrl.selectedStep)) {
					//if there is role select and there is only one option role, init selectedRole with it
					ctrl.roles = ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.roles;
					//if there is role select and there is onsave()ly one option role, init selectedRole with it
					if (ctrl.roles.length === 1) {
						ctrl.selectedRole = ctrl.roles[0];
						ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = ctrl.selectedRole;
					}
				}
				if (angular.isDefined(ctrl.selectedRole) && ctrl.selectedRole !== null) {
					ctrl.roleId = ctrl.selectedRole.identifier;
				}
				ctrl.getUsers(ctrl.roleId, ctrl.productCode, ctrl.editorialEntity.editorialEntityTemplate.code);
			}
		}

		ctrl.disableSelectStep = function () {
			return angular.isDefined(ctrl.nextStep) || (ctrl.selectedStep && ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO.length === 1);
		};

		ctrl.disableSelectRole = function () {
			return angular.isDefined(ctrl.roles) && ctrl.roles.length === 1;
		};


		ctrl.isNotValidStep = function () {
			return angular.isUndefined(ctrl.editorialEntity.workFlowHistoryDTO.selectedStep) ||
				(!ctrl.isMulti && ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.id === ctrl.editorialEntity.workFlowHistoryDTO.currentStep.id);
		};


		ctrl.selectedStepChanged = function () {
			ctrl.selectedUser = '';
			if (ctrl.editorialEntity.workFlowHistoryDTO.selectedStep && ctrl.roles.length === 1) {
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = ctrl.roles[0];
			} else if (ctrl.editorialEntity.workFlowHistoryDTO.selectedStep && ctrl.roles.length > 1) {
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = {};
			}
			ctrl.selectedStep = ctrl.editorialEntity.workFlowHistoryDTO.selectedStep;
			if (ctrl.selectedStep) {
				blockUI.start();
				editWorkflowModalService.getRolesByStep(ctrl.selectedStep.id)
					.then(function (data) {
						blockUI.stop();
						ctrl.roles = data;
						//if there is role select and there is only one option role, init selectedRole with it
						if (ctrl.roles.length === 1) {
							ctrl.selectedRole = ctrl.roles[0];
						}
						ctrl.roleSelectChanged();
					});
			}
		};

		/**
		 * ROLES
		 */
		ctrl.roleSelectDisplay = function () {
			return !ctrl.isNotValidStep() && ctrl.roles.length > 0;

		};

		ctrl.isNotValidRole = function () {
			return ctrl.roles.length > 0 && !ctrl.selectedRole;
		};

		ctrl.roleSelectChanged = function () {
			//
			ctrl.selectedUser = '';
			//
			ctrl.assignmentRole = null;

			//
			if (angular.isDefined(ctrl.selectedRole) && ctrl.selectedRole !== null) {
				ctrl.assignmentRole = ctrl.selectedRole;
				ctrl.roleId = ctrl.selectedRole.identifier;
			}
			ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = ctrl.assignmentRole;
			// GET LIST OF USERS BY role, groupcode, teeCode
			ctrl.getUsers(ctrl.roleId, ctrl.productCode, ctrl.editorialEntity.editorialEntityTemplate.code);
		};

		//USERS
		ctrl.userSelectDisplay = function () {
			return ctrl.editorialEntity.workFlowHistoryDTO.selectedStep && ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.userAssignmentAllowed &&
				!ctrl.isNotValidStep() &&
				!ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus;
		};


		ctrl.onSelect = function ($item) {
			ctrl.isValidUser = true;
			if ($item) {
				ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.userAssignment = $item.identifier;
			} else {
				delete ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.userAssignment;
			}
		};

		/* 		ctrl.checkUser = function (selectedUser) {
					ctrl.isValidUser = true;
					if (selectedUser === "") {
						delete ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.userAssignment;
					}
				};
		
				ctrl.checkIsValidUser = function () {
					var arr = [];
					if (ctrl.userList && ctrl.userList.length !== 0) {
						for (var i = 0, len = ctrl.userList.length - 1; i <= len; i++) {
							arr.push(ctrl.userList[i].identifier);
						}
					}
		
					ctrl.isValidUser = !ctrl.selectedUser || arr.indexOf(ctrl.selectedUser.identifier) !== -1;
				}; */



		// @BLO : REFACTO : Move BUISNESS LOGIC TO BACKEND
		ctrl.save = function (workflowHistorySaved, editorialEntity, isMulti, entityIds) {
			blockUI.start();
			//MULTI EDIT
			if (isMulti) {
				editWorkflowModalService.saveMultiEdit(editorialEntity.workFlowHistoryDTO, entityIds)
					.then(function (data) {
						ctrl.close({
							$value: data
						});
						blockUI.stop();
					});
			} else {

				//Get complete selected step data before proceed
				var selectedStep = editorialEntity.workFlowHistoryDTO.selectedStep;
				if (selectedStep.autoPublishing) {
					blockUI.stop();
					//Call publish form modal
					publishEeFormModalService.openPublishFormModal(editorialEntity, false, false, editorialEntity.ownerGroup, undefined, true).then(function (publishDto) {
						if (publishDto) {
							saveWorkflow(editorialEntity, publishDto);
						}
					});
				}
				else {
					blockUI.stop();
					saveWorkflow(editorialEntity);
				}
			}
		};

		function saveWorkflow(editorialEntity, publishDto) {
			blockUI.start();
			editWorkflowModalService.saveWorkflow(editorialEntity, undefined, publishDto).then(function (data) {
				ctrl.close({ $value: data });
				blockUI.stop();
			});
		}

		ctrl.cancel = function () {
			//RULE : CANCEL LOCK WHEN FINISH AND LOCKED FOR THIS EDITION

			if (!ctrl.locked) {
				entityLockService.unlock(ctrl.editorialEntity.identifier);
			}

			// BAD PRACTICE
			// THE VALUE IS DIRECTLY BINDED AND NOT MAPPED IN THE CALLER
			ctrl.editorialEntity.workFlowHistoryDTO = ctrl.initialWorkFlowHistoryDTO;
			ctrl.dismiss({
				$value: ctrl.editorialEntity.workFlowHistoryDTO
			});
		};


		ctrl.isValidRoleAndUser = function () {

			return !ctrl.isNotValidRole() || (ctrl.isValidUser && ctrl.selectedUser);
		};

		ctrl.getUsers = function (roleId, groupC, teeC) {
			userResource.getUsersByRoleGroup({
				roleId: roleId,
				groupCode: groupC,
				teeCode: teeC,
			}).$promise.then(function (data) {
				ctrl.userList = data;
				if (ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.assignDefaultCreator) {
					ctrl.selectedUser = _.find(ctrl.userList, { login: ctrl.editorialEntity.system.systemCreator });
					if (angular.isUndefined(ctrl.selectedUser)) {
						ctrl.isValidUser = false;
					}

				}
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editWorkflowModalService', EditWorkflowModalService);


	/** @ngInject */
	function EditWorkflowModalService($q, $state, $rootScope, checkBrokenLinksService, workflowResource, workflowHistoryResource, ModalAlertService, validateEntityService, $filter, blockUI, $uibModal, entityAuthorizeService, entityFetchResource, infoModalService, roleResource, publishService) {
		var service = {
			openMultiEdit: openMultiEdit,
			saveMultiEdit: saveMultiEdit,
			saveMultiInit: saveMultiInit,
			openWorkflowModal: openWorkflowModal,
			getRolesByStep: getRolesByStep,
			saveWorkflow: saveWorkflow,
			isNotValidAndNotFinal: isNotValidAndNotFinal,
			displayEditWorkflowModal: displayEditWorkflowModal
		};

		return service;

		/**
		 * Return true if need to edit workflow modal to fullfill next step fields
		 */
		function displayEditWorkflowModal(step) {
			return (step.deadlineInstallationAllowed && !step.finalStatus) || step.userAssignmentAllowed || (angular.isDefined(step.roles) && step.roles.length > 1);
		}

		/**
		 * not validate EE  and allowed publish
		 */
		function isNotValidAndNotFinal(workflowHistorySaved, editorialEntity) {
			return workflowHistorySaved.shematronStructureValid && angular.isDefined(workflowHistorySaved.validationReportDTO)
				&& (workflowHistorySaved.validationReportDTO.errorList.length > 0 || workflowHistorySaved.validationReportDTO.warningList.length > 0
					&& (!editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus && editorialEntity.workFlowHistoryDTO.selectedStep.publishAllowed));

		}

		/**
		 * Save workflow step promise
		 */
		function saveWorkflow(editorialEntity, redirect, publishDto) {

			var deferred = $q.defer();
			var isValid = true;

			// NORMAL EDIT
			workflowHistoryResource.changeStepWorkFlow(editorialEntity.workFlowHistoryDTO, function (data) {
				var workflowHistorySaved = data;

				if (!editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus && !editorialEntity.workFlowHistoryDTO.selectedStep.publishAllowed) {
					deferred.resolve(data);
				}

				//invalid shematron structure = NULL and has entities being created or updated
				else if (!workflowHistorySaved.shematronStructureValid && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus && (workflowHistorySaved.statusValidationReportDTO.notFinalUpdatedEntities.length > 0 || workflowHistorySaved.statusValidationReportDTO.notFinalCreatedEntities.length > 0)) {
					blockUI.stop();
					validateEntityService.openModalToValidateFLowModal(workflowHistorySaved)
						.then(function () {
							deferred.resolve(data);
							isValid = false;
						});
				}

				//invalid shematron structure = NULL only
				else if (!workflowHistorySaved.shematronStructureValid && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
					closeWorkFlow(deferred, editorialEntity, workflowHistorySaved).then(function () {
						hasPublishPermission(editorialEntity, isValid, redirect, publishDto);
					});
				}

				// valid EE and has entities being created or updated
				else if (workflowHistorySaved.shematronStructureValid && workflowHistorySaved.validationReportDTO.validEE && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus && (workflowHistorySaved.statusValidationReportDTO.notFinalUpdatedEntities.length > 0 || workflowHistorySaved.statusValidationReportDTO.notFinalCreatedEntities.length > 0)) {
					blockUI.stop();
					validateEntityService.openModalToValidateFLowModal(workflowHistorySaved)
						.then(function () {
							deferred.resolve(data);
						});
				}

				//valid EE
				else if (workflowHistorySaved.shematronStructureValid && workflowHistorySaved.validationReportDTO.validEE && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
					if (editorialEntity.editorialEntityTemplate.contentType !== 'TREE' && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
						closeWorkFlow(deferred, editorialEntity, workflowHistorySaved).then(function () {
							hasPublishPermission(editorialEntity, isValid, redirect, publishDto);
						});
					} else if (editorialEntity.editorialEntityTemplate.contentType === 'TREE' && workflowHistorySaved.treeInvalid) {
						ModalAlertService.info('info', $filter('translate')('userApp.editorialEntity.msg.treeInvalid'), '');

					} else if (editorialEntity.editorialEntityTemplate.contentType === 'TREE' && !workflowHistorySaved.treeInvalid && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
						closeWorkFlow(deferred, editorialEntity, workflowHistorySaved).then(function () {
							hasPublishPermission(editorialEntity, isValid, redirect, publishDto);
						});
					}

				}

				//invalid EE
				else if (workflowHistorySaved.shematronStructureValid && !workflowHistorySaved.validationReportDTO.validEE && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
					blockUI.stop();

					validateEntityService.openModalToValidateFLowModal(workflowHistorySaved)
						.then(function (modalResult) {
							if (modalResult) {
								hasPublishPermission(editorialEntity, true, redirect, publishDto);
								deferred.resolve(modalResult);
							} else {
								deferred.resolve(data);
							}
						});
				}

				//invalid EE and not final
				else if (isNotValidAndNotFinal(workflowHistorySaved, editorialEntity)) {
					var changeWF = validateEntityService.changeStepValidationValidation(workflowHistorySaved.validationReportDTO, editorialEntity, workflowHistorySaved).then(function () {
						deferred.resolve(changeWF);
						isValid = false;
					});
				}
				// invalid EE => ERM problem
				else if (angular.isDefined(workflowHistorySaved.validationReportDTO) && workflowHistorySaved.validationReportDTO !== null && workflowHistorySaved.validationReportDTO.errorERM) {
					ModalAlertService.info('error', $filter('translate')('userApp.editorialEntity.msg.errorERM'), '');
					deferred.resolve(data);
					isValid = false;
				} else {
					deferred.resolve(data);
				}
				if (!editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
					hasPublishPermission(editorialEntity, isValid, redirect, publishDto);
				}

				return deferred.promise;

			});
			return deferred.promise;
		}


		function hasPublishPermission(editorialEntity, isvalid, redirect, publishDto) {
			if ((publishDto && publishDto.selectedChannel && publishDto.selectedChannel.length > 0) || !publishDto) {
				entityAuthorizeService.permissions(editorialEntity.identifier)
					.then(function (permissions) {
						var hasNoPermission = angular.isDefined(permissions) && permissions.indexOf('PUBLISH') === -1;
						if (!hasNoPermission && isvalid) {
							//publish pub channel
							publishService.publishOrder(editorialEntity.identifier, undefined, true, redirect, publishDto);
						}
					});
			}
		}

		// IF BROKEN LINKS WITH CURRENT ENTITY AS SOURCE EXISTS => OPEN REPORT MODAL TO ASK USER CONFIRMATION, ELSE CLOSE WORKFLOW
		function closeWorkFlow(deferred, editorialEntity, workflowHistory) {

			var brokenLinksReport = workflowHistory.brokenLinksReportDTO;
			if (brokenLinksReport && brokenLinksReport.targetEntitiesWordingList.length > 0 && editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus) {
				checkBrokenLinksService.openBrokenLinksReportModal(workflowHistory).then(function () {
					deferred.resolve(workflowHistory);
					return deferred.promise;
				});
			} else {
				workflowHistoryResource.closeWorkFlow(workflowHistory).$promise
					.then(function (data) {
						deferred.resolve(data);
						return deferred.promise;
					});
			}
			return deferred.promise;
		}

		function openWorkflowModal(editorialEntity, currentUser, load, nextStep) {
			blockUI.start();
			return entityAuthorizeService.permissions(editorialEntity.identifier).then(function (permissions) {

				if (entityAuthorizeService.isInitWorkflowUpdateEnabled(permissions)) {
					blockUI.stop();
					return openInitWorkflowModal(editorialEntity, nextStep);

				} else if (entityAuthorizeService.isEditWorkflowEnabled(permissions)) {
					return openEditWorkflowModal(editorialEntity, currentUser, load, false, undefined, nextStep);

				} else {
					blockUI.stop();
					infoModalService.openModal("error.actionDenied.message", "error.actionDenied.title", {
						name: $filter('translate')('entity.actionBar.workflow.tooltip'),
						denied: $filter('translate')('entity.actionBar.workflow.denied')
					});
				}
			});
		}

		function openInitWorkflowModal(editorialEntity, nextStep, isMulti, entityIds) {
			var modalInstance = $uibModal.open({
				component: 'initWorkflowModal',
				windowClass: 'sidebar-open',
				resolve: {
					nextStep: function () {
						return nextStep;
					},
					workflowInstanceDTO: function () {
						return editorialEntity.workflowInstanceDTO ? editorialEntity.workflowInstanceDTO : [];
					},
					maxSizeMedia: function (entityTemplateResource) {
						return entityTemplateResource.getMaxSize().$promise;
					},
					productCode: function () {
						return editorialEntity.ownerGroup;
					},
					isMulti: function () {
						return isMulti;
					},
					entityIds: function () {
						return entityIds;
					},
					entityType: function () {
						return editorialEntity.editorialEntityTemplate.contentType;
					},
					isFormular: function () {
						return editorialEntity.editorialEntityTemplate.formular;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('metadatas');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function openEditWorkflowModal(editorialEntity, currentUser, load, isMulti, entityIds, nextStep) {
			var modalInstance = $uibModal.open({
				component: 'editWorkflowModal',
				windowClass: 'sidebar-open',
				resolve: {
					entity: function () {
						return load ? entityFetchResource.getByFlashId({
							flashId: editorialEntity.identifier
						}).$promise : editorialEntity;
					},
					currentUser: function () {
						return currentUser;
					},
					isMulti: function () {
						return isMulti;
					},
					entityIds: function () {
						return entityIds;
					},
					nextStep: function () {
						return nextStep;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('datepicker');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function getRolesByStep(stepId) {
			return roleResource.getRolesByStep({
				id: stepId
			}).$promise;
		}

		function openMultiEdit(entityIds, currentUser) {
			blockUI.start();
			workflowResource.multiEdit({
				entityIds: entityIds
			}).$promise
				.then(function (workflowMultiEdit) {
					blockUI.stop();

					var errorMsgName = '';
					//Entities haven't some workflow, the error
					if (!workflowMultiEdit.sameWorkflow) {
						errorMsgName = 'userApp.bulkoperations.actions.changeStep.notSameWorkflow';
						//some entities are in progress step and other(s) in final one, the error
					} else if (!workflowMultiEdit.allEntitiesInFinalStatus && workflowMultiEdit.existEntitiesInFinalStatus) {
						errorMsgName = 'userApp.bulkoperations.actions.changeStep.existEntitiesInFinalStatus';
						//workflow is constraint and not all entities have some current step, then error
					} else if (workflowMultiEdit.workflowConstraint && !workflowMultiEdit.sameCurrentStep) {
						errorMsgName = 'userApp.bulkoperations.actions.changeStep.notSameCurrentStep';
					}

					//there is an error to display
					if (errorMsgName !== '') {
						infoModalService.openActionDenied({
							name: $filter('translate')('userApp.bulkoperations.actions.changeStep.name'),
							denied: $filter('translate')(errorMsgName)
						});
					} else {
						//all entities are in final step, then open init workflow modal
						if (workflowMultiEdit.allEntitiesInFinalStatus) {
							openInitWorkflowModal(workflowMultiEdit.entity, workflowMultiEdit.nextStep, true, entityIds);
						} else {
							openEditWorkflowModal(workflowMultiEdit.entity, currentUser, false, true, entityIds);
						}
					}
				});

		}

		function saveMultiEdit(workflowHistory, entityIds) {
			return workflowResource.saveMultiEdit({
				entityIds: entityIds
			}, workflowHistory).$promise
				.then(function () {
					//OPEN MODAL INFO
					infoModalService.openBulkSucess({
						operation: $filter('translate')('entity.actionBar.workflow.tooltip')
					}).then(function () {
						$state.go('myBulkOperations');
					});
				});
		}

		function saveMultiInit(wfMetaDataInstance, entityIds) {
			return workflowResource.saveMultiInit({
				entityIds: entityIds
			}, wfMetaDataInstance).$promise
				.then(function () {
					//OPEN MODAL INFO
					infoModalService.openBulkSucess({
						operation: $filter('translate')('entity.actionBar.workflow.tooltip')
					}).then(function () {
						$state.go('myBulkOperations');
					});
				});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('deleteEntityService', DeleteEntityService);


	/** @ngInject */
	function DeleteEntityService(relationResource, blockUI, entityOperationResource, ModalAlertService, $filter, $state) {
		var service = {
			deleteEntity: deleteEntity,
			forceDeleteEntity: forceDeleteEntity,
			deleteEntityMulti: deleteEntityMulti,
		};

		return service;

		function forceDeleteEntity(eeFlashId) {
			return entityOperationResource.forceDeleteEE({flashId: eeFlashId}).$promise;
		}

		function deleteEntity(editorialEntityId) {
			blockUI.start();
			entityOperationResource.deleteEE({flashId: editorialEntityId}).$promise.then(function (data) {
				return data;
			}).then(function (ee) {
				blockUI.stop();
				ModalAlertService.success("'" + $filter('translate')('userApp.archiveEditorialEntity.home.success') + "'", $filter('translate')('userApp.archiveEditorialEntity.home.deletePerformed'), '');
				$state.reload();
			});
		}

		function deleteEntityMulti(flashIds) {
			return entityOperationResource.deleteEntityMulti(flashIds).$promise;
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('editorialEntityActionBar', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/editorial-entity-action-bar/editorial-entity-action-bar.html',
			controller: EditorialEntityActionBarController,
			transclude: true,
			bindings: {
				contentClass: '@?',
				flashId: '<?',
				config: '<?',
				onRefreshPreview: '&?',
				onEditMetaData: '&?',
				onEditContent: '&?',
				currentUser: '<',
				onRefreshPage: '&',
				previewHtml: '<',
				openOnNewTab: '<?',
				fromTrush: '<'
			}
		});

	/** @ngInject */
	function EditorialEntityActionBarController($rootScope, $filter, ModalAlertService, editorialEntityActionBarService, OpenNewTabService, entityFetchResource, validateEntityService, htmlPreviewTabService, editWorkflowModalService, $log, blockUI, publishService, $timeout, EDITORIAL_ELEMENT_TYPE, restoreEntityService, deleteEntityService, publishEeFormModalService) {
		var ctrl = this;


		////////////////

		ctrl.startEdition = function () {
			var confExtra = ctrl.config['editContent'].extra;
			if (confExtra && confExtra.openWorkflow) {
				ctrl.openWorkflowModal().then(function () {
					ctrl.onEditContent();
				});
			}
			else {
				ctrl.onEditContent();
			}
		};

		ctrl.openEditMetaData = function () {
			var confExtra = ctrl.config['editMeta'].extra;
			if (confExtra && confExtra.openWorkflow) {
				ctrl.openWorkflowModal().then(function () {
					ctrl.onEditMetaData();
				});
			}
			else {
				ctrl.onEditMetaData();
			}
		};

		ctrl.openWorkflowModal = function () {
			return entityFetchResource.getByFlashId({
				flashId: ctrl.flashId
			}).$promise
				.then(function (entity) {
					return editWorkflowModalService.openWorkflowModal(entity, ctrl.currentUser, true)
						.then(function (data) {
							if (data) {
								ctrl.onRefreshPage();
								editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config);
							}
						});
				});
		};

		function goNextStep(step) {
			blockUI.start();
			entityFetchResource.getByFlashId({ flashId: ctrl.flashId }).$promise.then(function (editorialEntity) {
				//open edit workflow modal to complete fields
				if (editWorkflowModalService.displayEditWorkflowModal(step)) {
					blockUI.stop();
					editWorkflowModalService.openWorkflowModal(editorialEntity, ctrl.currentUser, false, step)
						.then(function (data) {
							blockUI.stop();
							if (data) {
								ctrl.onRefreshPage();
								editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config);
							}
						});
					//No need to complete step fields, so don't display edit workflow modal, rather directly validate next step
				} else {
					//Get complete selected step data before proceed
					var selectedStep = _.find(editorialEntity.workFlowHistoryDTO.stepsDTO, function (s) {
						return s.id === step.id;
					});

					editorialEntity.workFlowHistoryDTO.selectedStep = selectedStep;
					//init default role if exists
					if (angular.isDefined(selectedStep.roles) && selectedStep.roles.length === 1) {
						editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = selectedStep.roles[0];
					}

					if (selectedStep.autoPublishing) {
						blockUI.stop();
						//Call publish form modal
						publishEeFormModalService.openPublishFormModal(editorialEntity, false, false, editorialEntity.ownerGroup, undefined, true).then(function (publishDto) {
							if (publishDto) {
								saveWorkflow(editorialEntity, publishDto);
							}
						});
					}
					else {
						blockUI.stop();
						saveWorkflow(editorialEntity);
					}
				}
			});
		}

		function saveWorkflow(editorialEntity, publishDto) {
			blockUI.start();
			editWorkflowModalService.saveWorkflow(editorialEntity, undefined, publishDto).then(function (data) {
				blockUI.stop();
				//REFRESH ENTITY
				ctrl.onRefreshPage();
				editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config);
			});
		}

		ctrl.executeWorkflowStep = function (step) {
			goNextStep(step);
		};

		ctrl.openPreview = function () {
			blockUI.start();
			entityFetchResource.getByFlashId({
				flashId: ctrl.flashId
			}).$promise
				.then(function (entity) {
					blockUI.stop();
					htmlPreviewTabService.openAuthorizedTab(ctrl.flashId, undefined, entity.editorialEntityTemplate.code, false);
				});
		};

		ctrl.openControl = function () {

			entityFetchResource.isTree({ type: 'ENTITY', flashId: ctrl.flashId })
				.$promise.then(function (data) {
					openControlModal(data.tree);
				}, function (error) {
					$log.error("Error ocurred when calling is tree WS");
				});
		};

		ctrl.loadEntityInfo = function () {
			blockUI.start();
			ctrl.entity = {};
			ctrl.isHooksExternalEntities = false;
			$timeout(function () {
				entityFetchResource.getByFlashId({
					flashId: ctrl.flashId
				}).$promise
					.then(function (entity) {
						blockUI.stop();
						ctrl.entity = entity;
						// If EE hooks external entities
						if (entity) {
							ctrl.isHooksExternalEntities = entity.editorialEntityTemplate.hooksExternalEntities;
						}
					});
			});

		};

		ctrl.printPreview = function () {
			OpenNewTabService.openNewTab(ctrl.previewHtml);
		};
		ctrl.restoreEntity = function () {
			restoreEntityService.restoreEntity(ctrl.flashId);
		};



		/**
		 * Delete an editorial entity
		 */
		ctrl.deleteEntity = function () {
			deleteEntityService.deleteEntity(ctrl.flashId);
		};

		// a modifier 
		ctrl.openPublishModal = function () {
			entityFetchResource.getByFlashId({
				flashId: ctrl.flashId
			}).$promise
				.then(function (entity) {
					var listChannels = entity.editorialEntityTemplate.publicationChannels;
					if (listChannels && listChannels.length > 0) {
						publishService.publishOrder(entity.flashId, entity);
					}
					else {
						ModalAlertService.info($filter("translate")('entity.actionBar.publish.empty'));
					}
				});
		};

		ctrl.$onInit = function () {
		};

		ctrl.isConfifEmpty = function () {
			return _.isEmpty(ctrl.config);
		};

		//Listen to event refresh
		$rootScope.$on('$destroy', $rootScope.$on('refresh_action_bar', function (event, data) {
			editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config);
		}));

		ctrl.$onChanges = function (changesObj) {
			if (changesObj.flashId) {
				if (ctrl.flashId) {
					if (!ctrl.config) {
						ctrl.config = {};
					}
					if (ctrl.fromTrush) {
						editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config, EDITORIAL_ELEMENT_TYPE.deletedEntity);
					} else {
						editorialEntityActionBarService.refreshConfig(ctrl.flashId, ctrl.config);
					}

				}
			}
		};

		ctrl.$onDestroy = function () { };


		//OPEN CONTROL MODAL BASED ON ENTITY TYPE
		function openControlModal(tree) {
			ctrl.editorialEntity = { identifier: ctrl.flashId };
			if (tree === 'true') {
				validateEntityService.chooseValidationType(ctrl.editorialEntity);
			}
			else {
				validateEntityService.openModal(ctrl.editorialEntity, false, false, false);
			}
		}

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};
	}
})();

(function () {
	'use strict';

	/**
		* service providing utilities functions to display action bar
		*/
	angular
		.module('userApp')
		.factory('editorialEntityActionBarService', EditorialEntityActionBarService);

	/** @ngInject */
	function EditorialEntityActionBarService($filter, blockUI, EDITORIAL_ELEMENT_TYPE, entityAuthorizeService, entityTemplateService, entityFetchResource) {
		var service = {
			refreshConfig: refreshConfig,
			completeActionBarConfig: completeActionBarConfig
		};
		return service;

		// CHECK IF ITEM SHOULD BE ENABLED
		function itemEnabled(item, permissionsDTO, infos) {
			switch (item) {
				case 'editContent':
					return entityAuthorizeService.isEditContentEnabled(permissionsDTO.permissions)
						|| entityAuthorizeService.isInitAndEditContentEnabled(permissionsDTO.permissions);
				case 'editMeta':
					return entityAuthorizeService.isMetadataEnabled(permissionsDTO.permissions)
						|| entityAuthorizeService.isInitAndEditMetadataEnabled(permissionsDTO.permissions);
				case 'workflow':
					var isEditWorkflowEnabled = entityAuthorizeService.isEditWorkflowEnabled(permissionsDTO.permissions);
					var isInitWorkflowUpdateEnabled = entityAuthorizeService.isInitWorkflowUpdateEnabled(permissionsDTO.permissions);
					return isInitWorkflowUpdateEnabled || isEditWorkflowEnabled;
				case 'preview':
					return permissionsDTO.ermProofingConfigAvailable;
				case 'control':
					return entityAuthorizeService.isControlEnabled(permissionsDTO.permissions);
				case 'publish':
					return entityAuthorizeService.isPublishEnabled(permissionsDTO.permissions) && infos.publishChannels && infos.publishChannels.length > 0;
				case 'restore':
					return entityAuthorizeService.isControlEnabled(permissionsDTO.permissions);
				case 'delete':
					return entityAuthorizeService.isControlEnabled(permissionsDTO.permissions);
				default:
					return true;
			}
		}

		function isItemVisible(item, permissionsDTO, infos) {
			switch (item) {
				case 'publish':
					return !(infos.workflowConstraint && !entityAuthorizeService.isPublishEnabled(permissionsDTO.permissions) || !infos.publishChannels || !infos.publishChannels.length > 0) || !infos.workflowConstraint;
				default:
					return true;
			}
		}

		// GET CONFIG FOR GIVEN ITEM
		function getItemConfig(item, permissionsDTO, infos, tooltipKey) {
			var ItemMessageConfigKey = getItemMessageConfigKey(item, permissionsDTO);
			var defaultTooltipMsgKey = tooltipKey ? tooltipKey : 'entity.actionBar.' + ItemMessageConfigKey + '.tooltip';
			var isItemEnabled = itemEnabled(item, permissionsDTO, infos);
			var itemConfig = {
				disabled: !isItemEnabled,
				visible: isItemVisible(item, permissionsDTO, infos),
				tooltip: $filter('translate')(isItemEnabled ? defaultTooltipMsgKey : 'entity.actionBar.' + ItemMessageConfigKey + '.denied'),
				extra: getExtraConfig(item, permissionsDTO, infos)
			};
			return itemConfig;
		}

		//GET EXTRA CONFIG FOR SPECIFIC ITEMS
		function getExtraConfig(item, permissionsDTO, infos) {
			switch (item) {
				case 'workflow':
					{
						var extraWorkflowData = {
							showSteps: !entityAuthorizeService.isInitWorkflowUpdateEnabled(permissionsDTO.permissions) && infos.workflowConstraint
						};
						return extraWorkflowData;
					}
				case 'editMeta': {
					return { openWorkflow: entityAuthorizeService.isInitWorkflowUpdateEnabled(permissionsDTO.permissions) };
				}
				case 'editContent': {
					return { openWorkflow: entityAuthorizeService.isInitWorkflowUpdateEnabled(permissionsDTO.permissions) };
				}
				default:
					return;
			}
		}

		// GET KEY OF MESSAGE CONFIG IN I18N FILE
		function getItemMessageConfigKey(item, permissionsDTO) {
			var isInitWorkflowUpdateEnabled = entityAuthorizeService.isInitWorkflowUpdateEnabled(permissionsDTO.permissions);
			if (item === 'workflow' && isInitWorkflowUpdateEnabled) {
				return 'initWorflow';
			} else {
				return item;
			}
		}

		//SET CONFIG OF ACTION BAR ITEMS
		function completeActionBarConfig(config, permissionsDTO, infos) {

			//	DEFAULT CONFIG
			var defaultConfig = {
				visible: true,
				disabled: false
			};
			// config for entity that hooks external entities
			var externalConfig = {
				visible: true,
				disabled: true
			};
			// Config to hide a button and disable the associated action
			var disabledAndInvisibleConfig = {
				visible: false,
				disabled: true
			};
			if (!config.goToEE) {
				config.goToEE = defaultConfig;
			}
			if (!config.showInfo) {
				config.showInfo = defaultConfig;
			}
			if (!config.refreshPreview || !infos.hooksExternalEntities) {
				config.refreshPreview = defaultConfig;
			}

			if (!config.print || !infos.hooksExternalEntities) {
				config.print = defaultConfig;
			}

			// CONFIGS DEPENDS ON PERMISSIONS AND NEED TO BE REFRESHED
			config.editMeta = getItemConfig('editMeta', permissionsDTO);
			config.workflow = getItemConfig('workflow', permissionsDTO, infos);
			config.preview = getItemConfig('preview', permissionsDTO);
			config.control = getItemConfig('control', permissionsDTO);
			config.publish = getItemConfig('publish', permissionsDTO, infos);
			// HIDE EDITOR SHORTCUT FOR FORM TYPE
			if (infos && infos.form) {
				config.editContent = { visible: false };
				config.editMeta = getItemConfig('editMeta', permissionsDTO, infos, 'entity.actionBar.editMetaForm.tooltip');
			}
			else {
				config.editContent = getItemConfig('editContent', permissionsDTO);
			}
			//disable actions for tree that hooks external entities
			if (infos.hooksExternalEntities) {
				config.refreshPreview = externalConfig;
				config.print = externalConfig;
				config.preview = externalConfig;
				config.publish = externalConfig;
			}
			// Hide some of the buttons if the entity is a media entity
			if (infos.contentType === 'MEDIA') {
				config.publish = disabledAndInvisibleConfig;
				config.preview = disabledAndInvisibleConfig;
				config.print = disabledAndInvisibleConfig;
				config.editContent = disabledAndInvisibleConfig;
			}
		}

		function addWorkflowSteps(flashId, config, infos) {
			if (infos.workflowConstraint && config.workflow.extra.showSteps) {
				entityFetchResource.getByFlashId({
					flashId: flashId
				}).$promise
					.then(function (entity) {
						if (entity && entity.workFlowHistoryDTO && entity.workFlowHistoryDTO.currentStep && !_.isEmpty(entity.workFlowHistoryDTO.currentStep.nextSteps)) {
							config['workflow'].extra.steps = entity.workFlowHistoryDTO.currentStep.nextSteps;
						}
						else {
							config['workflow'].extra.showSteps = false;
						}
					});
			}
		}

		function refreshConfig(flashId, config, type) {
			var actionBarUI = blockUI.instances.get('actionBarUI');
			type = type ? type : EDITORIAL_ELEMENT_TYPE.entity;
			if (flashId) {
				actionBarUI.start();
				entityAuthorizeService.permissionsDTO(flashId)
					.then(function (permissionsDTO) {
						entityTemplateService.getInfo(flashId, type).then(function (infos) {
							completeActionBarConfig(config, permissionsDTO, infos);
							addWorkflowSteps(flashId, config, infos);

							actionBarUI.stop();
						});
					}).finally(actionBarUI.stop);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('importArticleModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/import-article-modal/import-article-modal.html',
			controller: ImportArticleModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ImportArticleModalController($filter, importArticleModalService, ModalAlertService, blockUI, $translate, userPreferenceService, entityValidateResource, publishEeFormModalService, productDashboardService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.flashId = ctrl.resolve.editorialEntity.identifier;
			ctrl.initImportFields();
		};

		ctrl.initImportFields = function () {
			ctrl.editorialEntity.system.systemTitle = undefined;
			ctrl.lang = $translate.use();
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.ownerGroupContextualTir = userPreferenceService.getUserGlobalPreference('OwnerGroup');

			// Get importOwnerGroupName
			if (ctrl.ownerGroupContextualTir) {
				productDashboardService.getGroup(ctrl.ownerGroupContextualTir).then(function (ownerGroupData) {
					if (ownerGroupData) {
						ctrl.importOwnerGroupName = ownerGroupData.name;
					}
				});
			}

		};


		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};


		ctrl.importArticle = function () {
			if (_.isEmpty(ctrl.editorialEntity.system.systemTitle)) {
				ctrl.editorialEntity.system.systemTitle = ctrl.resolve.editorialEntity.titleSystem;
			}
			blockUI.start();
			//CHECK IF ENTITY HAS ON GOING OR ACCEPTED PROPOSAL
			entityValidateResource.checkIfEntityHasOnGoingOrAcceptedProposals({ id: ctrl.editorialEntity.identifier, product: ctrl.ownerGroupContextualTir }).$promise
				.then(function (data) {
					if (data.exist) {
						ModalAlertService.error("'" + $filter('translate')('error.import.hasOnGoingOrAcceptedProposals') + "'");
						blockUI.stop();
					} else {
						importArticleModalService.importArticle(ctrl.editorialEntity, ctrl.ownerGroupContextualTir).then(function () {
							ctrl.close({ $value: true });
							blockUI.stop();
							// Show publication modal if step is auto publishing
							if (ctrl.editorialEntity.workFlowHistoryDTO.currentStep.autoPublishing) {
								publishEeFormModalService.openPublishFormModal(ctrl.editorialEntity, true, false, ctrl.ownerGroupContextualTir, ctrl.importOwnerGroupName, false);
							}
							ModalAlertService.success("'" + $filter('translate')('userApp.importArticle.home.success') + "'", $filter('translate')('userApp.importArticle.home.importPerformed'), '');
						});
					}
				});

		};

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('importArticleModalService', ImportArticleModalService);


	/** @ngInject */
	function ImportArticleModalService(blockUI, $uibModal, entityFetchResource, productResource) {
		var service = {
			openModal: openModal,
			importArticle: importArticle
		};

		return service;

		function openModal(flashId) {
			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'importArticleModal',
				resolve: {
					editorialEntity: function () {
						return entityFetchResource.getByFlashId({ flashId: flashId }).$promise;
					},
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('importArticle');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}


		function importArticle(editorialEntity, productCode) {
			blockUI.start();
			return productResource.saveImport({ productCode: productCode }, editorialEntity).$promise
				.then(function () {
					blockUI.stop();
				});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('htmlPreviewTabService', HtmlPreviewTabService);


	/** @ngInject */
	function HtmlPreviewTabService(EDITORIAL_ELEMENT_TYPE, blockUI, $window, entityFetchResource, EditorialEntityService, OpenNewTabService, infoModalService, $filter, entityBuilderService, ermService, htmlPreviewService, ENTITY_RESOURCE_TYPE) {
		var service = {
			openAuthorizedTab: openAuthorizedTab,
			openTabById: openTabById
		};

		return service;


		function openTabById(id, entityType, overloadedPreview, isArchived) {
			blockUI.start();
			return openWindow(id, entityType, overloadedPreview, isArchived);
		}

		function openAuthorizedTab(id, entityType, templateCode, authorize) {
			blockUI.start();
			if (authorize) {
				return ermService.checkConfigExits(templateCode, ENTITY_RESOURCE_TYPE.proofReading)
					.then(function (data) {
						var authorized = (data.exist === "true");
						if (authorized) {
							return openWindow(id, entityType);
						} else {
							blockUI.stop();
							infoModalService.openWindow("error.actionDenied.message", "error.actionDenied.title",
								{
									name: $filter('translate')('entity.actionBar.preview.tooltip'),
									denied: $filter('translate')('entity.actionBar.preview.denied')
								});
						}
					});
			}
			return openWindow(id, entityType);

		}


		function openWindow(id, type, overloadedPreview, isArchived) {
			var entityType = type ? type : EDITORIAL_ELEMENT_TYPE.entity;

			var promise;
			if (overloadedPreview && (entityType === 'REFERENCE')) {
				promise = htmlPreviewService.getOverloadPreview(id, entityType, isArchived);
			} else {
				promise = htmlPreviewService.getProofReadingPreview(id, entityType, false /*Proof reading preview dont manage archived EE*/);
			}

			var win = $window.open();
			promise.then(function (html) {
				blockUI.stop();
				OpenNewTabService.openNewTab(html, win);
			});

		}



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('initWorkflowModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/init-workflow-modal/init-workflow-modal.html',
			controller: InitWorkflowModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function InitWorkflowModalController(editWorkflowModalService, workflowHistoryResource, $translate, blockUI, $state) {
		var ctrl = this;
		ctrl.$onInit = function () {

			ctrl.maxSizeMedia = ctrl.resolve.maxSizeMedia.maxSize;
			ctrl.lang = $translate.use();
			ctrl.workflowInstanceDTO = ctrl.resolve.workflowInstanceDTO;
			ctrl.productCode = ctrl.resolve.productCode;
			ctrl.entityType = ctrl.resolve.entityType;
			ctrl.isFormular = ctrl.resolve.isFormular;

            //MULTI EDIT
			ctrl.isMulti = ctrl.resolve.isMulti;
			ctrl.entityIds = ctrl.resolve.entityIds;
			ctrl.workFlowHistoryDTO = ctrl.resolve.workFlowHistoryDTO;
		};


		ctrl.save = function () {
			blockUI.start();
            //MULTI EDIT
			if (ctrl.isMulti) {
				editWorkflowModalService.saveMultiInit(ctrl.workflowInstanceDTO, ctrl.entityIds)
					.then(function (data) {
						ctrl.close({
							$value: data
						});
						blockUI.stop();
					});
			} else {
				workflowHistoryResource.initWFUpdate(ctrl.workflowInstanceDTO, function (data) {
					ctrl.close({ $value: data });
					blockUI.stop();
				});
			}
		};
	
		ctrl.editReadOnly = function () {
			$state.go("editorialEntityEdit", { id: ctrl.workflowInstanceDTO.eeFlashId, readOnly: true });
		};

		ctrl.isReadonlyEditionAllowed = function(){
			return ctrl.entityType === 'STRUCTUREDTEXT' && !ctrl.isFormular;
		};

		ctrl.cancel = function () {
			ctrl.dismiss();
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('exportXmlRessource', ExportXmlRessource);

	/** @ngInject */
	function ExportXmlRessource($resource) {
		return $resource('api/xmlExporter', {}, {
			'content': {
				method: 'GET',
				url: 'api/xmlExporter/exportToXML',
				params: {
					flashId: '@flashId'
				},
				isArray: false,
				transformResponse: function (data) {
					return { body: data };
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('exportXMLService', ExportXMLService);

	/** @ngInject */
	function ExportXMLService(exportXmlRessource, OpenNewTabService) {
		var service = {
			content: content
		};

		function content(id) {
			//GET XML CONTENT
			exportXmlRessource.content({ flashId: id }).$promise.then(function (data) {
				//OPEN NEW TAB WITH XML
				OpenNewTabService.openXMLTab(data.body);
			});
		}
		return service;
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('publishEeFormModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/publish-ee-form-modal/publish-ee-form-modal.html',
			controller: publishEeFormModalController,
			bindings: {
				resolve: '<',
				dismiss: '&',
				close: '&'
			},
		});

	/** @ngInject */
	function publishEeFormModalController($filter, blockUI, publishService) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.publish = ctrl.resolve.publish;
			ctrl.publicationChannels = ctrl.resolve.publish.publicationChannel;
			ctrl.selectedChannels = ctrl.resolve.publish.selectedChannel;
			ctrl.isPublishOnly = ctrl.resolve.isPublishOnly;
			ctrl.fromForm = ctrl.resolve.fromForm;
			ctrl.publishProductName = ctrl.resolve.publishProductName;
			ctrl.publishProductCode = ctrl.resolve.publishProductCode;
			ctrl.isPublishAssociatedProducts = ctrl.resolve.isPublishAssociatedProducts;

			angular.forEach(ctrl.publicationChannels, function (channel) {
				if (channel.notCheckedByDefault) {
					channel.ticked = false;
				} else {
					channel.ticked = true;
				}
			});

			ctrl.selectChannels();

		};

		ctrl.selectChannels = function () {
			ctrl.selectedChannels = $filter('filter')(
				ctrl.publicationChannels, {
					ticked: true
				});
		};


		ctrl.cancel = function () {
			ctrl.dismiss({
				$value: false
			});
		};

		ctrl.confirmPublish = function () {
			blockUI.start();
			_.each(ctrl.selectedChannels, function (selectedChannel) {
				selectedChannel.productCode = ctrl.publishProductCode;
			});
			// If at least one channel selected for principal product, then publish associated products if allowed
			if (ctrl.isPublishAssociatedProducts && ctrl.selectedChannels && ctrl.selectedChannels.length > 0) {
				ctrl.publish.addAssociatedProducts = true;
			}
			ctrl.resolve.publish.selectedChannel = ctrl.selectedChannels;
			if (ctrl.isPublishOnly && ctrl.publish && ctrl.publish.selectedChannel && ctrl.publish.selectedChannel.length > 0) {
				publishService.publishOrder(ctrl.editorialEntity.identifier, undefined, undefined, undefined, ctrl.publish, ctrl.publishProductName);
				ctrl.close({ $value: true });
				blockUI.stop();
			} else {
				ctrl.close({ $value: ctrl.publish });
				blockUI.stop();
			}
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('publishEeFormModalService', PublishEeFormModalService);


	/** @ngInject */
	function PublishEeFormModalService(blockUI, $uibModal) {
		var service = {
			openPublishFormModal: openPublishFormModal
		};

		return service;


		function openPublishFormModal(editorialEntity, isPublishOnly, fromForm, publishProductCode, publishProductName, isPublishAssociatedProducts) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'publishEeFormModalComponent',
				resolve: {
					editorialEntity: function () {
						return editorialEntity;
					},
					isPublishOnly: function () {
						return isPublishOnly;
					},
					fromForm: function () {
						return fromForm;
					},
					publishProductCode: function () {
						return publishProductCode;
					},
					publishProductName: function () {
						return publishProductName;
					},
					isPublishAssociatedProducts: function () {
						return isPublishAssociatedProducts;
					},
					publish: function (publishResource) {
						return publishResource.getAllChannelsByFlashIdAndProduct({
							flashId: editorialEntity.identifier,
							productCode: publishProductCode
						}).$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('publish');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('treeAutoMountModalService', treeAutoMountModalService);


	/** @ngInject */
	function treeAutoMountModalService(blockUI, $uibModal, EditorialEntityService, entityTreeAutoAssemblingResource) {

		var service = {
			openModal: openModal,
			save: save,
			getAutoMountingIds: getAutoMountingIds
		};

		return service;


		function openModal(editorialEntity) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'treeAutoMount',
				resolve: {
					editorialEntity: function () { return editorialEntity; },

					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('global');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}


		function save(editorialEntity, exactMatchSelected, approximateMatchSelected) {
			blockUI.start();
			editorialEntity.targetEntitiesFlashIds = getAutoMountingIds(exactMatchSelected, approximateMatchSelected);
			return entityTreeAutoAssemblingResource.assembling({ sourceEntityFlashId: editorialEntity.identifier}, editorialEntity.targetEntitiesFlashIds).$promise;
		}


		function getAutoMountingIds(exactMatchSelected, approximateMatchSelected) {
			var selectedExact = _.pickBy(exactMatchSelected, function (val) { return val; });
			var selectedApprox = _.pickBy(approximateMatchSelected, function (val) { return val; });
			var allSelected = _.merge(selectedExact, selectedApprox);
			return _.keys(allSelected);
		}
	}
})();

(function () {
	'use strict';


	angular.module('userApp')
		.component('treeAutoMount', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/tree-auto-mount/tree-auto-mount.tpl.html',
			controller: treeAutoMountController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'

			},
		});

	/** @ngInject */
	function treeAutoMountController(entityTemplateService, TirFilterSharedService, treeAutoMountModalService, blockUI, $translate, $state, treeAutoMountService, $scope, $timeout) {
		var ctrl = this;


		ctrl.$onInit = function () {

			ctrl.rawFilters = [];
			ctrl.showAdvanced = false;
			ctrl.filterDTO = [];
			ctrl.exactMatchSelected = [];
			ctrl.exactFiltersDisplay = [];
			ctrl.approximateMatch = [];
			ctrl.approximateMatchSelected = [];
			ctrl.isAllMasked = false;
			ctrl.isLocalStored = false;

			if (ctrl.resolve.editorialEntity.editorialEntityTemplate.contentType === 'TREE' && ctrl.resolve.editorialEntity.editorialEntityTemplate.automaticMounting) {
				ctrl.showAutoMountingFilters = true;
				ctrl.loadAutoMountingFilters();
				ctrl.mountingRt = ctrl.resolve.editorialEntity.editorialEntityTemplate.defaultMountingTR.id;
			}



		};


		ctrl.loadAutoMountingFilters = function () {
			//get stored filter
			var stored = treeAutoMountService.getSessionStorageFilter(ctrl.resolve.editorialEntity.identifier);
			if (angular.isDefined(stored)) {
				ctrl.isLocalStored = true;
				ctrl.filterDTO = stored;

				// timeout needed to bind value of sessionstorage
				$timeout(function () {
					ctrl.mappedFilters();
				});
			} else {
				treeAutoMountService.loadAutoMountingFilters(ctrl.resolve.editorialEntity.editorialEntityTemplate.code).then(function (result) {
					ctrl.filterDTO = angular.copy(result);
					ctrl.mappedFilters();
				});
			}
		};

		ctrl.mappedFilters = function () {
			ctrl.filterDTO = treeAutoMountService.mappedFilters(ctrl.filterDTO, ctrl.isLocalStored);
			ctrl.rawFilters = _.flatMap(this.filterDTO, ctrl.getfilter);
			ctrl.isAllMasked = treeAutoMountService.isAllMasked(ctrl.rawFilters);
		};

		ctrl.getfilter = function (f) {
			return f.filter;
		};

		ctrl.mount = function () {
			blockUI.start();
			treeAutoMountModalService.save(ctrl.resolve.editorialEntity, ctrl.exactMatchSelected, ctrl.approximateMatchSelected).then(function () {
				blockUI.stop();
				treeAutoMountService.saveFilterInSession(ctrl.filterDTO, ctrl.resolve.editorialEntity.identifier);
				ctrl.close();
				//Refresh the current page
				$state.reload();
			});
		};

		ctrl.entityChecked = function () {
			var selectedIds = treeAutoMountModalService.getAutoMountingIds(ctrl.exactMatchSelected, ctrl.approximateMatchSelected);
			return selectedIds.length === 0;
		};


		ctrl.closeModal = function (result) {
			ctrl.close({ $value: result });
		};


		ctrl.next = function () {

			ctrl.exactFiltersDisplay = TirFilterSharedService.extractFilters(ctrl.rawFilters);
			blockUI.start();
			entityTemplateService.searchTargetEntities(ctrl.resolve.editorialEntity.editorialEntityTemplate.code, ctrl.resolve.editorialEntity.ownerGroup || '', ctrl.filterDTO, ctrl.resolve.editorialEntity.identifier)
				.then(function (result) {
					ctrl.exactMatch = getLockState(result.exactMatch, ctrl.exactMatchSelected);
					ctrl.approximateMatch = getLockState(result.approximateMatch);
					ctrl.columns = result.columns;

					ctrl.showAdvanced = true;
					$translate.refresh();
					blockUI.stop();
				}).catch(function (err) {
					blockUI.stop();
				});

		};

		function getLockState(rows, checkboxModel) {
			rows.forEach(function (r) {
				if (checkboxModel) {
					checkboxModel[r.FLASH_ID] = true;
				}
				if (r.LOCK_STATE) {
					var s = r.LOCK_STATE.split('#');
					r.padlock = {
						color: s[0],
						closed: s[1],
						owner: s[2]
					};
				}
			});
			return rows;
		}

		ctrl.previous = function () {
			ctrl.exactMatchSelected = [];
			ctrl.approximateMatchSelected = [];
			ctrl.showAdvanced = false;
		};

		//check if all mandatory mounting meta are mentioned
		ctrl.isMandatoryMountingFiltersEmpty = function () {
			return TirFilterSharedService.isMandatoryFiltersEmpty(ctrl.rawFilters);
		};
	}
})();

(function () {
	'use strict';

	/**
	 * service providing utilities functions for tree assembling.
	 */
	angular
		.module('userApp')
		.factory('treeAutoMountService', TreeAutoMountService);

	/** @ngInject */
	function TreeAutoMountService($state, $filter, blockUI, entityTreeAutoAssemblingResource, ModalAlertService, entityTemplateService, $sessionStorage) {
		var service = {
			spreadTargetEntities: spreadTargetEntities,
			loadAutoMountingFilters: loadAutoMountingFilters,
			mappedFilters: mappedFilters,
			isAllMasked: isAllMasked,
			saveFilterInSession: saveFilterInSession,
			getSessionStorageFilter: getSessionStorageFilter,
			getDisplayFilter: getDisplayFilter
		};

		return service;

		//AUTO SPREAD TARGET ENTITIES
		function spreadTargetEntities(sourceEntityFlashId) {
			blockUI.start();
			entityTreeAutoAssemblingResource.spreadTargetEntities({ sourceEntityFlashId: sourceEntityFlashId }).$promise.then(function () {
				blockUI.stop();
				$state.reload();
				ModalAlertService.success($filter('translate')('userApp.treeEEEdition.messages.autoSpreadSuccess'));
			});
		}


		function loadAutoMountingFilters(code) {

			return entityTemplateService.getAutoAssemblingFilters(code)
				.then(function (result) {
					return result;
				});

		}

		function mappedFilters(filterDTO, isLocalStored) {

			filterDTO.forEach(function (f) {
				var curF = f.filter;
				curF.masked = f.masked;
				var type = curF.metaDataDTO.metaDataType.toLowerCase();
				if (type === 'date' && !isLocalStored) {
					curF.dateOperator = 'BETWEEN';
				}
				curF.visibility = true;
				curF.mandatory = f.mandatory;
			});

			return filterDTO;
		}

		function getDisplayFilter(filterDTO) {
			var rawFilters = [];
			// replace with map when using real service
			filterDTO.forEach(function (f) {
				rawFilters.push(f.filter);

			});
			return rawFilters;
		}

		function isAllMasked(rawFilters) {
			var i = 0;
			rawFilters.forEach(function (f) {
				if (f.masked) {
					i++;
				}
			});
			if (rawFilters.length === i) {
				return true;
			} else {
				return false;
			}
		}


		//get filter to sessionStorage
		function getSessionStorageFilter(eeId) {
			var storage = $sessionStorage['persitedFilter-' + eeId];
			return storage;
		}

		//save filter in sessionStorage
		function saveFilterInSession(data, eeId) {
			if (data) {
				$sessionStorage['persitedFilter-' + eeId] = data;
			}
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('restoreEntityService', RestoreEntityService);


	/** @ngInject */
	function RestoreEntityService(relationResource, blockUI, entityOperationResource, ModalAlertService, $filter, $state) {
		var service = {
			restoreEntity: restoreEntity,
			restoreEntityMulti: restoreEntityMulti
		};

		return service;

		function restoreEntity(editorialEntity) {
			blockUI.start();
			entityOperationResource.restoreEE(editorialEntity).$promise.then(function (data) {
				return data;
			}).then(function (ee) {
				blockUI.stop();
				$state.reload();
				ModalAlertService.success("'" + $filter('translate')('userApp.trash.home.success') + "'", $filter('translate')('userApp.trash.home.restorePerformed'), '');
			});
		}

		function restoreEntityMulti(eeTargetFlashIdList) {
			blockUI.start();
			entityOperationResource.restoreEditorialEntities(eeTargetFlashIdList).$promise.then(function (data) {
				blockUI.stop();
				ModalAlertService.success("'" + $filter('translate')('userApp.trash.home.success') + "'", $filter('translate')('userApp.trash.home.restorePerformed'), '');
				$state.reload();
				blockUI.stop();
				return data;
			});
		}
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('chooseEditorialEntity', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-link/choose-editorial-entity/choose-editorial-entity.component.html',
			controller: ChooseEditorialEntity,
			bindings: {
				tirId: "=",
				eeTargetChosen: "&?",
				eeSelected: "=", //clicked ee
				eeListChecked: "=", //checked ees list
				onSelectRowChange: "&?", //function fired when check or uncheck ee from list
				onSelectAllChange: "&?", //function fired when check or uncheck all from list page
				linkText: "=?",
				searchFlashId: "=?",
				nodeFlashId: "=?",
				trCode: "=?",
				enableMultiEETargetSelection: "<",
				searchSolr: '='
			},
		});

	/** @ngInject */
	function ChooseEditorialEntity($log) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Init choose editorial entity step");
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('validateEntityService', ValidateEntityService);


	/** @ngInject */
	function ValidateEntityService($q, $log, $rootScope, blockUI, $uibModal, entityValidateResource, ModalAlertService, $filter, confirmModalService, infoModalService) {
		var service = {
			openModal: openModal,
			checkIfExist: checkIfExist,
			openModalToValidateFLowModal: openModalToValidateFLowModal,
			chooseValidationType: chooseValidationType,
			handleRootValidation: handleRootValidation,
			changeStepValidationValidation: changeStepValidationValidation,
			checkIfEntityExistWithSomeDiscriminants: checkIfEntityExistWithSomeDiscriminants
		};

		return service;


		function chooseValidationType(editorialEntity) {
			var modalText = "userApp.editorialEntity.msg.chooseValidationType";
			var includeLinksButtonText = "userApp.editorialEntity.msg.includeChildInValidation";
			var onlyEeButtonText = "userApp.editorialEntity.msg.onlyTreeValidation";
			var title = "userApp.editorialEntity.msg.validation";
			var result = confirmModalService.openConfirmValidation(modalText, title, includeLinksButtonText, onlyEeButtonText);

			result.then(function (result) {
				if (result) {
					openModal(editorialEntity, true, true, true);
				} else {
					openModal(editorialEntity, false, true, false);
				}
			});

		}

		function openModal(editorialEntity, fullValidation, treeValdiation, refresh) {
			blockUI.start();

			var params = {
				id: editorialEntity.identifier
			};

			if (treeValdiation) {
				params.fullValidation = fullValidation;
				params.refresh = refresh;
			}

			return entityValidateResource.validateEE(params).$promise
				.then(function (data) {

					//CASE OF WORKFLOW VALDIATION
					if (!treeValdiation) {
						handleRootValidation(data, editorialEntity);
					} else if (fullValidation) {
						entireTreeValidation(data);
					} else {
						handleRootValidation(data.report, editorialEntity);
					}


				});
		}
		
		function checkIfExist(flashId){
			var deferred = $q.defer();
			entityValidateResource.checkIfExist({id: flashId}).$promise
				.then(function(data){
					if(!data.exist){
						infoModalService.openModal('error.invalidEE.message', 'error.invalidEE.title', {flashId: flashId});
						deferred.reject(data);
					}else{
						deferred.resolve(data);
					}})
				.catch(function(e){
					deferred.resolve(e);
				});
			return deferred.promise;
		}

		function checkIfEntityExistWithSomeDiscriminants(metaDataInstances, systemTee, entityFlashId){
			return entityValidateResource.checkIfEntityExistWithSomeDiscriminants({ entityFlashId: entityFlashId, systemTee: systemTee  }, metaDataInstances);
		}


		//USED BY WORK FLOW HOSTORY TO DISPLAY EE VALDIATION, THE REPORT IS AVAILABLE DIRECTLY FROM workFlowHistory OBJECT
		function openModalToValidateFLowModal(workFlowHistory) {
			var modalInstance = $uibModal.open({
				component: 'validateEntityComponent',
				resolve: {
					validation: workFlowHistory.validationReportDTO,
					statusValidation: workFlowHistory.statusValidationReportDTO,
					workflowHistoryDTO: workFlowHistory,
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}


		function entireTreeValidation(data) {

			if (_.has(data, 'availability') && data.availability) {


				var modalInstance = $uibModal.open({
					component: 'validateTreeComponent',
					resolve: {
						report: data
					},
					size: 'lg',
					backdrop: 'static'
				});
				modalInstance.opened.then(function () {
					blockUI.stop();
				});


			} else if (_.has(data, 'reportStatus') && data.reportStatus === 'IN_PROGRESS') {
				blockUI.stop();
				ModalAlertService.warn('info', $filter('translate')('userApp.editorialEntity.msg.requestInProgress'), '');
			} else {
				blockUI.stop();
				ModalAlertService.info('info', $filter('translate')('userApp.editorialEntity.msg.requestValidationSentInfo'), '');
			}

			$rootScope.$emit('validationStatusChanged');
		}



		function handleRootValidation(validation, editorialEntity) {
			if (validation.validEE) {
				ModalAlertService.info('info', $filter('translate')('userApp.editorialEntity.msg.valideEE'), '');
				blockUI.stop();
				return $q.when();
			} else {
				var modalInstance = $uibModal.open({
					component: 'validateEntityComponent',
					resolve: {
						validation: validation,
						editorialEntity: function () {
							return editorialEntity;
						},
						workflowHistoryDTO: function () {
							return null;
						}
					},
					size: 'lg',
					backdrop: 'static'
				});
				modalInstance.opened.then(function () {
					blockUI.stop();
				});

				return modalInstance.result;
			}
		}

		function changeStepValidationValidation(validation, editorialEntity, workflowHistoryDTO) {
			if (validation.validEE) {
				ModalAlertService.info('info', $filter('translate')('userApp.editorialEntity.msg.valideEE'), '');
				blockUI.stop();
				return $q.when();
			} else {
				var modalInstance = $uibModal.open({
					component: 'validateEntityComponentChangeStep',
					resolve: {
						validation: validation,
						editorialEntity: function () {
							return editorialEntity;
						},
						workflowHistoryDTO: function () {
							return workflowHistoryDTO;
						}
					},
					size: 'lg',
					backdrop: 'static'
				});
				modalInstance.opened.then(function () {
					blockUI.stop();
				});

				return modalInstance.result;
			}
		}
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('chooseRelationship', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-link/choose-relationship/choose-relationship.component.html',
			controller: ChooseRelationship,
			bindings: {
				relationshipTemplateList: "=",
				selectedValue: "=",
				currentStep: "=",
				prepareFirstStep: "&",
				gotoStep: "&"

			},
		});

	/** @ngInject */
	function ChooseRelationship($log) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Init choose relation ship  step");
		};

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('enterRelationshipMetadata', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-link/enter-relationship-metadata/enter-relationship-metadata.component.html',
			controller: EnterRelationshipMetadata,
			bindings: {
				metaData: "=",
				multiRelation: "=",
				targetEntities: "=",
				relations: "=",
				relationTemplate: "<",
				isContainer: "=",
				eetCode: "=?",
				ownerGroup: "=?",
				desiredPublicationDate: "=?",
				eeTargetFlashId: "=?",
				isLinkedRelation: '<'
			},
		});

	/** @ngInject */
	function EnterRelationshipMetadata($log, $sce, $translate, blockUI, relationResource) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Init enter relation ship meta data step " + ctrl.eetCode);
			ctrl.lang = $translate.use();
			ctrl.initDesiredPublicationDate();
			ctrl.initContainerSourcesData();

		};

		ctrl.trustAsHtml = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
			return $sce.trustAsHtml(ctrl.deleteHtmlTags(html));
		};

		// XF-3283
		ctrl.initContainerSourcesData = function () {
			ctrl.containerSources = [];
			if (ctrl.isContainer) {
				var eeTargetFlashId = ctrl.eeTargetFlashId;
				if (eeTargetFlashId) {
					ctrl.initDesiredPublicationDate(eeTargetFlashId);
					ctrl.initContainerSources(eeTargetFlashId);
				}
			}
		};

		ctrl.initDesiredPublicationDate = function (eeTargetFlashId) {
			if (eeTargetFlashId) {
				blockUI.start();
				relationResource.getOldestPublicationDateOnContainerSource({
					eeTargetFlashId: eeTargetFlashId
				}).$promise.then(function (data) {
					blockUI.stop();
					ctrl.desiredPublicationDate.value = data.date ? new Date(data.date) : new Date();
				});
			} else {
				ctrl.desiredPublicationDate.value = new Date();
			}
		};

		ctrl.initContainerSources = function (eeTargetFlashId) {
			blockUI.start();
			relationResource.getContainerSources({
				eeTargetFlashId: eeTargetFlashId
			}).$promise.then(function (data) {
				blockUI.stop();
				ctrl.containerSources = data;
			});
		};
	}
})();


(function () {
	'use strict';


	angular
		.module('userApp')
		.component('chooseTree', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-intra-link/choose-tree/choose-tree.component.html',
			controller: ChooseTree,
			bindings: {
				parents: "=",
				parentChosen: "&"
			},
		});

	/** @ngInject */
	function ChooseTree($log) {
		var ctrl = this;

		ctrl.$onInit = function () {


		};



	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('chooseEeFromTree', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-intra-link/choose-ee-from-tree/choose-ee-from-tree.component.html',
			controller: ChooseEeFromTree,
			bindings: {
				entity: "=",
				selectedElement: "=",
				teeCodes: "=",
				entityFlashId: "="
			},
		});

	/** @ngInject */
	function ChooseEeFromTree($log, $timeout) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Choose an element from the tree");

			initDataSource(ctrl.entity);

			ctrl.options = {
				checkboxes: {
					checkChildren: false,
					template: "<input id='radio_#:item.uid#' ng-if='dataItem.type === \"REFERENCE\"' type='radio' ng-click=\"$scope.elementChosenen(dataItem)\" />"
				}
			};
		};

		ctrl.onDataBound = function (e) {
			$timeout(function () {
				ctrl.treeview.expand("> .k-group > .k-item");
			});
		};

		ctrl.isContains = function (node) {
			var found = _.includes(ctrl.teeCodes, node.teeCode);
			return found && (node.targetId !== ctrl.entityFlashId);
		};


		/**
		 * Prepare the data source to be used by kendo ui.
		 */
		function initDataSource(tree) {

			ctrl.source = new kendo.data.HierarchicalDataSource({
				data: tree.items,
				schema: {
					model: {
						children: "items",
						hasChildren: function (e) {
							return e.items && e.items.length;
						}
					}
				}


			});
			countSelectableItems(ctrl.entity.items);

		}

		function countSelectableItems(items) {

			if (ctrl.teeCodes && ctrl.teeCodes.length === 0) {
				ctrl.selectableFound = false;
			}
			else {
				_.forEach(items, function (item) {
					if (ctrl.isContains(item)) {
						ctrl.selectableFound = true;
						return;
					}
					else {
						countSelectableItems(item.items);
					}
				});
			}


		}



	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('pointToSubElement', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-link/point-to-sub-element/point-to-sub-element.component.html',
			controller: PointToSubElement,
			bindings: {
				eeTarget: "=",
				pointToSubElement: "=",
				typeEe: "=",
				containsSubElement: "=",
				selected: "=",
				wording: "=",
				onNodeCheck: "&",
				onNodeAction: "&"
			},
		});

	/** @ngInject */
	function PointToSubElement($log, $sce, blockUI, HTML_PREVIEW_TYPE, EDITORIAL_ELEMENT_TYPE, htmlPreviewService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Init point to sub element step ");
			var previewUI = blockUI.instances.get('previewUI');
			previewUI.start();

			if (ctrl.eeTarget) {
				htmlPreviewService.getPreview(ctrl.eeTarget.identifier, HTML_PREVIEW_TYPE.restricted, false, EDITORIAL_ELEMENT_TYPE.entity, ctrl.productCode)
					.then(function (eePreviewHtml) {
						ctrl.eeTarget.restrictedHtmlPreview = eePreviewHtml.htmlPreview;
						ctrl.eeTarget.type = eePreviewHtml.type;
						previewUI.stop();
					});
			}
		};

		ctrl.trustAsHtml = function (html) {
			if (html) {
				return $sce.trustAsHtml(html);
			}
		};


	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editEEsMetadataModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/bulk/edit-ees-metadata-modal.html',
			controller: EditEESMetadataModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function EditEESMetadataModalController($rootScope, $filter, $state, confirmModalService, infoModalService, entityLockService, metadataValidationService, $translate, editMetaDataModalService, blockUI, EDITORIAL_ELEMENT_TYPE) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.lang = $translate.use();
			ctrl.flashIds = ctrl.resolve.flashIds;
			ctrl.metaInstances = ctrl.resolve.metaInstances;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.idTee = ctrl.resolve.idTee;
			//$ctrl.ownerGroup=
		};

		ctrl.save = function () {
			confirmModalService.openModal('userApp.editEEsMetaData.home.confirmMsg').then(function (result) {
				if (result) {
					//SAVE METADATA
					editMetaDataModalService.editMultiple(ctrl.flashIds, ctrl.selectedMetaInstance)
						.then(function (metadataInstances) {
							blockUI.stop();
							ctrl.close({});
							//OPEN MODAL INFO					
							infoModalService.openBulkSucess(
								{
									operation: $filter('translate')('entity.actionBar.workflow.tooltip')
								}
							).then(function () {
								$state.go('myBulkOperations');
							});
						});
				}
			});


		};

		ctrl.cancel = function () {
			ctrl.dismiss();
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('displayEditorialMetadataService', DisplayEditorialMetadataService);

	/** @ngInject */
	function DisplayEditorialMetadataService(relationResource) {
		var service = {
			isRelationDeleted: isRelationDeleted
		};

		return service;

		function isRelationDeleted(flashId) {
			return relationResource.getByFlashId({
				flashId: flashId
			}).$promise
				.then(function (data) {
					return angular.isUndefined(data.deleted) || data.deleted === true;
				});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('displayEditorialMetadata', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/metadata/display-editorial-metadata/display-editorial-metadata.html',
			controller: DisplayEditorialMetadata,
			bindings: {
				editorialType: '<',
				ecmStyle: '<',
				onEditMetadata: '&',
				isRelation: '<',
				isSourceEntityContainer: '<?',
				editMetadataEnabled: '<',
				isEditor: '<',
				flashId: '<'
			}
		});

	/** @ngInject */
	function DisplayEditorialMetadata(metadataResource, EDITORIAL_ELEMENT_TYPE, editMetaDataModalService, $translate, displayEditorialMetadataService) {
		var ctrl = this;
		ctrl.$onInit = function () {
			ctrl.lang = $translate.use();
		};

		ctrl.$onChanges = function () {
			if (ctrl.flashId) {
				var type = ctrl.isRelation ? EDITORIAL_ELEMENT_TYPE.relation : ctrl.editorialType;
				if (ctrl.isRelation) {
					// TEST IF RELATION DELETED
					displayEditorialMetadataService.isRelationDeleted(ctrl.flashId)
						.then(function (deleted) {
							if (!deleted) {
								getMetaInstanceByGroup(type);
							}
						});
				} else {
					getMetaInstanceByGroup(type);
				}
			}
		};

		ctrl.isDefinedGroupName = function (groupName) {
			//FIXME : group by filter on ng-repeat  generate an 'undefiend' strings.
			return angular.isDefined(groupName) && !_.isEqual(groupName, "undefined");
		};

		ctrl.editMetadata = function () {

			var type = ctrl.isRelation ? EDITORIAL_ELEMENT_TYPE.relation : ctrl.editorialType;

			// if we are in editor mode, the modal should not handle lock
			editMetaDataModalService.openEditMetaModalByFlashId(ctrl.flashId, type, undefined, undefined, undefined, undefined, undefined, ctrl.isSourceEntityContainer, undefined, undefined, ctrl.isEditor)
				.then(function (response) {
					ctrl.metaGroupList = response.metaDataByMetaGroup;
				});
		};

		function getMetaInstanceByGroup(type) {
			metadataResource.getMetaInstanceByGroup({ id: ctrl.flashId, type: type }).$promise
				.then(function (list) {
					ctrl.metaGroupList = list;
				});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('systemAuthorService', SystemAuthorService);

	/** @ngInject */
	function SystemAuthorService(userResource) {
		var service = {
			getUsersByGrpCode: getUsersByGrpCode
		};

		return service;

		// GET GROUPS FOR CURRENT USER & TEE
		function getUsersByGrpCode(userGroupCode, query) {
			return userResource.getUsersByGrpCode({userGroupCode: userGroupCode, query: query}).$promise;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('systemAuthor', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/metadata/systemAuthor/system-author.html',
			controller: SystemAuthorController,
			bindings: {
				entity: '=',
				editAuthors: '<',
				contentClass: '@?',
				labelClass: '@?'
			}
		});

	/** @ngInject */
	function SystemAuthorController($q, $scope, systemAuthorService, userResource, $filter) {
		var ctrl = this;

		ctrl.$onInit = function () {

			//init metadata system section if undefined
			if (angular.isUndefined(ctrl.entity.system)) {
				ctrl.entity.system = {};
			}
			//init metadata system authors if undefined as empty
			if (angular.isUndefined(ctrl.entity.system.systemAuthors)) {
				ctrl.entity.system.systemAuthors = [];
			}

			if ((_.isUndefined(ctrl.entity.ownerGroup) || ctrl.entity.ownerGroup.length >= 0) && !ctrl.editAuthors) {
				initUser();

			} else {
				ctrl.getAuthors();
			}
			if (ctrl.editAuthors) {
				initEditedUser();
			}

		};

		ctrl.getAuthors = function (query) {
			var deferred = $q.defer();
			//GET USERS FOR GRP
			if (angular.isUndefined(ctrl.users) || ctrl.users.length === 0 && ctrl.entity.ownerGroup && ctrl.entity.ownerGroup !== '') {
				systemAuthorService.getUsersByGrpCode(ctrl.entity.ownerGroup, query).then(function (data) {
					ctrl.users = _.map(data, function (row) {
						return {
							'login': row.login,
							'fullName': row.fullName
						};
					});

					deferred.resolve($filter('filter')(ctrl.users, { fullName: query }));
				});
			} else {
				//filter arrays by query
				var filteredUsers = $filter('filter')(ctrl.users, { fullName: query });
				deferred.resolve(filteredUsers);
			}
			return deferred.promise;
		};

		// //When ownerGroup change
		$scope.$on('ownerGroupUpdated', function () {
			//rest authors
			initUser();
		});

		ctrl.disableSystemAuthors = function () {
			return angular.isUndefined(ctrl.entity.ownerGroup) || ctrl.entity.ownerGroup === '';
		};

		function initUser() {
			userResource.getCurrentUser().$promise.then(function (currentUser) {
				ctrl.entity.system.systemAuthors = [];
				ctrl.entity.system.systemAuthors.push({
					login: currentUser.login,
					fullName: currentUser.fullName
				});
			});
		}

		function initEditedUser() {
			var systemAuthors = [];
			_.each(ctrl.entity.system.systemAuthors, function (row) {
				systemAuthors.push(row.login);
			});
			ctrl.entity.system.systemAuthors = [];
			userResource.getUserPublicInfoByLogin(systemAuthors).$promise.then(function (users) {
				_.each(users, function (row) {
					ctrl.entity.system.systemAuthors.push({
						fullName: row.fullName,
						login: row.login
					});
				});


			});
		}

	}
})();

/* eslint-disable indent */
(function () {
	'use strict';

	angular
		.module('userApp')
		.component('linkEeWizardForm', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/link-ee-wizard-form.tpl.html',
			controller: LinkEeWizardFormController,
			/// 1.API ///
			bindings: {
				targetEntities: '<',
				currentUser: '<',
				isBulk: '<',
				isFromFileMenu: '<',
				productCode: '<?',
				proofChannels: '<?',
				productChannels: '<?',
				canalsFromProduct: '<?',
				isProofing: '<?',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function LinkEeWizardFormController($rootScope, $scope, LinkEeWizardModalService, entityLinkingResource, $q, MetadataService, relationshipTemplateWizardService, entityLockService, $filter, $sce, blockUI, EditorialEntityService, entityOperationResource, nodeResource, ModalAlertService, relationTemplateResource, relationResource, modelService, publishResource, deleteEntityService, infoModalService, linkEeWizardFormService) {
		var ctrl = this;
		ctrl.alreadySelectedSubElementsIds = [];
		ctrl.listNode = [];
		ctrl.relationshipTemplateList = [];
		/// 2.CONFIG ///
		ctrl.$onInit = function () {
			ctrl.oldTargetEntities = ctrl.targetEntities;
			//Contains relationship template all elements selected in steps 1 (TR), 2(EE source) and 3(sub element)
			ctrl.rtStepElementsSelected = [];
			ctrl.existEntitiesWithOtherProduct = false;
			ctrl.rtBreadcrumb = '';
			// Step access.
			ctrl.proofChannelSelected = undefined;
			ctrl.accessedSelectProofChannelStep = false;
			ctrl.accessedSelectModelSourceStep = false;
			ctrl.accessedRelationsReferenceNodeStep = false;
			ctrl.accessedSelectTrStep = false;
			ctrl.accessedSelectEeSourceStep = false;
			ctrl.accessedSelectSubElementStep = false;
			ctrl.wizardEnd = false;
			ctrl.initDates(ctrl.targetEntities);
			//Errors
			ctrl.errors = [];

			//Wizard steps
			ctrl.steps = [
				{
					id: 1,
					name: "userApp.linkEEWizard.labels.step01",
					description: "Select relation templates step" //this is for documentation
				},
				//if is proofing true step2 to display is model list otherwise it's ee list
				{
					id: 2,
					name: "userApp.linkEEWizard.labels.step02" + (!ctrl.isProofing ? "SelectEE" : "SelectModel"),
					description: "Select source entity step or in case proofing wizard select ee model step"
				},
				{
					id: 3,
					name: "userApp.linkEEWizard.labels.step03",
					description: "Select a sub node in entity tree step"
				},
				{
					id: 4,
					name: "userApp.linkEEWizard.labels.step04",
					description: "Fulfil relationship metadata step"
				}
			];
			//
			ctrl.eetCodes = [];
			//
			ctrl.eetFlashIds = [];
			//
			ctrl.relationMetaDatasList = [];
			ctrl.multiRelation = true;
			//
			ctrl.isLinked = false;
			ctrl.hideNextStepButton = ctrl.isBulk || ctrl.isFromFileMenu;
			angular.forEach(ctrl.targetEntities, function (ee) {
				ctrl.eetCodes.push(ee.eetCode);
			});
			angular.forEach(ctrl.targetEntities, function (ee) {
				ctrl.eetFlashIds.push(ee.flashId);
			});
			//Get target system title
			if (ctrl.targetEntities.length === 1) {
				ctrl.targetSystemTitle = ctrl.targetEntities[0].system.systemTitle;
			}

			ctrl.currentStep = {};
			//Add step to choose proffing channel only if it's proofing wizard
			if (ctrl.isProofing) {
				ctrl.steps.unshift({
					id: 0,
					name: "userApp.linkEEWizard.labels.step00",
					description: "Only in case it's proofing wizard, Select proofing channel step"
				});
				calculateStepsToDisplaySinceStep0(ctrl.productChannels, ctrl.proofChannels);
			} else {
				calculateStepsToDisplaySinceStep1(ctrl.eetCodes, ctrl.eetFlashIds);
			}
		};

		/**
		 * IF there is only one proofing channel,
		 * then init step0 with default values and go to step1 in wizard
		 * @param proofChannels target eeCodes
		 * @param productChannels proofing channels by products
		 */
		function calculateStepsToDisplaySinceStep0(productChannels, proofChannels) {

			//Check list steps to display
			if ((!productChannels || productChannels.length === 0) && proofChannels && proofChannels.length === 1) {
				ctrl.currentStep = ctrl.steps[1];
				ctrl.onProofChannelSelected(proofChannels[0], false, false);
				calculateStepsToDisplaySinceStep1(ctrl.eetCodes, ctrl.eetFlashIds);
			} else {
				if (productChannels.length === 1 && productChannels[0].publicationChannel.length === 1) {
					ctrl.onProofChannelSelected(productChannels[0].publicationChannel[0], false, false, productChannels[0].productCode, productChannels[0].productWording);
					calculateStepsToDisplaySinceStep1(ctrl.eetCodes, ctrl.eetFlashIds);

				} else {
					ctrl.currentStep = getStepById(0);
				}
			}
		}

		/**
		 * IF there is only one TR associated to target eeCodes,
		 * then init step1 with default values and bypass step1 in wizard
		 * @param eetCodes target eeCodes
		 */
		function calculateStepsToDisplaySinceStep1(eetCodes, eetFlashIds) {
			//Check list steps to display
			blockUI.start();
			relationTemplateResource.getRelationshipTemplatesByEetTarget({
				//remove duplicated eeCodes from list with _.uniq
				eetCodes: _.uniq(eetCodes),
				eetFlashIds: _.uniq(eetFlashIds),
				trTypeWording: 'accrochage',
				checkExistsModelsForTrEeSources: ctrl.isProofing,
				productCodeModelsFilter: ctrl.modelProductCodeFilter,
				publicationChannelCode: ctrl.isProofing && ctrl.proofChannelSelected ? ctrl.proofChannelSelected.code : null
			}).$promise.then(function (data) {
				ctrl.relationshipTemplateList = data.dtos;
				if (ctrl.relationshipTemplateList.length === 1) {
					var selectedTr = ctrl.relationshipTemplateList[0];
					//init slected tr by the only one found
					ctrl.onTrSelected(selectedTr, false, false);
					calculateStepsToDisplaySinceStep2(ctrl.relationTemplateDetails);
				} else {
					ctrl.currentStep = getStepById(1);
				}
				blockUI.stop();
			});
		}

		/**
		 * If the selected TR has only one EE source which is owned by current user and not locked,
		 * then init step2 with default values and bypass step2 in wizard
		 * @param relationTemplateDetails info details of the selected relationship template
		 */
		function calculateStepsToDisplaySinceStep2(relationTemplateDetails) {
			//
			if (ctrl.isProofing) {
				ctrl.modelsEetCodesFilters = _.uniq(_.map(ctrl.trSelected.sourceEditorialEntityTemplates, function (eet) { return eet.code; }));
				ctrl.currentStep = getStepById(2);
			} else {
				blockUI.start();
				relationTemplateResource.getSourceEEntitiesById({
					trId: relationTemplateDetails.id
				}).$promise.then(function (data) {
					ctrl.sourceEesList = _.sortBy(data.ees, ['titleSystem']);
					if (ctrl.sourceEesList.length === 1 && (!ctrl.sourceEesList[0].padlock.closed || (ctrl.sourceEesList[0].padlock.closed && ctrl.sourceEesList[0].padlock.owner.identifier === ctrl.currentUser.identifier))) {
						//init selected EE source by the only one found
						ctrl.onEeSourceSelected(ctrl.sourceEesList[0], false, false).then(function (selectedEeSource) {
							calculateStepsToDisplaySinceStep3(selectedEeSource);
						});
					} else {
						ctrl.currentStep = getStepById(2);
					}
					blockUI.stop();
				});
			}
		}

		/**
		 * If select EE source hasn't sub element with STRUCTURAL	type
		 * init step3 with default values and bypass step3 in wizard
		 * @param eeSourceSubElements subelements of the selected eesource
		 */
		function calculateStepsToDisplaySinceStep3(eeSource) {
			// check if exist relation template with attribute onlyEntitiesWithSameProductAsMe is true
			var rTsWithOnlyEntitiesWithSameProductAsMe = $filter('filter')(ctrl.relationshipTemplateList, { 'onlyEntitiesWithSameProductAsMe': true });
			// set flashIds to relation template in targetEntites
			if (rTsWithOnlyEntitiesWithSameProductAsMe.length > 0) {
				angular.forEach(rTsWithOnlyEntitiesWithSameProductAsMe, function (rt) {
					if (rt.id === ctrl.relationTemplateDetails.id
						&& rt.entitiesFlashIdsWithSameProductAsMe && rt.entitiesFlashIdsWithSameProductAsMe !== ctrl.eetFlashIds) {
						ctrl.targetEntities = ctrl.targetEntities.filter(function (target) {
							return rt.entitiesFlashIdsWithSameProductAsMe.indexOf(target.flashId) !== -1;
						});
					} else {
						ctrl.targetEntities = ctrl.oldTargetEntities;
					}
				});
			}

			entityLinkingResource.isLinkedEEList({
				sourceEEFlashId: eeSource.identifier,
				targetEEFlashIds: ctrl.eetFlashIds,
				targetSubElementFlashId: ""
			}).$promise.then(function (linksInfoList) {
				blockUI.stop();

				var previousHooksList = [];
				var displayLinkEesWarningModal = false;
				_.each(linksInfoList, function (linksInfos) {
					if (linksInfos !== null && (linksInfos.alreadyLinked || linksInfos.hookedToSameProduct || linksInfos.hookedToSameEet)) {
						//Injecte le titre de l'info ciblée dans linksInfos...
						var targetEe = _.filter(ctrl.targetEntities, function (element) { return element.flashId === linksInfos.eeTargetFlashId; });
						if (targetEe !== null && targetEe.length === 1) {
							linksInfos.eeTargetSystemTitle = targetEe[0].system.systemTitle;
						}
						previousHooksList.push(linksInfos);
						if (linksInfos.alreadyLinked) {
							displayLinkEesWarningModal = true;
						}
					}
				});
				if (previousHooksList.length > 0) {
					var rtWithActiveContextualizationOptions = _.filter(ctrl.relationshipTemplateList, function (rt) {
						return rt.ignoreEntitiesAttachedToSource || rt.ignoreEntitiesHookedToSameProduct || rt.ignoreEntitiesHookedToSameEet;
					});
					if (rtWithActiveContextualizationOptions.length > 0) {
						ctrl.targetEntities = ctrl.oldTargetEntities;
						angular.forEach(rtWithActiveContextualizationOptions, function (rt) {
							if (rt.id === ctrl.relationTemplateDetails.id) {
								angular.forEach(previousHooksList, function (item) {
									var ignoreItem = rt.ignoreEntitiesAttachedToSource && item.alreadyLinked
										|| rt.ignoreEntitiesHookedToSameProduct && item.hookedToSameProduct
										|| rt.ignoreEntitiesHookedToSameEet && item.hookedToSameEet;
									if (ignoreItem && item.eeTargetFlashId) {
										displayLinkEesWarningModal = true;
										// remove linked tee from targetEntities
										ctrl.targetEntities = _.filter(ctrl.targetEntities, function (element) {
											return element.flashId !== item.eeTargetFlashId;
										});
									}
								});
							}
						});
					}
					if (displayLinkEesWarningModal) {
						//Launch confirmation modal
						//Report incompatible targets that will be filtered out (already linked, linked to the same product, linked to the same entity type)
						LinkEeWizardModalService.openLinkEesWarningModal(previousHooksList, true, ctrl.trSelected).then(function (confirm) {
							if (confirm) {
								prepareCalculateStepsToDisplaySinceStep3(eeSource);
							}
						});
					} else {
						prepareCalculateStepsToDisplaySinceStep3(eeSource);
					}
				} else {
					prepareCalculateStepsToDisplaySinceStep3(eeSource);
				}
			}, function () {
				blockUI.stop();
			});
		}

		/**
		 * If there is no RT metadata nor hooking metadata
		 * and if the EE source isn't CONTAINER type
		 * then init step4 with default values and bypass step4 in wizard (as it is last step, wizard will be closed)
		 * @param relationTemplateDetails info details of the selected relationship template
		 */
		function calculateStepsToDisplaySinceStep4(relationTemplateDetails) {
			if (!ctrl.eeSourceDetails.container && ctrl.relationMetaDatasList.length === 0) {
				var relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationTemplateDetails, ctrl.relationMetaDatasList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate);
				var referenceNodes = relationshipTemplateWizardService.initReferenceNodes(ctrl.eeSourceDetails, ctrl.subElementDetails, relations);
				ctrl.onRelationsRefNodesInitialized(relations, false, referenceNodes);
				ctrl.doSave();
			} else {
				ctrl.currentStep = getStepById(4);
			}
		}

		/**
		 * Function fired when proof channel is selected (Step select proof channel of the wizard)
		 * @param proofChannelSelected selected proof channel
		 * @param launchNextStep bypass select model step and auto launch next step (case where there is only one channel, so init selected one with it and go directly to next step without display select channel step to user)
		 * @param accessedSelectProofChannelStep true if select channel step was displayed to user and not bypassed (case where there is more than one channel so user has to make choose manually)
		 * @param productCode product code of the product proof channel selected
		 * @param productWording product wording of the product proof channel selected
		 */
		ctrl.onProofChannelSelected = function (proofChannelSelected, launchNextStep, accessedSelectProofChannelStep, productCode, productWording) {

			ctrl.modelProductCodeFilter = productCode;
			ctrl.accessedSelectProofChannelStep = accessedSelectProofChannelStep;
			ctrl.proofChannelSelected = proofChannelSelected;
			//IF IT'S PRODUCT CODE CHANNEL? IN WIZARD DISPLAY CHANNEL NAME WITH PRODUCT CODE BETWEEN BRACKETS
			var stepWizardLabel = ctrl.proofChannelSelected.name + (productCode ? ' (' + productWording + ')' : '');
			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(0).id, stepWizardLabel, accessedSelectProofChannelStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			if (launchNextStep) {
				//Launch next step
				ctrl.next();
			}
		};
		/**
		 * Function fired when TR is selected (Step select TR of the wizard)
		 * @param trSelected tr selected
		 * @param launchNextStep bypass select tr step and auto launch next step (case where there is only one tr, so init selected one with it and go directly to next step without display select tr step to user)
		 * @param accessedSelectTrStep true if select tr step was displayed to user and not bypassed (case where there is more than one tr so user has to make choose manually)
		 */
		ctrl.onTrSelected = function (trSelected, launchNextStep, accessedSelectTrStep) {

			ctrl.trSelected = trSelected;
			ctrl.relationTemplateDetails = {
				id: trSelected.id,
				metaInstanceList: trSelected.metaInstanceList,
				code: trSelected.code,
				wording: trSelected.wording
			};
			ctrl.accessedSelectTrStep = accessedSelectTrStep;
			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(1).id, ctrl.relationTemplateDetails.wording, accessedSelectTrStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			if (launchNextStep === true) {
				//Launch next step
				ctrl.next();
			}
		};
		/**
		 * Function fired when model is selected (Step select model of the wizard)
		 * @param selectedModel model selected
		 * @param launchNextStep bypass select model step and auto launch next step (case where there is only one model, so init selected one with it and go directly to next step without display select model step to user)
		 * @param accessedSelectModelSourceStep true if select model step was displayed to user and not bypassed (case where there is more than one model so user has to make choose manually)
		 */
		ctrl.onModelSourceSelected = function (selectedModel, launchNextStep, accessedSelectModelSourceStep) {
			blockUI.start();
			modelService.getModel({
				modelFlashId: selectedModel.flashId,
				withAllMetaInstances: true
			}).$promise.then(function (data) {
				var modelSelected = data;
				var editorialEntity = {
					editorialEntityTemplate: modelSelected.editorialEntityTemplate,
					modelFlashId: modelSelected.flashId,
					ownerGroup: modelSelected.system.systemOwnerGroup,
					system: {
						systemAuthors: [{
							login: ctrl.currentUser.login,
							fullName: ctrl.currentUser.fullName
						}]
					},
					forProofing: true
				};
				EditorialEntityService.save(editorialEntity).$promise.then(function (ee) {
					ctrl.onEeSourceSelected(ee, true, false).then(function (selectedEeSource) {
						prepareCalculateStepsToDisplaySinceStep3(selectedEeSource);
						ctrl.accessedSelectModelSourceStep = accessedSelectModelSourceStep;
						ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(2).id, selectedModel.name, accessedSelectModelSourceStep);
						ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
					});
					blockUI.stop();
				});
			});
		};
		/**
		 * Function fired when ee source is selected (Step select EE source of the wizard)
		 * @param selectedEeSource ee source selected
		 * @param launchNextStep bypass select ee source step and auto launch next step (case where there is only one ee source, so init selected one with it and go directly to next step without display select ee source step to user)
		 * @param accessedSelectEeSourceStep true if select ee source step was displayed to user and not bypassed (case where there is more than one ee source so user has to make choose manually)
		 */
		ctrl.onEeSourceSelected = function (selectedEeSource, launchNextStep, accessedSelectEeSourceStep) {

			var deferred = $q.defer();
			var selectedEeSourceId = selectedEeSource.identifier;
			var selectedEeSourceWording = selectedEeSource.titleSystem;
			ctrl.accessedSelectEeSourceStep = accessedSelectEeSourceStep;
			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(2).id, selectedEeSourceWording, accessedSelectEeSourceStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			blockUI.start();
			EditorialEntityService.getEEWithFirstLevelChildNodesById({
				id: selectedEeSourceId
			}).$promise.then(function (data) {
				blockUI.stop();
				ctrl.selectedEeSource = data;
				ctrl.eeSourceDetails = {
					container: ctrl.selectedEeSource.editorialEntityTemplate.container,
					metaInstanceList: ctrl.selectedEeSource.metaInstanceList,
					flashId: ctrl.selectedEeSource.identifier,
					subNodesId: ctrl.selectedEeSource.subNodesId,
					ownerGroup: ctrl.selectedEeSource.ownerGroup,
					eetCode: ctrl.selectedEeSource.editorialEntityTemplate.code
				};

				if (launchNextStep === true) {
					//Lauch select subelement step
					ctrl.next();
				}
				deferred.resolve(data);
			}, function () {
				blockUI.stop();
				deferred.reject(null);
			});
			return deferred.promise;
		};
		/**
		 * Function fired when subelement of ee source tree is selected (Step select subelement of ee source tree of the wizard)
		 * @param subElementDetails ee source subelement selected
		 * @param launchNextStep bypass select subelement of ee source tree step and auto launch next step (case where there is ee source tree is empty, so add element and  go directly to next step without display select ee source sub element step to user)
		 * @param accessedSelectSubElementStep true if subelement of ee source tree step was displayed to user and not bypassed (case where ee source tree is not empty  so user has to make choose manually of the subnode were to link target)
		 */
		ctrl.onSubElementSelected = function (subElementDetails, launchNextStep, accessedSelectSubElementStep) {

			ctrl.subElementDetails = subElementDetails;
			// Do nothing if the selected subelement is not part of the selected source EE
			// Ex.: the selected subelement is part of an EE hooked to the selected source EE (which is possible since the contents of the hooked EEs are displayed in the wizard)
			// (ctrl.subElementDetails is null if there is no structural node to chose from in the selected source EE)
			if (ctrl.subElementDetails === null || ctrl.subElementDetails.path[0] === ctrl.selectedEeSource.identifier) {
				ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(3).id, subElementDetails !== null ? subElementDetails.text : '', accessedSelectSubElementStep);
				ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
				ctrl.accessedSelectSubElementStep = accessedSelectSubElementStep;
				if (!ctrl.eeSourceDetails.container && ctrl.relationMetaDatasList.length === 0) {
					ctrl.wizardEnd = true;
				} else {
					if (launchNextStep === true) {
						//Go to edit relation metadata step.
						ctrl.next();
					}
				}
			}
		};

		ctrl.onRelationsRefNodesInitialized = function (relations, accessedRelationsReferenceNodeStep, referenceNodes) {

			ctrl.rtStepElementsSelected = relationshipTemplateWizardService.updateTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, getStepById(4).id, '', accessedRelationsReferenceNodeStep);
			ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
			ctrl.relations = relations;
			ctrl.referenceNodes = referenceNodes;
			ctrl.wizardEnd = !accessedRelationsReferenceNodeStep;
		};
		//
		ctrl.formatSystemTitle = function (titleSystem) {
			return $sce.trustAsHtml(titleSystem);
		};
		//
		ctrl.$onChanges = function (changesObj) { };
		//
		ctrl.$onDestroy = function () { };
		//
		ctrl.onErrors = function (errors) {
			ctrl.errors = (errors !== null) ? _.uniq([].concat(ctrl.errors, errors)) : [];
		};
		//
		function getStepById(stepId) {
			return _.find(ctrl.steps, function (step) {
				return step.id === stepId;
			});
		}
		//
		ctrl.initDates = function (targetEntities) {
			blockUI.start();
			targetEntities.forEach(function (tr, index) {
				if (tr.flashId) {
					relationResource.getOldestPublicationDateOnContainerSource({
						eeTargetFlashId: tr.flashId
					}).$promise.then(function (data) {
						blockUI.stop();
						if (ctrl.targetEntities) {
							ctrl.targetEntities[index].desiredPublicationDate = data.date ? new Date(data.date) : new Date();
							ctrl.targetEntities[index].display = !!data.date;
						}
						if (data.date) {
							ctrl.isLinked = true;
						}
					});
				}
			});
		};
		//Step 0 is specific for proofing wizard
		ctrl.isActiveStep00 = function () {
			return ctrl.currentStep.id === 0;
		};
		//
		ctrl.isActiveStep01 = function () {
			return ctrl.currentStep.id === 1;
		};
		//
		ctrl.isActiveStep02 = function () {
			return ctrl.currentStep.id === 2;
		};
		//
		ctrl.isActiveStep03 = function () {
			return ctrl.currentStep.id === 3;
		};
		//
		ctrl.isActiveStep04 = function () {
			return ctrl.currentStep.id === 4;
		};
		//
		ctrl.isPrevious = function () {
			return (
				(ctrl.isProofing && ctrl.currentStep.id === 1 && ctrl.accessedSelectProofChannelStep) ||
				(ctrl.currentStep.id === 2 && (ctrl.accessedSelectTrStep || ctrl.accessedSelectProofChannelStep)) ||
				(ctrl.currentStep.id === 3 && (ctrl.accessedSelectEeSourceStep || ctrl.accessedSelectTrStep || ctrl.accessedSelectProofChannelStep)) ||
				(ctrl.currentStep.id === 4)
			);
		};
		//
		ctrl.isNext = function () {
			return (
				(ctrl.isProofing && ctrl.currentStep.id === 0 && angular.isDefined(ctrl.proofingChannels)) ||
				(ctrl.currentStep.id === 1 && angular.isDefined(ctrl.relationTemplateDetails) && ctrl.relationTemplateDetails !== null) ||
				(ctrl.currentStep.id === 2 && angular.isDefined(ctrl.eeSourceDetails) && ctrl.eeSourceDetails !== null) ||
				(ctrl.currentStep.id === 3 && angular.isDefined(ctrl.subElementDetails) && ctrl.subElementDetails !== null) ||
				(ctrl.currentStep.id === 4)
			);
		};
		//
		ctrl.handleStep = function (toStep) {
			//
			ctrl.wizardEnd = false;
			ctrl.errors = [];
			switch (toStep) {
				default:
				case 0:
					ctrl.selectedEeSource = null;
					ctrl.proofChannelSelected = null;
					ctrl.currentStep = getStepById(0);
					break;
				case 1:
					ctrl.selectedEeSource = null;
					ctrl.relationTemplateDetails = null;
					ctrl.currentStep = getStepById(1);
					break;
				case 2:
					ctrl.selectedEeSource = null;
					ctrl.eeSourceDetails = undefined;
					ctrl.currentStep = getStepById(2);
					break;
				case 3:
					ctrl.subElementDetails = null;
					ctrl.currentStep = getStepById(3);
					break;
				case 4:
					ctrl.relations = null;
					ctrl.referenceNodes = null;
					ctrl.currentStep = getStepById(4);
					break;
			}
		};
		//
		ctrl.previous = function () {
			if (ctrl.currentStep.id > 0) {
				var stepId;
				switch (ctrl.currentStep.id) {
					case 1:
						if (ctrl.accessedSelectProofChannelStep) {
							stepId = 0;
						}
						break;
					case 2:
						if (ctrl.accessedSelectTrStep) {
							stepId = 1;
						} else if (ctrl.accessedSelectProofChannelStep) {
							stepId = 0;
						}
						break;
					case 3:
						if (ctrl.accessedSelectEeSourceStep || ctrl.accessedSelectModelSourceStep) {
							stepId = 2;
						} else if (ctrl.accessedSelectTrStep) {
							stepId = 1;
							ctrl.accessedSelectTrStep = false;
						} else if (ctrl.accessedSelectProofChannelStep) {
							stepId = 0;
						}
						//if user is in proofing wizard and we are in step 3 (hook to ee created from model), and we want go previous step then delete the entity created from this model
						if (ctrl.isProofing) {
							blockUI.start();
							deleteEntityService.forceDeleteEntity(ctrl.selectedEeSource.identifier).then(function () {
								blockUI.stop();
							});
						}
						break;
					case 4:
						if (ctrl.accessedSelectSubElementStep) {
							stepId = 3;
						} else if (ctrl.accessedSelectEeSourceStep || ctrl.accessedSelectModelSourceStep) {
							stepId = 2;
						} else if (ctrl.accessedSelectTrStep) {
							stepId = 1;
							//ctrl.accessedSelectTrStep = false;
						} else if (ctrl.accessedSelectProofChannelStep) {
							stepId = 0;
						}
						//if user is in proofing wizard and we are in step 3 (hook to ee created from model), and we want go previous step then delete the entity created from this model
						if (ctrl.isProofing && stepId < 3) {
							blockUI.start();
							deleteEntityService.forceDeleteEntity(ctrl.selectedEeSource.identifier).then(function () {
								blockUI.stop();
							});
						}
						break;
				}
				//Remove previous step from rt steps history
				ctrl.rtStepElementsSelected = relationshipTemplateWizardService.removePreviousStepFromTemplateRelationshipStepsHistory(ctrl.rtStepElementsSelected, ctrl.currentStep.id);
				ctrl.rtBreadcrumb = relationshipTemplateWizardService.calculateRelationshipTemplateBreadcrumb(ctrl.rtStepElementsSelected);
				ctrl.handleStep(stepId);
			}
		};
		//
		ctrl.next = function () {
			switch (ctrl.currentStep.id) {
				case 0:
					calculateStepsToDisplaySinceStep1(ctrl.eetCodes, ctrl.eetFlashIds);
					break;
				case 1:
					calculateStepsToDisplaySinceStep2(ctrl.relationTemplateDetails);
					break;
				case 2:
					if (!ctrl.isProofing) {
						calculateStepsToDisplaySinceStep3(ctrl.selectedEeSource);
					} else {
						prepareCalculateStepsToDisplaySinceStep3(ctrl.selectedEeSource);
					}
					break;
				case 3:
					calculateStepsToDisplaySinceStep4(ctrl.relationTemplateDetails);
					break;
				case 4:
					ctrl.doSave();
					break;
			}
		};
		//
		ctrl.isFinalStep = function () {
			if (ctrl.currentStep) {
				return ctrl.currentStep.id === 4 || ctrl.wizardEnd;
			}
			return false;
		};
		//
		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};
		//
		ctrl.doSave = function () {
			if (ctrl.subElementDetails && ctrl.subElementDetails.id && _.includes(ctrl.alreadySelectedSubElementsIds, ctrl.subElementDetails.id)) {
				infoModalService.openModal("userApp.linkEEWizard.messages.hookAlreadyDoneOnNodeMsg", "userApp.linkEEWizard.messages.hookAlreadyDoneOnNodeTitle", { nodeName: ctrl.subElementDetails.text });
			} else {
				ctrl.checkAndSaveReferenceNodes();
				if (ctrl.subElementDetails && ctrl.subElementDetails.id) {
					ctrl.alreadySelectedSubElementsIds.push(ctrl.subElementDetails.id);
				}
			}
		};
		//
		ctrl.checkAndSaveReferenceNodes = function () {
			//3. Verify if selected EE is locked

			entityLockService.isLockedByOtherUser(ctrl.eeSourceDetails.flashId)
				.then(function (isLocked) {
					if (!isLocked) {
						//ctrl.listNode = ctrl.isListAccroche(ctrl.referenceNodes);
						ctrl.saveReferenceNodes(ctrl.referenceNodes);
					} else {
						//selected ee already locked.
						ctrl.errors.push($filter('translate')('userApp.linkEEWizard.labels.eeLocked'));
					}
					if (!ctrl.isProofing && (ctrl.trSelected.ignoreEntitiesHookedToSameProduct || ctrl.trSelected.ignoreEntitiesAttachedToSource || ctrl.trSelected.ignoreEntitiesHookedToSameEet)) {
						ctrl.dismiss();
					}
				});
		};
		//

		//
		ctrl.saveReferenceNodes = function (referenceNodes) {

			//Set Up the relations metadatas
			//Workarround to handle relaion.metaInstanceDTOList updates in a child component <relation-reference-node/>
			//Fix this.
			blockUI.start();
			var getTargetLinkDetailsPromises = [];
			var tabreferenceNode = [];
			if (angular.isDefined(referenceNodes) && referenceNodes.length >= 1) {
				referenceNodes.forEach(function (tr, index) {
					var sourceEntityFlashId = referenceNodes[index].parent;
					var targetEntityFlashId = referenceNodes[index].refNodeId;
					getTargetLinkDetailsPromises.push(linkEeWizardFormService.getTargetLinkDetail(sourceEntityFlashId, targetEntityFlashId).then(function (targetLinkDetails) {
						var ignoreEntity = ctrl.trSelected.ignoreEntitiesAttachedToSource && targetLinkDetails.alreadyLinked
							|| ctrl.trSelected.ignoreEntitiesHookedToSameProduct && targetLinkDetails.hookedToSameProduct
							|| ctrl.trSelected.ignoreEntitiesHookedToSameEet && targetLinkDetails.hookedToSameEet;
						if (ignoreEntity) {
							tabreferenceNode.push(referenceNodes[index]);
						}
					}));
				});
				$q.all(getTargetLinkDetailsPromises).then(function () {
					blockUI.stop();
					ctrl.listNode = _.difference(referenceNodes, tabreferenceNode);
					if (ctrl.multiRelation) {
						angular.forEach(ctrl.listNode, function (referenceNode) {
							referenceNode.relationDTO.metaInstanceDTOList = [];
							referenceNode.relationDTO.metaInstanceDTOList = _.concat(referenceNode.relationDTO.metaInstanceDTOList, ctrl.relationMetaDatasList);
						});
					}
					if (ctrl.isProofing) {
						blockUI.start();
						var contextualProofing = {
							nodes: ctrl.listNode,
							publicationChannel: [ctrl.proofChannelSelected],
							sourceEntityFlashId: ctrl.selectedEeSource.identifier
						};
						publishResource.proofContextualization(contextualProofing).$promise.then(function (publish) {
							blockUI.stop();
							ctrl.close();
							var proofingMessage = publish.informatifMessag[0];
							if (proofingMessage.publishStatus) {
								ModalAlertService.success(proofingMessage.messageStatus + ' ==> OK', $filter('translate')('userApp.linkEEWizard.labels.linkEE'), '');
							} else {
								ModalAlertService.error(proofingMessage.messageStatus + ' ==> KO', $filter('translate')('userApp.linkEEWizard.labels.linkEE'), '');
							}
						});
					} else {
						blockUI.start();
						nodeResource.createReferenceNodes({
							isBulk: ctrl.isBulk,
							productCode: ctrl.productCode
						}, ctrl.listNode).$promise.then(function () {
							//IF IT'S CONTEXTUAL PROOFING WIZARD THEN AFTER CREATE REFERENCE NODE, LAUNCH PROOFING ENTITY
							$rootScope.$broadcast("reloadTree");
							blockUI.stop();
							ctrl.displaySaveSuccessMsg();
						}, function () {
							blockUI.stop();
						});
					}
				});

			}

		};

		//
		ctrl.displaySaveSuccessMsg = function () {
			//
			var eeSourceSystemTitle = ctrl.selectedEeSource.system.systemTitle;
			//
			var msg = null;
			if (ctrl.targetEntities.length === 1) {
				msg = $filter('translate')('userApp.linkEEWizard.labels.linkedEETitle') + " << " + ctrl.deleteHtmlTags(ctrl.relations[0].wording) + " >> " +
					$filter('translate')('userApp.linkEEWizard.labels.linkSourceEETitle') + " << " + ctrl.deleteHtmlTags(eeSourceSystemTitle) + " >> ";
			} else {
				msg = $filter('translate')('userApp.linkEEWizard.labels.linkEesSuccess') + " " + ctrl.deleteHtmlTags(eeSourceSystemTitle);
				var targetEesMsg = "";
				angular.forEach(ctrl.relations, function (relation) {
					if (relation.wording !== null && relation.wording !== "") {
						targetEesMsg = targetEesMsg + '-' + ctrl.deleteHtmlTags(relation.wording) + "\n";
					}
				});
				msg = msg + "\n" + targetEesMsg;
			}
			//
			ModalAlertService.success(
				$filter('translate')('userApp.linkEEWizard.labels.linkEE'), msg, '');
		};

		/**
		 * Return true if there is one or more metadata where value not unique constraint is violated
		 */
		ctrl.isMetadataUniqueValueViolated = function () {
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(ctrl.relationMetaDatasList, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		};
		//
		function prepareCalculateStepsToDisplaySinceStep3(eeSource) {

			ctrl.checkOptionsByTemplate(ctrl.relationTemplateDetails).then(function () {
				var contains = false;
				angular.forEach(eeSource.subElements, function (subNode) {
					if (subNode.type === 'STRUCTURAL') {
						contains = true;
					}
				});
				if (!contains) {
					//init selected sub element with null
					ctrl.onSubElementSelected(null, false, false);
					calculateStepsToDisplaySinceStep4(ctrl.relationTemplateDetails);
				} else {
					ctrl.currentStep = getStepById(3);
				}
			});

		}
		//
		ctrl.dismiss = function () {

			//if user close proofing wizard after select model in step 2, delete the entity created from this model
			if (ctrl.isProofing && (ctrl.isActiveStep03() || ctrl.isActiveStep04())) {
				blockUI.start();
				deleteEntityService.forceDeleteEntity(ctrl.selectedEeSource.identifier).then(function () {
					blockUI.stop();
				});
			}
			//Close the wizard
			ctrl.close();
		};
		//
		$scope.$watch('$ctrl.currentStep', function (newVal) {
			ctrl.existEntitiesWithOtherProduct = false;
			if (!angular.equals({}, newVal) && getStepById(newVal.id) === 3) {
				var relationTemplate = $filter('filter')(ctrl.relationshipTemplateList, { 'onlyEntitiesWithSameProductAsMe': true });
				if (relationTemplate.length > 0 && relationTemplate[0].id === ctrl.relationTemplateDetails.id && relationTemplate[0].entitiesFlashIdsWithSameProductAsMe
					&& relationTemplate[0].entitiesFlashIdsWithSameProductAsMe !== ctrl.eetFlashIds) {
					ctrl.existEntitiesWithOtherProduct = true;
				}
			}
		});
		//
		ctrl.checkOptionsByTemplate = function (relationTemplateDetails) {
			blockUI.start();
			//Get EE source hooking metadata
			return relationResource.getHookingMetadata({
				eetCode: ctrl.eeSourceDetails.eetCode
			}).$promise.then(function (hangingNodeEetMetadatas) {
				blockUI.stop();
				//Init metadatas to pass to wizard step4
				ctrl.relationMetaDatasList = angular.copy(ctrl.relationTemplateDetails.metaInstanceList);
				//update relationTemplate metadata list with hooking metadata
				ctrl.relationMetaDatasList = MetadataService.copyHookingMetadata(ctrl.relationMetaDatasList, hangingNodeEetMetadatas);
				//update relationTemplate metadata list with EE source metadata
				ctrl.relationMetaDatasList = MetadataService.copyEeSourceMetadata(ctrl.relationMetaDatasList, ctrl.eeSourceDetails);
			});
		};

	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('linkEeWizardFormService', LinkEeWizardFormService);

	/** @ngInject */
	function LinkEeWizardFormService(entityLinkingResource, blockUI) {
		return {
			getTargetLinksDetail: getTargetLinksDetail,
			getTargetLinkDetail: getTargetLinkDetail
		};

		function getTargetLinksDetail(sourceEntityFlashId, targetEntitiesFlashIds) {
			blockUI.start();
			return entityLinkingResource.isLinkedEEList({
				sourceEEFlashId: sourceEntityFlashId,
				targetEEFlashIds: targetEntitiesFlashIds,
				targetSubElementFlashId: ""
			}).$promise.then(function (targetLinksDetails) {
				blockUI.stop();
				return {
					allTargetsAreAlreadyHooked: _.map(targetLinksDetails, 'alreadyLinked').reduce(function(accumulator, next) { return  accumulator && next; }),
					allTargetsAreAlreadyHookedToSameProduct: _.map(targetLinksDetails, 'hookedToSameProduct').reduce(function (accumulator, next) { return  accumulator && next; }),
					allTargetsAreAlreadyHookedToSameEet: _.map(targetLinksDetails, 'hookedToSameEet').reduce(function(accumulator, next) { return  accumulator && next; }),
				};
			});
		}

		function getTargetLinkDetail(sourceEntityFlashId, targetEntityFlashId) {
			blockUI.start();
			return entityLinkingResource.isLinkedEE({
				sourceEEFlashId: sourceEntityFlashId,
				targetEEFlashId: targetEntityFlashId,
				targetSubElementFlashId: ""
			}).$promise.then(function (targetLinkDetails) {
				blockUI.stop();
				return targetLinkDetails;
			});
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// Creates:
	// 

	angular
		.module('userApp')
		.component('linkEeWizardModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-modal/link-ee-wizard-modal.tpl.html',
			controller: LinkEeWizardModalontroller,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	function LinkEeWizardModalontroller() {
		var ctrl = this;


		/// 1.OPERATIONS ///
		ctrl.$onInit = function () {
			ctrl.targetEntities = ctrl.resolve.targetEntities;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.isBulk = ctrl.resolve.isBulk;
			ctrl.isFromFileMenu = ctrl.resolve.isFromFileMenu;
			ctrl.productCode = ctrl.resolve.productCode;
			ctrl.isProofing = ctrl.resolve.isProofing;
			ctrl.proofingChannels = ctrl.resolve.publish ? ctrl.resolve.publish.publicationChannel : [];
			ctrl.productChannels = ctrl.resolve.publish ? ctrl.resolve.publish.productChannels : [];
			ctrl.canalsFromProduct = ctrl.resolve.publish ? ctrl.resolve.publish.canalsFromProduct : false;
		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('LinkEeWizardModalService', LinkEeWizardModalService);
	/** @ngInject */
	function LinkEeWizardModalService($uibModal, blockUI, EditorialEntityService) {
		var service = {
			openModal: openModal,
			openLinkEesWarningModal: openLinkEesWarningModal
		};

		return service;

		////////////////
		function openModal(targetEntities, currentUser, isBulk, isFromFileMenu, productCode, isProofing) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'linkEeWizardModal',
				resolve: {
					targetEntities: function () {
						return targetEntities;
					},
					productCode: function () {
						return productCode;
					},
					isProofing: function () {
						return isProofing;
					},
					currentUser: currentUser,
					isBulk: isBulk,
					isFromFileMenu: isFromFileMenu,
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('linkEEWizard');
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}


		function openLinkEesWarningModal(previousHooksList, hookingFromTarget, trSelected) {

			var modalInstance = $uibModal.open({
				templateUrl: 'scripts/app/entities/editorialEntity/eeLinkInfos/linkedEE.tpl.html',
				controller: 'LinkedEEController',
				controllerAs: 'linkedEECtrl',
				resolve: {
					alreadyLinkedList: function () {
						var alreadyLinkedList = [];
						_.each(previousHooksList, function (linksInfos) {
							if (linksInfos !== null && linksInfos.alreadyLinked) {
								alreadyLinkedList.push(linksInfos);
							}
						});
						return alreadyLinkedList;
					},
					hookedToSameProductList: function () {
						var hookedToSameProductList = [];
						_.each(previousHooksList, function (linksInfos) {
							if (linksInfos !== null && linksInfos.hookedToSameProduct) {
								hookedToSameProductList.push(linksInfos);
							}
						});
						return hookedToSameProductList;
					},
					hookedToSameEetList: function () {
						var hookedToSameEetList = [];
						_.each(previousHooksList, function (linksInfos) {
							if (linksInfos !== null && linksInfos.hookedToSameEet) {
								hookedToSameEetList.push(linksInfos);
							}
						});
						return hookedToSameEetList;
					},
					hookingFromTarget: function () {
						return hookingFromTarget;
					},
					trSelected: function () {
						return trSelected;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('eeLinkInfos');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('displayProductGroupMeta', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/display-product-group-meta/display-product-group-meta.html',
			controller: DisplayProductGroupMetaController,
			controllerAs: '$ctrl',
			bindings: {
				product: '<',
				metadataList: '<',
				hideSuggestedPublicationDate: '<'
			},
		});

	/** @ngInject */
	function DisplayProductGroupMetaController() {
		var $ctrl = this;


		////////////////

		$ctrl.$onInit = function () {

		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editProducts', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/edit-products/edit-products.html',
			controller: EditProductController,
			bindings: {
				entityFlashId: '<',
				entityTitle: '<',
				teeCode: '<',
				currentProducts: '<',
				proposalProducts: '<',
				isEditMetadataModal: '<',
				isFormEntityCreation: '<',
				hidePrincipalProduct: '@?',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function EditProductController($filter, editProductsService, editMetaDataModalService, $rootScope, OpenNewTabService, confirmModalService, ModalAlertService, $timeout) {
		var ctrl = this;

		ctrl.$onInit = function () {

			//ee flash id to republish after close modal
			ctrl.eeFlashIdToPublish = undefined;

			//PRINCIPAL PRODUCT
			ctrl.principalProduct = _.find(ctrl.currentProducts, function (c) {
				return c.principal;
			});
			if (!ctrl.principalProduct) {
				ctrl.principalProduct = {};
			}
			if (ctrl.isFormEntityCreation) {
				// HANDLER EVENT TO CHANGING PRINCIPAL PRODUCT ONLY IN CREATION CASE
				ctrl.registerPrincipalProductChangeEvent = $rootScope.$on('principal-product-change', function (event, data) {
					if (ctrl.principalProduct.code !== data.code) {
						ctrl.principalProduct = data;
						ctrl.refreshProposals();
					}
				});
			}

			// UNDO ACTION : remove an existing proposed product
			ctrl.undoProposal = function (flashId, entityFlashId) {
				editProductsService.undoProposal(flashId, entityFlashId)
					.then(function () {
						ctrl.refreshProposals();
					});
			};

			//SELECT DROPDOWN SETTINGS
			ctrl.proposalSettings = { searchField: 'label', enableSearch: true, showCheckAll: true, showUncheckAll: true, checkBoxes: true, scrollable: true };
			if (ctrl.isEditMetadataModal) {
				editProductsService.hideAction('DUPLICATE', ctrl.currentProducts);
			}
		};

		ctrl.$onChanges = function (changes) {
			//INIT PROPOSALS
			ctrl.selectedProductMap = {};
			ctrl.proposalProductFilter = '';
			if (changes.proposalProducts || changes.currentProducts) {
				ctrl.applyTextProposalsFilter();
			}
		};

		ctrl.applyTextProposalsFilter = function () {
			ctrl.filteredProposalProduct = editProductsService.filterProposals(ctrl.proposalProducts, ctrl.currentProducts, ctrl.proposalProductFilter);
		};

		ctrl.proposalProductFilterChanged = function () {
			ctrl.applyTextProposalsFilter();
		};

		ctrl.toggleProducts = function (event) {
			ctrl.displayProducts = !ctrl.displayProducts;
			// force the scroll to the button
			if (event.target) {
				$timeout(function () {
					event.target.scrollIntoView();
				});
			}
		};

		ctrl.selectProduct = function (product) {
			ctrl.selectedProductMap[product.id] = !ctrl.selectedProductMap[product.id];
			// MAP CODES
			var proposalCodes = _.keys(_.pickBy(ctrl.selectedProductMap, function (selected) { return selected; }));
			// SAVE PROPOSALS BY CODES AND ENTITY FLASH ID
			editProductsService.saveProposals(ctrl.entityFlashId, proposalCodes)
				.then(function () {
					// REFRESH
					ctrl.refreshProposals();
				});
		};

		ctrl.refreshProposals = function () {
			editProductsService.getCurrentProducts(ctrl.entityFlashId)
				.then(function (data) {
					ctrl.currentProducts = data;
					ctrl.applyTextProposalsFilter();
					ctrl.selectedProductMap = {};
					if (ctrl.isFormEntityCreation || ctrl.isEditMetadataModal) {
						editProductsService.hideAction('DUPLICATE', ctrl.currentProducts);
					}
				});
		};

		ctrl.getSelectedProductsCount = function () {
			return _.keys(ctrl.selectedProductMap).length;
		};

		ctrl.openEditMetaModal = function (flashId, productName) {
			var editMetaModalTitle = $filter('translate')('userApp.product.editMetaModal.editMetaModalTitle', { productName: productName });
			var modalClass = ctrl.isEditMetadataModal ? 'no-editor' : 'editor-zindex';
			editMetaDataModalService.openEditProductMetaModal(flashId, editMetaModalTitle, modalClass, false).then(function (response) {
				if (response) {
					ctrl.refreshProposals();
				}
			});
		};

		ctrl.cancel = function () {
			ctrl.dismiss({ $value: false });
		};

		$rootScope.$on('$destroy', $rootScope.$on('association_deleted', function (eeFlashIdToPublish) {
			//entity flash id to publish, when close modal
			ctrl.eeFlashIdToPublish = eeFlashIdToPublish;
		}));

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};

		ctrl.$onDestroy = function () {
			// Unregister root scope event
			if (ctrl.registerPrincipalProductChangeEvent) {
				ctrl.registerPrincipalProductChangeEvent();
			}
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editProductsService', EditProductsService);


	/** @ngInject */
	function EditProductsService(blockUI, productResource, productGroupService, stringUtil) {
		var service = {
			getCurrentProducts: getCurrentProducts,
			getProposalProducts: getProposalProducts,
			filterProposals: filterProposals,
			saveProposals: saveProposals,
			applyAction: applyAction,
			deleteProposals: deleteProposals,
			isForEetConversion: isForEetConversion,
			hideAction: hideAction,
			undoProposal: undoProposal
		};

		return service;

		function getCurrentProducts(entityFlashId) {
			blockUI.start();
			// Get Products
			return productResource.getCurrentProducts({ entityFlashId: entityFlashId }).$promise
				.then(function (products) {
					blockUI.stop();
					return _.sortBy(products, function (p) {
						return !p.principal;
					});
				});
		}

		function getProposalProducts(teeCode) {
			blockUI.start();
			//GET GROUPS FOR CURRENT USER & TEE			
			return productGroupService.groupsByTemplate(teeCode)
				.then(function (data) {
					blockUI.stop();
					return _.map(data, function (p) {
						return { id: p.code, label: p.name };
					});
				});
		}

		/**
			* Returns only not already added products
			* @param {product} proposals 
			* @param {product} currents 
			*/
		function filterProposals(proposals, currents, text) {
			var filteredCurrentProducts = _.filter(proposals, function (p) {
				return !_.find(currents, function (c) {
					return p.id === c.code;
				});
			});

			return _.filter(filteredCurrentProducts, function (product) {
				return stringUtil.contains(product.label, text);
			});
		}

		/**
			* SAVE PROPOSALS BY CODES AND FLASH ID
			* @param {*} entityFlashId 
			* @param {*} proposals 
			*/
		function saveProposals(entityFlashId, proposals) {
			blockUI.start();
			return productResource.saveProposals({ entityFlashId: entityFlashId }, proposals).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		/**
			* APPLY GIVEN ACTION ON PROPOSAL WITH GIVEN FLASH ID 
			* @param {*} flashId 
			* @param {*} entityFlashId 
			* @param {*} action 
			*/
		function applyAction(flashId, entityFlashId, action) {
			blockUI.start();
			return productResource.applyAction({ flashId: flashId, entityFlashId: entityFlashId, action: action }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		/**
			* TAKE OFF PROPOSAL (undo action) WITH GIVEN FLASH ID
			* @param {*} flashId : association flash id
			* @param {*} entityFlashId : entity flash id
			*/
		function undoProposal(flashId, entityFlashId) {
			blockUI.start();
			return productResource.undoProposal({ flashId: flashId, entityFlashId: entityFlashId }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		/**
	* DELETE PRODUCTS BY ENTITY FLASH ID
			* @param entityFlashId
			* @returns {*}
			*/
		function deleteProposals(entityFlashId) {
			blockUI.start();
			return productResource.deleteProposals({ entityFlashId: entityFlashId }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		/**
			* Check if product is parametrized for eet conversion
			* @param {*} productCode 
			* @param {*} eetCode 
			*/
		function isForEetConversion(productCode, eetCode) {
			blockUI.start();
			return productResource.isForEetConversion({ productCode: productCode, eetCode: eetCode }).$promise.then(function (data) {
				blockUI.stop();
				return data;
			});
		}

		/**
			* Hide given action for each product in the given products list
			* @param {*} actionToHide 
			*/
		function hideAction(actionToHide, products) {
			products.forEach(function (product) {
				product.permittedActions = _.filter(product.permittedActions, function (action) {
					return action !== actionToHide;
				});
			});
		}

	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component(
		'productGroupManyEE',
		{
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/many-ee/product-group-many-ee.html',
			controller: ProductGroupManyEE,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&',
			},
		});
	/** @ngInject */
	function ProductGroupManyEE(productGroupManyEEService, infoModalService, $filter, $state) {
		var ctrl = this;

		ctrl.$onInit = function () {
			// GET GROUPS FOR CURRENT USER
			ctrl.groups = ctrl.resolve.groups;
			// RULE : SINGLE RESULT = > DEFAULT VALUE
			if (ctrl.groups.length === 1) {
				ctrl.selectedGroup = ctrl.groups[0].code;
			}
		};

		ctrl.save = function () {
			productGroupManyEEService.save(ctrl.selectedGroup, ctrl.resolve.eeFlashIds)
				.then(function (response) {
					ctrl.close();
					//OPEN MODAL INFO					
					infoModalService.openBulkSucess(
						{
							operation: $filter('translate')('entity.actionBar.workflow.tooltip')
						}
					).then(function () {
						$state.go('myBulkOperations');
					});
				});
		};

		ctrl.cancel = function () {
			ctrl.dismiss({ $value: false });
		};
	}
})();

(function () {
	'use strict';

	angular.module('userApp').factory('productGroupManyEEService',
		ProductGroupManyEEService);

	/** @ngInject */
	function ProductGroupManyEEService(blockUI, $uibModal, $filter, $state, entityOperationResource, productGroupService) {
		var service = {
			openModal: openModal,
			save: save
		};

		return service;

		function openModal(eeFlashIds) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'productGroupManyEE',
				resolve: {
					eeFlashIds: function () {
						return eeFlashIds;
					},
					groups: function () {
						return productGroupService.groupsByUser();
					},
					translatePartialLoader: ['$translate',
						'$translatePartialLoader',
						function ($translate, $translatePartialLoader) {
							return $translate.refresh();
						}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function save(selectedGroup, eeFlashIds) {
			return entityOperationResource.updateProductGroupEE({
				productGroup: selectedGroup,
				eeFlashIds: eeFlashIds
			}).$promise;

		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editProductsModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/edit-products-modal/edit-products-modal.html',
			controller: EditProductModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function EditProductModalController(publishService, $rootScope) {

		var ctrl = this;
		ctrl.eeFlashIdToPublish = undefined;
		ctrl.hasPublishRight = ctrl.resolve.hasPublishRight;

		ctrl.cancel = function () {
			ctrl.dismiss({ $value: false });
			if (angular.isDefined(ctrl.eeFlashIdToPublish) &&
				(angular.isUndefined(ctrl.hasPublishRight) || ctrl.hasPublishRight))  {
				publishService.publishOrder(ctrl.eeFlashIdToPublish);
			}
		};

		$rootScope.$on('$destroy', $rootScope.$on('association_deleted', function (event, eeFlashIdToPublish) {

            //entity flash id to publish, when close modal
			ctrl.eeFlashIdToPublish = eeFlashIdToPublish;
		}));

	}



})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editProductsModalService', EditProductsModalService);



	function EditProductsModalService(blockUI, $uibModal, editProductsService) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal(entityFlashId, entityTitle, teeCode, hasPublishRight) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'editProductsModal',
				resolve: {
					entityFlashId: function () { return entityFlashId; },
					entityTitle: function () { return entityTitle; },
					hasPublishRight: function () { return hasPublishRight; },
					teeCode: function () { return teeCode; },
					currentProducts: function () { return editProductsService.getCurrentProducts(entityFlashId); },
					proposalProducts: function () { return editProductsService.getProposalProducts(teeCode); },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('product');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static',
				windowClass: 'sidebar-open edit-product-modal-window',
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

	}
})();




(function () {
	'use strict';

	angular
		.module('userApp')
		.component('productActionsBar', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/product-actions-bar/product-actions-bar.html',
			controller: ProductActionsBarController,
			bindings: {
				permittedActions: '<',
				associationFlashId: '<',
				productName: '<',
				productCode: '<',
				onRefresh: '&',
				onClose: '&',
				entityFlashId: '<',
				entityTitle: '<',
				eetCode: '<',
				metasAssociation: '<',
				fromProductEntity: '<'
			},
		});

	/** @ngInject */
	function ProductActionsBarController(editProductsService, editMetaDataModalService, duplicateEntityModalService, ModalAlertService, confirmModalService, blockUI, $log, $filter, $rootScope, publishEeFormModalService, productDashboardService, convertEntityService, convertModalService, infoModalService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntityTemplate = {
				code: ctrl.eetCode
			};
			ctrl.editorialEntity = {
				identifier: ctrl.entityFlashId,
				titleSystem: ctrl.entityTitle,
				editorialEntityTemplate: ctrl.editorialEntityTemplate,
				ownerGroup: ctrl.productCode
			};

			// Get proposalGroupName
			if (ctrl.productCode) {
				productDashboardService.getGroup(ctrl.productCode).then(function (ownerGroupData) {
					if (ownerGroupData) {
						ctrl.proposalOwnerGroupName = ownerGroupData.name;
					}
				});
			}
		};


		ctrl.applyAction = function (action, event) {
			event.stopPropagation();
			switch (action) {
				case "ACCEPT":
					ctrl.acceptProposal();
					break;
				case "DECLINE":
					ctrl.declineProposal();
					break;
				case "DUPLICATE":
					ctrl.duplicateEntity();
					break;
				case "DELETE":
					ctrl.deleteProposal();
					break;
				case "RESTORE":
					ctrl.restoreProposal();
					break;
				default:
					break;
			}
		};

		ctrl.acceptProposal = function () {
			blockUI.start();
			editProductsService.isForEetConversion(ctrl.productCode, ctrl.eetCode).then(function (data) {
				var isForConversion = data.result;
				if (isForConversion) {
					convertEntityService.getPermissionStatus(ctrl.entityFlashId, true).then(function (response) {
						if (response.enabled) {
							convertModalService.openModal(ctrl.entityFlashId, ctrl.associationFlashId, true);
						} else {
							infoModalService.openModal(response.message.key, 'error.conversionDenied.title', { param_1: response.message.params[0] });
						}
					});
				} else {
					// EDIT META DATA IN A MODAL
					var editMetaModalTitle = $filter('translate')('userApp.product.editMetaModal.acceptEditMetaModalTitle', { productName: ctrl.productName });
					editMetaDataModalService.openEditProductMetaModal(ctrl.associationFlashId, editMetaModalTitle, 'no-editor', true).then(function (response) {
						if (response) {
							// ACCEPT PROPOSAL
							editProductsService.applyAction(ctrl.associationFlashId, ctrl.entityFlashId, 'ACCEPT')
								.then(function () {
									// Publish product from proposal page
									if (ctrl.fromProductEntity) {
										publishEeFormModalService.openPublishFormModal(ctrl.editorialEntity, true, false, ctrl.editorialEntity.ownerGroup, ctrl.proposalOwnerGroupName, false);
									}
									var msg = $filter('translate')('userApp.product.infoModal.acceptProposalMessage');
									ModalAlertService.success(msg, ctrl.productName, '');
									ctrl.onRefresh();
								});
						}
					});
				}
				blockUI.stop();
			});
		};

		ctrl.declineProposal = function () {
			// ASK USER CONFIRMATION
			confirmModalService.openModal("userApp.product.confirmModal.declineProposalMessage", "userApp.product.confirmModal.declineProposalTitle", { productName: ctrl.productName })
				.then(function (result) {
					if (result) {
						// DECLINE PROPOSAL
						editProductsService.applyAction(ctrl.associationFlashId, ctrl.entityFlashId, 'DECLINE')
							.then(function () {
								var msg = $filter('translate')('userApp.product.infoModal.declineProposalMessage');
								ModalAlertService.success(msg, ctrl.productName, '');
								ctrl.onRefresh();
							});
					}
				});
		};

		ctrl.duplicateEntity = function () {
			duplicateEntityModalService.openModal(ctrl.editorialEntity, false, ctrl.associationFlashId, ctrl.metasAssociation, ctrl.productCode)
				.then(function (result) {
					if (result) {
						ctrl.onClose();
					}
				});
		};

		ctrl.deleteProposal = function () {
			// ASK USER CONFIRMATION
			confirmModalService.openModal("userApp.product.confirmModal.deleteProposalMessage", "userApp.product.confirmModal.deleteProposalTitle", { productName: ctrl.productName })
				.then(function (result) {
					if (result) {
						// DELETE PROPOSAL
						editProductsService.applyAction(ctrl.associationFlashId, ctrl.entityFlashId, 'DELETE')
							.then(function () {
								var msg = $filter('translate')('userApp.product.infoModal.deleteProposalMessage');
								ModalAlertService.success(msg, ctrl.productName, '');
								//Emit entity flash Id to republish after delete
								$rootScope.$broadcast("association_deleted", ctrl.entityFlashId);
								ctrl.onRefresh();
							});
					}
				});
		};

		ctrl.restoreProposal = function () {
			// ASK USER CONFIRMATION
			confirmModalService.openModal("userApp.product.confirmModal.restoreProposalMessage", "userApp.product.confirmModal.restoreProposalTitle", { productName: ctrl.productName })
				.then(function (result) {
					if (result) {
						// RESTORE PROPOSAL
						editProductsService.applyAction(ctrl.associationFlashId, ctrl.entityFlashId, 'RESTORE')
							.then(function () {
								var msg = $filter('translate')('userApp.product.infoModal.restoreProposalMessage');
								ModalAlertService.success(msg, ctrl.productName, '');
								ctrl.onRefresh();
							});
					}
				});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('productGroupModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/product-group-modal/product-group-modal.html',
			controller: ProductGroupModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});
	/** @ngInject */
	function ProductGroupModalController(productGroupModalService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = angular.copy(ctrl.resolve.editorialEntity);
			ctrl.teeCode = ctrl.resolve.teeCode;

		};

		ctrl.cancel = function () {
			ctrl.dismiss({ $value: false });
		};


		/**
		 * Save
		 */
		ctrl.save = function () {
			productGroupModalService.editGroup(ctrl.editorialEntity)
				.then(function (data) {
					ctrl.close({ $value: data });
				});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('productGroupModalService', ProductGroupModalService);


	/** @ngInject */
	function ProductGroupModalService(blockUI, $uibModal, userGroupResource, entityUpdateResource, $filter) {
		var service = {
			openModal: openModal,
			editGroup: editGroup
		};

		return service;

		function openModal(editorialEntity, teeCode) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'productGroupModal',
				resolve: {
					editorialEntity: function () { return editorialEntity; },
					teeCode: function () { return teeCode; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function editGroup(editorialEntity) {
			blockUI.start();
			// EDIT GROUP
			return entityUpdateResource.editGroup({ "flashId": editorialEntity.identifier, "groupCode": editorialEntity.ownerGroup })
				.$promise.then(function (data) {
					if (!_.isEmpty(editorialEntity.ownerGroup)) {
						//LOAD GROUP
						return userGroupResource.groupByCode({ "code": editorialEntity.ownerGroup })
							.$promise.then(function (data) {
								blockUI.stop();
								return data.body;
							});
					} else {
						blockUI.stop();
						return { code: "", name: $filter('translate')('userApp.editorialEntity.noGroup') };
					}
				});
		}
	}
})();


(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('productMetaData', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/product-meta-data/product-meta-data.html',
			controller: ProductMetaDataController,
			bindings: {
				productCode: '<',
				eetId: '<',
				flashId: '<',
				entity: '=',
				contentClass: '@?',
				labelClass: '@?',
				displayGroup: '<?',
				typology: '<'
			},
		});

	/** @ngInject */
	function ProductMetaDataController($translate, $rootScope, userResource, metadataResource, productGroupService) {
		var ctrl = this;

		ctrl.isFormEntityCreation = function () {
			return ctrl.entity.editorialEntityTemplate.formular && ctrl.entity.workCopy && ctrl.entity.deleted;
		};

		ctrl.changeProductcode = $rootScope.$on('product-code-change', function (event, params) {
			if (params && params.productCode) {
				metadataResource.getMetaInstanceToCreate({
					templateCode: params.productCode,
					type: 'PRODUCT',
					parentId: null
				}).$promise.then(function (data) {
					ctrl.entity.productMetaInstanceByMetaGroupList = data;
					productGroupService.updateMetaGrpValueFromSession(ctrl.entity.productMetaInstanceByMetaGroupList, params.sessionMap);
					ctrl.flatMetadatas();
				});
			}
		});

		ctrl.flatMetadatas = function () {
			if (!ctrl.displayGroup && ctrl.entity) {
				ctrl.metaDatas = _.flatMap(ctrl.entity.productMetaInstanceByMetaGroupList, function (metaGroup) { return metaGroup.metaDataInstanceDTOList; });
				ctrl.metaDatas = _.sortBy(ctrl.metaDatas, ['displayOrder']);
			}
		};
		ctrl.$onChanges = function (changes) {
			if (!ctrl.entity.productSuggestedPublicationDate && ctrl.isFormEntityCreation()) {
				ctrl.entity.productSuggestedPublicationDate = new Date();
			}
		};
		ctrl.$onInit = function () {
			ctrl.lang = $translate.use();
			ctrl.entity.productMetaInstanceByMetaGroupList = ctrl.entity.productMetaInstanceByMetaGroupList ? ctrl.entity.productMetaInstanceByMetaGroupList : [];
			userResource.getCurrentUser().$promise.then(function (data) {
				ctrl.currentUser = data;
			});

			if (angular.isUndefined(ctrl.displayGroup)) {
				ctrl.displayGroup = true;
			}

			ctrl.flatMetadatas();

		};

		ctrl.$onDestroy = function () {
			if (ctrl.changeProductcode) {
				ctrl.changeProductcode();
			}
		};
	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('addNodeModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/add-node-modal/add-node-modal.html',
			controller: AddNodeModalComponent,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function AddNodeModalComponent(metadataValidationService, $translate, addNodeModalService, blockUI) {
		var ctrl = this;
		ctrl.$onInit = function () {
			//lang
			ctrl.lang = $translate.use();
			ctrl.metaDataByMetaGroup = ctrl.resolve.metaInstanceByMetaGroup;
			ctrl.nodeToCreate = ctrl.resolve.nodeToCreate;
			ctrl.type = ctrl.resolve.nodeToCreate.type;
			ctrl.title = addNodeModalService.getTitle(ctrl.type);
		};

		ctrl.save = function () {
			blockUI.start();
			//GET META INSTANCES
			ctrl.nodeToCreate.metaDataByMetaGroupList = ctrl.metaDataByMetaGroup;
			//CREATE NODE
			addNodeModalService.createNode(ctrl.nodeToCreate)
				.then(function (nodeDto) {
					blockUI.stop();
					ctrl.close({ $value: nodeDto });
				});

		};

		ctrl.cancel = function () {
			ctrl.dismiss();
		};

		ctrl.isMetadataUniqueValueViolated = function() {
			return metadataValidationService.isMetadataUniqueValueViolated(ctrl.metaDataByMetaGroup);
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('addNodeModalService', AddStructuralNodeModalService);


	/** @ngInject */
	function AddStructuralNodeModalService(blockUI, $uibModal, EDITORIAL_ELEMENT_TYPE, metadataResource, treeViewService) {

		var service = {
			openModal: openModal,
			createNode: createNode,
			getTitle: getTitle
		};

		return service;


		function openModal(nodeToCreate) {

			var modalInstance = $uibModal.open({
				component: 'addNodeModalComponent',
				resolve: {
					nodeToCreate: function () { return nodeToCreate; },
					metaInstanceByMetaGroup: function () {
						return metadataResource.getMetaInstanceToCreate({
							templateCode: nodeToCreate.templateCode,
							type: nodeToCreate.type,
							parentId: nodeToCreate.parentId
						}).$promise;
					},
					productCode: function () { return nodeToCreate.ownerGroup; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}

		function createNode(nodeToCreate) {
			return treeViewService.createNode(nodeToCreate);
		}

		function getTitle(type) {
			switch (type) {
				case EDITORIAL_ELEMENT_TYPE.structural:
					return "userApp.editorialEntity.home.addStructuralNode";
				case EDITORIAL_ELEMENT_TYPE.content:
					return "userApp.editorialEntity.home.addContentNode";
				default:
					return "";
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('userApp')
		.directive('treeView', TreeView);

	/** @ngInject */
	function TreeView() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				editorialEntity: '=',
				readonly: '=',
				onNodeSelection: '&?',
				showPreviewMenu: '=',
				isShowNodesMetaData: '=?',
				treeViewInstance: '=?',
				//Optionel
				isDisplayRadioButton: '=?',
				//Optionel
				onNodeCheck: '&?',
				onNodeAction: '&?',
				radionButtonDisplayOn: '=?',
				handleExternalActionEvent: '=?',
				handleExternalActionAccessor: "=?",
				currentUser: "=?",
				editorialEntityState: '=',
				editMetadataEnabled: '<',
				editContentEnabled: '<',
				showOverloadedView: '='


			},
			link: function link(scope, element, attrs) {
				var cheatCodeExpandAll = [38, 38, 40, 40, 37, 37, 39, 39];
				var cheatCodeIndex = 0;
				element.bind('keydown keypress', function (event) {
					if (event.which === 27) { // 27 = esc key
						scope.$apply(function () {
							scope.treeViewCtrl.deselectNode();
						});
						//event.preventDefault();
					}
					if (event.which === cheatCodeExpandAll[cheatCodeIndex]) {
						cheatCodeIndex++;
					}
					else {
						cheatCodeIndex = 0;
					}

					if (cheatCodeIndex === cheatCodeExpandAll.length) {
						scope.treeViewCtrl.unlockExpand();
					}
				});

				if (scope.handleExternalActionAccessor) {
					scope.handleExternalActionAccessor.callAction = function (action) {
						scope.treeViewCtrl.doAction(action);
					};
				}
			},
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/treeview.html',
			controllerAs: 'treeViewCtrl',
			controller: TreeViewController
		};
	}

	/** @ngInject */
	function TreeViewController(ModalAlertService, treeViewService, editNodeTitleModalService, editStructuralNodeTypeModalService, userPreferenceService, treeviewNodeService, nodeBuilderService, relationResource, nodeService, addNodeModalService, $animateCss, editMetaDataModalService, htmlPreviewTabService, MetadataService, $state, $scope, $sce, $uibModal, nodeResource, blockUI, createLinkService, $filter, $log, $rootScope, CreateAndHookEeWizardModalService, ermService, ENTITY_RESOURCE_TYPE, htmlPreviewService, HTML_PREVIEW_TYPE, EDITORIAL_ELEMENT_TYPE, $timeout, validateEntityService, treeAutoMountModalService, treeAutoMountService, SYSTEM_METADATA_IDENTIFIERS) {

		var vm = this;
		//Tree and node level context menu filter
		vm.isReadOnly = angular.isDefined($scope.readonly) ? $scope.readonly : false;
		$scope.isFullPreviewPossible = false;

		//init controller
		init();

		//This boolean indicates whether the right click menu is needed only  to show preview functionality
		vm.isShowPreviewMenu = angular.isDefined($scope.showPreviewMenu) ? $scope.showPreviewMenu : false;
		vm.showNodesMetaDatas = function () {
			var showNodesMetaData = angular.isDefined($scope.isShowNodesMetaData) ? $scope.isShowNodesMetaData : false;
			return showNodesMetaData;
		};

		// If EE Source hooks external entities
		vm.isHooksExternalEntities = $scope.editorialEntity.editorialEntityTemplate.hooksExternalEntities;

		vm.showManageDeleteHook = function () {
			return _.get(vm.selectedNode, 'relationStatus') === 'BROKEN' && vm.selectedNode.relationId;
		};

		//Tree view component configuration
		vm.options = {
			dragAndDrop: !$scope.readonly
		};

		//Check for tree of type container
		vm.container = $scope.editorialEntity.editorialEntityTemplate.container;
		//Check for tree if edit content authorized
		vm.editContentAuthorized = $scope.editorialEntity.editorialEntityTemplate.usedFlashEditor;

		function init() {
			ermService.checkConfigExits($scope.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.proofReading)
				.then(function (data) {
					$scope.isFullPreviewPossible = data.exist === "true" ? true : false;
				}, function (error) {
					$log.error("Error occured whene checking config", error);
					$scope.isFullPreviewPossible = false;
				});
		}

		//Listen to evnet sent by parent ;: see  'editorialEntityEdit.controller.js'
		$scope.$on('expand_or_collapse_tree', function (event, data) {
			if (data === 'expand') {
				vm.expandAll();
			}
			if (data === 'collapse') {
				vm.collapseAll();
			}
		});

		$scope.$on('refresh_tree', function (event, data) {
			vm.doAction('refresh');
		});


		vm.setFocus = function () {
			$scope.treeViewInstance.focus();
		};
		//
		vm.addRefNode = function (node) {
			var referenceNode = vm.initTreeNode(
				node.id,
				node.title,
				node.subNodesId !== null && node.subNodesId.length > 0,
				vm.filterMetaData(node.metaInstanceDTOList, 'system'),
				vm.filterMetaData(node.metaInstanceDTOList, 'editorial'),
				node.metaInstanceDTOList, [],
				node.type,
				node.relationStatus,
				null,
				null,
				node.grayDisplay,
				false,
				node.displayOrder,
				node.path,
				node.linkedEETitle,
				node.activated,
				node.relationDTO !== null ? node.relationDTO.flashId : null,
				node.refNodeId,
				node.subNodesId,
				null,
				false,
				node.relationDTO !== null ? node.relationDTO.desiredPublicationDate : null);
			//
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				//add node to treeview
				vm.selectedNode.append(referenceNode);
			} else {
				$scope.treeViewInstance.append(referenceNode);
			}
		};
		//Add node
		$scope.$on('tree_view_add_node', function (event, node) {
			//Add the node to the root level
			vm.selectedNode = null;
			vm.addRefNode(node);
		});

		//
		$scope.$on('tree_node_editorials_metadata_updated', function (event, updatedNode) {
			vm.nodeEditorialMetaDatasUpdated(updatedNode);
		});
		//
		vm.nodeEditorialMetaDatasUpdated = function (updatedNode) {
			vm.selectedNode = updatedNode;
			vm.selectedNode.editorialsMetaData = vm.filterMetaData(vm.selectedNode.metaInstanceDTOList, 'editorial');
			$scope.onNodeSelection({
				nodeSelected: vm.selectedNode
			});
		};

		//COMPUTE NODE STYLE
		vm.nodeStyle = function (dataItem) {
			var style = {};
			if (vm.copiedNode && (dataItem.id === vm.copiedNode.id) && !vm.isCut) {
				style = _.merge({}, style, {
					borderLeft: "solid 3px darkseagreen"
				});
			}

			return style;
		};

		//CHECK IF NODE IS DISABLED TO APPLY STYLE
		vm.isDisabledNode = function (dataItem) {
			var refDisabled = dataItem.type === 'REFERENCE' && !dataItem.activated;
			var cuttedNode = vm.copiedNode && (dataItem.id === vm.copiedNode.id) && vm.isCut;
			return refDisabled || cuttedNode;
		};

		//Display radio button on each node.
		vm.showRadio = function (node) {
			if ($scope.isDisplayRadioButton) {
				if (node && !node.grayDisplay) {
					if ($scope.radionButtonDisplayOn && $scope.radionButtonDisplayOn.length > 0) {
						return _.findIndex($scope.radionButtonDisplayOn, function (o) {
							return node.type === o;
						}) >= 0;
					}
					return true;
				}
			}
			return false;
		};

		if (angular.isDefined($scope.isDisplayRadioButton) && $scope.isDisplayRadioButton) {
			//node checked
			vm.checkNode = function (nodeId) {
				var checkedNode = vm.dataSource.get(nodeId);
				if (angular.isDefined($scope.onNodeCheck)) {
					$scope.onNodeCheck({
						checkedNode: checkedNode
					});
				}
			};
		}

		vm.nodeAction = function (nodeId, $event) {
			if (angular.isDefined($scope.onNodeAction)) {
				$event.stopPropagation();
				var selectedNode = vm.dataSource.get(nodeId);
				$scope.onNodeAction({
					selectedNode: selectedNode
				});
			}
		};
		//Launch action from external event
		vm.doAction = function (value) {
			if (angular.isDefined(value) && value !== null) {
				//insert position
				vm.selectedMenuItemId = null;
				if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
					if (vm.selectedNode.type === 'STRUCTURAL') {
						vm.selectedMenuItemId = 'addChild';
					} else {
						vm.selectedMenuItemId = 'insertAfter';
					}
				}
				switch (value) {
					case 'addContentNode':
						vm.addNode(EDITORIAL_ELEMENT_TYPE.content);
						break;
					case 'addQueryNode':
						vm.addNode('QUERY');
						break;
					case 'addReferenceNode':
						vm.addNode('REFERENCE');
						break;
					case 'addStructuralNode':
						vm.addNode(EDITORIAL_ELEMENT_TYPE.structural);
						break;
					case 'showDeletedNodes':
						vm.setDeletedNodeDisplay(true);
						break;
					case 'hideDeletedNodes':
						vm.setDeletedNodeDisplay(false);
						break;
					case 'showEmptyStructuralNodes':
						vm.setEmptyStructuralNodeDisplay(false);
						break;
					case 'hideEmptyStructuralNodes':
						vm.setEmptyStructuralNodeDisplay(true);
						break;
					case 'expandAllNodes':
						vm.expandAll();
						break;
					case 'collapseAllNodes':
						vm.collapseAll();
						break;
					case 'validateEE':
						vm.validateEE();
						break;
					case 'automaticMounting':
						vm.autoMountDisplay();
						break;
					case 'autoSpread':
						vm.spreadTargetEntities();
						break;
					case 'order':
						vm.order();
						break;
					case 'refresh':
						vm.reloadNode($scope.editorialEntity.identifier, true, true);
						break;
				}
			}
		};

		//Order Tree
		vm.order = function () {
			treeViewService.sort($scope.editorialEntity.identifier)
				.then(function () {
					$state.reload();
					ModalAlertService.success($filter('translate')('userApp.treeEEEdition.messages.autoSortSuccess'));
				});
		};

		//Auto spread target entities
		vm.spreadTargetEntities = function () {
			treeAutoMountService.spreadTargetEntities($scope.editorialEntity.identifier);
		};


		// automatic mount entity 
		vm.autoMountDisplay = function () {
			treeAutoMountModalService.openModal($scope.editorialEntity);
		};

		//
		vm.reinitExternalNodeAction = function () {
			//Reinit
			$scope.treeViewInstance.select(null);
			vm.selectedNode = undefined;
			vm.selectedNodeElement = undefined;
		};
		//
		vm.getLinkedEEInsertionSummary = function (node, $event) {
			if (angular.isDefined($event)) {
				$event.stopPropagation();
			}

			if (node.showLinkedEESummary) {
				node.showLinkedEESummary = false;
			} else {
				if (node.refNodeId !== null && !node.external) {
					//get html preview for the  referenced EE.
					htmlPreviewService.getPreview(node.refNodeId, HTML_PREVIEW_TYPE.insertionAbstract)
						.then(function (eePreviewHtml) {
							var html = eePreviewHtml.htmlPreview;
							node.linkedEESummary = html ? html : node.linkedEESummary = $filter('translate')('userApp.treeEEEdition.labels.noInsertionSummary');
							node.showLinkedEESummary = true;
						});
				} else {
					node.linkedEESummary = $filter('translate')('userApp.treeEEEdition.labels.noInsertionSummary');
					node.showLinkedEESummary = true;
				}
			}
		};
		//datasource
		//
		vm.loadingCounter = {};
		vm.loadingQueue = {};

		function setLoadingCounter(id) {
			if (id) {
				vm.loadingCounter[id] ? vm.loadingCounter[id]++ : vm.loadingCounter[id] = 1;
			}
		}

		function removeLoadingCounter(id) {
			if (vm.loadingCounter[id] && vm.loadingCounter[id] > 0) {
				vm.loadingCounter[id]--;
			}

			if (vm.loadingCounter[id] === 0) {
				delete vm.loadingCounter[id];
			}

			if (_.isEmpty(vm.loadingCounter)) {
				$timeout(function () {
					if (_.isEmpty(vm.loadingCounter)) {
						vm.expandAllFlag = false;
					}
				}, 500);
			}
		}

		function animateNodes(nodes) {
			_.forEach(nodes, function (n) {
				var nElem = $scope.treeViewInstance.findByUid(n.uid);
				var animator = $animateCss(nElem, {
					addClass: 'new-node'
				});
				animator.start().then(function () {
					nElem.removeClass("new-node");
				});
			});
		}

		vm.newDataSource = function () {
			return new kendo.data.HierarchicalDataSource({
				sort: {
					field: "displayOrder",
					dir: "asc"
				},
				change: function (e) {
					if (e && e.action && e.action === 'add' && !e.hasOwnProperty('field')) {
						var lastItem = _.last(e.items);
						if (lastItem && lastItem.uid) {
							$timeout(function () {
								if (vm.selectAdded) {
									vm.selectAdded = false;
									var nodeElement = $scope.treeViewInstance.findByUid(lastItem.uid);
									$scope.treeViewInstance.select(nodeElement);
									scrollToNode(nodeElement);
									animateNodes(e.items);
								}
							}, 200);
						}
					}
				},
				transport: {
					read: function (options) {
						// Node id
						var id = options.data.id || (angular.isDefined(options.data.data) ? options.data.data.id : null);

						// Load remote child nodes
						var node = vm.dataSource.get(id);
						if (!vm.nodeBlackList[id]) {
							//blockUI.start();
							setLoadingCounter(id);
							var t = treeviewNodeService.getNodeWithFirstLevelChildNodes({
								id: angular.isDefined(node) ? node.id : $scope.editorialEntity.identifier,
								grayDisplay: angular.isDefined(node) ? node.grayDisplay : false,
								deleted: vm.showDeletedNode,
								hideEmptyStructuralNode: vm.hideEmptyStructuralNode
							});
							t.then(function (subnodes) {
								blockUI.stop();
								removeLoadingCounter(id);
								options.success(vm.mapNodes(subnodes));
							}, function () {
								blockUI.stop();
								removeLoadingCounter(id);
								options.success([]);
							});
						} else {
							options.success([]);
						}
					}
				},
				schema: {
					model: {
						id: "id",
						hasChildren: "hasChildren"
					}
				}
			});
		};


		vm.reloadTree = function () {
			vm.dataSource = vm.newDataSource();
		};

		vm.reloadTree();

		$scope.$on('reloadTree', function (event, data) {
			vm.reloadTree();
		});

		//##################Globals variables######################
		//By default all treeview node metadatas will be displayed.
		//Initialisation
		vm.showNodesMetaData = false;
		vm.selectedMenuItemId = null;
		//node activation/deactivation
		vm.authorizedNodeDeactivation = $scope.editorialEntity.editorialEntityTemplate.authorizedNodeDeactivation;
		//################## Events registration ###################

		vm.onExpand = function (e) {
			if (!vm.expandAllFlag) {
				$scope.treeViewInstance.select(e.node);
			}
		};

		vm.onDrag = function (e) {
			var sourceNode = $scope.treeViewInstance.dataItem(e.sourceNode);
			var overNode = $scope.treeViewInstance.dataItem(e.dropTarget);
			//TODO: replace by a function to know if a node allow drag or not
			if ((sourceNode && sourceNode.deleted) || (overNode && overNode.deleted)) {
				e.setStatusClass('k-i-denied');
			}
		};

		vm.onNodeDragAndDrop = function (e) {
			var destinationNode = $scope.treeViewInstance.dataItem(e.destinationNode);
			var sourceNode = $scope.treeViewInstance.dataItem(e.sourceNode);
			var dropPosition = e.dropPosition;
			e.preventDefault();
			if (angular.isUndefined(destinationNode) || angular.isUndefined(sourceNode) || destinationNode.id === sourceNode.id) {
				return;
			}
			else if ((angular.isDefined(destinationNode) && !destinationNode.deleted) && !sourceNode.deleted && e.valid) {
				//FIXME

				//Disable droping on REFERENCE, CONTENT and QUERY nodes.
				if (!(dropPosition === 'over' && (destinationNode.type === 'REFERENCE' ||
					destinationNode.type === 'CONTENT' ||
					destinationNode.type === 'QUERY'))) {
					//Save in db
					vm.copyAction = 'cutNodeWithChildren';
					vm.isCut = true;
					vm.copiedNode = sourceNode;
					vm.selectedNode = destinationNode.parentNode();
					var displayOrder;
					if (dropPosition === 'over') {
						vm.selectedNode = destinationNode;
					} else if (dropPosition === 'before') {
						displayOrder = destinationNode.displayOrder === 0 ? 0 : destinationNode.displayOrder;
					} else if (dropPosition === 'after') {
						displayOrder = destinationNode.displayOrder + 1;
					}
					vm.pastNode(displayOrder);
				}
			}
		};
		//DESELECT NODE
		vm.deselectNode = function () {
			$scope.treeViewInstance.select(null);
			vm.copiedNode = null;
		};
		// handle tree view node selection
		vm.onNodeSelection = function (node, $event) {
			//CHECK IF NODE IS DEFINED, OTHERWISE EXIT
			if (!node) {
				if ($event) {
					$event.stopPropagation();
				}
				return;
			}

			//Get node html preview
			vm.selectedNode = node;

			if (angular.isDefined($scope.onNodeSelection)) {
				$scope.onNodeSelection({
					nodeSelected: vm.selectedNode
				});
			}
		};

		//on destroy cleanup
		$scope.$on('$destroy', function () {
			//TODO remove tag node to be cut
			//vm.selectedNode.set('enabled', false);
		});
		//On menu open
		vm.onContexMenuOpen = function (e) {
			vm.selectedNodeElement = angular.element(e.target);
			vm.selectedNode = $scope.treeViewInstance.dataItem(e.target);
			$scope.treeViewInstance.select(vm.selectedNodeElement);
			//force load of sub nodes.
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				vm.selectedNode.load();
			}
		};
		//
		vm.onNodeLevelContextMenuOpen = function (e) {
			//close alaready opned context menu
			vm.treeLevelContextMenu.close();
			vm.onContexMenuOpen(e);
		};
		//
		vm.onTreeLevelContextMenuOpen = function (e) {
			//close alaready opned context menu
			vm.nodeLevelContextMenu.close();
			vm.onContexMenuOpen(e);
		};
		//####################### Node context menu #######################
		//close the context menu
		vm.onContextMenuSelection = function (e) {
			vm.selectedMenuItemId = e.item.id;
			//action 
			switch (vm.selectedMenuItemId) {
				case 'addChildContentNode':
				case 'insertBeforeContentNode':
				case 'insertAfterContentNode':
				case 'addFirslLevelContentNode':
					vm.addNode('CONTENT');
					break;
				case 'addChildQueryNode':
				case 'insertBeforeQueryNode':
				case 'insertAfterQueryNode':
				case 'addFirslLevelQueryNode':
					vm.addNode('QUERY');
					break;
				case 'addChildReferenceNode':
				case 'insertBeforeReferenceNode':
				case 'insertAfterReferenceNode':
				case 'addFirslLevelReferenceNode':
					vm.addNode('REFERENCE');
					break;
				case 'addChildStructuralNode':
				case 'insertBeforeStructuralNode':
				case 'insertAfterStructuralNode':
				case 'addFirslLevelStructuralNode':
					vm.addNode('STRUCTURAL');
					break;
				case 'pastNode':
					vm.pastNode();
					break;
				case 'copyNode':
				case 'copyNodeWithChildren':
					vm.copyNode();
					break;
				case 'cutNodeWithChildren':
				case 'cutNode':
					vm.cutNode();
					break;
				case 'moveNode':
					vm.moveNode();
					break;
				case 'expandAllSelectedNode':
					vm.expandAllSelectedNode();
					break;
				case 'collapseAllSelectedNode':
					vm.collapseAllSelectedNode();
					break;
				case 'editNodeContent':
					vm.editNodeContent();
					break;
				case 'editNodeRequest':
					vm.editNodeRequest();
					break;
				case 'editNodeReference':
					vm.editNodeReference();
					break;
				case 'modifyNodeTitle':
					vm.modifyNodeTitle();
					break;
				case 'previewNodeRequestResolution':
					vm.previewNodeRequestResolution();
					break;
				case 'restoreNode':
					vm.restoreNode();
					break;
				case 'deleteNode':
					vm.deleteNode();
					break;
				case 'editNodeMetaData':
					vm.editNodeMetaData();
					break;
				case 'activateNode':
					vm.activateNode();
					break;
				case 'deactivateNode':
					vm.deactivateNode();
					break;
				case 'modifyNodeType':
					vm.modifyNodeType();
					break;
				case 'editDesiredPublicationDate':
					vm.editDesiredPublicationDate();
					break;
				case 'preview':
					vm.openPreviewTab();
					break;
				case 'createAndHook':
					vm.createAndHook();
					break;
				case 'deleteHook':
					vm.deleteHook();
					break;
			}
		};
		//################## Treeview Actions ########################

		//Show node system metadata
		vm.showNodeSystemMetaData = function (id) {
			angular.element('#node_' + id + '_system_metadatas').show();
			angular.element('#' + id + '_voir_plus').hide();
		};
		//Show node system metadata
		vm.hideNodeSystemMetaData = function (id) {
			angular.element('#node_' + id + '_system_metadatas').hide();
			angular.element('#' + id + '_voir_plus').show();
		};
		//show all nodes metadata
		vm.showAllNodesMetaData = function () {
			angular.element('#treeview_display_all_metadatas').hide();
			angular.element('#treeview_hide_all_metadatas').show();
			vm.showNodesMetaData = true;

		};
		//hide all nodes metadata
		vm.hideAllNodesMetaData = function () {
			angular.element('#treeview_display_all_metadatas').show();
			angular.element('#treeview_hide_all_metadatas').hide();
			vm.showNodesMetaData = false;
		};

		// VALIDATE EE
		vm.validateEE = function () {
			if ($scope.editorialEntity.editorialEntityTemplate.contentType === 'TREE') {
				validateEntityService.chooseValidationType($scope.editorialEntity);
			} else {
				validateEntityService.openModal($scope.editorialEntity, false, false, false);
			}
		};

		vm.showDeletedNode = false;
		vm.setDeletedNodeDisplay = function (display) {
			vm.showDeletedNode = display;
			vm.reloadNode($scope.editorialEntity.identifier, true);
		};

		vm.hideEmptyStructuralNodesMap = userPreferenceService.getUserTreeViewPreference('hideEmptyStructuralNodes', {});
		vm.hideEmptyStructuralNode = vm.hideEmptyStructuralNodesMap[$scope.editorialEntity.editorialEntityTemplate.code] ? vm.hideEmptyStructuralNodesMap[$scope.editorialEntity.editorialEntityTemplate.code] : false;
		vm.setEmptyStructuralNodeDisplay = function (display) {
			vm.hideEmptyStructuralNode = display;
			vm.reloadNode($scope.editorialEntity.identifier, true);
		};

		//Add node
		vm.addNode = function (nodeType) {
			switch (nodeType) {
				case 'STRUCTURAL':
					vm.addTypedNode(EDITORIAL_ELEMENT_TYPE.structural);
					break;
				case 'REFERENCE':
					vm.addReferenceNode();
					break;
				case 'CONTENT':
					vm.addTypedNode(EDITORIAL_ELEMENT_TYPE.content);
					break;
				case 'QUERY':
					vm.addQueryNode();
					break;
			}
		};
		//add node
		vm.addNodeToTreeView = function (node, select) {

			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				//update existing node.
				var parentNode = vm.selectedNode.parentNode();
				if (vm.selectedMenuItemId.startsWith('insertAfter')) {
					if (angular.isDefined(parentNode)) {
						parentNode.children.insert(parentNode.children.indexOf(vm.selectedNode) + 1, node);
					} else {
						if (angular.isUndefined(vm.selectedNodeElement)) {
							vm.dataSource.insert(vm.dataSource.indexOf(vm.selectedNode) + 1, node);
						} else {
							$scope.treeViewInstance.insertAfter(node, vm.selectedNodeElement);
						}
					}
				} else if (vm.selectedMenuItemId.startsWith('insertBefore')) {
					if (angular.isDefined(parentNode)) {
						parentNode.children.insert(parentNode.children.indexOf(vm.selectedNode), node);
					} else {
						$scope.treeViewInstance.insertBefore(node, vm.selectedNodeElement);
					}
				} else if (vm.selectedMenuItemId.startsWith('addChild')) {
					//add child node
					vm.selectedNode.append(node);
				}
			} else {
				//add first level node
				$scope.treeViewInstance.append(node);
			}

			if (select) {
				vm.expandSelectedNode();
				vm.selectAdded = true;
			}

			// if (angular.isDefined($scope.handleExternalActionEvent) && $scope.handleExternalActionEvent) {
			// 	vm.reinitExternalNodeAction();
			// }
		};
		//add reference node
		vm.addReferenceNode = function () {
			//Call the wizard
			var idSelectedNode = angular.isDefined(vm.selectedNode) ? vm.selectedNode.id : undefined;
			// open the current selected node
			vm.expandSelectedNode();
			var modalInstance = $uibModal.open(createLinkService.getConfigForReferenceNodeCreation($scope.editorialEntity.identifier, vm.container, idSelectedNode, $scope.editorialEntity.ownerGroup, $scope.editorialEntity.editorialEntityTemplate.identifier));
			modalInstance.result.then(function (relations) {
				//create a node for every relation (case where we selected more then one ee target)
				var parentId = vm.getParentId();
				var nodeDTOs = [];
				_.each(relations, function (relation) {
					var nodeDTO = vm.initNodeDTO(null,
						null,
						null,
						null,
						'REFERENCE',
						vm.getNodePath(),
						parentId,
						[], [], [],
						null,
						null, [],
						null,
						vm.getDisplayOrder() + nodeDTOs.length,
						null,
						angular.isDefined(vm.selectedNode) && angular.isDefined(vm.selectedNode.parentNode()) ? vm.selectedNode.parentNode().grayDisplay : false);
					//Seting up the associated relation
					relation.eeSourceFlashId = $scope.editorialEntity.identifier;
					nodeDTO.relationDTO = relation;
					nodeDTOs.push(nodeDTO);
				});

				blockUI.start();
				nodeResource.createNodes(nodeDTOs).$promise.then(function (nodes) {
					blockUI.stop();
					_.each(nodes, function (node) {
						var referenceNode = vm.initTreeNode(
							node.id,
							node.title,
							showChildren(node),
							vm.filterMetaData(node.metaInstanceDTOList, 'system'),
							vm.filterMetaData(node.metaInstanceDTOList, 'editorial'),
							node.metaInstanceDTOList, [],
							node.type,
							node.relationStatus,
							null,
							null,
							node.grayDisplay,
							false,
							node.displayOrder,
							node.path,
							node.linkedEETitle,
							node.activated,
							node.relationDTO !== null ? node.relationDTO.flashId : null,
							node.refNodeId,
							node.subNodesId,
							null,
							false,
							node.relationDTO !== null ? node.relationDTO.desiredPublicationDate : null);
						//add node to treeview
						vm.addNodeToTreeView(referenceNode, true);
						//Refresh tree if entity template is a container
						if ($scope.editorialEntity.editorialEntityTemplate.container) {
							$state.reload();
						}
					});
				});
			}, function () {
				blockUI.stop();
			});
		};
		//add query node
		vm.addQueryNode = function () { };

		//add node type 
		vm.addTypedNode = function (type) {

			var nodeToCreate = nodeBuilderService.nodeToCreate($scope.editorialEntity, type,
				vm.selectedNode, vm.selectedMenuItemId, vm.dataSource, $scope.editorialEntity.ownerGroup);

			addNodeModalService.openModal(nodeToCreate)
				.then(function (node) {
					var structuralNode = vm.createNodeObject(node);
					//add node to treeview
					vm.addNodeToTreeView(structuralNode, true);
				});


		};

		vm.createNodeObject = function (node) {
			return vm.initTreeNode(
				node.id,
				node.title,
				node.subNodesId !== null && node.subNodesId.length > 0,
				vm.filterMetaData(node.metaInstanceDTOList, 'system'),
				vm.filterMetaData(node.metaInstanceDTOList, 'editorial'),
				node.metaInstanceDTOList, [],
				node.type,
				node.relationStatus,
				null,
				null,
				node.grayDisplay,
				false,
				node.displayOrder,
				node.path,
				node.linkedEETitle,
				node.activated,
				node.type === 'REFERENCE' && node.relationDTO ? node.relationDTO.flashId : null,
				node.refNodeId,
				node.subNodesId,
				node.relationDTO ? node.relationDTO.desiredPublicationDate : null,
				node.external);
		};

		//return node parent id
		vm.getParentId = function () {
			return nodeService.getParentId(vm.selectedNode, vm.selectedMenuItemId, $scope.editorialEntity.identifier);
		};
		//calculate display order
		vm.getDisplayOrder = function (newNodesSize) {
			return nodeService.getDisplayOrder(vm.selectedNode, vm.selectedMenuItemId, vm.dataSource, newNodesSize);
		};
		//Get the node path
		vm.getNodePath = function () {
			return nodeService.getNodePath(vm.selectedNode, vm.selectedMenuItemId, $scope.editorialEntity.identifier);
		};

		vm.canRestore = function () {
			if (vm.selectedNode) {
				var parentNode = vm.selectedNode.parentNode();

				return vm.selectedNode.deleted && (!parentNode || !parentNode.deleted);
			}
			return false;
		};

		function getParentNodeId(node) {
			return node.parentNode() ? node.parentNode().id : $scope.editorialEntity.identifier;
		}

		vm.restoreNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				var node = vm.selectedNode;
				nodeResource.restoreNode({
					id: node.id
				}).$promise.then(function () {
					vm.reloadNode(getParentNodeId(node));
					vm.reloadNode(node.id, true);
				});
			}
		};

		function getScrollingParent(element) {
			element = element.parentElement;
			while (element) {
				if (element.scrollHeight !== element.clientHeight) {
					return angular.element(element);
				}
				element = element.parentElement;
			}
			return null;
		}

		function scrollToNode(nodeElement) {
			var scrollParent = getScrollingParent(nodeElement[0]);
			if (scrollParent) {
				var delta = nodeElement.offset().top - scrollParent.offset().top;
				scrollParent.animate({
					scrollTop: delta - (scrollParent.height() / 2)
				});
			}
		}

		vm.reloading = {};

		function hardRefresh(nodeDataSource, subnodes, deep) {
			var currentChildsMap = {};

			while (nodeDataSource.data().length) {
				var child = nodeDataSource.at(0);
				currentChildsMap[child.id] = child;
				nodeDataSource.remove(child);
			}

			for (var i = 0; i < subnodes.length; i++) {
				var newNode = vm.mapNode(subnodes[i], false);
				var mappedChild = currentChildsMap[newNode.id];
				if (mappedChild) {
					mappedChild.displayOrder = newNode.displayOrder;
					mappedChild.relationStatus = newNode.relationStatus;
					mappedChild.deleted = newNode.deleted;
					mappedChild.nodeLastUpdateDate = newNode.nodeLastUpdateDate;
					nodeDataSource.insert(i, mappedChild);

					if (mappedChild.hasChildren !== newNode.hasChildren) {
						var n = vm.dataSource.get(newNode.id);
						n.hasChildren = newNode.hasChildren;
						n.loaded(false);
						n.load();
					} else if (mappedChild.loaded() && deep) {
						vm.reloadNode(mappedChild.id, deep);
					}
				} else {
					nodeDataSource.insert(i, newNode);
				}
			}
		}

		function softRefresh(nodeDataSource, subnodes, deep) {
			var nodeMap = _.keyBy(nodeDataSource.data(), 'id');

			_.forEach(subnodes, function (node) {
				var currentNode = nodeMap[node.id];
				if (currentNode) {
					nodeMap[node.id].text = node.title;
					if (deep && currentNode.loaded()) {
						vm.reloadNode(currentNode.id, deep, true);
					}
				}
			});
		}

		//force load of the treeview
		vm.reloadNode = function (id, deep, light) {
			var node = vm.dataSource.get(id);

			var nodeDataSource = null;
			if ($scope.editorialEntity.identifier === id) {
				nodeDataSource = vm.dataSource;
			} else {
				if (node) {
					if (!node.hasChildren) {
						vm.reloadNode(node.parentNode() ? node.parentNode().id : $scope.editorialEntity.identifier);
						return;
					}
					nodeDataSource = node.children;
				}
			}

			if (nodeDataSource && !vm.reloading[id]) {
				vm.reloading[id] = true;
				blockUI.start();
				nodeResource.getNodeWithFirstLevelChildNodes({
					id: angular.isDefined(node) ? node.id : $scope.editorialEntity.identifier,
					grayDisplay: angular.isDefined(node) ? node.grayDisplay : false,
					deleted: vm.showDeletedNode,
					hideEmptyStructuralNode: vm.hideEmptyStructuralNode
				}).$promise.then(function (subnodes) {
					try {
						if (!light) {
							hardRefresh(nodeDataSource, subnodes, deep);
						}
						else {
							softRefresh(nodeDataSource, subnodes, deep);
						}

					} finally {
						delete vm.reloading[id];
						blockUI.stop();
					}
				}, function () {
					delete vm.reloading[id];
					blockUI.stop();
				});
			}
		};
		//Modify node title
		vm.modifyNodeTitle = function () {
			if (vm.selectedNode) {
				editNodeTitleModalService.openModal(vm.selectedNode)
					.then(function (data) {
						if (data.titelUpdatedDisplay === '' && vm.selectedNode.type === 'REFERENCE') {
							vm.selectedNode.text = vm.selectedNode.linkedEETitle;
							vm.selectedNode.systemTitle = undefined;
						} else {
							vm.selectedNode.text = data.titelUpdatedDisplay;
							vm.selectedNode.systemTitle = data.systemDTO.systemTitle;
						}
					});
			}
		};
		//Delete node
		vm.deleteNode = function () {
			//confirmation popup 
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				var modalInstance = $uibModal.open({
					templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/deleteNodeModal.tpl.html',
					controller: 'DeleteNodeController',
					controllerAs: 'deleteNodeCtrl',
					scope: $scope,
					resolve: {
						hasChildren: function () {
							return (vm.selectedNode.type !== 'REFERENCE') && vm.selectedNode.hasChildren;
						},
						translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('editorialEntity');
							return $translate.refresh();
						}]
					},
					size: 'lg',
					backdrop: 'static'
				});
				//
				modalInstance.result.then(function (deleteChildNodes) {
					blockUI.start();
					var parentId = angular.isDefined(vm.selectedNode.parentNode()) ? vm.selectedNode.parentNode().id : $scope.editorialEntity.identifier;
					nodeResource.deleteNode({
						id: vm.selectedNode.id,
						deleteChildNodes: deleteChildNodes
					}).$promise.then(function (data) {
						blockUI.stop();
						vm.reloadNode(parentId, false);
						if (vm.showDeletedNode) {
							vm.reloadNode(vm.selectedNode.id, true);
						}
					}, function () {
						blockUI.stop();
					});
				});
			}
		};
		//Modify node type
		vm.modifyNodeType = function () {
			if (vm.selectedNode) {
				var templateCode = $scope.editorialEntity.editorialEntityTemplate.code;
				editStructuralNodeTypeModalService.openModal(vm.selectedNode, templateCode)
					.then(function (type) {
						if (type !== '') {
							vm.selectedNode.text = type + (vm.selectedNode.text.indexOf(':') !== -1 ? vm.selectedNode.text.substr(vm.selectedNode.text.indexOf(':'), vm.selectedNode.text.length) : ':' + vm.selectedNode.text);
						} else {
							vm.selectedNode.text = vm.selectedNode.text.indexOf(':') !== -1 ? vm.selectedNode.text.substr(vm.selectedNode.text.indexOf(':') + 1, vm.selectedNode.text.length) : vm.selectedNode.text;
						}
					});
			}
		};

		//Edit node content
		vm.editNodeContent = function () {
			$state.go('editorialEntityEditTreeNode', {
				id: $scope.editorialEntity.identifier,
				subid: vm.selectedNode.id
			});
		};
		//Edit node request
		vm.editNodeRequest = function () {
			//TODO
		};
		//Preview node request resolution
		vm.previewNodeRequestResolution = function () {
			//TODO
		};
		//Edit node reference
		vm.editNodeReference = function () {
			//TODO
		};

		//expand node
		vm.expandSelectedNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				var node = $scope.treeViewInstance.findByUid(vm.selectedNode.uid);
				$scope.treeViewInstance.expand(node);
			}
		};
		//Move node to
		vm.moveNode = function () {
			//TODO
		};
		//copy node
		vm.copyNode = function (isCut) {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				//copied node
				// if (angular.isDefined(vm.copiedNode) && vm.copiedNode !== null) {
				// 	var node = $scope.treeViewInstance.dataItem($scope.treeViewInstance.findByUid(vm.copiedNode.uid));
				// 	node.set('enabled', true);
				// }
				vm.copiedNode = angular.copy(vm.selectedNode);
				vm.copyAction = vm.selectedMenuItemId;
				if (isCut) {
					//TODO tag node to be cut
					//vm.selectedNode.set('enabled', false);
				} else {
					$scope.treeViewInstance.select(vm.selectedNodeElement);
					$scope.treeViewInstance.focus();

				}
				vm.isCut = angular.isUndefined(isCut) ? false : isCut;
			}
		};
		//Cut node
		vm.cutNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				vm.copyNode(true);
			}
		};
		//past node
		vm.pastNode = function (customDisplayOrder) {
			if (vm.copiedNode !== null && !vm.copiedNode.deleted) {
				//Service call
				blockUI.start();

				var target;
				var displayOrder;

				//if no selectednode add to root
				//need to check if destination is a structural node to change the target
				if (!vm.selectedNode || vm.selectedNode.type === 'STRUCTURAL') {
					target = vm.selectedNode ? vm.selectedNode.id : $scope.editorialEntity.identifier;

					if (angular.isDefined(customDisplayOrder)) {
						displayOrder = customDisplayOrder;
					}
					else {
						var last = _.last(vm.selectedNode.items);
						displayOrder = last ? last.displayOrder + 1 : 1;
					}
				}
				else {
					target = vm.selectedNode.parentNode() ? vm.selectedNode.parentNode().id : $scope.editorialEntity.identifier;
					displayOrder = vm.selectedNode.displayOrder + 1;
				}

				nodeResource.copyNode({
					id: vm.copiedNode.id,
					isDeepCopy: ((vm.copyAction === 'copyNodeWithChildren' || vm.copyAction === 'cutNodeWithChildren') ? true : false),
					isCut: vm.isCut,
					targetNodeId: target,
					sourceNodeParentId: angular.isDefined(vm.copiedNode.parentNode()) ? vm.copiedNode.parentNode().id : $scope.editorialEntity.identifier,
					displayOrder: displayOrder
				}).$promise.then(
					function () {
						blockUI.stop();
						//Find parent node
						var parentId;
						if (angular.isDefined(vm.selectedNode)) {
							if (vm.selectedNode.type === 'STRUCTURAL') {
								parentId = vm.selectedNode.id;
							} else {
								parentId = vm.selectedNode.parentNode() ? vm.selectedNode.parentNode().id : $scope.editorialEntity.identifier;
							}
						} else {
							parentId = $scope.editorialEntity.identifier;
						}
						//Reload node/tree
						vm.reloadNode(parentId);
						//Reload parent of the deleted node.
						//Cut node
						if (vm.isCut) {
							if (angular.isDefined(vm.copiedNode.parentNode())) {
								vm.reloadNode(vm.copiedNode.parentNode().id);
							} else {
								//Reload tree.
								vm.reloadNode($scope.editorialEntity.identifier);
							}
						}
						//Deselect
						vm.deselectNode();
					},
					function () {
						blockUI.stop();
					});
			}
		};

		//Edit node metadata
		vm.editNodeMetaData = function () {
			var isReferenceNode = vm.selectedNode.type === "REFERENCE";
			var id = isReferenceNode ? vm.selectedNode.relationId : vm.selectedNode.id;
			var type = isReferenceNode ? EDITORIAL_ELEMENT_TYPE.relation : vm.selectedNode.type;
			editMetaDataModalService.openEditMetaModalByFlashId(id, type, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !vm.isReadOnly).then(function (response) {
				if (response) {
					vm.selectedNode.metaInstanceDTOList = response.metadataInstances;
					vm.selectedNode.editorialsMetaData = vm.filterMetaData(vm.selectedNode.metaInstanceDTOList, 'editorial');
				}
			});

		};


		vm.updateSystemActivatedMetaData = function (value) {
			blockUI.start();
			nodeResource.activateNode({
				referenceId: vm.selectedNode.id,
				name: SYSTEM_METADATA_IDENTIFIERS.systemActivated,
				type: 'REFERENCE',
				value: value,
				relationId: vm.selectedNode.relationId
			}

			).$promise.then(function (data) {
				vm.selectedNode.activated = data.systemDTO.systemActivated;
				blockUI.stop();
			});
		};
		//node activation
		vm.activateNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				vm.updateSystemActivatedMetaData(true);
			}
		};
		//
		// node deactivation
		vm.deactivateNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				//desactivation
				var modalInstance = $uibModal.open({
					templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/deactivateNodeConfirmModal.tpl.html',
					controller: 'DeactivateNodeConfirmationController',
					controllerAs: 'deactivateNodeCtrl',
					size: 'lg',
					backdrop: 'static'
				});
				modalInstance.result.then(function (confirm) {
					if (confirm) {
						vm.updateSystemActivatedMetaData(false);
					}
				});
			}
		};
		//########################## Utilities methods #######################
		// filter on system meta data
		vm.filterMetaData = function (metaInstanceDTOList, metaDataType) {
			var metaData = [];
			if (metaInstanceDTOList !== null && metaInstanceDTOList.length > 0) {
				var count = 0;
				if (metaDataType === 'system') {
					// system meta data
					for (; count < metaInstanceDTOList.length; count++) {
						if (metaInstanceDTOList[count].metaDataDTO.metaSystem) {
							// system meta data
							metaInstanceDTOList[count].value = metaInstanceDTOList[count].value;
							metaData.push(metaInstanceDTOList[count]);
						}
					}
				} else if (metaDataType === 'editorial') {
					// user meta data
					for (; count < metaInstanceDTOList.length; count++) {
						if (!metaInstanceDTOList[count].metaDataDTO.metaSystem) {
							// system meta data
							metaInstanceDTOList[count].value = metaInstanceDTOList[count].value;
							metaData.push(metaInstanceDTOList[count]);
						}
					}
				}
				return metaData;
			}
		};
		vm.setNodeImageUrl = function (nodeType, relationStatus) {
			var nodeImageUrl = null;
			if (nodeType && angular.isDefined(nodeType)) {
				switch (nodeType) {
					case 'CONTENT':
						nodeImageUrl = "assets/images/content_node.png";
						break;
					case 'STRUCTURAL':
						nodeImageUrl = null;
						break;
					case 'REFERENCE':
						if (relationStatus !== 'BROKEN') {
							nodeImageUrl = "assets/images/reference_node.png";
						} else {
							nodeImageUrl = "assets/images/invalid_link.png";
						}
						break;
					case 'QUERY':
						nodeImageUrl = "assets/images/query_node.png";
						break;
				}
			}
			return nodeImageUrl;
		};
		//
		vm.trustAsHtml = function (text) {
			if (!_.isEmpty(text)) {
				return $sce.trustAsHtml(text);
			}
			return $filter('validName')(text);
		};
		//
		vm.getStructuralNodeTitle = function (structuralNode) {
			var title, type, number;
			var fullTitle = "";
			angular.forEach(structuralNode.metaInstanceDTOList, function name(metaData) {
				if (metaData.metaDataDTO.code === 'systemTitle') {
					title = metaData.value;
				} else if (metaData.metaDataDTO.code === 'systemType') {
					type = metaData.value;
				} else if (metaData.metaDataDTO.code === 'systemNumber') {
					number = metaData.value;
				}
			});
			// NUMBER system metadata
			if (angular.isDefined(number) && number.length > 0) {
				fullTitle = number;
			}
			// TYPE system metadata
			if (angular.isDefined(type) && type.length > 0) {
				fullTitle = fullTitle + " " + type;
			}
			// TITLE system metadata
			if (angular.isDefined(title) && title.length > 0) {
				if ((angular.isDefined(number) && number.length > 0) || (angular.isDefined(type) && type.length > 0)) {
					fullTitle = fullTitle + ":" + title;
				} else {
					fullTitle = title;
				}
			}
			return fullTitle;
		};

		function showChildren(data) {
			if (!$scope.readonly && data.type === 'REFERENCE') {
				return false;
			} else {
				return data.subNodesId !== null && data.subNodesId.length > 0;
			}
		}

		vm.mapNode = function (data, expand) {
			var node = vm.initTreeNode(
				data.id,
				data.title,
				showChildren(data),
				vm.filterMetaData(data.metaInstanceDTOList, 'system'),
				vm.filterMetaData(data.metaInstanceDTOList, 'editorial'),
				data.metaInstanceDTOList, [],
				data.type,
				data.relationStatus,
				(data.type === 'CONTENT') ? data.xmlContent : null,
				(data.type === 'REFERENCE') ? data.htmlPreview : null,
				data.grayDisplay,
				false,
				data.displayOrder,
				data.path,
				data.linkedEETitle,
				data.activated,
				(data.type === 'REFERENCE' && data.relationDTO) ? data.relationDTO.flashId : null,
				data.refNodeId,
				data.subNodesId,
				null,
				false,
				(data.type === 'REFERENCE' && data.relationDTO) ? data.relationDTO.desiredPublicationDate : null,
				data.deleted,
				data.refNodeTree,
				data.systemDTO ? data.systemDTO.systemLastUpdateDate : null,
				data.systemDTO ? data.systemDTO.systemTitle : null,
				data.systemDTO ? data.systemDTO.systemType : null,
				data.external

			);
			//Expand firt level nodes.				
			// if (expand && node.path.length === 1 && node.hasChildren) {
			// 	node.expanded = true;
			// }

			return node;
		};
		// Map data to list of nodes
		vm.mapNodes = function (data) {
			var nodes = [];
			if (angular.isDefined(data) && data !== null && (data.length > 0)) {
				var i = 0;
				for (; i < data.length; i++) {
					var node = vm.mapNode(data[i], true);
					nodes.push(node);
				}
			}
			return nodes;
		};
		//Create a new treeview node.
		vm.initTreeNode = function (
			id,
			text,
			hasChildren,
			systemMetaData,
			editorialsMetaData,
			metaInstanceDTOList,
			items,
			type,
			relationStatus,
			xmlContent,
			htmlPreview,
			grayDisplay,
			showSystemMetaData,
			displayOrder,
			path,
			linkedEETitle,
			activated,
			relationId,
			refNodeId,
			subNodesId,
			linkedEESummary,
			showLinkedEESummary,
			desiredPublicationDate,
			deleted,
			refNodeTree,
			nodeLastUpdateDate,
			systemTitle,
			systemType,
			external
		) {
			var node = {
				id: id,
				text: text,
				hasChildren: hasChildren,
				systemMetaData: systemMetaData,
				editorialsMetaData: editorialsMetaData,
				metaInstanceDTOList: metaInstanceDTOList,
				items: items,
				type: type,
				relationStatus: relationStatus,
				xmlContent: xmlContent,
				htmlPreview: htmlPreview,
				grayDisplay: grayDisplay,
				showSystemMetaData: showSystemMetaData,
				displayOrder: displayOrder,
				path: path,
				linkedEETitle: linkedEETitle,
				activated: activated,
				relationId: relationId,
				refNodeId: refNodeId,
				subNodesId: subNodesId,
				linkedEESummary: linkedEESummary,
				showLinkedEESummary: showLinkedEESummary,
				desiredPublicationDate: desiredPublicationDate,
				deleted: deleted,
				refNodeTree: refNodeTree,
				nodeLastUpdateDate: nodeLastUpdateDate,
				systemTitle: systemTitle,
				systemType: systemType,
				external: external
			};
			return node;
		};
		//Create DTO node
		vm.initNodeDTO = function (
			id,
			status,
			pathStr,
			title,
			type,
			path,
			parent,
			idsXMLFirst,
			linksId,
			metaInstanceDTOList,
			nodeQuery,
			refNodeId,
			subNodesId,
			xmlContent,
			displayOrder,
			relationId,
			grayDisplay) {
			var nodeDTO = {
				id: id,
				status: status,
				pathStr: pathStr,
				title: title,
				type: type,
				path: path,
				parent: parent,
				idsXMLFirst: idsXMLFirst,
				linksId: linksId,
				metaInstanceDTOList: metaInstanceDTOList,
				nodeQuery: nodeQuery,
				refNodeId: refNodeId,
				subNodesId: subNodesId,
				subElements: [],
				xmlContent: xmlContent,
				htmlPreview: null,
				displayOrder: displayOrder,
				relationDTO: {
					id: relationId
				},
				grayDisplay: grayDisplay
			};
			return nodeDTO;
		};
		//Create editorial meta data.
		vm.initMetaData = function (
			identifier,
			mongoDocumentId,
			displayOrder,
			name,
			code,
			metaDataType, metaGroupName, value, labelCode, isSystem) {
			var metaData = {
				displayOrder: displayOrder,
				information: false,
				instantiation: false,
				listDisplayPathForNode: [],
				listFiles: {},
				relationDTOList: {},
				mandatory: true,
				metaDataDTO: {
					identifier: identifier,
					authorized: true,
					mongoDocumentId: mongoDocumentId,
					name: name,
					code: code,
					metaDataType: metaDataType,
					entityStatus: 'VALIDATED',
					description: null,
					metaGroupName: metaGroupName,
					metaSystem: isSystem,
					labelCode: labelCode
				},
				metaDataMultiValuesList: [],
				multiValuesList: [],
				multipleOccurrences: false,
				referentialValueDTOList: [],
				relationshipTemplateId: null,
				value: value
			};
			return metaData;
		};

		//Edit desired publication date
		vm.editDesiredPublicationDate = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				$uibModal.open({
					templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/editDesiredPublicationDateModal.tpl.html',
					controller: 'EditDesiredPulbicationDateController',
					controllerAs: 'EditPublDateCtrl',
					resolve: {
						selectedNode: function () {
							return vm.selectedNode;
						}
					},
					scope: $scope,
					size: 'lg',
					backdrop: 'static'
				});
			}
		};

		//Open modal to let user choose the prams for the preview transformation.
		vm.openPreviewTab = function () {
			$scope.treeViewInstance.select(vm.selectedNodeElement);
			var isArchived = vm.selectedNode.relationStatus === 'BROKEN';
			htmlPreviewTabService.openTabById(vm.selectedNode.id, vm.selectedNode.type, false, isArchived);
		};


		//Create and hook a new ee.
		vm.createAndHook = function () {
			//
			var eeSourceDetails = {
				flashId: $scope.editorialEntity.identifier,
				eetCode: $scope.editorialEntity.editorialEntityTemplate.code,
				metaInstanceList: $scope.editorialEntity.metaInstanceList,
				container: $scope.editorialEntity.editorialEntityTemplate.container,
				subNodesId: $scope.editorialEntity.subNodesId,
				systemTitle: $scope.editorialEntity.titleSystem,
				subElementSystemTitle: angular.isDefined(vm.selectedNode) ? vm.selectedNode.text : ''
			};
			//
			var subElementDetails = null;
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				subElementDetails = {
					type: vm.selectedNode.type,
					id: vm.selectedNode.id,
					path: vm.selectedNode.path,
					subNodesId: vm.selectedNode.subNodesId
				};
			}
			//Launch the wizard
			CreateAndHookEeWizardModalService.openModal(eeSourceDetails, subElementDetails, $scope.currentUser, false, $scope.editorialEntity).then(function (node) {
				vm.addRefNode(node);
				//Refresh tree if entity template is a container
				if ($scope.editorialEntity.editorialEntityTemplate.container) {
					$state.reload();
				}
			});
		};
		// META
		vm.isMetaEmpty = function (metadataList) {
			return _.some(metadataList, function (meta) {
				return !MetadataService.isMetaEmpty(meta);
			});
		};

		function checkAncestors(dataNode) {
			var parent = dataNode.parentNode();
			var checkId = dataNode.refNodeId;
			while (parent) {
				if (parent.id === checkId || parent.refNodeId === checkId) {
					return true;
				}
				parent = parent.parentNode();
			}

			//check root
			return $scope.editorialEntity.identifier === checkId;
		}

		vm.autoExpandLevel = userPreferenceService.getUserGlobalPreference('TreeviewAutoExpandValue', -1);
		vm.nodeBlackList = {};
		vm.hideRecursiveNodes = true;
		vm.autoExpandFirstLevel = true;
		vm.onDataBound = function (e) {

			var childSelector;
			// root 
			if (!e.node) {
				childSelector = $scope.treeViewInstance.element.find(">ul>.k-item");
			} else {
				childSelector = e.node.find(".k-item");
			}

			vm.expandNodes(childSelector);
		};

		vm.unlockExpand = function () {
			vm.unlockExpandActived = true;
		};

		vm.expandNodes = function (nodesSelector) {
			var maxExpandLevel = vm.autoExpandLevel + (vm.relativeLevel ? vm.relativeLevel : 0);

			var openedRefNodes = {};
			nodesSelector.each(function () {
				var dataNode = $scope.treeViewInstance.dataItem(this);

				if (vm.hideRecursiveNodes && dataNode.refNodeTree && checkAncestors(dataNode)) {
					vm.nodeBlackList[dataNode.id] = true;
				}

				if (dataNode.refNodeTree) {
					this.setAttribute('data-ref-node', '');
				}

				if ((vm.unlockExpandActived || !dataNode.refNodeTree) && vm.expandAllFlag && (vm.autoExpandLevel === -1 || dataNode.level() < (maxExpandLevel))) {
					$scope.treeViewInstance.expand(this);
					vm.expandNodes(angular.element(this).find(">ul>.k-item"));
				}
				else if (vm.autoExpandFirstLevel && dataNode.level() === 0) {
					if (dataNode.refNodeTree && !openedRefNodes[dataNode.refNodeId]) {
						openedRefNodes[dataNode.refNodeId] = true;
						$scope.treeViewInstance.expand(this);
						vm.reinitExternalNodeAction();
						vm.expandNodes(angular.element(this).find(">ul>.k-item"));
					}
					else if (!dataNode.refNodeTree) {
						$scope.treeViewInstance.expand(this);
						vm.reinitExternalNodeAction();
						vm.expandNodes(angular.element(this).find(">ul>.k-item"));
					}
				}
			});

			// [SIETRAINT1-1681] Only way to remove auto focus on expanded node with kendo ...
			$timeout(function () {
				angular.element('.k-state-focused').removeClass("k-state-focused");
			});

			openedRefNodes = {};
		};

		vm.expandAll = function () {
			vm.expandAllFlag = true;
			vm.relativeLevel = 0;
			var childSelector = $scope.treeViewInstance.element.find(">ul>.k-item");
			vm.expandNodes(childSelector);
		};

		//collapse all nodes
		vm.collapseAll = function () {
			// collapse all items
			$scope.treeViewInstance.collapse(".k-item");
		};

		//expand all element of selected node
		vm.expandAllSelectedNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				vm.expandAllFlag = true;

				$scope.treeViewInstance.expand("[data-uid='" + vm.selectedNode.uid + "']");
				var node = $scope.treeViewInstance.findByUid(vm.selectedNode.uid);
				var dataNode = $scope.treeViewInstance.dataItem(node);
				var childSelector = node.find(">ul>.k-item");

				vm.relativeLevel = dataNode.level();
				vm.expandNodes(childSelector, dataNode.level());
			}
		};

		// collapse all element of selected node
		vm.collapseAllSelectedNode = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				$scope.treeViewInstance.collapse("[data-uid='" + vm.selectedNode.uid + "']");
				$scope.treeViewInstance.collapse("[data-uid='" + vm.selectedNode.uid + "'] .k-item");
			}
		};

		//delete broken reference node
		vm.deleteHook = function () {
			if (angular.isDefined(vm.selectedNode) && vm.selectedNode !== null) {
				if (vm.selectedNode.type === "REFERENCE") {
					blockUI.start();
					var referenceNodeFlashId = vm.selectedNode.flashId;
					return nodeResource.deleteNode({
						id: referenceNodeFlashId,
						deleteChildNodes: false
					}).$promise.then(function (data) {
						$rootScope.$broadcast("refresh_entity");
						vm.reloadTree();
						blockUI.stop();
					});
				}
			}
		};
	}


	angular.module('userApp').controller(
		'DeleteNodeController',
		function ($translate, $uibModalInstance, hasChildren) {
			var vm = this;
			//lang
			vm.lang = $translate.use();
			//
			vm.deleteChildNodes = false;
			vm.hasChildren = hasChildren;
			// save
			vm.ok = function () {
				$uibModalInstance.close(vm.deleteChildNodes);
			};
			//cancel
			vm.cancel = function () {
				$uibModalInstance.dismiss('cancel');
			};

		}).controller('ModifyNodeTypeController',
			function ($translate, $uibModalInstance, $uibModal, node, nodeTypes) {
				var vm = this;
				//lang
				vm.lang = $translate.use();
				vm.nodeTypes = nodeTypes;
				//
				vm.node = node;
				vm.type = null;
				//system type metadata
				var systemTypeMetaData = null;
				angular.forEach(vm.node.metaInstanceDTOList, function (metadata) {
					if (metadata.metaDataDTO.code === 'systemType') {
						systemTypeMetaData = metadata;
					}
				});
				//
				if (systemTypeMetaData !== null) {
					vm.type = systemTypeMetaData.value;
				}
				// save
				vm.save = function () {
					//update system type metadata
					if (systemTypeMetaData !== null) {
						systemTypeMetaData.value = vm.type;
						vm.node.metaInstanceDTOList = angular.copy(vm.node.metaInstanceDTOList);
					}
					var data = {
						node: vm.node,
						type: systemTypeMetaData === null ? vm.type : null
					};
					$uibModalInstance.close(data);
				};
				//cancel
				vm.cancel = function () {
					$uibModalInstance.dismiss('cancel');
				};

			}).controller('DeactivateNodeConfirmationController',
				function ($translate, $uibModalInstance) {
					var vm = this;
					//lang
					vm.lang = $translate.use();
					// save
					vm.ok = function () {
						$uibModalInstance.close(true);
					};
					//cancel
					vm.cancel = function () {
						$uibModalInstance.dismiss('cancel');
					};

				}).controller('EditDesiredPulbicationDateController', function ($scope, $rootScope, $log, $uibModalInstance, blockUI, $filter, selectedNode, relationResource, modalService, ModalAlertService) {

					$scope.desiredPublicationDate = {
						value: selectedNode.desiredPublicationDate !== null ? new Date(selectedNode.desiredPublicationDate) : null
					};

					$scope.label = $filter('translate')('userApp.linkingWizard.home.desiredPublicationDate');
					$scope.save = function () {
						var relation = {
							"flashId": selectedNode.relationId,
							"desiredPublicationDate": $scope.desiredPublicationDate.value
						};

						relationResource.updateDesiredPublicationDate(relation).$promise.then(function (data) {
							selectedNode.desiredPublicationDate = $scope.desiredPublicationDate.value;
							$uibModalInstance.close(true);
							//TODO add success popup
							ModalAlertService.success("'" + $filter('translate')('userApp.treeEEEdition.labels.success') + "'", $filter('translate')('userApp.treeEEEdition.labels.DesiredPublicationDateUpdatedSuccess'), '');

							/**
								* event send to  treeFlatViewController to inform that the update has been succeed so tha value can be update
								* without need to request web service gain to get the new value.
								*/
							$rootScope.$broadcast('desiredPublicationDateUpdated', $scope.desiredPublicationDate.value);

						}).catch(function (error) {
							$log.error("Error whene updating desired publication date ", error);
						});
						//TODO add error popup
						$uibModalInstance.close(true);
					};
					$scope.cancel = function () {
						$uibModalInstance.dismiss('cancel');
					};
				});

})();

(function () {
	'use strict';
	/*global classNames*/

	angular
		.module('userApp')
		.factory('EcmTreeviewDivRenderService', EcmTreeviewDivRenderService);

	/** @ngInject */
	function EcmTreeviewDivRenderService(EcmTreeviewRenderService, $sce, $translate) {


		var service = {
			divRenderer: divRenderer
		};

		var tag = EcmTreeviewRenderService.tag;

		return service;

		function divRenderer(node, treeOptions) {
			var id = node.id;
			var name = node.name;
			var loadOnDemand = node.loadOnDemand;
			var children = node.children;
			var state = node.state;
			// const { id, name, loadOnDemand = false, children, state, props = {} } = node;
			var props = node.props;
			var droppable = treeOptions.droppable;

			// j'en ai marre de pas être en ES6
			//const { depth, open, path, total, selected = false, filtered, checked, indeterminate, loading } = state;
			var depth = state.depth;
			var open = state.open;
			var path = state.path;
			var total = state.total;
			var selected = state.selected;
			var filtered = state.filtered;
			// var checked = state.checked;
			// var indeterminate = state.indeterminate;
			var loading = state.loading;

			var childrenLength = Object.keys(children).length;
			var more = node.hasChildren();

			if (filtered === false) {
				return;
			}

			var togglerContent = '-';
			if (!more && loadOnDemand) {
				togglerContent = tag('i', {
					'class': classNames('glyphicon', { 'glyphicon-triangle-right': !loading }, { 'glyphicon-refresh': loading },
						{ 'rotating': loading })
				}, '');
			}
			if (more && open) {
				togglerContent = tag('i', {
					'class': classNames('glyphicon', 'glyphicon-triangle-bottom')
				}, '');
			}
			if (more && !open) {
				togglerContent = tag('i', {
					'class': classNames('glyphicon', 'glyphicon-triangle-right')
				}, '');
			}

			var toggler = tag('a', {
				'class': (function () {
					if (!more && loadOnDemand) {
						return classNames(treeOptions.togglerClass, 'infinite-tree-closed');
					}
					if (more && open) {
						return classNames(treeOptions.togglerClass);
					}
					if (more && !open) {
						return classNames(treeOptions.togglerClass, 'infinite-tree-closed');
					}
					return 'infinite-tree-spacer';
				})()
			}, togglerContent);

			// var checkbox = tag('input', {
			// 	type: 'checkbox',
			// 	style: 'display: inline-block; margin: 0 4px',
			// 	'class': 'checkbox',
			// 	checked: checked,
			// 	'data-checked': checked,
			// 	'data-indeterminate': indeterminate
			// });

			var title = tag('span', {
				'class': classNames('infinite-tree-title')
			}, (function () {
				if (props.type === 'CONTENT' && props.fullNode.contentEmpty) {
					return name + '\n<span class="disabled-node">(' + $translate.instant('userApp.treeEEEdition.labels.emptyNodeContent') + ')</span>';
				}

				return name;
			})());

			var typeIcon = tag('i', {
				'class': (function () {
					// TODO PUT IN A SERVICE
					var iconClass;
					if (props.type === 'REFERENCE') {
						switch (props.relationStatus) {
							case 'BROKEN':
								iconClass = 'faricon-broken-link';
								break;
							case 'VALID':
								iconClass = 'faricon-valid-link';
								break;
							default:
								iconClass = '';
						}
					}

					if (props.type === "CONTENT") {
						iconClass = "fa fa-file-text-o";
					}

					return classNames('infinite-tree-item-icon', iconClass);
				})()
			}, '');

			var summaryToggleIcon = tag('i',
				{
					class: classNames('fa', 'fa-ellipsis-h', 'ecm-summary-transition', { 'fa-rotate-90': node.showSummary }),
					'ng-class': "{\'fa-rotate-90\': $ctrl.node.showSummary}"
				}, '');

			var summaryToggle = (props.type === 'REFERENCE' && props.relationStatus !== 'BROKEN') ? tag('a', {
				class: classNames('ecm-tree-show-summary-btn'),
				'ng-click': '$ctrl.toggleSummary($ctrl.node, $event)'
			}, summaryToggleIcon) : '';

			var summary = tag('div', {
				'ecm-collapse': '!$ctrl.node.showSummary',
				class: classNames('ecm-tree-collapse', 'ecm-collapsable'),
				style: node.showSummary ? '' : ('height: 0; margin-top: 0;')
			}, '<div class="ecm-tree-zone ecm-tree-zone-summary"><div ng-bind-html="$ctrl.node.summary" class="resume-label">' + (node.summary ? $sce.getTrustedHtml(node.summary) : '') + '</div></div>');

			var metadataBlockIcon = tag('i', {
				class: classNames('ecm-tree-zone-icon'),
				'ng-class': "{'fa fa-info': '!$ctrl.node.props.metadataLoading', 'glyphicon glyphicon-refresh rotating': $ctrl.node.props.metadataLoading}"
			}, '');

			var metadataBlock = tag('div', {
				style: 'min-height:0',
				class: classNames('ecm-tree-zone', 'ecm-tree-zone-meta'),
				'ng-style': "{'min-height': $ctrl.context.showMetadata ? '19px': 0}"
			}, metadataBlockIcon + '<display-meta-values flash-id="$ctrl.node.props.flashId" type="$ctrl.node.props.type" external-load-callback="$ctrl.loadMetadata"></display-meta-values>');

			var metadataContainer = tag('div', {
				'ng-if': '$ctrl.context.showMetadata && !$ctrl.node.hideMeta',
				'class': 'ecm-tree-metadata-container',
				'style': 'margin-left:' + (depth * 10 + 6) + 'px;',
			}, metadataBlock);

			var treeNode = tag('div', {
				'class': classNames('infinite-tree-node', 'ecm-tree-title-' + node.props.type.toLowerCase(), { 'disabled-node': node.props.disabled }),
				'style': 'margin-left:' + depth * 10 + 'px',
			}, toggler + typeIcon + summaryToggle + '\n' + title + summary);

			return tag('div', {
				'draggable': 'true',
				'data-id': id,
				'data-target-id': props.fullNode.targetEntityDTO && props.fullNode.targetEntityDTO.flashId ? props.fullNode.targetEntityDTO.flashId : props.flashId,
				'data-expanded': more && open,
				'data-depth': depth,
				'data-path': path,
				'data-selected': selected,
				'data-children': childrenLength,
				'data-total': total,
				'context-menu': '$ctrl.menuOptions($ctrl.node)',
				'context-menu-empty-text': "'userApp.treeEEEdition.labels.disabled'|translate",
				'close-menu-on': 'click',
				'ng-class': "{'infinite-tree-selected': $ctrl.node.state.selected}",
				'class': classNames(
					'infinite-tree-item',
					{ 'infinite-tree-selected': selected }
				),
				'droppable': droppable
			}, treeNode + metadataContainer);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('EcmTreeviewRenderService', EcmTreeviewRenderService);

	/** @ngInject */
	function EcmTreeviewRenderService() {
		var voidElements = [
			'area',
			'base',
			'br',
			'col',
			'embed',
			'hr',
			'img',
			'input',
			'keygen',
			'link',
			'meta',
			'param',
			'source',
			'track',
			'wbr'
		];

		var service = {
			tag: tag
		};

		return service;

		////////////////
		function tag(tag, attrs, text) {
			if (angular.isObject(tag)) {
				text = attrs;
				attrs = tag;
				tag = 'div';
			}

			var voidElement = voidElements.indexOf(('' + tag).toLowerCase()) >= 0;
			var html = '<' + tag;

			attrs = Object.assign({}, attrs);
			Object.keys(attrs).forEach(function (name) {
				var value = attrs[name];
				if (angular.isString(value)) {
					value = ('' + value);
					html += ' ' + name + '="' + value + '"';
				} else if (value) {
					html += ' ' + name;
				}
			});

			if (voidElement) {
				html += '>';
			} else if (angular.isDefined(text)) {
				html += '>' + text + '</' + tag + '>';
			} else {
				html += '/>';
			}

			return html;
		}
	}
})();

(function () {
	'use strict';
	/*global classNames*/
	/*global InfiniteTree*/
	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('ecmTreeview', {
			controller: EcmTreeview,
			bindings: {
				flashId: '<',
				nodeSelection: '&?',
				editorialEntity: '<',
				currentUser: '<',
				showMetadata: '<'
			},
		});


	function EcmTreeview($element, EcmTreeviewDivRenderService, $state, blockUI, $scope, ecmTreeviewService, $q, $sce, $compile, $rootScope, $translate, $filter, $timeout) {
		var ctrl = this;


		////////////////


		var debouncedUpdate = (function (debouncedUpdateDelay) {
			var running = false;
			return function () {
				if (!running) {
					running = true;
					$timeout(function () {
						running = false;
						ctrl.tree.update();
					}, debouncedUpdateDelay);
				}
			};
		})(400);

		function getNodeFromElement(element) {
			var treeItem = angular.element(element);
			var nodeItemId = treeItem.data('id');
			var node = ctrl.tree.getNodeById(nodeItemId);

			return node;
		}

		ctrl.updateCheckboxState = function (tree) {
			var checkboxes = tree.contentElement.querySelectorAll('input[type="checkbox"]');
			for (var i = 0; i < checkboxes.length; ++i) {
				var checkbox = checkboxes[i];
				if (checkbox.hasAttribute('data-indeterminate')) {
					checkbox.indeterminate = true;
				} else {
					checkbox.indeterminate = false;
				}
			}
		};

		ctrl.toggleNode = function (node, open) {
			if (node.hasChildren() || node.loadOnDemand) {
				open ? ctrl.tree.openNode(node, { updateView: false }) : node.state.open = false;
				var childs = node.getChildren();
				childs.forEach(function (child) { ctrl.toggleNode(child, open); });
			}
		};

		ctrl.refreshNode = function (node) {
			return ecmTreeviewService.getTree(node.props.flashId, node.state.depth).then(function (result) {
				var opened = node.state.open;
				ctrl.tree.removeChildNodes(node);
				ctrl.tree.addChildNodes(result.children, 0, node);
				ctrl.tree.updateNode(node, result, { shallowRendering: false });
				if (opened) {
					ctrl.tree.openNode(node);
				}
				return node;
			});
		};

		ctrl.expandAll = function () {
			var root = ctrl.tree.getRootNode();
			var childs = root.getChildren();
			childs.forEach(function (child) { ctrl.toggleNode(child, true); });
			//ctrl.tree.update();
			debouncedUpdate();
		};

		ctrl.collapseAll = function () {
			var root = ctrl.tree.getRootNode();
			var childs = root.getChildren();
			var autoOpenOption = ctrl.tree.options.autoOpen;
			ctrl.tree.options.autoOpen = false;
			ctrl.tree.loadData(childs);
			ctrl.tree.options.autoOpen = autoOpenOption;
		};

		ctrl.checkAncestor = function (node) {
			var parent = node.parent;
			while (parent.id) {
				if (node.props.flashId === parent.props.flashId) {
					return false;
				}

				// TEMP FIX UNTIL CONFIG
				if (parent.props.fullNode.systemDTO.systemType === 'Sujets liés') {
					return false;
				}
				parent = parent.parent;
			}

			// check root
			if (ctrl.flashId === node.props.flashId) {
				return false;
			}

			return true;
		};

		function getMetadataCacheKey(node) {
			return node.props.flashId + node.props.type;
		}

		ctrl.clearMetadataCache = function (node) {
			if (!node) {
				ctrl.metadatasCache = {};
			}
			else {
				var key = getMetadataCacheKey(node);
				delete ctrl.metadatasCache[key];
			}
		};

		ctrl.loadNodeMetadata = function (node) {
			var key = getMetadataCacheKey(node);
			node.props.metadataLoading = true;
			if (ctrl.metadatasCache[key]) {
				node.props.metadataLoading = false;
				return $q.resolve(ctrl.metadatasCache[key]);
			}

			return ecmTreeviewService.getMetadata(node).then(function (data) {
				ctrl.metadatasCache[key] = data;
				return data;
			}).finally(function () { node.props.metadataLoading = false; });
		};

		ctrl.refreshNodeMetadata = function (node) {
			ctrl.clearMetadataCache(node);
			$timeout(function () {
				node.hideMeta = true;
			});
			$timeout(function () {
				node.hideMeta = false;
			});
		};

		ctrl.editMetadata = function (node) {
			ecmTreeviewService.editMetadata(node).then(function () {
				// refresh when finishing editing meta				
				ctrl.changeSelectedNode(node);

				if (ctrl.showMetadata) {
					ctrl.refreshNodeMetadata(node);
				}
			});
		};

		/**
		 * Handle menu
		 */
		ctrl.menuOptions = function (node) {
			if (node) {
				return [
					{
						// edit metadata structure
						text: function () { return $translate('userApp.treeEEEdition.labels.editMeta'); },
						click: function () {
							ctrl.editMetadata(node);
						},
						displayed: node.props.type === 'STRUCTURAL' && !node.props.disabled
					},
					{
						// edit metadata relation
						text: function () { return $translate('userApp.treeEEEdition.labels.editRelationMeta'); },
						click: function () {
							ctrl.editMetadata(node);
						},
						displayed: node.props.type === 'REFERENCE' && !node.props.disabled
					},
					{
						// edit metadata relation
						text: function () { return $translate('userApp.treeEEEdition.labels.editMeta'); },
						click: function () {
							ctrl.editMetadata(node);
						},
						displayed: node.props.type === 'CONTENT' && !node.props.disabled
					},
					{
						// expand all
						text: function () { return $translate('userApp.treeEEEdition.labels.expandAllSelectedNode'); },
						click: function () {
							ctrl.toggleNode(node, true);
							ctrl.tree.update();
						},
						displayed: node.hasChildren() || (!node.hasChildren() && node.loadOnDemand)
					},
					{
						// collapse
						text: function () { return $translate('userApp.treeEEEdition.labels.collapseAllSelectedNode'); },
						click: function () {
							ctrl.toggleNode(node, false);
							ctrl.tree.closeNode(node);
							ctrl.tree.update();
						},
						displayed: node.hasChildren() || (!node.hasChildren() && node.loadOnDemand)
					},
					{
						// Preview
						text: function () { return $translate('userApp.treeEEEdition.labels.preview'); },
						click: function () {
							ecmTreeviewService.openPreviewTab(node);
						},
						enabled: ctrl.isFullPreviewEnabled && node.props.relationStatus !== 'BROKEN' && !ctrl.isHooksExternalEntities
					},
					{
						// Create And Hook
						text: function () { return $translate('userApp.treeEEEdition.labels.createAndHook'); },
						click: function () {
							ecmTreeviewService.createAndHook(node, ctrl.editorialEntity, ctrl.currentUser).then(function (result) {
								ctrl.refreshNode(node);
							});
						},
						displayed: node.props.type === 'STRUCTURAL' && !node.props.disabled && !ctrl.isHooksExternalEntities
					},
					{
						// Delete broken reference node
						text: function () { return $translate('userApp.treeEEEdition.labels.deleteHook'); },
						click: function () {
							blockUI.start();
							ecmTreeviewService.deleteHook(node).then(function () {
								if (node.parent) {
									ctrl.refreshNode(node.parent);
								}
								else {
									ctrl.getTree();
								}
								blockUI.stop();
							});
						},
						displayed: node.props.type === 'REFERENCE' && node.props.relationStatus === 'BROKEN' && !node.props.disabled && !node.props.external
					}
				];
			}

			return;
		};

		/**
		 * Menu Event
		 */
		$scope.$on('context-menu-opening', function (event, args) {
			if (args.context) {
				var node = getNodeFromElement(args.context);
				if (node) {
					ctrl.tree.selectNode(node, { updateView: false });
				}
			}
		});

		ctrl.metadatasCache = {};

		// force height size calculation for infinitescroll
		ctrl.refreshTreeSize = function () {
			ctrl.tree.clusterize.resizeEventListener();
		};

		ctrl.$onChanges = function (changes) {
			if (changes.showMetadata && ctrl.tree) {
				ctrl.clearMetadataCache();
				ctrl.tree.options.showMetadata = ctrl.showMetadata;

				ctrl.refreshTreeSize();
			}
		};

		ctrl.$onInit = function () {
			ctrl.firstLoad = true;
			ctrl.tree = new InfiniteTree($element[0], {
				rowsInBlock: 50,
				blocksInCluster: 4,
				autoOpen: true, // Defaults to false
				droppable: true, // Defaults to false
				layout: 'div', // Defaults to 'div'
				rowRenderer: EcmTreeviewDivRenderService.divRenderer,
				noDataText: '',
				selectable: true, // Defaults to true
				updateViewOnSelect: false,
				doRender: false,
				shouldSelectNode: function (node) { // Defaults to null
					if (!node || (node === ctrl.tree.getSelectedNode())) {
						return false; // Prevent from deselecting the current node
					}
					return true;
				},
				shouldLoadNodes: function (node) {
					return !node.hasChildren() && node.loadOnDemand && ctrl.checkAncestor(node);
				},
				loadNodes: function (parentNode, next) {
					// Loading
					var flashId = parentNode.props.type === 'REFERENCE' ? parentNode.props.fullNode.targetEntityDTO.flashId : parentNode.props.flashId;
					ecmTreeviewService.getTree(flashId, parentNode.state.path, true).then(function (result) {
						next(null, result.children, function () {
							if (!parentNode.clickOpen) {
								var childs = parentNode.getChildren();
								childs.forEach(function (child) { ctrl.toggleNode(child, true); });
								debouncedUpdate();
							}
							parentNode.clickOpen = false;
						});
					});
				},
			});

			ctrl.tree.on('openNode', function (parentNode) {
			});

			ctrl.tree.on('contentDidUpdate', function () {
				if (ctrl.firstLoad) {
					ctrl.firstLoad = false;
					ctrl.refreshTreeSize();
				}
				ctrl.updateCheckboxState(ctrl.tree);
			});

			ctrl.nodeScopes = [];

			ctrl.tree.on('clusterDidChange', function (content) {
				//ctrl.updateCheckboxState(ctrl.tree);

				var treeElement = angular.element(ctrl.tree.contentElement);

				ctrl.nodeScopes.forEach(function (nodeScope) {
					nodeScope.$destroy();
				});
				ctrl.nodeScopes = [];

				var newContent = angular.element(content);
				$scope.$evalAsync(function () {
					newContent.each(function () {
						var currentNode = getNodeFromElement(this);
						var nodeScope = angular.extend($rootScope.$new(), {
							$ctrl: {
								context: ctrl,
								menuOptions: ctrl.menuOptions,
								node: currentNode,
								loadMetadata: function () {
									return ctrl.loadNodeMetadata(currentNode);
								},
								toggleSummary: function (node, $event) {
									if ($event) {
										$event.stopPropagation();
									}
									if (!node.showSummary) {
										ecmTreeviewService.getSummary(node).then(function (summary) {
											node.showSummary = true;
											if (summary) {
												node.summary = summary;
											}
											else {
												node.summary = $filter('translate')('userApp.treeEEEdition.labels.noInsertionSummary');
											}
											ctrl.tree.updateNode(node, node, { shallowRendering: true, updateView: false });
										});
									}
									else {
										node.showSummary = false;
									}
								}
							}
						});
						ctrl.nodeScopes.push(nodeScope);
						$compile(this)(nodeScope);
					});

					treeElement.html(newContent);
				});
			});

			ctrl.tree.on('click', function (event) {
				var currentNode = ctrl.tree.getNodeFromPoint(event.clientX, event.clientY);
				if (!currentNode) {
					return;
				}

				if (event.target.parentElement.classList.contains('infinite-tree-toggler')) {
					currentNode.clickOpen = true;
				}

				if (event.target.className === 'checkbox') {
					event.stopPropagation();
					ctrl.tree.checkNode(currentNode);
					return;
				}
			});

			ctrl.changeSelectedNode = function (node) {
				if (ctrl.nodeSelection) {
					ctrl.nodeSelection({
						nodeSelected: _.cloneDeep(node.props.fullNode)
					});
				}
			};

			ctrl.tree.on('selectNode', function (node) {
				ctrl.changeSelectedNode(node);
				$scope.$apply();
			});

			ecmTreeviewService.getTree(ctrl.flashId, 0).then(function (result) {
				blockUI.stop();
				ctrl.tree.loadData(result.children);
			});

			ctrl.expandListener = $scope.$on('expand_or_collapse_tree', function (event, data) {
				if (data === 'expand') {
					ctrl.expandAll();
				}
				if (data === 'collapse') {
					ctrl.collapseAll();
				}
			});

			// If EE Source hooks external entities
			ctrl.isHooksExternalEntities = ctrl.editorialEntity.editorialEntityTemplate.hooksExternalEntities;

		};

		ecmTreeviewService.isFullPreviewEnabled(ctrl.editorialEntity.editorialEntityTemplate.code)
			.then(function (result) { ctrl.isFullPreviewEnabled = result; });


		$scope.$on('ecm-treeview', function (e, message) {

			switch (message.operation) {
				case 'refreshNode':
					{
						var node = ctrl.tree.getNodeById(message.data);
						if (node) {
							var title = node.name;

							ctrl.refreshNode(node).then(function (newNode) {
								if (newNode.name === title) {
									$timeout(function () {
										ctrl.refreshNode(newNode);
									}, 5000);
								}
							});
						}
					}
					break;

				default:
					break;
			}

		});

		ctrl.$onDestroy = function () {
			if (ctrl.expandListener) {
				ctrl.expandListener();
			}

			ctrl.nodeScopes.forEach(function (nodeScope) {
				nodeScope.$destroy();
			});
			ctrl.nodeScopes = [];
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('ecmTreeviewService', EcmTreeviewService);


	/** @ngInject */
	function EcmTreeviewService(treeV2Resource, EDITORIAL_ELEMENT_TYPE, $q, editMetaDataModalService, CreateAndHookEeWizardModalService, nodeResource, ermService, ENTITY_RESOURCE_TYPE, HTML_PREVIEW_TYPE, htmlPreviewService, htmlPreviewTabService, $log, treeviewNodeService) {
		var deferedQueue = [];
		var maxRequests = 20;
		var runningRequests = 0;

		var service = {
			getTree: getTree,
			editMetadata: editMetadata,
			createAndHook: createAndHook,
			isFullPreviewEnabled: isFullPreviewEnabled,
			getSummary: getSummary,
			openPreviewTab: openPreviewTab,
			deleteHook: deleteHook,
			getMetadata: getMetadata
		};

		return service;

		function mapProps(flashNode, disabled) {
			return {
				flashId: flashNode.flashId,
				// TEMP UNTIL DTO OPTIMIZATION
				fullNode: Object.assign({}, flashNode, { htmlPreview: null }),
				type: flashNode.type,
				relationStatus: flashNode.relationDTO.status,
				disabled: disabled,
				external: flashNode.external
			};
		}

		function getName(flashNode) {
			switch (flashNode.type) {
				case "REFERENCE":
					if (_.isEmpty(flashNode.systemDTO.systemTitle) && _.isEmpty(flashNode.targetEntityDTO.title)) {
						return flashNode.relationDTO.wording;
					} else {
						return _.isEmpty(flashNode.systemDTO.systemTitle) ? flashNode.targetEntityDTO.title : flashNode.systemDTO.systemTitle;
					}

				case "CONTENT":
					return flashNode.systemDTO.systemTitle;
				default:
					{
						var title = '';
						if (flashNode.systemDTO.systemType) {
							title += flashNode.systemDTO.systemType;
						}
						if (flashNode.systemDTO.systemNumber) {
							title = _.isEmpty(title) ? flashNode.systemDTO.systemNumber : title + ' ' + flashNode.systemDTO.systemNumber;
						}

						return _.isEmpty(title) ? flashNode.systemDTO.systemTitle : title + ':' + flashNode.systemDTO.systemTitle;
					}
			}
		}

		function checkLoad(flashNode) {
			return flashNode.type === "REFERENCE" && flashNode.targetEntityDTO.isTree && flashNode.subElementsDTOList.length === 0;
		}

		function mapChildren(flashNode, level, disabled) {
			if (flashNode.type === "REFERENCE" && flashNode.targetEntityDTO && !flashNode.targetEntityDTO.isTree) {
				return [];
			}
			return flashNode.subElementsDTOList.map(function (fNode) { return mapToTreeviewNode(fNode, level + '.0', disabled); });
		}

		function mapToTreeviewNode(flashNode, level, disabled) {
			return {
				id: flashNode.flashId,
				name: getName(flashNode),
				children: mapChildren(flashNode, level, disabled),
				props: mapProps(flashNode, disabled),
				loadOnDemand: checkLoad(flashNode)
			};
		}

		function handleQueue() {
			if (deferedQueue.length > 0 && runningRequests < maxRequests) {
				var q = deferedQueue.shift();
				runningRequests++;
				treeV2Resource.getTree({ id: q.p }).$promise.then(
					function (result) {
						q.d.resolve(result);
						runningRequests--;
						handleQueue();
					},
					function (reason) {
						q.d.reject(reason);
						runningRequests--;
						handleQueue();
					}
				);
			}
		}

		function getTree(flashId, level, disabled) {

			var deferred = $q.defer();
			deferedQueue.push({ d: deferred, p: flashId });

			handleQueue();

			return deferred.promise.then(function (data) {
				if (data) {
					return mapToTreeviewNode(data, level, disabled);
				}
			});
		}

		function editMetadata(node) {
			var isReferenceNode = node.props.type === "REFERENCE";
			var id = isReferenceNode ? node.props.fullNode.relationDTO.flashId : node.props.flashId;
			var type = isReferenceNode ? EDITORIAL_ELEMENT_TYPE.relation : node.props.type;
			return editMetaDataModalService.openEditMetaModalByFlashId(id, type);
		}

		function createAndHook(node, editorialEntity, currentUser) {
			var eeSourceDetails = {
				flashId: editorialEntity.identifier,
				eetCode: editorialEntity.editorialEntityTemplate.code,
				metaInstanceList: editorialEntity.metaInstanceList,
				container: editorialEntity.editorialEntityTemplate.container,
				subNodesId: editorialEntity.subNodesId,
				systemTitle: editorialEntity.titleSystem,
				subElementSystemTitle: node ? node.text : ''
			};
			//
			var subElementDetails = null;
			if (node) {
				subElementDetails = {
					type: node.props.type,
					id: node.props.flashId,
					path: node.props.fullNode.path,
					subNodesId: node.props.fullNode.subNodesFlashIds
				};
			}
			//Launch the wizard
			return CreateAndHookEeWizardModalService.openModal(eeSourceDetails, subElementDetails, currentUser, false, editorialEntity);
		}

		function isFullPreviewEnabled(editorialEntityTemplateCode) {
			return ermService.checkConfigExits(editorialEntityTemplateCode, ENTITY_RESOURCE_TYPE.proofReading)
				.then(function (data) {
					return data.exist === "true" ? true : false;
				}, function (error) {
					$log.error("Error occured whene checking config", error);
					return false;
				});
		}

		function getSummary(node) {
			if (node && node.props.fullNode.targetEntityDTO && node.props.fullNode.targetEntityDTO.flashId && !node.props.external) {
				//get html preview for the  referenced EE.
				return htmlPreviewService.getPreview(node.props.fullNode.targetEntityDTO.flashId, HTML_PREVIEW_TYPE.insertionAbstract)
					.then(function (eePreviewHtml) {
						return eePreviewHtml.htmlPreview;
					});
			} else {
				return $q.resolve();
			}
		}

		function getMetadata(node) {
			if (node) {
				return treeviewNodeService.getMetaInstance(node.props.flashId, node.props.type);
			}
		}

		function openPreviewTab(node) {
			if (node && node.props)
				htmlPreviewTabService.openTabById(node.props.flashId, node.props.type, false, false);
		}

		function deleteHook(node) {
			if (node && node.props.fullNode) {
				var referenceNodeFlashId = node.props.fullNode.flashId;
				return nodeResource.deleteNode({
					id: referenceNodeFlashId,
					deleteChildNodes: false
				}).$promise;
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editStructuralNodeTypeModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/edit-structural-node-type/edit-structural-node-type-modal.html',
			controller: EditStructuralNodeTypeModalComponent,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function EditStructuralNodeTypeModalComponent($translate, editStructuralNodeTypeModalService) {
		var ctrl = this;
		ctrl.$onInit = function () {
			//lang
			ctrl.lang = $translate.use();
			ctrl.confirm = false;
			ctrl.node = ctrl.resolve.node;
			ctrl.nodeTypes = ctrl.resolve.nodeTypes;
			ctrl.type = ctrl.node.text.indexOf(':') !== -1 ? ctrl.node.text.substr(0, ctrl.node.text.indexOf(':')) : '';

		};

		// save
		ctrl.save = function () {
			editStructuralNodeTypeModalService.save(ctrl.node.id, ctrl.type)
				.then(function () {
					ctrl.close({ $value: ctrl.type });
				});
		};

		//cancel
		ctrl.cancel = function () {
			ctrl.dismiss();
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editStructuralNodeTypeModalService', EditStructuralNodeTypeModalService);


	/** @ngInject */
	function EditStructuralNodeTypeModalService(blockUI, $uibModal, MetadataService, SYSTEM_METADATA_IDENTIFIERS, treeviewNodeService) {

		var service = {
			openModal: openModal,
			save: save
		};

		return service;

		function openModal(node, templateCode) {

			var modalInstance = $uibModal.open({
				component: 'editStructuralNodeTypeModal',
				resolve: {
					nodeTypes: function () {
						return treeviewNodeService.getStructuralTypesById(node.id, templateCode)
							.then(function (data) {
								return data;
							});
					},
					node: function () { return node; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}


		function save(flashId, type) {
			return MetadataService.updateSystemMetaValue(SYSTEM_METADATA_IDENTIFIERS.systemType, flashId, 'EDITORIAL_ELEMENT', type)
				.$promise;
		}

	}


})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editNodeTitleModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/edit-node-title-modal/edit-node-title-modal.html',
			controller: EditNodeTitleModalComponent,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function EditNodeTitleModalComponent($translate, editNodeTitleModalService) {
		var ctrl = this;
		ctrl.$onInit = function () {
			//lang
			ctrl.lang = $translate.use();
			ctrl.confirm = false;
			ctrl.node = ctrl.resolve.node;
			ctrl.title = ctrl.deleteHtmlTags(ctrl.node.systemTitle);
			ctrl.loadedTitle = ctrl.title;
		};

		ctrl.confirmAction = function () {
			if (!ctrl.confirm) {
				ctrl.systemTitleMetaData.value = null;
			}
		};

		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};

		ctrl.titleIsRequired = function () {
			return ctrl.node.type != 'REFERENCE' || _.isEmpty(ctrl.loadedTitle);
		}

		// save
		ctrl.save = function () {
			editNodeTitleModalService.save(ctrl.node.id, ctrl.title)
				.then(function (data) {
					ctrl.close({ $value: data });
				});
		};

		//cancel
		ctrl.cancel = function () {
			ctrl.dismiss();
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editNodeTitleModalService', EditNodeTitleModalService);


	/** @ngInject */
	function EditNodeTitleModalService(blockUI, $uibModal, MetadataService, SYSTEM_METADATA_IDENTIFIERS, TinyMceLightModalService) {

		var service = {
			openModal: openModal,
			save: save
		};

		return service;

		function openModal(node) {

			if (node.type === 'CONTENT') {
				return TinyMceLightModalService.openModal(node.text, null, null, true).result
					.then(function (title) {
						return save(node.id, title)
							.then(function (data) {
								return data;
							});
					});
			} else {
				// REF | STRUCTURE
				var modalInstance = $uibModal.open({
					component: 'editNodeTitleModal',
					resolve: {
						node: function () { return node; },
						translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('editorialEntity');
							return $translate.refresh();
						}]
					},
					size: 'lg',
					backdrop: 'static'
				});

				modalInstance.opened.then(function () {
					blockUI.stop();
				});

				return modalInstance.result;
			}

		}

		function save(flashId, title) {
			return MetadataService.updateSystemMetaValue(SYSTEM_METADATA_IDENTIFIERS.systemTitle, flashId, 'EDITORIAL_ELEMENT', title)
				.$promise;
		}

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('nodeBuilderService', NodeBuilderService);


	/** @ngInject */
	function NodeBuilderService(nodeService) {

		var service = {
			nodeToCreate: nodeToCreate,
		};

		return service;

		function nodeToCreate(entity, type, selectedNode, selectedMenuItemId, dataSource, ownerGroup) {
			var path = nodeService.getNodePath(selectedNode, selectedMenuItemId, entity.identifier);
			var parentId = nodeService.getParentId(selectedNode, selectedMenuItemId, entity.identifier);
			var displayOrder = nodeService.getDisplayOrder(selectedNode, selectedMenuItemId, dataSource);
			return {
				parentId: parentId,
				templateCode: entity.editorialEntityTemplate.code,
				type: type,
				path: path,
				displayOrder: displayOrder,
				ownerGroup: ownerGroup
			};
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('nodeEventService', NodeEventService);



	/** @ngInject */
	function NodeEventService($rootScope) {
		var service = {
			requestReloadTree: requestReloadTree,
		};

		return service;

		function requestReloadTree(text, params) {
			$rootScope.$broadcast("reloadTree");
		}

	}

})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('nodeService', NodeService);


	/** @ngInject */
	function NodeService() {

		var service = {
			getParentId: getParentId,
			getNodePath: getNodePath,
			getDisplayOrder: getDisplayOrder
		};

		return service;

		function getParentId(selectedNode, selectedMenuItemId, entityId) {
			var id = 0;
			if (selectedNode) {
				var parent = selectedNode.parentNode();
				if (selectedMenuItemId.startsWith('insert')) {
					//add siblling node
					if (parent) {
						id = parent.id;
					} else {
						id = entityId;
					}

				} else {
					//add child node
					id = selectedNode.id;
				}
			} else {
				//add first level node
				id = entityId;
			}
			return id;
		}

		function getNodePath(selectedNode, selectedMenuItemId, entityId) {
			var parentId = getParentId(selectedNode, selectedMenuItemId, entityId);
			var path = [];
			if (selectedNode) {
				path = selectedNode.path;
				if (path.indexOf(parentId) === -1) {
					path.push(parentId);
				}
			} else {
				//add first level after the last node of the tree.
				path.push(entityId);
			}
			return path;

		}

		function getDisplayOrder(selectedNode, selectedMenuItemId, dataSource) {
			var id = 0;
			if (selectedNode) {
				//
				if (selectedMenuItemId.startsWith('insert')) {
					//add siblling node
					if (selectedMenuItemId.startsWith('insertAfter')) {
						id = selectedNode.displayOrder + 1;
					} else if (selectedMenuItemId.startsWith('insertBefore')) {
						id = selectedNode.displayOrder;
					}
				} else {
					//add child node
					var last = _.last(selectedNode.items);
					id = last ? last.displayOrder + 1 : 1;
				}
			} else if (dataSource.data().length >= 1) {
				//add first level after the last node of the tree.
				var node = dataSource.data()[dataSource.data().length - 1];
				id = node.displayOrder + 1;
			}
			return id;
		}

	}
})();


(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('nodeView', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/node-view/node-view.tpl.html',
			controller: NodeViewController,

			/// 1.API ///
			bindings: {
				node: '<',
				onNodeCheck: '&?',
				onNodeAction: '&?',
				showNodesMetaData: '<?',
				readOnly: '<?',
				showSummary: "=?",
				interPostLink: "=?",
				selectedElement: "=?",
				teeCodes: "=?",
				entityFlashId: "=?",
				pathFilter: "=?"
			}
		});

	/** @ngInject */
	function NodeViewController($log, $sce, MetadataService) {
		var ctrl = this;

		/// 2.OPERATIONS ///
		//Trust html
		ctrl.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};
		//COMPUTE NODE STYLE
		ctrl.nodeStyle = function () {
			var style = {};
			if (ctrl.copiedNode && (ctrl.node.id === ctrl.copiedNode.id) && !ctrl.isCut) {
				style = _.merge({}, style, {
					borderLeft: "solid 3px darkseagreen"
				});
			}
			return style;
		};
		//CHECK IF NODE IS DISABLED TO APPLY STYLE
		ctrl.isDisabledNode = function () {
			var refDisabled = ctrl.node.type === 'REFERENCE' && !ctrl.node.activated;
			var cuttedNode = ctrl.copiedNode && (ctrl.node.id === ctrl.copiedNode.id) && ctrl.isCut;
			return refDisabled || cuttedNode;
		};
		//
		ctrl.isNodeMetaDatasEmpty = function () {
			return _.some(ctrl.node.editorialsMetaData, function (meta) {
				return !MetadataService.isMetaEmpty(meta);
			});
		};
		/// 3.INIT BLOC ///
		ctrl.$onInit = function () {
			ctrl.showNodesMetaData = angular.isDefined(ctrl.showNodesMetaData) ? ctrl.showNodesMetaData : false;
			ctrl.readOnly = angular.isDefined(ctrl.readOnly) ? ctrl.readOnly : false;
		};

		/// 4.HANDLE EXTERNAL CHANGES
		ctrl.$onChanges = function (changesObj) { };

		/// 5.RELEASE RESOURCES ///
		ctrl.$onDestroy = function () { };

		ctrl.showRadioButton = function (node) {
			var found = _.includes(ctrl.teeCodes, node.teeCode);
			return found && (node.targetId !== ctrl.entityFlashId);
		};

		ctrl.elementChosen = function (node) {
			ctrl.selectedElement = node;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('treeviewNodeService', TreeviewNodeService);



	/** @ngInject */
	function TreeviewNodeService($q, nodeResource, userPreferenceService, metadataResource) {
		var deferedQueue = [];
		var maxRequests = userPreferenceService.getUserGlobalPreference('TreeviewGetNodesMaxRequests', 10);
		var runningRequests = 0;

		var service = {
			getNodeWithFirstLevelChildNodes: getNodeWithFirstLevelChildNodes,
			getStructuralTypesById: getStructuralTypesById,
			getMetaInstance: getMetaInstance
		};

		return service;

		function handleQueue() {
			if (deferedQueue.length > 0 && runningRequests < maxRequests) {
				var q = deferedQueue.shift();
				runningRequests++;
				nodeResource.getNodeWithFirstLevelChildNodes(q.p).$promise.then(
					function (result) {
						q.d.resolve(result);
						runningRequests--;
						handleQueue();
					},
					function (reason) {
						q.d.reject(reason);
						runningRequests--;
						handleQueue();
					}
				);
			}
		}

		function getNodeWithFirstLevelChildNodes(params) {
			var deferred = $q.defer();
			deferedQueue.push({ d: deferred, p: params });

			handleQueue();

			return deferred.promise;
		}

		function getStructuralTypesById(flashId, templateCode) {
			return nodeResource.getStructuralTypesById({
				id: flashId,
				templateCode: templateCode
			}).$promise
				.then(function (data) {
					return data;
				});
		}
		function getMetaInstance(flashId, type) {
			return metadataResource.getMetaInstance({
				flashId: flashId,
				type: type
			}).$promise
				.then(function (data) {
					return data;
				});
		}


	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('treeViewService', TreeViewService);


	/** @ngInject */
	function TreeViewService(blockUI, treeViewResource) {
		var service = {
			sort: sort,
			afterEdit: afterEdit,
			createNode: createNode
		};

		return service;

		function sort(entityId) {
			blockUI.start();
			return treeViewResource.sort({ flashId: entityId }).$promise
				.then(function () {
					blockUI.stop();

				});
		}

		function afterEdit(entityId) {
			blockUI.start();
			return treeViewResource.afterEdit({
				flashId: entityId
			}).$promise.then(function (data) {
				blockUI.stop();
				return data.result;
			});

		}

		function createNode(nodeToCreate) {
			return treeViewResource.createNode(nodeToCreate).$promise;
		}

	}

})();










(function () {
	'use strict';

	// Usage:
	// <tree-flat-view></tree-flat-view>
	// Creates:
	// 

	angular
		.module('userApp')
		.component('treeFlatView', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/tree-flat-view/tree-flat-view.html',
			controller: TreeFlatViewController,
			bindings: {
				editorialEntity: "=",
				treeFlatViewConfig: '<',
				isMetadataEnabled: '<',
				currentUser: '=',
				eEpermissions: '='
			},
		});

	/** @ngInject */
	/* eslint-disable indent */
	function TreeFlatViewController(entityLinkingResource, entityAuthorizeService, $sce, $state, $uibModal, blockUI, moment, $rootScope, editMetaDataModalService,
		relationTemplateResource, PUBLICATION_STATUS, htmlPreviewService, userPreferenceService, HTML_PREVIEW_TYPE, MetadataService, flatViewService, EDITORIAL_ELEMENT_TYPE) {
		/* eslint-enable */
		var ctrl = this;
		//init stuff
		ctrl.$onInit = function () {
			ctrl.lang = $rootScope.currentLang;
			ctrl.PUBLICATION_STATUS = PUBLICATION_STATUS;

			//Global variables
			ctrl.moment = moment;
			ctrl.tableId = 'flatview_' + ctrl.editorialEntity.editorialEntityTemplate.identifier;
			ctrl.selectedEe = [];
			ctrl.selectedRelationsIds = [];
			//Get flatview settings								
			//Columns config				
			ctrl.columnsList = ctrl.treeFlatViewConfig.columnsList;
			ctrl.columnNames = _.concat(flatViewService.getColumnsNames(ctrl.columnsList));
			ctrl.currentUserId = ctrl.treeFlatViewConfig.currentUserId;
			ctrl.parameterizedFilters = ctrl.treeFlatViewConfig.parameterizedFilters;
			ctrl.publicationFilterValue = ctrl.treeFlatViewConfig.publicationFilter;

			// Localized format for date + time
			ctrl.dateFormatForColumn = function (column) {
				switch (column.value) {
					case 'systemLastUpdateDate':
						// case 'any other... ':
						return 'short';
				}
			};

			// Pagination settings
			ctrl.paginationPreferenceStorageKey = ctrl.tableId;
			// Pagination infos
			ctrl.pagination = flatViewService.buildPaginationDTO();
			// Search settings
			ctrl.searchLinkedEEsDTO = flatViewService.buildSearchLinkedEesDTO(ctrl.editorialEntity.identifier, ctrl.editorialEntity.system.systemTee, ctrl.tableId);

			// Load the first page
			ctrl.searchLinkedEEsDTO.columnsList = ctrl.columnNames;

			// Listen to event entity metadata changed 
			ctrl.metadataEntityChangedHandler = $rootScope.$on('refresh_entity', function () {
				ctrl.getEEHtmlPreviewAfterEdit();
			});

		};

		//Listen to event permissions
		var unregisterPermissionsChanged = $rootScope.$on('permissions_changed', function (event, eEpermissions) {
			ctrl.isMetadataEnabled = entityAuthorizeService.isMetadataEnabled(eEpermissions);
		});

		ctrl.$onDestroy = function () {
			unregisterPermissionsChanged();
		};


		//
		//check wether the current tree is a container
		ctrl.isContainer = function () {
			return ctrl.editorialEntity.editorialEntityTemplate.container;
		};

		//
		//load linked ees list
		ctrl.loadEEList = function (searchLinkedEEsDTO) {
			var resultsBlockUI = blockUI.instances.get('resultsDiv');
			resultsBlockUI.start();
			entityLinkingResource.searchHookedEEs(searchLinkedEEsDTO).$promise.then(function (results) {
				resultsBlockUI.stop();
				ctrl.results = results;
			}, function () {
				resultsBlockUI.stop();
			});
		};

		ctrl.getMetaValue = function (meta) {
			return MetadataService.getMetaValues(meta);
		};

		//
		ctrl.formatSystemTitle = function (systemTitle) {
			return flatViewService.formatSystemTitle(systemTitle);
		};

		ctrl.isMetaEmpty = function (meta) {
			return MetadataService.isMetaEmpty(meta);
		};
		ctrl.buildSearchFilters = function () {
			ctrl.selectedEE = null;
			ctrl.searchLinkedEEsDTO.filters = flatViewService.buildSearchFilters(ctrl.publicationFilterValue, ctrl.parameterizedFilters);
		};
		//load a page
		ctrl.pageChanged = function () {
			//init search params
			blockUI.start();
			ctrl.buildSearchFilters();
			ctrl.searchLinkedEEsDTO.currentPage = (ctrl.pagination.currentPage === 0 ? 0 : ctrl.pagination.currentPage - 1);
			ctrl.searchLinkedEEsDTO.itemByPage = ctrl.pagination.itemByPage;
			ctrl.loadEEList(ctrl.searchLinkedEEsDTO);
			blockUI.stop();
		};

		// Filters
		ctrl.doFilter = function () {
			ctrl.buildSearchFilters();
			//Default displayed page
			ctrl.pagination.currentPage = 0;
			ctrl.searchLinkedEEsDTO.currentPage = 0;
			ctrl.loadEEList(ctrl.searchLinkedEEsDTO);
		};
		ctrl.doFilterDirectlyFromSelect = function () {
			if (ctrl.isContainer() && !ctrl.existsParametrizedFilters()) {
				ctrl.doFilter();
			}
		};
		ctrl.resetFilters = function () {
			flatViewService.emptyParameterizedFilters(ctrl.parameterizedFilters);
			ctrl.publicationFilterValue = ctrl.treeFlatViewConfig.publicationFilter;
			ctrl.doFilter();
		};

		ctrl.loadTable = function (tableState) {
			//get sort info
			ctrl.searchLinkedEEsDTO.sortField = null;
			ctrl.searchLinkedEEsDTO.sortDirection = null;
			//
			var sort = tableState.sort;
			if (angular.isDefined(sort.predicate)) {
				ctrl.searchLinkedEEsDTO.sortField = sort.predicate;
				var reverse = angular.isUndefined(sort.reverse) || Boolean(sort.reverse);
				ctrl.searchLinkedEEsDTO.sortDirection = reverse ? 'DESC' : 'ASC';
			}
			ctrl.doFilter();
		};
		//
		ctrl.navigateToEE = function (ee) {
			if (ee && ee.relationStatus !== "BROKEN") {
				$state.go('editorialEntity', {
					id: ee.identifier
				});
			}
		};
		//
		ctrl.isEESelected = function (ee) {
			return ee && ctrl.selectedEE && ee.relation.flashId === ctrl.selectedEE.relation.flashId;
		};

		//Get EE html preview
		ctrl.getEEHtmlPreview = function (ee) {
			ctrl.relationShip = {};
			ctrl.selectedEE = ee;
			if (ee && ee.relationStatus !== "BROKEN") {
				relationTemplateResource.getRelationshipTemplateByCode({
					rtCode: ctrl.selectedEE.relation.trCode
				}).$promise.then(function (data) {
					ctrl.relationShip = data;
					//load of ee html preview
					if (ctrl.selectedEE && !ctrl.selectedEE.htmlPreview) {
						var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');
						htmlPreviewService.getPreview(ctrl.selectedEE.identifier, HTML_PREVIEW_TYPE.complete, false, EDITORIAL_ELEMENT_TYPE.entity, contextProductCode)
							.then(function (eePreviewHtml) {
								ctrl.selectedEE.htmlPreview = eePreviewHtml.htmlPreview;
							});
					}
				});
			}
		};
		// REFRESH AND GET THE NEW HTML PREVIEW AFTER EDIT FROM METADATA MODAL
		ctrl.getEEHtmlPreviewAfterEdit = function () {
			// SCREENSHOT OF SELECTED EE 
			var selectedEE = ctrl.selectedEE;
			// INIT FILTER AND TABLE
			ctrl.pageChanged();
			var newEE = ctrl.results.hookedEEsList.find(function (ee) {
				return selectedEE && ee.identifier === selectedEE.identifier && ee.relation.flashId === selectedEE.relation.flashId;
			});
			// REBUILD THE NEW HTML PREVIEW 
			ctrl.getEEHtmlPreview(newEE);
		};
		//
		ctrl.sidebarClosed = function () {
			ctrl.selectedEE = null;
		};
		//
		ctrl.trustAsHtml = function (string) {//alert('string -> '+string);
			return $sce.trustAsHtml(string);
		};

		ctrl.openEditMetaModal = function (entity) {
			editMetaDataModalService.openEditEntityMetaModal(entity.identifier, undefined, undefined, false).then(function (selectedItem) {
				ctrl.selectedEE = entity;
				ctrl.updatePreview(entity.identifier, 'COMPLETE');
				ctrl.pageChanged();
			});
		};

		ctrl.isMetaRelation = function (column, refEE) {
			return refEE.relation.metaInstanceDTOList.some(function (meta) {
				return meta.metaDataDTO.code === column.value;
			});
		};

		ctrl.relationMetaQuickEdit = function (entity, event) {

			var checkPermission = !ctrl.isMetadataEnabled;
			editMetaDataModalService.openEditMetaModalByFlashId(entity.relation.flashId, EDITORIAL_ELEMENT_TYPE.relation, ctrl.editorialEntity.identifier, checkPermission, undefined, undefined, undefined, ctrl.isContainer())
				.then(function (response) {
					ctrl.pageChanged();
				});

			if (angular.isDefined(event)) event.stopPropagation();
		};

		ctrl.openEditor = function (flashId) {
			$state.go("editorialEntityEdit", {
				id: flashId
			});
		};
		/**
			* see description in #EditDesiredPulbicationDateController  in file treeview.directive.js  .
			*/
		ctrl.desiredPublicationDateUpdatedHandler = $rootScope.$on('desiredPublicationDateUpdated', function (event, date) {

			if (angular.isDefined(ctrl.selectRelation)) {
				ctrl.selectRelation.desiredPublicationDate = date;
				ctrl.editorialEntity.updateDate = new Date();
			}

		});

		ctrl.editDesiredPublicationDate = function (relation) {
			ctrl.selectRelation = relation;
			$uibModal.open({
				templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/editDesiredPublicationDateModal.tpl.html',
				controller: 'EditDesiredPulbicationDateController',
				controllerAs: 'EditPublDateCtrl',
				resolve: {
					selectedNode: function () {
						return {
							"relationId": relation.flashId,
							"desiredPublicationDate": relation.desiredPublicationDate
						};
					}
				},
				size: 'lg',
				backdrop: 'static'
			});
		};

		ctrl.updatePreview = function (flashId, typePreview) {
			htmlPreviewService.updatePreview(flashId, typePreview)
				.then(function (result) {
					if (result) {
						ctrl.newHtmlPreview = result;
						if (ctrl.selectedEE) {
							ctrl.selectedEE.htmlPreview = ctrl.newHtmlPreview.htmlPreview;
						}
					}
				});
		};

		//This event is received when the publishing has been done successfully
		ctrl.publishSuccessHandler = $rootScope.$on('publish_success', function () {
			ctrl.doFilter();
		});
		//
		ctrl.existsParametrizedFilters = function () {
			return _.size(ctrl.parameterizedFilters) > 0;
		};

		// Get the FLASH IDs of the selected EEs' referenceNodes
		ctrl.getSelectedReferenceNodesIds = function () {
			ctrl.selectedRelationsIds.length = 0;
			if (angular.isDefined(ctrl.selectedEe) && ctrl.selectedEe !== null) {
				var selectedEEs = _.keys(_.pickBy(ctrl.selectedEe), true);
				if (angular.isDefined(ctrl.results) && selectedEEs.length >= 1) {
					ctrl.results.hookedEEsList.forEach(function (ee) {
						if (selectedEEs.indexOf(ee.identifier) !== -1) {
							ctrl.selectedRelationsIds.push(ee.referenceNodeFlashId);
						}
					});
				}
				return ctrl.selectedRelationsIds;
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('flatViewService', FlatViewService);



	/** @ngInject */
	function FlatViewService($filter, $sce, userPreferenceService, USER_PREFERENCE, blockUI, flatViewSettingsResource, TREE_FLAT_VIEW) {
		var service = {
			formatSystemTitle: formatSystemTitle,
			getColumnsNames: getColumnsNames,
			buildSearchLinkedEesDTO: buildSearchLinkedEesDTO,
			buildPaginationDTO: buildPaginationDTO,
			getFlatViewConfig: getFlatViewConfig,
			buildSearchFilters: buildSearchFilters,
			emptyParameterizedFilters: emptyParameterizedFilters
		};
		return service;
		// 
		function buildSearchFilters(publicationFilterValue, parameterizedFilters) {
			var filters = {};
			//
			if (_.size(publicationFilterValue)) {
				filters[TREE_FLAT_VIEW.PUBLICATION_FILTER_NAME] = publicationFilterValue;
			}

			//Add dynamic parametrized filters
			_.forEach(parameterizedFilters, function (filter) {
				var value;
				//MONO
				if (filter.value && filter.value !== null) {
					value = filter.value;
				}
				//REF
				else if (!_.isEmpty(filter.referentialTypeListDTOList)) {
					value = [];
					_.forEach(filter.referentialTypeListDTOList, function (refValue) {
						if (refValue && refValue !== null) {
							value.push(refValue.refValueId);
						}
					});
				}
				else if (!_.isEmpty(filter.referentialValueDTOList)) {
					value = [];
					_.forEach(filter.referentialValueDTOList, function (refValue) {
						if (refValue && refValue !== null) {
							value.push(refValue);
						}
					});
				}
				//MULTI
				else if (!_.isEmpty(filter.multiValuesList)) {
					value = [];
					_.forEach(filter.multiValuesList, function (mValue) {
						if (mValue && mValue !== null) {
							value.push(mValue.text);
						}
					});
				}

				//SET FILTER VALUE
				if ((value && value !== null && value !== "false" && !_.isArray(value)) || (_.isArray(value) && !_.isEmpty(value))) {
					filters[filter.metaDataDTO.code] = value;
				}
			});
			return filters;
		}

		function emptyParameterizedFilters(parameterizedFilters) {
			_.forEach(parameterizedFilters, function (filter) {
				if (filter.value && filter.value !== null) { filter.value = null; }
				else if (!_.isEmpty(filter.referentialTypeListDTOList)) { filter.referentialTypeListDTOList = []; }
				else if (!_.isEmpty(filter.referentialValueDTOList)) { filter.referentialValueDTOList = []; }
				else if (!_.isEmpty(filter.multiValuesList)) { filter.multiValuesList = []; }
			});
		}

		//
		function getFlatViewConfig(eeFlashId) {
			return flatViewSettingsResource.getFlatViewConfig({ eeFlashId: eeFlashId }).$promise;
		}
		//
		function buildPaginationDTO() {
			return {
				//Default page size
				itemByPage: userPreferenceService.getUserPaginationPreference(USER_PREFERENCE.pagination.views.treeFlatView),
				//Default initial page
				currentPage: 0
			};
		}
		function buildSearchLinkedEesDTO(eeFlashId, eetCode, tableId) {
			return {
				currentPage: 0,
				itemByPage: userPreferenceService.getUserPaginationPreference(tableId ? tableId : USER_PREFERENCE.pagination.views.treeFlatView),
				eeFlashId: eeFlashId,
				eetCode: eetCode,
				filters: {},
				columnsList: []
			};
		}
		//
		function deleteHtmlTags(html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		}
		//
		function formatSystemTitle(systemTitle) {
			//FIXME ng-html-bind dont remove div tag on : 
			//<div xmlns="http://www.w3.org/1999/xhtml">Corpus</div>
			//<div xmlns="http://www.w3.org/1999/xhtml">Sociétés</div>
			if (systemTitle === null || systemTitle.length === 0) {
				systemTitle = $filter('translate')('userApp.eeLinkInfos.labels.noEETitle');
			}
			//
			return $sce.trustAsHtml(deleteHtmlTags(systemTitle));
		}

		//
		function getColumnsNames(columnsList) {
			var columns = [];
			angular.forEach(columnsList, function (column) {
				columns.push(column.value);
			});
			return columns;
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('treeViewActions', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view-actions/tree-view-actions.component.html',
			controller: TreeViewActionsController,
			bindings: {
				onShowMetaData: '&',
				isEmpty: '=?',
				isHooksExternalEntities: '<'
			}
		});

	/** @ngInject */
	function TreeViewActionsController($rootScope) {
		var ctrl = this;


		////////////////
		ctrl.showOverloadedView = false;

		ctrl.$onInit = function () { };
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		ctrl.collapseAll = function () {
			//Send event to scope itsefl and its children
			$rootScope.$broadcast("expand_or_collapse_tree", 'collapse');
		};

		ctrl.expandAll = function () {
			//Send event to scope itsefl and its children

			$rootScope.$broadcast("expand_or_collapse_tree", 'expand');
		};

		ctrl.switchOverloadedPreview = function () {
			ctrl.showOverloadedView = !ctrl.showOverloadedView;
			$rootScope.$emit('overload_preview_switched', ctrl.showOverloadedView);
		};

		ctrl.toggleMetaData = function () {
			ctrl.showMetaData = !ctrl.showMetaData;
			if (ctrl.onShowMetaData) {
				ctrl.onShowMetaData({
					show: ctrl.showMetaData
				});
			}
		};
	}
})();

(function () {
	'use strict';

	// Usage:
	// TEMP WRAPPER UNTIL WE HAVE ONE TREE
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('treeViewWrapper', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view-wrapper/tree-view-wrapper.tpl.html',
			controller: TreeViewWrapperController,
			controllerAs: '$ctrl',
			bindings: {
				mode: '<?',
				editorialEntity: '<',
				treeViewInstance: '<',
				isShowNodesMetaData: '<',
				editMetadataEnabled: '<',
				editContentEnabled: '<',
				currentUser: '<',
				showOverloadedView: '<',
				onNodeSelection: '&?'
			},
		});

	/** @ngInject */
	function TreeViewWrapperController($stateParams, htmlPreviewService, HTML_PREVIEW_TYPE, $filter, EDITORIAL_ELEMENT_TYPE,userPreferenceService, $rootScope, blockUI) {
		var $ctrl = this;

		////////////////

		$ctrl.$onInit = function () {
			$ctrl.tree = {};
			$ctrl.currentNode;

			if (!$ctrl.mode) {
				$ctrl.mode = 'NORMAL';
			}
		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };

		//handle overlaod and normal preview
		$ctrl.overloadeEvent = $rootScope.$on('overload_preview_switched', function (event, overloadedPreview) {
			$ctrl.showOverloadedView = overloadedPreview;
			$ctrl.nodeSelection($ctrl.currentNode);
		});

		//TEMP model transformation to allow treeviewV1 to work 
		$ctrl.convertV2Node = function convert(node) {
			if ($ctrl.mode === 'V2' && !node.id) {
				return {
					id: node.flashId,
					type: node.type,
					refNodeId: node.targetEntityDTO ? node.targetEntityDTO.flashId : undefined,
					relationId: node.relationDTO ? node.relationDTO.flashId : undefined,
					relationStatus: node.relationDTO ? node.relationDTO.status : undefined,
					external: node.external
				};
			}

			return node;
		};

		$ctrl.nodeSelection = function (nodeSelected) {
			$ctrl.currentNode = $ctrl.convertV2Node(nodeSelected);

			if ($ctrl.onNodeSelection) {
				$ctrl.loadPreview($ctrl.currentNode);
				$ctrl.onNodeSelection({
					nodeSelected: $ctrl.currentNode
				});
			}

		};

		function getOverloadPreview(nodeSelected) {
			if (nodeSelected.relationStatus === 'BROKEN') {
				nodeSelected.htmlPreview = $filter('translate')('userApp.editorialEntity.msg.contentEditorialEntityUnavailable');
			} else {
				htmlPreviewService.getOverloadPreview(nodeSelected.id, nodeSelected.type).then(function (htmlPreview) {
					nodeSelected.htmlPreview = htmlPreview;
				});
			}
		}

		$ctrl.loadPreview = function (nodeSelected) {
			if (nodeSelected && (nodeSelected.type === 'CONTENT' || nodeSelected.type === 'REFERENCE')) {

				if ($ctrl.showOverloadedView) {
					getOverloadPreview(nodeSelected);
				} else {
					if (nodeSelected.type === 'REFERENCE') {
						//reference node 
						if (nodeSelected.external) {
							nodeSelected.htmlPreview = '<div class="ecm-previ-alert">' + $filter('translate')('userApp.editorialEntity.msg.externalContent') + '</div>';
						} else {
							if ((nodeSelected.relationStatus !== 'BROKEN') && nodeSelected.refNodeId) {
								var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');	
								htmlPreviewService.getPreview(nodeSelected.refNodeId, HTML_PREVIEW_TYPE.complete, false, EDITORIAL_ELEMENT_TYPE.entity, contextProductCode)
									.then(function (eePreviewHtml) {
										nodeSelected.htmlPreview = eePreviewHtml.htmlPreview;

									});
							} else {
								//No html preview to display : invalid link.
								nodeSelected.htmlPreview = $filter('translate')('userApp.editorialEntity.msg.contentEditorialEntityUnavailable');
							}
						}
					} else {
						//Content node				
						htmlPreviewService.getPreview(nodeSelected.id, HTML_PREVIEW_TYPE.restricted, false, EDITORIAL_ELEMENT_TYPE.content)
							.then(function (eePreviewHtml) {
								nodeSelected.htmlPreview = eePreviewHtml.htmlPreview;
							});
					}

				}

			}
		};

	}
})();

(function () {
	'use strict';


	angular.module('userApp').controller(
		'treeEEEditionController', EditEntityTreeController);

	/** @ngInject */
	function EditEntityTreeController(htmlPreviewTabService, entityFetchResource, treeViewService, entityLockService, htmlPreviewService, $scope, $sce, ermService, ENTITY_RESOURCE_TYPE, $filter, $state, $window, entity, nodeResource, $rootScope, editMetaDataModalService, blockUI, currentUser, $log, EditorialEntityService, confirmModalService, HTML_PREVIEW_TYPE, EDITORIAL_ELEMENT_TYPE, $stateParams, eEpermissions, userPreferenceService, $timeout) {
		var vm = this;
		//Edition mode
		vm.editionMode = $state.params.editionMode;
		//lang
		vm.lang = $rootScope.currentLang;
		vm.resize = true;
		//Tree ee
		vm.editorialEntity = entity;
		//
		vm.currentUser = currentUser;
		//
		vm.treeViewInstance = null;
		//
		vm.externalActionAccessor = {};
		vm.showDeletedNodes = false;

		// Get option from session
		vm.hideEmptyStructuralNodesMap = userPreferenceService.getUserTreeViewPreference('hideEmptyStructuralNodes', {});
		vm.hideEmptyStructuralNodes = vm.hideEmptyStructuralNodesMap[vm.editorialEntity.editorialEntityTemplate.code] ? vm.hideEmptyStructuralNodesMap[vm.editorialEntity.editorialEntityTemplate.code] : false;

		vm.eEpermissions = eEpermissions;

		// If EE Source hooks external entities
		vm.isHooksExternalEntities = vm.editorialEntity.editorialEntityTemplate.hooksExternalEntities;

		function activate() {
			// Lock Entity if it's not already locked
			if (!vm.editorialEntity.locked) {
				entityLockService.lock(vm.editorialEntity.identifier)
					.then(function () {
						vm.editorialEntity.locked = true;
					});
			}
			ermService.checkConfigExits(vm.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.reorderTree)
				.then(function (data) {
					vm.orderTreePermitted = data.exist === "true";
				});
		}

		activate();

		function formatSystemTitle() {
			var maxCar = 150;
			var tooltipTitle = vm.editorialEntity.titleSystem;
			if (tooltipTitle && tooltipTitle.length > maxCar) {
				var posCut = tooltipTitle.indexOf(" ", maxCar);
				vm.titleSystemasHTML = tooltipTitle.substring(0, posCut) + "<BR/>" + tooltipTitle.substring(posCut, tooltipTitle.length);
				vm.titleSystemasHTML = $sce.trustAsHtml(vm.titleSystemasHTML);
			} else {
				vm.titleSystemasHTML = $sce.trustAsHtml(vm.editorialEntity.titleSystem);
			}
		}
		//
		// Formattage du titre pour le ToolTip.
		formatSystemTitle();
		//
		vm.contententDisplay = {
			rightMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedRigthMargin'),
			leftMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedLeftMargin'),
		};
		// Mouse Down Dragbar
		vm.mdDragBar = function (e) {
			$window.angular.element(document).on('mousemove', vm.onResize);
		};

		vm.toggleDeletedNodes = function () {
			vm.showDeletedNodes = !vm.showDeletedNodes;
			vm.showDeletedNodes ? vm.doAction('showDeletedNodes') : vm.doAction('hideDeletedNodes');
		};

		vm.toggleEmptyStructuralNodes = function () {
			vm.hideEmptyStructuralNodes = !vm.hideEmptyStructuralNodes;
			//Persist option in session
			vm.hideEmptyStructuralNodesMap[vm.editorialEntity.editorialEntityTemplate.code] = vm.hideEmptyStructuralNodes;
			userPreferenceService.setUserTreeViewPreference('hideEmptyStructuralNodes', vm.hideEmptyStructuralNodesMap);
			vm.hideEmptyStructuralNodes ? vm.doAction('hideEmptyStructuralNodes') : vm.doAction('showEmptyStructuralNodes');
		};

		vm.switchOverloadedView = function () {
			vm.showOverloadedView = !vm.showOverloadedView;
			if (vm.nodeSelected) {
				vm.loadPreview(vm.nodeSelected);
				vm.refresh();
			}
		};

		function getOverloadPreview(nodeSelected) {
			if (nodeSelected.relationStatus === 'BROKEN') {
				nodeSelected.htmlPreview = $filter('translate')('userApp.editorialEntity.msg.contentEditorialEntityUnavailable');
			} else {
				if (!nodeSelected.deleted) {
					htmlPreviewService.getOverloadPreview(nodeSelected.id, nodeSelected.type).then(function (htmlPreview) {
						nodeSelected.htmlPreview = htmlPreview;
					});
				}
			}
		}

		vm.loadPreview = function (nodeSelected) {
			if (nodeSelected.type === 'CONTENT' || nodeSelected.type === 'REFERENCE') {

				if (vm.showOverloadedView) {
					getOverloadPreview(nodeSelected);
				} else {
					if (nodeSelected.type === 'REFERENCE') {
						//reference node 
						if (nodeSelected.external) {
							nodeSelected.htmlPreview = '<div class="ecm-previ-alert">' + $filter('translate')('userApp.editorialEntity.msg.externalContent') + '</div>';
						} else {
							if ((nodeSelected.relationStatus !== 'BROKEN') && nodeSelected.refNodeId) {
								var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');
								htmlPreviewService.getPreview(nodeSelected.refNodeId, HTML_PREVIEW_TYPE.complete, false, EDITORIAL_ELEMENT_TYPE.entity, contextProductCode)
									.then(function (eePreviewHtml) {
										nodeSelected.htmlPreview = eePreviewHtml.htmlPreview;

									});
							} else {
								//No html preview to display : invalid link.
								nodeSelected.htmlPreview = $filter('translate')('userApp.editorialEntity.msg.contentEditorialEntityUnavailable');
							}
						}
					} else {
						//Content node				
						if (!nodeSelected.deleted) {
							htmlPreviewService.getPreview(nodeSelected.id, HTML_PREVIEW_TYPE.restricted, false, EDITORIAL_ELEMENT_TYPE.content)
								.then(function (eePreviewHtml) {
									nodeSelected.htmlPreview = eePreviewHtml.htmlPreview;
								});
						}
					}

				}

			}
		};

		// handle tree view node selection
		vm.onNodeSelection = function (node, $event) {
			if (typeof $event !== typeof undefined) {
				$event.stopPropagation();
			}
			vm.loadPreview(node);
			vm.resize = true;
			vm.nodeSelected = node;
		};

		vm.updatePreview = function () {
			var flashId = vm.nodeSelected.refNodeId;
			var typePreview = 'COMPLETE';
			var service = htmlPreviewService.updatePreview(flashId, typePreview);
			if (vm.showOverloadedView) {
				flashId = vm.nodeSelected.id;
				service = htmlPreviewService.getOverloadPreview(flashId, 'REFERENCE', false);
			}
			service.then(function (result) {
				if (result) {
					vm.newHtmlPreview = result;
					vm.nodeSelected.htmlPreview = vm.showOverloadedView ? result : result.htmlPreview;
				}
			});
		};

		var refreshPreviewEventHandler = $scope.$on('refresh_preview', function (event, data) {
			vm.refresh();
		});

		var refreshOverloadedPreviewEventHandler = $scope.$on('refresh_overloaded_preview', function (event, data) {
			if (vm.showOverloadedView) {
				htmlPreviewService.getOverloadPreview(vm.nodeSelected.id, 'REFERENCE', false)
					.then(function (result) {
						if (result) {
							vm.newHtmlPreview = result;
							vm.nodeSelected.htmlPreview = result;
						}
					});
			}
		});

		vm.refresh = function () {
			var currentNode = vm.nodeSelected;
			if (currentNode) {
				vm.nodeSelected = undefined;
				$timeout(function () { vm.onNodeSelection(currentNode); });
			}
			vm.doAction('refresh');
		};

		vm.openPreview = function () {
			blockUI.start();
			entityFetchResource.getByFlashId({
				flashId: vm.editorialEntity.identifier
			}).$promise
				.then(function (entity) {
					blockUI.stop();
					htmlPreviewTabService.openAuthorizedTab(vm.editorialEntity.identifier, undefined, entity.editorialEntityTemplate.code, false);
				});
		};

		vm.openEditMetaModal = function (entity) {
			editMetaDataModalService.openEditMetaModalByFlashId(entity.refNodeId, EDITORIAL_ELEMENT_TYPE.entity, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).then(function (selectedItem) {
				vm.nodeSelected = entity;
				vm.updatePreview(entity.refNodeId, 'COMPLETE');
				vm.doAction('refresh');
			});
		};

		vm.openEditor = function (flashId) {
			$state.go("editorialEntityEdit", {
				id: flashId
			});
		};

		//
		//show nodes metadata
		vm.showNodesMetaData = false;
		vm.isShowNodesMetaData = function () {
			return vm.showNodesMetaData;
		};
		//	
		$window.angular.element(document).on('mouseup', function () {
			$window.angular.element(document).off('mousemove', vm.onResize);
		});
		//
		vm.doAction = function (action) {
			if (vm.externalActionAccessor) {
				vm.externalActionAccessor.callAction(action);
			}
		};
		//
		vm.onResize = function (e) {
			e.preventDefault();
			var winWidth = angular.element(window).width();
			var moveX = winWidth - e.pageX - 20;
			if (moveX > vm.contententDisplay.leftMargin) {
				moveX = vm.leftMargin;
			}

			if (moveX < vm.contententDisplay.rightMargin) {
				moveX = vm.rightMargin;
			}
			angular.element('#idDivContenu').css({
				'flex-basis': moveX
			});
		};
		//
		vm.closePreview = function () {
			vm.resize = false;
		};
		//expand all nodes
		vm.expandAll = function () {
			// collapse all items
			vm.doAction('expandAllNodes');
		};
		//collapse all nodes
		vm.collapseAll = function () {
			// collapse all items
			vm.doAction('collapseAllNodes');
		};
		//close the web page
		vm.close = function () {
			blockUI.start();
			//Execute a post save + sort order on ee update
			treeViewService.afterEdit(vm.editorialEntity.identifier)
				.then(function () {
					vm.redirect();
				}).finally(function () {
					blockUI.stop();
				});
		};
		//
		vm.redirect = function () {
			//Redirect
			if ($stateParams.returnToEE || !$rootScope.previousStateName || _.startsWith($rootScope.previousStateName, "editorialEntityEdit")) {
				$state.go('editorialEntity', {
					id: vm.editorialEntity.identifier
				});
			} else {
				$state.go($rootScope.previousStateName, $rootScope.previousStateNameParams);
			}
		};
		//
		vm.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};
		//
		vm.isDefinedGroupName = function (groupName) {
			//FIXME : group by filter on ng-repeat  generate an 'undefiend' strings.
			return angular.isDefined(groupName);
		};
		//
		vm.openNodeEditMetaModal = function (groupName) {

			editMetaDataModalService.openEditMetaModalByFlashId(vm.nodeSelected.id, vm.nodeSelected.type).then(function (response) {
				if (response) {
					vm.nodeSelected.metaInstanceDTOList = response.metadataInstances;
					$scope.$broadcast("tree_node_editorials_metadata_updated", vm.nodeSelected);
				}
			});
		};

		// CHECK PERMISSION FOR CURRENT USER
		vm.hasNoPermission = function (permision) {
			return angular.isDefined(vm.eEpermissions) && vm.eEpermissions.indexOf(permision) === -1;
		};

		vm.isPermitted = function (action) {
			if (action === "order") {
				return vm.orderTreePermitted;
			}
			return true;
		};

		$scope.$on('$destroy', function() {
			refreshPreviewEventHandler();
			refreshOverloadedPreviewEventHandler();
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('metaDataMedia', {
			templateUrl: 'scripts/pre-upgrade/components/metadata-instance/components/meta-data-media/meta-data-media.html',
			controller: MetaDataMediaController,
			bindings: {
				metaDataInstance: '<',
				readonly: '<',
				display: '<'
			}
		});

	/** @ngInject */
	function MetaDataMediaController(metaMediaService, $window, $scope) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.type = ctrl.metaDataInstance.metaDataDTO.metaDataType.toLowerCase();
			// Pattern to validate Extensions allowed for type MEDIA
			ctrl.mediaFieldPattern = ctrl.metaDataInstance.metaDataDTO.mediaFieldPattern;

			ctrl.maxSize = ctrl.metaDataInstance.metaDataDTO.maxSize;
			// needed to update old meta data 
			ctrl.metaDataInstance.originalListmediaFile = angular.copy(ctrl.metaDataInstance.listMediaFiles);
			// array displayed
			ctrl.filesArray = ctrl.metaDataInstance.listMediaFiles || [];
		};

		ctrl.$onChanges = function (changes) {
			if (!ctrl.metaDataInstance.temporraryListFile) {
				ctrl.metaDataInstance.temporraryListFile = [];
			}
		};


		// Method Upload Files
		ctrl.uploadMultiFiles = function (files) {
			ctrl.files = files;
			ctrl.errorFiles = [];
			if (files && files.length > 0 && ctrl.type === 'media') {
				var validFiles = [];
				var errorFiles = [];

				_.forEach(files, function (f) {
					if (f.$error) {
						errorFiles.push(f);
					} else {
						validFiles.push(f);
					}
				});
				ctrl.errorFiles = errorFiles;

				if (validFiles.length > 0) {
					if (ctrl.metaDataInstance.multipleOccurrences) {
						validFiles.forEach(function (file) {
							ctrl.metaDataInstance.temporraryListFile.push(file);
						});

						ctrl.metaDataInstance.listMediaFiles.push.apply(ctrl.metaDataInstance.listMediaFiles, validFiles);
					} else {
						ctrl.metaDataInstance.temporraryListFile = validFiles;
						ctrl.metaDataInstance.listMediaFiles = [];
						ctrl.metaDataInstance.listMediaFiles = validFiles;
					}

				}
				metaMediaService.setUpDisplayOrder(ctrl.metaDataInstance.listMediaFiles);
			}


		};



		ctrl.displayMediaExtension = function (extensions) {
			if (extensions) {
				return extensions.split(';').join('; ');
			}
		};


		// Method Remove Files
		ctrl.removeMedia = function (fileId, key) {
			if (angular.isDefined(fileId)) {
				if (ctrl.metaDataInstance.listMediaFiles !== null) {
					for (var file in ctrl.metaDataInstance.listMediaFiles) {
						if (ctrl.metaDataInstance.listMediaFiles[file].idMedia === fileId) {

							ctrl.metaDataInstance.listMediaFiles.splice(file, 1);
							break;
						}
					}

				}
			} else {
				if (ctrl.metaDataInstance.temporraryListFile !== null) {
					for (var temp in ctrl.metaDataInstance.temporraryListFile) {
						if (ctrl.metaDataInstance.temporraryListFile[temp].$$hashKey === key) { //eslint-disable-line
							ctrl.metaDataInstance.temporraryListFile.splice(temp, 1);
							break;
						}
					}

					for (var md in ctrl.metaDataInstance.listMediaFiles) {
						if (ctrl.metaDataInstance.listMediaFiles[md].$$hashKey === key) {//eslint-disable-line
							ctrl.metaDataInstance.listMediaFiles.splice(md, 1);
							break;
						}
					}


				}
			}

		};

		ctrl.displayMedia = function (fileId) {
			$window.open('api/media/displayMedia/' + fileId);
		};

		// if Dragula drop-model event fired on a media-meta-bag: update displayOrder attribute
		$scope.$on('$destroy', $scope.$on('media-meta-bag.drop-model', function (e, el) {
			if (ctrl.metaDataInstance.listMediaFiles) {
				metaMediaService.setUpDisplayOrder(ctrl.metaDataInstance.listMediaFiles);
			}
		}));
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('metaMediaService', MetaMediaService);


	/** @ngInject */
	function MetaMediaService(Upload, blockUI, $q) {
		var service = {
			createMetaDataMedia: createMetaDataMedia,
			editMetaMediaByGroup: editMetaMediaByGroup,
			setUpDisplayOrder: setUpDisplayOrder
		};

		return service;

		// function upload media when create entity
		function createMetaDataMedia(metaInstanceList) {
			blockUI.start();
			var mediaFilePromises = [];
			if (metaInstanceList !== null && metaInstanceList.length > 0) {
				for (var i = 0, len = metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA" && angular.isDefined(metaInstanceDto.temporraryListFile) && metaInstanceDto.temporraryListFile.length > 0) {
						metaInstanceDto.temporraryListFile = _.cloneDeep(mappedFileObject(metaInstanceDto.temporraryListFile));
						mediaFilePromises.push(uploadMediaFile(metaInstanceDto));
					}
				}
			}
			blockUI.stop();
			// return all promises
			return $q.all(mediaFilePromises);
		}


		// Upload media
		function uploadMediaFile(metaInstanceDto) {
			return Upload.upload({
				url: 'api/media/uploadFiles',
				data: {
					files: metaInstanceDto.temporraryListFile
				}
			}).then(function (response) {
				blockUI.stop();
				//remove temporary files from media list
				metaInstanceDto.listMediaFiles = _.filter(metaInstanceDto.listMediaFiles, function (m) {
					return !(m instanceof File);
				});
				//add uploaded media file to media list
				metaInstanceDto.listMediaFiles.push.apply(metaInstanceDto.listMediaFiles, response.data);
			});
		}


		//adding custumName and display order information to the file
		function mappedFileObject(temporraryListFile) {
			var tempList = [];
			// filter array to save only files of type file		
			temporraryListFile.forEach(function (file) {
				if (file instanceof File) {
					tempList.push({ file: file, customFileName: file.customFileName, displayOrder: file.displayOrder });
				}
			});
			return tempList;
		}



		// function upload media when edit  entity
		function editMetaMediaByGroup(metaInstanceListByGroup) {
			blockUI.start();
			var metaInstanceList = [];
			var deferred = $q.defer();
			deferred.resolve([]);

			// returned the list of meta data to embed in the group list 
			_.forEach(metaInstanceListByGroup, function (value) {
				Array.prototype.push.apply(metaInstanceList, value.metaDataInstanceDTOList);
			});

			if (metaInstanceList.length > 0) {
				for (var i = 0, len = metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA" && angular.isDefined(metaInstanceDto.temporraryListFile) && metaInstanceDto.temporraryListFile.length > 0) {
						metaInstanceDto.temporraryListFile = mappedFileObject(metaInstanceDto.temporraryListFile);
						if (metaInstanceDto.temporraryListFile.length > 0) {
							return Upload.upload({
								url: 'api/media/uploadFiles',
								data: {
									files: metaInstanceDto.temporraryListFile
								}
							}).then(function (response) {
								blockUI.stop();
								metaInstanceDto.listMediaFiles = _.filter(metaInstanceDto.listMediaFiles, function (o) {
									return !(o instanceof File);
								});
								metaInstanceDto.listMediaFiles.push.apply(metaInstanceDto.listMediaFiles, response.data);
								//sort with display order
								metaInstanceDto.listMediaFiles.sort(function (a, b) {
									return a.displayOrder - b.displayOrder;
								});

							});

						}
						// return empty promise
						blockUI.stop();
						return deferred.promise;
					}
				}
			}
			// return empty promise
			blockUI.stop();
			return deferred.promise;
		}

		// Set up displayOrder attribute, displayOrder = index of files in the given liste
		function setUpDisplayOrder(files) {
			if (files) {
				_.forEach(files, function (file, index) {
					file.displayOrder = index;
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('metaDataReferential', {
			templateUrl: 'scripts/pre-upgrade/components/metadata-instance/components/meta-data-referential/meta-data-referential.html',
			controller: MetaDataReferentialController,
			bindings: {
				metaDataInstance: '<',
				readonly: '<',
				display: '<',
				lang: '<',
				filter: '<?',
				eeSourceFlashId: '<?'
			},
		});

	/** @ngInject */
	function MetaDataReferentialController($rootScope, $scope, blockUI, metaDataReferentielService, $uibModal, $log, $filter, $timeout) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.currentPage = -1;
			ctrl.itemsPerPage = 50;
			ctrl.refId = ctrl.metaDataInstance.metaDataDTO.refid;
			ctrl.linkedRefId = ctrl.metaDataInstance.metaDataDTO.linkedRefid;
			if (angular.isDefined(ctrl.metaDataInstance.metaDataDTO.referential)) {
				ctrl.refType = ctrl.metaDataInstance.metaDataDTO.referential.type;
			}

			ctrl.referentialValueList = [];

			ctrl.referentialValueDisplay = [];

			ctrl.referentialValueIDs = [];

			if (ctrl.metaDataInstance.listDisplayPathForNode) {
				ctrl.referentialValueDisplay = ctrl.metaDataInstance.listDisplayPathForNode;
			}

			ctrl.referentialValueDTOList = _.cloneDeep(ctrl.metaDataInstance.referentialValueDTOList) || [];

			//UPDATE LINKED VALUES ON MESSAGE
			$scope.$on('$destroy', $scope.$on('referential_changed', function (event, message) {
				if (ctrl.linkedRefId === message.refId) {
					$log.info(ctrl.linkedRefId + " has been changed, update values of " + ctrl.refId + " is needed");
					//DO NOTHING IF SAME PARENT VALUE IS SELECTED
					if (!_.isEmpty(ctrl.referentialValueIDs) && _.isEqual(ctrl.referentialValueIDs, message.refValueIds)) {
						return;
					}
					//GET REF VALUE IDs TO BE USED IN LINKED META SEARCH ctrl.searchRef()
					ctrl.referentialValueIDs = message.refValueIds;
					ctrl.isLinked = true;

					//CLEAR
					if (message.refValueIds && message.event !== 'INIT') {
						ctrl.referentialValueList = [];
						ctrl.metaDataInstance.referentialTypeListDTOList = [];
					}

					//ON INIT LINKED META VALUES ARE LOADED WITH ctrl.searchRef() FUNCTION
					if (!_.isEmpty(message.refValueIds) && message.event !== 'INIT') {
						//GET LINKED VALUES
						return metaDataReferentielService.getLinkedValues(ctrl.refId, ctrl.linkedRefId, message.refValueIds, ctrl.filter, ctrl.metaDataInstance.metaDataDTO.code)
							.then(function (refList) {
								ctrl.referentialValueList = refList;
							});
					}
				}
			}));

		};
		ctrl.$onChanges = function () {
			if (ctrl.metaDataInstance) {

				ctrl.refId = ctrl.metaDataInstance.metaDataDTO.refid;
				ctrl.linkedRefId = ctrl.metaDataInstance.metaDataDTO.linkedRefid;
				if (angular.isDefined(ctrl.metaDataInstance.metaDataDTO.referential)) {
					ctrl.refType = ctrl.metaDataInstance.metaDataDTO.referential.type;
				}
			}
		};
		ctrl.searchFilter = function ($select) {
			if (ctrl.lang === "fr") {
				return { labelFR: $select.search };
			}
			return { labelEN: $select.search };
		};

		ctrl.startsWith = function (actual, expected) {
			var lowerStr = (actual + "").toLowerCase();
			return lowerStr.indexOf(expected.toLowerCase()) === 0;
		};

		ctrl.getLabel = function (metaDataOption) {
			if (ctrl.lang === "fr") {
				return metaDataOption.labelFR;
			}
			return metaDataOption.labelEN;
		};

		ctrl.highlightText = function (meta, term) {
			var label = ctrl.lang === 'fr' ? meta.labelFR : meta.labelEN;
			if (!_.isEmpty(term)) {
				var first = ctrl.metaDataInstance.metaDataDTO.searchType && ctrl.metaDataInstance.metaDataDTO.searchType === 'STARTSWITH';
				return $filter('highlightFirst')(label, term, first);
			}
			return label;
		};

		ctrl.filterMetaValues = function (actual, expected) {
			if (!_.isEmpty(expected) && !_.isEmpty(actual)) {
				if (ctrl.metaDataInstance.metaDataDTO.searchType && ctrl.metaDataInstance.metaDataDTO.searchType === 'STARTSWITH') {
					return actual.toLowerCase().indexOf(expected.toLowerCase()) === 0;
				}
				return actual.toLowerCase().contains(expected.toLowerCase());
			}
			return true;
		};

		ctrl.openTreeModal = function () {
			ctrl.modalInstance = $uibModal.open({
				templateUrl: 'scripts/components/util/metadata/repository/modalTree.html',
				controller: 'ModalTreeRepositoryController',
				resolve: {
					metaDataInstance: function () {
						return ctrl.metaDataInstance;
					},
					referentialValueDisplay: function () {
						return ctrl.referentialValueDisplay;
					},
					multiple: function () {
						return ctrl.metaDataInstance.multipleOccurrences;
					},
					tree: function () {
						if (ctrl.isLinked) {
							return ctrl.referentialValueList;
						}
						return metaDataReferentielService.getReferentialById(ctrl.refId, ctrl.filter, ctrl.metaDataInstance.metaDataDTO.code);
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editMetaData');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			ctrl.modalInstance.result.then(function (selectedItem) {
				ctrl.metaDataInstance.referentialValueDTOList = selectedItem.referentialValueDTOList;
				ctrl.referentialValueDisplay = selectedItem.referentialValueDisplay;
				ctrl.metaDataInstance.listDisplayPathForNode = selectedItem.referentialValueDisplay;

			});
		};

		ctrl.updatelinkedRefs = function (event) {
			//DONT NEED TO BROADCAST EVENT IF THE CHANCHING META IS LINKED
			if (ctrl.isLinked) {
				return;
			}
			//BUILD MESSAGE + SEND
			var message = { refId: ctrl.refId, refValueIds: ctrl.getReferentialValueIDs(), event: event ? event : 'UPDATE' };
			$log.info(message);
			$rootScope.$broadcast("referential_changed", message);
		};

		ctrl.getReferentialValueIDs = function () {
			var refValueIds = [];
			var refTypeList = ctrl.metaDataInstance.referentialTypeListDTOList;

			//BUILD REFVALUE IDS
			if (ctrl.isSelectOne() && _.get(refTypeList[0], "refValueId")) {
				refValueIds.push(refTypeList[0].refValueId);
			} else if (ctrl.isSelectMulti()) {
				refValueIds = _.map(refTypeList, 'refValueId');
			}
			return refValueIds;
		};

		ctrl.isSelectOne = function () {
			return ctrl.isList() && !ctrl.metaDataInstance.multipleOccurrences;
		};

		ctrl.isSelectMulti = function () {
			return ctrl.isList() && ctrl.metaDataInstance.multipleOccurrences;
		};

		ctrl.isTree = function () {
			return ctrl.refType === 'TREE';
		};

		ctrl.isList = function () {
			return ctrl.refType === 'LIST';
		};

		ctrl.refreshResults = function ($select) {
			return metaDataReferentielService.getReferentialById(ctrl.refId, ctrl.filter, ctrl.metaDataInstance.metaDataDTO.code)
				.then(function (refList) {
					$select.items = refList;
					return refList;
				});
		};

		ctrl.initLinkedCall = function () {
			// INIT CALL TO OTHERS META IN THE SAME WINDOW
			ctrl.updatelinkedRefs('INIT');
		};

		function broadCastUISelectDataReady() {
			$timeout(function () {
				$scope.$broadcast("UISelect_Data_Ready");
			});
		}

		// CALL THIS FUNCTION TO GET NEXT PAGE OF UI SELECT LIST
		ctrl.fetch = function ($select) {
			if (ctrl.isLinked) {
				//NOTHING TO DO, DATA IS ALREADY LOADED BY referential_changed EVENT
				return;
			}
			if (!ctrl.allowFetch) {
				broadCastUISelectDataReady();
				return;
			}
			ctrl.currentPage++;
			if (ctrl.currentPage >= 0) {
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.refId, ctrl.filter, $select.search, ctrl.metaDataInstance.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						if (refList.length === 0) {
							ctrl.allowFetch = false;
							broadCastUISelectDataReady();
							return;
						}
						if (ctrl.currentPage === 0) {
							ctrl.referentialValueList = refList;
						} else {
							ctrl.referentialValueList = ctrl.referentialValueList.concat(refList);
						}
						broadCastUISelectDataReady();
					});
			}
		};

		// SEARCH REFERENTIAL BY INPUT TEXT AND GET FIRST PAGE
		ctrl.searchRef = function ($select) {
			if (ctrl.isLinked) {
				if (!_.isEmpty(ctrl.referentialValueIDs)) {
					//GET LINKED VALUES (FOR LINKED META WE DONT NEED TO GET VALUES BY PAGE)
					return metaDataReferentielService.getLinkedValues(ctrl.refId, ctrl.linkedRefId, ctrl.referentialValueIDs, ctrl.filter, ctrl.metaDataInstance.metaDataDTO.code, $select.search)
						.then(function (refList) {
							ctrl.referentialValueList = refList;
						});
				}
				return;
			}
			ctrl.allowFetch = true;
			if (ctrl.currentPage !== -1) {
				if (!$select.search) {
					ctrl.referentialValueList = [];
				}
				ctrl.currentPage = 0;
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.refId, ctrl.filter, $select.search, ctrl.metaDataInstance.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						ctrl.referentialValueList = refList;
						broadCastUISelectDataReady();
					});
			}
		};

		// INITIALIZE UI ON OPEN/CLOSE EVENT
		ctrl.initializeSelect = function ($select, isOpen) {
			if (ctrl.isLinked) {
				//NOTHING TO DO, DATA IS ALREADY LOADED BY referential_changed EVENT
				return;
			}
			if (isOpen) {
				ctrl.allowFetch = true;
				ctrl.currentPage = 0;
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.refId, ctrl.filter, $select.search, ctrl.metaDataInstance.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						ctrl.referentialValueList = refList;
					});
			} else {
				ctrl.referentialValueList = [];
			}
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('metaDataUrl', {
			templateUrl: 'scripts/pre-upgrade/components/metadata-instance/components/meta-data-url/meta-data-url.html',
			controller: MetaDataUrlController,
			bindings: {
				metaDataInstance: '<',
				readonly: '<',
				display: '<',
			},
		});

	/** @ngInject */
	function MetaDataUrlController(urlService, infoModalService, $window) {
		var ctrl = this;

		ctrl.$onInit = function () {
			if (ctrl.metaDataInstance.urlDTOList && ctrl.metaDataInstance.urlDTOList.length === 0) {
				ctrl.metaDataInstance.urlDTOList = [];
				ctrl.metaDataInstance.urlDTOList.push({ label: null, value: null });
			}
			ctrl.isLastMetaURL = ctrl.metaDataInstance.urlDTOList && ctrl.metaDataInstance.urlDTOList.length === 1;
			//Normalize URL
			if (ctrl.readonly && ctrl.metaDataInstance.urlDTOList && ctrl.metaDataInstance.urlDTOList.length !== 0) {
				ctrl.metaDataInstance.urlDTOList.forEach(function (url) {
					if (url.value) {
						url.value = ctrl.normalizeURL(url.value);
					}
				});
			}
		};

		ctrl.addNewURL = function () {
			ctrl.metaDataInstance.urlDTOList.push({ label: null, value: null });
			ctrl.isLastMetaURL = ctrl.metaDataInstance.urlDTOList.length === 1;
		};

		ctrl.removeURL = function (url) {
			if (ctrl.isLastMetaURL) {
				ctrl.metaDataInstance.urlDTOList[0].label = "";
				ctrl.metaDataInstance.urlDTOList[0].value = "";
			} else {
				ctrl.metaDataInstance.urlDTOList.splice(ctrl.metaDataInstance.urlDTOList.indexOf(url), 1);
			}
			ctrl.isLastMetaURL = ctrl.metaDataInstance.urlDTOList.length === 1;

		};

		ctrl.disableRemoveButton = function () {
			return ctrl.metaDataInstance.urlDTOList.length === 1 && !(ctrl.metaDataInstance.urlDTOList[0].label || ctrl.metaDataInstance.urlDTOList[0].value);
		};

		ctrl.checkConnection = function (url) {
			var link = url.value;
			if (link) {
				urlService.checkConnection(link).then(function (status) {
					url.checkConnection = status;
					if (!status) {
						infoModalService.openModal("error.invalidURL.message", "error.invalidURL.title");
					}
				});
			} else {
				delete url['checkConnection'];
			}
		};

		ctrl.checkAllURLValue = function (urlList) {
			if (urlList && urlList.length > 0) {
				for (var i = 0; i < urlList.length; i++) {
					if (!urlList[i].value) {
						return false;
					}
				}
				return true;
			}
		};

		ctrl.openURL = function (url) {
			var link = url.value;
			if (link) {
				link = ctrl.normalizeURL(link);
				$window.open(link, '_blank');
			}
		};

		ctrl.normalizeURL = function (url) {
			if (!url.contains('://')) {
				url = 'http://' + url;
			}
			return url;
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('urlService', URLService);


	/** @ngInject */
	function URLService(urlResource, blockUI) {
		var service = {
			checkConnection: checkConnection
		};

		return service;

		function checkConnection(url) {
			blockUI.start();
			return urlResource.checkConnection({url: url}).$promise
				.then(function (data) {
					blockUI.stop();
					return data.body === "true";
				});
		}
	}

})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('instanceHealth', {
			templateUrl: 'scripts/pre-upgrade/components/monitoring/app-health/instance-health/instance-health.html',
			controller: InstanceHealthController,
			bindings: {
				instance: '<'
			},
		});

	/** @ngInject */
	function InstanceHealthController() {
		var $ctrl = this;
		////////////////

		$ctrl.$onInit = function () { };
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrContainerList', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-container/search-container-list/search-container-list.component.html',
			controller: SearchSolrContainerListController,
			bindings: {
				searchSolr: "=",
				resultat: "=",
				editTirInModal: "=",
				eeSelected: "=",
				selectedEe: "=",
				pagination: "=",
				getData: "&",
				navigateToEe: "&",
				getEeSelected: "&",
				eeTargetChosen: "&?",
				showFacet: "&?",
				onSelectRowChange: "&?",
				onSelectAllChange: "&?",
				multiSelect: "<"
			},
		});

	/** @ngInject */
	function SearchSolrContainerListController($log, $stateParams, $sce, $filter, SYSTEM_METADATA_IDENTIFIERS, validateEntityService, infoModalService, OpenNewTabService, ColumnValueService) {
		var ctrl = this;

		ctrl.SystemTileMetaName = 'HTML_MULTI_SYSTEMTITLE';

		ctrl.$onInit = function () {
			ctrl.tableTirId = 'tableTIR_' + $stateParams.identifier;
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.pageChanged = function () {
			ctrl.getData();

		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};

		ctrl.loadResultList = function (tableState) {
			var sorting = tableState.sort;
			if (sorting.predicate) {
				var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
				ctrl.searchSolr.pagination.sortDirection = reverse ? 'desc' : 'asc';
				ctrl.searchSolr.pagination.sortPredicate = sorting.predicate;
				ctrl.searchSolr.sortByScore = false;
			}
			else {
				ctrl.searchSolr.pagination.sortDirection = 'desc';
				ctrl.searchSolr.pagination.sortPredicate = undefined;
			}
			ctrl.getData();
		};

		ctrl.htmlPreview = function (data) {
			ctrl.getEeSelected({
				idEE: data['FLASH_ID'],
				editEnabled: data['editEnabled'],
				isLocked: data['isLocked'],
				entityTemplateCode: data['EE_DOC_TYPE']
			});
		};

		ctrl.chooseEE = function (data) {

			validateEntityService.checkIfExist(data['FLASH_ID']).then(function (result) {
				ctrl.getEeSelected({
					idEE: data['FLASH_ID'],
					editEnabled: data['editEnabled'],
					isLocked: data['isLocked'],
					entityTemplateCode: data['EE_DOC_TYPE']
				});
				if (angular.isDefined(ctrl.eeTargetChosen)) {
					ctrl.eeTargetChosen({
						eeTarget: data['FLASH_ID']
					});
				}
			});
		};

		//TEMP waiting for spring data solr update
		ctrl.searchText = function (data) {
			return ctrl.searchSolr.searchFullTextDTO.searchFullText;
		};

		ctrl.getColumnValue = function (column, colValue) {
			return ColumnValueService.getColumnValue(column, colValue);
		};

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrContainerPlan', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-container/search-container-plan/search-container-plan.component.html',
			controller: searchSolrContainerPlanController,
			bindings: {
				searchSolr: "=",
				resultat: "=",
				navigateToEe: "&",
				getEeSelected: "&",
				selectedEe: "="
			},
		});

	/** @ngInject */
	function searchSolrContainerPlanController(blockUI, solrResource, $sce,OpenNewTabService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.selectedEE = [];
			ctrl.showDetails = false;
		};


		ctrl.getSubLevel = function (resultPlan) {
			//.listParams, resultPlan.levelToGet
			blockUI.start();
			var searchSubLevelPlanDTO = {};
			searchSubLevelPlanDTO.searchSolrDTO = ctrl.searchSolr;
			searchSubLevelPlanDTO.listParams = resultPlan.listParams;
			searchSubLevelPlanDTO.level = resultPlan.levelToGet;

			solrResource.getSubLevelClassification(searchSubLevelPlanDTO).$promise.then(
				function (data) {
					resultPlan.listResultat = data.listResultat;
					resultPlan.children = data.children;
					blockUI.stop();
				},
				function () {
					blockUI.stop();
				}
			);
		};

		ctrl.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('RetreiveDataService', RetreiveDataService);


	/** @ngInject */
	function RetreiveDataService(RetreiveDataResource) {
		var service = {
			readFromJson: readFromJson,
		};

		return service;

		function readFromJson() {
			return RetreiveDataResource.readJson().$promise;
		}

	}
})();

(function () {
	'use strict';

	angular.module('userApp').factory('RetreiveDataResource', RetreiveDataResource);

	/** @ngInject */
	function RetreiveDataResource($resource) {
		return $resource('scripts/pre-upgrade/components/searchv2/search-container/search-container-list/data.json', {}, {
			'readJson': {
				method: 'GET',
				transformResponse: function (data) {
					return  angular.fromJson(data);
				
				}
			}
		});
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchContainerList', {
			templateUrl: 'scripts/pre-upgrade/components/searchv2/search-container/search-container-list/search-container-list.component.html',
			controller: SearchContainerListController,
			bindings: {
				pagination: "=", // default init value { itemByPage: 50 , totalCount: 0 , currentPage: 1 }
				showFacet: "&?",
				metaHtmlTitle:"<"
			},
		});

	/** @ngInject */
	function SearchContainerListController(blockUI, RetreiveDataService, $log, $stateParams, $sce, $filter, SYSTEM_METADATA_IDENTIFIERS, validateEntityService, infoModalService, OpenNewTabService, ColumnValueService) {

		var ctrl = this;
		ctrl.metaHtmlTitle = "META_HTML_TITLE";
		ctrl.$onInit = function () {
			ctrl.dataTableConfig = {};
			ctrl.dataTableConfig.META_HTML_TITLE = ctrl.metaHtmlTitle;
			ctrl.pagination = { itemByPage: 50 , totalCount: 0 , currentPage: 1 };
			ctrl.getSearchData();
			ctrl.tableTirId = 'tableTIR_' + $stateParams.identifier;
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.pageChanged = function () {
			ctrl.getSearchData();

		};
		ctrl.loadResultList = function (tableState) {
			ctrl.getSearchData();
		};

		ctrl.getColumnValue = function (column, colValue) {
			return ColumnValueService.getColumnValue(column, colValue);
		};
		ctrl.getSearchData = function () {
			blockUI.start();
			RetreiveDataService.readFromJson().then(function (result) {
				ctrl.searchDto = result;
				blockUI.stop();
			});

		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('searchFacetOption', {
			templateUrl: 'scripts/pre-upgrade/components/searchv2/search-facet/search-facet-option/search-facet-option.html',
			controller: SearchFacetOptionController,
			bindings: {
				facet: "<",
				facetOption: "=",
				facetMapValues: "=", // Used for collapse facet values
				parentFacetOption: "<?",
				onFacetChanged: '&?' // Fire event change facet
			},
		});

	/** @ngInject */
	function SearchFacetOptionController(SearchFacetService) {
		var ctrl = this;

		// Check whether the facet value is collapsed
		ctrl.isCollapsed = function (facetIdentifier, facetValue) {
			if (!ctrl.facetMapValues[facetIdentifier]) {
				ctrl.facetMapValues[facetIdentifier] = {};
			}
			return !ctrl.facetMapValues[facetIdentifier][facetValue];
		};

		// Toggle Facet Value (show/hide)
		ctrl.toggleCollapse = function (facetCode, facetValue) {
			var collapsed = ctrl.facetMapValues[facetCode][facetValue];
			ctrl.facetMapValues[facetCode][facetValue] = !collapsed;
		};

		// Toggle facet value and its children (Check/uncheck)
		ctrl.toggleCheck = function (facetOption, parentFacetOption) {
			if (facetOption.children.length > 0) {
				SearchFacetService.updateChildrenValues(facetOption);
			} else {
				if (parentFacetOption) {
					parentFacetOption.checked = false;
				}
			}
			ctrl.facetChanged();
		};

		// Change facet event
		ctrl.facetChanged = function () {
			if (ctrl.onFacetChanged) {
				ctrl.onFacetChanged();
			}
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('archiveEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/archive-entity-modal/archive-entity-modal.html',
			controller: ArchiveEntityModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ArchiveEntityModalController($state, entityOperationResource, $filter, modalService, blockUI, ModalAlertService) {
		var ctrl = this;

		ctrl.$onInit = function () {		
			ctrl.eeSourceList = ctrl.resolve.eeSourceList;
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		/**
		 * Archive an editorial entity
		 */
		ctrl.archiveEditorialEntity = function () {
			blockUI.start();
			if (ctrl.eeSourceList > 0) {
				ModalAlertService.error($filter('translate')('userApp.archiveEditorialEntity.home.error'));
				blockUI.stop();
			} else {
				entityOperationResource.archiveEE(ctrl.resolve.editorialEntity).$promise.then(function (data) {
					return data;
				}).then(function (ee) {
					ctrl.close();
					blockUI.stop();
                    //Display success message
					ModalAlertService.success("'" + $filter('translate')('userApp.archiveEditorialEntity.home.success') + "'", $filter('translate')('userApp.archiveEditorialEntity.home.archivePerformed'), '');
                    //Go to the home page
					$state.go('home');
				});
			}
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('multiArchiveEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/multi-archive-entity-modal/multi-archive-entity-modal.html',
			controller: MultiArchiveEntityModal,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function MultiArchiveEntityModal($state, entityOperationResource, $filter, modalService, blockUI, ModalAlertService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.modalOptions = {
				isConfirm: false,
				closeButtonText: $filter('translate')('userApp.editorialEntity.action.cancel'),
				actionButtonText: $filter('translate')('userApp.editorialEntity.action.confirm'),
				headerText: $filter('translate')('userApp.editorialEntity.header.alert'),
				bodyText: 'bodyText'
			};

			ctrl.allowedEntitiesToBeArchived = ctrl.resolve.allowedEntitiesToBeArchived;
			ctrl.entitiesLinkedToSource = ctrl.resolve.entitiesLinkedToSource;
			ctrl.isAnyEntityToArchive = ctrl.resolve.isAnyEntityToArchive;
			ctrl.eeTargetListNotToArchive = ctrl.resolve.eeTargetListNotToArchive;
			ctrl.allowedEntityIdsToBeArchived = ctrl.resolve.allowedEntityIdsToBeArchived;
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		/**
		 * Archive editorial entities
		 */
		ctrl.archiveEditorialEntities = function () {

			if (ctrl.allowedEntitiesToBeArchived.length > 0) {
				blockUI.start();
				entityOperationResource.archiveEditorialEntities(ctrl.allowedEntityIdsToBeArchived).$promise.then(function (data) {
					return data;
				}).then(function (data) {
					blockUI.stop();
					ctrl.close({
						$value: data
					});
                    //Display success message
					ModalAlertService.success("'" + $filter('translate')('userApp.archiveEditorialEntity.home.success') + "'", $filter('translate')('userApp.archiveEditorialEntity.home.archivePerformed'), '');
                    //Refresh the current page
					$state.reload();
				}).catch(function (error) {
					blockUI.stop();
					ctrl.modalOptions.bodyText = $filter('translate')('userApp.editorialEntity.msg.ERROR_TECH') + error.data.error;
					modalService.showModal({}, ctrl.modalOptions);
				});
			} else {
				//No entity to archive.
				ctrl.close();
			}
		};



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('multiDeleteEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/multi-delete-entity-modal/multi-delete-entity-modal.html',
			controller: MultiDeleteEntityModal,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function MultiDeleteEntityModal($state, deleteEntityService, $filter, modalService, blockUI, ModalAlertService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.modalOptions = {
				isConfirm: false,
				closeButtonText: $filter('translate')('userApp.editorialEntity.action.cancel'),
				actionButtonText: $filter('translate')('userApp.editorialEntity.action.confirm'),
				headerText: $filter('translate')('userApp.editorialEntity.header.alert'),
				bodyText: 'bodyText'
			};

			ctrl.flashIds = ctrl.resolve.flashIds;
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		/**
		 * Archive editorial entities
		 */
		ctrl.deleteEntityMulti = function () {
			blockUI.start();
			deleteEntityService.deleteEntityMulti(ctrl.flashIds).then(function (data) {
				return data;
			}).then(function (data) {
				blockUI.stop();
				ctrl.close();
                    //Display success message
				ModalAlertService.success("'" + $filter('translate')('userApp.archiveEditorialEntity.home.success') + "'", $filter('translate')('userApp.archiveEditorialEntity.home.archivePerformed'), '');
                    //Refresh the current page
				$state.reload();
			}).catch(function (error) {
				blockUI.stop();
				ctrl.modalOptions.bodyText = $filter('translate')('userApp.editorialEntity.msg.ERROR_TECH') + error.data.error;
				modalService.showModal({}, ctrl.modalOptions);
			});
		};



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('convertModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-modal/convert-modal.html',
			controller: ConvertModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});
	/** @ngInject */
	function ConvertModalController(editProductsService, entityConvertResource, blockUI) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;
			ctrl.currentTemplate = ctrl.editorialEntity.editorialEntityTemplate.wording;
			ctrl.flashId = ctrl.editorialEntity.identifier;
			ctrl.associationFlashId = ctrl.resolve.associationFlashId;
			ctrl.createNewEntity = ctrl.resolve.createNewEntity;
			ctrl.convertibleTemplatesList = [];
			initConvertibleTemplates(ctrl.editorialEntity.editorialEntityTemplate.code, ctrl.createNewEntity);
		};

		/**
		 * Cancel the conversion
		 */
		ctrl.cancel = function () {
			ctrl.dismiss({ $value: false });
		};

		ctrl.excutePostConversionTasks = function () {
			ctrl.deleteConversionProposal();
			ctrl.deletePublishedXml();
		};

		function initConvertibleTemplates(templateCode, createNewEntity) {
			blockUI.start();
			entityConvertResource.getConvertibleTemplates({ teeCode: templateCode, createNewEntity: createNewEntity }).$promise.then(function (data) {
				ctrl.convertibleTemplatesList = data;
			});
			blockUI.stop();
		}

		/**
		 * SIETRAINMQ-607
		 * Delete proposal of conversion
		 */
		ctrl.deleteConversionProposal = function () {
			if (ctrl.associationFlashId) {
				editProductsService.applyAction(ctrl.associationFlashId, ctrl.flashId, 'DECLINE');
			}
		};

		/**
		 * SIETRAINMQ-717
		 * Delete XML published on initial template
		 */
		ctrl.deletePublishedXml = function () {
			if (!ctrl.createNewEntity) {
				entityConvertResource.deletePublishedXml({flashId: ctrl.flashId, sourceEetCode: ctrl.editorialEntity.editorialEntityTemplate.code});
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('convertModalService', ConvertModalService);


	/** @ngInject */
	function ConvertModalService(blockUI, $uibModal, entityConvertResource, entityFetchResource) {
		var service = {
			openModal: openModal,
			getConvertibleTemplates: getConvertibleTemplates,
			checkEnablingOfConvert: checkEnablingOfConvert
		};

		return service;
    /**
		 * 
		 * @param {*} code 
		 */
		function getConvertibleTemplates(code, createNewEntity) {
			return entityConvertResource.getConvertibleTemplates({ teeCode: code, createNewEntity: createNewEntity }).$promise;
		}

		/**
		 * 
		 * @param {*} flashId : Source entity flashId
		 * @param {*} associationFlashId (Optional): FlashId of the proposal of conversion (SIETRAINMQ-607)  
		 */
		function openModal(flashId, associationFlashId, createNewEntity) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'convertModal',
				windowClass: "sidebar-open editor-zindex",
				resolve: {
					editorialEntity: function () {
						return entityFetchResource.getByFlashId({ flashId: flashId }).$promise;
					},
					associationFlashId: function () { return associationFlashId; },
					createNewEntity: function () { return createNewEntity;},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editMetaData');
						$translatePartialLoader.addPart('datepicker');
						$translatePartialLoader.addPart('global');
						$translatePartialLoader.addPart('product');
						$translatePartialLoader.addPart('editor');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}
    /**
		 * 
		 * @param {*} editorialEntity 
		 * @param {*} convertibleTemplates 
		 */
		function checkEnablingOfConvert(editorialEntity, convertibleTemplates) {
			if (!editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus || _.isEmpty(convertibleTemplates) || !checkHasPersmission(convertibleTemplates)) {
				return true;
			} else {
				return false;
			}
		}
    /**
		 * 
		 * @param {*} convertibleTemplates 
		 */
		function checkHasPersmission(convertibleTemplates) {
			var authorizedConvertibleTee = _.filter(convertibleTemplates, function (t) {
				return t.authorized === true;
			});
			return !_.isEmpty(authorizedConvertibleTee);
		}

	}
})();


/* eslint-disable indent */
(function () {
	'use strict';

	angular
		.module('userApp')
		.component('convertEntityWizardForm', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/convert-entity-wizard-form.tpl.html',
			controller: ConvertEntityWizardFormController,
			/// 1.API ///
			bindings: {
				currentTemplate: '<',
				convertibleTemplatesList: '<',
				sourceFlashId: '<',
				createNewEntity: '<',
				close: '&',
				dismiss: '&',
				onEntityConverted: '&?'
			},
		});

	/** @ngInject */
	function ConvertEntityWizardFormController(convertEntityService, deleteEntityService, blockUI, $filter, entityFetchResource, editMetaUseCaseConstants) {
		var ctrl = this;
		ctrl.$onInit = function () {
			ctrl.currentStep = ctrl.steps[0];
			ctrl.convertEntityDetail = {};
			ctrl.errors = [];
			ctrl.templateSelected = false;
			ctrl.editMetaUseCase = ctrl.createNewEntity ? editMetaUseCaseConstants.convertCreatingNewEntity : editMetaUseCaseConstants.convertOverwritingExistingEntity;
		};
		/**
		 * Wizard steps
		 * */
		ctrl.steps = [
			{
				id: 1,
				name: "userApp.editorialEntity.convert.step01",
				description: "Select target tee step"
			},
			{
				id: 2,
				name: "userApp.editorialEntity.convert.step02",
				description: "edit meta-instance"
			},
			{
				id: 3,
				name: "userApp.editorialEntity.convert.step01",
				description: "error management"
			}
		];

    /**
		 * Step 01 is specific for tee selection
		 */
		ctrl.isActiveStep01 = function () {
			return ctrl.currentStep.id === 1;
		};
		/**
		 * Step 02 is specific for edit metadata
		 */
		ctrl.isActiveStep02 = function () {
			return ctrl.currentStep.id === 2;
		};
		/**
		 * Step 02 is specific for edit metadata
		 */
		ctrl.isActiveStep03 = function () {
			return ctrl.currentStep.id === 3;
		};
		/**
		 * @description Function convert Entity to target Template
		 * @param teeSelected tee selected
		 * @param launchNextStep bypass select tr step and auto launch next step
		 */
		ctrl.convert = function () {
			blockUI.start();
			convertEntityService.convert(ctrl.sourceFlashId, ctrl.selectedTemplate.code, ctrl.createNewEntity)
				.then(function (data) {
					ctrl.convertEntityDetail = data;
					if (ctrl.convertEntityDetail.succeeded && ctrl.convertEntityDetail.convertedEntityFlashId && ctrl.convertEntityDetail.validated) {
						return entityFetchResource.prepareFictiveEntityForPersist({ flashId: ctrl.convertEntityDetail.convertedEntityFlashId }).$promise.then(function (data) {
							ctrl.infosForPersist = data;
							ctrl.currentStep = ctrl.steps[1];
						});
					} else {
						ctrl.currentStep = ctrl.steps[2];
						if (!ctrl.convertEntityDetail.validated) {
							ctrl.errors.push($filter('translate')('userApp.editorialEntity.convert.errorMsg.noValid'));
						} else {
							ctrl.errors.push($filter('translate')('userApp.editorialEntity.convert.errorMsg.noConverted'));
						}
						if (ctrl.convertEntityDetail.convertedEntityFlashId) {
							return deleteEntityService.forceDeleteEntity(ctrl.convertEntityDetail.convertedEntityFlashId);
						}
					}
				}).finally(function () {
					blockUI.stop();
				});
		};
		/**
		 * @description Function fired when TEE is selected (Step select Tee target of the wizard)
		 * @param teeSelected tee selected
		 * @param launchNextStep bypass select tee step and auto launch next step
		 */
		ctrl.onTeeSelected = function (teeSelected, launchNextStep) {
			ctrl.selectedTemplate = teeSelected;
			ctrl.templateSelected = true;
			if (launchNextStep === true) {
				//Launch next step
				ctrl.convert();
			}
		};
		/**
		 * 
		 */
		ctrl.cancel = function () {
			ctrl.dismiss();
		};
	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('convertEntityService', ConvertEntityService);


	/** @ngInject */
	function ConvertEntityService(entityConvertResource, userPreferenceService) {
		var service = {
			convert: convert,
			getPermissionStatus: getPermissionStatus
		};

		return service;


		/**
			* @description CONVERT TO A TARGET TEMPLATE
			* @param {*} flashId 
			* @param {*} selectedTemplateCode
			*/
		function convert(flashId, selectedTemplateCode, createNewEntity) {
			var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');
			return entityConvertResource.convert({ flashId: flashId, targetTeeCode: selectedTemplateCode, createNewEntity: createNewEntity, contextProductCode: contextProductCode }).$promise;
		}

		function getPermissionStatus(flashId, createNewEntity) {
			return entityConvertResource.getPermissionStatus({ flashId: flashId, createNewEntity: createNewEntity }).$promise;
		}
	}
})();


(function () {
	'use strict';

	// Usage:
	// Use the service to launch this modal component.
	// Creates:
	// 

	angular
		.module('userApp')
		.component('createAndHookEeWizardModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/create-and-hook-ee-wizard-modal/create-and-hook-ee-wizard-modal.tpl.html',
			controller: CreateAndHookEeWizardModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function CreateAndHookEeWizardModalController() {
		var ctrl = this;


		////////////////
		ctrl.closeModal = function (result) {
			ctrl.close({ $value: result });
		};
		//
		ctrl.$onInit = function () {
			ctrl.eeSourceDetails = ctrl.resolve.eeSourceDetails;
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.subElementDetails = ctrl.resolve.subElementDetails;
			ctrl.relationshipMetaCase = ctrl.resolve.relationshipMetaCase;
			ctrl.editorialEe = ctrl.resolve.editorialEe;
		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('CreateAndHookEeWizardModalService', CreateAndHookEeWizardModalService);

	/** @ngInject */
	function CreateAndHookEeWizardModalService($uibModal, blockUI) {
		var service = {
			openModal: openModal
		};

		return service;

		////////////////
		function openModal(eeSourceDetails, subElementDetails, currentUser, relationshipMetaCase, editorialEntity) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'createAndHookEeWizardModal',
				resolve: {
					eeSourceDetails: eeSourceDetails,
					subElementDetails: subElementDetails,
					currentUser: currentUser,
					relationshipMetaCase: relationshipMetaCase,
					editorialEe: editorialEntity,
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('linkAndCreateEeWizard');
						$translatePartialLoader.addPart('linkEEWizard');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('validateEntityComponentChangeStep', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/edit-workflow-modal/validate-entity-change-step/validate-entity-change-step.html',
			controller: validateEntityChangeStepController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function validateEntityChangeStepController(entityLockService, checkBrokenLinksService, blockUI, workflowHistoryResource, $rootScope) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.workflowHistoryDTO = ctrl.resolve.workflowHistoryDTO;
			ctrl.validation = ctrl.resolve.validation;
		};

		ctrl.cancelModal = function () {
			ctrl.close({ $value: true });
		};

		ctrl.cancel = function () {
			ctrl.cancelModal();
			if (ctrl.workflowHistoryDTO && ctrl.workflowHistoryDTO.lockResource) {
				entityLockService.unlock(ctrl.workflowHistoryDTO.eeflashId);
			}
		};

		ctrl.changeStepWarning = function () {
			workflowHistoryResource.changeStepWithWarning(ctrl.workflowHistoryDTO, function (data) {
				blockUI.stop();
				ctrl.cancelModal();
			});
		};

		ctrl.clore = function () {
			blockUI.start();
			var brokenLinksReport = ctrl.workflowHistoryDTO.brokenLinksReportDTO;
			if (brokenLinksReport && brokenLinksReport.targetEntitiesWordingList.length > 0) {
				checkBrokenLinksService.openBrokenLinksReportModal(ctrl.workflowHistoryDTO).then(function () {
					blockUI.stop();
					ctrl.cancelModal();
				});
			} else {
				workflowHistoryResource.warningWorkFlow(ctrl.workflowHistoryDTO).$promise.then(function (data) {
					blockUI.stop();
					sendEvent();
					ctrl.cancelModal();
				});
			}
		};

		//SEND EVENT TO MENU COMPONENT TO RECALCULATE PERMISSIONS
		function sendEvent() {
			$rootScope.$emit('WfForcedByWarningOrError');
		}

	}
})();

(function () {
	'use strict';


	angular.module('userApp')
		.component('entityAutoMount', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/tree-auto-mount/entity-mounting/entity-mounting.tpl.html',
			controller: entityAutoMountController,
			bindings: {
				exactMatch: '<',
				approximateMatch: '<',
				columns: '<',
				exactMatchSelected: '<',
				approximateMatchSelected: '<',
				exactFiltersDisplay: '<?'
			},
		});

	/** @ngInject */
	function entityAutoMountController(entityTemplateService, TirFilterSharedService, treeAutoMountModalService, blockUI, $translate, $sce) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.preview = {};
		};


		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.closePreview = function (id) {
			ctrl.preview.flashId = null;
		};

		ctrl.showPreview = function (id) {
			ctrl.preview = {
				opened: true,
				flashId: id
			};
		};

		ctrl.filterExact = function (row) {
			return (!ctrl.searchExact || ctrl.searchExact.length === 0 || row.NAME.toLowerCase().indexOf(ctrl.searchExact.toLowerCase()) !== -1);
		};

		ctrl.filterApproximate = function (row) {
			return (!ctrl.searchApproximate || ctrl.searchApproximate.length === 0 || row.NAME.toLowerCase().indexOf(ctrl.searchApproximate.toLowerCase()) !== -1);
		};

		ctrl.refreshAllTable = function () {
			ctrl.refreshApproxTable();
			ctrl.refreshExactTable();
		};

		ctrl.refreshApproxTable = function (tableState) {
			if (tableState) {
				ctrl.sortColumn(tableState, ctrl.approximateMatch);
			}
		};

		ctrl.refreshExactTable = function (tableState) {
			if (tableState) {
				ctrl.sortColumn(tableState, ctrl.exactMatch);
			}
		};

		ctrl.sortColumn = function (tableState, list) {
			var pred = tableState.sort.predicate;
			var reverse = tableState.sort.reverse;

			list = list.sort(function (a, b) {
				var x = a[pred] ? a[pred] : '0';
				var y = b[pred] ? b[pred] : '0';
				var result = x > y ? -1 : 1;

				if (reverse) result = result * -1;

				return result;
			});

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('validateEntityComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/validation/validate-entity/validate-entity.html',
			controller: validateEntityController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function validateEntityController(entityLockService, checkBrokenLinksService, blockUI, workflowHistoryResource, $rootScope) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.workflowHistoryDTO = ctrl.resolve.workflowHistoryDTO;
			ctrl.validation = ctrl.resolve.validation;
			ctrl.statusValidation = ctrl.resolve.statusValidation;
			ctrl.hasNotFinalCreatedEntities = ctrl.statusValidation && ctrl.statusValidation.notFinalCreatedEntities.length > 0;
			ctrl.hasNotFinalUpdatedEntities = ctrl.statusValidation && ctrl.statusValidation.notFinalUpdatedEntities.length > 0;
			ctrl.hasNotFinalEntities = ctrl.hasNotFinalCreatedEntities || ctrl.hasNotFinalUpdatedEntities;
			ctrl.validation.validFunction = ctrl.hasNotFinalEntities ? false : ctrl.validation.validFunction;
		};

		ctrl.isEmptyTitle = function (title) {
			return _.isEmpty(title);
		};

		ctrl.cancelModal = function () {
			ctrl.close();
		};

		ctrl.closeModal = function (data) {
			ctrl.close({ $value: data });
		};

		ctrl.cancel = function () {
			ctrl.cancelModal();
			if (ctrl.workflowHistoryDTO && ctrl.workflowHistoryDTO.lockResource) {
				entityLockService.unlock(ctrl.workflowHistoryDTO.eeflashId);
			}
		};

		ctrl.sendEEToCorrection = function () {
			blockUI.start();
			workflowHistoryResource.errorWorkFlow(ctrl.workflowHistoryDTO).$promise.then(function (data) {
				blockUI.stop();
				sendEvent();
				ctrl.cancelModal();
			});
		};

		ctrl.clore = function () {
			blockUI.start();
			var brokenLinksReport = ctrl.workflowHistoryDTO.brokenLinksReportDTO;
			if (brokenLinksReport && brokenLinksReport.targetEntitiesWordingList.length > 0) {
				checkBrokenLinksService.openBrokenLinksReportModal(ctrl.workflowHistoryDTO).then(function () {
					blockUI.stop();
					ctrl.cancelModal();
				});
			} else {
				workflowHistoryResource.warningWorkFlow(ctrl.workflowHistoryDTO).$promise.then(function (data) {
					blockUI.stop();
					sendEvent();
					ctrl.closeModal(data);
				});
			}
		};

		//SEND EVENT TO MENU COMPONENT TO RECALCULATE PERMISSIONS
		function sendEvent() {
			$rootScope.$emit('WfForcedByWarningOrError');
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('validateTreeComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/validation/validate-tree/validate-tree.component.html',
			controller: validateTreeController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function validateTreeController(blockUI, $uibModal, $timeout, $sce, validateEntityService) {
		var ctrl = this;
		var validationTreeBlockUI = blockUI.instances.get('validationTreeBlockUI');

		ctrl.$onInit = function () {


			ctrl.report = ctrl.resolve.report;
			ctrl.allValid = _.has(ctrl.report, 'allValid') && ctrl.report.allValid;

			ctrl.tree = {
				id: ctrl.report.id,
				text: ctrl.report.text,
				items: ctrl.report.items,
				report: ctrl.report.report
			};
			ctrl.data = [ctrl.tree];

			ctrl.source = new kendo.data.HierarchicalDataSource({
				data: ctrl.data
			});

		};

		ctrl.onDataBound = function () {
			$timeout(function () {
				ctrl.treeview.expand(".k-item");
			});
		};

		ctrl.expandAll = function () {
			//e.sender.expandPath([1, 2, 3])
			$timeout(function () {
				ctrl.treeview.expand(".k-item");
			});
		};

		ctrl.collapseAll = function (e) {
			$timeout(function () {
				ctrl.treeview.collapse(".k-item");
			});
		};

		ctrl.cancelModal = function () {
			ctrl.close({
				$value: true
			});
		};

		ctrl.cancel = function () {
			ctrl.cancelModal();
		};


		//Expand only the valide EE
		ctrl.expandValid = function () {
			validationTreeBlockUI.start();
			ctrl.collapseAll();
			$timeout(function () {
				_.forEach(ctrl.report.validEe, function (id) {
					expandToParent(id);
				});
				validationTreeBlockUI.stop();
			}, 1000);
		};

		//Expand only the EE with warnings
		ctrl.expandWarning = function () {
			validationTreeBlockUI.start();
			ctrl.collapseAll();
			$timeout(function () {
				_.forEach(ctrl.report.warningEe, function (id) {
					expandToParent(id);
				});
				validationTreeBlockUI.stop();
			}, 1000);
		};

		//Expand only the EE with errors
		ctrl.expandError = function () {
			validationTreeBlockUI.start();
			ctrl.collapseAll();
			$timeout(function () {
				_.forEach(ctrl.report.errorEe, function (id) {
					expandToParent(id);
				});
				validationTreeBlockUI.stop();
			}, 1000);
		};


		ctrl.trustAsHtml = function (title) {
			return $sce.trustAsHtml(title);
		};



		ctrl.openReportModal = function (report) {
			$uibModal.open({
				component: 'validateEntityComponent',
				resolve: {
					validation: report,
					editorialEntity: function () {
						return undefined;
					},
					workflowHistoryDTO: function () {
						return undefined;
					}
				},
				size: 'lg',
				backdrop: 'static'
			});
		};


		ctrl.refresh = function () {

			//SEND REFRESH TRUE TO FORCE A NEW  REPORT GENERATION

			var editorialEntity = {
				identifier: ctrl.tree.id
			};
			validateEntityService.openModal(editorialEntity, true, true, true /*refresh*/);

			//CLOSE CURRENT MODAL
			ctrl.cancelModal();

		};


		function expandToParent(id) {
			var nodeDataItem = ctrl.treeview.dataSource.get(id);
			ctrl.treeview.expandTo(nodeDataItem);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editSystemAuthorService', EditSystemAuthorService);


	/** @ngInject */
	function EditSystemAuthorService(blockUI, $uibModal, userGroupResource, entityUpdateResource, $filter) {
		var service = {
			openModal: openModal,
			editAuthor: editAuthor
		};

		return service;

		function openModal(editorialEntity) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'editAuthorModal',
				resolve: {
					editorialEntity: function () { return editorialEntity; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result.then(function (selectedItem) {
				return editorialEntity.authors = selectedItem;

			});
		}

		function editAuthor(editorialEntity) {
			blockUI.start();
			// EDIT AUTHORS
			var systemAuthors = _.map(editorialEntity.system.systemAuthors, function (tr) {
				return tr.login;
			});
			return entityUpdateResource.editAuthors({ "flashId": editorialEntity.identifier, "login": systemAuthors })
				.$promise.then(function (data) {
					blockUI.stop();

				});
		}
	}
})();



(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editAuthorModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/metadata/systemAuthor/edit-system-author-modal/edit-system-author-modal.html',
			controller: editAuthorModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});
	/** @ngInject */
	function editAuthorModalController(editSystemAuthorService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.editorialEntity;		
			ctrl.originalAuthors = angular.copy(ctrl.resolve.editorialEntity.system.systemAuthors);		

		};

		ctrl.cancel = function () {
			ctrl.resolve.editorialEntity.system.systemAuthors=	 angular.copy(ctrl.originalAuthors);
			ctrl.dismiss({ $value: false });
		};


		/**
		 * Save
		 */
		ctrl.save = function () {
			var authors = _.map(ctrl.editorialEntity.system.systemAuthors, function (tr) {
				return tr.fullName;
			});
			editSystemAuthorService.editAuthor(ctrl.editorialEntity)
				.then(function (data) {
					ctrl.close({ $value: authors });
				});
		};
	}
})();

(function () {
	'use strict';

	// Usage:
	/**
	 * <create-ee-form  
	 * 				eet-code="$ctrl.rtEet.editorialEntityTemplate.code" 
	 * 				current-user="$ctrl.currentUser"
            editorial-entity="$ctrl.editorialEntity" 
						on-valid-form="$ctrl.onValidForm(status)">
		</create-ee-form>
	 */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('createEeForm', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/steps/create-ee-form/create-ee-form.tpl.html',
			controller: CreateEeFormController,
			/** 1.API */
			bindings: {
				currentUser: '<',
				eetCode: '<',
				editorialEntity: '=',
				editorialEeProduct: '<',
				onValidForm: '&'
			},
		});

	/** @ngInject */
	function CreateEeFormController($scope, $translate, $filter, blockUI, modelService, entityTemplateResource) {
		var ctrl = this;

		/** 2. CONFIG */
		ctrl.$onInit = function () {
			//
			ctrl.lang = $translate.use();
			ctrl.titleMaxLengthViolation = false;
			moment.locale(ctrl.lang);
			ctrl.editorialEeProduct;
			ctrl.editorialEntity.ownerGroup = angular.isDefined(ctrl.editorialEeProduct) && ctrl.currentUser.userGroups.some(function (u) { return u.code === ctrl.editorialEeProduct; }) ? ctrl.editorialEeProduct : '';
			//
			var displayEeCreationForm = blockUI.instances.get('displayEeCreationForm');
			displayEeCreationForm.start();
			entityTemplateResource.getEET({
				codeTEE: ctrl.eetCode
			}).$promise.then(function (eet) {
				//
				ctrl.editorialEntity.editorialEntityTemplate = eet;
				ctrl.editorialEntity.metaInstanceList = eet.metaDataInstanceDTOList;
				return entityTemplateResource.getMaxSize().$promise;
			}).then(function (maxSizeMedia) {
				//
				ctrl.maxSizeMedia = maxSizeMedia.maxSize;
				return modelService.getAllModels({
					codeTEE: ctrl.eetCode
				}).$promise;
			}).then(function (allModelsList) {
				//
				ctrl.allModels = [];
				ctrl.allModelsList = allModelsList;
				ctrl.initModels();
				ctrl.allModelsSize = Object.keys(ctrl.allModels).length;
				return modelService.loadMetaInstantiation({
					codeTEE: ctrl.eetCode
				}).$promise;
			}).then(function (metaInstanceList) {
				ctrl.metaInstanceList = metaInstanceList;
			}).catch(function () {
				displayEeCreationForm.stop();
			}).finally(function () {
				displayEeCreationForm.stop();
				ctrl.loadModel();
				if (ctrl.editorialEntity.modelFlashId !== 'NOMODEL') {
					ctrl.loadMetaInstance();
				}
			});

		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		/** 3.OPERATIONS */
		$scope.$watch('$ctrl.createEntityForm.$valid', function (newVal) {
			//$scope.valid = newVal;
			if (angular.isDefined(newVal)) {
				ctrl.onValidForm({ status: newVal || ctrl.isNotAllMediasAssigned() || ctrl.isNotTreeAssigned() || ctrl.titleMaxLengthViolation });
			}
		});
		//
		ctrl.onChangeProductGroup = function (ownerGroup) {

			//emit event to system author component when owner group change
			$scope.$broadcast('ownerGroupUpdated', ownerGroup);

		};

		ctrl.initModels = function () {
			var mapAllModels = _.mapValues(_.keyBy(ctrl.allModelsList, 'flashId'), function (m) {
				//add model visibility to label
				if (m.modelVisibility) {
					var isDefault = m.defaultModel ? '*' : '';
					var visibility = $filter('translate')(m.modelVisibility === 'SHARED' ? m.modelVisibility + '_SHORT' : m.modelVisibility);
					return visibility + ' - ' + m.name + isDefault;
				}
				return m.name;
			});

			ctrl.allModels = mapAllModels;
		};

		//
		ctrl.loadModel = function () {
			ctrl.editorialEntity.modelFlashId = setDefaultModelFlashId();
			if (ctrl.metaInstanceList.length > 0) {
				ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList = ctrl.metaInstanceList;
				ctrl.editorialEntity.metaInstanceList = ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList;
			}
		};

		function setDefaultModelFlashId() {
			var sharedDefaultModels = _.filter(ctrl.allModelsList, function (model) {
				return model.defaultModel;
			});
			if (sharedDefaultModels.length > 0) {
				return sharedDefaultModels[0].flashId;
			}
			else {
				return ctrl.allModelsList[0].flashId;
			}
		}
		//
		ctrl.loadMetaInstance = function () {
			modelService.loadMetaInstantiation({
				codeTEE: ctrl.editorialEntity.editorialEntityTemplate.code,
				modelFlashId: ctrl.editorialEntity.modelFlashId
			}).$promise.then(function (data) {
				ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList = data;
				ctrl.editorialEntity.metaInstanceList = ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList;
				ctrl.editorialEntity.ownerGroup = ctrl.currentUser.userGroups.length === 1 ? ctrl.currentUser.userGroups[0].code.toString() : '';
			});
		};

		//verify if all the metaDataInstances "MEDIA" are not assigned	
		function getListMetaInstanceMedia() {
			var listMEDIA = [];
			if (ctrl.editorialEntity.metaInstanceList && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized) {
						listMEDIA.push(metaInstanceDto);
					}
				}
			}
			return listMEDIA;
		}
		//
		ctrl.isNotAllMediasAssigned = function () {
			var listMEDIA = getListMetaInstanceMedia();
			var isAllAssigned;
			var size = 0;
			if (listMEDIA === null || listMEDIA.length === 0) {
				isAllAssigned = false;
			} else if (listMEDIA !== null && listMEDIA.length > 0) {
				for (var i = 0, len = listMEDIA.length; i <= len - 1; i++) {
					var metaInstanceDto = listMEDIA[i];
					if (angular.isDefined(metaInstanceDto.listMediaFiles) && angular.isDefined(metaInstanceDto.temporraryListFile) && (Object.keys(metaInstanceDto.listMediaFiles).length > 0 || metaInstanceDto.temporraryListFile.length > 0)) {
						size++;
					}
				}
				if (size === listMEDIA.length) {
					isAllAssigned = false;
				} else {
					isAllAssigned = true;
				}
			}
			return isAllAssigned;
		};
		//
		ctrl.isNotTreeAssigned = function () {
			var authorizedTree = false;
			if (ctrl.editorialEntity.metaInstanceList && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "REPOSITORY" && metaInstanceDto.metaDataDTO.referential !== null && metaInstanceDto.metaDataDTO.referential.type === "TREE" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized && (metaInstanceDto.referentialValueDTOList === null || !metaInstanceDto.referentialValueDTOList.length > 0 || angular.isUndefined(metaInstanceDto.referentialValueDTOList))) {
						authorizedTree = true;
						break;
					}
				}
			}
			return authorizedTree;
		};

		$scope.$on('titleMaxLengthViolation', function (event, data) {
			ctrl.titleMaxLengthViolation = data;
		});


	}



})();

(function () {
	'use strict';

	// Usage:
	/**
	 * <rt-eet-selection  
	 * 				eet-code="$ctrl.eeSourceDetails.eetCode" 
	 * 				relation-template-id="$ctrl.eeSourceDetails.relationTemplateId"
	 * 				on-rt-eet-selected="$ctrl.onRtEetSelected(rtEet,launchNextStep,accessedSelectRtEetStep)" 
	 * 				relationship-meta-case="$ctrl.relationshipMetaCase">
	 * </rt-eet-selection>
	 */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('rtEetSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/steps/rt-eet-selection/rt-eet-selection.tpl.html',
			controller: RtEetSelectionController,
			/** 1.API */
			bindings: {
				eetCode: '<',
				relationTemplateId: '<?',
				onRtEetSelected: '&',
				relationshipMetaCase: '<'
			},
		});

	/** @ngInject */
	function RtEetSelectionController(blockUI, rtEetSelectionService) {
		var ctrl = this;
		/** 2.OPERATIONS */
		ctrl.selectEet = function (rtEet, launchNextStep) {
			ctrl.selectedRtEet = rtEet;
			if (angular.isDefined(launchNextStep)) {
				ctrl.onRtEetSelected({ rtEet: rtEet, launchNextStep: true, accessedSelectRtEetStep: true });
			} else {
				ctrl.onRtEetSelected({ rtEet: rtEet, accessedSelectRtEetStep: true });
			}
		};
		ctrl.$onInit = function () {
			ctrl.selectedRtEet = null;
			var displayRtEetDiv = blockUI.instances.get('displayRtEetDiv');
			displayRtEetDiv.start();

			if (ctrl.relationshipMetaCase) {
				rtEetSelectionService.findAllAuthorizedTargetEetByRtId(ctrl.relationTemplateId)
					.then(function (rtEets) {
						displayRtEetDiv.stop();
						ctrl.rtEets = rtEets;
						ctrl.byPassSelectRtEetStepIfHavingOneChoice();
					}, function () {
						displayRtEetDiv.stop();
					});
			} else {
				rtEetSelectionService.findAllAuthorizedTargetEetBySourceEetCode(ctrl.eetCode)
					.then(function (rtEets) {
						displayRtEetDiv.stop();
						ctrl.rtEets = rtEets;
						ctrl.byPassSelectRtEetStepIfHavingOneChoice();
					}, function () {
						displayRtEetDiv.stop();
					});
			}
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		//BY PASS SELECT RT-EET STEP IF WE HAVE ONE CHOICE AND GO TO CREATE EE FORM
		ctrl.byPassSelectRtEetStepIfHavingOneChoice = function () {
			if (ctrl.rtEets.length === 1) {
				ctrl.onRtEetSelected({ rtEet: ctrl.rtEets[0], launchNextStep: true, accessedSelectRtEetStep: false });
			}
		};
	}
})();

(function () {
	'use strict';

	/**
	 * Service providing utilities functions to editorial entity template selection
	 * in create and hook wizard.
	 */
	angular
		.module('userApp')
		.factory('rtEetSelectionService', RtEetSelectionService);

	/** @ngInject */
	function RtEetSelectionService(relationTemplateResource) {
		var service = {
			findAllAuthorizedTargetEetByRtId: findAllAuthorizedTargetEetByRtId,
			findAllAuthorizedTargetEetBySourceEetCode: findAllAuthorizedTargetEetBySourceEetCode
		};

		return service;

		//GET AUTHORIZED EET TO INSTANTIATE TARGETD BY RELATION TEMPLATE WITH GIVEN ID
		function findAllAuthorizedTargetEetByRtId(relationTemplateId) {
			return relationTemplateResource.findAllAuthorizedTargetEetByRtId({
				relationTemplateId: relationTemplateId
			}).$promise;
		}

		//GET AUTHORIZED EET TO INSTANTIATE TARGETD BY EET WITH GIVEN CODE
		function findAllAuthorizedTargetEetBySourceEetCode(eetCode) {
			return relationTemplateResource.findAllAuthorizedTargetEetBySourceEetCode({
				eetCode: eetCode
			}).$promise;
		}
	}
})();


(function () {
	'use strict';

	// Usage:
  /**
   * <ee-source-selection 
   * tr-id="$ctrl.relationTemplateDetails.id" 
   * current-user="$ctrl.currentUser"
      on-ee-source-selected="$ctrl.onEeSourceSelected(selectedEeSourceId,launchNextStep,accessedSelectEeSourceStep)">
    </ee-source-selection>
   */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('eeSourceSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/ee-source-selection/ee-source-selection.tpl.html',
			controller: EeSelectionController,

			/// 1.API ///
			bindings: {
				sourceEesList: '<',
				currentUser: '<',
				onEeSourceSelected: '&',
				rtStepElementsSelected: '=',
				rtBreadcrumb: '=',
				targetEntities: '<',
				relationshipTemplateList: '<',
				trSelected: '<'

			},
		});
	/** @ngInject */
	function EeSelectionController($sce, $log, blockUI, relationTemplateResource, entityLinkingResource, linkEeWizardFormService, $q) {
		var ctrl = this;

		/// 2.OPERATIONS ///
		ctrl.isEeSelectable = function (ee) {
			return (!ee.padlock.closed || ee.padlock.owner.identifier === ctrl.currentUser.identifier) && !ee.disable;
		};
		//
		ctrl.selectEeSource = function (ee, launchNextStep) {
			if (ctrl.isEeSelectable(ee)) {
				ctrl.selectedEe = ee;
				ctrl.onEeSourceSelected({ selectedEeSource: ee, launchNextStep: angular.isDefined(launchNextStep), accessedSelectEeSourceStep: true });
			}
		};
		//
		ctrl.formatSystemTitle = function (titleSystem) {
			return $sce.trustAsHtml(titleSystem);
		};
		//
		ctrl.$onInit = function () {
			ctrl.selectedEe = null;
			blockUI.start();
			var getTargetLinksDetailsPromises = [];
			ctrl.sourceEesList.forEach(function (ee) {
				if (ctrl.trSelected.ignoreEntitiesAttachedToSource || ctrl.trSelected.ignoreEntitiesHookedToSameProduct || ctrl.trSelected.ignoreEntitiesHookedToSameEet) {
					var targetEntitiesFlashIds = _.map(ctrl.targetEntities, 'flashId');
					getTargetLinksDetailsPromises.push(
						linkEeWizardFormService.getTargetLinksDetail(ee.identifier, targetEntitiesFlashIds).then(function (targetLinksDetail) {
							ee.disable = ctrl.trSelected.ignoreEntitiesAttachedToSource && targetLinksDetail.allTargetsAreAlreadyHooked
								|| ctrl.trSelected.ignoreEntitiesHookedToSameProduct && targetLinksDetail.allTargetsAreAlreadyHookedToSameProduct
								|| ctrl.trSelected.ignoreEntitiesHookedToSameEet && targetLinksDetail.allTargetsAreAlreadyHookedToSameEet
								|| ctrl.currentUser.fullName !== ee.lockedBy && ee.padlock.closed;
						}));
				}
				if (ctrl.currentUser.fullName !== ee.lockedBy && ee.padlock.closed) {
					ee.disable = true;
				}				
			});
			return $q.all(getTargetLinksDetailsPromises).then(function () {
				blockUI.stop();
			});
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('proofChannelSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/proof-channel-selection/proof-channel-selection.tpl.html',
			controller: ProofChannelSelectionController,
			bindings: {
				onProofChannelSelected: '&',
				rtBreadcrumb: '=',
				proofChannels: '<',
				productChannels: '<',
				canalsFromProduct: '<'

			}
		});

	/** @ngInject */
	function ProofChannelSelectionController() {

		var ctrl = this;
		ctrl.$onInit = function () {
			if (ctrl.proofChannels && ctrl.proofChannels.length === 1) {
				ctrl.selectedProofingChannel = ctrl.proofChannels[0];
			} else {
				if (ctrl.productChannels.length === 1 && ctrl.productChannels[0].publicationChannel.length === 1) {
					ctrl.selectedProofChannel = ctrl.productChannels[0].publicationChannel[0];
				}
			}
		};

		ctrl.selectProofChannel = function (productCode, productWording) {
			ctrl.onProofChannelSelected({proofChannelSelected: ctrl.selectedProofChannel, launchNextStep: true, accessedSelectProofChannelStep: true, productCode: productCode, productWording: productWording});
		};
	}
})();

(function () {
	'use strict';

	// Usage:
  /**
   * <ee-sub-element-selection 
   * ee-source="$ctrl.selectedEeSource" 
   * on-sub-element-selected="$ctrl.onSubElementSelected(subElementDetails,launchNextStep,accessedSelectSubElementStep)">
   * </ee-sub-element-selection>
   */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('eeSubElementSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/ee-sub-element-selection/ee-sub-element-selection.tpl.html',
			controller: EeSubElementSelectionController,

			/// 1.API ///
			bindings: {
				eeSource: '<',
				onSubElementSelected: '&',
				rtStepElementsSelected: '=',
				rtBreadcrumb: '='
			},
		});
	/** @ngInject */
	function EeSubElementSelectionController() {
		var ctrl = this;

		/// 2.OPERATIONS ///
		//On node check treeview directive event.
		ctrl.onNodeCheck = function (checkedNode) {
			ctrl.onSubElementSelected({ subElementDetails: checkedNode, launchNextStep: true, accessedSelectSubElementStep: true });
		};
		/// 3.CONFIG ///
		ctrl.$onInit = function () {

		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	// Usage:
	/**
	 * <relation-reference-node 
	 * 			ee-source-details="$ctrl.eeSourceDetails" 
	 * 			relation-template-details="$ctrl.relationTemplateDetails"
	 * 			target-entities="$ctrl.targetEntities" 
	 * 			sub-element-details="$ctrl.subElementDetails" 
	 * 			on-relation-ref-node-initialized="$ctrl.onRelationRefNodeInitialized(relation,referenceNode)"
	 * 			on-errors="$ctrl.onErrors(errors)" 
	 * 			is-reference-node-creation="true">
	 * </relation-reference-node>
	 * 
	 * 
	 */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('relationReferenceNode', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/relation-reference-node/relation-reference-node.tpl.html',
			controller: RelationReferenceNodeController,
			/// 1.API ///
			bindings: {
				targetEntities: '<',
				eeSourceDetails: '<',
				subElementDetails: '<?',
				relationTemplateDetails: '<',
				onRelationsRefNodesInitialized: '&',
				isReferenceNodesCreation: '@',
				relationMetaDatasList: '=',
				onErrors: '&?',
				multiRelation: '=?',
				rtStepElementsSelected: '=',
				rtBreadcrumb: '=',
				onValidForm: '&',
				trSelected: '<',
				isLinked: '<',
				sourceEesList: '<',
			},
		});
	/** @ngInject */
	function RelationReferenceNodeController($q, $scope, $translate, $filter, blockUI, relationResource, $sce, relationshipTemplateWizardService, productResource, EDITORIAL_ELEMENT_TYPE, linkEeWizardFormService) {
		var ctrl = this;
		/// 2.CONFIG ////
		ctrl.$onInit = function () {
			ctrl.accessedRelationsReferenceNodeStep = false;
			ctrl.oneAtATime = false;
			ctrl.lang = $translate.use();
			ctrl.initDesiredPublicationDate();
			ctrl.initContainerSourcesData();
			ctrl.initData();
			ctrl.multiRelation = true;
			ctrl.productCode = ctrl.eeSourceDetails.ownerGroup;
		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		/// 2.OPERATIONS ///
		ctrl.userInputChanged = function () {
			ctrl.setUpRelationsAndRefNodes();
		};

		//Validate relation form
		$scope.$watch('$ctrl.relationForm.$valid', function (newVal) {
			if (angular.isDefined(newVal)) {
				var errors = ctrl.validateInputs();
				ctrl.onErrors({ errors: errors.length > 0 ? errors : [] });
				ctrl.onValidForm({ status: newVal });
			}
		});

		// XF-3283
		ctrl.initContainerSourcesData = function () {
			ctrl.containerSources = [];
			if (ctrl.eeSourceDetails.container && ctrl.targetEntities.length === 1) {
				var eeTargetFlashId = ctrl.targetEntities[0].flashId;
				if (eeTargetFlashId) {
					ctrl.initDesiredPublicationDate(eeTargetFlashId);
					ctrl.initContainerSources(eeTargetFlashId);
				}
			} else if (ctrl.targetEntities.length > 1) {
				ctrl.targetEntities = ctrl.isListAccroche(ctrl.targetEntities, ctrl.eeSourceDetails);
			}
		};
		ctrl.isListAccroche = function (targetEntities, eeSourceDetails) {
			var tabreferenceNode = [];
			var getTargetLinksDetailsPromises = [];
			blockUI.start();
			targetEntities.forEach(function (tr, index) {
				if (ctrl.targetEntities.length >= 1) {
					ctrl.initContainerSources(ctrl.targetEntities[index].flashId);
					ctrl.sourceEesList.forEach(function (sr, i) {
						getTargetLinksDetailsPromises.push(linkEeWizardFormService.getTargetLinkDetail(ctrl.sourceEesList[i].identifier, targetEntities[index].flashId).then(function (targetLinksDetail) {
							if ((ctrl.trSelected.ignoreEntitiesHookedToSameProduct && targetLinksDetail.hookedToSameProduct && eeSourceDetails.flashId === ctrl.sourceEesList[i]) ||
								(ctrl.ignoreEntitiesAttachedToSource && targetLinksDetail.alreadyLinked && eeSourceDetails.flashId === ctrl.sourceEesList[i]) ||
								(ctrl.trSelected.ignoreEntitiesHookedToSameEet && targetLinksDetail.hookedToSameEet && eeSourceDetails.flashId === ctrl.sourceEesList[i])) {
								tabreferenceNode.push(targetEntities[index]);
							}
							return ctrl.targetEntities = _.difference(targetEntities, tabreferenceNode);
						}
						));
					});
				}

			});
			$q.all(getTargetLinksDetailsPromises).then(function () {
				blockUI.stop();
			});

		};
		ctrl.initData = function () {
			blockUI.start();
			var displayMetaDataDiv = blockUI.instances.get('displayMetaDataDiv');
			displayMetaDataDiv.start();
			relationResource.getHookingMetadata({
				eeSourceFlashId: ctrl.eeSourceDetails.flashId
			}).$promise.then(function (data) {
				blockUI.stop();
				displayMetaDataDiv.stop();
				ctrl.setUpRelationsAndRefNodes();
			}).catch(function () {
				blockUI.stop();
				displayMetaDataDiv.stop();
			});
		};

		ctrl.setUpRelationsAndRefNodes = function () {
			if (ctrl.eeSourceDetails.container && ctrl.targetEntities) {
				ctrl.updateTargetEntities().then(function () {
					ctrl.initRelations();
				});
			} else {
				ctrl.initRelations();
			}

			//Do validation
			if (ctrl.isLinked === true) {
				ctrl.multiRelation = false;
			}
			var errors = ctrl.validateInputs();
			if (errors.length > 0) {
				ctrl.onErrors({ errors: errors });
			} else {
				ctrl.onErrors({ errors: [] });
			}
		};
		ctrl.validateInputs = function () {
			var errors = [];
			//Verify required meta data
			angular.forEach(ctrl.relationMetaDatasList, function (meta) {
				if (meta.mandatory &&
					meta.multipleOccurrences &&
					(meta.metaDataMultiValuesList === null || meta.metaDataMultiValuesList.length === 0) &&
					(meta.referentialTypeListDTOList === null || meta.referentialTypeListDTOList.length === 0)) {
					errors.push($filter('translate')('userApp.linkEEWizard.labels.mandatoryFields'));
				}
			});
			return errors;
		};
		ctrl.isEeSourceContainer = function () {
			return ctrl.eeSourceDetails.container;
		};

		ctrl.trustAsHtml = function (string) {
			var html = $sce.trustAsHtml(ctrl.deleteHtmlTags(string));
			return html;
		};
		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};

		ctrl.initDesiredPublicationDate = function (eeTargetFlashId) {
			if (eeTargetFlashId) {
				blockUI.start();
				relationResource.getOldestPublicationDateOnContainerSource({
					eeTargetFlashId: eeTargetFlashId
				}).$promise.then(function (data) {
					blockUI.stop();
					ctrl.desiredPublicationDate = data.date ? new Date(data.date) : new Date();
				});
			} else {
				blockUI.stop();
				ctrl.desiredPublicationDate = new Date();
			}

		};
		ctrl.initContainerSources = function (eeTargetFlashId) {
			blockUI.start();
			relationResource.getContainerSources({
				eeTargetFlashId: eeTargetFlashId
			}).$promise.then(function (data) {
				blockUI.stop();
				ctrl.containerSources = data;
			});
		};
		ctrl.updateTargetEntities = function () {
			blockUI.start();
			if (ctrl.eeSourceDetails.container) {
				var targetEntityFlashIds = _.map(ctrl.targetEntities, function (targetEntity) {
					return targetEntity.flashId;
				});
				if (targetEntityFlashIds && targetEntityFlashIds.length) {
					return relationResource.getContainerSourcesByEntityTarget({
						eeTargetFlashIds: targetEntityFlashIds
					}).$promise.then(function (data) {
						var containerSourcesByEntityTarget = data;
						_.each(ctrl.targetEntities, function (targetEntity) {
							var targetEntityInfo = _.find(containerSourcesByEntityTarget, function (targetEntityInfo) {
								return targetEntityInfo.eeTargetFlashId === targetEntity.flashId;
							});
							if (targetEntityInfo) {
								targetEntity.containerSources = targetEntityInfo.containerSources;
							}
						});
						blockUI.stop();
						return ctrl.targetEntities;
					});

				}
			}
		};
		ctrl.initRelations = function () {
			if (ctrl.targetEntities) {
				ctrl.relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationTemplateDetails, ctrl.relationMetaDatasList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate);
				if (ctrl.relationTemplateDetails && ctrl.relationTemplateDetails.metaInstanceList.length === 0) {
					//activate step.
					ctrl.accessedRelationsReferenceNodeStep = true;
				}
				if (ctrl.isReferenceNodesCreation) {
					var referenceNodes = relationshipTemplateWizardService.initReferenceNodes(ctrl.eeSourceDetails, ctrl.subElementDetails, ctrl.relations);
					ctrl.onRelationsRefNodesInitialized({ relations: ctrl.relations, accessedRelationsReferenceNodeStep: ctrl.accessedRelationsReferenceNodeStep, referenceNodes: referenceNodes });
				} else {
					ctrl.onRelationsRefNodesInitialized({ relations: ctrl.relations, accessedRelationsReferenceNodeStep: ctrl.accessedRelationsReferenceNodeStep });
				}
			}

		};

	}


})();

(function () {
	'use strict';

	// Usage:
	/**
		* <tr-selection
		*      eet-codes="$ctrl.eetCodes"
		*      on-tr-selected="$ctrl.onTrSelected(relationTemplateDetails,launchNextStep,accessedSelectTrStep)">
		* </tr-selection>
		*
		*/
	// Creates:
	// 

	angular
		.module('userApp')
		.component('trSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/tr-selection/tr-selection.tpl.html',
			controller: TrSelectionController,

			/// 1.API ///
			bindings: {
				relationshipTemplateList: '<',
				currentUser: '<',
				onTrSelected: '&',
				rtStepElementsSelected: '=',
				rtBreadcrumb: '=',
				eeTargetFlashId: '<?',
				targetEntities: '<',
				isProofing: '<?'

			},
		});

	/** @ngInject */
	function TrSelectionController($log, blockUI, relationTemplateResource, entityLinkingResource, linkEeWizardFormService, $q) {
		var ctrl = this;
		/// 2.OPERATIONS ////////

		ctrl.selectTr = function (tr, launchNextStep) {
			ctrl.selectedTr = tr;
			if (!tr.disable) {

				ctrl.onTrSelected({ trSelected: tr, launchNextStep: angular.isDefined(launchNextStep), accessedSelectTrStep: true });
			}
		};
		ctrl.$onInit = function () {
			if (_.isUndefined(ctrl.isProofing)) {
				ctrl.isProofing = false;
			}
			if (!ctrl.isProofing) {
				blockUI.start();
				var sourceEEntitiesByIdPromises = [];
				ctrl.relationshipTemplateList.forEach(function (tr, i) {
					var sourceEEntitiesByIdPromise = relationTemplateResource.getSourceEEntitiesById({
						trId: tr.id
					}).$promise.then(function (data) {
						ctrl.sourceEesList = _.sortBy(data.ees, ['titleSystem']);
						var getTargetLinksDetailsPromises = [];
						var eesSourcesShouldBeDisabled = [];
						if (ctrl.sourceEesList.length === 0) {
							ctrl.relationshipTemplateList[i].disable = true;
						} else if (!ctrl.relationshipTemplateList[i].disable && (tr.ignoreEntitiesAttachedToSource || tr.ignoreEntitiesHookedToSameProduct || tr.ignoreEntitiesHookedToSameEet)) {
							ctrl.sourceEesList.forEach(function (entity) {
								var targetEntitiesFlashIds = _.map(ctrl.targetEntities, 'flashId');
								getTargetLinksDetailsPromises.push(
									linkEeWizardFormService.getTargetLinksDetail(entity.identifier, targetEntitiesFlashIds).then(function (targetLinksDetail) {
										eesSourcesShouldBeDisabled.push(tr.ignoreEntitiesAttachedToSource && targetLinksDetail.allTargetsAreAlreadyHooked
											|| tr.ignoreEntitiesHookedToSameProduct && targetLinksDetail.allTargetsAreAlreadyHookedToSameProduct
											|| tr.ignoreEntitiesHookedToSameEet && targetLinksDetail.allTargetsAreAlreadyHookedToSameEet);
									}));
							});
							return $q.all(getTargetLinksDetailsPromises).then(function () {
								// Si toutes les EEs sources du TR (eesSourcesShouldBeDisabled) ne devraient pas être actives car aucune target ne peut s'y accrocher -> le tr doit être désactivé
								// Sinon, c'est qu'il existe au moins une target qui peut s'accrocher à au moins une source -> le tr doit alors être activé, sauf s'il est déjà désactivé
								ctrl.relationshipTemplateList[i].disable = eesSourcesShouldBeDisabled.reduce(function (accumulator, next) { return accumulator && next; });
							});
						}
					});
					sourceEEntitiesByIdPromises.push(sourceEEntitiesByIdPromise);
				});
				$q.all(sourceEEntitiesByIdPromises).then(function () {
					blockUI.stop();
				});
			}
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	// Usage:
  /**
   * 	<edit-converted-entity result="$ctrl.result" tee-code="$ctrl.selectedTemplate.code"
	 *			 close="$ctrl.close()" dismiss="$ctrl.dismiss()">
	 *	</edit-converted-entity>
   *
   */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('editConvertedEntity', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/steps/edit-meta-target-entity/edit-converted-entity.tpl.html',
			controller: EditConvertedEntityController,

			/// 1.API ///
			bindings: {
				infosForPersist: '<',
				onTeeSelected: '&',
				close: '&',
				dismiss: '&',
				editMetaUseCase: '<?',
				onEntityConverted: '&?'
			},
		});

	/** @ngInject */
	function EditConvertedEntityController(EDITORIAL_ELEMENT_TYPE) {
		var ctrl = this;
		ctrl.$onInit = function () {
			ctrl.type = EDITORIAL_ELEMENT_TYPE.entity;
			ctrl.isAcceptProposal = undefined;
			ctrl.editorialEntity = ctrl.infosForPersist.editorialEntityDTO;
			ctrl.autoRedirect = true;
			ctrl.modalTitle = 'userApp.editorialEntity.convert.step02';
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	// Usage:
  /**
   * <tee-selection
   *      convertible-templates-list="$ctrl.convertibleTemplatesList"
				  on-tee-selected="$ctrl.onTeeSelected(teeSelected,launchNextStep)">
   * </tee-selection>
   *
   */
	// Creates:
	// 

	angular
		.module('userApp')
		.component('teeSelection', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/steps/tee-selection/tee-selection.tpl.html',
			controller: TeeSelectionController,

			/// 1.API ///
			bindings: {
				convertibleTemplatesList: '<',
				onTeeSelected: '&',
			},
		});

	/** @ngInject */
	function TeeSelectionController() {
		var ctrl = this;
		ctrl.$onInit = function () {
		};
    /**
		 * @description Function fired 
		 * we select the tee target
		 * @param {object} tee the target tee
		 * @param {boolean} launchNextStep launch Next Step just after the selection
		 * @returns {Event}
		 */
		ctrl.selectTee = function (tee, launchNextStep) {
			if (tee.authorized) {
				ctrl.selectedTee = tee;
				ctrl.onTeeSelected({ teeSelected: tee, launchNextStep: launchNextStep });
			} 
		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular.module('userApp').config(function ($httpProvider, httpRequestInterceptorCacheBusterProvider) {

		//CACHE BUSTER: Cache everything except rest api requests
		httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

		//INTERCEPTORS
		$httpProvider.interceptors.push('errorHandlerInterceptor');
		$httpProvider.interceptors.push('authExpiredInterceptor');
		$httpProvider.interceptors.push('authInterceptor');
		$httpProvider.interceptors.push('authReloadTokenInterceptor');
		$httpProvider.interceptors.push('forbiddenAccessInterceptor');

	});
})();

(function () {
	'use strict';

	angular.module('userApp').config(function ($translateProvider, tmhDynamicLocaleProvider) {

		// Initialize angular-translate
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: 'assets/i18n/{lang}/{part}.json'
		});

		$translateProvider.preferredLanguage('fr');
		$translateProvider.useCookieStorage();
		$translateProvider.useSanitizeValueStrategy(null);
		$translateProvider.addInterpolation('$translateMessageFormatInterpolation');

		tmhDynamicLocaleProvider.localeLocationPattern('lib/angular-i18n/angular-locale_{{locale}}.js');
		tmhDynamicLocaleProvider.useCookieStorage();
		tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
	});
})();

(function () {
	'use strict';

	angular.module('userApp').config(function (configProvider, ENV) {
		if (ENV === 'prod') {
			var url = location.protocol + '//' + location.host + location.pathname + 'front/configuration';
			$.get(url, function (configData) {
				configProvider.config(configData);
			});
		} else {
			$.get('/config/application-prod.json', function (configData) {
				configProvider.config(configData.ecmUser);
			});
		}
	});
})();

(function () {
	'use strict';

	angular.module('userApp').config(function (localStorageServiceProvider) {
		localStorageServiceProvider.setPrefix('userApp');
	});
})();

(function () {
	'use strict';
	angular.module('userApp').config(function (toastrConfig) {
		angular.extend(toastrConfig, {
			allowHtml: true,
			closeButton: true,
			closeHtml: '<button>&times;</button>',
			extendedTimeOut: 100,
			iconClasses: {
				error: 'toast-error',
				info: 'toast-info',
				success: 'toast-success',
				warning: 'toast-warning'
			},
			messageClass: 'toast-message',
			onHidden: null,
			onShown: null,
			onTap: null,
			progressBar: true,
			positionClass: 'toast-top-full-width',
			tapToDismiss: true,
			templates: {
				toast: 'directives/toast/toast.html',
				progressbar: 'directives/progressbar/progressbar.html'
			},
			timeOut: 5000,
			titleClass: 'toast-title',
			toastClass: 'toast',
			autoDismiss: true,
			maxOpened: 1
		});

	});
})();

(function () {
	'use strict';

	/** @ngInject */
	angular.module('userApp').config(function (ENV, uiSelectConfig, $uibTooltipProvider, tagsInputConfigProvider, blockUIConfig, uibPaginationConfig, ecmDatePickerConfig, uibDatepickerConfig) {

		//UI SELECT
		uiSelectConfig.theme = 'bootstrap';
		uiSelectConfig.appendToBody = false;

		//TOOLTIP
		$uibTooltipProvider.options({
			appendToBody: true
		});

		//ngTagsInput
		tagsInputConfigProvider.setDefaults('tagsInput', {
			placeholder: '',
			minLength: 2,
			replaceSpacesWithDashes: false
		});
		tagsInputConfigProvider.setActiveInterpolation('tagsInput', {
			placeholder: true
		});

		//BLOCK UI
		// Disable automatically blocking of the user interface
		blockUIConfig.autoBlock = false;
		blockUIConfig.templateUrl = 'scripts/pre-upgrade/components/commons/blockUI/default.tpl.html';
		blockUIConfig.message = 'global.LOADING';

		//PAGINATION
		uibPaginationConfig.itemsPerPage = 20;
		uibPaginationConfig.rotate = true;
		uibPaginationConfig.maxSize = 4;
		uibPaginationConfig.boundaryLinks = true;
		uibPaginationConfig.firstText = '«';
		uibPaginationConfig.previousText = '‹';
		uibPaginationConfig.nextText = '›';
		uibPaginationConfig.lastText = '»';
		uibPaginationConfig.boundaryLinkNumbers = false;

		//ECM DATE PICKER
		ecmDatePickerConfig.forceUTC = true;
	});

	angular.module('userApp')
		.run(function ($templateCache) {
			$templateCache.put('template/smart-table/pagination.html',
				'<ul ng-if="pages.length > 1" uib-pagination total-items="totalItemCount" items-per-page="stItemsByPage" ng-model="currentPage" ng-change="selectPage(currentPage)"> </ul> ');
		});

})();

(function () {
	'use strict';

	angular.module('userApp').config(function ($urlMatcherFactoryProvider) {

		$urlMatcherFactoryProvider.type('boolean', {
			name: 'boolean',
			decode: function (val) {
				return val === true ? true : val === "true" ? true : false;
			},
			encode: function (val) {
				return val ? 1 : 0;
			},
			equals: function (a, b) {
				return this.is(a) && a === b;
			},
			is: function (val) {
				return [true, false, 0, 1].indexOf(val) >= 0;
			},
			pattern: /bool|true|0|1/
		});

	});
})();

(function () {
	'use strict';

	angular.module("userApp").provider("config", function () {
		var options = {};
		this.config = function (opt) {
			angular.extend(options, opt);
		};
		this.$get = function () {
			if (!options) {
				throw new Error('Config options must be configured');
			}
			return options;
		};
	});
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('announcementResource', AnnouncementResource);

	/** @ngInject */
	function AnnouncementResource($resource) {
		return $resource('api/announcements', {}, {
			'getCurrentAnnouncement': {
				url: 'api/announcements/current',
				method: 'GET'
			},
			'saveAnnouncement': {
				url: 'api/announcements',
				method: 'POST'
			},
			'deleteAllAnnouncements': {
				url: 'api/announcements',
				method: 'DELETE'
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('batchResource', batchResource);


	/** @ngInject */
	function batchResource($resource) {
		return $resource('api/batch', {}, {
			'getAllConfigs': {
				url: 'api/batch/getAllConfigs',
				method: 'GET',
				isArray: true
			},
			'requestBatchProcess': {
				url: 'api/batch/requestBatchProcess',
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('bulkOperationsResource', bulkOperationsResource);


	/** @ngInject */
	function bulkOperationsResource($resource) {
		return $resource('api/bulkoperations', {}, {
			'getBulkOperations': {
				url: 'api/bulkoperations/getBulkOperations',
				method: 'GET',
				isArray: false
			},
			'replayFailedOperations': {
				url: 'api/bulkoperations/replayFailedOperations',
				method: 'POST'
			},
			'purgeOperations': {
				url: 'api/bulkoperations/purgeOperations/:result',
				method: 'DELETE'
			}
		});
	}
})();

/* eslint-disable indent */
(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('configurationLocalUserResource', ConfigurationLocalUserResource);

	/** @ngInject */
	function ConfigurationLocalUserResource($resource) {
		return $resource('api/configLocal', {}, {
			'getListConfigLocalStorageByCurrentUser': {
				url: 'api/configLocal/listconfigLocalStorage',
				method: 'GET'
			},
			'addConfigLocalStrorage': {
				url: 'api/configLocal',
				method: 'POST',
				params: {
					keyData: '@keyData'
				},
			},
			'updateConfigLocalStrorage': {
				url: 'api/configLocal',
				method: 'PUT',
				isArray: false
			},
			'displayConfiguration': {
				url: 'api/configLocal/listconfigLocalStorage',
				method: 'GET',
				isArray: true
			},
			'getConfigLocalStorageByKey': {
				url: 'api/configLocal/configlocalStroage/:key',
				method: 'GET',
				isArray: true
			},
			'deleteConfigStorage': {
				url: 'api/configLocal/delete',
				method: 'DELETE'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('userApp')
		.factory('debugResource', DebugResource);

	/** @ngInject */
	function DebugResource($resource) {
		var resourceUrl = 'api/debug/';
		return $resource(resourceUrl, {}, {

			'sendSolrRequest': {
				method: 'POST',
				url: resourceUrl + 'solr',
				transformResponse: function (data) {
					return angular.fromJson(data);
				}
			},
			'sendMariaRequest': {
				method: 'POST',
				url: resourceUrl + 'maria',
				isArray: true
			},
			'sendLogRequest': {
				method: 'POST',
				url: resourceUrl + 'log/lines',
				isArray: true
			},
			'getLogFiles': {
				method: 'GET',
				url: resourceUrl + 'log/file/list',
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('deploymentResource', DeploymentResource);

	/** @ngInject */
	function DeploymentResource($resource) {
		return $resource('api/deployment/', {}, {
			'deploy': {
				method: 'GET',
				url: 'api/deployment/import'
			},
			'getCurrentConfigurationVersion': {
				method: 'GET',
				url: 'api/deployment/configuration'
			},
			'getCurrentEpmVersion': {
				method: 'GET',
				url: 'api/deployment/epm/current'
			},
			'getActiveEpmVersions': {
				method: 'GET',
				url: 'api/deployment/epm/versions',
				isArray: true
			},
			'saveEpmVersion': {
				method: 'POST',
				url: 'api/deployment/epm/save',
				isArray: true,
				params: {
					version: '@version'
				}
			},
			'enableEpm': {
				method: 'POST',
				url: 'api/deployment/epm/toggle',
				isArray: false,
				params: {
					enabled: '@enabled'
				},
			},

		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityMediaResource', EntityMediaResource);

	/** @ngInject */
	function EntityMediaResource($resource) {
		return $resource('api/editorialEntity/fileFormatInstances', {}, {
			'deleteMediaAndUpdateEntity': {
				url: 'api/editorialEntity/fileFormatInstances/deleteFile/:idMedia',
				method: 'DELETE',
				params: {
					entityId: '@entityId',
					fileFormatCode: '@fileFormatCode'
				},
				isArray: true
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('userApp')
		.factory('ermResource', ERMResource);

	/** @ngInject */
	function ERMResource($resource) {
		var resourceUrl = 'api/erm/';
		return $resource(resourceUrl, {}, {

			'getCurrentVersion': {
				method: 'GET',
				url: resourceUrl + 'current'
			},
			'getActiveVersion': {
				method: 'GET',
				url: resourceUrl + 'version/active',
				isArray: true
			},
			'changeVersion': {
				method: 'GET',
				url: resourceUrl + 'version/set'
			},
			'enableErm': {
				method: 'GET',
				url: resourceUrl + 'enable'
			},
			'disableErm': {
				method: 'GET',
				url: resourceUrl + 'disable'
			},
			'checkConfigExits': {
				method: 'GET',
				url: resourceUrl + 'check',
				transformResponse: function (data) {
					return { exist: data };
				}
			}
		});
	}

})();

(function () {
	'use strict';


	angular.module('userApp')
		.factory('monitoringResource', MonitoringResource);

	/** @ngInject */
	function MonitoringResource($resource) {
		return $resource('api/monitoring', {}, {
			'getAppsHealth': {
				method: 'GET',
				url: 'api/monitoring/health',
				isArray: true
			},
			'getAppHealth': {
				method: 'GET',
				url: 'api/monitoring/health/:appName',
				isArray: true
			},
			'getApps': {
				method: 'GET',
				url: 'api/monitoring/apps',
				isArray: true
			},
			'getDownApps': {
				method: 'GET',
				url: 'api/monitoring/apps/down',
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('referentialResource', ReferentialResource);

	/** @ngInject */
	function ReferentialResource($resource) {
		return $resource('api/referential/filtred', {}, {
			'getReferentialById': {
				method: 'GET',
				url: 'api/referential/filtred/:id/',
				isArray: true,
				transformResponse: function (data) {
					return angular.fromJson(data);
				}
			},
			'getReferentialByIdPageable': {
				method: 'GET',
				url: 'api/referential/filtredByPage/:id/',
				params: {
					searchText: '@searchText',
					metaDataCode: '@metaDataCode',
					lang: '@lang',
					filters: '@filters',
					page: '@page',
					size: '@size'
				},
				isArray: true,
				transformResponse: function (data) {
					return angular.fromJson(data);
				}
			},
			'getLinkedValues': {
				method: 'post',
				url: 'api/referential/linkedValues',
				isArray: true
			}
		});
	}

})();


(function () {
	'use strict';

	angular.module('userApp')
		.factory('urlResource', URLResource);

	/** @ngInject */
	function URLResource($resource) {
		var resourceUrl = 'api/url/';
		return $resource(resourceUrl, {}, {
			'checkConnection': {
				method: 'POST',
				url: resourceUrl + 'checkConnection',
				params: {
					url: '@url'
				},
				isArray: false,
				transformResponse: function (data) {
					return {
						body: data
					};
				}
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('webImportResource', WebImportResource);


	/** @ngInject */
	function WebImportResource($resource) {
		return $resource('api/webImport', {}, {
			'getAllConfigs': {
				url: 'api/webImport/getAllConfigs',
				method: 'GET',
				isArray: true
			},
			'requestWebimportProcess': {
				url: 'api/webImport/requestWebImportProcess',
				method: 'POST'
			},
			'getImportAssociatedProducts': {
				url: 'api/webImport/getImportAssociatedProducts',
				method: 'GET',
				isArray: true
			},
			'getWebImportHistory': {
				url: 'api/webImport/getWebImportHistory',
				method: 'POST'
			},
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('xmlEditionResource', xmlEditionResource);


	/** @ngInject */
	function xmlEditionResource($resource) {
		return $resource('api/xmlEdition', {}, {
			'getXml': {
				url: 'api/xmlEdition/xml/:entityFlashId',
				params: {
					eetCode: '@eetCode'
				},
				method: 'GET',
				isArray: false
			},
			'saveXml':{
				url: 'api/xmlEdition/save',
				method: 'POST'
			},
			'validateXml':{
				url: 'api/xmlEdition/validate',
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/');
		$stateProvider.state('site', {
			'abstract': true,			
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('error');
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('announcementEvents', {
			ADD_ANNOUNCEMENT: "ADD_ANNOUNCEMENT",
			DELETE_ANNOUNCEMENT: "DELETE_ANNOUNCEMENT"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('announcementMessages', {
			ECM: "ecm",
			MONITORING: "monitoring"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('authorizeConstants', {
			initWorkflowUpdate: "INIT_WFW_UPDATE",
			editWorkflow: "CHANGE_WFW_UPDATE",
			editMetadata: "EDIT_META",
			initAndEditMetadata: "INIT_AND_EDIT_META",
			editContent: "EDIT_CONTENT",
			initAndEditContent: "INIT_AND_EDIT_CONTENT",
			control: "VALIDATE_EE",
			publish: "PUBLISH"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('editMetaUseCaseConstants', {
			editMeta: "EDIT_META",
			convertCreatingNewEntity: "CONVERT_CREATE_NEW_ENTITY",
			convertOverwritingExistingEntity: "CONVERT_OVERWRITE_EXISTING_ENTITY"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('EDITORIAL_RESPONSE_STATUS', {
			"OK": "OK",
			"KO": "NOK",
			"CANCEL": "CANCEL"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('EDITORIAL_ELEMENT_TYPE', {
			entity: "ENTITY",
			structural: "STRUCTURAL",
			reference: "REFERENCE",
			query: "QUERY",
			content: "CONTENT",
			model: "MODEL",
			relation: 'RELATION',
			product: 'PRODUCT',
			deletedEntity: 'DELETED_ENTITY'
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('ENTITY_RESOURCE_TYPE', {
			proofReading: 'PROOFREADING',
			summary: "SUMMARY",
			reorderTree: "REORDER_TREE"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('HTML_PREVIEW_TYPE', {
			complete: "COMPLETE",
			summary: "SUMMARY",
			restricted: "RESTRICTED",
			insertionAbstract: "INSERTION_ABSTRACT"
		});
})();

(function() {
	'use strict';

	angular
		.module('userApp')
		.constant('PRODUCT_ACTION_ENUM', {
			DUPLICATE: "DUPLICATE",
			ACCEPT: "ACCEPT",
			DECLINE: "DECLINE",
			DELETE: "DELETE"
		});
}) ();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('PUBLICATION_STATUS', {
			TO_BE_PUBLISHED: "TO_BE_PUBLISHED",
			TO_BE_REPUBLISHED: "TO_BE_REPUBLISHED",
			TO_BE_UNPUBLISHED: "TO_BE_UNPUBLISHED",
			TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED: "TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED",
			TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED_AND_TO_BE_UNPUBLISHED: "TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED_AND_TO_BE_UNPUBLISHED",
			ALL: "ALL",
		});
})();

(function () {
	'use strict';
  /**
   * @ngdoc constant
   * @name adminApp.constant:SYSTEM_METADATA_IDENTIFIERS
   * @function
   * @description
   * # System meta data identifiers.
   */
	angular.module('userApp')
		.constant('SYSTEM_METADATA_IDENTIFIERS', {
			systemTitle: "systemTitle",
			systemType: "systemType",
			systemActivated: "systemActivated"
		});
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('FACETCONFIG', {
			"showLimit": 5
		});
})();

/**
	* @ngdoc constant
	* @name adminApp.constant:constant
	* @function
	* @description
	* # constant
	*/
angular.module('userApp')
	.constant('TREE_FLAT_VIEW', {
		PUBLICATION_FILTER_NAME: 'publication'
	});

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('USER_PREFERENCE', {
			pagination: {
				storageKey: 'ecm-pagination',
				views: {
					treeFlatView: "treeFlatViewPagination",
					tir: "tirPagination"
				}
			},
			table: {
				storageKey: 'ecm-table'
			},
			facet: {
				storageKey: 'facet'
			},
			global: {
				storageKey: 'global'
			},
			treeView: {
				storageKey: 'tree-view'
			}
		});

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('activeLink', activeLink);

	activeLink.inject = ['$location'];

	function activeLink($location) {


		var directive = {
			link: link,
			restrict: 'A'
		};

		return directive;

		function link(scope, element, attrs, controller) {
			var clazz = attrs.activeLink;
			var path = attrs.href;
			path = path.substring(1);
			scope.location = $location;
			scope.$watch('location.path()', function (newPath) {
				if (path === newPath) {
					element.addClass(clazz);
				} else {
					element.removeClass(clazz);
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('activeMenu', activeMenu);

	activeMenu.inject = ['$translate', '$locale', 'tmhDynamicLocale'];

	function activeMenu($translate, $locale, tmhDynamicLocale) {


		var directive = {
			link: link,
			restrict: 'A'
		};

		return directive;

		function link(scope, element, attrs) {
			var language = attrs.activeMenu;

			scope.$watch(function () {
				return $translate.use();
			}, function (selectedLanguage) {
				if (language === selectedLanguage) {
					tmhDynamicLocale.set(language);
					element.addClass('active');
				} else {
					element.removeClass('active');
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('ecmCollapse', ecmCollapse);

	ecmCollapse.inject = ['$timeout', '$parse'];

	function ecmCollapse($timeout, $parse, $animate) {
		// Usage:
		//
		// Creates:
		//
		var directive = {
			link: link,
			restrict: 'A'
		};
		return directive;

		function link(scope, ngElement, attrs) {
			var element = ngElement[0];
			ngElement.addClass('ecm-collapsable');
			var delay = angular.isDefined(attrs.delay) ? $parse(attrs.delay)(scope) : 0;

			scope.$watch(attrs.ecmCollapse, function (collapse) {
				if (collapse) {
					element.style.height = 0 + 'px';
					element.style.marginTop = 0 + 'px';
				} else {
					$timeout(function () {
						var newHeight = getElementHeight();
						element.style.height = newHeight + 'px';
						element.style.marginTop = '';
					}, delay);
				}
			});

			function getElementHeight() {
				return element.scrollHeight;
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('ecmPreviewHtml', ecmPreviewHtml);

	ecmPreviewHtml.$inject = ['$timeout', '$window', '$sce', "$parse", "htmlPreviewService"];

	function ecmPreviewHtml($timeout, $window, $sce, $parse, htmlPreviewService) {
		// Usage:
		//<ecm-preview-html content='html'></ecm-preview-html>
		// Creates:
		// an iframe with content embeded
		//
		var directive = {
			link: link,
			restrict: 'E',
			template: '<iframe scrolling="no" ng-cloak style="display: inline;border:solid 0px green;width: 100%;overflow: hidden;vertical-align:top;"></iframe>'
		};
		return directive;

		function link(scope, element, attrs) {
			element.css('display', 'block');
			var iframe = element.find('iframe');

			var htmlContent = iframe.contents().find('html');
			var body = htmlContent.find('body');

			// dispatch move event for resize
			iframe[0].contentWindow.addEventListener('mousemove', function (event) {
				var boundingClientRect = iframe[0].getBoundingClientRect();

				var evt = new CustomEvent('mousemove', {
					bubbles: true,
					cancelable: false
				});
				evt.clientX = event.clientX + boundingClientRect.left;
				evt.clientY = event.clientY + boundingClientRect.top;
				evt.pageX = event.pageX + boundingClientRect.left;
				evt.pageY = event.pageY + boundingClientRect.top;

				iframe[0].dispatchEvent(evt);
			});

			// Resize when the iframe is completly loaded ( css, img, etc).
			iframe[0].onload = function () {
				resizeIFrame();
			};

			// Sometimes the height is not right, we check to be sure
			function checkHeight() {
				$timeout(function () {
					var currentHeight = iframe.height();
					var htmlHeight = htmlContent.height();

					if (currentHeight !== htmlHeight) {
						iframe.height(htmlHeight);
					}
				});
			}

			function resizeIFrame() {
				//fix element height so we don't lose scrolling position'
				var elemHeight = element.height();
				element.height(elemHeight);

				//we need to reset the iframe height to get the real content height
				iframe.height(0);
				var htmlHeight = htmlContent.height();
				iframe.height(htmlHeight);
				checkHeight();

				element.height('auto');
			}

			function destroy() {
				angular.element($window).off('resize', resizeIFrame);
			}

			var edit = false;
			if (angular.isDefined(attrs.edit) && angular.isDefined(attrs.edit)) {
				var editMode = $parse(attrs.edit);
				var selectedValueSetter = $parse(attrs.selected).assign;
				edit = editMode(scope);
			}

			var ngBindHtmlGetter = $parse(attrs.content);
			var ngBindHtmlWatch = $parse(attrs.content, function sceValueOf(val) {
				// Unwrap the value to compare the actual inner safe value, not the wrapper object.
				return $sce.valueOf(val);
			});

			function addSelectors() {
				//Retrieve all divs with an id attribute
				var divs = body.find('div[id]');
				var containsSubElements = $parse(attrs.contains).assign;

				if (divs.length > 0) {
					containsSubElements(scope, true);
				}
				//Add a radio button for each div
				angular.forEach(divs, function (value, key) {
					//Radio button
					var radioBut = angular.element('<input type="radio" value="' + value.getAttribute('id') + '" name="selection"></input>');
					radioBut.on("click", function () {
						selectedValueSetter(scope, this.value);
						scope.$apply();
					});

					//Add to div component
					value.prepend(radioBut[0]);
				});
			}

			function handleHighlight(content) {
				var hlEnabledAttr = attrs.hlEnabled;
				if (angular.isUndefined(hlEnabledAttr) || scope.$eval(hlEnabledAttr)) {
					var searchTerms = $parse(attrs.searchTerms)(scope);
					if (!_.isEmpty(searchTerms)) {
						angular.element(body).mark(searchTerms,
							{
								accuracy: {
									value: 'exactly',
									limiters: ['-', '/']
								},
								separateWordSearch: false,
								element: "ecm-hl",
								className: "ecm-highlight",
							});
					}
				}
			}

			scope.$watch(ngBindHtmlWatch, function () {
				var value = ngBindHtmlGetter(scope);
				var contentText = $sce.getTrustedHtml(value);

				var idoc = iframe[0].contentWindow.document;
				idoc.open();
				idoc.write(contentText ? contentText : '');
				idoc.close();

				htmlContent = iframe.contents().find('html');
				var head = htmlContent.find('head');
				head.append('<style>.ecm-highlight { background: yellow} .ecm-previ-alert { background-color: #f2dede;border-color: #ebcccc;color: #a94442; padding: .75rem 1.25rem; margin-bottom: 1rem;  border: 1px solid transparent;border-radius: .25rem;} .comparison-deleted, .comparison-deleted>*,del, del>* {color: red; text-decoration: line-through; background-color: #f8d7da; } .comparison-added,.comparison-added>*,ins, ins>*  {color: green; text-decoration: none; background-color: #d4edda; } .erm-version { clear:both; margin-top:12px} </style>');

				body = htmlContent.find('body');

				// Use jquery plugin to resize IFrames when all images are loaded
				body.imagesLoaded(function () {
					resizeIFrame();
				});

				if (edit === true) {
					addSelectors();
				}

				htmlPreviewService.updateHref(body);
				handleHighlight();
				resizeIFrame();
			});

			scope.$watch(function () {
				return {
					'w': iframe.width()
				};
			}, function () {
				resizeIFrame();
			}, true);

			angular.element($window).on('resize', resizeIFrame);
			scope.$on('$destroy', destroy);
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('userApp')
		.directive('uiselectScrollBottom', uiselectScrollBottom);
	function uiselectScrollBottom() {
		return {
			link: function (scope, ngElement) {
				var handler;
				var element = ngElement[0];
				handler = function () {
					if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
						scope.callbackFn();
					}
				};
				ngElement.on('scroll', handler);
				scope.$on("UISelect_Data_Ready", function () {
					var uiSelectParent = ngElement.parent()[0];
					if (uiSelectParent) {
						var uiSelectTextField = uiSelectParent.getElementsByClassName('ui-select-search')[0];
						if (uiSelectTextField) {
							uiSelectTextField.focus();
						}
					}
				});
			},
			scope: {
				callbackFn: "&"
			}
		};

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('expose', expose);

	function expose() {

		var directive = {
			link: link,
			restrict: 'A',
			require: 'stTable',
		};

		return directive;
		function link(scope, element, attr, ctrl) {
			scope.smartTableState = ctrl.tableState();
		}
	}
})();

'use strict';

angular.module('userApp')
	.factory('authInterceptor', function ($rootScope, $q, $location, userPreferenceService) {
		return {
			// Add authorization token to headers
			request: function (config) {
				config.headers = config.headers || {};
				var token = userPreferenceService.getUserGlobalPreference('token');

				if (token) {
					config.headers['x-auth-token'] = token.token;
				}

				return config;
			}
		};
	})
	.factory('authReloadTokenInterceptor', function ($rootScope, $q, $location, userPreferenceService, USER_PREFERENCE, $injector) {
		var token = userPreferenceService.getUserGlobalPreference('token');
		return {
			// Reload token
			response: function (response) {
				if (response.headers('x-auth-token')
					&& response.headers('x-auth-token-expires')
					&& token && token.token !== response.headers('x-auth-token')) {
					token.token = response.headers('x-auth-token');
					token.expires = response.headers('x-auth-token-expires');		
					userPreferenceService.setUserGlobalPreference('token', token);
				}
				return response;
			}
		};
	})
	.factory('authExpiredInterceptor', function ($rootScope, $q, $injector, userPreferenceService, blockUI) {
		return {
			responseError: function (response) {
				// token has expired
				if (response.status === 401) {
					userPreferenceService.removeFromUserGlobalPreference('token');
					var Principal = $injector.get('Principal');
					if (Principal.isAuthenticated()) {
						blockUI.stop();
						var LoginService = $injector.get('LoginService');
						LoginService.open();
						// var Auth = $injector.get('Auth');
						// Auth.authorize(true);
					}
				}
				return $q.reject(response);
			}
		};
	})
	.factory('forbiddenAccessInterceptor', function ($rootScope, $q, $injector, $translate, userPreferenceService, blockUI) {
		return {
			responseError: function (response) {
				// token has expired
				if (response.status === 403) {
					blockUI.stop();
					//GET MODAL SERVICE
					var ModalAlertService = $injector.get('ModalAlertService');
					//GET ERROR
					if (response.data) {
						var error = response.data;
						//SHOW ERROR MODAL
						var message = error.message ? error.message : error;
						ModalAlertService.error($translate.instant(message));
					}
				}
				return $q.reject(response);
			}
		};
	});

'use strict';

angular.module('userApp')
	.factory('errorHandlerInterceptor', function ($q, $rootScope, $injector, $translate, blockUI) {
		return {
			'responseError': function (response) {
				//406 is used to manage media file validation exception
				if (!(response.status === 401) && !(response.status === 403) && !(response.status === 406)) {
					$rootScope.$emit('userApp.httpError', response);
					//STOP LOADING
					blockUI.stop();
					//GET MODAL SERVICE
					var ModalAlertService = $injector.get('ModalAlertService');
					var openErrorModalService = $injector.get('openErrorModalService');

					//GET ERROR
					if (response.data) {
						var error = response.data.body ? response.data.body : response.data;
						//SHOW ERROR MODAL
						var message = error.message ? error.message : error.body ? error.body : error;
						var params = error.params ? error.params.join() : message === 'import.error' ? error.description : '';
						var solrError = angular.isDefined(error.codeDetail) && error.codeDetail === "solr.syntax.error";
						var importError = angular.isDefined(error.codeDetail) && (error.codeDetail === "IMPORT_CONCURRENCY_ERROR" ||
							error.codeDetail === 'IMPORT_NO_ZIP_FOUND');

						if (solrError) {
							openErrorModalService.OpenModal($translate.instant(message), "userApp.searchInterfaceTemplate.error.backError");
						}
						else if (importError) {
							//DO NOTHING ==> THE CONFIGURATION SERVICE WILL HANDLE THIS ERROR BASED ON CODE.
						}
						else {
							ModalAlertService.error($translate.instant(message), params, solrError);
						}

					}
				}
				return $q.reject(response);
			}
		};
	});

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('betterOrderBy', betterOrderByFilter);

	function betterOrderByFilter($filter) {
		return function (input, arg1, arg2) {

			if (!input[0]) {
				return $filter('orderBy')(input, arg1, arg2);
			}

			var copy_of_input = angular.copy(input);

			function normalize(str) {
				str = str.toLowerCase();
				str = str.replace(/\\s/g, "");
				str = str.replace(/[àáâãäå]/g, "a");
				str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");
				str = str.replace(/æ/g, "ae");
				str = str.replace(/Æ/g, "AE");
				str = str.replace(/’/g, "'");
				str = str.replace(/[“”«»]/g, "");
				str = str.replace(/ç/g, "c");
				str = str.replace(/Ç/g, "C");
				str = str.replace(/[èéêë]/g, "e");
				str = str.replace(/[ÈÉÊË]/g, "E");
				str = str.replace(/[ìíîï]/g, "i");
				str = str.replace(/[ÌÍÎÏ]/g, "I");
				str = str.replace(/ñ/g, "n");
				str = str.replace(/Ñ/g, "N");
				str = str.replace(/[òóôõö]/g, "o");
				str = str.replace(/[ÒÓÔÕÖ]/g, "O");
				str = str.replace(/œ/g, "oe");
				str = str.replace(/Œ/g, "OE");
				str = str.replace(/[ùúûü]/g, "u");
				str = str.replace(/[ÙÚÛÜ]/g, "U");
				str = str.replace(/[ýÿ]/g, "y");
				str = str.replace(/[ÝŸ]/g, "Y");
				str = str.replace(/\\W/g, "");
				return str.trim();
			}

			for (var i = 0; i < input.length; i++) {
				copy_of_input[i]['orig'] = input[i];

				if (angular.isString(input[i][arg1])) {
					copy_of_input[i][arg1] = normalize(copy_of_input[i][arg1]);
				}
			}
			var normalized_sorted = $filter('orderBy')(copy_of_input, arg1, arg2);
			var normalized_sorted_orig = [];
			angular.forEach(normalized_sorted, function (obj, i) {
				normalized_sorted_orig.push(obj.orig);
			});
			return normalized_sorted_orig;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('concatStrings', concatStrings);

	function concatStrings() {
		return function (stringArray, separator) {
			return (angular.isUndefined(stringArray) || stringArray.length === 0) ?
				'' : stringArray.join(angular.isUndefined(separator) ? ', ' : separator);
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('ecmBoolean', ecmBooleanFilter);

	function ecmBooleanFilter($filter) {
		return function (input) {
			if (input === 'true' || input === 'false' || typeof input === 'boolean') {
				return (input === 'true' || input === true) ?
					$filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.checkboxTrueValue') :
					$filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.checkboxFalseValue');
			}
			if (input === 'VALID') {
				return $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.valid');
			}
			if (input === 'WAITING') {
				return $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.waiting');
			}
			if (input === 'DELETED') {
				return $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.deleted');
			}
			if (input === 'RESTORE') {
				return $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.restore');
			}
			return input;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('ecmDate', ecmDateFilter);

	function ecmDateFilter($filter, moment) {
		return function (input, format) {
			if (moment(input, moment.ISO_8601).isValid()) {
				var value = moment.isMoment(input) ? input.format() : input;
				if (!format) {
					format = $filter('translate')('global.dateFormat');
				}
				return $filter('date')(value, format);
			}
			return input;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('ecmDateTir', ecmDateTirFilter);

	function ecmDateTirFilter($filter, moment) {
		return function (input, format) {
			var formattedString = '';
			if (input) {
				var results = input.split('||');
				for (var i=0, len=results.length; i < len ; i++) {
					var stringToFormat = results[i].trim();
					if (moment(stringToFormat, moment.ISO_8601).isValid()) {
						if (!format) {
							format = $filter('translate')('global.dateFormat');
						}
						formattedString = formattedString + ( i!==0 ? ' || ' : '') + $filter('date')(stringToFormat, format);
					}
					else {
						formattedString = formattedString + ( i!==0 ? ' || ' : '') + stringToFormat;
					}
				}
				return formattedString;
			} else {
				return input;
			}
		};
	}
})();

'use strict';

(
	function (angular) {
		return angular
			.module('userApp')
			.filter('orderObjectBy', function () {
				return function (items, field, reverse) {

					// function isNumeric(n) {
					// 	return !isNaN(parseFloat(n)) && isFinite(n);
					// }

					var filtered = [];

					angular.forEach(items, function (item, key) {
						item.key = key;
						filtered.push(item);
					});

					// function index(obj, i) {
					// 	return obj[i];
					// }

					filtered.sort(function (a, b) {
						var comparator;
						// var reducedA = field.split('.').reduce(index, a);
						// var reducedB = field.split('.').reduce(index, b);

						// if (isNumeric(reducedA) && isNumeric(reducedB)) {
						// 	reducedA = Number(reducedA);
						// 	reducedB = Number(reducedB);
						// }

						// if (reducedA === reducedB) {
						// 	comparator = 0;
						// } else {
						// 	comparator = reducedA > reducedB ? 1 : -1;
						// }

						return comparator;
					});

					// if (reverse) {
					// 	filtered.reverse();
					// }

					return filtered;
				};
			});
	}
)(angular);

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('formatValidationError', formatValidationErrorFilter);

	function formatValidationErrorFilter($filter, moment) {
		return function (input) {
			if(input) {
				if(input.startsWith("errorEditionStatePresentForEE")) {
					var results = input.split(',');
					var formattedString = '';
					for(var i in results){
						var stringToFormat = results[i].trim();
						formattedString = formattedString + (i!==0? ' : ' : '') +  $filter('translate')('userApp.editorialEntity.editionStatus.'+stringToFormat);
					}
					return formattedString;
				}
				return input;
			}
			return input;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('highlightFirst', highlightFirstFilter);

	function highlightFirstFilter($filter, moment, stringUtil) {
		return function (input, searchString, first) {

			if (!_.isEmpty(input) && !_.isEmpty(searchString)) {
				var noAccentInput = stringUtil.noAccent(input.toLowerCase());
				var noAccentSearchString = stringUtil.noAccent(searchString.toLowerCase());
				var index = noAccentInput.indexOf(noAccentSearchString);
				var length = searchString.length;
				if (index >= 0) {
					var originalText = input.substr(index, length);
					if (!first) {
						var pattern = new RegExp(originalText, "gi");
						return input.replace(pattern, '<span class="ui-select-highlight">$&</span>');
					}
					else if (index === 0) {
						return input.replace(originalText, '<span class="ui-select-highlight">' + originalText + '</span>');
					}
				}
			}
			return input;

		};
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('highlighter', highlighterFilter);

	function highlighterFilter($filter, moment) {
		return function (input, searchTerms) {
			if (!_.isEmpty(input) && !_.isEmpty(searchTerms)) {

				//	THE WORDS OF SEARCH COULD BE SEPARATED EITHER BY SPACE OR + SIGN 
				var terms = '';
				if (searchTerms.indexOf("+") !== -1) {
					terms = searchTerms.split("+");
				}
				else {
					terms = searchTerms.split(/\s+/);
				}


				var pattern = new RegExp(_.join(terms, '|'), "gi");
				var res = input.replace(pattern, '<span class="highlight">$&</span>');
				return res;
			} else {
				return input;
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('split', split);

	function split($filter) {
		return function (value, separator, splitIndex) {
			if (angular.isUndefined(value) || !value.length) return;
			return value.split(separator)[splitIndex];
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('StrictFilter', strictFilter);

	function strictFilter($filter) {
		return function (input, predicate) {
			return $filter('filter')(input, predicate, true);
		};
	}
})();

(function () {
	//Port of String.Format from C# to Angular written by David Votrubec - st-software.com
	//http://davidjs.com
	//Based on String.js from Ajax Control Toolkit - http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js

	// Placehoders processing
	angular.module('userApp').filter('stringFormat', function () {

		// function _toFormattedString is based on String.js from http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
		// as seen in http://stackoverflow.com/questions/2534803/string-format-in-javascript
		function toFormattedString(useLocale, format, values) {
			var result = '';

			for (var i = 0; ;) {
				// Find the next opening or closing brace
				var open = format.indexOf('{', i);
				var close = format.indexOf('}', i);
				if ((open < 0) && (close < 0)) {
					// Not found: copy the end of the string and break
					result += format.slice(i);
					break;
				}
				if ((close > 0) && ((close < open) || (open < 0))) {

					if (format.charAt(close + 1) !== '}') {
						throw new Error('format stringFormatBraceMismatch');
					}

					result += format.slice(i, close + 1);
					i = close + 2;
					continue;
				}

				// Copy the string before the brace
				result += format.slice(i, open);
				i = open + 1;

				// Check for double braces (which display as one and are not arguments)
				if (format.charAt(i) === '{') {
					result += '{';
					i++;
					continue;
				}

				if (close < 0) throw new Error('format stringFormatBraceMismatch');

				// Find the closing brace

				// Get the string between the braces, and split it around the ':' (if any)
				var brace = format.substring(i, close);
				var colonIndex = brace.indexOf(':');
				var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10);

				if (isNaN(argNumber)) throw new Error('format stringFormatInvalid');

				var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);

				var arg = values[argNumber];
				if (angular.isUndefined(arg) || arg === null) {
					arg = '';
				}

				// If it has a toFormattedString method, call it.  Otherwise, call toString()
				if (arg.toFormattedString) {
					result += arg.toFormattedString(argFormat);
				} else if (useLocale && arg.localeFormat) {
					result += arg.localeFormat(argFormat);
				} else if (arg.format) {
					result += arg.format(argFormat);
				} else
					result += arg.toString();

				i = close + 1;
			}

			return result;
		}

		return function ( /*string*/ template, /*array*/ values) {
			if (!values || !values.length || !template) {
				return template;
			}
			return toFormattedString(false, template, values);
		};
	});

})(this);

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('propsFilter', propsFilter);

	_.debounce(propsFilter(), 300);

	function propsFilter() {
		return function (items, props) {
			var out = [];

			if (angular.isArray(items)) {
				var keys = Object.keys(props);

				items.forEach(function (item) {
					var itemMatches = false;

					for (var i = 0; i < keys.length; i++) {
						var prop = keys[i];
						var text = props[prop].toLowerCase();
						if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
							itemMatches = true;
							break;
						}
					}

					if (itemMatches) {
						out.push(item);
					}
				});
			} else {
				// Let the output be the input untouched
				out = items;
			}

			return out;
		};
	}
})();




(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('validClassifName', validClassifName);

	function validClassifName($filter) {
		return function (input) {
			var output = input;
			if (!input || input.trim() === '') {
				output = $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.nullValue');
			}
			return output;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.filter('validName', validName);

	function validName($filter) {
		return function (input) {
			var output = input;
			if (!input || input.trim() === '' || input === 'Abstract undefined') {
				output = '<i>' + $filter('translate')('global.noTitle') + '</i>';
			}
			return output;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityAuthorizeResource', EntityAuthorizeResource);

	/** @ngInject */
	function EntityAuthorizeResource($resource) {
		return $resource('', {}, {
			'canPerform': {
				method: 'POST',
				url: 'api/editorialEntity/authorize/canPerform',
				params: {
					flashId: '@flashId',
					action: '@action'
				},
				isArray: false,
				transformResponse: function (data) {
					return {
						body: data
					};
				}
			},
			'secureAction': {
				method: 'POST',
				url: 'api/editorialEntity/authorize/secureAction',
				params: {
					flashId: '@flashId',
					action: '@action'
				},
				isArray: false
			},
			'permissions': {
				method: 'GET',
				url: 'api/editorialEntities/editorialEntityPermission/:id',
				isArray: true
			},
			'permissionsDTO': {
				method: 'GET',
				url: 'api/editorialEntities/editorialEntityPermissionsDTO/:id',
				isArray: false
			},
			'entityTemplatepermissions': {
				method: 'GET',
				url: 'api/editorialEntities/editorialEntityTemplatePermission',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	/**
	 * DEPRECATED : USE DEDICATED RESOURCE
	 */
	angular.module('userApp')
		.factory('entityCloneResource', EntityOperationResource);

	function EntityOperationResource($resource) {
		return $resource('api/editorialEntity', {}, {

			'getCloneableEntityValidationInfoDTO': {
				method: 'GET',
				url: 'api/editorialEntity/clone/:flashId/validation'
			},
			'cloneEE': {
				method: 'POST',
				url: 'api/editorialEntity/clone',
				transformResponse: function (data) {
					return {eeClonedFlashId: data};
				}
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityConvertResource', EntityConvertResource);

	/** @ngInject */
	function EntityConvertResource($resource) {
		return $resource('', {}, {
			'convert': {
				method: 'POST',
				url: 'api/editorialEntity/convert/tee',
				params: {
					flashId: '@flashId',
					targetTeeCode: '@targetTeeCode',
					createNewEntity: '@createNewEntity',
					productCode: '@contextProductCode'
				},
				isArray: false
			},
			'getConvertibleTemplates': {
				method: 'GET',
				url: 'api/erm/conversion/templates',
				params: {
					teeCode: '@teeCode',
					createNewEntity: '@createNewEntity'
				},
				isArray: true
			},
			'getPermissionStatus': {
				method: 'GET',
				url: 'api/editorialEntity/convert/permissionStatus',
				params: {
					flashId: '@flashId',
					createNewEntity: '@createNewEntity'
				}
			},
			'deletePublishedXml': {
				method: 'DELETE',
				url: 'api/editorialEntity/convert/deletePublishedXml',
				params: {
					flashId: '@flashId',
					sourceEetCode: '@sourceEetCode'
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityFetchResource', EntityFetchResource);

	/** @ngInject */
	function EntityFetchResource($resource) {
		return $resource('', {}, {
			'getByFlashId': {
				method: 'GET',
				url: 'api/editorialEntities/:flashId'
			},
			'getByShortId': {
				method: 'GET',
				url: 'api/editorialEntities/shortId/:shortId'
			},
			'getEditorialEntityTemplateId': {
				method: 'GET',
				url: 'api/editorialEntities/editorialEntityTemplate/:flashId',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return { eetId: data };
				}
			},
			'getEditorialEntityTemplateCode': {
				method: 'GET',
				url: 'api/editorialEntities/editorialEntityTemplateCode/:flashId',
				transformResponse: function (data) {

					return { eetCode: data };
				}
			},
			'isTree': {
				method: 'GET',
				url: 'api/editorialEntities/isTree/:flashId',
				params: {
					type: '@type'
				},
				transformResponse: function (data) {
					return { tree: data };
				}
			},
			'prepareFictiveEntityForPersist': {
				method: 'GET',
				url: 'api/editorialEntities/prepareForPersist',
				params: {
					flashId: '@flashId'
				}
			}


		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('entityLinkingResource', EntityLinkingResource);

	function EntityLinkingResource($resource) {
		return $resource('api/entity/linking', {}, {
			'searchHookedEEs': {
				method: 'POST',
				url: 'api/entity/linking/hookedEesSearch',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'searchEeLinkInfos': {
				method: 'POST',
				url: 'api/entity/linking/linkInfos',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'countEeLinkInfos': {
				method: 'POST',
				url: 'api/entity/linking/linkInfosCount',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'isLinkedEE': {
				method: 'GET',
				url: 'api/entity/linking/islinkedEE',
				params: {
					sourceEEFlashId: "",
					targetSubElementFlashId: "",
					targetEEFlashId: ""
				},
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'isLinkedEEList': {
				method: 'GET',
				url: 'api/entity/linking/islinkedEE/list',
				params: {
					sourceEEFlashId: "",
					targetSubElementFlashId: "",
					targetEEFlashIds: ""
				},
				isArray: true
			},
			'verifyLinkConditions': {
				method: 'GET',
				url: 'api/entity/linking/verifyConditions',
				params: {
					eeFlashIds: []
				}
			},
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityLockResource', EntityLockResource);

	/** @ngInject */
	function EntityLockResource($resource) {
		return $resource('', {}, {
			'padlock': {
				method: 'GET',
				url: 'api/entity/locking/padlock/:flashId'
			},
			'lock': {
				url: 'api/entity/locking/lock',
				method: 'POST',
				params: {
					flashId: '@flashId'
				}
			},
			'lockSourceEntity': {
				url: 'api/entity/locking/lockSourceEntity',
				method: 'POST',
				params: {
					flashId: '@flashId',
					type: '@type'
				}
			},
			'unlock': {
				url: 'api/entity/locking/unlock/:flashId',
				method: 'DELETE'
			},
			'unlockSourceEntity': {
				url: 'api/entity/locking/unlockSourceEntity/',
				method: 'DELETE'
			},
			'breakLock': {
				url: 'api/entity/locking/breakLock/:flashId',
				method: 'DELETE'
			},
			'isLockedByOtherUser': {
				url: 'api/entity/locking/isLockedByOtherUser/:flashId',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return { isLocked: data };
				}
			},
			'isLocked': {
				url: 'api/entity/locking/isLocked/:flashId',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return { isLocked: data };
				}
			},
			'isSourceEntityLocked': {
				url: 'api/entity/locking/isSourceEntityLocked',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return { isLocked: data };
				}
			},
			'unlockList': {
				url: 'api/entity/locking/unlockList',
				method: 'POST',
				params: {
					flashIds: '@flashIds'
				}
			}

		});
	}
})();

(function () {
	'use strict';

	/**
		* DEPRECATED : USE DEDICATED RESOURCE
		*/
	angular.module('userApp')
		.factory('entityOperationResource', EntityOperationResource);

	function EntityOperationResource($resource) {
		return $resource('api/editorialEntity/operations', {}, {
			'duplicateEE': {
				method: 'POST',
				url: 'api/editorialEntity/operations/duplicate',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getCloneableEntityValidationInfoDTO': {
				method: 'GET',
				url: 'api/editorialEntity/operations/clone/:flashId/validation'
			},
			'cloneEE': {
				method: 'POST',
				url: 'api/editorialEntity/operations/clone',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'archiveEE': {
				method: 'POST',
				url: 'api/editorialEntity/operations/archive'
			},
			'deleteEE': {
				method: 'DELETE',
				url: 'api/editorialEntity/operations/delete/:flashId'
			},
			'forceDeleteEE': {
				method: 'DELETE',
				url: 'api/editorialEntity/operations/delete/:flashId',
				params: {
					forceDelete: true
				}
			},
			'deleteEntityMulti': {
				method: 'POST',
				url: 'api/editorialEntity/operations/delete'
			},
			'archiveEditorialEntities': {
				method: 'POST',
				url: 'api/editorialEntity/operations/archive/list'
			},
			'updateProductGroupEE': {
				method: 'POST',
				url: 'api/editorialEntity/operations/update/productGroup/list',
			},
			'getListOfParent': {
				method: 'GET',
				url: 'api/editorialEntity/operations/listOfParents',
				isArray: true,
			},
			'getEntityStructure': {
				method: 'GET',
				url: 'api/editorialEntity/operations/entityStructure'
			},
			'getRelationTargetTeeCode': {
				method: 'GET',
				url: 'api/editorialEntity/operations/relation/target/teeCode',
				isArray: true,
			},
			'restoreEE': {
				method: 'POST',
				url: 'api/editorialEntity/operations/restore'
			},
			'restoreEditorialEntities': {
				method: 'POST',
				url: 'api/editorialEntity/operations/restore/list'
			},
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('entityTemplateResource', EntityTemplateResource);

	/** @ngInject */
	function EntityTemplateResource($resource) {
		return $resource('api/editorialEntityTemplates', {}, {
			'info': {
				method: 'GET',
				url: 'api/editorialEntityTemplates/info',
				params: {
					flashId: '@flashId',
					type: '@type'
				},
			},
			'getInstantiablesEET': {
				method: 'GET',
				url: 'api/editorialEntityTemplates/instantiables',
				isArray: true
			},
			'getEET': {
				url: 'api/editorialEntityTemplates/:codeTEE',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getMaxSize': {
				url: 'api/maxSizeMedia',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('entityTreeAutoAssemblingResource', EntityTreeAutoAssembling);

	/** @ngInject */
	function EntityTreeAutoAssembling($resource) {
		return $resource('api/treeAutoAssembling', {}, {
			'getMountingMetaDataList': {
				method: 'GET',
				url: 'api/treeAutoAssembling/getMountingMetaDataList/:eetCode',
				isArray: true
			},
			'searchTargetEntities': {
				method: 'POST',
				url: 'api/treeAutoAssembling/searchTargetEntities',
				params: {
					sourceEntityFlashId: '@sourceEntityFlashId',
					eetCode: '@eetCode',
					productCode: '@type'
				}
			},
			'assembling': {
				method: 'POST',
				url: 'api/treeAutoAssembling/assembling',
				params: {
					sourceEntityFlashId: '@sourceEntityFlashId'
				}
			},
			'spreadTargetEntities': {
				method: 'POST',
				url: 'api/treeAutoAssembling/spreadTargetEntities',
				params: {
					sourceEntityFlashId: '@sourceEntityFlashId'
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityUpdateResource', EntityUpdateResource);

	/** @ngInject */
	function EntityUpdateResource($resource) {
		return $resource('', {}, {
			'editGroup': {
				method: 'POST',
				url: 'api/editorialEntity/update/productGroup',
				params: {
					flashId: '@flashId',
					groupCode: '@groupCode'
				},
				isArray: false,
				transformResponse: function (data) {
					return { body: data };
				}
			},
			'editAuthors': {
				method: 'POST',
				url: 'api/editorialEntity/update/authors',
				params: {
					flashId: '@flashId',
					login: '@login'
				},
				isArray: false,
				transformResponse: function (data) {
					return { body: data };
				}
			},


			
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityValidateResource', EntityValidateResource);

	/** @ngInject */
	function EntityValidateResource($resource) {
		return $resource('', {}, {
			'validateEE': {
				method: 'GET',
				url: 'api/editorialEntities/validate/:id/:fullValidation'
			},
			'checkIfExist': {
				method: 'GET',
				url: 'api/editorialEntities/checkIfExist/:id',
				transformResponse: function (data) {
					return { exist: data === 'true' };
				}
			},
			'checkIfEntityExistWithSomeDiscriminants': {
				method: 'POST',
				url: 'api/editorialEntities/checkIfEntityExistWithSomeDiscriminants',
				params: {
					systemTee: '@systemTee',
					entityFlashId: '@entityFlashId'
				},
				transformResponse: function (data) {
					return { exist: data === 'true' };
				}
			},
			'checkValidationReportStatus': {
				method: 'GET',
				url: 'api/editorialEntities/report/status',
				transformResponse: function (data) {
					return { status: data };
				}
			},
			'checkIfEntityHasOnGoingOrAcceptedProposals': {
				method: 'GET',
				url: 'api/editorialEntities/hasProposals/:id/:product',
				transformResponse: function (data) {
					return { exist: data === 'true' };
				}
			}

		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('flatViewSettingsResource', flatViewSettingsResource);


	/** @ngInject */
	function flatViewSettingsResource($resource) {
		return $resource('api/flatviewsettings', {}, {
			'getFlatViewConfig': {
				method: 'GET',
				url: 'api/flatviewsettings/:eeFlashId',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('metadataResource', metadataResource);


	/** @ngInject */
	function metadataResource($resource) {
		return $resource('api/metadata', {}, {
			'getMetaInstanceToEdit': {
				method: 'GET',
				url: 'api/metadata/allMetaToEdit/:id',
				isArray: true
			}
			, 'getInstantiationMetaToDuplicate': {
				method: 'GET',
				url: 'api/metadata/instantiationMetaToDuplicate/:id',
				isArray: true
			},
			'getMetaInstanceListByCodeTee': {
				method: 'GET',
				url: 'api/metadata/multiEdit/allMetaByCodeTee/:codeTee',
				isArray: true
			},
			'getMetaInstanceToCreate': {
				method: 'GET',
				url: 'api/metadata/allMetaToCreate/:templateCode/:type',
				isArray: true,
				params: {
					parentId: '@parentId'
				}
			},
			'linkingMetaToCreate': {
				method: 'GET',
				url: 'api/metadata/linkingMetaToCreate',
				isArray: true,
				params: {
					relationTemplateCode: '@relationTemplateCode',
					sourceFlashId: '@sourceFlashId'
				}
			},
			'getMetaInstanceByGroup': {
				method: 'GET',
				url: 'api/metadata/allMetaByGroup/:id',
				transformResponse: function (data) {
					if (data) return angular.fromJson(data);


				},
				isArray: true
			},
			'checkIsValueUnique': {
				method: 'GET',
				url: 'api/metadata/:code/uniqueValue',
				params: {
					value: '@value',
					eeFlashId: '@eeFlashId',
					productCode: '@productCode'
				}
			},
			'checkIsAllValuesUnique': {
				method: 'GET',
				url: 'api/metadata/:code/uniqueValues',
				params: {
					values: '@values',
					eeFlashId: '@eeFlashId',
					productCode: '@productCode'
				}
			},
			'save': {
				method: 'POST',
				url: 'api/metadata/save',
				isArray: true,
				params: {
					flashId: '@flashId',
					type: '@type',
					productSuggestedPublicationDate: '@productSuggestedPublicationDate'
				}
			},
			'saveTitle': {
				method: 'POST',
				url: 'api/metadata/updateTitle',
				isArray: true,
				params: {
					flashId: '@flashId',
					SystemTitle: '@SystemTitle'
				}
			},
			'checkPermission': {
				method: 'POST',
				url: 'api/metadata/multiEdit/checkPermission',
				params: {
					flashIds: '@flashIds'
				},
				isArray: false
			},
			'editMultiple': {
				method: 'POST',
				url: 'api/metadata/multiEdit/edit',
				params: {
					flashIds: '@flashIds',
					metaDataInstance: '@metaDataInstance',
				},
				isArray: false
			},
			'getValuatedInformationMetaDataInstances': {
				method: 'GET',
				url: 'api/metadata/valuatedInformationMetaDataInstances/:id',
				transformResponse: function (data) {
					return angular.fromJson(data);
				},
				isArray: true
			},
			'getMetaInstance': {
				method: 'GET',
				url: 'api/metadata/allMetaInstance/:flashId',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('nodeResource', NodeResource);

	/** @ngInject */
	function NodeResource($resource) {
		return $resource('api/node/:id', {}, {
			'restoreNode': {
				method: 'GET',
				url: 'api/node/:id/restore'
			},
			'deleteNode': {
				method: 'DELETE',
				params: {
					deleteChildNodes: false
				}
			},
			'deleteNodes': {
				method: 'DELETE',
				url: 'api/nodes/delete',
				params: {
					nodesIds: ''
				}
			},
			'copyNode': {
				method: 'GET',
				url: 'api/node/:id/copy',
				params: {
					isDeepCopy: false,
					isCut: false,
					targetNodeId: '',
					sourceNodeParentId: '',
					displayOrder: ''
				}
			},
			'getStructuralTypesById': {
				method: 'GET',
				url: 'api/node/:id/structuralTypeSetting',
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getNodeWithFirstLevelChildNodes': {
				method: 'GET',
				url: 'api/node/:id/subnodes',
				params: { grayDisplay: false },
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'createNodes': {
				method: 'POST',
				url: 'api/nodes',
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'createReferenceNodes': {
				method: 'POST',
				url: 'api/node/references',
				params: {
					isBulk: false
				}
			},
			'saveReferenceNodeWithTargetEnity': {
				method: 'POST',
				url: 'api/node/references/targetentity',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'deactivateReferenceNodes': {
				method: 'POST',
				url: 'api/node/references/deactivate/list',
			}
			
			,
			'activateNode': {
				method: 'GET',
				url: 'api/node/references/:referenceId/activateNode',
				params: {
					name: '@name',				
					type: '@type',
					value: '@value',
					relationId: '@relationId'
				}
			}

		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('productResource', ProductResource);


	/** @ngInject */
	function ProductResource($resource) {
		return $resource('api/product', {}, {
			'getCurrentProducts': {
				method: 'GET',
				url: 'api/product/current/:entityFlashId',
				isArray: true,
			},
			'getProductCode': {
				method: 'GET',
				url: 'api/product/productCode/:flashId',
				transformResponse: function (data) {
					return { code: data };
				}
			},
			'getSuggestedPublicationDate': {
				method: 'GET',
				url: 'api/product/suggestedPublicationDate/:flashId',
				transformResponse: function (data) {
					return { date: data };
				}
			},
			'saveProposals': {
				method: 'POST',
				url: 'api/product/proposal/save',
				params: {
					entityFlashId: '@entityFlashId'
				}
			},
			'saveImport': {
				method: 'POST',
				url: 'api/product/import/save',
				params: {
					productCode: '@productCode'
				}
			},
			'applyAction': {
				method: 'POST',
				url: 'api/product/proposal/applyAction',
				params: {
					flashId: '@flashId',
					entityFlashId: '@entityFlashId',
					action: '@action'
				}
			},
			'undoProposal': {
				method: 'POST',
				url: 'api/product/proposal/undo',
				params: {
					flashId: '@flashId',
					entityFlashId: '@entityFlashId',
				}
			},
			'deleteProposals': {
				method: 'DELETE',
				url: 'api/product/proposals/delete',
				params: {
					entityFlashId: '@entityFlashId',
					action: '@action'
				}
			},
			'duplicateEntityWithProposal': {
				method: 'POST',
				url: 'api/product/proposal/duplicateEntityWithProposal',
				params: {
					flashId: '@flashId'
				}
			},
			'checkIfEditProposalPermitted': {
				method: 'GET',
				url: 'api/product/checkIfEditProposalPermitted/:productCode',
				transformResponse: function (data) {
					return { result: data === 'true' };
				}
			},
			'getProposalsByProductCodeAndEntityFlashIds': {
				method: 'POST',
				url: 'api/product/proposals/:productCode',
				isArray: true
			},
			'declineProposals': {
				method: 'POST',
				url: 'api/product/operations/declineProposals/:productCode'
			},
			'isForEetConversion': {
				method: 'GET',
				url: 'api/product/isForEetConversion',
				params: {
					productCode: '@productCode',
					eetCode: '@eetCode'
				},
				transformResponse: function (data) {
					return { result: data === 'true' };
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('systemResource', systemResource);


	/** @ngInject */
	function systemResource($resource) {
		return $resource('api/system', {}, {
			'getSystemMetaValue': {
				method: 'GET',
				url: 'api/system/getSystemMetaValue/:name/:editorialObjectId/:type',
				isArray: false,
				transformResponse: function (data) {
					return { body: data };
				}
			},
			'updateSystemMetaValue': {
				method: 'POST',
				url: 'api/system/updateSystemMetaValue',
				params: {
					name: '@name',
					editorialObjectId: '@editorialObjectId',
					type: '@type',
					value: '@value'
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('treeViewResource', treeViewResource);


	/** @ngInject */
	function treeViewResource($resource) {
		return $resource('api/treeView', {}, {
			'createNode': {
				method: 'POST',
				url: 'api/treeView/node/create',
				isArray: false,
				params: {
				}
			},
			'afterEdit': {
				method: 'POST',
				url: 'api/treeView/afterEdit',
				isArray: false,
				params: {
					flashId: '@flashId'
				},
				transformResponse: function (data) {
					return { result: data === 'true'};
				}
			},
			'sort': {
				method: 'POST',
				url: 'api/treeView/sort',
				isArray: false,
				params: {
					flashId: '@flashId'
				}
			},

		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('TrashResource', function ($resource) {
			return $resource('api/archived', {}, {

				'getAll': {
					url: 'api/archived/all',
					method: 'POST',
					isArray: false
				},

				'getAllFilters': {
					method: 'GET',
					url: 'api/archived/filters',
					transformResponse: function (data) {
						data = angular.fromJson(data);
						return { filters: data };
					}
				}

			});
		});

})();



(function () {
	'use strict';

	angular.module('userApp')
		.factory('metadataSystemResource', MetadataSystemResource);

	/** @ngInject */
	function MetadataSystemResource($resource) {
		return $resource('api/metaDataSystem', {}, {


			'getMetaSystem': {
				method: 'POST',
				url: 'api/metaDataSystem/getMetaDataSystem',
				isArray: true
			},
			'getMountingSystemFilterValues': {
				method: 'POST',
				url: 'api/metaDataSystem/getMountingSystemFilterValues',
				params: {
					systemMetaCode: '@systemMetaCode',
					mountingRtId: '@mountingRtId'
				},
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('htmlPreviewResource', HtmlPreviewResource);


	/** @ngInject */
	function HtmlPreviewResource($resource) {
		return $resource('', {}, {
			'getEEHtmlPreview': {
				method: 'GET',
				url: 'api/html/:entityType/:id/:requestedPreview',
				params: {
					isArchived: false,
					productCode: '@productCode'
				},
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getProofReadingPreview': {
				method: 'POST',
				url: 'api/html/proofReading',
				params: {
					isArchived: false
				},
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getHtmlPreviews': {
				method: 'POST',
				url: 'api/html/previews',
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},

			'getOverloadedPreview': {
				method: 'GET',
				url: 'api/html/overloadPreview',
				params: {
					isArchived: false
				},
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('updatePreviewResource', UpdatePreviewResource);


	/** @ngInject */
	function UpdatePreviewResource($resource) {
		return $resource('api/html', {}, {
			'get': {
				url: 'api/html',
				method: 'GET',
				isArray: true
			},
			'query': { method: 'GET', isArray: false },
			'update': { method: 'PUT' },
			'updateHtmlPreview': {
				method: 'GET',
				url: 'api/html/updateHtmlPreview/:flashId/:requestedPreview'
			}

		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('WorksResource', function ($resource) {
			return $resource('api/works', {}, {

				'getAll': {
					url: 'api/works/all',
					method: 'POST',
					isArray: false
				},

				'getAllFilters': {
					method: 'GET',
					url: 'api/works/filters',
					transformResponse: function (data) {
						data = angular.fromJson(data);
						return { filters: data };
					}
				},

				'getInProgressInstances': {
					url: 'api/works/instances/inProgress',
					method: 'POST'
				},

			});
		});

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('publishProofHistoryResource', PublishProofHistoryResource);


	/** @ngInject */
	function PublishProofHistoryResource($resource) {
		return $resource('api/publishAndProofingHistorical', {}, {
			'getHistoryForEE': {
				method: 'GET',
				url: 'api/publishAndProofingHistorical/:eeFlashId',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('publishResource', PublishResource);

	/** @ngInject */
	function PublishResource($resource) {
		return $resource('api/publish', {}, {
			'get': {
				url: 'api/publish',
				method: 'GET',
				isArray: true
			},
			'query': { method: 'GET', isArray: false },
			'update': { method: 'PUT' },
			'getAll': {
				method: 'GET',
				url: 'api/publish/all',
				isArray: true
			},
			'getAllByTEE': {
				method: 'GET',
				url: 'api/publish/channelByTEE/:codeTEE/editorialEntitie/:idEE',
				isArray: false
			},
			'getAllByProduct': {
				method: 'GET',
				url: 'api/publish/channelByTEE/:codeTEE/editorialEntitie/:idEE',
				params: {
					publishMode: '@publishMode',
					isProofingWizard: '@isProofingWizard'
				},
				isArray: false,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'proofContextualization': {
				method: 'POST',
				url: 'api/publish/proofContextualization'
			},
			'getAllChannelsByFlashIdAndProduct': {
				method: 'GET',
				url: 'api/publish/getAllChannelsByFlashIdAndProduct/:flashId',
				params: {
					productCode: '@productCode'
				},
				isArray: false
			}

		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('ProductEntityResource', function ($resource) {
			return $resource('api/productEntities', {}, {

				'getAll': {
					url: 'api/productEntities/all',
					method: 'POST',
					isArray: false
				}

			});
		});

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('productSearchResource', function ($resource) {
			return $resource('api/productSearch', {}, {

				'findByCode': {
					url: 'api/productSearch/:code',
					method: 'GET',
					isArray: true
				},
				'findByCodeAndSitId': {
					url: 'api/productSearch/:code/:sitId',
					method: 'GET'
				}
			});
		});

})();

(function () {
	'use strict';

	angular.module('userApp').factory('relationTemplateResource', RelationTemplateResource);


	/** @ngInject */
	function RelationTemplateResource($resource) {
		return $resource('api/relationshipTemplate/metaRelation/:mdRelationCode/eetId/:eetId', { mdRelationCode: '@mdRelationCode', eetId: '@eetId' }, {
			'getRelationshipsTemplateInfo': {
				method: 'GET'
			},
			'getRelationshipTemplateDTOListByEetSource': {
				method: 'GET',
				url: 'api/relationshipTemplate/eetSource/:eeSourceFlashId',
				isArray: true
			},
			'getRelationshipTemplatesByEetTarget': {
				method: 'GET',
				url: 'api/relationshipTemplate/eetTarget',
				params: {
					//Default values
					trTypeWording: null,
					eetCode: null,
					eetFlashIds: null,
					checkExistsModelsForTrEeSources: false,
					productCodeModelsFilter: null
				},
				isArray: false,
				transformResponse: function (data, headers) {
					data = angular.fromJson(data);
					return { dtos: data };
				}
			},
			'getSourceEEntitiesById': {
				method: 'GET',
				url: 'api/relationshipTemplate/:trId/sourceEEntities',
				params: {
				},
				isArray: false,
				transformResponse: function (data, headers) {
					data = angular.fromJson(data);
					return { ees: data };
				}
			},
			'getRelationshipTemplateByCode': {
				method: 'GET',
				url: 'api/relationshipTemplate/code/:rtCode',
				isArray: false
			},
			'getRelationshipTemplateWithEetMeta': {
				method: 'GET',
				url: 'api/relationshipTemplate/:rtCode',
				params: {
					eeFlashId: null
				},
				isArray: false
			},
			'findAllAuthorizedTargetEetBySourceEetCode': {
				method: 'GET',
				url: 'api/relationshipTemplate/eetSource/eetTargets',
				isArray: true
			},
			'findAllAuthorizedTargetEetByRtId': {
				method: 'GET',
				url: 'api/relationshipTemplate/relationTemplate/eetTargets',
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	angular.module('userApp')
		.factory('relationResource', RelationResource);

	/** @ngInject */
	function RelationResource($resource) {
		return $resource('api/relation/:id', {}, {
			'getByEeSourceId': {
				method: 'GET',
				url: 'api/relation/eeSourceId/:eeSourceId',
				isArray: true
			},
			'getByEeTarget': {
				method: 'GET',
				url: 'api/relation/eeTarget/:eeTargetFlashId',
				params: {
					trType: '@trType'
				}
			},
			'updateRelationEditorialsMetaData': {
				method: 'POST',
				url: 'api/relation/editorialsMetadata',
			},
			'getByTargetEditorialEntities': {
				method: 'POST',
				url: 'api/relation/eeTarget/list',
				isArray: true
			},
			'getHookingMetadata': {
				method: 'GET',
				url: 'api/relation/hookingMetadata/:eetCode',
				isArray: true
			},
			'updateDesiredPublicationDate': {
				method: 'POST',
				url: 'api/relation/desiredPublicationDate',
			},
			'getByFlashId': {
				method: 'GET',
				url: 'api/relation/:flashId',
				isArray: false
			},
			'getOldestPublicationDateOnContainerSource': {
				method: 'GET',
				url: 'api/relation/oldestPublicationDateOnContainerSource/:eeTargetFlashId',
				transformResponse: function (data) {
					return { date: data };
				}
			},
			'getContainerSources': {
				method: 'GET',
				url: 'api/relation/containerSources/:eeTargetFlashId',
				isArray: true
			},
			'getContainerSourcesByEntityTarget': {
				method: 'GET',
				url: 'api/relation/containerSources',
				params: {
					publishMode: '@eeTargetFlashIds'
				},
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('searchInterfaceTemplateResource', searchInterfaceTemplateResource);


	/** @ngInject */
	function searchInterfaceTemplateResource($resource) {
		return $resource('api/searchInterfaceTemplates', {}, {
			'allFilters': {
				method: 'GET',
				url: 'api/searchInterfaceTemplates/allFilters/:identifier',
				isArray: true
			},
			'isContextualized': {
				method: 'GET',
				url: 'api/searchInterfaceTemplates/:identifier/products/:productCode/isContextualized',
				transformResponse: function (data) {
					return { result: data === 'true' };
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('solrResource', solrResource);


	/** @ngInject */
	function solrResource($resource) {
		return $resource('api/searchSolr', {}, {
			'search': {
				method: 'POST',
				isArray: false
			},
			'initDTO': {
				url: 'api/searchSolr/init',
				method: 'POST',
				isArray: false
			},
			'getSubLevelClassification': {
				method: 'POST',
				url: 'api/searchSolr/getSubLevel',
				isArray: false
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('searchResource', searchResource);


	/** @ngInject */
	/** Resource for new generic search */
	function searchResource($resource) {
		return $resource('api/search', {}, {
			'search': {
				method: 'POST',
				isArray: false
			},
			'initSearch': {
				url: 'api/search/init',
				method: 'POST',
				isArray: false
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('treeV2Resource', treeV2Resource);


	/** @ngInject */
	function treeV2Resource($resource) {
		return $resource('api/treeView', {}, {
			'getTree': {
				url: 'api/treeView/:id/tree',
				method: 'GET',
				isArray: false
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('menuResource', menuResource);


	/** @ngInject */
	function menuResource($resource) {
		return $resource('api/menu', {}, {
			'getMenu': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('globalPreferenceResource', GlobalPreferenceResource);


	/** @ngInject */
	function GlobalPreferenceResource($resource) {
		return $resource('api/preference/global', {}, {
			'getValue': {
				url: 'api/preference/global/:preference',
				method: 'GET',
				isArray: false,
				transformResponse: function (data) {
					return { value: data };
				}
			},
			'save': {
				method: 'POST',
				transformResponse: function (data) {
					return { value: data };
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('roleResource', roleResource);


	/** @ngInject */
	function roleResource($resource) {
		return $resource('api/role', {}, {
			'getRolesByStep': {
				url: 'api/role/step/:id',
				method: 'GET',
				isArray: true
			},

			'getAllRoleFilter': {
				url: 'api/role/roleFilter',
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('userGroupResource', userGroupResource);

	/** @ngInject */
	function userGroupResource($resource) {
		return $resource('', {}, {
			'groupsByUserAndTemplate': {
				method: 'GET',
				url: 'api/group/current/template',
				params: {
					code: '@code'
				},
				isArray: true
			},
			'groupsByTemplate': {
				method: 'GET',
				url: 'api/group/template',
				params: {
					code: '@code'
				},
				isArray: true
			},
			'groupsByUser': {
				method: 'GET',
				url: 'api/group/current',
				isArray: true
			},
			'groupByCode': {
				method: 'GET',
				url: 'api/group/code',
				params: {
					code: '@code'
				},
				isArray: false,
				transformResponse: function (data) {
					return {
						body: _.isEmpty(data) ? "" : angular.fromJson(data)
					};
				}
			},
			'getGroupForFilter': {
				method: 'GET',
				url: 'api/group/groupFilters',
				isArray: true
			},
			'getUserGroupByCategory': {
				url: 'api/group/groupByCategory',
				method: 'GET',
				isArray: true
			},
			'findCodesByNameIn': {
				url: 'api/group/codesByNames',
				method: 'GET',
				params: {
					names: '@names'
				},
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('userLdapResource', userLdapResource);


	/** @ngInject */
	function userLdapResource($resource) {
		return $resource('api/users/ldap', {}, {
			'query': { 
				method: 'POST', 
				isArray: true
			}
		});
    
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('userResource', userResource);


	/** @ngInject */
	function userResource($resource) {
		return $resource('api/users', {}, {
			'query': {
				method: 'GET'
			},
			'filter': {
				url: 'api/users/filter/:filterValue',
				method: 'GET'
			},
			'get': {
				url: 'api/users/:id',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getUsersByGrpCode': {
				url: 'api/users/allUsersByGrpCode/:userGroupCode',
				method: 'GET',
				isArray: true
			},
			'getCurrentUser': {
				url: 'api/users/current',
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getByLoginUser': {
				url: 'api/users/logins',
				method: 'post',
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'getUserPublicInfoByLogin': {
				url: 'api/users/userPublicInfos',
				method: 'post',
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'update': {
				method: 'PUT'
			},
			'getUsersByRoleGroup': {
				url: 'api/users/roleGroup',
				method: 'GET',
				isArray: true
			},
			'saveUserInfo': {
				url: 'api/users/saveUserInfo',
				method: 'POST',
				params: {
					signature: '@signature'
				},
				transformResponse: function (data) {
					return { saved: data === 'true' };
				}
			}
		});

	}
})();

'use strict';

angular.module('userApp')
	.factory('workflowHistoryResource', function ($resource) {
		return $resource('api/workFlowHistory', {}, {
			'changeStepWorkFlow': {
				url: 'api/workFlowHistory/changeStepWfw',
				method: 'POST'
			},
			'closeWorkFlow': {
				url: 'api/workFlowHistory/closeWorkFlow',
				method: 'POST'
			},
			'errorWorkFlow': {
				url: 'api/workFlowHistory/errorWorkFlow',
				method: 'POST'
			},
			'warningWorkFlow': {
				url: 'api/workFlowHistory/warningWorkFlow',
				method: 'POST'
			},
			'initWFUpdate': {
				url: 'api/workFlowHistory/initWF',
				method: 'POST'
			},
			'deleteAssignRole': {
				url: 'api/workFlowHistory/deleteAssignRole/:idWfwHistory',
				method: 'DELETE'
			},
			'workflowHistory': {
				url: 'api/workFlowHistory/:flashId',
				method: 'GET'
			},
			'changeStepWithWarning': {
				url: 'api/workFlowHistory/changeStepWithWarning',
				method: 'POST'
			}
		});

	});

'use strict';

angular.module('userApp')
	.factory('workflowResource', function ($resource) {
		return $resource('api/workFlow', {}, {
			'multiEdit': {
				url: 'api/workFlow/multiEdit',
				method: 'POST',
				params: {
					entityIds: '@entityIds'
				}
			},
			'saveMultiEdit': {
				url: 'api/workFlow/saveMultiEdit',
				method: 'POST',
				params: {
					entityIds: '@entityIds'
				}
			},
			'saveMultiInit': {
				url: 'api/workFlow/saveMultiInit',
				method: 'POST',
				params: {
					entityIds: '@entityIds'
				}
			}
		});

	});

(function () {
	'use strict';

	angular.module('userApp')
		.factory('versioningResource', VersioningResource);

	/** @ngInject */
	function VersioningResource($resource) {
		return $resource('api/versioning', {}, {
			'getPreview': {
				method: 'GET',
				url: 'api/versioning/:qualifiedVersion/getPreview',
				params: {
					flashId: '@flashId'
				},
				transformResponse: function (data) {
					return { htmlContent: data };
				}
			},
			'getAvailableVersion': {
				method: 'GET',
				url: 'api/versioning/getAvailableVersions/:flashId',
				isArray: true
			}
		});
	}

})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('announcement', {
			templateUrl: 'scripts/pre-upgrade/components/announcements/announcement.html',
			controller: AnnouncementController
		});

	/** @ngInject */
	function AnnouncementController(announcementResource, $rootScope, announcementEvents, announcementService, announcementMessages) {
		var ctrl = this;
		ctrl.announcements = [];

		////////////////

		ctrl.$onInit = function () {
			ctrl.refresh();
		};

		ctrl.refresh = function () {
			announcementResource.getCurrentAnnouncement().$promise
				.then(function (announcement) {
					if (announcement.message) {
						var announce = announcementService.buildAnnouncement(announcementMessages.ECM, announcement.message, "info");
						ctrl.announcements.push(announce);
					}
				});
		};

		//
		$rootScope.$on('$destroy', $rootScope.$on(announcementEvents.ADD_ANNOUNCEMENT, function (event, announcement) {
			if (announcement) {
				ctrl.announcements.push(announcement);
			} else {
				ctrl.refresh();
			}
		}));

		//
		$rootScope.$on('$destroy', $rootScope.$on(announcementEvents.DELETE_ANNOUNCEMENT, function (event, id) {
			if (id) {
				_.remove(ctrl.announcements, { id: id });
			} else {
				ctrl.refresh();
			}
		}));

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('announcementService', AnnouncementService);

	/** @ngInject */
	function AnnouncementService($rootScope, announcementEvents) {
		var service = {
			buildAnnouncement: buildAnnouncement,
			addAnnouncement: addAnnouncement,
			deleteAnnouncement: deleteAnnouncement
		};

		return service;

		////////////////
		function buildAnnouncement(id, message, severity) {
			var announcement = {};
			announcement.id = id;
			announcement.message = message;
			announcement.severity = severity;
			return announcement;
		}

		function addAnnouncement(announcement) {
			$rootScope.$emit(announcementEvents.ADD_ANNOUNCEMENT, announcement);
		}

		function deleteAnnouncement(id) {
			$rootScope.$emit(announcementEvents.DELETE_ANNOUNCEMENT, id);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('bulkoperationsComponent', {
			templateUrl: 'scripts/pre-upgrade/components/bulkoperations/bulkoperations.html',
			controller: BulkOperationsController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function BulkOperationsController($state, blockUI, FileSaver, confirmModalService, bulkOperationService) {
		var ctrl = this;

		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'operationDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');

			ctrl.loadAllBulkOperations();
		};

		ctrl.loadAllBulkOperations = function () {
			ctrl.isLoading = true;
			blockUI.start();

			ctrl.searchMap['startOperationDate'] = ctrl.operationDateFilter.startDate || null;
			ctrl.searchMap['endOperationDate'] = ctrl.operationDateFilter.endDate || null;
			ctrl.sortString = ctrl.sortString ? ctrl.sortString : 'operationDate,desc';

			bulkOperationService.getBulkOperations(ctrl.searchMap,
				ctrl.refreshData,
				Math.max(ctrl.pagination.currentPage - 1, 0),
				ctrl.pagination.itemByPage,
				ctrl.sortString
			).then(function (data) {
				var rowCollection = data ? (data.operationDTOList ? data.operationDTOList : []) : [];

				ctrl.operations = [].concat(rowCollection);
				ctrl.pagination.totalCount = data.totalElements;
				ctrl.useCaseFilterList = data.bulkOperationFiltersDTO.useCaseFilterList;
				ctrl.resultFilterList = data.bulkOperationFiltersDTO.resultFilterList;

				ctrl.isLoading = false;
				ctrl.refreshData = false;
				ctrl.lastUpdateDate = new Date();
				blockUI.stop();
			})
				.catch(function (e) {
					ctrl.isLoading = false;
					blockUI.stop();
				});
		};

		ctrl.downloadLogs = function (logLines, bulkOperationId) {
			bulkOperationService.downloadLogs(logLines, bulkOperationId);
		};

		ctrl.okOperationsSize = function (operation) {
			return bulkOperationService.computeOkOperationsSize(operation);
		};

		ctrl.failedOperationsSize = function (operation) {
			return bulkOperationService.computeFailedOperationsSize(operation);
		};

		ctrl.inProgressOperationsSize = function (operation) {
			return bulkOperationService.computeInProgressOperationsSize(operation);
		};

		ctrl.operationStatus = function (operation) {
			return bulkOperationService.getOperationStatus(operation);
		};

		ctrl.refresh = function () {
			ctrl.refreshData = true;
			ctrl.loadAllBulkOperations();
		};

		ctrl.existsResultInOperations = function (operations, result) {
			return bulkOperationService.existsResultInOperations(operations, result);
		};

		ctrl.replayFailedOperations = function () {
			bulkOperationService.replayFailedOperations()
				.then(function () {
					_.delay(function () {
						ctrl.refresh();
					}, 1000);
				})
				.catch(function (e) {
					ctrl.isLoading = false;
					blockUI.stop();
				});
		};

		ctrl.purgeOperations = function (operationResult) {
			var modalText = 'userApp.bulkoperations.home.confirmPurgeMessage';
			confirmModalService.openModal(modalText, undefined, { operationResult: operationResult })
				.then(function (result) {
					if (result) {
						bulkOperationService.purgeOperations(operationResult)
							.then(function () {
								ctrl.refresh();
							})
							.catch(function (e) {
								ctrl.isLoading = false;
								blockUI.stop();
							});
					}
				});
		};

		// INIT
		ctrl.$onInit = function () {
			ctrl.refreshData = true;
			ctrl.searchMap = {};
			ctrl.searchMap['useCase'] = null;
			ctrl.searchMap['result'] = null;
			ctrl.searchMap['startOperationDate'] = null;
			ctrl.searchMap['endOperationDate'] = null;
			ctrl.operationDateFilter = {};
			ctrl.sortString;
			ctrl.pagination = {
				itemByPage: 50,
				totalCount: 0,
				currentPage: 1
			};
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('myBulkOperations', {
			parent: 'main',
			url: '/bulkoperations',
			views: {
				'content@mainLayout': 'bulkoperationsComponent'
			},
			resolve: {
				forceRefresh: function (bulkOperationService) { },
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('bulkoperations');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	/**
	 * service providing utilities functions to display bulk operations view.
	 */
	angular
		.module('userApp')
		.factory('bulkOperationService', BulkOperationService);

	/** @ngInject */
	function BulkOperationService($state, bulkOperationsResource, blockUI, FileSaver, confirmModalService) {
		var service = {
			getBulkOperations: getBulkOperations,
			replayFailedOperations: replayFailedOperations,
			purgeOperations: purgeOperations,
			downloadLogs: downloadLogs,
			computeOkOperationsSize: computeOkOperationsSize,
			computeFailedOperationsSize: computeFailedOperationsSize,
			computeInProgressOperationsSize: computeInProgressOperationsSize,
			getOperationStatus: getOperationStatus,
			existsResultInOperations: existsResultInOperations
		};

		return service;

		//GET BULK OPERATIONS
		function getBulkOperations(filtersMap, refreshData, page, size, sort) {
			return bulkOperationsResource.getBulkOperations({
				filtersMap: filtersMap,
				refreshData: refreshData,
				page: page,
				size: size,
				sort: sort
			}).$promise;
		}

		//REPLAY FAILED OPERATIONS
		function replayFailedOperations() {
			return bulkOperationsResource.replayFailedOperations().$promise;
		}

		//PURGE OPERATIONS
		function purgeOperations(operationResult) {
			return bulkOperationsResource.purgeOperations({ result: operationResult }).$promise;
		}

		//DOWNLOAD LOGS AS TXT FILE 
		function downloadLogs(logLines, bulkOperationId) {
			var logs = _.join(logLines, '\n');
			var data = new Blob([logs], { type: 'text/plain;charset=utf-8' });
			FileSaver.saveAs(data, 'BulkOperation_logs_' + bulkOperationId + '.txt');
		}

		// COUNT 'OK' RESULTS ON GIVEN BULK OPERATION
		function computeOkOperationsSize(operation) {
			return _.filter(operation.resultDetails, _.matches('OK')).length;
		}

		// COUNT 'KO' RESULTS ON GIVEN BULK OPERATION 
		function computeFailedOperationsSize(operation) {
			return _.filter(operation.resultDetails, _.matches('KO')).length;
		}

		//COUNT OPERATIONS 'IN PROGRESS' ON GIVEN BULK OPERATION 
		function computeInProgressOperationsSize(operation) {
			return _.filter(operation.resultDetails, _.matches('IN_PROGRESS')).length;
		}

		//OPERATION STATUS
		function getOperationStatus(operation) {
			if (_.filter(operation.statusDetails, _.matches('IN_PROGRESS')).length > 0) {
				return 'IN_PROGRESS';
			}
			return 'FINISHED';
		}

		//CHECK IF THERE IS AN OPERATION WITH GIVEN RESULT IN ALL OPERATIONS LIST
		function existsResultInOperations(operations, result) {
			return _.includes(_.flatMap(_.map(operations, 'resultDetails')), result);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('batchComponent', {
			templateUrl: 'scripts/pre-upgrade/components/batch/batch.html',
			controller: batchController,
			bindings: {
				allConfigs: '<',
				currentUser: '<'
			},
		});

	/** @ngInject */
	function batchController($filter, blockUI, batchService, confirmModalService, ModalAlertService) {
		var ctrl = this;

		ctrl.requestBatchProcess = function () {
			var batchName = $filter('translate')(ctrl.selectedBatchConfig.batchName);
			var confirmModalText = 'userApp.batch.home.confirmExecuteBatchMessage';
			var inforModalText = 'userApp.batch.home.requestBatchProcessSentInfo';
			var errorModalText = 'userApp.batch.home.requestBatchProcessSentError';
			confirmModalService.openModal(confirmModalText, undefined, { batchName: batchName })
				.then(function (result) {
					if (result) {
						blockUI.start();
						batchService.requestBatchProcess(ctrl.selectedBatchConfig).then(function () {
							ModalAlertService.info($filter('translate')(inforModalText, { batchName: batchName }));
							blockUI.stop();
						}).catch(function (e) {
							ModalAlertService.error($filter('translate')(errorModalText, { batchName: batchName }));
							blockUI.stop();
						});
					}
				});
		};

		// INIT
		ctrl.$onInit = function () {
			ctrl.parameterList = [];
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('batch', {
			parent: 'main',
			url: '/batch',
			views: {
				'content@mainLayout': 'batchComponent'
			},
			resolve: {
				allConfigs: function (batchService) {
					return batchService.getAllConfigs();
				},
				currentUser: function (userResource) {
					return userResource.getCurrentUser().$promise;
				},
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('batch');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	/**
	 * service providing utilities functions to display batch execution view.
	 */
	angular
		.module('userApp')
		.factory('batchService', batchService);

	/** @ngInject */
	function batchService($filter, blockUI, batchResource) {
		var service = {
			getAllConfigs: getAllConfigs,
			requestBatchProcess: requestBatchProcess
		};

		return service;

		//GET ALL batch CONFIGURATIONS
		function getAllConfigs() {
			blockUI.start();
			return batchResource.getAllConfigs().$promise
				.then(function (data) {
					blockUI.stop();
					return data;
				}).catch(function (e) {
					blockUI.stop();
				});
		}

		//REQUEST PROCESS OF BATCH WITH GIVEN CONFIG
		function requestBatchProcess(batchConfig) {
			return batchResource.requestBatchProcess(batchConfig).$promise;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('configurationComponent', {
			templateUrl: 'scripts/pre-upgrade/components/configuration/configuration.html',
			controller: ConfigurationController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function ConfigurationController(globalPreferenceResource, userPreferenceService, $filter, $log, blockUI, modalService, deploymentResource, ermResource, announcementResource, announcementService, announcementMessages, configurationLocalUserService, EDITOR_VERSION) {
		var ctrl = this;


		ctrl.$onInit = function () {
			ctrl.lang = 'fr';
			ctrl.currentConfiguration = {};
			ctrl.currentVersion = '';
			ctrl.activeVersions = [];
			ctrl.selectedVersion = '';
			ctrl.editorVersion = EDITOR_VERSION;

			ctrl.maxAutoExpandLevel = userPreferenceService.getUserGlobalPreference('TreeviewAutoExpandValue', null);
			ctrl.maxConcurrentRequests = userPreferenceService.getUserGlobalPreference('TreeviewGetNodesMaxRequests', 10);

			//Get a current Announcement 
			announcementResource.getCurrentAnnouncement().$promise.then(function (currentAnnouncement) {
				ctrl.currentAnnouncement = currentAnnouncement;
				ctrl.announcementMessage = currentAnnouncement.message;
			});

			ctrl.refresh();
		};

		ctrl.refresh = function () {
			/**
			* Get the current configuration
			*/
			getCurrentConfiguration();

			/**
				* Get the current version of Erm Used by Ecm-Core.
				*/

			getCurrentErmVersion();

			/**
				* Get the list of active version From ERM .
				*/
			getListOfAvailableVersionOfErm();

			/**MEDIA */
			blockUI.start();
			globalPreferenceResource.getValue({ "preference": "MEDIA_MAX_FILE" }).$promise
				.then(function (data) {
					ctrl.maxMediaFile = _.isEmpty(data.value) ? 0 : parseInt(data.value);
					blockUI.stop();
				});

		};

		ctrl.maxAutoExpandChange = function () {
			userPreferenceService.setUserGlobalPreference('TreeviewAutoExpandValue', ctrl.maxAutoExpandLevel);
		};

		ctrl.maxConcurrentRequestsChanged = function () {
			userPreferenceService.setUserGlobalPreference('TreeviewGetNodesMaxRequests', ctrl.maxConcurrentRequests);
		};


		function getCurrentConfiguration() {

			deploymentResource.getCurrentConfigurationVersion().$promise.then(
				function (data) {
					ctrl.currentConfiguration = data;
				},
				function (error) {
					$log.error("There's an error when getting the current configuration ", error);
				}
			);
		}

		function getCurrentErmVersion() {

			ermResource.getCurrentVersion().$promise.then(
				function (data) {
					ctrl.currentVersion = data.version;
					ctrl.enableErm = data.enabled;
				},
				function (error) {
					$log.error("There's an error when getting the current version of ERM resource ", error);
				}
			);
		}

		function getListOfAvailableVersionOfErm() {

			ermResource.getActiveVersion().$promise.then(
				function (data) {

					ctrl.activeVersions = data;
				},
				function (error) {
					$log.error("There's an error when getting the list of active version ", error);
				}
			);

		}


		ctrl.ImportConf = function () {
			configurationLocalUserService.reinitialiser();
			var modalOptions = {
				isConfirm: false,
				closeButtonText: $filter('translate')('userApp.configuration.msg.closeButtonText'),
				headerText: $filter('translate')('userApp.configuration.msg.titleAlert'),
				actionButtonText: $filter('translate')('userApp.configuration.msg.actionButton')
			};

			blockUI.start();
			deploymentResource.deploy(function () {
				ctrl.refresh();
				blockUI.stop();
				modalOptions.headerText = $filter('translate')('userApp.configuration.msg.titleConfirm'),
					modalOptions.bodyText = $filter('translate')('userApp.configuration.msg.IMPORT_SUCCESS');
				modalService.showModal({}, modalOptions);

				//$state.reload($state.current.name);
			}, function (err) {
				blockUI.stop();
				var code = _.has(err, 'data.codeDetail') ? err.data.codeDetail : undefined;
				if (angular.isDefined(code) && code === 'IMPORT_CONCURRENCY_ERROR') {
					modalOptions.bodyText = $filter('translate')('userApp.configuration.msg.ERROR_DEPLOY_IN_PROGRESS');
					modalService.showModal({}, modalOptions);
				}
				else if (angular.isDefined(code) && code === 'IMPORT_NO_ZIP_FOUND') {
					modalOptions.bodyText = $filter('translate')('userApp.configuration.msg.ERROR_ZIP_NOT_FOUND');
					modalService.showModal({}, modalOptions);
				}


			});
		};

		ctrl.saveVersion = function () {

			var version = ctrl.selectedVersion;
			var isChangePossible = version !== null && version.length && version !== ctrl.currentVersion;
			if (isChangePossible) {
				$log.info("Changing the current version to ", version);
				ermResource.changeVersion({
					version: version
				}).$promise.then(
					function (data) {
						getCurrentErmVersion();
					},
					function (error) {
						$log.error('Error when changing version, the current version stay ', ctrl.currentVersion);
					}
				);
			}
		};

		ctrl.saveAnnouncement = function () {
			blockUI.start();
			announcementResource.saveAnnouncement(ctrl.announcementMessage).$promise.then(function (currentAnnouncement) {
				blockUI.stop();
				ctrl.currentAnnouncement = currentAnnouncement;
				announcementService.addAnnouncement();
			}, function () {
				blockUI.stop();
			});
		};

		ctrl.deleteAllAnnouncements = function () {
			blockUI.start();
			announcementResource.deleteAllAnnouncements().$promise.then(function () {
				blockUI.stop();
				announcementService.deleteAnnouncement(announcementMessages.ECM);
				ctrl.currentAnnouncement = undefined;
				ctrl.announcementMessage = undefined;
			}, function () {
				blockUI.stop();
			});
		};

		ctrl.setMaxMediaFiles = function () {
			if (ctrl.maxMediaFile) {
				globalPreferenceResource.save({
					preference: "MEDIA_MAX_FILE",
					value: ctrl.maxMediaFile
				}, {}).$promise
					.then(function (data) {
						ctrl.maxMediaFile = _.isEmpty(data.value) ? 0 : parseInt(data.value);
					});
			}
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('configuration', {
			parent: 'main',
			url: '/configuration',
			data: {
				authorities: ["ROLE_ADMIN_SI"]
			},
			params: {
				page: {
					value: '0',
					squash: true
				},
				sort: {
					value: 'version',
					squash: true
				}
			},
			views: {
				'content@mainLayout': 'configurationComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('configuration');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('debug-solr', {
				parent: 'main',
				url: "/debug/solr",
				data: {
					authorities: []
				},
				params: {
				},
				views: {
					'content@mainLayout': 'debugSolrComponent'

				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('debug');
						return $translate.refresh();
					}]
				}

			})
			.state('debug-mongo', {
				parent: 'main',
				url: "/debug/mongo",
				data: {
					authorities: []
				},
				params: {
				},
				views: {
					'content@mainLayout': 'debugMongoComponent'

				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('debug');
						return $translate.refresh();
					}]
				}

			}).
			state('debug-maria', {
				parent: 'main',
				url: "/debug/maria",
				data: {
					authorities: []
				},
				params: {
				},
				views: {
					'content@mainLayout': 'debugMariaComponent'

				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('debug');
						return $translate.refresh();
					}]
				}

			})
			.
			state('debug-log', {
				parent: 'main',
				url: "/debug/logs",
				data: {
					authorities: []
				},
				params: {
				},
				views: {
					'content@mainLayout': 'debugLogComponent'

				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('debug');
						return $translate.refresh();
					}]
				}

			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('debugService', DebugService);


	/** @ngInject */
	function DebugService(debugResource, blockUI) {
		var service = {
			sendSolrRequest: sendSolrRequest,
			sendMariaRequest: sendMariaRequest,
			getLogFiles: getLogFiles,
			getLogFileContent: getLogFileContent,
		};

		return service;

		function sendSolrRequest(request) {
			blockUI.start();
			return debugResource.sendSolrRequest(request).$promise
				.then(function (data) {

					blockUI.stop();
					return data;
				});
		}

		function sendMariaRequest(request) {
			blockUI.start();
			return debugResource.sendMariaRequest(request).$promise
				.then(function (data) {

					blockUI.stop();
					return data;
				});
		}

		function getLogFiles() {
			blockUI.start();
			return debugResource.getLogFiles().$promise
				.then(function (data) {

					blockUI.stop();
					return data;
				});
		}



		function getLogFileContent(numberOfLine, fileName) {
			blockUI.start();
			return debugResource.sendLogRequest({ numberOfLine: numberOfLine, fileName: fileName }, fileName).$promise
				.then(function (data) {

					blockUI.stop();
					return data;
				});
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('homeComponent', {
			templateUrl: 'scripts/pre-upgrade/components/home/home.html',
			controller: HomeController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function HomeController($interval, monitoringService) {
		var ctrl = this;

		ctrl.showPreview = function (ee) {
			ctrl.selectedEE = ee.identifier;
			ctrl.preview = {
				opened: true,
				flashId: ee.identifier
			};
		};

		ctrl.isMore = function (pagination) {
			return pagination && pagination.totalCount >= pagination.itemByPage ? 'more' : '';
		};

		ctrl.setAdapter = function (adapter) {
			ctrl.myWorkAdapter = adapter;
		};

		ctrl.myWorkPreviewClose = function () {
			if (ctrl.myWorkAdapter) {
				ctrl.myWorkAdapter.clearSelection();
			}
		};

		ctrl.reload = function () {
			if (ctrl.myWorkAdapter) {
				ctrl.myWorkAdapter.reload();
			}
		};

		ctrl.$onInit = function () {
			ctrl.userName = ctrl.currentUser ? ctrl.currentUser.firstName : null;

			// Set monitoring check period 05 minutes.
			//$interval(function () {
			//	monitoringService.announceDownApps();
			//}, 1800000);

			// Get the first check. 
			monitoringService.announceDownApps();
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('home', {
			parent: 'main',
			url: '/',
			views: {
				'content@mainLayout': 'homeComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('travaux');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('metadatas');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('editorialEntity.proofHistory', {
				url: '/proofhistory',
				views: {
					'editorialEntityContent': {
						component: 'publishProofHistory'
					}
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.pubHistPageTitle"
				}
			}).state('editorialEntity.table', {
				url: '/table',
				params: { selectedNodeId: undefined },
				views: {
					'editorialEntityContent': {
						component: 'treeFlatView'
					}
				},
				resolve: {
					treeFlatViewConfig: function (editorialEntity, flatViewService) {
						return flatViewService.getFlatViewConfig(editorialEntity.identifier);
					},
					isMetadataEnabled: function (entityAuthorizeService, eEpermissions) {
						return entityAuthorizeService.isMetadataEnabled(eEpermissions);
					}
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.boardPageTitle"
				}
			}).state('editorialEntity.hooks', {
				url: '/hooks',
				views: {
					'editorialEntityContent': {
						component: 'eeLinkInfos'
					}
				},
				resolve: {
					displayMode: function () {
						return 'HOOKS';
					}
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.hooksPageTitle"
				}
			}).state('editorialEntity.duplicate', {
				url: '/duplicate',
				views: {
					'editorialEntityContent': {
						component: 'eeLinkInfos'
					}
				},
				resolve: {
					displayMode: function () {
						return 'DUPLICATES';
					}
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.duplicatePageTitle"
				}
			}).state('editorialEntity.timeline', {
				url: '/timeline',
				views: {
					'editorialEntityContent': {
						component: 'timelinePageComponent'
					}
				},
				data: {
					pageTitle: "userApp.editorialEntity.menu.timelinePageTitle"
				}
			}).state('editorialEntity.media', {
				url: '/media',
				redirectTo: 'editorialEntity'
			});
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('massOperationContainer', {
			templateUrl: 'scripts/pre-upgrade/components/mass-operation/mass-operation-container.component.html',
			controller: MassOperationContainerrController,
			bindings: {
				currentUser: "=",
				currentPermissions: "=?",
				selectedAction: "<",
				selectedEe: "=",
				selectedRelationsIds: "=?",
				selectedNodesIds: "=?",
				refreshFunction: "&?",
				fromTrash: "<?",
				fromFlatView: "<?",
				sitId: "<?"
			},
		});

	/** @ngInject */
	function MassOperationContainerrController($state, $rootScope, $stateParams, $timeout, declineProposalService, entityAuthorizeService, entityFetchResource, entityLinkingResource, deactivateNodesModalService, deleteNodesModalService, $filter, editMetaDataModalService, editWorkflowModalService, archiveEntityModalService, blockUI, LinkEeWizardModalService, ModalAlertService, entityUnlockService, productGroupManyEEService, $uibModal, restoreEntityService, htmlPreviewService, OpenNewTabService, productSearchService, entityImportService, convertEntityService, convertModalService, infoModalService) {
		var ctrl = this;


		ctrl.$onInit = function () {

			//PRODUCT CODE AND PROPOSALS PRODUCT PARAMS ARE READ FROM URL PARAMS
			ctrl.productCode = $stateParams.productCode;
			ctrl.proposalsProduct = $stateParams.proposalsProduct === "true";

			ctrl.facetVisibility = true;
			ctrl.actionList = [
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.METADATA',
					value: 'METADATA'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.WORKFLOW',
					value: 'WORKFLOW'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.LINK',
					value: 'LINK'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.PRODUCT_GROUP',
					value: 'PRODUCT_GROUP'
				},

				{
					name: 'userApp.searchInterfaceTemplate.menuAction.unlock',
					value: 'UNLOCK'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.convertToNewEntity',
					value: 'CONVERT_TO_NEW_ENTITY'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.convert',
					value: 'CONVERT'
				}
			];
			// Add actions for node deletion/deactivation (only if criteria are met)
			ctrl.nodeActions = [
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.DEACTIVATENODES',
					value: 'DEACTIVATENODES'
				},
				{
					name: 'userApp.searchInterfaceTemplate.menuAction.DELETENODES',
					value: 'DELETENODES'
				}
			];

			ctrl.trashActions = [
				{
					name: 'userApp.trash.menuAction.DELETE',
					value: 'DELETEDEFINITELY'
				},
				{
					name: 'userApp.trash.menuAction.RESTORE',
					value: 'RESTORE'
				}
			];

			ctrl.actionList.push({
				name: 'userApp.searchInterfaceTemplate.menuAction.HTMLPRINT',
				value: 'HTMLPRINT'
			});

			if (!ctrl.fromFlatView) {
				ctrl.actionList.push({
					name: 'userApp.searchInterfaceTemplate.menuAction.ARCHIVE',
					value: 'ARCHIVE'
				});
			}

			if (angular.isDefined(ctrl.fromTrash) && ctrl.fromTrash) {
				ctrl.actionList = ctrl.trashActions;
			} else {
				ctrl.addNodeActions();
				ctrl.handler = $rootScope.$on('permissions_changed', function (event, data) {
					ctrl.currentPermissions = data;
					ctrl.addNodeActions();
				});
			}

			//IF IT'S CONTEXTUALIZATION AND A TIR WITH PROPOSALS PRODUCT APPLIED (IS TRUE), THEN ADD PROPOSAL ACTIONS IN ACTION LIST
			if (ctrl.productCode && ctrl.proposalsProduct) {

				ctrl.proposalActions = {
					name: 'userApp.searchInterfaceTemplate.menuAction.DECLINE_PROPOSAL',
					value: 'DECLINE_PROPOSAL'
				};
				ctrl.actionList.push(ctrl.proposalActions);
			}

			addImportAction();
			//sort action list after adding all actions
			$timeout(function () {
				sortActionList();
			}, 500);

		};

		function addImportAction() {
			//CHECK IF CONTEXTUALIZED PRODUCT
			if (ctrl.productCode && ctrl.sitId) {
				productSearchService.findByCodeAndSitId(ctrl.productCode, ctrl.sitId).then(function (productSearch) {
					//CHECK IF SEARCH INTERFACE TEMPLATE IS NOT CONTEXTUALIZED
					if (productSearch && !productSearch.contextualized) {
						ctrl.actionList.push({
							name: 'userApp.searchInterfaceTemplate.menuAction.import',
							value: 'IMPORT'
						});
					}
				});
			}
		}

		function sortActionList() {
			ctrl.actionList = _.sortBy(ctrl.actionList, [function (action) {
				return $filter('translate')(action.name);
			}]);
		}

		// Add actions for node deletion/deactivation (only if criteria are met)
		ctrl.addNodeActions = function () {
			if (ctrl.currentPermissions) {
				var editContentEnabled = entityAuthorizeService.isEditContentEnabled(ctrl.currentPermissions);
				ctrl.nodeActions.forEach(function (action) {
					// The current user must be authorized to edit the EE
					var actionExist = ctrl.actionList.indexOf(action) !== -1;
					if (!actionExist && editContentEnabled) {
						ctrl.actionList.push(action);
					} else if (!editContentEnabled) {
						ctrl.actionList.splice(ctrl.actionList.indexOf(action), 1);
					}
				});
			}
		};

		ctrl.applyAction = function (action) {
			var selectedEE = ctrl.getSelectedEE();
			ctrl.editorialEntitiesList = angular.toJson(selectedEE);
			if (selectedEE && selectedEE.length > 0) {
				switch (action) {
					case 'WORKFLOW':
						//EDIT WORKFLOW
						if (selectedEE.length === 1) {
							entityFetchResource.getByFlashId({
								flashId: selectedEE[0]
							}).$promise
								.then(function (entity) {
									editWorkflowModalService.openWorkflowModal(entity, ctrl.currentUser, true)
										.then();
								});
						} else {
							editWorkflowModalService.openMultiEdit(selectedEE, ctrl.currentUser);
						}
						break;
					case 'ARCHIVE':
						//Archive selected editorial entities
						archiveEEModal(ctrl.editorialEntitiesList);
						break;
					case 'HTMLPRINT':
						openPreviewModal(ctrl.editorialEntitiesList);
						break;
					case 'PRODUCT_GROUP':
						//update product group of selected editorial entities
						productGroupEEModal(selectedEE);
						break;
					case 'LINK':
						//hook selected editorial entities
						if (ctrl.editorialEntitiesList.length > 0) {
							linkEes(selectedEE, ctrl.productCode);
						}
						break;
					case 'DECLINE_PROPOSAL':
						declineProposal(ctrl.productCode, ctrl.editorialEntitiesList);
						break;
					case 'UNLOCK':
						//unlock selected editorial entities
						unlockEEModal(selectedEE);
						break;
					case 'METADATA':
						editMetadata(selectedEE);
						break;
					case 'DEACTIVATENODES':
						// Deactivate selected nodes (referenceNode)
						deactivateNodes(ctrl.selectedNodesIds);
						break;
					case 'DELETENODES':
						deleteNodes(ctrl.selectedNodesIds);
						break;
					// delete entity definitely
					case 'DELETEDEFINITELY':
						openDeleteEntityMultiModal(ctrl.editorialEntitiesList);
						break;
					case 'RESTORE':
						restoreEntityService.restoreEntityMulti(ctrl.editorialEntitiesList);
						break;
					case 'IMPORT':
						importEntity(selectedEE);
						break;
					case 'CONVERT_TO_NEW_ENTITY':
						convertEntity(selectedEE, true);
						break;
					case 'CONVERT':
						convertEntity(selectedEE, false);
						break;
				}
			}
		};

		function convertEntity(flashIdsList, createNewEntity) {
			if (flashIdsList.length > 1) {
				infoModalService.openModal("error.conversionDenied.multiSelect", "error.conversionDenied.title");
			} else {
				blockUI.start();
				var entityFlashId = flashIdsList[0];
				convertEntityService.getPermissionStatus(entityFlashId, createNewEntity).then(function (response) {
					if (response.enabled) {
						convertModalService.openModal(entityFlashId, null, createNewEntity);
					} else {
						infoModalService.openModal(response.message.key, 'error.conversionDenied.title', { param_1: response.message.params[0] });
					}
				}).finally(function () {
					blockUI.stop();
				});
			}
		}

		//IMPORT SELECTED ENTITY
		function importEntity(selectedEE) {
			entityImportService.importEntity(selectedEE, ctrl.productCode);
		}

		ctrl.getSelectedEE = function () {
			var selectedEE = _.keys(_.pickBy(ctrl.selectedEe), true);
			return selectedEE;
		};

		ctrl.clearSelection = function () {
			ctrl.selectedEe = [];
		};

		function archiveEEModal(eeTargetFlashIdList) {
			archiveEntityModalService.openModalMulti(eeTargetFlashIdList);
		}

		function declineProposal(productCode, eeTargetFlashIdList) {
			declineProposalService.openModalMulti(productCode, eeTargetFlashIdList);
		}

		function openPreviewModal(flashIds) {
			blockUI.start();
			htmlPreviewService.getHtmlPreviews(flashIds).then(function (htmlPreviews) {
				blockUI.stop();
				OpenNewTabService.openNewTab(htmlPreviews.join(), false, true);
				return htmlPreviews;
			}, function (error) {
				blockUI.stop();
			});
		}

		function unlockEEModal(eeTargetFlashIdList) {
			entityUnlockService.confirmUnlock(eeTargetFlashIdList);
		}

		function editMetadata(eeFlashIds) {
			editMetaDataModalService.openEditEntitiesMetaModal(eeFlashIds);
		}

		function productGroupEEModal(eeFlashIds) {
			productGroupManyEEService.openModal(eeFlashIds);
		}

		function deactivateNodes(nodesFlashIds) {
			deactivateNodesModalService.deactivateNodes(nodesFlashIds)
				.then(function () {
					ctrl.refreshFunction();
				});
		}
		function deleteNodes(nodesFlashIds) {
			deleteNodesModalService.deleteNodes(nodesFlashIds)
				.then(function () {
					ctrl.refreshFunction();
				});
		}

		function linkEes(eeFlashIds, productCode) {
			blockUI.start();
			entityLinkingResource.verifyLinkConditions({
				eeFlashIds: eeFlashIds
			}).$promise.then(function (response) {
				blockUI.stop();

				var errorMsgName = null;
				if (response.editContentEnabled && response.existCommonTargetsTR) {
					prepareEesLinkWizard(response.targetEntities, productCode);
				} else if (!response.editContentEnabled) {
					errorMsgName = 'userApp.searchInterfaceTemplate.home.unauthorizedEditContent';
				} else if (!response.existCommonTargetsTR) {
					errorMsgName = 'userApp.searchInterfaceTemplate.home.noCommonTr';
				}

				if (errorMsgName !== null) {
					infoModalService.openActionDenied({
						name: $filter('translate')('userApp.bulkoperations.modal.linkTitle'),
						denied: $filter('translate')(errorMsgName)
					});
				}

			}, function () {
				blockUI.stop();
			});
		}

		function prepareEesLinkWizard(targetEntities, productCode) {

			//Launch link ee wizard
			var entities = [];
			angular.forEach(targetEntities, function (targetEe) {
				entities.push({
					flashId: targetEe.identifier,
					eetCode: targetEe.editorialEntityTemplate.code,
					metaInstanceList: targetEe.metaInstanceList,
					system: targetEe.system
				});
			});
			LinkEeWizardModalService.openModal(entities, ctrl.currentUser, true, undefined, productCode).then(function () {
				ctrl.clearSelection();
				$state.reload();
			});

		}

		function openDeleteEntityMultiModal(flashIds) {

			var deleteEntityMultiModal = $uibModal.open({
				component: 'multiDeleteEntityModal',
				resolve: {
					flashIds: function () { return flashIds; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('archiveEditorialEntity');
						$translatePartialLoader.addPart('editorialEntity');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			deleteEntityMultiModal.opened.then(function () {
				blockUI.stop();
			});
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('inProgressInstances', {
			templateUrl: 'scripts/pre-upgrade/components/in-progress-instances/in-progress-instances.html',
			controller: InProgressInstancesController,
			bindings: {
				tableId: '<?',
				onRowSelected: '&?',
				getAdapter: '&?',
				userGroup: '<',
				hidePagination: '<?',
				pageSize: '<?',
				displayMode: '<?'
			}
		});

	/** @ngInject */
	function InProgressInstancesController($sce, $state, blockUI, userPreferenceService, workService, $timeout, OpenNewTabService) {
		var ctrl = this;

		////////////////

		ctrl.initPagination = function (size) {
			ctrl.pagination = {
				itemByPage: size,
				totalCount: 0,
				currentPage: 1
			};
		};

		ctrl.$onInit = function () {
			//ENTITIES TO SHOW
			ctrl.entities = [];

			if (!ctrl.tableId) {
				ctrl.tableId = 'inProgressInstancesTable';
			}

			//SEARCH CRITERIAS
			if (!ctrl.filterSearchParam) {
				ctrl.filterSearchParam = {};
				ctrl.filterSearchParam.ownerGroup = ctrl.userGroup;
			}

			//default value
			ctrl.filterSearchParam = userPreferenceService.getUserGlobalPreference(ctrl.getStorageKey(), ctrl.filterSearchParam);

			if (ctrl.getAdapter) {
				ctrl.getAdapter({
					adapter: {
						reload: function () {
							$timeout(function () {
								ctrl.loadAllee();
							});
						},
						clearSelection: function () {
							ctrl.selectedEE = null;
						}
					}
				});
			}

			//PAGINATION
			if (!ctrl.pagination) {
				ctrl.initPagination(50);
			}

			if (angular.isUndefined(ctrl.hidePagination)) {
				ctrl.hidePagination = false;
			}
		};
		ctrl.$onChanges = function (changesObj) {
			if (changesObj.pageSize) {
				ctrl.initPagination(changesObj.pageSize.currentValue);
			}
		};
		ctrl.$onDestroy = function () { };

		ctrl.getStorageKey = function (pagination) {
			var key = 'InProgressInstancesSearchMap_' + ctrl.userGroup;

			if (pagination) {
				key += '_pagination';
			}

			return key;
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.navigateToEE = function (idEE) {
			$state.go('editorialEntity', {
				id: idEE
			});
		};

		ctrl.rowSelected = function (ee) {
			ctrl.selectedEE = ee.identifier;

			if (ctrl.onRowSelected) {
				ctrl.onRowSelected({ row: ee });
			}
		};

		ctrl.isEESelected = function (idEE) {
			return idEE === ctrl.selectedEE;
		};

		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'change';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllee();
		};



		ctrl.loadAllee = function () {
			userPreferenceService.setUserGlobalPreference(ctrl.getStorageKey(), ctrl.filterSearchParam);
			//FETCHING DATA
			blockUI.start();
			ctrl.filterSearchParam.page = Math.max(ctrl.pagination.currentPage - 1, 0);
			ctrl.filterSearchParam.size = ctrl.pagination.itemByPage;
			ctrl.filterSearchParam.sort = ctrl.sortString;
			workService.getInProgressInstances(
				ctrl.filterSearchParam

			).then(function (data) {
				ctrl.events = data;
				ctrl.rowCollection = data ? (data.content ? data.content : []) : [];
				ctrl.entities = []
					.concat(ctrl.rowCollection);

				ctrl.pagination.totalCount = data.totalElements;
				ctrl.isLoading = false;

				blockUI.stop();
			}).catch(function (e) {
				blockUI.stop();
			});
		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('loginComponent', {
			templateUrl: 'scripts/pre-upgrade/components/login/login.html',
			controller: LoginController,
			bindings: {
			}
		});

	/** @ngInject */
	function LoginController($rootScope, config) {
		var ctrl = this;
		ctrl.$onInit = function () {
			ctrl.environnement = config.environnement;
			ctrl.version = config.version;
			ctrl.tag = $rootScope.TAG;
			ctrl.build_time = $rootScope.BUILD_TIME;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('login', {
				parent: 'connect',
				url: '/login',
				data: {
					authorities: [],
					pageTitle: 'login.title'
				},
				component: 'loginComponent',
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('login');
						return $translate.refresh();
					}]
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('loginService', LoginService);



	/** @ngInject */
	function LoginService($state, $rootScope) {
		var service = {
			back: back,
			navigate: navigate
		};

		return service;

		function navigate(modal) {
			if ($rootScope.navigating) {
				$state.go($rootScope.toState, $rootScope.toStateParams);
			}
			else {
				$state.reload();
			}
		}

		function back() {
			// If previous state is 'activate' or do not exist go to 'home'
			var previousStateName = $state.get($rootScope.previousStateName);
			if (previousStateName === null || previousStateName.name === "home") {
				$state.go('home');
			} else {
				$state.go($rootScope.previousStateName, $rootScope.previousStateNameParams);
			}
			$rootScope.menuLock = true;
		}


	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('displayMetaValues', {
			templateUrl: 'scripts/pre-upgrade/components/metadata/display-meta-values.html',
			controller: DisplayMetaValuesController,
			controllerAs: '$ctrl',
			bindings: {
				metadataList: '<?',
				includeSystem: '<?',
				flashId: '<?',
				type: '<?',
				externalLoadCallback: '<?'
			},
		});


	function DisplayMetaValuesController(blockUI, treeviewNodeService) {
		var $ctrl = this;


		////////////////

		$ctrl.loading = false;
		$ctrl.$onInit = function () {
			if ($ctrl.flashId && $ctrl.type) {
				if (!$ctrl.externalLoadCallback) {
					blockUI.start();
					treeviewNodeService.getMetaInstance($ctrl.flashId, $ctrl.type)
						.then(function (data) {
							$ctrl.metadataList = data;
							blockUI.stop();
						});
				}
				else {
					$ctrl.loading = true;
					$ctrl.externalLoadCallback($ctrl.flashId, $ctrl.type).then(function (data) {
						$ctrl.metadataList = data;
					}).finally(function () {
						$ctrl.loading = false;
					});
				}
			}
			if (angular.isUndefined($ctrl.includeSystem)) {
				$ctrl.includeSystem = false;
			}
		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };

		$ctrl.canDisplay = function (meta) {
			if ($ctrl.flashId || $ctrl.type) {
				if ($ctrl.includeSystem) {
					return true;
				}
				else {
					if (meta) {
						return !meta.metaDataDTO.metaSystem;
					}

					return false;
				}
			}
			return true;
		};

		$ctrl.getMetaValueFromList = function (metadata) {
			var result;
			_.forEach(metadata.metaDataDTO.listMetaDataValues, function (item) {
				if (item.identifier === metadata.value) {
					result = item.wording;
				}
			});
			return result ? result : metadata.value;
		};
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('monitoringComponent', {
			templateUrl: 'scripts/pre-upgrade/components/monitoring/monitoring.html',
			controller: MonitoringController
		});

	/** @ngInject */
	function MonitoringController(monitoringResource, blockUI) {
		var ctrl = this;
		////////////////

		ctrl.$onInit = function () {
			ctrl.getAppsHealth();
		};

		ctrl.getAppsHealth = function () {
			var monitoringUi = blockUI.instances.get('monitoringUi');
			monitoringUi.start();
			monitoringResource.getApps().$promise.then(function (apps) {
				ctrl.apps = apps;
				ctrl.lastUpdateDate = new Date();
				monitoringUi.stop();
			}, function () {
				monitoringUi.stop();
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('monitoring', {
			parent: 'main',
			url: '/monitoring',
			data: {
				authorities: ["ROLE_ADMIN_SI"]
			},
			views: {
				'content@mainLayout': 'monitoringComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('monitoring');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('monitoringService', MonitoringService);

	/** @ngInject */
	function MonitoringService(monitoringResource, announcementMessages, announcementService, $filter) {
		var service = {
			announceDownApps: announceDownApps
		};

		return service;

		////////////////
		function announceDownApps() {
			monitoringResource.getDownApps().$promise.then(function (apps) {
				announcementService.deleteAnnouncement(announcementMessages.MONITORING);
				if (!_.isEmpty(apps)) {
					var appNames = _.map(apps, function (app) {
						return app;
					}).join(', ');
					var announcement = announcementService.buildAnnouncement(announcementMessages.MONITORING, $filter("translate")("global.messages.monitoring.warning", { apps: appNames }), "warning");
					announcementService.addAnnouncement(announcement);
				}
			});
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('myWork', {
			templateUrl: 'scripts/pre-upgrade/components/mywork/my-work.html',
			controller: MyWorkController,
			bindings: {
				tableId: '<?',
				currentUser: '<',
				displayMode: '<?',
				onRowSelected: '&?',
				getAdapter: '&?',
				userGroup: '<?',
				hidePagination: '<?',
				pageSize: '<?'
			},
		});

	/** @ngInject */
	function MyWorkController($sce, $state, blockUI, userPreferenceService, workService, $timeout, OpenNewTabService) {
		var ctrl = this;

		////////////////

		ctrl.initPagination = function (size) {
			ctrl.pagination = {
				itemByPage: size,
				totalCount: 0,
				currentPage: 1
			};
		};

		ctrl.$onInit = function () {
			//ENTITIES TO SHOW
			ctrl.entities = [];

			if (!ctrl.displayMode) {
				ctrl.displayMode = 'FULL';
			}

			if (!ctrl.tableId) {
				ctrl.tableId = 'myWorkTable';
			}

			//SEARCH CRITERIA
			if (!ctrl.searchFilters) {
				ctrl.searchFilters = {};
				ctrl.searchFilters.creatorLogin = null;
				ctrl.searchFilters.modifierLogin = null;
				ctrl.searchFilters.assignmentRoleCode = null;
				ctrl.searchFilters.statusId = null;
				ctrl.searchFilters.eetCode = null;
				ctrl.searchFilters.lockerLogin = null;
				ctrl.searchFilters.initiatorLogin = null;
				ctrl.searchFilters.ownerGroupCode = null;
			}

			ctrl.allFilters = {};

			//default value

			// No need to get the filters when the displayMode is LIGHT (home page) or GROUP (contextualized home page)
			if (ctrl.displayMode !== 'LIGHT' && ctrl.displayMode !== 'GROUP') {
				ctrl.searchFilters = userPreferenceService.getUserGlobalPreference(ctrl.getStorageKey(), ctrl.searchFilters);

				workService.getAllFilters().then(function (data) {
					if (data.filters.lockers) {
						data.filters
							.lockers.splice(0, 0, {
								code: 'notLocked',
								value: 'userApp.travaux.unlocked'
							});
					}

					ctrl.allFilters = data.filters;
				});
			}

			if (ctrl.displayMode === 'GROUP') {
				ctrl.searchFilters.ownerGroupCode = ctrl.userGroup;
			}

			//PAGINATION
			if (!ctrl.pagination) {
				ctrl.initPagination(50);
				if (ctrl.displayMode === 'LIGHT') {
					ctrl.pagination.itemByPage = 10;
				}
			}

			if (ctrl.getAdapter) {
				ctrl.getAdapter({
					adapter: {
						reload: function () {
							$timeout(function () {
								ctrl.loadAllee();
							});
						},
						clearSelection: function () {
							ctrl.selectedEE = null;
						},
						pagination: ctrl.pagination
					}
				});
			}
		};
		ctrl.$onChanges = function (changesObj) {
			if (changesObj.pageSize) {
				ctrl.initPagination(changesObj.pageSize.currentValue);
			}
		};
		ctrl.$onDestroy = function () { };

		ctrl.getStorageKey = function (pagination) {
			var baseKey = 'MY_WORK_SEARCH_MAP';
			var key = ctrl.displayMode === 'GROUP' ? baseKey + '_' + ctrl.userGroup : baseKey;

			if (pagination) {
				key += '_pagination';
			}

			return key;
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.navigateToEE = function (idEE) {
			$state.go('editorialEntity', {
				id: idEE
			});
		};

		ctrl.rowSelected = function (ee) {
			ctrl.selectedEE = ee.identifier;

			if (ctrl.onRowSelected) {
				ctrl.onRowSelected({ row: ee });
			}
		};

		ctrl.isEESelected = function (idEE) {
			return idEE === ctrl.selectedEE;
		};

		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'systemLastUpdateDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllee();
		};



		ctrl.loadAllee = function () {
			ctrl.currentUserFullName = ctrl.currentUser.firstName + " " + ctrl.currentUser.lastName;
			if (ctrl.displayMode !== 'LIGHT') {
				userPreferenceService.setUserGlobalPreference(ctrl.getStorageKey(), ctrl.searchFilters);
			}
			//FETCHING DATA
			blockUI.start();
			ctrl.searchFilters.currentPage = Math.max(ctrl.pagination.currentPage - 1, 0);
			ctrl.searchFilters.itemByPage = ctrl.pagination.itemByPage;
			workService.getAll(
				ctrl.searchFilters,
				Math.max(ctrl.pagination.currentPage - 1, 0),
				ctrl.pagination.itemByPage,
				ctrl.sortString
			).then(function (data) {
				ctrl.events = data;
				ctrl.rowCollection = data ? (data.entities ? data.entities : []) : [];
				ctrl.entities = []
					.concat(ctrl.rowCollection);

				ctrl.pagination.totalCount = data.totalElements;
				ctrl.isLoading = false;

				blockUI.stop();
			}).catch(function (e) {
				blockUI.stop();
			});
		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('myworkPageComponent', {
			templateUrl: 'scripts/pre-upgrade/components/mywork/mywork-page.html',
			controller: MyWorkPageController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function MyWorkPageController() {
		var ctrl = this;

		ctrl.showPreview = function (ee) {
			ctrl.selectedEE = ee.identifier;
			ctrl.preview = {
				opened: true,
				flashId: ee.identifier
			};
		};

		ctrl.setAdapter = function (adapter) {
			ctrl.myWorkAdapter = adapter;
		};

		ctrl.myWorkPreviewClose = function () {
			if (ctrl.myWorkAdapter) {
				ctrl.myWorkAdapter.clearSelection();
			}
		};

		ctrl.reload = function () {
			if (ctrl.myWorkAdapter) {
				ctrl.myWorkAdapter.reload();
			}
		};

		// INIT
		ctrl.$onInit = function () {
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('mywork', {
			parent: 'main',
			url: '/mywork',
			views: {
				'content@mainLayout': 'myworkPageComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('travaux');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	/**
		*  service that groups my work operations
		*/
	angular
		.module('userApp')
		.factory('workService', workService);

	/** @ngInject */
	function workService(WorksResource) {

		var service = {
			getAllFilters: getAllFilters,
			getAll: getAll,
			getInProgressInstances: getInProgressInstances
		};

		return service;

		function getAllFilters() {
			return WorksResource.getAllFilters().$promise;
		}

		function getAll(searchFilters, page, size, sort) {
			return WorksResource.getAll({
				page: page,
				size: size,
				sort: sort
			}, searchFilters
			).$promise;
		}

		function getInProgressInstances(filters) {
			return WorksResource.getInProgressInstances(filters).$promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('myModels', {
			parent: 'main',
			url: '/mymodels',
			views: {
				'content@mainLayout': 'myModelsComponent'
			},
			resolve: {
				mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('model');
					$translatePartialLoader.addPart('datepicker');
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('editorialEntity');
					return $translate.refresh();
				}]
			}
		});
	}

})();

'use strict';

angular.module('userApp')
	.factory('modelService', function ($resource) {
		return $resource('api/model', {}, {
			'saveModel': {
				url: 'api/model/saveModel',
				method: 'POST'
			},
			'allModelVisibility': {
				url: 'api/model/allModelVisibility',
				method: 'GET'
			},
			'getAllModels': {
				url: 'api/model/allModels/:codeTEE',
				method: 'GET',
				isArray: true
			},
			'loadMetaInstantiation': {
				url: 'api/model/allMetaInstantiation/:codeTEE',
				method: 'GET',
				params: {
					allMetas: '@allMetas'
				},
				isArray: true
			},
			'query': {
				method: 'GET',
				isArray: false
			},
			'deleteModel': {
				url: 'api/model/deleteModel/:modelFlashId',
				method: 'DELETE'
			},
			'getModel': {
				method: 'GET',
				url: 'api/model/:modelFlashId',
				params: {
					withAllMetaInstances: '@withAllMetaInstances'
				},
			},
			'checkManageDefaultModelPermission': {
				method: 'GET',
				url: 'api/model/checkManageDefaultModelPermission',
				params: {
					eetCode: '@eetCode',
					productCode: '@productCode'
				},
				transformResponse: function (data) {
					return { permission: data === 'true' };
				}
			}
		});

	});

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('mytrashComponent', {
			templateUrl: 'scripts/pre-upgrade/components/my-trash/my-trash.component.html',
			controller: MyTrashContoller,
			bindings: {

			},
		});

	/** @ngInject */
	function MyTrashContoller() {
		var ctrl = this;

		ctrl.showPreview = function (ee) {
			ctrl.selectedEE = ee.identifier;
			ctrl.preview = {
				opened: true,
				flashId: ee.identifier,
				isArchived: true
			};
		};

		ctrl.setAdapter = function (adapter) {
			ctrl.myTrashAdapter = adapter;
		};

		ctrl.closePreview = function () {
			if (ctrl.myTrashAdapter) {
				ctrl.myTrashAdapter.clearSelection();
			}
		};

		ctrl.reload = function () {
			if (ctrl.myTrashAdapter) {
				ctrl.myTrashAdapter.reload();
			}
		};

		// INIT
		ctrl.$onInit = function () {
		};

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('mytrash', {
			parent: 'main',
			url: '/mytrash',
			views: {
				'content@mainLayout': 'mytrashComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('archiveEditorialEntity');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('searchInterfaceTemplate');
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('datepicker');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	/**
	 *  service that groups my trash operations
	 */
	angular
		.module('userApp')
		.factory('trashService', trashService);

	/** @ngInject */
	function trashService(TrashResource) {

		var service = {
			getAllFilters: getAllFilters,
			getAll: getAll,
		};

		return service;

		function getAllFilters() {
			return TrashResource.getAllFilters().$promise;
		}

		function getAll(filterSearchParam) {
			return TrashResource.getAll(filterSearchParam).$promise;
		}

	}
})();

(function () {
	'use strict';

	// Usage:
	//
	// Creates:
	//

	angular
		.module('userApp')
		.component('productEntity', {
			templateUrl: 'scripts/pre-upgrade/components/product-entity/product-entity.html',
			controller: ProductEntityController,
			bindings: {
				tableId: '<?',
				onRowSelected: '&?',
				getAdapter: '&?',
				userGroup: '<',
				publicationFilter: '@?',
				associationStatus: '@',
				hidePagination: '<?',
				pageSize: '<?',
				isNews: '<',
				isProposals: '@?',
				sortString: '<?'
			},
		});

	/** @ngInject */
	function ProductEntityController($rootScope, $sce, $state, $filter, $timeout, blockUI, userPreferenceService, productEntityService, editMetaDataModalService,OpenNewTabService) {
		var ctrl = this;

		////////////////

		ctrl.initPagination = function (size) {
			ctrl.pagination = {
				itemByPage: size,
				totalCount: 0,
				currentPage: 1
			};
		};

		ctrl.$onInit = function () {
			//ENTITIES TO SHOW
			ctrl.entities = [];

			if (!ctrl.tableId) {
				ctrl.tableId = 'myProductEntityTable';
			}

			//SEARCH CRITERIAS
			if (!ctrl.filterSearchParam) {
				ctrl.filterSearchParam = {};
				ctrl.filterSearchParam.ownerGroup = ctrl.userGroup;
				ctrl.filterSearchParam.publicationFilter = ctrl.publicationFilter;
				ctrl.filterSearchParam.associationStatus = ctrl.associationStatus;
			}

			//PAGINATION
			ctrl.pagination.itemByPage = 10;


			if (ctrl.getAdapter) {
				ctrl.getAdapter({
					adapter: {
						reload: function () {
							$timeout(function () {
								ctrl.loadAllee();
							});
						},
						clearSelection: function () {
							ctrl.selectedEE = null;
						},
						pagination: ctrl.pagination
					}
				});
			}

			ctrl.loadAllee();
		};

		ctrl.showOrHideAll = function() {
			if (ctrl.hidePagination) {
				ctrl.hidePagination = false;
				ctrl.pagination.itemByPage = 20;
				ctrl.loadAllee();
			} else {
				ctrl.hidePagination = true;
				ctrl.pagination.itemByPage = 10;
				ctrl.pagination.currentPage = 1;
				ctrl.loadAllee();
			}
		};

		ctrl.$onChanges = function (changesObj) {
			if (changesObj.pageSize) {
				ctrl.initPagination(changesObj.pageSize.currentValue);
			}
		};
		ctrl.$onDestroy = function () { };

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.navigateToEE = function (idEE) {
			$state.go('editorialEntity', {
				id: idEE
			});
		};

		ctrl.rowSelected = function (ee) {
			ctrl.selectedEE = ee.identifier;

			if (ctrl.onRowSelected) {
				ctrl.onRowSelected({ row: ee });
			}
		};

		ctrl.isEESelected = function (idEE) {
			return idEE === ctrl.selectedEE;
		};

		$rootScope.$on('$destroy', $rootScope.$on('proposal_update', function (fireCallBack) {
			//reload only To BE PUBLISHED EE
			if (fireCallBack && ctrl.publicationFilter === 'TO_BE_PUBLISHED') {
				ctrl.loadAllee();
			}
		}));

		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'change';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllee();
		};

		ctrl.refreshProposals = function () {
			//Reload proposals
			ctrl.loadAllee();
			//Emit event to fire callback and reload To BE PUBLISHED EE
			$rootScope.$broadcast("proposal_update", 'true');
		};

		ctrl.loadAllee = function () {
			//FETCHING DATA
			blockUI.start();

			productEntityService.getAll(
				ctrl.filterSearchParam,
				Math.max(ctrl.pagination.currentPage - 1, 0),
				ctrl.pagination.itemByPage,
				ctrl.sortString
			).then(function (data) {
				ctrl.events = data;
				ctrl.rowCollection = data ? (data.productEntityDtos ? data.productEntityDtos : []) : [];
				ctrl.entities = [].concat(ctrl.rowCollection);

				ctrl.pagination.totalCount = data.totalElements;
				ctrl.isLoading = false;

				blockUI.stop();
			}).catch(function (e) {
				blockUI.stop();
			});
		};

		ctrl.openEditMetaModal = function (flashId, productName, event) {
			event.stopPropagation();
			var editMetaModalTitle = $filter('translate')('userApp.product.editMetaModal.editMetaModalTitle', { productName: productName });
			editMetaDataModalService.openEditProductMetaModal(flashId, editMetaModalTitle).then(function (response) {
				if (response) {
					ctrl.refreshProposals();
				}
			});
		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};
	}
})();

(function () {
	'use strict';

	/**
	 *  service that groups my work operations
	 */
	angular
		.module('userApp')
		.factory('productEntityService', productEntityService);

	/** @ngInject */
	function productEntityService(ProductEntityResource) {

		var service = {
			getAll: getAll
		};

		return service;

		function getAll(filterSearchParam, page, size, sort) {
			return ProductEntityResource.getAll({page: page, size: size, sort: sort},filterSearchParam).$promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('pinsComponent', {
			templateUrl: 'scripts/pre-upgrade/components/pins/pins.html',
			controller: PinsController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function PinsController() {

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('pins', {
			parent: 'main',
			url: '/pins',
			views: {
				'content@mainLayout': 'pinsComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pins');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('menuService', MenuService);



	/** @ngInject */
	function MenuService($resource, menuResource, userPreferenceService, configurationLocalUserService) {
		var service = {
			saveMenu: saveMenu,
			getMenu: getMenu
		};

		return service;


		function saveMenu(groupName, state) {

			var menu = userPreferenceService.getUserGlobalPreference('EcmuUserMenu', {});
			menu[groupName] = state;
			userPreferenceService.setUserGlobalPreference('EcmuUserMenu', menu);
			configurationLocalUserService.addUserGlobalPreference('EcmuUserMenu', menu);
		}

		function getMenu() {
			return menuResource.getMenu().$promise.then(function (data) {
				var result = [];
				if (data && data.length > 0) {
					var current = {};
					current.groups = [];
					result.push(current);
					var currentGroup = {
						childs: []
					};
					current.groups.push(currentGroup);

					var storedMenu = userPreferenceService.getUserGlobalPreference('EcmuUserMenu', null);
					data.forEach(function (element) {
						if (element.uiSref === 'sep') {
							if (current.groups.length > 0) {
								current = {};
								current.groups = [];
								result.push(current);
							}
						} else if (element.uiSref === '') {
							currentGroup = {
								group: element,
								childs: []
							};
							current.groups.push(currentGroup);
							if (storedMenu && angular.isDefined(storedMenu[element.translate])) {
								currentGroup.isOpen = storedMenu[element.translate];
							}
						} else {
							currentGroup.childs.push(element);
						}

					}, this);
				}
				return result;
			});
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('navbar', {
			templateUrl: 'scripts/pre-upgrade/components/navbar/navbar.component.html',
			controller: navbarController,
			bindings: {
				currentUser: "="
			},
		});

	/** @ngInject */
	function navbarController($location) {
		var ctrl = this;

		ctrl.$onInit = function () {};
	}
})();

(function () {
	'use strict';

	// Usage:
	//
	// Creates:
	//

	angular
		.module('userApp')
		.component('productSearch', {
			templateUrl: 'scripts/pre-upgrade/components/product-search/product-search.html',
			controller: ProductSearchController,
			bindings: {
				code: '<'
			},
		});

	/** @ngInject */
	function ProductSearchController($rootScope, $sce, $state, $filter, $timeout, blockUI, productSearchService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.productSearchs = productSearchService.findByCode({ code: ctrl.code }).then(function (data) {
				ctrl.productSearchs = data;
			});
		};
	}
})();

(function () {
	'use strict';

	/**
	 *  service that groups my work operations
	 */
	angular
		.module('userApp')
		.factory('productSearchService', ProductSearchService);

	/** @ngInject */
	function ProductSearchService(productSearchResource) {

		var service = {
			findByCode: findByCode,
			findByCodeAndSitId: findByCodeAndSitId
		};

		return service;

		function findByCode(params) {
			return productSearchResource.findByCode(params).$promise;
		}

		function findByCodeAndSitId(code, sitId) {
			return productSearchResource.findByCodeAndSitId({ code: code, sitId: sitId }).$promise;
		}

	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('productDashboardComponent', {
			templateUrl: 'scripts/pre-upgrade/components/product-dashboard/product-dashboard.html',
			controller: ProductDashboardController,
			bindings: {
				userGroup: '<',
				currentUser: '<'
			},
		});

	/** @ngInject */
	function ProductDashboardController($rootScope, $timeout, imageUtilService, productDashboardService, userPreferenceService) {
		var $ctrl = this;

		////////////////

		$ctrl.isMore = function (pagination) {
			return pagination && pagination.totalCount >= pagination.itemByPage ? 'more' : '';
		};

		$ctrl.setAdapter = function (key, adapter) {
			$ctrl.adapters[key] = adapter;
		};

		$ctrl.reload = function () {
			if ($ctrl.currentPreviewKey && $ctrl.adapters[$ctrl.currentPreviewKey]) {
				$ctrl.adapters[$ctrl.currentPreviewKey].reload();
			}
		};

		$ctrl.close = function () {
			if ($ctrl.currentPreviewKey && $ctrl.adapters[$ctrl.currentPreviewKey]) {
				$ctrl.adapters[$ctrl.currentPreviewKey].clearSelection();
			}
		};

		$ctrl.show = function (key, ee) {
			if ($ctrl.currentPreviewKey && key !== $ctrl.currentPreviewKey) {
				$ctrl.currentPreview.opened = false;
				$timeout(function () {
					$ctrl.currentPreviewKey = key;
					$ctrl.currentPreview = { opened: true, flashId: ee.identifier };
				}, 200);
			}
			else {
				$ctrl.currentPreview = { opened: true, flashId: ee.identifier };
				$ctrl.currentPreviewKey = key;
			}
		};

		$ctrl.getPaginationStorageKey = function (value) {
			return value + '_' + $ctrl.userGroup.code;
		};

		$ctrl.showOrHideWorkAll = function() {
			if ($ctrl.hideWorkTablePagination) {
				$ctrl.hideWorkTablePagination = false;
				$ctrl.adapters.myWork.pagination.itemByPage = 20;
				$ctrl.adapters.myWork.reload();
			} else {
				$ctrl.hideWorkTablePagination = true;
				$ctrl.adapters.myWork.pagination.itemByPage = 10;
				$ctrl.adapters.myWork.pagination.currentPage = 1;
				$ctrl.adapters.myWork.reload();
			}
		};

		$ctrl.$onInit = function () {
			if ($ctrl.userGroup) {
				$rootScope.ownerGroup = $ctrl.userGroup.code;
				//set ownerGroup to local storage
				userPreferenceService.setUserGlobalPreference('OwnerGroup', $ctrl.userGroup.code);
				imageUtilService.groupImageExist($ctrl.userGroup.code).then(function (result) {
					$ctrl.hasLogo = result;
					$ctrl.logoPath = imageUtilService.getGroupLogoPath($ctrl.userGroup.code);
				});
				productDashboardService.checkIfEditProposalPermitted($ctrl.userGroup.code).then(function (data) {
					$ctrl.showProposals = data.result;
				});
			}
			$ctrl.adapters = {};
			$ctrl.inProgressPageSize = 10;
			$ctrl.hideWorkTablePagination = true;
			$ctrl.myWorkPageSize = 10;
			$ctrl.newEntityToPublishAgainSize = 10;
			$ctrl.newEntityWaitingForPublicationSize = 10;
			$ctrl.entityWaitingForProductAcceptance = 10;
			$ctrl.lastPublicationsTitleSize = 10;
			$ctrl.myWorkPageSize = 10;
			$ctrl.notificationPageSize = 10;


		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('productDashboard', {
			parent: 'main',
			url: '/productdashboard/{code}',
			views: {
				'content@mainLayout': 'productDashboardComponent'
			},
			resolve: {
				userGroup: function ($stateParams, productDashboardService) {
					if ($stateParams.code) {
						return productDashboardService.getGroup($stateParams.code);
					}
					return null;
				},
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('datepicker');
					$translatePartialLoader.addPart('travaux');
					$translatePartialLoader.addPart('product');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('metadatas');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	/**
	 * service for my-groups component.
	 */
	angular
		.module('userApp')
		.factory('productDashboardService', productDashboardService);

	/** @ngInject */
	function productDashboardService(userGroupResource, productResource) {
		var service = {
			getGroup: getGroup,
			checkIfEditProposalPermitted: checkIfEditProposalPermitted
		};

		return service;

		function getGroup(code) {
			return userGroupResource.groupByCode({ code: code }).$promise.then(function (data) {
				return data.body;
			});
		}

		function checkIfEditProposalPermitted(code) {
			return productResource.checkIfEditProposalPermitted({ productCode: code }).$promise.then(function (data) {
				return data;
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('proofComponent', {
			templateUrl: 'scripts/pre-upgrade/components/publish/proof.html',
			controller: proofController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			}
		});

	/** @ngInject */
	function proofController($filter, $rootScope, publishResource, blockUI) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.editorialEntity = ctrl.resolve.entity;
			ctrl.publish = ctrl.resolve.publish;
			//boolean indicate we have product channels
			ctrl.canalsFromProduct = ctrl.resolve.publish.canalsFromProduct;
			ctrl.productChannels = ctrl.resolve.publish.productChannels;

			//Tee channels, empty if there is product channels
			ctrl.publicationChannel = ctrl.resolve.publish.publicationChannel;
			ctrl.selectedProofChannel = {};
			ctrl.checkedValue = false;
			ctrl.informatifMessag = [];
			// SET DEFAULT SELECTION 
			// CASE 1 : WHENE THERE 'S ONE CHANNEL IN THE TEE AND NO ONE IN THE PRODUCT
			if (enableDefaultSelectionTeeChannel()) {
				ctrl.publicationChannel[0].ticked = true;
				ctrl.selectedProofChannel = ctrl.publicationChannel[0];
				ctrl.publish.selectedChannel.push(ctrl.selectedProofChannel);
				ctrl.checkedValue = true;
			}
			// SET DEFAULT SELECTION 
			// CASE 2 : WHENE THERE 'S ONE CHANNEL IN THE TEE AND THE SAME IN THE **ONLY** PRODUCT 
			else if (enableDefaultSelectionProductChannel()) {
				ctrl.productChannels[0].publicationChannel[0].ticked = true;
				ctrl.selectedProofChannel = ctrl.productChannels[0].publicationChannel[0];
				ctrl.publish.selectedChannel.push(ctrl.selectedProofChannel);
				ctrl.checkedValue = true;
			}
		};

		ctrl.selectProofChannel = function () {
			ctrl.publish.selectedChannel = [];
			ctrl.checkedValue = true;
			ctrl.publish.selectedChannel.push(ctrl.selectedProofChannel);
		};

		ctrl.save = function () {
			blockUI.start();
			ctrl.publish.editorialEntity = ctrl.editorialEntity;
			ctrl.publish.publishMode = false;

			ctrl.publishResolve = publishResource.save(ctrl.publish, function () {
				ctrl.informatifMessag = ctrl.publishResolve.informatifMessag;
				ctrl.confirm = true;
				blockUI.stop();
			});
		};

		ctrl.cancel = function () {
			ctrl.dismiss({
				$value: false
			});
		};

		ctrl.closeProofingStatusModal = function () {

			$rootScope.$emit("publish_success");
			ctrl.dismiss({
				$value: false
			});
		};
    /**
		 * FUNCTION RETURN BOOLEAN TRUE IN CASE DEFAULT SELECTION OF THE ONE PRODUCT CHANNEL
		 */
		function enableDefaultSelectionProductChannel() {
			return ctrl.canalsFromProduct && ctrl.productChannels && ctrl.productChannels.length === 1 && ctrl.productChannels[0].publicationChannel && ctrl.productChannels[0].publicationChannel.length === 1;
		}
    /**
		 * FUNCTION RETURN BOOLEAN TRUE IN CASE DEFAULT SELECTION OF THE ONE TEE CHANNEL
		 */
		function enableDefaultSelectionTeeChannel() {
			return !ctrl.canalsFromProduct && ctrl.publicationChannel && ctrl.publicationChannel.length === 1;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('publishComponent', {
			templateUrl: 'scripts/pre-upgrade/components/publish/publish.html',
			controller: publishController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function publishController($filter, publishResource, blockUI, $rootScope, $state) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editorialEntity = ctrl.resolve.entity;
			ctrl.publicationChannel = ctrl.resolve.publish.publicationChannel;
			ctrl.publish = ctrl.resolve.publish;
			ctrl.publish.publishMode = true;
			ctrl.selectedChannel = [];
			ctrl.notFinalStatusEntities = ctrl.resolve.publish.notFinalStatusEntities;
			ctrl.notValidEntitys = ctrl.resolve.publish.notValidEntitys;
			ctrl.brockenLink = ctrl.resolve.publish.brockenLink;
			ctrl.notImportedHistoricalIds = ctrl.resolve.publish.notImportedHistoricalIds;
			ctrl.selectedChanels = [];
			ctrl.productChannels = ctrl.resolve.publish.productChannels;

			//boolean indicate we have chennels from product
			ctrl.canalsFromProduct = ctrl.resolve.publish.canalsFromProduct;


			ctrl.informatifMessag = [];
			ctrl.confirm = false;
			ctrl.forcePublish = false;
			ctrl.allChannel = false;
			if (ctrl.publicationChannel && ctrl.publicationChannel.length === 1 && !ctrl.publicationChannel[0].notCheckedByDefault) {
				ctrl.publicationChannel[0].ticked = true;
				ctrl.selectedChanels.push(ctrl.publicationChannel[0]);
				ctrl.publish.selectedChannel = ctrl.selectedChanels;
			}
			if (ctrl.notValidEntitys.length > 0 || ctrl.notImportedHistoricalIds.length > 0) {
				ctrl.confirm = true;
			}

			if (ctrl.brockenLink.length > 0 || ctrl.notFinalStatusEntities.length > 0) {
				ctrl.forcePublish = true;
			}

			if (!ctrl.forcePublish && !ctrl.confirm) {
				ctrl.allChannel = true;
			}

			if (ctrl.publicationChannel) {
				ctrl.checkAllEntityPublicationChannels = false;
			}

			if (ctrl.canalsFromProduct) {
				ctrl.flatMap = [];
				ctrl.flatMap = _.flatMapDeep(ctrl.publish.productChannels, ctrl.returnChannels);
				angular.forEach(ctrl.flatMap, function (channel) {
					if (!channel.notCheckedByDefault) {
						channel.ticked = true;
					}
				});
				angular.forEach(ctrl.productChannels, function (product) {
					product.disabelAllchannel = true;
				});
				ctrl.selectedChanels = $filter('filter')(
					ctrl.flatMap, {
						ticked: true
					});
				ctrl.publish.selectedChannel = ctrl.selectedChanels;
			}
			angular.forEach(ctrl.publicationChannel, function (channel) {
				if (channel.checkedAndCanNotUncheck) {
					channel.ticked = true;
				}
			});

		};


		ctrl.returnChannels = function (product) {
			if (product && product.publicationChannel && product.publicationChannel.length > 0) {
				return [product.publicationChannel];
			}

		};

		ctrl.selectProductChannels = function (item) {
			ctrl.publish.selectedChannel = $filter('filter')(
				ctrl.flatMap, {
					ticked: true
				});
			ctrl.selectedChanels = ctrl.publish.selectedChannel;
			//All channels are ticked, set select all ticket
			item.disabelAllchannel = ctrl.publish.selectedChannel.length === ctrl.flatMap.length;
		};

		ctrl.selectAll = function (product) {
			if (product) {
				ctrl.selectedChanels = [];
				if (product.disabelAllchannel) {
					angular.forEach(product.publicationChannel, function (channel) {
						channel.ticked = true;
					});

					Array.prototype.push.apply(ctrl.selectedChanels, product.publicationChannel);
					ctrl.publish.selectedChannel = ctrl.selectedChanels;

				} else {
					angular.forEach(product.publicationChannel, function (channel) {
						channel.ticked = false;

					});
				}
			} else {
				angular.forEach(ctrl.publicationChannel, function (channel) {
					channel.ticked = ctrl.checkAllEntityPublicationChannels;
				});

				ctrl.selectChannels();
			}

		};


		ctrl.selectChannels = function () {
			ctrl.publish.selectedChannel = $filter('filter')(
				ctrl.publicationChannel, {
					ticked: true
				});
			ctrl.selectedChanels = ctrl.publish.selectedChannel;
		};

		ctrl.save = function () {
			blockUI.start();
			ctrl.publish.editorialEntity = ctrl.editorialEntity;
			ctrl.publish.publishMode = true;
			ctrl.publishResolve = publishResource.save(ctrl.publish, function () {

				ctrl.informatifMessag = ctrl.publishResolve.informatifMessag;
				ctrl.confirm = true;
				blockUI.stop();
			});

		};

		ctrl.displayChannel = function () {
			ctrl.allChannel = true;
			ctrl.forcePublish = false;
		};

		ctrl.cancel = function () {

			ctrl.dismiss({
				$value: false
			});
		};

		ctrl.closePublishStatusModal = function () {

			$rootScope.$emit("publish_success");
			ctrl.dismiss({
				$value: false
			});
		};
	}
})();

'use strict';

angular.module('userApp')
	.config(function ($stateProvider) {
		$stateProvider
			.state('publish', { 
				parent: 'main',
				url: "/publish/:id",       
				views: {
					'content@mainLayout': {
						templateUrl: 'scripts/app/entities/publish/publish.html' ,
						controller: 'PublishCtrl'
					}
				},
				resolve: {

				}           
			}) ;
	});

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('publishService', EditProductsModalService);


	/** @ngInject */
	function EditProductsModalService(blockUI, $uibModal, publishResource, entityFetchResource, $rootScope, $state, ModalAlertService, $filter) {
		var service = {
			publishModal: publishModal,
			proofModal: proofModal,
			getListChannel: getListChannel,
			publishOrder: publishOrder,
			excutePublishForProduct: excutePublishForProduct,
			openContextualProofingWizardModal: openContextualProofingWizardModal
		};

		return service;


		/**
		 * Publishing EE .
		 */
		function publishModal(editorialEntity, codeTEE) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'publishComponent',
				resolve: {
					entity: function () {
						return editorialEntity;
					},

					publish: function (publishResource) {
						return publishResource.getAllByProduct({
							codeTEE: codeTEE,
							idEE: editorialEntity.identifier,
							publishMode: true
						}).$promise;
					},

					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('publish');
						$translatePartialLoader.addPart('proof');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			modalInstance.result;

		}

		function proofModal(editorialEntity, codeTEE) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'proofComponent',
				resolve: {
					entity: function () {
						return editorialEntity;
					},

					publish: function (publishResource) {
						return publishResource.getAllByProduct({
							codeTEE: codeTEE,
							idEE: editorialEntity.identifier,
							publishMode: false
						}).$promise;
					},

					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('publish');
						$translatePartialLoader.addPart('proof');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			modalInstance.result;
		}

		function openContextualProofingWizardModal(editorialEntity, currentUser, isBulk, isFromFileMenu, productCode) {

			var entities = [];
			entities.push({
				flashId: editorialEntity.identifier,
				eetCode: editorialEntity.editorialEntityTemplate.code,
				metaInstanceList: editorialEntity.metaInstanceList,
				system: editorialEntity.system
			});

			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'linkEeWizardModal',
				resolve: {
					targetEntities: function () {
						return entities;
					},
					productCode: function () {
						return productCode;
					},
					isProofing: function () {
						return true;
					},
					entity: function () {
						return editorialEntity;
					},

					publish: function (publishResource) {
						return publishResource.getAllByProduct({
							codeTEE: editorialEntity.editorialEntityTemplate.code,
							idEE: editorialEntity.identifier,
							publishMode: false,
							isProofingWizard: true
						}).$promise;
					},
					currentUser: currentUser,
					isBulk: isBulk,
					isFromFileMenu: isFromFileMenu,
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('linkEEWizard');
						$translatePartialLoader.addPart('proof');
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}

		function getListChannel(codeTEE, idEE, publishMode) {
			return publishResource.getAllByProduct({
				codeTEE: codeTEE,
				idEE: idEE,
				publishMode: publishMode
			}).$promise.then(function (list) {
				return list;
			});


		}

		function publishOrder(eeFlashId, editorialEntity, isworkflow, redirect, publishFormDTO, publishProductName) {
			if (editorialEntity) {
				excutePublish(editorialEntity, isworkflow, redirect, publishFormDTO, publishProductName);
			} else {
				entityFetchResource.getByFlashId({ flashId: eeFlashId }).$promise.then(function (entity) {
					excutePublish(entity, isworkflow, redirect, publishFormDTO, publishProductName);
				});
			}

		}

		function excutePublishForProduct(entity, currentStep) {
			if (!currentStep || (!!currentStep && (currentStep.id !== entity.workFlowHistoryDTO.currentStep.id)) && entity.workFlowHistoryDTO.currentStep.autoPublishing) {
				excutePublish(entity, currentStep);
			}
		}


		function excutePublish(entity, isworkflow, redirect, publishFormDTO, publishProductName) {

			if (publishFormDTO) {
				savePublicationChannels(publishFormDTO, entity, true, redirect, publishProductName);
			} else if (!isworkflow) {
				publishModal(entity, entity.editorialEntityTemplate.code, true);

				if (redirect) {
					$rootScope.$broadcast("refresh_entity", { eeFlashId: entity.flashId });
					$state.go('editorialEntity', {
						id: entity.flashId
					});
				}
				blockUI.stop();
			}

		}

		//publish using all publication channels without using select pop-up
		function savePublicationChannels(publishDto, entity, publishMode, redirect, publishProductName) {
			blockUI.start();
			publishDto.editorialEntity = entity;
			publishDto.publishMode = publishMode;
			if (publishDto.selectedChannel.length === 0) {
				publishDto.selectedChannel = createPubChannel(publishDto);
			}
			var publishResolve = publishResource.save(publishDto, function () {
				var pubStatus = publishResolve.informatifMessag;
				var failedPub = false;
				pubStatus.find(function (status) {
					if (!status.publishStatus) {
						failedPub = true;
					}
				});
				if (failedPub) {
					ModalAlertService.error($filter('translate')('userApp.publish.msg.publishError'), publishProductName ? publishProductName : entity.ownerGroupName);
				} else {
					ModalAlertService.success($filter('translate')('userApp.publish.msg.publishSuccess'), publishProductName ? publishProductName : entity.ownerGroupName);
					$rootScope.$emit("publish_success");
				}
				if (redirect) {
					$state.go('editorialEntity', {
						id: entity.identifier
					});
				}
				blockUI.stop();
			});

		}


		function returnChannels(product) {
			if (product && product.publicationChannel && product.publicationChannel.length > 0) {
				return [product.publicationChannel];
			}

		}
		// create an array from all publication channels of all products
		function createPubChannel(publishDto) {
			if (publishDto.productChannels.length > 0) {
				var pubChannels = [];
				pubChannels = _.flatMapDeep(publishDto.productChannels, returnChannels);
				return pubChannels;
			} else {
				return publishDto.publicationChannel;
			}
		}

	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('proofingComponent', {
			templateUrl: 'scripts/pre-upgrade/components/proofing/proofing.html',
			controller: ProofingController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function ProofingController() {

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('proofing', {
			parent: 'main',
			url: '/proofing',
			views: {
				'content@mainLayout': 'proofingComponent'
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('proofing');
					return $translate.refresh();
				}]
			}
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('ColumnValueService', ColumnValueService);



	/** @ngInject */
	function ColumnValueService($filter) {
		var service = {
			getColumnValue: getColumnValue
		};

		return service;

		function getColumnValue(column, colValue) {
			if (colValue && column.associationMetaData) {
				var isDate = column.value.indexOf("DATE_") !== -1;
				var isBoolean = column.value.indexOf("BOOLEAN_") !== -1;
				var result = [];
				var values = colValue.split(" || ");
				for (var i in values) {
					var val = _.trim(values[i].substring(0, values[i].indexOf('(')));
					var product = values[i].substring(values[i].indexOf('('), values[i].indexOf(')') + 1);
					if (!_.isEmpty(product)) {
						if (isDate && !moment(values[i], moment.ISO_8601).isValid() && moment(val, moment.ISO_8601).isValid() && values[i].indexOf(" ") !== 1) {
							val = $filter('ecmDateTir')(val, getDateFormat(column.value));
						}
						else if (isBoolean) {
							val = (val === 'true' || val === true) ? $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.checkboxTrueValue') : $filter('translate')('userApp.searchInterfaceTemplate.listFilterTir.checkboxFalseValue');
						}
						result.push(val + " " + product);
					}
				}
				if (result.length > 0)
					return result.join(" || ");
			}
			return $filter('ecmDateTir')(colValue, getDateFormat(column.value));
		}

		//display date and hour only in case of column creation date or last update date
		function getDateFormat(column) {
			if (column.indexOf('SYSTEMCREATIONDATE') !== -1 || column.indexOf('SYSTEMLASTUPDATEDATE') !== -1)
				return 'short';
			return 'dd/MM/yyyy';
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('searchInterfacesTemplate', {
				parent: 'main',
				url: '/searchInterfacesTemplate/:identifier/:savedSearchId?:productCode:proposalsProduct',
				views: {
					'content@mainLayout': 'searchSolrMain'
				},
				params: {
					savedSearchId: { value: null, squash: true },
					productCode: { value: null, squash: true },
					proposalsProduct: { value: null, squash: true }
				},
				resolve: {
					savedSearch: function (SavedSearchService, $stateParams) {
						if ($stateParams.savedSearchId) {
							return SavedSearchService.getSavedSearch({
								identifier: $stateParams.identifier,
								savedSearchId: $stateParams.savedSearchId
							}).$promise;
						} else {
							return null;
						}

					},
					searchRequest: function () { return null; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('searchInterfaceTemplate');
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('bulkoperations');
						$translatePartialLoader.addPart('archiveEditorialEntity');
						return $translate.refresh();
					}]
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('SearchSolrService', SearchSolrService);



	/** @ngInject */
	function SearchSolrService(TirFilterSharedService, solrResource) {
		var service = {
			search: search
		};

		return service;

		function search(searchSolr, callback, errorCallback) {
			var searchHistory = {};
			if (searchSolr) {
				searchSolr.saveHistory = searchSolr.searchFullTextDTO.identifier ? false : true;

				var searchIdentifier = searchSolr.searchFullTextDTO.identifier;
				var tirId = searchSolr.searchFullTextDTO.searchInterfaceTemplateId;
				var text = _.trim(searchSolr.searchFullTextDTO.searchFullText);
				var filters = TirFilterSharedService.extractFilters(searchSolr.searchFullTextDTO.filterInstanceDTOs);

				// we check if the search is not empty
				if (searchSolr.saveHistory) {
					searchSolr.saveHistory = !_.isEmpty(text) || filters.length > 0;
				}

				// we check if the request is not the same as before
				if (searchSolr.saveHistory && searchHistory[tirId]) {
					var previousSearch = searchHistory[tirId];
					searchSolr.saveHistory = previousSearch.text !== text || !_.isEqual(previousSearch.filters, filters);

					if (!searchSolr.saveHistory) {
						searchSolr.searchFullTextDTO.identifier = previousSearch.identifier;
					}
				}

				searchHistory[tirId] = {
					text: text,
					filters: filters,
					identifier: searchIdentifier
				};
			}
			return solrResource.search(searchSolr, callback, errorCallback);
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('TirFilterSharedService', TirFilterSharedService);



	/** @ngInject */
	function TirFilterSharedService($sessionStorage, userPreferenceService, userGroupResource) {
		var service = {
			getSearchSolr: getSearchSolr,
			getSavedSearch: getSavedSearch,
			extractFilters: extractFilters,
			getSessionStorage: getSessionStorage,
			saveInSession: saveInSession,
			clearFilter: clearFilter,
			extractFiltersToString: extractFiltersToString,
			isMandatoryFiltersEmpty: isMandatoryFiltersEmpty,
			canSaveSearch: canSaveSearch,
			isTirStored: isTirStored,
			setProductFilterValues: setProductFilterValues,
			getStoredProductFilterValues: getStoredProductFilterValues,
			getPorductCodesByNameIn: getPorductCodesByNameIn
		};

		return service;

		function setProductFilterValues(tirId, productFilterValues) {
			$sessionStorage['productFilterValues-' + tirId] = productFilterValues;
		}

		function getStoredProductFilterValues(tirId) {
			var storedProductFilterValues = $sessionStorage['productFilterValues-' + tirId];
			return storedProductFilterValues ? storedProductFilterValues : [];
		}

		function getSearchSolr() {
			return this.searchSolr;
		}

		function getSavedSearch() {
			return undefined;
		}

		function getSessionStorage(tirId, productCode) {

			var code = productCode ? tirId + '-' + productCode : tirId;
			var storage = $sessionStorage['persitedtir-' + code];
			if (!storage) {
				storage = {
					filters: {},
					facets: []
				};
				$sessionStorage['persitedtir-' + code] = storage;
			}
			storage.filters.searchInterfaceTemplateId = undefined;
			return storage;
		}

		function isTirStored(tirId) {
			return angular.isDefined($sessionStorage['persitedtir-' + tirId]);
		}

		function saveInSession(data) {
			if (data) {
				var clone = _.cloneDeep(data);
				var storage = getSessionStorage(clone.searchFullTextDTO.searchInterfaceTemplateId, clone.productCode ? clone.productCode : null);
				storage.filters = clone.searchFullTextDTO;
				storage.facets = clone.listFacet;
				var tirId = clone.searchFullTextDTO.searchInterfaceTemplateId;
				var productCode = clone.productCode ? clone.productCode : null;
				var code = productCode ? tirId + '-' + productCode : tirId;
				userPreferenceService.setUserFacetPreference(code, storage);
				//Save data in searchsolr object to be used when we want to save the search
				this.searchSolr = clone;
			}
		}

		function extractFiltersToString(filters) {
			var f = extractFilters(filters);

			return _.join(_.map(f, function (v) {
				return _.join(v.filterValues, ' ; ');
			}), ' ; ');
		}

		function extractFilters(filters) {
			var result = [];

			if (filters) {
				filters.forEach(function (filterDTO) {
					var value = extractFilter(filterDTO);

					if (value) {
						value.filterDTORef = filterDTO;
						value.contains = filterDTO.contains;
						result.push(value);
					}
				}, this);
			}

			return result;
		}

		function clearFilter(filter, tirId) {
			if (filter.value !== null) {
				filter.value = "";
			}

			if (filter.multiValuesList && filter.multiValuesList.length > 0) {
				filter.multiValuesList = [];
			}
			if (filter.metaDataDTO.metaDataType === "NUMERIC") {
				filter.metaDataOperator = "EQUAL";
			}
			if (filter.metaDataDTO.metaDataType === "DATE" && (filter.dateOperator === 'CURRENTWEEK' || filter.dateOperator === 'CURRENTMONTH' || filter.dateOperator === 'CURRENTYEAR' || filter.dateOperator === 'CURRENTDATE')) {
				filter.dateOperator = "EQUAL";
			}
			filter.nullValue = false;
			filter.referentialValueDisplay = [];
			filter.contains = true;
			
			if (filter.metaDataDTO.code === 'systemOwnerGroup' || filter.metaDataDTO.code === 'systemProducts') {
				setProductFilterValues(tirId, []);
			}
		}

		function canSaveSearch() {
			var searchSolr = this.getSearchSolr();

			if (searchSolr && searchSolr.searchFullTextDTO) {
				var filters = this.extractFilters(searchSolr.searchFullTextDTO.filterInstanceDTOs);
				return (searchSolr.searchFullTextDTO.identifier
					&& (!_.isEmpty(searchSolr.searchFullTextDTO.searchFullText) || !_.isEmpty(filters)));
			}

			return false;
		}

		/**
		 * Return codes for user groups (products) with given names
		 * @param {*} productNames 
		 */
		function getPorductCodesByNameIn(productNames) {
			return userGroupResource.findCodesByNameIn({ names: productNames }).$promise;
		}

		//=================================== private methods ==========================
		//==============================================================================
		function createFilter(name, operator1, values, operator2, value2) {
			return {
				filterName: name,
				filterOperator1: operator1,
				filterValues: values,
				filterOperator2: operator2,
				filterValue2: value2,
				isDate: false,
				isBoolean: false
			};
		}

		function extractFilter(filterDTO) {
			if (filterDTO && filterDTO.visibility) {
				switch (filterDTO.metaDataDTO.metaDataType.toLowerCase()) {
					case 'boolean':
						return extractFilterBoolean(filterDTO);
					case 'date':
						return extractFilterDate(filterDTO);
					case 'numeric':
						return extractFilterNumber(filterDTO);
					default:
						return extractFilterDefault(filterDTO);
				}
			}
			return null;
		}

		function extractFilterNumber(filter) {
			var operator1 = filter.metaDataOperator;
			var result = null;

			if (filter.nullValue) {
				result = createFilter(filter.wording, null, null);
			} else if (operator1 === 'BETWEEN') {
				result = createFilter(filter.wording, operator1, [filter.multiValuesList[0].text], 'userApp.searchInterfaceTemplate.home.and', filter.multiValuesList[1].text);
			} else if (filter.multiValuesList[0]) {
				result = createFilter(filter.wording, operator1, [filter.multiValuesList[0].text]);
			} else if (filter.value) {
				result = createFilter(filter.wording, operator1, [filter.value]);
			}

			return result;
		}

		function extractFilterDate(filter) {
			var operator1 = filter.dateOperator;
			var result = null;

			if (filter.nullValue) {
				result = createFilter(filter.wording, null, null);
			} else if (operator1 === 'BETWEEN' && filter.multiValuesList[0] && filter.multiValuesList[1]) {
				result = createFilter(filter.wording, operator1, [filter.multiValuesList[0].text], 'userApp.searchInterfaceTemplate.home.and', filter.multiValuesList[1].text);
			} else if (operator1 === 'CURRENTWEEK' || operator1 === 'CURRENTMONTH' || operator1 === 'CURRENTYEAR' || operator1 === 'CURRENTDATE') {
				result = createFilter(filter.wording, operator1);
			} else if ((operator1 === 'EQUAL' || operator1 === 'BEFORE' || operator1 === 'AFTER') && filter.value) {
				result = createFilter(filter.wording, operator1, [filter.value]);
			} else if (filter.multiValuesList[0]) {
				result = createFilter(filter.wording, operator1, [filter.multiValuesList[0].text]);
			}

			if (result) {
				result.isDate = true;
			}

			return result;
		}

		function extractFilterBoolean(filter) {
			// TEMP FIX:
			filter.nullValue = false;
			var result = extractFilterDefault(filter);

			if (result) {
				if (filter.metaDataDTO.selectionFormat === 'RADIOBUTTON') {
					result.filterValues[0] = result.filterValues[0] === "true" ? filter.metaDataDTO.rightWording : filter.metaDataDTO.falseWording;
				} else {
					result.filterValues[0] = result.filterValues[0] === "true" ? 'userApp.searchInterfaceTemplate.listFilterTir.yes' : 'userApp.searchInterfaceTemplate.listFilterTir.no';
				}

				result.isBoolean = true;
			}
			return result;
		}

		function extractFilterDefault(filter) {
			var result = null;

			if (filter.nullValue) {
				result = createFilter(filter.wording, null, null);
			} else if (filter.multiValued && filter.multiValuesList.length > 0) {
				result = createFilter(filter.wording, null, _.map(filter.multiValuesList, 'text'));
			} else if (filter.value) {
				result = createFilter(filter.wording, null, [filter.value]);
			}

			return result;
		}

		//check if all mandatory filters are mentioned
		function isMandatoryFiltersEmpty(filters) {
			var ret = false;
			var i = 0;
			while (!ret && i < filters.length) {
				if (filters[i].mandatory) {
					ret = isFilterEmpty(filters[i]);
				}
				i++;
			}
			return ret;
		}

		//check if filter is valorized
		function isFilterEmpty(filter) {
			var ret = false;
			if (filter.metaDataDTO.metaDataType === "DATE") {
				ret = isFilterDateEmpty(filter);
			}
			else {
				if (filter.multiValuesList && filter.multiValuesList.length > 0) {
					if (filter.metaDataOperator === "BETWEEN") {
						ret = filter.multiValuesList.length === 2 ? isMultivaluesListEmpty(filter.multiValuesList) : true;
					}
					else if (filter.metaDataDTO.metaDataType === "NUMERIC") {
						if (areBothValuesEmpty(filter.multiValuesList)) {
							ret = true;
						}
						else if (isMultivaluesListEmpty(filter.multiValuesList)) {
							ret = !filter.value;
						}
					}
				}
				else if (!filter.value) {
					ret = true;
				}
			}
			return ret;
		}

		//check if date filter is valorized
		function isFilterDateEmpty(filter) {
			if (filter.dateOperator.indexOf('CURRENT') !== 0) {
				if (filter.multiValuesList.length === 2 && filter.multiValuesList[0].text && filter.multiValuesList[1].text) {
					return false;
				}
				else return true;
			}
			return false;
		}

		function isMultivaluesListEmpty(multiValuesList) {
			var ret = false;
			multiValuesList.forEach(function (v) {
				if (!v || !v.text || v.text === null) {
					ret = true;
				}
			});
			return ret;
		}

		function areBothValuesEmpty(multiValuesList) {
			if (multiValuesList.length !== 2) {
				return false;
			}
			var ret = true;
			multiValuesList.forEach(function (v) {
				if (v && v.text && v.text !== null) {
					ret = false;
				}
			});
			return ret;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('SearchService', SearchService);



	/** @ngInject */
	function SearchService(searchResource) {
		var service = {
			search: search,
			initSearch: initSearch
		};

		return service;

		function search(searchDTO, callback, errorCallback) {
			return searchResource.search(searchDTO, callback, errorCallback);
		}

		function initSearch(searchDTO, callback, errorCallback) {
			return searchResource.initSearch(searchDTO, callback, errorCallback);
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('searchInterfacesTemplatev2', {
				parent: 'main',
				url: '/searchInterfacesTemplatev2/:identifier/:savedSearchId?:productCode:proposalsProduct',
				views: {
					'content@mainLayout': 'searchMain'
				},
				params: {
					savedSearchId: { value: null, squash: true },
					productCode: { value: null, squash: true },
					proposalsProduct: { value: null, squash: true }
				},
				resolve: {
					searchRequest: function () { return null; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('searchInterfaceTemplate');
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('bulkoperations');
						return $translate.refresh();
					}]
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('mySavedSearch', {
			parent: 'main',
			url: '/mySavedSearch',
			views: {
				'content@mainLayout': 'listSavedSearchComponent'
			},
			resolve: {
				mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('savedSearch');
					$translatePartialLoader.addPart('datepicker');
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('editorialEntity');
					return $translate.refresh();
				}]
			}
		});
	}

})();

'use strict';

angular.module('userApp')
	.factory('SavedSearchService', function ($resource) {
		return $resource('api/savedSearch/:id', {}, {
			'get': {
				url: 'api/saveSearch/:id',
				method: 'GET',
				isArray: true
			},
			'query': { method: 'GET', isArray: false },
			'update': { method: 'PUT' },			
			'getListSavedSearchDTO': {
				url: 'api/savedSearch/listSavedSearchDTO',
				method: 'GET',
				isArray: false
			},
			'deleteSavedSearch': {
				url: 'api/savedSearch/deleteSavedSearch/:id',
				method: 'DELETE'
			},
			'shareWithMyGroups': {
				url: 'api/savedSearch/shareWithMyGroups/:id/:checked',
				method: 'GET'
			},
			'addToMenu': {
				url: 'api/savedSearch/addToMenu/:id/:checked',
				method: 'GET'
			},
			'getSavedSearch': {
				url: 'api/savedSearch/:identifier/:savedSearchId',
				method: 'GET'
			}
		});
	});

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('webImportComponent', {
			templateUrl: 'scripts/pre-upgrade/components/web-import/web-import.html',
			controller: webImportController,
			bindings: {
				allConfigs: '<',
				currentUser: '<'
			},
		});

	/** @ngInject */
	function webImportController(blockUI, webImportService, Upload, confirmModalService, $filter) {
		var ctrl = this;

		// Process web import 
		ctrl.requestWebImportProcess = function () {
			//check if import is already executed
			webImportService.getWebImportHistory(ctrl.selectedWebImportConfig).then(function (history) {
				if (history && history.importType) { //import has been executed before with the same parameters
					var importDate = $filter('ecmDate')(history.importDate);
					var importUser = history.importUserFullName;
					var confirmModalTitle = $filter('translate')("userApp.webImport.home.confirmTitle");
					var confirmModalText = $filter('translate')("userApp.webImport.home.confirmMessage", { importDate: importDate, importUser: importUser });
					confirmModalService.openModal(confirmModalText, confirmModalTitle).then(function (confirm) {
						if (confirm) {
							ctrl.processWebImport();
						}
					});
				}
				else { //import never been executed with the mentioned parameters
					ctrl.processWebImport();
				}
			});
		};

		ctrl.isFileUpload = function () {
			var params = _.get(ctrl.selectedWebImportConfig, 'webImportParameters');
			if (params && params.length > 0) {
				return _.findIndex(params, function (param) {
					return param.parameterType === "UPLOAD_FILE";
				}) >= 0;
			}
			return false;
		};

		ctrl.processWebImport = function () {
			if (ctrl.isFileUpload()) {
				var file = ctrl.getXmlFile();
				var importType = _.get(ctrl.selectedWebImportConfig, 'webImportEnum');
				ctrl.submitUploadXmlImportFile(file, importType);
			}
			else {
				blockUI.start();
				webImportService.requestWebImportProcess(ctrl.selectedWebImportConfig).then(function (data) {
					ctrl.data = data;
					blockUI.stop();
				}).catch(function (e) {
					blockUI.stop();
				});
			}
		};

		ctrl.submitUploadXmlImportFile = function (file, importType) {

			if (file) {
				if (file.type === 'text/xml') {
					blockUI.start();
					Upload.upload({
						url: 'api/webImport/requestWebImportXmlProcess',
						data: { 'multiPartXmlFile': file, 'importType': importType }
					}).success(function (data) {
						// console.log('upload success : ' + data);
						ctrl.data = data;
						blockUI.stop();
					}).error(function (data) {
						ctrl.data = data;
						blockUI.stop();
					});
				} else {
					//error
				}
			}
		};

		ctrl.getXmlFile = function () {
			var importXmlParam = _.filter(ctrl.selectedWebImportConfig.webImportParameters, function (webImportParameter) {
				return webImportParameter.parameterType === 'UPLOAD_FILE';
			});
			return importXmlParam[0].value;
		};

		// Reset web import parameter values
		ctrl.reset = function () {
			ctrl.data = null;
		};

		// INIT
		ctrl.$onInit = function () {
			ctrl.parameterList = [];
			if (ctrl.allConfigs.length === 1) {
				ctrl.selectedWebImportConfig = ctrl.allConfigs[0];
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.run(routerRun)
		.config(routerConfig);


	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider.state('web-import', {
			parent: 'main',
			url: '/webimport',
			views: {
				'content@mainLayout': 'webImportComponent'
			},
			data: {
				authorities: ['ROLE_ADMIN_SI', 'ROLE_ADMIN_HOUSE']
			},
			resolve: {
				allConfigs: function (webImportService) {
					return webImportService.getAllConfigs();
				},
				currentUser: function (userResource) {
					return userResource.getCurrentUser().$promise;
				},
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('web-import');
					return $translate.refresh();
				}]
			}
		});
	}

	/** @ngInject */
	function routerRun($transitions, webImportService, userGroupResource) {
		$transitions.onStart({}, function (transition) {
			//Reject transition if user is not affected to web import associated groups
			if (transition.$to().name === 'web-import') {
				return webImportService.getImportAssociatedProducts()
					.then(function (data) {
						return userGroupResource.groupsByUser().$promise.then(function (userGroups) {
							var intersection = _.intersection(_.map(userGroups, "code"), data);
							return intersection && intersection.length >= 1;
						});
					});
			}
		});
	}

})();

(function () {
	'use strict';

	/**
	 * Service providing utilities functions to display import execution view.
	 */
	angular
		.module('userApp')
		.factory('webImportService', webImportService);

	/** @ngInject */
	function webImportService(blockUI, webImportResource) {
		var service = {
			requestWebImportProcess: requestWebImportProcess,
			getAllConfigs: getAllConfigs,
			getImportAssociatedProducts: getImportAssociatedProducts,
			getWebImportHistory: getWebImportHistory
		};
		return service;

		//GET ALL webimport CONFIGURATIONS
		function getAllConfigs() {
			blockUI.start();
			return webImportResource.getAllConfigs().$promise
				.then(function (data) {
					blockUI.stop();
					return data;
				}).catch(function (e) {
					blockUI.stop();
				});
		}

		//GET ALL webimport associated products
		function getImportAssociatedProducts() {
			blockUI.start();
			return webImportResource.getImportAssociatedProducts().$promise
				.then(function (data) {
					blockUI.stop();
					return data;
				}).catch(function (e) {
					blockUI.stop();
				});
		}

		//REQUEST PROCESS OF Import
		function requestWebImportProcess(webImportConfig) {
			return webImportResource.requestWebimportProcess(webImportConfig).$promise;
		}

		//GET IMPORT HISTORY
		function getWebImportHistory(webImportConfig) {
			return webImportResource.getWebImportHistory(webImportConfig).$promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('user', {
				parent: 'main',
				url: "/users?page&sort",
				data: {
					authorities: ["ROLE_ADMIN_SI", "ROLE_ADMIN_HOUSE"]
				},
				params: {
					page: {
						value: '0',
						squash: true
					},
					sort: {
						value: 'lastModifiedDate',
						squash: true
					}
				},
				views: {
					'content@mainLayout': 'usersDisplayComponent'

				},
				resolve: {
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('user');
						return $translate.refresh();
					}],
					allHouses: function ($resource) {
						return $resource('api/allHouses').get().$promise;
					}
				}

			})
			.state('editUser', {
				parent: 'main',
				url: '/users/:id/edit',
				data: {
					authorities: ["ROLE_ADMIN_SI", "ROLE_ADMIN_HOUSE"]
				},
				views: {
					'content@mainLayout': 'usersEditPageComponent'
				},
				resolve: {
					user: function (userResource, $stateParams) {
						return userResource.get({
							id: $stateParams.id
						}).$promise;
					},
					roles: function ($resource) {
						return $resource('api/allRoles').query().$promise;
					},
					groups: function ($resource) {
						return $resource('api/allGroups').query().$promise;
					},
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('user');
						$translatePartialLoader.addPart('role');
						$translatePartialLoader.addPart('userGroup');
						return $translate.refresh();
					}]
				}
			}).state('newUser', {
				parent: 'user',
				url: '/new',
				data: {
					authorities: ["ROLE_ADMIN_SI", "ROLE_ADMIN_HOUSE"]
				},
				views: {
					'content@mainLayout': 'usersCreateComponent'
				},
				resolve: {
					entity: function () {
						return {
							id: null
						};
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('user');
						$translatePartialLoader.addPart('role');
						$translatePartialLoader.addPart('userGroup');
						return $translate.refresh();
					}],
					roles: function ($resource) {
						return $resource('api/allRoles').query().$promise;
					},
					groups: function ($resource) {
						return $resource('api/allGroups').query().$promise;
					},
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('xmlEditionModal', {
			templateUrl: 'scripts/pre-upgrade/components/xml-edition-modal/xml-edition-modal.html',
			controller: xmlEditionModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function xmlEditionModalController($state, blockUI, xmlEditionModalService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.xmlEditionModel = ctrl.resolve.xmlEditionModel;
		};

		ctrl.save = function () {
			blockUI.start();
			xmlEditionModalService.save(ctrl.xmlEditionModel).then(function () {
				ctrl.close();
			}).finally(function () {
				blockUI.stop();
				$state.reload();
			});
		};

		ctrl.validate = function () {
			blockUI.start();
			xmlEditionModalService.validate(ctrl.xmlEditionModel).then(function (validationReport) {
				ctrl.xmlEditionModel.validationReport = validationReport;
			}).finally(function () {
				blockUI.stop();
			});
		};

		ctrl.cancel = function () {
			ctrl.close();
		};

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('xmlEditionModalService', XmlEditionModalService);


	/** @ngInject */
	function XmlEditionModalService(blockUI, $uibModal, xmlEditionResource) {
		var service = {
			openModal: openModal,
			save: save,
			validate: validate
		};

		return service;

		function openModal(entityFlashId, eetCode) {
			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'xmlEditionModal',
				resolve: {
					xmlEditionModel: function () {
						return xmlEditionResource.getXml({ entityFlashId: entityFlashId, eetCode: eetCode }).$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('xmlEdition');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}

		function save(xmlEditionModel) {
			return xmlEditionResource.saveXml(xmlEditionModel).$promise;
		}

		function validate(xmlEditionModel) {
			return xmlEditionResource.validateXml(xmlEditionModel).$promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('parameter', {
			templateUrl: 'scripts/pre-upgrade/components/batch/parameter/parameter.html',
			controller: parameterController,
			bindings: {
				batchParameter: '<'
			},
		});

	/** @ngInject */
	function parameterController() {
		var ctrl = this;

		// INIT
		ctrl.$onInit = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('confirmModal', {
			templateUrl: 'scripts/pre-upgrade/components/commons/confirm-modal/confirm-modal.html',
			controller: ConfirmModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ConfirmModalController($sce) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.confirmButtonText = ctrl.resolve.button.confirmButtonText;
			ctrl.cancelButtontext = ctrl.resolve.button.cancelButtontext;
		};

		ctrl.confirm = function () {
			ctrl.close({ $value: true });
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

		ctrl.trust = function (val) {
			return $sce.trustAsHtml(val);
		};
	}
})();

(function () {
	'use strict';


	/**
	 * Common service used to show a confirm pop up with the appropriate messages.
	 */

	angular
		.module('userApp')
		.factory('confirmModalService', ConfirmModalService);



	/** @ngInject */
	function ConfirmModalService($uibModal, blockUI, $sanitize, $sce, $filter) {
		var service = {
			openModal: openModal,
			openMessageModal: openMessageModal,
			openConfirmValidation: openConfirmValidation
		};

		return service;

		function openMessageModal(text, params) {
			return openModal(text, undefined, params);
		}

		function openModal(text, title, params, confirmButtonText, cancelButtontext) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'confirmModal',
				resolve: {
					message: {
						text: text,
						title: title ? title : 'global.menu.modalLogout.title',
						params: params ? params : {}
					},
					button: {
						confirmButtonText: _.isEmpty(confirmButtonText) ? "global.menu.modalLogout.deconnect" : confirmButtonText,
						cancelButtontext: _.isEmpty(cancelButtontext) ? "global.menu.modalLogout.cancel" : cancelButtontext
					}

				},
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}


		function openConfirmValidation(text, title, includeLinksButtonText, onlyEeButtonText) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'confirmModalValidation',
				resolve: {
					message: {
						text: text,
						title: title
					},
					button: {
						includeLinksButtonText: includeLinksButtonText,
						onlyEeButtonText: onlyEeButtonText,
						cancelButtontext: "global.menu.modalLogout.cancel"
					}

				},
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance.result;
		}

	}

})();

(function () {
	'use strict';


	/**
	 * Display a html preview at right side which it could be closed
	 *
	 * 
	 * Example :
	 * 
	 * JS : 
	 * ctrl.preview = {
	 *				opened: true,
	 *        flashId: '',
	 *				entityType: ''
	 *			},
	 * mode: 'full'
	 * 
	 * HTML :
	 * <closeable-html-preview preview="$ctrl.preview"/>
	 */

	angular
		.module('userApp')
		.component('closeableHtmlPreview', {
			templateUrl: 'scripts/pre-upgrade/components/commons/closeable-html-preview/closeable-html-preview.html',
			controller: CloseableHtmlPreviewController,
			bindings: {
				preview: '<',
				mode: '@?',
				onRefreshPage: '&?',
				onClose: '&?',
				productCode: '<?',
				fromTrush: '<'
			},
		});

	/** @ngInject */
	function CloseableHtmlPreviewController($sce, $log, blockUI, editMetaDataModalService, htmlPreviewService, HTML_PREVIEW_TYPE, $state, authorizeConstants, entityAuthorizeService) {
		var ctrl = this;

		ctrl.editorialEntity = {};
		ctrl.currentFlashId;

		ctrl.$onInit = function () {
			if (!ctrl.mode) {
				ctrl.mode = 'light';
			}
		};

		ctrl.loadEditorialEntity = function () {
			htmlPreviewService.getPreview(ctrl.currentFlashId, HTML_PREVIEW_TYPE.complete, ctrl.fromTrush, ctrl.preview.entityType, ctrl.productCode)
				.then(function (eePreviewHtml) {
					ctrl.editorialEntity.html = eePreviewHtml.htmlPreview;
					ctrl.editorialEntity.type = eePreviewHtml.type;
				});
		};

		ctrl.$onChanges = function () {
			if (ctrl.preview) {
				if (ctrl.currentFlashId !== ctrl.preview.flashId) {
					ctrl.currentFlashId = ctrl.preview.flashId;
					ctrl.loadEditorialEntity();
					return entityAuthorizeService.authorizeById(ctrl.currentFlashId, authorizeConstants.editMetadata)
						.then(function (authorized) {
							return ctrl.isEditMetadata = authorized;
						});
				}
			}
		};

		ctrl.close = function () {
			if (ctrl.preview) {
				ctrl.preview.opened = false;
			}

			if (ctrl.onClose) {
				ctrl.onClose();
			}
		};

		ctrl.trustAsHtml = function (html) {
			return (angular.isDefined(html) && html !== '') ? $sce.trustAsHtml(html) : '';
		};



		ctrl.updatePreview = function (flashId, typePreview, productCode) {
			var previewUI = blockUI.instances.get('previewUI');
			previewUI.start();
			htmlPreviewService.reloadEntityPreview(flashId, typePreview, productCode)
				.then(function (result) {
					if (result) {
						ctrl.newHtmlPreview = result;
						if (ctrl.editorialEntity) {
							ctrl.editorialEntity.html = "";
							ctrl.editorialEntity.html = ctrl.newHtmlPreview.htmlPreview;
							previewUI.stop();
						}
					}
				});
		};

		ctrl.openEditMetaModal = function (flashId) {
			editMetaDataModalService.openEditEntityMetaModal(flashId).then(function (selectedItem) {
				ctrl.updatePreview(flashId, 'COMPLETE');
				ctrl.refreshPage();
			});
		};

		ctrl.startEdition = function (flashId) {
			if (ctrl.editorialEntity.type === 'TREE') {
				$state.go("treeEEEdition", { id: flashId, editionMode: 'STRUCTURE' });
			}
			else {
				$state.go("editorialEntityEdit", { id: flashId });
			}
		};

		ctrl.refreshPage = function () {
			if (ctrl.onRefreshPage) {
				ctrl.onRefreshPage();
			}
		};

		ctrl.closePreview = function () {
			ctrl.preview.opened = false;
		};

	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('ecmPageSelector', {
			templateUrl: 'scripts/pre-upgrade/components/commons/ecm-pagination/ecm-page-selector.html',
			controller: EcmPaginationController,
			bindings: {
				onChange: '&?',
				paginationSizes: '<',
				label: '@',
				storageKey: '@?'
			},
		});

	/** @ngInject */
	function EcmPaginationController(EcmPaginationConfig, userPreferenceService, USER_PREFERENCE) {
		var ctrl = this;

		////////////////

		ctrl.selectedSizeChanged = function () {
			if (angular.isDefined(ctrl.onChange)) {
				ctrl.onChange({ size: ctrl.selectedSize });
			}
			if (ctrl.storageKey) {
				userPreferenceService.setUserPaginationPreference(ctrl.storageKey, ctrl.selectedSize);
			}
		};

		ctrl.$onInit = function () {
			if (!ctrl.paginationSizes) {
				ctrl.paginationSizes = _.clone(EcmPaginationConfig.lightPaginationSizes);
			}

			if (ctrl.storageKey) {
				var val = userPreferenceService.getUserPaginationPreference(ctrl.storageKey, 5);
				if (val) {
					var idx = _.findIndex(ctrl.paginationSizes, function (o) {
						return o === val;
					});
					if (idx > -1) {
						ctrl.selectedSize = val;
					}
				}
			}
		};
		ctrl.$onChanges = function (changesObj) {
		};
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('EcmPaginationConfig', {
			"paginationSizes": [20, 50, 100, 200],
			"lightPaginationSizes": [5, 10, 20]
		});
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('ecmPagination', {
			templateUrl: 'scripts/pre-upgrade/components/commons/ecm-pagination/ecm-pagination.html',
			controller: EcmPaginationController,
			bindings: {
				onChange: '&?',
				showPageSizeSelector: '<?',
				paginationSizes: '<',
				paginationModel: '=',
				totalItems: '<',
				storageKey: '@?'
			},
		});

	/** @ngInject */
	function EcmPaginationController(EcmPaginationConfig, userPreferenceService, USER_PREFERENCE) {
		var ctrl = this;

		////////////////

		function initPaginationModel() {
			if (angular.isUndefined(ctrl.paginationModel)) {
				ctrl.paginationModel = {
					itemByPage: 50,
					totalCount: 0,
					currentPage: 1
				};
			}
		}

		ctrl.onPageSizesChange = function () {
			if (angular.isDefined(ctrl.onChange)) {
				ctrl.paginationModel.currentPage = 1;
				ctrl.onChange(ctrl.paginationModel);
			}
			if (ctrl.storageKey) {
				userPreferenceService.setUserPaginationPreference(ctrl.storageKey, ctrl.paginationModel.itemByPage);
			}
		};

		ctrl.$onInit = function () {
			if (!ctrl.paginationSizes) {
				ctrl.paginationSizes = _.clone(EcmPaginationConfig.paginationSizes);
			}

			if (angular.isUndefined(ctrl.showPageSizeSelector)) {
				ctrl.showPageSizeSelector = true;
			}

			initPaginationModel();

			if (ctrl.totalItems) {
				ctrl.paginationModel.totalItems = ctrl.totalItems;
			}

			if (ctrl.storageKey) {
				var val = userPreferenceService.getUserPaginationPreference(ctrl.storageKey);
				if (val) {
					var idx = _.findIndex(ctrl.paginationSizes, function (o) {
						return o === val;
					});
					if (idx > -1) {
						ctrl.paginationModel.itemByPage = val;
					}
				}
			}
		};
		ctrl.$onChanges = function (changesObj) {

			initPaginationModel();

			if (changesObj.totalItems) {
				ctrl.paginationModel.totalCount = changesObj.totalItems.currentValue;
			}
		};
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	// Usage:
	// @basic
	// <ecm-datepicker ng-model="model" ng-change="functiontocallwhenuserchangedate"></ecm-datepicker>
	// 
	// @range
	// <ecm-datepicker ng-model="model" model-type="'RANGE'"></ecm-datepicker>
	// When model-type is RANGE the component bind an object with startDate and endDate -> {starDate, endDate}
	//
	// @full
	// <ecm-datepicker ng-disabled="boolean" operators="dateOperatorOptions" showOperator="true" ng-model="model" model-type="'RANGE" ng-change="function">

	angular
		.module('userApp')
		.constant('ecmDatePickerConfig', { forceUTC: false })
		.component('ecmDatepicker', {
			templateUrl: 'scripts/pre-upgrade/components/commons/ecm-datepicker/ecm-datepicker.html',
			controller: EcmDatepickerController,
			require: {
				ngModelCtrl: '?ngModel'
			},
			bindings: {
				operators: '<?',
				selectedOperator: '=?',
				modelType: '<?',
				showOperator: '<?',
				ngDisabled: '<?',
				name: '@?',
				onStartDateChange: '&?',
				onEndDateChange: '&?',
				endDateLabel: '<?',
				startDateRequired: '<?',
				endDateRequired: '<?',
				endDateDiscriminant: '<?'
			},
		});

	/** @ngInject */
	function EcmDatepickerController(ecmDatePickerConfig) {
		var ctrl = this;

		var betweenOperator = 'BETWEEN';

		ctrl.startDateOpen = false;
		ctrl.endDateOpen = false;
		ctrl.dateOptionsStart = {
			formatYear: 'yy',
			startingDay: 1,
			appendToBody: true
		};
		ctrl.dateOptionsEnd = {
			formatYear: 'yy',
			startingDay: 1,
			appendToBody: true
		};
		////////////////

		ctrl.showOnlyOperator = function () {
			return ctrl.selectedOperator === 'CURRENTWEEK' || ctrl.selectedOperator === 'CURRENTMONTH' ||
				ctrl.selectedOperator === 'CURRENTYEAR' || ctrl.selectedOperator === 'CURRENTDATE';
		};

		ctrl.showStartInput = function () {
			return !ctrl.showOnlyOperator() && ctrl.selectedOperator !== betweenOperator;
		};

		ctrl.checkDateRange = function () {
			if (ctrl.startDate && ctrl.endDate) {
				if (moment(ctrl.startDate).isAfter(ctrl.endDate)) {
					ctrl.endDate = ctrl.startDate;
				}
			}
		};

		ctrl.operatorChanged = function (previousOperator, newOperator) {

			if (newOperator === 'CURRENTWEEK' || newOperator === 'CURRENTMONTH' ||
				newOperator === 'CURRENTYEAR' || newOperator === 'CURRENTDATE') {
				ctrl.startDate = undefined;
				ctrl.endDate = undefined;

			}
			if (newOperator !== betweenOperator) {
				ctrl.dateOptionsStart.maxDate = null;
				if (ctrl.startDate) {
					ctrl.endDate = ctrl.startDate;
				}
			}
			ctrl.selectedOperator = newOperator;
			ctrl.updateValue();
		};

		ctrl.startChanged = function () {
			if (ctrl.modelType === 'RANGE') {
				ctrl.dateOptionsEnd.minDate = ctrl.startDate;
				if (ctrl.selectedOperator !== betweenOperator) {
					ctrl.endDate = ctrl.startDate;
				}
			}
			ctrl.checkDateRange();
			ctrl.updateValue();
			if (ctrl.onStartDateChange) {
				ctrl.onStartDateChange();
			}
		};

		ctrl.endChanged = function () {
			ctrl.dateOptionsStart.maxDate = ctrl.endDate;
			ctrl.checkDateRange();
			ctrl.updateValue();
			if (ctrl.onEndDateChange) {
				ctrl.onEndDateChange();
			}
		};

		ctrl.updateValue = function () {
			if (ctrl.ngModelCtrl) {
				if (ctrl.modelType === 'RANGE') {
					ctrl.ngModelCtrl.$setViewValue({ startDate: ctrl.getValidDate(ctrl.startDate), endDate: ctrl.getValidEndDate(ctrl.endDate) });
				}
				else {
					ctrl.ngModelCtrl.$setViewValue(ctrl.getValidDate(ctrl.startDate));
				}
			}
		};

		ctrl.getValidEndDate = function (date) {
			if (date) {
				var test = moment(date);
				if (test.isValid()) {
					return test.endOf('day').toDate();
				}
			}
		};

		ctrl.getValidDate = function (date) {
			if (date) {
				var test = moment(date);
				if (test.isValid()) {
					var cleanedMomentDate = ecmDatePickerConfig.forceUTC && !ctrl.showOperator ? moment.utc(test.format('DD/MM/YYYY'), 'DD/MM/YYYY') : test;
					return cleanedMomentDate.toDate();
				}
			}
		};
		ctrl.setInternalDate = function () {
			if (ctrl.ngModelCtrl.$viewValue) {
				if (ctrl.modelType === 'RANGE') {
					ctrl.startDate = ctrl.getValidDate(ctrl.ngModelCtrl.$viewValue.startDate);
					ctrl.endDate = ctrl.getValidDate(ctrl.ngModelCtrl.$viewValue.endDate);
					ctrl.dateOptionsEnd.minDate = ctrl.startDate;
				}
				else {
					ctrl.startDate = ctrl.getValidDate(ctrl.ngModelCtrl.$viewValue);
				}
			}
		};

		ctrl.$onInit = function () {
			ctrl.dateRangeSeparator = ctrl.endDateLabel ? ctrl.endDateLabel : '-';
			ctrl.selectedOperator = ctrl.endDateLabel ? betweenOperator : ctrl.selectedOperator;

			if (angular.isUndefined(ctrl.showOperator)) {
				ctrl.showOperator = false;
			}

			if (!ctrl.modelType) {
				ctrl.modelType = 'SINGLE';
			}

			if (ctrl.ngModelCtrl) {
				ctrl.ngModelCtrl.$render = function () {
					ctrl.setInternalDate();
					ctrl.updateValue();
				};
			}

			if (!ctrl.selectedOperator) {
				ctrl.selectedOperator = 'EQUAL';
			}
			if (!ctrl.operators && !ctrl.endDateLabel) {
				ctrl.operators = [{ name: 'EQUAL', value: 'EQUAL' }];
				ctrl.selectedOperator = 'EQUAL';
			}
		};
		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };


	}


})();

/**
               _ _____           _          _     _      
              | |  __ \         (_)        | |   | |     
      ___ ___ | | |__) |___  ___ _ ______ _| |__ | | ___ 
     / __/ _ \| |  _  // _ \/ __| |_  / _` | '_ \| |/ _ \
    | (_| (_) | | | \ \  __/\__ \ |/ / (_| | |_) | |  __/
     \___\___/|_|_|  \_\___||___/_/___\__,_|_.__/|_|\___|
	 
	v1.7 - jQuery plugin created by Alvaro Prieto Lauroba
	
	Licences: MIT & GPL
	Feel free to use or modify this plugin as far as my full name is kept	
*/

(function ($) {

	// for eslint
	var jq = $;
	var d = jq(document); //window object
	var h = jq("head"); //head object
	var drag = null; //reference to the current grip that is being dragged
	var tables = {}; //object of the already processed tables (table.id as key)
	var count = 0; //internal count to create unique IDs when needed.	

	//common strings for packing
	var ID = "id";
	var PX = "px";
	var SIGNATURE = "JColResizer";
	var FLEX = "JCLRFlex";

	//short-cuts
	var I = parseInt;
	var M = Math;
	var ie = navigator.userAgent.indexOf('Trident/4.0') > 0;
	var S;

	//try { S = sessionStorage; } catch (e)	//Firefox crashes when executed as local file system

	//append required CSS rules  
	h.append("<style type='text/css'>  .JColResizer{table-layout:fixed;} .JColResizer > tbody > tr > td, .JColResizer > tbody > tr > th{overflow:hidden}  .JPadding > tbody > tr > td, .JPadding > tbody > tr > th{padding-left:0!important; padding-right:0!important;} .JCLRgrips{ height:0px; position:relative;} .JCLRgrip{margin-left:-5px; position:absolute; z-index:5; } .JCLRgrip .JColResizer{position:absolute;background-color:red;filter:alpha(opacity=1);opacity:0;width:10px;height:100%;cursor: col-resize;top:0px} .JCLRLastGrip{position:absolute; width:1px; } .JCLRgripDrag{ border-left:1px dotted black;	} .JCLRFlex{} .JCLRgrip.JCLRdisabledGrip .JColResizer{cursor:default; display:none;}</style>");

	/**
	 * This function allows to remove any enhancements performed by this plugin on a previously processed table.
	 * @param {jQuery ref} t - table object
	 */
	var destroy = function (t) {
		var id = t.attr(ID);
		t = tables[id]; //its table object is found
		if (!t || !t.is("table")) return; //if none, then it wasn't processed	 
		t.removeClass(SIGNATURE + " " + FLEX).gc.remove(); //class and grips are removed
		delete tables[id]; //clean up data
	};

	/**
	 * Function to allow the persistence of columns dimensions after a browser postback. It is based in
	 * the HTML5 sessionStorage object, which can be emulated for older browsers using sessionstorage.js
	 * @param {jQuery ref} t - table object
	 * @param {jQuery ref} th - reference to the first row elements (only set in deserialization)
	 */
	var memento = function (t, th) {
		var w, m = 0,
			i = 0,
			aux = [],
			tw;
		if (th) { //in deserialization mode (after a postback)
			t.cg.removeAttr("width");
			if (t.opt.flush) {
				S[t.id] = "";
				return;
			} //if flush is activated, stored data is removed
			w = S[t.id].split(";"); //column widths is obtained
			tw = w[t.ln + 1];
			if (!t.f && tw) { //if not fixed and table width data available its size is restored
				t.width(tw *= 1);
				if (t.opt.overflow) { //if overfolw flag is set, restore table width also as table min-width
					t.css('min-width', tw + PX);
					t.w = tw;
				}
			}
			for (; i < t.ln; i++) { //for each column
				aux.push(100 * w[i] / w[t.ln] + "%"); //width is stored in an array since it will be required again a couple of lines ahead
				th.eq(i).css("width", aux[i]); //each column width in % is restored
			}
			for (i = 0; i < t.ln; i++)
				t.cg.eq(i).css("width", aux[i]); //this code is required in order to create an inline CSS rule with higher precedence than an existing CSS class in the "col" elements
		} else { //in serialization mode (after resizing a column)
			S[t.id] = ""; //clean up previous data
			for (; i < t.c.length; i++) { //iterate through columns
				w = t.c[i].width(); //width is obtained
				S[t.id] += w + ";"; //width is appended to the sessionStorage object using ID as key
				m += w; //carriage is updated to obtain the full size used by columns
			}
			S[t.id] += m; //the last item of the serialized string is the table's active area (width), 
			//to be able to obtain % width value of each columns while deserializing
			if (!t.f) S[t.id] += ";" + t.width(); //if not fixed, table width is stored
		}
	};

	/**
	 * Function that places each grip in the correct position according to the current table layout	 
	 * @param {jQuery ref} t - table object
	 */
	var syncGrips = function (t) {
		t.gc.width(t.w); //the grip's container width is updated				
		for (var i = 0; i < t.ln; i++) { //for each column
			var c = t.c[i];
			t.g[i].css({ //height and position of the grip is updated according to the table layout
				left: c.offset().left - t.offset().left + c.outerWidth(false) + t.cs / 2 + PX,
				height: t.opt.headerOnly ? t.c[0].outerHeight(false) : t.outerHeight(false)
			});
		}
	};

	/**
	 * This function updates column's width according to the horizontal position increment of the grip being
	 * dragged. The function can be called while dragging if liveDragging is enabled and also from the onGripDragOver
	 * event handler to synchronize grip's position with their related columns.
	 * @param {jQuery ref} t - table object
	 * @param {number} i - index of the grip being dragged
	 * @param {bool} isOver - to identify when the function is being called from the onGripDragOver event	
	 */
	var syncCols = function (t, i, isOver) {
		var inc = drag.x - drag.l,
			c = t.c[i],
			c2 = t.c[i + 1];
		var w = c.w + inc;
		var w2 = c2.w - inc; //their new width is obtained					
		c.width(w + PX);
		t.cg.eq(i).width(w + PX);
		if (t.f) { //if fixed mode
			c2.width(w2 + PX);
			t.cg.eq(i + 1).width(w2 + PX);
		} else if (t.opt.overflow) { //if overflow is set, incriment min-width to force overflow
			t.css('min-width', t.w + inc);
			t.width(t.w + inc);
		}
		if (isOver) {
			c.w = w;
			c2.w = t.f ? w2 : c2.w;
		}
	};

	/**
	 * This function updates all columns width according to its real width. It must be taken into account that the 
	 * sum of all columns can exceed the table width in some cases (if fixed is set to false and table has some kind 
	 * of max-width).
	 * @param {jQuery ref} t - table object	
	 */
	var applyBounds = function (t) {
		var w = $.map(t.c, function (c) { //obtain real widths
			return c.width();
		});
		t.width(t.w = t.width()).removeClass(FLEX); //prevent table width changes
		$.each(t.c, function (i, c) {
			c.width(w[i]).w = w[i]; //set column widths applying bounds (table's max-width)
		});
		t.addClass(FLEX); //allow table width changes
	};

	/**
	 * Event handler used while dragging a grip. It checks if the next grip's position is valid and updates it. 
	 * @param {event} e - mousemove event binded to the window object
	 */
	var onGripDrag = function (e) {
		if (!drag) return;
		var t = drag.t; //table object reference 
		var oe = e.originalEvent.touches;
		var ox = oe ? oe[0].pageX : e.pageX; //original position (touch or mouse)
		var x = ox - drag.ox + drag.l; //next position according to horizontal mouse position increment
		var mw = t.opt.minWidth,
			i = drag.i; //cell's min width
		var l = t.cs * 1.5 + mw + t.b;
		var last = i === t.ln - 1; //check if it is the last column's grip (usually hidden)
		var min = i ? t.g[i - 1].position().left + t.cs + mw : l; //min position according to the contiguous cells
		var max = t.f ? //fixed mode?
			i === t.ln - 1 ?
			t.w - l :
			t.g[i + 1].position().left - t.cs - mw :
			Infinity; //max position according to the contiguous cells 
		x = M.max(min, M.min(max, x)); //apply bounding		
		drag.x = x;
		drag.css("left", x + PX); //apply position increment	
		if (last) { //if it is the last grip
			var c = t.c[drag.i]; //width of the last column is obtained
			drag.w = c.w + x - drag.l;
		}
		if (t.opt.liveDrag) { //if liveDrag is enabled
			if (last) {
				c.width(drag.w);
				if (!t.f && t.opt.overflow) { //if overflow is set, incriment min-width to force overflow
					t.css('min-width', t.w + x - drag.l);
				} else {
					t.w = t.width();
				}
			} else {
				syncCols(t, i); //columns are synchronized
			}
			syncGrips(t);
			var cb = t.opt.onDrag; //check if there is an onDrag callback
			if (cb) {
				e.currentTarget = t[0];
				cb(e);
			} //if any, it is fired			
		}
		return false; //prevent text selection while dragging				
	};


	/**
	 * Event handler fired when the dragging is over, updating table layout
	 * @param {event} e - grip's drag over event
	 */
	var onGripDragOver = function (e) {

		d.unbind('touchend.' + SIGNATURE + ' mouseup.' + SIGNATURE).unbind('touchmove.' + SIGNATURE + ' mousemove.' + SIGNATURE);
		jq("head :last-child").remove(); //remove the dragging cursor style	
		if (!drag) return;
		drag.removeClass(drag.t.opt.draggingClass); //remove the grip's dragging css-class
		if (!(drag.x - drag.l === 0)) {
			var t = drag.t;
			var cb = t.opt.onResize; //get some values	
			var i = drag.i; //column index
			var last = i === t.ln - 1; //check if it is the last column's grip (usually hidden)
			var c = t.g[i].c; //the column being dragged
			if (last) {
				c.width(drag.w);
				c.w = drag.w;
			} else {
				syncCols(t, i, true); //the columns are updated
			}
			if (!t.f) applyBounds(t); //if not fixed mode, then apply bounds to obtain real width values
			syncGrips(t); //the grips are updated
			if (cb) {
				e.currentTarget = t[0];
				cb(e.currentTarget);
			} //if there is a callback function, it is fired
			if (t.p && S) memento(t); //if postbackSafe is enabled and there is sessionStorage support, the new layout is serialized and stored
		}
		drag = null; //since the grip's dragging is over									
	};


	/**
	 * Event handler fired when the grip's dragging is about to start. Its main goal is to set up events 
	 * and store some values used while dragging.
	 * @param {event} e - grip's mousedown event
	 */
	var onGripMouseDown = function (e) {
		var o = jq(this).data(SIGNATURE); //retrieve grip's data
		var t = tables[o.t],
			g = t.g[o.i]; //shortcuts for the table and grip objects
		var oe = e.originalEvent.touches; //touch or mouse event?
		g.ox = oe ? oe[0].pageX : e.pageX; //the initial position is kept
		g.l = g.position().left;
		g.x = g.l;

		d.bind('touchmove.' + SIGNATURE + ' mousemove.' + SIGNATURE, onGripDrag).bind('touchend.' + SIGNATURE + ' mouseup.' + SIGNATURE, onGripDragOver); //mousemove and mouseup events are bound
		h.append("<style type='text/css'>*{cursor:" + t.opt.dragCursor + "!important}</style>"); //change the mouse cursor
		g.addClass(t.opt.draggingClass); //add the dragging class (to allow some visual feedback)				
		drag = g; //the current grip is stored as the current dragging object
		if (t.c[o.i].l)
			for (var i = 0, c; i < t.ln; i++) {
				c = t.c[i];
				c.l = false;
				c.w = c.width();
			} //if the colum is locked (after browser resize), then c.w must be updated		
		return false; //prevent text selection
	};

	/**
	 * Function to create all the grips associated with the table given by parameters 
	 * @param {jQuery ref} t - table object
	 */
	var createGrips = function (t) {

		var th = t.find(">thead>tr:first>th,>thead>tr:first>td"); //table headers are obtained
		if (!th.length) th = t.find(">tbody>tr:first>th,>tr:first>th,>tbody>tr:first>td, >tr:first>td"); //but headers can also be included in different ways
		th = th.filter(":visible"); //filter invisible columns
		t.cg = t.find("col"); //a table can also contain a colgroup with col elements		
		t.ln = th.length; //table length is stored	
		if (t.p && S && S[t.id]) memento(t, th); //if 'postbackSafe' is enabled and there is data for the current table, its coloumn layout is restored
		th.each(function (i) { //iterate through the table column headers			
			var c = jq(this); //jquery wrap for the current column		
			//var dc = t.dc.indexOf(this.id) != -1;           //is this a disabled column?
			var dc = this.hasAttribute('no-resize');
			var g = jq(t.gc.append('<div class="JCLRgrip"></div>')[0].lastChild); //add the visual node to be used as grip
			g.append(dc ? "" : t.opt.gripInnerHtml).append('<div class="' + SIGNATURE + '"></div>');
			if (i === t.ln - 1) { //if the current grip is the las one 
				g.addClass("JCLRLastGrip"); //add a different css class to stlye it in a different way if needed
				if (t.f) g.html(""); //if the table resizing mode is set to fixed, the last grip is removed since table with can not change
			}
			g.bind('touchstart mousedown', onGripMouseDown); //bind the mousedown event to start dragging 

			if (!dc) {
				//if normal column bind the mousedown event to start dragging, if disabled then apply its css class
				g.removeClass('JCLRdisabledGrip').bind('touchstart mousedown', onGripMouseDown);
			} else {
				g.addClass('JCLRdisabledGrip');
			}

			g.t = t;
			g.i = i;
			g.c = c;
			c.w = c.width(); //some values are stored in the grip's node data as shortcut
			t.g.push(g);
			t.c.push(c); //the current grip and column are added to its table object
			c.width(c.w).removeAttr("width"); //the width of the column is converted into pixel-based measurements
			g.data(SIGNATURE, {
				i: i,
				t: t.attr(ID),
				last: i === t.ln - 1
			}); //grip index and its table name are stored in the HTML 												
		});
		t.cg.removeAttr("width"); //remove the width attribute from elements in the colgroup 

		t.find('td, th').not(th).not('table th, table td').each(function () {
			jq(this).removeAttr('width'); //the width attribute is removed from all table cells which are not nested in other tables and dont belong to the header
		});
		if (!t.f) {
			t.removeAttr('width').addClass(FLEX); //if not fixed, let the table grow as needed
		}
		syncGrips(t); //the grips are positioned according to the current table layout			
		//there is a small problem, some cells in the table could contain dimension values interfering with the 
		//width value set by this plugin. Those values are removed

	};

	/**
	 * Function to allow column resizing for table objects. It is the starting point to apply the plugin.
	 * @param {DOM node} tb - reference to the DOM table object to be enhanced
	 * @param {Object} options	- some customization values
	 */
	var init = function (tb, options) {
		var t = jq(tb); //the table object is wrapped
		t.opt = options; //each table has its own options available at anytime
		t.mode = options.resizeMode; //shortcuts
		t.dc = t.opt.disabledColumns;
		if (t.opt.removePadding) t.addClass("JPadding");
		if (t.opt.disable) return destroy(t); //the user is asking to destroy a previously colResized table
		var id = t.id = t.attr(ID) || SIGNATURE + count++; //its id is obtained, if null new one is generated		
		t.p = t.opt.postbackSafe; //short-cut to detect postback safe 		
		if (!t.is("table") || tables[id] && !t.opt.partialRefresh) return; //if the object is not a table or if it was already processed then it is ignored.
		if (t.opt.hoverCursor !== 'col-resize') h.append("<style type='text/css'>.JCLRgrip .JColResizer:hover{cursor:" + t.opt.hoverCursor + "!important}</style>"); //if hoverCursor has been set, append the style
		t.addClass(SIGNATURE).attr(ID, id).before('<div class="JCLRgrips"/>'); //the grips container object is added. Signature class forces table rendering in fixed-layout mode to prevent column's min-width
		t.g = [];
		t.c = [];
		t.w = t.width();
		t.gc = t.prev();
		t.f = t.opt.fixed; //t.c and t.g are arrays of columns and grips respectively				
		if (options.marginLeft) t.gc.css("marginLeft", options.marginLeft); //if the table contains margins, it must be specified
		if (options.marginRight) t.gc.css("marginRight", options.marginRight); //since there is no (direct) way to obtain margin values in its original units (%, em, ...)
		t.cs = I(ie ? tb.cellSpacing || tb.currentStyle.borderSpacing : t.css('border-spacing')) || 2; //table cellspacing (not even jQuery is fully cross-browser)
		t.b = I(ie ? tb.border || tb.currentStyle.borderLeftWidth : t.css('border-left-width')) || 1; //outer border width (again cross-browser issues)
		// if(!(tb.style.width || tb.width)) t.width(t.width()); //I am not an IE fan at all, but it is a pity that only IE has the currentStyle attribute working as expected. For this reason I can not check easily if the table has an explicit width or if it is rendered as "auto"
		tables[id] = t; //the table object is stored using its id as key	
		createGrips(t); //grips are created 

	};

	/**
	 * Event handler fired when the browser is resized. The main purpose of this function is to update
	 * table layout according to the browser's size synchronizing related grips 
	 */
	var onResize = function () {
		for (var t in tables) {
			if (tables.hasOwnProperty(t)) {
				t = tables[t];
				var i, mw = 0;
				t.removeClass(SIGNATURE); //firefox doesn't like layout-fixed in some cases
				if (t.f) { //in fixed mode
					t.w = t.width(); //its new width is kept
					for (i = 0; i < t.ln; i++) mw += t.c[i].w;
					//cell rendering is not as trivial as it might seem, and it is slightly different for
					//each browser. In the beginning i had a big switch for each browser, but since the code
					//was extremely ugly now I use a different approach with several re-flows. This works 
					//pretty well but it's a bit slower. For now, lets keep things simple...   
					for (i = 0; i < t.ln; i++) {
						if (!t.c[i][0].hasAttribute('no-resize')) {
							t.c[i].css("width", M.round(1000 * t.c[i].w / mw) / 10 + "%").l = true;
						}
						//var cw = t.c[i].width();
						// if (cw < t.opt.minWidth) {
						// 	t.c[i].outerWidth(t.opt.minWidth);
						// 	t.c[i].w = t.c[i].width();
						// }
					}
					//c.l locks the column, telling us that its c.w is outdated									
				} else { //in non fixed-sized tables
					applyBounds(t); //apply the new bounds 
					if (t.mode === 'flex' && t.p && S) { //if postbackSafe is enabled and there is sessionStorage support,
						memento(t); //the new layout is serialized and stored for 'flex' tables
					}
				}
				syncGrips(t.addClass(SIGNATURE));
			}
		}

	};

	//bind resize event, to update grips position 
	jq(window).bind('resize.' + SIGNATURE, onResize);

	/**
	 * The plugin is added to the jQuery library
	 * @param {Object} options -  an object that holds some basic customization values 
	 */
	$.fn.extend({
		colResizable: function (options) {
			var defaults = {

				//attributes:

				resizeMode: 'fit', //mode can be 'fit', 'flex' or 'overflow'
				draggingClass: 'JCLRgripDrag', //css-class used when a grip is being dragged (for visual feedback purposes)
				gripInnerHtml: '', //if it is required to use a custom grip it can be done using some custom HTML				
				liveDrag: true, //enables table-layout updating while dragging	
				minWidth: 26, //minimum width value in pixels allowed for a column 
				headerOnly: false, //specifies that the size of the the column resizing anchors will be bounded to the size of the first row 
				hoverCursor: "col-resize", //cursor to be used on grip hover
				dragCursor: "col-resize", //cursor to be used while dragging
				postbackSafe: false, //when it is enabled, table layout can persist after postback or page refresh. It requires browsers with sessionStorage support (it can be emulated with sessionStorage.js). 
				flush: false, //when postbakSafe is enabled, and it is required to prevent layout restoration after postback, 'flush' will remove its associated layout data 
				marginLeft: null, //in case the table contains any margins, colResizable needs to know the values used, e.g. "10%", "15em", "5px" ...
				marginRight: null, //in case the table contains any margins, colResizable needs to know the values used, e.g. "10%", "15em", "5px" ...
				disable: false, //disables all the enhancements performed in a previously colResized table	
				partialRefresh: true, //can be used in combination with postbackSafe when the table is inside of an updatePanel,
				disabledColumns: [], //column indexes to be excluded
				removePadding: false, //for some uses (such as multiple range slider), it is advised to set this modifier to true, it will remove padding from the header cells.

				//events:
				onDrag: null, //callback function to be fired during the column resizing process if liveDrag is enabled
				onResize: null //callback function fired when the dragging process is over
			};
			options = $.extend(defaults, options);

			//since now there are 3 different ways of resizing columns, I changed the external interface to make it clear
			//calling it 'resizeMode' but also to remove the "fixed" attribute which was confusing for many people
			options.fixed = true;
			options.overflow = false;
			switch (options.resizeMode) {
				case 'flex':
					options.fixed = false;
					break;
				case 'overflow':
					options.fixed = false;
					options.overflow = true;
					break;
			}

			return this.each(function () {
				init(this, options);
			});
		}
	});
})(jQuery);

(function () {
	'use strict';

	angular
		.module('userApp')
		.directive('ecmUltimateTable', ecmUltimateTable);

	/** @ngInject */
	function ecmUltimateTable($compile, $parse) {
		// Usage:
		//
		// Creates:
		//
		var directive = {
			priority: 2000,
			terminal: true,
			transclude: false,
			scope: true,
			restrict: 'A',
			compile: function (element, attrs) {

				// need to modify dom before compile
				// add Html and swap directive
				var tableType = attrs.ecmUltimateTable;
				var clone = element.clone(true);
				clone.removeAttr('ecm-ultimate-table');
				clone.attr('ecm-ultimate-table-wrapper', tableType);
				var newElement = angular.element('<div class="ecm-table-container" style="position: relative"/>');

				var configButtonHtml = '<div ng-if="hideColumns && hideColumns.length > 0" ng-mouseleave="collapseConfigToolbar(false)" class="ecm-ultimate-table-config" ng-mouseover="openConfigToolbar()">' +
					'<div class="btn-group" on-toggle="collapseConfigToolbar(open)" is-open="_ecmTableConfig.isConfigOpen" dropdown-append-to="configContainer" uib-dropdown auto-close="outsideClick">' +
					'<button id="single-button" type="button" class="btn btn-xs btn-primary" uib-dropdown-toggle ng-disabled="disabled">' +
					'<i class="fa fa-cog" aria-hidden="true"></i> <span class="caret"></span>' +
					'</button>' +
					'<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button">' +
					'<li ng-if="col.display" ng-repeat="col in hideColumns | orderBy:\'order\'" ng-click="toggleColumn(col)" role="menuitem"><div class="checkbox"><label><input ng-model="col.visible" type="checkbox">{{col.display}}</label></div></li>' +
					'<li class="btn-reset" ng-click="resetColumn()" role="menuitem"><a>{{\'global.reset\' | translate}}</a></li>' +
					'<li class="divider"></li>' +
					'<li class="btn-reset" ng-click="toggleRowHeight()" role="menuitem"><a>{{\'table.toggleRowHeight\' | translate}}</a></li>' +
					'</ul>' +
					'</div>' +
					'</div>';
				newElement.append(configButtonHtml);
				newElement.append(clone);

				element.replaceWith(newElement);

				return function (scope, element, attrs) {
					scope.configContainer = element;
					var table = element.children().last();

					var firstTr = table.find(">thead>tr:first");
					if (attrs.checkboxModel && $parse(attrs.multiSelect)(scope)) {
						var selectorHtml =
							'<th class="icon-column" no-ellipsis no-drag no-resize><input type="checkbox" ng-model="_ecmTableConfig.all" ng-click="_ecmTableAllChanged()"></th>';
						firstTr.prepend(selectorHtml);

						// add checkbox
						var firstBodyTr = table.find(">tbody>tr:first");
						if (firstBodyTr.length > 0) {
							var checkboxTemplate = '<td class="icon-column">';
							checkboxTemplate += '<input ecm-table-select type="checkbox" ng-model="' + attrs.checkboxModel + '" ng-click="_selectRowChange($event)" class="sidebar-open" aria-label="checkbox">';
							checkboxTemplate += '</td>';
							firstBodyTr.prepend(checkboxTemplate);
						}
					}

					//element.append(clone);
					$compile(element)(scope);
				};
			}
		};
		return directive;
	}

	angular
		.module('userApp')
		.directive('ecmUltimateTableWrapper', ecmUltimateTableWrapper);

	/** @ngInject */
	function ecmUltimateTableWrapper($timeout, $parse, $animate, $animateCss, userPreferenceService, configurationLocalUserService) {
		var storeVersion = 3;
		// Usage:
		//
		// Creates:
		//
		var directive = {
			require: 'stTable',
			compile: compile,
			transclude: 'element',
			restrict: 'A'
		};
		return directive;

		function resetStore(orders) {
			var store = {
				columns: {},
				sort: {},
				version: storeVersion
			};

			//init store columns properties with default column configuration (column visibility) retrieved from admin/user tables
			_.each(orders, function (val, key) {
				store.columns[key] = initColumnData(val);
			});

			return store;
		}

		function initColumnData(columnData) {
			return {
				order: columnData.order,
				size: '',
				visible: columnData.visible
			};
		}

		function getStoredPrefs(id) {
			var store = userPreferenceService.getUserTablePreference(id);
			if (!store || store.version !== storeVersion) {
				return resetStore();
			}

			return store;
		}

		function compile(element, attrs) {
			return {
				pre: function (scope, element, attrs) { },
				post: link
			};

		}

		function link(scope, element, attrs, ctrl, $transclude) {

			var tableElement;

			// select
			scope._ecmTableConfig = {
				all: false,
				multi: angular.isDefined(attrs.multiSelect) ? $parse(attrs.multiSelect)(scope) : true,
				isConfigOpen: false,
				resizeEnabled: angular.isDefined(attrs.resizeEnabled) ? $parse(attrs.resizeEnabled)(scope) : true,
				resizeMode: angular.isDefined(attrs.resizeMode) ? attrs.resizeMode : 'fit'
			};
			scope._ecmTableAllChanged = function () {
				scope.$applyAsync(
					tableElement.find('[ecm-table-select]').prop('checked', scope._ecmTableConfig.all).each(function () {
						var ngCtrl = angular.element(this).controller('ngModel');
						ngCtrl.$setViewValue(this.checked, 'change');
					})
				);
				$parse(attrs.onSelectAllChange)(scope.$parent);
			};

			scope._ecmCheckAllSelected = function () {
				if (tableElement) {
					$timeout(function () {
						var selectCount = tableElement.find('[ecm-table-select]').length;
						var checkedCount = tableElement.find('[ecm-table-select]:checked').length;
						var old = scope._ecmTableConfig.all;
						scope._ecmTableConfig.all = selectCount > 0 && selectCount === checkedCount;
						if (old !== scope._ecmTableConfig.all) {
							scope.$apply();
						}
					}, 0, false);
				}
			};

			scope._selectRowChange = function (event) {
				event.stopPropagation();
				scope._ecmCheckAllSelected();
				var rowScope = angular.element(event.target).scope();
				$parse(attrs.onSelectRowChange)(rowScope);
			};

			scope.isConfigOpen = false;

			function getConfigToolbarElem() {
				return tableElement.parent().find('.ecm-ultimate-table-config').first();
			}

			scope.collapseConfigToolbar = function (open) {
				if (!open) {
					var configElem = getConfigToolbarElem();

					if (!scope._ecmTableConfig.isConfigOpen) {
						configElem.css({
							overflow: 'hidden'
						});

						$animateCss(configElem, {
							removeClass: 'open'
						}).start()['finally'](function () {
							configElem.removeClass('open');
						});
					}
				}
			};

			scope.openConfigToolbar = function () {
				var configElem = getConfigToolbarElem();

				if (configElem.hasClass('open')) {
					return;
				}

				configElem.addClass('open');
			};

			function toggleColumn(colId, visible) {
				var thtb = tableElement.children();
				var findIdx = tableElement.find('#' + colId).index() + 1;
				var headers = tableElement.find('th');
				var all = thtb.find('> tr > td:nth-child(' + findIdx + ')').add(thtb.find('> tr > th:nth-child(' + findIdx + ')'));
				headers.css('width', '');
				if (!visible) {
					all.css({
						'display': 'none'
					});
				} else {
					all.css({
						'display': ''
					});

				}
			}

			function setColumnsVisibility() {
				var store = getStoredPrefs(attrs.id);
				_.each(scope.hideColumns, function (val) {
					var column = store.columns[val.id];
					val.order = column.order;
					if (!column.visible) {
						val.visible = column.visible;
						toggleColumn(val.id, column.visible);
					}
				});
			}

			function setResize(table, restoresize) {
				if (scope._ecmTableConfig.resizeEnabled) {
					table.colResizable({
						disable: true
					});
					if (restoresize) {
						var store = getStoredPrefs(attrs.id);
						table.find('th').each(function (i) {
							if (store.columns[this.id]) {
								this.style.width = store.columns[this.id].size;
							}
						});
					}
					table.colResizable({
						resizeMode: scope._ecmTableConfig.resizeMode,
						onResize: persistColumnsSize
					});
				}
			}

			function persistColumnsVisibility() {
				var store = getStoredPrefs(attrs.id);
				_.each(scope.hideColumns, function (val) {
					store.columns[val.id].visible = val.visible;
				});
				userPreferenceService.setUserTablePreference(attrs.id, store);
				cloneTable();
			}

			function persistColumnsSize(elem) {
				var table = angular.element(elem);
				var store = getStoredPrefs(attrs.id);

				table.find('th').each(function (i) {
					store.columns[this.id].size = this.style.width;
				});
				userPreferenceService.setUserTablePreference(attrs.id, store);
				configurationLocalUserService.addUserTablePreference(attrs.id, store);
				cloneTable();
			}

			function persistColumnOrder(table) {
				var store = getStoredPrefs(attrs.id);
				table.el.find('th').each(function (i) {
					store.columns[this.id].order = i;
				});

				_.each(scope.hideColumns, function (val) {
					val.order = store.columns[val.id].order;
				});
				userPreferenceService.setUserTablePreference(attrs.id, store);
				setResize(table.el);
				cloneTable();
			}

			function cloneTable() {
				var previousTableHtml = tableElement.clone().removeAttr('id');
				previousTableHtml.children().find('> tr > th').removeAttr('id');
				scope._previousTableHTMLContainer = angular.element('<div style="width: ' + tableElement.outerWidth() + 'px"></div>').append(previousTableHtml);
			}

			function getStoredSort() {
				var store = getStoredPrefs(attrs.id);

				var sort = store ? store.sort : null;
				return sort ? sort : {};
			}

			function initializeColumns() {
				scope.hideColumns = [];
				scope._ecmTableDefaultSort = null;

				var store = getStoredPrefs(attrs.id);

				var th = tableElement.find('th');
				var cols = {};
				var columnProperties = {};
				th.each(function (i) {

					if (!this.hasAttribute('no-ellipsis')) {
						this.classList.add('text-ellipsis');
					}
					if (_.isEmpty(this.id)) {
						angular.element(this).attr('id', 'col-id-' + i);
					}

					var columnVisible = true;
					if (angular.isDefined(angular.element(this).data("visible"))) {
						columnVisible = angular.element(this).data("visible");
					}

					var defaultSort = angular.element(this).data("defaultSort");
					if (defaultSort) {
						var sortSplit = defaultSort.split(' ');
						if (sortSplit.length > 1 && sortSplit[0] === "true") {
							var sort = angular.element(this).attr("st-sort");
							if (sort) {
								scope._ecmTableDefaultSort = { predicate: sort, reverse: sortSplit[1] === "ASC" ? false : true };
							}
						}
					}

					cols[this.id] = true;
					columnProperties[this.id] = {
						order: i,
						visible: columnVisible
					};
					var text = _.trim(this.textContent);
					scope.hideColumns.push({
						id: this.id,
						visible: true,
						display: _.isEmpty(text) ? null : text,
						order: i
					});

					if (!this.hasAttribute('no-drag')) {
						this.classList.add('draggable');
					}
				});

				// used only when header are declared in html
				if (scope._first) {
					scope.htmlHeader = tableElement.find('thead').clone();
					scope._firstColumnProperties = columnProperties;
				}

				scope._columnProperties = columnProperties;
				//check if stored values map with current columns. If not reset store
				var storedKeys = {};
				_.each(store.columns, function (val, key) {
					storedKeys[key] = true;
				});
				if (!_.isEqual(storedKeys, cols)) {
					userPreferenceService.setUserTablePreference(attrs.id, resetStore(scope._columnProperties));
				}

				scope._first = false;

				tableElement.dragtable({
					excludeFooter: true,
					persistState: persistColumnOrder,
					restoreState: getStoredPrefs(attrs.id).columns,
					dragaccept: '.draggable'
				});
				setColumnsVisibility();
			}

			scope._first = true;
			scope._columnProperties = {};

			scope.toggleRowHeight = function () {
				tableElement.toggleClass('row-height');
			};

			scope.resetColumn = function () {
				_.forEach(scope.hideColumns, function (col) {
					col.visible = scope._columnProperties[col.id].visible;
					toggleColumn(col.id, true);
				});
				persistColumnsVisibility();
				setColumnsVisibility();
				setResize(tableElement);
				persistColumnsSize(tableElement);

				if (scope._ecmTableDefaultSort) {
					ctrl.sortBy(scope._ecmTableDefaultSort.predicate, scope._ecmTableDefaultSort.reverse);
				}

				cloneTable();
			};

			scope.toggleColumn = function (column) {
				toggleColumn(column.id, column.visible);
				persistColumnsVisibility();
				setResize(tableElement);
				persistColumnsSize(tableElement);
				cloneTable();
			};

			scope._previousTableHTMLContainer;

			var block, childScope;

			function reset(newVal) {
				var storedSort = getStoredSort();

				if (attrs.stPipe && !_.isEqual(ctrl.tableState().sort, storedSort)) {
					ctrl.tableState().sort = storedSort;
				}

				if (childScope) {
					childScope.$destroy();
					childScope = null;
				}
				if (block) {
					tableElement.colResizable({
						disable: true
					});
					var inst = tableElement.dragtable("instance");
					if (inst) {
						tableElement.dragtable("destroy");
					}
					block.remove();
				}
				$transclude(function (clone, newScope) {
					childScope = newScope;
					block = clone;
					$animate.enter(clone, element.parent(), element);
					tableElement = block;
					//disable angular animation
					$animate.enabled(tableElement, false);
				});

				if (!_.isEmpty(newVal) || attrs.ecmUltimateTableWrapper === 'static') {
					if (scope._previousTableHTMLContainer) {
						tableElement.before(scope._previousTableHTMLContainer);
					}
					tableElement.css({
						'display': 'none'
					});

					$timeout(function () {
						initializeColumns();
						tableElement.css({
							'display': ''
						});
						setResize(tableElement, true);
						if (scope._previousTableHTMLContainer) {
							scope._previousTableHTMLContainer.remove();
						}

						scope._ecmCheckAllSelected();
						cloneTable();
					});
				}
			}

			scope.$watch(scope._ecmCheckAllSelected);


			// When data binded to stTable change, reset
			scope.$watch(attrs.stTable, function (newVal) {
				reset(newVal);
			});

			// persist sort
			scope.$watch(function () {
				return ctrl.tableState().sort;
			}, function (newValue) {
				var store = getStoredPrefs(attrs.id);
				store.sort = newValue;
				userPreferenceService.setUserTablePreference(attrs.id, store);
			}, true);
		}
	}

})();

/*!
 * dragtable
 *
 * @Version 2.0.15
 *
 * Copyright (c) 2010-2013, Andres akottr@gmail.com
 * Dual licensed under the MIT (MIT-LICENSE.txt)
 * and GPL (GPL-LICENSE.txt) licenses.
 *
 * Inspired by the the dragtable from Dan Vanderkam (danvk.org/dragtable/)
 * Thanks to the jquery and jqueryui comitters
 *
 * Any comment, bug report, feature-request is welcome
 * Feel free to contact me.
 */

/* TOKNOW:
 * For IE7 you need this css rule:
 * table {
 *   border-collapse: collapse;
 * }
 * Or take a clean reset.css (see http://meyerweb.com/eric/tools/css/reset/)
 */

/* TODO: investigate
 * Does not work properly with css rule:
 * html {
 *      overflow: -moz-scrollbars-vertical;
 *  }
 * Workaround:
 * Fixing Firefox issues by scrolling down the page
 * http://stackoverflow.com/questions/2451528/jquery-ui-sortable-scroll-helper-element-offset-firefox-issue
 *
 * var start = $.noop;
 * var beforeStop = $.noop;
 * if($.browser.mozilla) {
 * var start = function (event, ui) {
 *               if( ui.helper !== undefined )
 *                 ui.helper.css('position','absolute').css('margin-top', $(window).scrollTop() );
 *               }
 * var beforeStop = function (event, ui) {
 *              if( ui.offset !== undefined )
 *                ui.helper.css('margin-top', 0);
 *              }
 * }
 *
 * and pass this as start and stop function to the sortable initialisation
 * start: start,
 * beforeStop: beforeStop
 */
/*
 * Special thx to all pull requests comitters
 */

(function ($) {
	var jq = $;
	var $injector = angular.injector(['ng']);
	var $timeout = $injector.get('$timeout');
	var $window = $injector.get('$window');
	var $document = $injector.get('$document');

	$.widget("akottr.dragtable", {
		options: {
			revert: false, // smooth revert
			dragHandle: '.table-handle', // handle for moving cols, if not exists the whole 'th' is the handle
			maxMovingRows: 40, // 1 -> only header. 40 row should be enough, the rest is usually not in the viewport
			excludeFooter: false, // excludes the footer row(s) while moving other columns. Make sense if there is a footer with a colspan. */
			onlyHeaderThreshold: 100, // TODO:  not implemented yet, switch automatically between entire col moving / only header moving
			dragaccept: null, // draggable cols -> default all
			persistState: null, // url or function -> plug in your custom persistState function right here. function call is persistState(originalTable)
			restoreState: null, // JSON-Object or function:  some kind of experimental aka Quick-Hack TODO: do it better
			exact: true, // removes pixels, so that the overlay table width fits exactly the original table width
			clickDelay: 200, // ms to wait before rendering sortable list and delegating click event
			containment: null, // @see http://api.jqueryui.com/sortable/#option-containment, use it if you want to move in 2 dimesnions (together with axis: null)
			cursor: 'move', // @see http://api.jqueryui.com/sortable/#option-cursor
			cursorAt: false, // @see http://api.jqueryui.com/sortable/#option-cursorAt
			distance: 0, // @see http://api.jqueryui.com/sortable/#option-distance, for immediate feedback use "0"
			tolerance: 'pointer', // @see http://api.jqueryui.com/sortable/#option-tolerance
			axis: 'x', // @see http://api.jqueryui.com/sortable/#option-axis, Only vertical moving is allowed. Use 'x' or null. Use this in conjunction with the 'containment' setting
			beforeStart: $.noop, // returning FALSE will stop the execution chain.
			beforeMoving: $.noop,
			beforeReorganize: $.noop,
			beforeStop: $.noop
		},
		originalTable: {
			el: null,
			selectedHandle: null,
			sortOrder: null,
			startIndex: 0,
			endIndex: 0
		},
		sortableTable: {
			el: jq(),
			selectedHandle: jq(),
			movingRow: jq()
		},
		persistState: function () {
			var _this = this;
			this.originalTable.el.find('th').each(function (i) {
				if (this.id !== '') {
					_this.originalTable.sortOrder[this.id] = i;
				}
			});
			$.ajax({
				url: this.options.persistState,
				data: this.originalTable.sortOrder
			});
		},
		/*
		 * persistObj looks like
		 * {'id1':'2','id3':'3','id2':'1'}
		 * table looks like
		 * |   id2  |   id1   |   id3   |
		 */
		_restoreState: function (persistObj) {
			for (var n in persistObj) {
				this.originalTable.startIndex = jq(this.originalTable.el).find('#' + n).closest('th').prevAll().length + 1;
				this.originalTable.endIndex = parseInt(persistObj[n].order, 10) + 1;
				this._bubbleCols();
			}
		},
		// bubble the moved col left or right
		_bubbleCols: function () {
			var i, j, col1, col2;
			var from = this.originalTable.startIndex;
			var to = this.originalTable.endIndex;
			/* Find children thead and tbody.
			 * Only to process the immediate tr-children. Bugfix for inner tables
			 */
			var thtb = this.originalTable.el.children();
			if (this.options.excludeFooter) {
				thtb = thtb.not('tfoot');
			}
			if (from < to) {
				for (i = from; i < to; i++) {
					col1 = thtb.find('> tr > td:nth-child(' + i + ')')
						.add(thtb.find('> tr > th:nth-child(' + i + ')'));
					col2 = thtb.find('> tr > td:nth-child(' + (i + 1) + ')')
						.add(thtb.find('> tr > th:nth-child(' + (i + 1) + ')'));
					for (j = 0; j < col1.length; j++) {
						swapNodes(col1[j], col2[j]);
					}
				}
			} else {
				for (i = from; i > to; i--) {
					col1 = thtb.find('> tr > td:nth-child(' + i + ')')
						.add(thtb.find('> tr > th:nth-child(' + i + ')'));
					col2 = thtb.find('> tr > td:nth-child(' + (i - 1) + ')')
						.add(thtb.find('> tr > th:nth-child(' + (i - 1) + ')'));
					for (j = 0; j < col1.length; j++) {
						swapNodes(col1[j], col2[j]);
					}
				}
			}
		},
		// bubble the moved headers left or right
		_bubbleHeaderCols: function () {
			var i, j, col1, col2;
			var from = this.originalTable.startIndex;
			var to = this.originalTable.endIndex;
			/* Find children thead and tbody.
			 * Only to process the immediate tr-children. Bugfix for inner tables
			 */
			var thtb = this.originalTable.el.children();
			if (this.options.excludeFooter) {
				thtb = thtb.not('tfoot');
			}
			if (from < to) {
				for (i = from; i < to; i++) {
					col1 = thtb.find('> tr > th:nth-child(' + i + ')');
					col2 = thtb.find('> tr > th:nth-child(' + (i + 1) + ')');
					for (j = 0; j < col1.length; j++) {
						swapNodes(col1[j], col2[j]);
					}
				}
			} else {
				for (i = from; i > to; i--) {
					col1 = thtb.find('> tr > th:nth-child(' + i + ')');
					col2 = thtb.find('> tr > th:nth-child(' + (i - 1) + ')');
					for (j = 0; j < col1.length; j++) {
						swapNodes(col1[j], col2[j]);
					}
				}
			}
		},
		_rearrangeTableBackroundProcessing: function () {
			var _this = this;
			return function () {
				_this._bubbleCols();
				_this.options.beforeStop(_this.originalTable);
				_this.sortableTable.el.remove();
				restoreTextSelection();
				// persist state if necessary
				if (_this.options.persistState !== null) {
					$.isFunction(_this.options.persistState) ? _this.options.persistState(_this.originalTable) : _this.persistState();
				}
			};
		},
		_rearrangeTable: function () {
			var _this = this;
			return function () {
				// remove handler-class -> handler is now finished
				_this.originalTable.selectedHandle.removeClass('dragtable-handle-selected');
				// add disabled class -> reorgorganisation starts soon
				_this.sortableTable.el.sortable("disable");
				_this.sortableTable.el.addClass('dragtable-disabled');
				_this.options.beforeReorganize(_this.originalTable, _this.sortableTable);
				// do reorganisation asynchronous
				// for chrome a little bit more than 1 ms because we want to force a rerender
				_this.originalTable.endIndex = _this.sortableTable.movingRow.prevAll().length + 1;
				$timeout(_this._rearrangeTableBackroundProcessing(), 50);
				//setTimeout(_this._rearrangeTableBackroundProcessing(), 50);
			};
		},
		/*
		 * Disrupts the table. The original table stays the same.
		 * But on a layer above the original table we are constructing a list (ul > li)
		 * each li with a separate table representig a single col of the original table.
		 */
		_generateSortable: function (e) {
			!e.cancelBubble && (e.cancelBubble = true);
			var _this = this;
			// table attributes
			var attrs = this.originalTable.el[0].attributes;
			var attrsString = '';
			for (var i = 0; i < attrs.length; i++) {
				if (attrs[i].nodeValue && attrs[i].nodeName !== 'id' && attrs[i].nodeName !== 'width') {
					attrsString += attrs[i].nodeName + '="' + attrs[i].nodeValue + '" ';
				}
			}

			// row attributes
			var rowAttrsArr = [];
			//compute height, special handling for ie needed :-(
			var heightArr = [];
			this.originalTable.el.find('tr').slice(0, this.options.maxMovingRows).each(function (i, v) {
				// row attributes
				var attrs = this.attributes;
				var attrsString = "";
				for (var j = 0; j < attrs.length; j++) {
					if (attrs[j].nodeValue && attrs[j].nodeName !== 'id') {
						attrsString += " " + attrs[j].nodeName + '="' + attrs[j].nodeValue + '"';
					}
				}
				rowAttrsArr.push(attrsString);
				heightArr.push(jq(this).height());
			});

			// compute width, no special handling for ie needed :-)
			var widthArr = [];
			// compute total width, needed for not wrapping around after the screen ends (floating)
			var totalWidth = 0;
			/* Find children thead and tbody.
			 * Only to process the immediate tr-children. Bugfix for inner tables
			 */
			var thtb = _this.originalTable.el.children();
			if (this.options.excludeFooter) {
				thtb = thtb.not('tfoot');
			}
			thtb.find('> tr > th').each(function (i, v) {
				var w = jq(this).is(':visible') ? jq(this).outerWidth() : 0;
				widthArr.push(w);
				totalWidth += w;
			});
			if (_this.options.exact) {
				var difference = totalWidth - _this.originalTable.el.outerWidth();
				widthArr[0] -= difference;
			}
			// one extra px on right and left side
			totalWidth += 2;

			var sortableHtml = '<ul class="dragtable-sortable" style="position:absolute; width:' + totalWidth + 'px;">';
			// assemble the needed html
			thtb.find('> tr > th').each(function (i, v) {
				var width_li = jq(this).is(':visible') ? jq(this).outerWidth() : 0;
				sortableHtml += '<li style="width:' + width_li + 'px;">';
				sortableHtml += '<table ' + attrsString + '>';
				var row = thtb.find('> tr > th:nth-child(' + (i + 1) + ')');
				if (_this.options.maxMovingRows > 1) {
					row = row.add(thtb.find('> tr > td:nth-child(' + (i + 1) + ')').slice(0, _this.options.maxMovingRows - 1));
				}
				row.each(function (j) {
					// TODO: May cause duplicate style-Attribute
					var row_content = jq(this).clone().wrap('<div></div>').parent().html();
					if (row_content.toLowerCase().indexOf('<th') === 0) sortableHtml += "<thead>";
					sortableHtml += '<tr ' + rowAttrsArr[j] + '" style="height:' + heightArr[j] + 'px;">';
					sortableHtml += row_content;
					if (row_content.toLowerCase().indexOf('<th') === 0) sortableHtml += "</thead>";
					sortableHtml += '</tr>';
				});
				sortableHtml += '</table>';
				sortableHtml += '</li>';
			});
			sortableHtml += '</ul>';
			this.sortableTable.el = this.originalTable.el.before(sortableHtml).prev();
			// set width if necessary
			this.sortableTable.el.find('> li > table').each(function (i, v) {
				jq(this).css('width', widthArr[i] + 'px');
			});

			// assign this.sortableTable.selectedHandle
			this.sortableTable.selectedHandle = this.sortableTable.el.find('th .dragtable-handle-selected');

			var items = !this.options.dragaccept ? 'li' : 'li:has(' + this.options.dragaccept + ')';
			this.sortableTable.el.sortable({
				items: items,
				stop: this._rearrangeTable(),
				// pass thru options for sortable widget
				revert: this.options.revert,
				tolerance: this.options.tolerance,
				containment: this.options.containment,
				cursor: this.options.cursor,
				cursorAt: this.options.cursorAt,
				distance: this.options.distance,
				axis: this.options.axis
			});

			// assign start index
			this.originalTable.startIndex = jq(e.target).closest('th').prevAll().length + 1;

			this.options.beforeMoving(this.originalTable, this.sortableTable);
			// Start moving by delegating the original event to the new sortable table
			this.sortableTable.movingRow = this.sortableTable.el.find('> li:nth-child(' + this.originalTable.startIndex + ')');

			// prevent the user from drag selecting "highlighting" surrounding page elements
			disableTextSelection();
			// clone the initial event and trigger the sort with it
			this.sortableTable.movingRow.trigger($.extend($.Event(e.type), {
				which: 1,
				clientX: e.clientX,
				clientY: e.clientY,
				pageX: e.pageX,
				pageY: e.pageY,
				screenX: e.screenX,
				screenY: e.screenY
			}));

			// Some inner divs to deliver the posibillity to style the placeholder more sophisticated
			var placeholder = this.sortableTable.el.find('.ui-sortable-placeholder');
			if (!placeholder.height() <= 0) {
				placeholder.css('height', this.sortableTable.el.find('.ui-sortable-helper').height());
			}

			placeholder.html('<div class="outer" style="height:100%;"><div class="inner" style="height:100%;"></div></div>');
		},
		bindTo: {},
		_create: function () {
			this.originalTable = {
				el: this.element,
				selectedHandle: jq(),
				sortOrder: {},
				startIndex: 0,
				endIndex: 0
			};
			// bind draggable to 'th' by default
			this.bindTo = this.originalTable.el.find('th');
			// filter only the cols that are accepted
			if (this.options.dragaccept) {
				this.bindTo = this.bindTo.filter(this.options.dragaccept);
			}
			// bind draggable to handle if exists
			if (this.bindTo.find(this.options.dragHandle).length > 0) {
				this.bindTo = this.bindTo.find(this.options.dragHandle);
			}
			// restore state if necessary
			if (this.options.restoreState !== null) {
				$.isFunction(this.options.restoreState) ? this.options.restoreState(this.originalTable) : this._restoreState(this.options.restoreState);
			}
			var _this = this;
			this.bindTo.mousedown(function (evt) {
				// listen only to left mouse click
				if (evt.which !== 1) return;
				if (_this.options.beforeStart(_this.originalTable) === false) {
					return;
				}
				$timeout.cancel(this.downTimer);
				this.downTimer = $timeout(function () {
					_this.originalTable.selectedHandle = jq(this);
					_this.originalTable.selectedHandle.addClass('dragtable-handle-selected');
					_this._generateSortable(evt);
				}, _this.options.clickDelay);
			}).mouseup(function (evt) {
				$timeout.cancel(this.downTimer);
			});
		},
		redraw: function () {
			this.destroy();
			this._create();
		},
		destroy: function () {
			this.bindTo.unbind('mousedown');
			$.Widget.prototype.destroy.apply(this, arguments); // default destroy
			// now do other stuff particular to this widget
		},
		restoreHeaders: function (persistObj) {
			for (var n in persistObj) {
				this.originalTable.startIndex = jq('#' + n).closest('th').prevAll().length + 1;
				this.originalTable.endIndex = parseInt(persistObj[n], 10) + 1;
				this._bubbleHeaderCols();
			}
		}
	});

	/** closure-scoped "private" functions **/

	var body_onselectstart_save = jq($document[0].body).attr('onselectstart'),
		body_unselectable_save = jq($document[0].body).attr('unselectable');

	// css properties to disable user-select on the body tag by appending a <style> tag to the <head>
	// remove any current document selections

	function disableTextSelection() {
		// jQuery doesn't support the element.text attribute in MSIE 8
		// http://stackoverflow.com/questions/2692770/style-style-textcss-appendtohead-does-not-work-in-ie
		var $style = jq('<style id="__dragtable_disable_text_selection__" type="text/css">body { -ms-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-webkit-user-select:none;user-select:none; }</style>');
		jq($document[0].head).append($style);
		jq($document[0].body).attr('onselectstart', 'return false;').attr('unselectable', 'on');
		if ($window.getSelection) {
			$window.getSelection().removeAllRanges();
		} else {
			$document[0].selection.empty(); // MSIE http://msdn.microsoft.com/en-us/library/ms535869%28v=VS.85%29.aspx
		}
	}

	// remove the <style> tag, and restore the original <body> onselectstart attribute

	function restoreTextSelection() {
		jq('#__dragtable_disable_text_selection__').remove();
		if (body_onselectstart_save) {
			jq($document[0].body).attr('onselectstart', body_onselectstart_save);
		} else {
			jq($document[0].body).removeAttr('onselectstart');
		}
		if (body_unselectable_save) {
			jq($document[0].body).attr('unselectable', body_unselectable_save);
		} else {
			jq($document[0].body).removeAttr('unselectable');
		}
	}

	function swapNodes(a, b) {
		if (a && b) {
			var aparent = a.parentNode;
			var asibling = a.nextSibling === b ? a : a.nextSibling;
			b.parentNode.insertBefore(a, b);
			aparent.insertBefore(b, asibling);
		}
	}
})(jQuery);

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('errorModal', {
			templateUrl: 'scripts/pre-upgrade/components/commons/error-modal/error-modal.component.html',
			controller: ErrorModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ErrorModalController() {
		var ctrl = this;


		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('openErrorModalService', OpenErrorModalService);



	/**
	 * Common service used to show an error pop up with the appropriate messages.
	 */
	/** @ngInject */
	function OpenErrorModalService($uibModal) {
		var service = {
			OpenModal: OpenModal
		};

		return service;

		function OpenModal(text, title, params) {

			$uibModal.open({
				component: 'errorModal',
				resolve: {
					message: {
						text: text,
						title: title,
						params: params
					}
				},
				backdrop: 'static'
			});

		}


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('infoModal', {
			templateUrl: 'scripts/pre-upgrade/components/commons/info-modal/info-modal.html',
			controller: InfoModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function InfoModalController() {
		var ctrl = this;

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('infoModalService', infoModalService);



	/**
	 * Common service used to show an error pop up with the appropriate messages.
	 */
	/** @ngInject */
	function infoModalService($uibModal) {
		var service = {
			openModal: openModal,
			openActionDenied: openActionDenied,
			openBulkSucess: openBulkSucess
		};

		return service;

		function openModal(text, title, params) {

			var modalInstance = $uibModal.open({
				component: 'infoModal',
				resolve: {
					message: {
						text: text,
						title: title,
						params: params
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('bulkoperations');
						$translatePartialLoader.addPart('error');
						return $translate.refresh();
					}]
				},
				backdrop: 'static'
			});

			return modalInstance.result;

		}

		function openActionDenied(params) {
			return openModal("error.actionDenied.message", "error.actionDenied.title", params);
		}

		function openBulkSucess(params) {
			return openModal("userApp.bulkoperations.modal.message", "userApp.bulkoperations.modal.title");
		}

	}
})();

angular.module('userApp').component('padlockIcon', {
	templateUrl: 'scripts/pre-upgrade/components/commons/padlock/padlock.html',
	bindings: {
		color: '=',
		closed: "=",
		owner: "=",
		size: '@'
	},
	controller: function padlockCtrl() {
		this.bigPadlockColorClass = function () {
			var colorClass = "lock-doc-right";
			if (this.color === "GREEN") {
				colorClass = colorClass.concat(" locked-by-you");
			}
			else if (this.color === "ORANGE") {
				colorClass = colorClass.concat(" lock-editable");
			}
			else if (this.color === "RED") {
				colorClass = colorClass.concat(" locked-by-other");
			}
			return colorClass;
		};

		this.bigPadlockClass = function () {
			var bigPadlockClass = "icon-lock ion-ios-locked-outline";
			if (!this.closed || this.closed === 'false') {
				bigPadlockClass = "icon-lock ion-ios-unlocked-outline";
			}
			return bigPadlockClass;
		};

		this.smallPadlockClass = function () {
			var smallPadlockClass = "fa fa-lock";
			if (!this.closed || this.closed === 'false') {
				smallPadlockClass = "fa fa-unlock-alt";
			}
			return smallPadlockClass;
		};

	},
});

(function () {
	'use strict';

	// Usage:
	// <relation-status-icon relation-status="status"></relation-status-icon>
	// Creates:
	// 

	angular
		.module('userApp')
		.component('relationStatusIcon', {
			templateUrl: 'scripts/pre-upgrade/components/commons/relation-status-icon/relation-status-icon.html',
			controller: RelationStatusIconController,
			controllerAs: '$ctrl',
			bindings: {
				relationStatus: '<',
				disabled: '<?'
			},
		});


	function RelationStatusIconController() {
		var $ctrl = this;


		////////////////

		$ctrl.$onInit = function () {};
		$ctrl.$onChanges = function (changesObj) {};
		$ctrl.$onDestroy = function () {};


		///// Display Utils operations ///////////
		$ctrl.getRelationStatusIcon = function () {
			var iconClass;
			switch ($ctrl.relationStatus) {
				case 'BROKEN':
					iconClass = 'faricon-broken-link';
					break;
				case 'VALID':
					iconClass = 'faricon-valid-link';
					break;
				default:
					iconClass = '';
			}

			return $ctrl.disabled ? [iconClass, 'disabled'] : iconClass;
		};
		$ctrl.getRelationStatusTooltip = function (status) {
			if ($ctrl.disabled) {
				return 'status.disabledLink';
			}
			switch ($ctrl.relationStatus) {
				case 'BROKEN':
					return 'status.brokenLink';
				case 'VALID':
					return 'status.validLink';
				default:
					return '';
			}
		};
	}
})();

/* eslint-disable angular/json-functions */
/* eslint-disable indent */

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('configurationLocalUserService', ConfigurationLocalUserService);


	/** @ngInject */
	function ConfigurationLocalUserService($state, configurationLocalUserResource, localStorageService, USER_PREFERENCE, userPreferenceService, $sessionStorage) {

		var service = {
			addConfigLocalStrorage: addConfigLocalStrorage,
			addUserGlobalPreference: addUserGlobalPreference,
			addUserTablePreference: addUserTablePreference,
			addUserSessionStorage: addUserSessionStorage,
			addConfigSessionStrorage: addConfigSessionStrorage,
			addConfigGlobalOnStorage: addConfigGlobalOnStorage,
			setConfiguration: setConfiguration,
			updateSession: updateSession,
			reinitialiser: reinitialiser


		};

		return service;

		function addUserSessionStorage(code, data) {
			addConfigSessionStrorage(code, data);
		}
		function addUserGlobalPreference(preferenceStorageKey, data) {
			addConfigGlobalOnStorage(USER_PREFERENCE.global.storageKey, preferenceStorageKey, data);
		}

		function addUserTablePreference(preferenceStorageKey, data) {
			addConfigLocalStrorage(USER_PREFERENCE.table.storageKey, preferenceStorageKey, data);
		}


		function addConfigLocalStrorage(storageKey, preferenceStorageKey, data) {
			var settings = localStorageService.get(storageKey) || {};
			settings[preferenceStorageKey] = data;
			storageKey = JSON.stringify(storageKey);
			storageKey = storageKey.replace(/"/g, '');
			return configurationLocalUserResource.addConfigLocalStrorage({ keyData: storageKey }, settings).$promise;

		}
		function addConfigGlobalOnStorage(storageKey, preferenceStorageKey, data) {
			storageKey = JSON.stringify(storageKey);
			storageKey = storageKey.replace(/"/g, '');
			return configurationLocalUserResource.addConfigLocalStrorage({ keyData: storageKey }, data).$promise;


		}

		function addConfigSessionStrorage(code, data) {
			return configurationLocalUserResource.addConfigLocalStrorage({ keyData: JSON.stringify(code) }, data).$promise;

		}

		function setConfiguration(storageKeys, data) {
			localStorageService.set(storageKeys, data);
		}
		function updateSession() {
			configurationLocalUserResource.displayConfiguration().$promise.then(function (data) {
				if (data.length > 0) {
					_.each(data, function (configData) {
						if (configData !== null && data.length > 0) {
							var jsonData = angular.fromJson(configData.dataJson);
							if (configData.keyData === "ecm-table") {
								setConfiguration(configData.keyData, jsonData);
							} else if (configData.keyData === "global") {
								userPreferenceService.setUserGlobalPreference('EcmuUserMenu', jsonData);
							}
						}
					});
				}
			});


		}
		function reinitialiser() {
			configurationLocalUserResource.deleteConfigStorage().$promise.then(
				function () {
					var keyData = "ecm-table";
					localStorageService.remove(keyData);
					$state.reload();
				});
		}



	}

}

)();






(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('ermService', ERMService);


	/** @ngInject */
	function ERMService(ermResource, blockUI) {
		var service = {
			checkConfigExits: checkConfigExits
		};

		return service;

		function checkConfigExits(code, resourceType) {
			return ermResource.checkConfigExits({ code: code, resourceType: resourceType }).$promise;
		}
	}

}

)();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('htmlPreviewService', HtmlPreviewService);

	/** @ngInject */
	function HtmlPreviewService(blockUI, htmlPreviewResource, EDITORIAL_ELEMENT_TYPE, updatePreviewResource, versioningResource) {
		var editorialRoute = location.origin + '/#/editorialEntity/';
		var apiMediaRegex = /^\/?api\/media\/.*/;
		var internalAnchorRegex = /^#\w.*/;
		var flashIdRegex = /^f([0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12})$/;
		var editorialEntityFlashIdRegex = /^\/?#\/editorialEntity\/f([0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12})$/;
		var fullUrlRegex = /^http(s?):\/\/.*$/;
		var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		var service = {
			getPreview: getPreview,
			getProofReadingPreview: getProofReadingPreview,
			getHtmlPreviews: getHtmlPreviews,
			getOverloadPreview: getOverloadPreview,
			updatePreview: updatePreview,
			getVersionedPreview: getVersionedPreview,
			updateHref: updateHref,
			reloadEntityPreview: reloadEntityPreview
		};

		return service;

		function getPreview(id, requestedPreview, isArchived, entityType, productCode) {
			var previewUI = blockUI.instances.get('previewUI');
			previewUI.start();
			return htmlPreviewResource.getEEHtmlPreview({
				id: id,
				entityType: entityType ? entityType : EDITORIAL_ELEMENT_TYPE.entity,
				requestedPreview: requestedPreview,
				isArchived: isArchived ? isArchived : false,
				productCode: productCode
			}).$promise.then(function (data) {
				previewUI.stop();
				return data;

			}, function (error) {
				previewUI.stop();
			});
		}

		function getProofReadingPreview(id, entityType, isArchived) {
			blockUI.start();
			return htmlPreviewResource.getProofReadingPreview({
				entityType: entityType,
				flashId: id,
				isArchived: isArchived ? isArchived : false
			}, {}).$promise.then(function (data) {
				blockUI.stop();
				return data.htmlPreview;
			}, function (error) {
				blockUI.stop();
			});
		}

		function getHtmlPreviews(flashIds) {
			return htmlPreviewResource.getHtmlPreviews(flashIds).$promise;
		}

		function getOverloadPreview(id, entityType, isArchived) {
			blockUI.start();
			return htmlPreviewResource.getOverloadedPreview({
				entityType: entityType,
				flashId: id,
				isArchived: isArchived ? isArchived : false
			}).$promise.then(function (data) {
				blockUI.stop();
				return data.htmlPreview;
			}, function (error) {
				blockUI.stop();
			});
		}

		function updatePreview(flashId, typePreview) {
			blockUI.start();
			return updatePreviewResource.updateHtmlPreview({ flashId: flashId, requestedPreview: typePreview }).$promise
				.then(function (result) {
					blockUI.stop();
					if (result && result.valid) {
						return result;
					}
				});
		}

		function getVersionedPreview(flashId, version) {
			return versioningResource.getPreview({ flashId: flashId, qualifiedVersion: version }).$promise;
		}

		function updateHref(content, baseLocation) {
			if (content) {
				var base = baseLocation ? baseLocation : location.origin;
				var a = content.find('a');
				if (a && a.length > 0) {
					a.each(function () {
						var link = this;

						//add target blank except for internal anchor
						if (link.hasAttribute('href')) {
							var linkVal = link.getAttribute('href');
							if (emailRegex.test(linkVal)) {
								link.setAttribute('href', 'mailto:' + linkVal);
							} else if (!linkVal.startsWith('mailto:') && !internalAnchorRegex.test(linkVal)) {
								link.setAttribute('target', '_blank');

								if (flashIdRegex.test(linkVal)) {
									link.setAttribute('href', editorialRoute + linkVal);
								} else if (editorialEntityFlashIdRegex.test(linkVal)) {
									if (!linkVal.startsWith('/')) {
										linkVal = '/' + linkVal;
									}
									link.setAttribute('href', base + linkVal);
								} else if (apiMediaRegex.test(linkVal)) {
									if (!linkVal.startsWith('/')) {
										linkVal = '/' + linkVal;
									}
									link.setAttribute('href', base + linkVal);
								} else if (!fullUrlRegex.test(linkVal)) {
									link.setAttribute('href', 'http://' + linkVal);
								}
							}
						}
					});
				}
			}
		}

		/**
		 * On refresh: if contextualized preview requested we return preview, no cache to update because preview with context is not persisted in cache
		 * otherwise recalculate preview and update cache.
		 * @param {*} flashId 
		 * @param {*} typePreview 
		 * @param {*} productCode 
		 */
		function reloadEntityPreview(flashId, typePreview, productCode) {
			if (productCode) {
				return getPreview(flashId, typePreview, false, EDITORIAL_ELEMENT_TYPE.entity, productCode);
			} else {
				return updatePreview(flashId, typePreview);
			}
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.constant('EETIMAGEMAP', {
			"EFL_GRP_acdaf": '.jpg',
			"EFL_GRP_acp": '.jpg',
			"EFL_GRP_actuOMAvocat": '.jpg',
			"EFL_GRP_actuOMDaf": '.jpg',
			"EFL_GRP_actuOMPaie": '.jpg',
			"EFL_GRP_actuOMRh": '.jpg',
			"EFL_GRP_baf": '.jpg',
			"EFL_GRP_bdp": '.jpg',
			"EFL_GRP_bf": '.jpg',
			"EFL_GRP_bim": '.jpg',
			"EFL_GRP_bpat": '.jpg',
			"EFL_GRP_bpim": '.jpg',
			"EFL_GRP_brdaguide": '.jpg',
			"EFL_GRP_bs": '.jpg',
			"EFL_GRP_fr": '.jpg',
			"EFL_GRP_frc": '.jpg',
			"EFL_GRP_frchs": '.jpg',
			"EFL_GRP_frs": '.jpg',
			"EFL_GRP_patact": '.jpg',
			"EFL_GRP_revueBrda": '.jpg',
			"EFL_GRP_rjda": '.jpg',
			"EFL_GRP_rjf": '.jpg',
			"EFL_GRP_rjs": '.jpg',
			"EL_GRP_ACTU_15AL": '.png',
			"EL_GRP_ELI": '.png',
			"EL_GRP_ACTU_GR01": '.png',
			"EFL_GRP_mementoFiscal": '.png',
			"EFL_GRP_mementoSocial": '.png',
			"EL_GRP_DP05": '.jpg',
			"EL_GRP_DP08": '.jpg',
			"EL_GRP_DP11": '.png',
		})
		.factory('imageUtilService', ImageUtilService);

	/** @ngInject */
	function ImageUtilService($q, EETIMAGEMAP) {
		var service = {
			checkImageUrl: checkImageUrl,
			getGroupLogoPath: getGroupLogoPath,
			groupImageExist: groupImageExist
		};

		var baseLogoPath = 'assets/images/groups/';

		return service;

		function isImage(src) {
			var deferred = $q.defer();

			var image = new Image();
			image.onerror = function () {
				deferred.resolve(false);
			};
			image.onload = function () {
				deferred.resolve(true);
			};
			image.src = src;

			return deferred.promise;
		}

		function checkImageUrl(src) {
			return isImage(src);
		}

		function getGroupLogoPath(groupCode) {
			var logoPath = baseLogoPath + groupCode + EETIMAGEMAP[groupCode];
			return logoPath;
		}

		function groupImageExist(groupCode) {
			return $q.resolve(!!EETIMAGEMAP[groupCode]);
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('metaDataReferentielService', MetaDataReferentielService);

	/** @ngInject */
	function MetaDataReferentielService(referentialResource, blockUI) {
		var service = {
			getReferentialById: getReferentialById,
			getReferentialByIdPageable: getReferentialByIdPageable,
			getLinkedValues: getLinkedValues
		};

		return service;

		function cleanFilters(filters) {
			if (angular.isArray(filters)) {
				return filters.filter(function (f) { return f; });
			}

			return filters;
		}

		function getReferentialById(refId, filters, metaDataCode) {
			blockUI.start();
			return referentialResource.getReferentialById({
				id: refId,
				filters: cleanFilters(filters),
				metaDataCode: metaDataCode
			}).$promise.then(function (data) {
				blockUI.stop();
				return data;
			});

		}

		function getReferentialByIdPageable(refId, filters, searchText, metaDataCode, lang, page, size) {
			blockUI.start();
			return referentialResource.getReferentialByIdPageable({
				id: refId,
				filters: cleanFilters(filters),
				searchText: searchText,
				metaDataCode: metaDataCode,
				lang: lang,
				page: page,
				size: size,
			}).$promise.then(function (data) {
				blockUI.stop();
				return data;
			});

		}

		function getLinkedValues(refId, linkedRefId, refValueIds, filters, metaDataCode, searchText) {
			blockUI.start();
			return referentialResource.getLinkedValues({
				refId: refId,
				linkedRefId: linkedRefId,
				filters: cleanFilters(filters),
				metaDataCode: metaDataCode,
				searchText: searchText
			}, refValueIds).$promise.then(function (refList) {
				blockUI.stop();
				return refList;
			});
		}


	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('metadataSystemService', MetadataSystemService);

	/** @ngInject */
	function MetadataSystemService(metadataSystemResource) {
		var service = {
			getSystemFilterValues: getSystemFilterValues
		};
		return service;

		function getSystemFilterValues(filter, mountingRtId) {
			if (filter.automaticMounting) {
				return metadataSystemResource.getMountingSystemFilterValues({ systemMetaCode: filter.metaDataDTO.code, mountingRtId: mountingRtId }).$promise;
			}
			return metadataSystemResource.getMetaSystem(filter).$promise;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('MetadataService', MetadataService);

	/** @ngInject */
	function MetadataService($log, metadataResource, systemResource, blockUI) {
		var service = {
			filterByGroup: filterByGroup,
			isMetaEmpty: isMetaEmpty,
			formatForEditor: formatForEditor,
			getMetaValues: getMetaValues,
			getSystemMetaValue: getSystemMetaValue,
			updateSystemMetaValue: updateSystemMetaValue,
			linkingMetadata: linkingMetadata,
			copyEeSourceMetadata: copyEeSourceMetadata,
			copyHookingMetadata: copyHookingMetadata,
			getValuatedInformationMetaDataInstances: getValuatedInformationMetaDataInstances,
			notSystem: notSystem,
			checkPermission: checkPermission,
			getMetaInstanceListByCodeTee: getMetaInstanceListByCodeTee,
			editMultiple: editMultiple,
			checkIsValueUnique: checkIsValueUnique,
			checkIsAllValuesUnique: checkIsAllValuesUnique,
			getInstantiationMetaToDuplicate: getInstantiationMetaToDuplicate

		};

		return service;

		function getInstantiationMetaToDuplicate(flashId, type) {
			return metadataResource.getInstantiationMetaToDuplicate({ id: flashId, type: type });
		}

		function editMultiple(flashIds, metaDataInstance) {
			return metadataResource.editMultiple({ flashIds: flashIds }, metaDataInstance).$promise.then(function (data) {
				return data;
			});
		}

		function checkPermission(flashIds) {
			return metadataResource.checkPermission({
				flashIds: flashIds
			}).$promise.then(function (data) {
				return data;
			});
		}

		function getMetaInstanceListByCodeTee(codeTee) {
			return metadataResource.getMetaInstanceListByCodeTee({
				codeTee: codeTee
			}).$promise;
		}

		/**
			* check if value in parameter is already or not used in metadata.value
			* @param value
			* @returns true if value is not used yet
			*/
		function checkIsValueUnique(eeFlashId, code, value, productCode) {
			return metadataResource.checkIsValueUnique({
				code: code,
				value: value,
				eeFlashId: eeFlashId,
				productCode: productCode
			}).$promise;
		}

		/**
			* check if all values in parameter are already or not used in metadata.value
			* @param value
			* @returns true if value is not used yet
			*/
		function checkIsAllValuesUnique(eeFlashId, code, values, productCode) {
			return metadataResource.checkIsAllValuesUnique({
				code: code,
				values: values,
				eeFlashId: eeFlashId,
				productCode: productCode
			}).$promise;
		}

		function linkingMetadata(relationTemplateCode, isReferenceNode, eeSourceFlashId) {
			return metadataResource.linkingMetaToCreate({
				relationTemplateCode: relationTemplateCode,
				sourceFlashId: isReferenceNode ? eeSourceFlashId : undefined
			}).$promise.then(function (data) {
				blockUI.stop();
				return data;
			});
		}

		function filterByGroup(metaDataList, userGroup) {
			return _.filter(metaDataList, function (metaData) {
				return metaData.metaDataDTO.metaGroupName === userGroup;
			});
		}

		function getSystemMetaValue(name, editorialObjectId, type) {
			return systemResource.getSystemMetaValue({ name: name, editorialObjectId: editorialObjectId, type: type });
		}

		function updateSystemMetaValue(name, editorialObjectId, type, value) {
			return systemResource.updateSystemMetaValue({ name: name, editorialObjectId: editorialObjectId, type: type, value: value });
		}

		function isMetaEmpty(meta) {
			if ((!meta.value || isBlankString(meta.value)) && (!meta.multiValuesList || _.isEmpty(meta.multiValuesList)) && (!meta.metaDataMultiValuesList || _.isEmpty(meta.metaDataMultiValuesList)) &&
				(!meta.listFiles || _.isEmpty(meta.listFiles)) && (!meta.relationDTOList || _.isEmpty(meta.relationDTOList)) &&
				(!meta.referentialValueDTOList || _.isEmpty(meta.referentialValueDTOList) &&
					(!meta.referentialTypeListDTOList || _.isEmpty(meta.referentialTypeListDTOList)))) {
				return true;
			}

			return false;
		}

		// convert the ECM internal metadata model to a publicly distributed external model used by the editor.
		function formatForEditor(meta) {
			var formattedValues = [];

			meta.forEach(function (entry) {
				var formattedMeta = {};
				formattedMeta.groupname = entry.metaGroupName;
				formattedMeta.metadata = [];
				entry.metaDataInstanceDTOList.forEach(function (instanceDto) {
					var metadataValue = { "name": instanceDto.metaDataDTO.name, "values": getMetaValues(instanceDto) };
					formattedMeta.metadata.push(metadataValue);
				});
				formattedValues.push(formattedMeta);
			});
			return formattedValues;
		}

		function extractMetadataListValues(metadata) {
			var values = [];
			if (metadata.multipleOccurrences) {
				metadata.metaDataMultiValuesList.forEach(function (val) {
					values.push(val.wording);
				});
			}
			else {
				var res = _.find(metadata.metaDataDTO.listMetaDataValues, ['identifier', metadata.value]);
				if (res) {
					values.push(res.wording);
				}
			}

			return values;
		}

		function extractMediaMetadataListValues(metadata) {
			var values = [];
			if (metadata.listMediaFiles) {
				metadata.listMediaFiles.forEach(function (val) {
					values.push(val.customFileName);
				});
			}
			return values;
		}

		//get metadata value(s) from the "multiples" possibilities where looking for.
		function getMetaValues(metadata) {
			var values = [];

			if (metadata) {
				switch (metadata.metaDataDTO.metaDataType) {
					case 'LIST':
						Array.prototype.push.apply(values, extractMetadataListValues(metadata));
						break;
					case 'BOOLEAN':
						if (angular.isUndefined(metadata.value)) {
							metadata.value = 'false';
						}
						values.push(metadata.value);
						break;
					case 'MEDIA':
						Array.prototype.push.apply(values, extractMediaMetadataListValues(metadata));
						break;
					default:
						if (metadata.value) {
							values.push(metadata.value);
						}
						else if (!_.isEmpty(metadata.multiValuesList)) {
							Array.prototype.push.apply(values, _.map(metadata.multiValuesList, function (v) {
								return _.isObject(v) ? v.text : v;
							}));
						}

						else if (metadata.referentialTypeListDTOList && !_.isEmpty(metadata.referentialTypeListDTOList)) {
							_.forEach(metadata.referentialTypeListDTOList, function (val) {
								values.push(val.labelFR);
							});
						}

						else if (metadata.listDisplayPathForNode && !_.isEmpty(metadata.listDisplayPathForNode)) {
							_.forEach(metadata.listDisplayPathForNode, function (obj) {
								_.forOwn(obj, function (value, key) {
									values.push(value);
								});
							});
						}
						else {
							$log.warn("There is an empty metadata : " + metadata.metaDataDTO.name);
						}
						break;
				}
			}
			return values;
		}

		// Check if value is a blank string (value is made up of white spaces)
		function isBlankString(value) {
			return _.isString(value) ? !_.trim(value) : _.isEmpty(value);
		}

		function copyEeSourceMetadata(relationMetadataList, eeSourceDetails) {
			//TR meta data update
			angular.forEach(relationMetadataList, function (trMetaData) {
				if (trMetaData.copyFromTarget) {
					//copy meta data value from target ee ie : eeSource
					//TODO verify cible : EE or EET meta ?
					angular.forEach(eeSourceDetails.metaInstanceList, function (eeCibleMetaData) {
						if (eeCibleMetaData.metaDataDTO.code === trMetaData.metaDataDTO.code) {
							//copy meta data value from target ee ie : eeSource
							trMetaData.value = eeCibleMetaData.value;
						}
					});
				}
			});
			return relationMetadataList;
		}

		function copyHookingMetadata(relationMetadataList, hookingMetadata) {
			for (var i = 0; i < hookingMetadata.length; i++) {
				relationMetadataList.push(hookingMetadata[i]);
			}
			return relationMetadataList;
		}

		function getValuatedInformationMetaDataInstances(flashId) {
			return metadataResource.getValuatedInformationMetaDataInstances({ id: flashId }).$promise;
		}

		function notSystem(metaInstanceList) {
			if (!_.isEmpty(metaInstanceList)) {
				return metaInstanceList.filter(function (el) {
					return !el.metaData.metaSystem;
				});
			}
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('OpenNewTabService', openNewTabService);



	/** @ngInject */
	function openNewTabService($window, $filter, $timeout, htmlPreviewService) {
		var service = {
			openNewTab: openNewTab,
			openXMLTab: openXMLTab,
			openEntityNewTab: openEntityNewTab
		};

		return service;

		function resize(iframe, w) {
			$timeout(function () {
				iframe.height(iframe[0].contentWindow.document.body.scrollHeight + 'px');
				angular.element(w.document.body).css('margin', 0);
			}, 50);
		}


		function createCloseButton(windowObject) {
			var label = $filter('translate')('entity.action.exit');

			var button = windowObject.document.createElement('button');
			button.textContent = label;
			button.onclick = function () {
				windowObject.close();
			};

			return button;
		}

		/**
		 * Apply break page in preview used when bulk print
		 * @param htmlContent html content og the pee previews
		 * @returns {*}
		 */
		function applyBreakPageToHtmlPreview(htmlContent) {
			return htmlContent.replace(/(["'])ecm_metadata(["'])/g, '"ecm_metadata" style="page-break-before: always;"');
		}

		function openNewTab(content, window, addBreakPage) {

			var w = window ? window : $window.open();

			var button = '<button class="no-print button" style="text-align:right;" onClick="window.print()" >Imprimer</button>';
			var iframe = angular.element('<iframe scrolling="no" style="border:0;width: 100%;overflow: hidden;vertical-align:top;height:0"></iframe>');

			angular.element(w.document.body).append(iframe);

			if (addBreakPage) {
				//to force break page between ee preview when print
				content = applyBreakPageToHtmlPreview(content);
			}

			var idoc = iframe[0].contentWindow.document;
			idoc.open();
			idoc.write(content ? content : '');
			idoc.close();

			var body = iframe.contents().find('body');
			htmlPreviewService.updateHref(body, location.origin);
			body.prepend(button);
			body.prepend('&nbsp;');
			body.prepend(createCloseButton(w));

			iframe.contents().find('head').append('<style>@media print{.no-print, .no-print * {  display: none !important; }} </style>');
			angular.element(w.document).find("head").append('<style>@media print{.no-print, .no-print * {  display: none !important; }} </style>');

			resize(iframe, w);
			body.imagesLoaded(function () {
				resize(iframe, w);
			});
		}

		function openXMLTab(content) {
			var w = $window.open();
			w.document.body.textContent = content;
			// $window.open("data:text/xml;charset=utf-8," + content, "", "_blank");
		}

		function openEntityNewTab(flashId) {
			$window.open('#/editorialEntity/' + flashId, '_blank');
		}

	}

})();

(function () {
	'use strict';
	angular.module('userApp').factory('pageTitleService', PageTitleService);

	/** @ngInject */
	function PageTitleService($translate, $window) {
		var service = {
			update: update
		};
		return service;

		function update(titleKey, paramsKey) {
			$translate(titleKey || 'global.title', paramsKey).then(
				function (title) {
					$window.document.title = title;
				});
		}
	}
})();

(function () {
	'use strict';


	/**
	 * Common service used to show a confirm pop up with the appropriate messages.
	 */

	angular
		.module('userApp')
		.factory('relationshipTemplateWizardService', RelationshipTemplateWizardService);



	/** @ngInject */
	function RelationshipTemplateWizardService($q, relationResource, $sce) {
		var service = {
			calculateRelationshipTemplateBreadcrumb: calculateRelationshipTemplateBreadcrumb,
			removePreviousStepFromTemplateRelationshipStepsHistory: removePreviousStepFromTemplateRelationshipStepsHistory,
			updateTemplateRelationshipStepsHistory: updateTemplateRelationshipStepsHistory,
			initRelations: initRelations,
			initReferenceNodes: initReferenceNodes
		};

		return service;

		//Calculate relationship template breadcrumb
		function calculateRelationshipTemplateBreadcrumb(rtStepElementsSelected) {
			var rtBreadcrumb = '';
			_.forEach(rtStepElementsSelected, function (rtStepElement) {
				if (angular.isDefined(rtStepElement.trElementName) && rtStepElement.trElementName !== '')
					rtBreadcrumb += ' > ' + $sce.trustAsHtml(rtStepElement.trElementName);
			});
			return rtBreadcrumb;
		}

		//Remove last step and also previous automatic ones (step with flag accessStep === false) from wizard passed steps history
		function removePreviousStepFromTemplateRelationshipStepsHistory(rtStepElementsSelected) {

			var lastStep = rtStepElementsSelected[length - 1];
			//Remove last step from wizard passed steps history
			if (rtStepElementsSelected.length > 0) {
				rtStepElementsSelected.pop();
			}
			if (lastStep && !lastStep.accessStep && rtStepElementsSelected.length > 0) {
				var exist;
				//Remove all last automatic steps (with accessStep === false) from wizard passed steps history
				do {
					var step = rtStepElementsSelected[rtStepElementsSelected.length - 1];
					if (!step.accessStep) {
						rtStepElementsSelected.pop();
						exist = false;
					} else {
						exist = true;
					}
				} while (rtStepElementsSelected.length > 0 && !exist && rtStepElementsSelected[rtStepElementsSelected.length - 1].accessStep);
			}

			return rtStepElementsSelected;
		}
		function updateTemplateRelationshipStepsHistory(rtStepElementsSelected, stepId, trElementName, accessedStep) {

			//remove old element with some step if from steps history
			_.remove(rtStepElementsSelected, function (trElement) {
				return trElement.id === stepId;
			});

			//add new element to steps history
			rtStepElementsSelected.push({
				id: stepId,
				trElementName: trElementName,
				accessStep: accessedStep
			});

			return rtStepElementsSelected;
		}

		//Methods shared with step 4
		function initReferenceNodes(eeSourceDetails, subElementDetails, relations) {
			//Reference node initialisation
			var parentId = null;
			var displayOrder = null;
			var referenceNodes = [];
			var referenceNode = {};
			if (angular.isDefined(subElementDetails) && subElementDetails !== null && angular.isDefined(subElementDetails.type)) {
				switch (subElementDetails.type) {
					case 'STRUCTURAL':
						parentId = subElementDetails.id;
						//add as last sub element.
						displayOrder = subElementDetails.subNodesId !== null ? subElementDetails.subNodesId.length : 0;
						break;
					case 'REFERENCE':
					case 'CONTENT':
					case 'QUERY':
						parentId = angular.isDefined(subElementDetails.parentNode()) ? subElementDetails.parentNode().id : eeSourceDetails.flashId;
						displayOrder = subElementDetails.displayOrder + 1;
						break;
				}
			} else {
				//Tree ee without structural sub nodes
				parentId = eeSourceDetails.flashId;
				displayOrder = eeSourceDetails.subNodesId !== null ? eeSourceDetails.subNodesId.length : 0;
			}
			//Iterate over the relation
			angular.forEach(relations, function (relation) {
				referenceNode = {};
				//
				referenceNode = {
					id: null,
					status: null,
					pathStr: null,
					title: null,
					type: 'REFERENCE',
					path: angular.isDefined(subElementDetails) && subElementDetails !== null ? subElementDetails.path : [eeSourceDetails.flashId],
					parent: parentId,
					idsXMLFirst: [],
					linksId: [],
					metaInstanceDTOList: [],
					nodeQuery: null,
					refNodeId: relation.eeTargetFlashId,
					subNodesId: [],
					subElements: [],
					xmlContent: null,
					htmlPreview: null,
					displayOrder: angular.copy(displayOrder),
					relationDTO: relation,
					grayDisplay: false
				};
				displayOrder++;
				referenceNodes.push(referenceNode);
			});
			return referenceNodes;
		}

		function initRelations(targetEntities, relationTemplateDetails, relationMetaDatasList, eeSourceDetails, multiRelation, desiredPublicationDate, evaluateVerbalization, createdFromReferenceNode, subElementEeTargetFlashId) {
			//
			var relations = [];
			var relation = {};
			var eeTargetSystemTitle = null;
			var eeTargetSystemVersionMaj = null;
			var eeTargetSystemVersionMin = null;
			var eeTargetStepVersion = null;
			//Iterate over the target ees
			angular.forEach(targetEntities, function (targetEe) {
				relation = {};
				//system title & versions (do not init system title when create and hook as on creation totle is empty)
				if (angular.isDefined(targetEe.system)) {
					eeTargetSystemTitle = targetEe.system.systemTitle;
					eeTargetSystemVersionMaj = targetEe.system.systemVersionMaj;
					eeTargetSystemVersionMin = targetEe.system.systemVersionMin;
					eeTargetStepVersion = targetEe.system.systemVersionPatch;
				}

				//init verbalization
				var verbalisation = null;
				if (evaluateVerbalization) {
					angular.forEach(targetEe.metaInstanceList, function (metaInstance) {
						if (angular.equals(metaInstance.metaDataDTO.name, "systemVerbalization")) {
							verbalisation = metaInstance.value ||
								_.map(metaInstance.multiValuesList, function (v) {
									return v.text;
								});
						}
					});
				}
				relation = {
					trCode: relationTemplateDetails.code,
					eeTargetFlashId: targetEe.flashId,
					wording: eeTargetSystemTitle,
					eeTargetCode: targetEe.eetCode,
					metaInstanceDTOList: angular.copy(relationMetaDatasList),
					deleted: false,
					display: targetEe.display,
					containerSources: targetEe.containerSources ? targetEe.containerSources : null,
					eeTargetVersionMaj: eeTargetSystemVersionMaj,
					eeTargetVersionMin: eeTargetSystemVersionMin,
					eeTargetStepVersion: eeTargetStepVersion,
					desiredPublicationDate: multiRelation ? desiredPublicationDate : targetEe.desiredPublicationDate,
					verbalization: verbalisation,
					createdFromReferenceNode: angular.isDefined(createdFromReferenceNode) ? createdFromReferenceNode : null,
					subElementEeTargetFlashId: angular.isDefined(subElementEeTargetFlashId) ? subElementEeTargetFlashId : null
				};
				//Add to relations list
				if (angular.isDefined(eeSourceDetails) && angular.isDefined(eeSourceDetails.flashId)) {
					relation.eeSourceFlashId = eeSourceDetails.flashId;
				}
				relations.push(relation);
			});
			return relations;
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('stringUtil', StringUtil);


	/** @ngInject */
	function StringUtil() {
		var service = {
			noAccent: noAccent,
			hasAccent: hasAccent,
			contains: contains
		};

		var alphabet = { 'à': 'a', 'â': 'a', 'ç': 'c', 'é': 'e', 'è': 'e', 'ê': 'e', 'î': 'i', 'ô': 'o', 'ù': 'u' };

		return service;

		function noAccent(str) {
			if (str) {
				str = str.replace(/[àâçéèêîôù]/gi, function (letter) {
					return alphabet[letter];
				});
			}
			return str;
		}

		function hasAccent(str) {
			if (str) {
				for (var i in str) {
					if (alphabet[str[i]]) {
						return true;
					}
				}
			}
			return false;
		}

		function contains(str, text) {
			if (str && text) {
				var noAccentStr = _.toLower(noAccent(str));
				var noAccentText = _.toLower(noAccent(text));

				return noAccentStr.includes(noAccentText);
			}

			return true;
		}
	}

}

)();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('userPreferenceService', UserPreferenceService);

	/** @ngInject */
	function UserPreferenceService(localStorageService, USER_PREFERENCE) {
		var service = {
			getUserPaginationPreference: getUserPaginationPreference,
			setUserPaginationPreference: setUserPaginationPreference,
			getUserTreeViewPreference: getUserTreeViewPreference,
			setUserTreeViewPreference: setUserTreeViewPreference,
			getUserTablePreference: getUserTablePreference,
			setUserTablePreference: setUserTablePreference,
			getUserFacetPreference: getUserFacetPreference,
			setUserFacetPreference: setUserFacetPreference,
			getUserGlobalPreference: getUserGlobalPreference,
			setUserGlobalPreference: setUserGlobalPreference,
			removeFromUserGlobalPreference: removeFromUserGlobalPreference,
			removeFromUserTablePreference:removeFromUserTablePreference
			//	addConfigLocalStrorage: addConfigLocalStrorage
		};
		return service;

		/** API */
		function getUserPaginationPreference(preferenceStorageKey, defaultValue) {
			return get(USER_PREFERENCE.pagination.storageKey, preferenceStorageKey, defaultValue ? defaultValue : 50);
		}

		function setUserPaginationPreference(preferenceStorageKey, data) {
			set(USER_PREFERENCE.pagination.storageKey, preferenceStorageKey, data);
		}

		function getUserTreeViewPreference(preferenceStorageKey, defaultValue) {
			return get(USER_PREFERENCE.treeView.storageKey, preferenceStorageKey, defaultValue);
		}

		function setUserTreeViewPreference(preferenceStorageKey, data) {
			set(USER_PREFERENCE.treeView.storageKey, preferenceStorageKey, data);
		}

		function getUserTablePreference(preferenceStorageKey) {
			return get(USER_PREFERENCE.table.storageKey, preferenceStorageKey, null);
		}

		function setUserTablePreference(preferenceStorageKey, data) {
			set(USER_PREFERENCE.table.storageKey, preferenceStorageKey, data);
		}

		function getUserFacetPreference(preferenceStorageKey) {
			return get(USER_PREFERENCE.facet.storageKey, preferenceStorageKey, {});
		}

		function setUserFacetPreference(preferenceStorageKey, data) {
			set(USER_PREFERENCE.facet.storageKey, preferenceStorageKey, data);
		}

		function getUserGlobalPreference(preferenceStorageKey, defaultValue) {
			return get(USER_PREFERENCE.global.storageKey, preferenceStorageKey, defaultValue);
		}

		function setUserGlobalPreference(preferenceStorageKey, data) {
			set(USER_PREFERENCE.global.storageKey, preferenceStorageKey, data);
		}

		function removeFromUserGlobalPreference(preferenceStorageKey) {
			remove(USER_PREFERENCE.global.storageKey, preferenceStorageKey);
		}

		function removeFromUserTablePreference(preferenceStorageKey) {
			remove(USER_PREFERENCE.table.storageKey, preferenceStorageKey);
		}
		function set(storageKey, preferenceStorageKey, data) {
			var settings = localStorageService.get(storageKey) || {};
			settings[preferenceStorageKey] = data;
			localStorageService.set(storageKey, settings);

		}

		function get(storageKey, preferenceStorageKey, defaultValue) {
			var settings = localStorageService.get(storageKey);
			if (settings && settings[preferenceStorageKey]) {
				return settings[preferenceStorageKey];
			}
			//Default value.
			return defaultValue;
		}

		function remove(storageKey, preferenceStorageKey) {
			var settings = localStorageService.get(storageKey) || {};
			delete settings[preferenceStorageKey];
			localStorageService.set(storageKey, settings);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('versioningService', VersioningService);

	/** @ngInject */
	function VersioningService(versioningResource) {
		var service = {
			getVersions: getVersions
		};

		return service;

		function getVersions(flashId) {
			return versioningResource.getAvailableVersion({ flashId: flashId }).$promise;
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('ecmSidebar', {
			transclude: true,
			templateUrl: 'scripts/pre-upgrade/components/commons/sidebar/ecm-sidebar.tpl.html',
			controller: EcmSidebarController,
			bindings: {
				isOpen: '<',
				allowClose: '<',
				onClose: '&',
				contentClass: '@?'
			},
		});

	/** @ngInject */
	function EcmSidebarController($scope, $element, $timeout) {
		var ctrl = this;

		var defaultWidth = 600;
		var defaultMinWidth = 300;
		var defaultMaxWidth = angular.element(window).width() - 300;
		var resizing = false;

		ctrl.width = defaultWidth;
		ctrl.minWidth = defaultMinWidth;
		ctrl.maxWidth = defaultMaxWidth;
		//ctrl.isOpen = false;
		////////////////

		ctrl.$onInit = function () { };
		ctrl.$onChanges = function (changesObj) {
			if (changesObj.isOpen) {
				if (!changesObj.isOpen.currentValue) {
					ctrl.close();
				}
			}
		};
		ctrl.$onDestroy = function () { };

		ctrl.rightSize = function () {
			return '-' + ctrl.width;
		};

		ctrl.startResize = function (e) {
			angular.element(window).on('mousemove', onResize);
			ctrl.currentPageX = e.pageX;

			angular.element(window).on('mouseup', function () {
				angular.element(window).off('mousemove', onResize);
				$timeout(function () {
					ctrl.currentPageX = null;
					resizing = false;
				}, 200);
			});
		};

		ctrl.close = function () {
			if (ctrl.allowClose && !resizing) {
				ctrl.isOpen = false;
				if (angular.isDefined(ctrl.onClose)) {
					ctrl.onClose();
				}
			}
		};

		function onResize(e) {
			e.preventDefault();
			resizing = true;

			var delta = ctrl.currentPageX - e.pageX;
			var newWidth = ctrl.width + delta;
			ctrl.currentPageX = e.pageX;

			// var parent = $element.parent();
			var maxWidth = ctrl.maxWidth;
			// if (parent) {
			// 	maxWidth = parent.width() - 100;
			// }

			if (newWidth > ctrl.minWidth && newWidth < maxWidth) {
				ctrl.width = newWidth;
				$scope.$apply();
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('textAreaWithMenu', {
			templateUrl: 'scripts/pre-upgrade/components/commons/text-area-with-menu/text-area-with-menu.html',
			controller: TextAreaWithMenu,
			bindings: {
				htmlText: '=',
				showRemainingCharactersHelper: '<',
				maxlength: '<',
				close: '&',
				dismiss: '&'
			}
		});

	/** @ngInject */
	function TextAreaWithMenu($scope) {
		var ctrl = this;

		ctrl.$onInit = function () {
			//ctrl.checkMaxLength();
		};

		ctrl.requiredValidation = function () {
			return !_.isUndefined(ctrl.maxlength) && ctrl.maxlength !== 0;
		};

		ctrl.remainingTitleCharacters = function () {
			if (ctrl.requiredValidation()) {
				return angular.isDefined(ctrl.htmlText) && ctrl.htmlText.length > 0 ?
					(ctrl.maxlength - (ctrl.htmlText.replace(/<[^>]+>/g, "")).length) : ctrl.maxlength;
			}
			return 0;
		};

		ctrl.checkMaxLength = function () {
			if (ctrl.requiredValidation()) {
				$scope.$emit("titleMaxLengthViolation", ctrl.remainingTitleCharacters() < 0);
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('tinyMceAddButtonService', TinyMceAddButtonService);


	/** @ngInject */
	function TinyMceAddButtonService(blockUI, $uibModal) {
		var service = {
			addButton: addButton
		};

		return service;

		function addButton(editor) {
			editor.addButton('euro', {
				tooltip: 'euro sign',
				icon: 'euro-outline',
				image: '/editor/img/ic_euro_symbol_black_24px.svg',
				onclick: function () {
					editor.insertContent('€');
				}
			});

		}





	}
})();

'use strict';

angular.module('userApp').directive('plainTextMaxLength', function ($filter, $rootScope) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attributes, ngModel) {

			var maxLength, validPlainTextLength, stripHtmlTags;
			var type = scope.metaDataInstance ? scope.metaDataInstance.metaDataDTO.metaDataType.toLowerCase() : '';
			stripHtmlTags = function (v) {
				return angular.element('<textarea />').html(String(v).replace(/<[^>]+>/gm, '')).text();
			};
			validPlainTextLength = function (v) {
				if (!v || type === 'html') {
					return true;
				}
				$rootScope[attributes.name] = maxLength - stripHtmlTags(v).length;
				return stripHtmlTags(v).length <= maxLength;
			};
			maxLength = void 0;
			scope.$watch(attributes.plainTextMaxLength, function (newValue, oldValue) {
				if (maxLength !== newValue) {
					maxLength = newValue;
					return ngModel.$validate();
				}
			});
			return ngModel.$validators['plainTextMaxLength'] = function (modelValue, viewValue) {
				if (viewValue && viewValue.$$unwrapTrustedValue) { //eslint-disable-line
					return validPlainTextLength(viewValue.$$unwrapTrustedValue());//eslint-disable-line
				} else {
					return validPlainTextLength(viewValue);
				}
			};

		}
	};
});

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('tinyMceLight', {
			templateUrl: 'scripts/pre-upgrade/components/commons/tiny-mce-light/tiny-mce-light.html',
			controller: TinyMceLightController,
			bindings: {
				htmlContent: '=?',
				maxLength: '<?',
				plainTextMaxLength: '<?',
				lang: '<?',
				disabled: '<?',
				tinyRequired: '<?',
				class: '<?',
				onChange: '&?'
			},
		});

	/** @ngInject */
	function TinyMceLightController($rootScope, tinyMceAddButtonService, $timeout) {
		var $ctrl = this;
		////////////////

		$ctrl.$onInit = function () {
			//Init content max length default value.
			if (angular.isUndefined($ctrl.maxLength) || $ctrl.maxLength === null) {
				$ctrl.maxLength = 1000;
			}
			//Init content plain text max length default value.
			if (angular.isUndefined($ctrl.plainTextMaxLength) || $ctrl.plainTextMaxLength === null) {
				$ctrl.plainTextMaxLength = 1000;
			}
			//
			if (angular.isUndefined($ctrl.tinyRequired) || $ctrl.tinyRequired === null) {
				$ctrl.tinyRequired = false;
			}
			//
			if (angular.isUndefined($ctrl.lang) || $ctrl.lang === null) {
				$ctrl.lang = $rootScope.currentLangFull;
			}
			if (angular.isUndefined($ctrl.disabled) || $ctrl.disabled === null) {
				$ctrl.disabled = false;
			}
			if (angular.isUndefined($ctrl.htmlContent) || $ctrl.htmlContent === null) {
				$ctrl.htmlContent = "";
			}

			//
			$ctrl.tinymceOptions = {
				baseURL: 'editor/js/lib/tinymce/',
				content_style: '.mce-content-body {font-size:12px;}',
				menubar: false,
				toolbar1: 'bold italic underline superscript subscript charmap euro DiagPlWs',
				statusbar: false,
				theme: 'els',
				entity_encoding: "raw",
				plugins: ["charmap", "paste", "DiagPlWs", "visualchars_ms"],
				paste_as_text: true,
				forced_root_block: false,
				setup: function (editor, adapter) {
					$ctrl.currentEditor = editor;
					tinyMceAddButtonService.addButton(editor);
					// we cannot set height < 100 in config ...
					// so we must do this hack
					editor.on('init', function (args) {
						var maxLength = $ctrl.plainTextMaxLength;
						var lineHeight = 22;
						var minHeight = 48;
						var height = 0;

						if (maxLength < 200) {
							height = minHeight;
						}
						else if (maxLength >= 200 && maxLength < 300) {
							height = lineHeight * 3;
						}
						else if (maxLength >= 300 && maxLength < 400) {
							height = lineHeight * 4;
						}
						else if (maxLength >= 400 && maxLength < 500) {
							height = lineHeight * 5;
						}
						else {
							height = lineHeight * 6;
						}

						if (height > 0 && editor && editor.contentWindow && editor.contentWindow.frameElement) {
							editor.contentWindow.frameElement.style.height = height + 'px';
						}
					});

					editor.on('keyup', function (args) {
						adapter.updateView(editor);
					});

					editor.on('Change', function (args) {
						adapter.updateView(editor);
					});
				}
			};
			//$ctrl.tinymceOptions.language_url = 'editor/js/lib/tinymce/langs/' + $ctrl.lang + '.js';
			if ($ctrl.disabled) {
				$ctrl.tinymceOptions.content_style = $ctrl.tinymceOptions.content_style + '.mce-content-body {background-color:#eee}';
			}
		};

		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('tinyMceLightModal', {
			templateUrl: 'scripts/pre-upgrade/components/commons/tiny-mce-light-modal/tiny-mce-light-modal.html',
			controller: tinyMceLightModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function tinyMceLightModalController() {
		var $ctrl = this;

		// save
		$ctrl.save = function () {
			$ctrl.close({ $value: $ctrl.htmlContent });
		};
		//cancel
		$ctrl.cancel = function () {
			$ctrl.dismiss();
		};
		////////////////

		$ctrl.$onInit = function () {

			$ctrl.htmlContent = $ctrl.resolve.htmlContent;
			$ctrl.maxLength = $ctrl.resolve.maxLength;
			$ctrl.required = $ctrl.resolve.required;
			$ctrl.lang = $ctrl.resolve.lang;
		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('TinyMceLightModalService', TinyMceLightModalService);


	/** @ngInject */
	function TinyMceLightModalService(blockUI, $uibModal) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal(htmlContent, maxLength, lang, required) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'tinyMceLightModal',
				resolve: {
					htmlContent: function () {
						return htmlContent;
					},
					maxLength: function () {
						return maxLength;
					},
					lang: function () {
						return lang;
					},
					required: function () {
						return required;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('tinymcelight');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
			return modalInstance;
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('multiEditorMain', {
			templateUrl: 'scripts/pre-upgrade/components/editor/multi-editor/multi-editor-main.html',
			controller: MultiEditorMainController,
			bindings: {
				editorialEntity: "<",
				mainEntityId: '<',
				currentUser: '<'
			},
		});

	/** @ngInject */
	function MultiEditorMainController($scope, $filter, $document, $element, $timeout, entityLockResource, entityAuthorizeService) {
		var ctrl = this;
		////////////////

		ctrl.$onInit = function () {
			ctrl.contententDisplay = {
				rightMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedRigthMargin'),
				leftMargin: $filter('translate')('userApp.editorialEntity.display.content.fixedLeftMargin'),
			};
		};

		$scope.$on('test', function (e, message) {
			$timeout(function () {
				$scope.$broadcast('ecm-treeview', { operation: 'refreshNode', data: message });
			}, 1000);
		});
		$scope.$on('click-ee-from-multi-editor-view', function (e, message) {
			ctrl.subEditorialEntityId = message;
			ctrl.subEditorialEntityData = {};

			entityLockResource.padlock({
				flashId: ctrl.subEditorialEntityId
			}).$promise
				.then(function (dto) {
					ctrl.subEditorialEntityData.padlock = dto.padlock;
				});

			entityAuthorizeService.permissionsDTO(ctrl.subEditorialEntityId)
				.then(function (permissionsDTO) {
					ctrl.subEditorialEntityData.isEditable = entityAuthorizeService.isEditContentEnabled(permissionsDTO.permissions)
						|| entityAuthorizeService.isInitAndEditContentEnabled(permissionsDTO.permissions);
				});
		});


		ctrl.$onChanges = function (changesObj) { };

		var onResize = function (e) {
			e.preventDefault();
			var winWidth = angular.element(window).width();
			var moveX = winWidth - e.pageX - 20;
			if (moveX > ctrl.contententDisplay.leftMargin) {
				moveX = $scope.leftMargin;
			}

			if (moveX < ctrl.contententDisplay.rightMargin) {
				moveX = $scope.rightMargin;
			}
			angular.element('#idDivContenu').css({
				'flex-basis': moveX
			});
			$scope.$apply();
		};

		$document.on('mouseup', function () {
			$document.off('mousemove', onResize);
		});

		ctrl.mdDragBar = function (e) {
			$document.on('mousemove', onResize);
		};

		ctrl.showMetaData = function (show) {
			ctrl.showNodesMetaData = show;
		};

		ctrl.nodeSelection = function (node) {
			$scope.$broadcast('from-multieditor-main',
				{ operation: 'move', data: node.flashId });
		};

		ctrl.$onDestroy = function () { };

		ctrl.editInline = function () {
			if (ctrl.subEditorialEntityData.isEditable) {
				$scope.$broadcast('from-multieditor-main', { operation: 'edit' });
			}
		};
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('multiEditorView', {
			templateUrl: 'scripts/pre-upgrade/components/editor/multi-editor/multi-editor-view.html',
			controller: multiEditorViewController,
			bindings: {
				mainEntityId: '<',
				currentUser: '<'
			},
		});

	/** @ngInject */
	function multiEditorViewController($window, $scope, $filter, $document, $element, htmlPreviewService, HTML_PREVIEW_TYPE, $sce, $timeout, $rootScope, entityAuthorizeService, entityFetchResource, workflowHistoryResource, blockUI) {
		var ctrl = this;
		////////////////

		var actionBarSelector = '#multieditor-action-bar';

		ctrl.iframeScope = $window.parent.angular.element($window.frameElement).scope();

		ctrl.emit = function () {
			ctrl.iframeScope.$emit.apply(ctrl.iframeScope, arguments);
			ctrl.iframeScope.$apply();
		};

		ctrl.parentListener = ctrl.iframeScope.$on('from-multieditor-main', function (e, message) {
			switch (message.operation) {
				case 'move':
					ctrl.moveTo(message.data);
					break;
				case 'edit':
					ctrl.editInline();
					break;

				default:
					break;
			}
		});

		ctrl.editorLoaded = false;
		ctrl.entityEditedId = '';

		ctrl.currentEntityElement;
		ctrl.ecmInlineEditorElement;

		function getEntityIdFromElement(element) {
			//var el = angular.element(element).children("[class='htmlProofing-text-infos']").children()[1].innerText.split(':')[1].trim();
			var el = angular.element(element).attr('id');
			return el;
		}

		ctrl.$onInit = function () {
			// Temp solution we need to create a separate view for css
			var appCss = $document.find("head link[href='app/index.css'],head link[href^='assets/styles/app']");
			appCss.remove();

			//$document.find('head').append('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">');

			ctrl.ecmInlineEditorElement = $element.find('ecm-inline-editor');

			htmlPreviewService.getProofReadingPreview(ctrl.mainEntityId, 'ENTITY').then(function (html) {
				ctrl.source = $sce.trustAsHtml(html);

				$timeout(function () {
					ctrl.bindEvents();
				});
			});
		};

		ctrl.bindEvents = function () {
			var hiddeToolbarStatus = {
				engaged: false,
				timeoutPromise: null
			};

			/*
				Delay to hide the floating action bar from the moment we scroll the preview.
				This timeout is meant to be cleared if the mouse enters the action bar.
			*/
			var hideActionBarDelay = 1000;

			var refNodes = $element.find("[class='editorialEntity']");
			refNodes.click(function (event) {

				ctrl.entityEditedId = getEntityIdFromElement(this);
				ctrl.currentEntityElement = this;

				ctrl.emit('click-ee-from-multi-editor-view', ctrl.entityEditedId);

				positionMiniToolbar(event);

			});

			$window.addEventListener('scroll', function (event) {
				if (!hiddeToolbarStatus.engaged) {
					hiddeToolbarStatus.timeoutPromise = $timeout(hideMiniToolbar, hideActionBarDelay);
					hiddeToolbarStatus.engaged = true;
				}
			});

			var actionBar = $window.parent.angular.element(actionBarSelector);
			actionBar.mouseenter(function (event) {
				if (hiddeToolbarStatus.engaged) {
					$timeout.cancel(hiddeToolbarStatus.timeoutPromise);
					hiddeToolbarStatus.engaged = false;
				}
			});
		};

		/**
			Position the "mini toolbar" in front of the "multi-editor-view" iframe,
			over the clicked point.
		*/
		function positionMiniToolbar(event) {
			var positionInsideFrame = [event.clientX, event.clientY];
			var iframeRect = $window.parent.angular.element($window.frameElement)[0].getBoundingClientRect();
			var iframePosition = [iframeRect.left, iframeRect.top];

			var targetPosition = [
				positionInsideFrame[0] + iframePosition[0],
				positionInsideFrame[1] + iframePosition[1]
			];


			var actionBar = $window.parent.angular.element(actionBarSelector);
			var actionBarWith = actionBar[0].getBoundingClientRect().width;
			actionBar.css('left', (targetPosition[0] - actionBarWith / 2)).css('top', targetPosition[1]);

			actionBar.removeClass('hidden');
		}

		function hideMiniToolbar() {
			var actionBar = $window.parent.angular.element(actionBarSelector);
			actionBar.addClass('hidden');
		}

		ctrl.editInline = function () {
			if (!ctrl.editorLoaded) {
				blockUI.start();

				hideMiniToolbar();

				entityAuthorizeService.permissions(ctrl.entityEditedId).then(function (permissions) {
					if (entityAuthorizeService.isInitWorkflowUpdateEnabled(permissions)) {
						return ctrl.openWorkflowModal().then(function () {
							ctrl.showEditor(ctrl.currentEntityElement);
						});
					}
					else {
						ctrl.showEditor(ctrl.currentEntityElement);
					}

				}).finally(function () { blockUI.stop(); });
			}
		};

		$scope.$on("editor_refreshed", function (e, message) {
			//specific code for current preview
			var container = angular.element(ctrl.currentEntityElement).children("[class='htmlProofing-text-container']").first();
			var height = container.height();
			container.css('min-height', height + 'px');
			ctrl.editorHeight = height > 400 ? height : 400;
			if (container.length > 0) {
				container.html(ctrl.ecmInlineEditorElement);
			} else {
				angular.element(ctrl.currentEntityElement).append("<div class='htmlProofing-text-container'>");
				container = angular.element(ctrl.currentEntityElement).children("[class='htmlProofing-text-container']");
				container.html(ctrl.ecmInlineEditorElement);
			}
		});

		ctrl.showEditor = function (entityElement) {
			$rootScope.$broadcast("refresh_editor");
		};

		ctrl.outsideEditorClick = function (e) {
			if (ctrl.editorLoaded && !angular.element(e.target).closest('a').length) {
				if ($window.confirm($filter('translate')('userApp.editor.inline.confirmExit'))) {
					ctrl.saveCurrentEditorContent();
				}
			}
		};

		ctrl.saveCurrentEditorContent = function () {
			blockUI.start();
			var content = ctrl.contentAdapter.getCleanedContent();
			ctrl.contentAdapter.saveContentWithoutValidation(content).then(function () {

				// call preview
				return ctrl.endWorkflow().then(function () {
					return htmlPreviewService.getPreview(ctrl.entityEditedId, HTML_PREVIEW_TYPE.restricted)
						.then(function (eePreviewHtml) {
							var container = angular.element(ctrl.currentEntityElement).children("[class='htmlProofing-text-container']");

							content = angular.element('<div class="ecm_content">').append(eePreviewHtml.htmlPreview);
							var test = content.find('.erm-version');
							if (test.length > 0) {
								test.remove();
							}
							container.append(content);

							var nodeId = container.parents('.referenceNode').first().attr('id');
							container.css('min-height', '');
							ctrl.emit('test', nodeId);
						});
				});

			}).finally(function () {
				ctrl.editorLoaded = false;
				blockUI.stop();
			});
		};

		ctrl.endWorkflow = function () {
			return entityFetchResource.getByFlashId({ flashId: ctrl.entityEditedId }).$promise.then(function (entity) {
				var finalStep = _.find(entity.workFlowHistoryDTO.stepsDTO, { 'finalStatus': true });
				entity.workFlowHistoryDTO.selectedStep = finalStep;
				return workflowHistoryResource.changeStepWorkFlow(entity.workFlowHistoryDTO).$promise.then(function (wfData) {
					if (wfData.validationReportDTO && !wfData.validationReportDTO.validEE) {
						return workflowHistoryResource.warningWorkFlow(wfData).$promise;
					}
					return workflowHistoryResource.closeWorkFlow(wfData).$promise;
				});
				//return editWorkflowModalService.saveWorkflow(entity);
			});
		};

		ctrl.openWorkflowModal = function () {
			return entityFetchResource.getByFlashId({
				flashId: ctrl.entityEditedId
			}).$promise
				.then(function (entity) {
					return workflowHistoryResource.initWFUpdate(entity.workflowInstanceDTO).$promise;
				});
		};

		ctrl.setContentAdapter = function (adapter) {
			ctrl.contentAdapter = adapter;
		};

		ctrl.moveTo = function (id) {
			angular.element([$document.documentElement, $document.body]).animate({
				scrollTop: angular.element("#" + id).offset().top
			}, 500);
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () {
			if (ctrl.parentListener) {
				ctrl.parentListener();
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('multiEditorView', {
				parent: 'connect',
				url: '/multieditorview/:id',
				component: 'multiEditorView',
				resolve: {
					mainEntityId: function ($stateParams) { return $stateParams.id; },
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					mainTranslatePartialLoader: ['$translate',
						'$translatePartialLoader',
						function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('main');
							$translatePartialLoader.addPart('editor');
							return $translate.refresh();
						}]
				}
			}).state('editorialEntity.multiEditorMain', {
				url: '/multieditor',
				views: {
					'editorialEntityContent': {
						component: 'multiEditorMain'
					}
				},
				resolve: {
					mainEntityId: function ($stateParams) { return $stateParams.id; },
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					mainTranslatePartialLoader: ['$translate',
						'$translatePartialLoader',
						function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('main');
							return $translate.refresh();
						}]
				}
			});
	}

})();

(function () {
	'use strict';
	/*global msed*/

	angular.module('userApp').component("ecmEditorWrapper", {
		templateUrl: 'scripts/pre-upgrade/components/editor/components/ecm-editor-wrapper.component.html',
		controller: ecmEditorWrapperController,
		bindings: {
			saveIntervals: "<",
			author: "<",
			prolexisWsUrl: "<",
			entityEdited: "<",
			eeId: '<',
			subId: '<',
			config: '@',
			cssMode: '<?',
			setAdapter: '&?',
			inline: '<?',
			productCode: '<?',
			editorHeight: '<?',
			embededInProofing: '<?'
		}

	});

	/** @ngInject */
	function ecmEditorWrapperController($scope, $location, $window, editorMetadataService, editorLinkService, editorSaveService, editorValidationService, editorMediaService, editorMacroService, editorTableTemplateService, urlService, editorWordService, $q) {

		$window.msed = {};

		var ctrl = this;
		var entityEdited = ctrl.entityEdited;
		var author = ctrl.author;
		var prolexisWsUrl = ctrl.prolexisWsUrl;

		//the root edited Editorial entity ID
		entityEdited.eeId = ctrl.eeId;
		entityEdited.subid = ctrl.subId;

		// Unique ID for TinyMCE Editor instance
		var TINY_ID_PREFIX = 'tinyel';
		ctrl.editorUniqueID = generateEditorUniqueID(ctrl.eeId);

		ctrl.editorConfiguration = getEditorConfiguration(entityEdited);

		//the DTO use to save the editor's raw html content
		ctrl.rawHtmlDTO = {
			"id": ctrl.eeId,
			"subid": ctrl.subId,
			"status": entityEdited.editionStatus,
			"rawContent": entityEdited.htmlContent || entityEdited.error,
			"inline": ctrl.inline,
			"readOnly": entityEdited.readOnly
		};

		ctrl.setAdapterInternal = function (adapter) {
			if (adapter) {
				ctrl.augmentedAdapter = Object.assign(adapter, {
					saveContent: saveContent,
					saveContentWithoutValidation: saveContentWithoutValidation,
					validateHtmlContent: function (content, scenario) {
						return validateHtmlContent(content, scenario).then(function (data) {
							// V1
							if (data.error) {
								var errors = data.error.split('\n');
								var result = errors.map(function (error) {
									var e = error.split('error:');
									return { line: e[0], error: e[1] };
								});
								return result;
							}
							// V2
							else if (data['validation-reports']) {
								var reports = data['validation-reports'];
								var resultV2 = _.flatMap(reports, function (report) {
									return report.reports.map(function (r) {
										return { line: r.line, error: r.message[0].text };
									});
								});
								return resultV2;
							}
							return {};
						});
					}
				});
			}
			if (ctrl.setAdapter) {
				ctrl.setAdapter({ adapter: ctrl.augmentedAdapter });
			}
		};

		//Update metadata displayed in the editor after modification
		$scope.$on('update_metadata_success', function () {
			if (ctrl.augmentedAdapter) {
				ctrl.augmentedAdapter.displayMetadata();
			}
		});

		/*
		 validate editor HTML content.
		 */
		function validateHtmlContent(content, scenario) {
			ctrl.rawHtmlDTO.rawContent = content;
			return editorValidationService.validateHtmlContent(ctrl.rawHtmlDTO, scenario);
		}

		/*
		 save editor HTML content on an user'action (even if the content is not valid).
		 */
		function saveContent(content) {
			ctrl.rawHtmlDTO.rawContent = content;
			return editorSaveService.saveRawContent(ctrl.rawHtmlDTO);
		}

		/*
		 automatic editor HTML content backup, executed in background, without any validation.
		 */
		function saveContentAuto(content) {
			ctrl.rawHtmlDTO.rawContent = content;
			return editorSaveService.saveRawContentAuto(ctrl.rawHtmlDTO);
		}

		/*
	end editorial entity edition on an user'action for inline editor
	*/
		function saveContentWithoutValidation(content, saveAndContinue) {
			ctrl.rawHtmlDTO.rawContent = content;
			ctrl.rawHtmlDTO.overwrite = true;
			return editorSaveService.saveContentWithoutValidation(ctrl.rawHtmlDTO, saveAndContinue).then(function (result) {
				if (result && result.status) {
					ctrl.rawHtmlDTO.status = result.status;
				}
			});
		}

		/*
		 end editorial entity edition on an user'action
		 */
		function saveAndCloseContent(content, overwrite) {
			ctrl.rawHtmlDTO.rawContent = content;
			ctrl.rawHtmlDTO.overwrite = overwrite;
			return editorSaveService.saveContent(ctrl.rawHtmlDTO, ctrl.editorUniqueID);
		}

		function getTargetLinkWithFragment(eeId, tr, fragment) {
			return editorLinkService.getTargetLinkWithFragment(eeId, tr, fragment);
		}

		function listMacros(id_doc) {
			return editorMacroService.getMacroList(id_doc);
		}

		function applyMacro(key, id_doc, htmlContent) {
			return editorMacroService.applyMacro(key, id_doc, htmlContent);
		}

		function wordPasteTransformation(id_doc, wordContent) {
			return editorWordService.wordPasteTransformation(id_doc, wordContent);
		}

		/*
		 instanciate an object from editor's configuration from server's data received.
		 */
		function getEditorConfiguration() {

			return {
				configType: ctrl.config,
				saveIntervals: ctrl.saveIntervals,
				auteur: author.login,
				prolexisWsUrl: prolexisWsUrl,
				tinyMceBaseUrl: 'editor/js/lib/tinymce/',
				baseUrl: '/#/editorialEntity/',
				baseHost: _.trimEnd($location.absUrl().split('#')[0], '/'),
				static_path: "/editor/",
				entityTemplateCode: entityEdited.entityTemplateCode,

				// Used by editor to define some events listeners (scroll, etc.)
				containerElement: angular.element('ecm-editor-wrapper').parents('div.modal')[0],

				//inside-proofing edition for trees (SIETRAINPR-1543)
				isEmbededInProofing: ctrl.embededInProofing,


				//extension for metadata
				getMeta: editorMetadataService.getMeta,
				openEditMetaModal: editorMetadataService.openEditMetaModal,
				getInfoMeta: editorMetadataService.getInfoMeta,

				//extension for save
				saveContent: saveContent,
				saveContentAuto: saveContentAuto,
				saveAndCloseContent: saveAndCloseContent,

				//extension for validation
				validateHtmlContent: validateHtmlContent,

				//extension for linking
				getTargetLinkWithFragment: getTargetLinkWithFragment,
				openLinkingWizardModal: editorLinkService.openLinkingWizardModal,
				openLinkingIntraWizardModal: editorLinkService.openLinkingIntraWizardModal,

				//extension for media
				listEditorMedia: editorMediaService.listEditorMedia,
				uploadEditorMedia: editorMediaService.uploadEditorMedia,
				createDirectoryForEditorMedia: editorMediaService.createDirectoryForEditorMedia,
				renameMediaFile: editorMediaService.renameMediaFile,
				isExistMedia: editorMediaService.isExistMedia,

				//Macros
				listMacros: listMacros,
				applyMacro: applyMacro,

				// Word Paste
				applyWordPasteTransformation: wordPasteTransformation,

				getTabModels: getTabModels,
				importWordXML: importWordXML,

				validateURL: validateURL,

				editorHeight: ctrl.editorHeight
			};
		}

		function getTabModels(id_doc) {
			if (ctrl.productCode) {
				return editorTableTemplateService.getTableTemplateListByProduct(ctrl.productCode);
			}

			return editorTableTemplateService.getTableTemplateList(id_doc);
		}

		// TODO IMPLEMENT
		function importWordXML(id_doc, file_base64) {
			return $.get("editor/files/data/word_xml_upload.json");
		}

		function validateURL(url) {
			if (!url) {
				return $q.resolve({ "status": "KO" });
			}

			// // SIETRAINT1-889
			// // TEMP FIX BYPASS VALIDATION
			return $q.resolve({ "status": 'OK' });
			// return urlService.checkConnection(url).then(function (result) {
			// 	return result ? { "status": 'OK' } : { "status": 'KO' };
			// });
		}

		/**
		 * Generates a unique ID for TinyMCE Editor Instance used to edit
		 * the main content of an EditorialEntity, based on :
		 * - a shared prefix,
		 * - the FlashID of the EditorialEntity,
		 * - a random suffix
		 * 
		 * @param {string} flashId the FlashID of the EditorialEntity currently edited
		 * @returns A unique ID for Editor instance
		*/
		function generateEditorUniqueID(flashId){
			var SUFFIX_SIZE = 10000;
			var randomSuffix = String(Math.floor(Math.random() * SUFFIX_SIZE));
			var SEPARATOR = '-';

			return [TINY_ID_PREFIX, flashId, randomSuffix].join(SEPARATOR);
		}
	}
})();

(function () {
	'use strict';
	/*global msed*/

	angular.module('userApp').component("ecmInlineEditor", {
		templateUrl: 'scripts/pre-upgrade/components/editor/components/ecm-inline-editor.html',
		controller: EcmInlineEditorComponentController,
		bindings: {
			id: '<',
			subId: '<',
			setAdapter: '&?',
			productCode: '<?',
			loaded: '=',
			loadOnInit: '<?',
			editorHeight: '<?',
			embededInProofing: '<?'
		}

	});

	/** @ngInject */
	function EcmInlineEditorComponentController($q, EditorResource, Principal, defaultSvgDuration, entityEditorService, blockUI, $log, $timeout, $rootScope) {

		var ctrl = this;

		function resolveSaveIntervals() {
			return EditorResource.getTempoSvgAuto().$promise.then(
				function (data) {
					data = angular.fromJson(data);
					data.client_duration = data.client_duration || defaultSvgDuration.client_duration;
					data.server_duration = data.server_duration || defaultSvgDuration.server_duration;
					return data;
				},
				function (error) {
					return defaultSvgDuration;
				});
		}

		function resolveAuthor() {
			return Principal.identity();
		}

		function resolveProlexisWsUrl() {
			return EditorResource.getProlexisWsUrl().$promise.then(
				function (data) {
					return data.url;
				},
				function () { });
		}

		function resolveEntityEdited(entityId, modelId) {
			blockUI.start();
			var ee_id = entityId;
			return EditorResource.startEdition({
				id: ee_id
			}).$promise.then(
				function (response) {
					blockUI.stop();
					if (modelId === 'NOMODEL') {
						response.htmlContent = "";
					}
					if (response.forceEdition !== true && response.editionStatus === "TECHNICAL_ERROR" ||
						response.forceEdition !== true && response.editionStatus === "INVALID") {
						var result = {};
						result.editionStatus = response.editionStatus;
						result.error = response.error;
						result.id = ee_id;
						entityEditorService.errorXmlToHtmlModal(result);
						blockUI.stop();
						ctrl.valid = false;
						throw "error transformation xml to html from entity flash id : " + ee_id;
					} else {
						return response;
					}
				});
		}

		ctrl.$onInit = function () {
			ctrl.loaded = false;
			ctrl.dead = false;
			ctrl.valid = true;
			if (ctrl.loadOnInit) {
				$timeout(function () {
					loadEditor();
				});
			}
		};

		ctrl.handler = $rootScope.$on('refresh_editor', function (event, modelId) {
			ctrl.loaded = false;
			$timeout(function () {
				loadEditor(modelId);
			});
		});

		ctrl.$onDestroy = function () {
			ctrl.dead = true;
		};

		ctrl.setAdapterInternal = function (adapter) {
			if (ctrl.setAdapter) {
				ctrl.setAdapter({ adapter: adapter });
			}
		};

		function loadEditor(modelId) {
			// we need to check if the component was not destroyed before calling promises
			if (!ctrl.dead) {
				var resolveSaveIntervalsPromise = resolveSaveIntervals().then(function (result) { ctrl.saveIntervals = result; });
				var resolveAuthorPromise = resolveAuthor().then(function (result) { ctrl.author = result; });
				var resolveProlexisWsUrlPromise = resolveProlexisWsUrl().then(function (result) { ctrl.prolexisWsUrl = result; });
				var resolveEntityEditedPromise = resolveEntityEdited(ctrl.id, modelId).then(function (result) { ctrl.entityEdited = result; });

				$q.all([resolveSaveIntervalsPromise, resolveAuthorPromise, resolveProlexisWsUrlPromise, resolveEntityEditedPromise]).then(function () {
					ctrl.loaded = true;
					$rootScope.$broadcast('editor_refreshed', ctrl.id);
				});
			}
		}

	}
})();

(function () {
	'use strict';
	/*global msed*/

	angular.module('userApp').component("fullPageEditorComponent", {
		templateUrl: 'scripts/pre-upgrade/components/editor/components/full-page-editor.html',
		controller: fullPageEditorController,
		bindings: {
			saveIntervals: "<",
			author: "<",
			prolexisWsUrl: "<",
			entityEdited: "<"
		}

	});

	/** @ngInject */
	function fullPageEditorController($stateParams) {

		var ctrl = this;

		ctrl.$onInit = function () {
			//the root edited Editorial entity ID
			ctrl.eeId = $stateParams.id;
			ctrl.subId = $stateParams.subid;
			ctrl.config = ctrl.entityEdited.editorProperties.editorConfiguration;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('EditorResource', editorResource);

	/** @ngInject */
	function editorResource($resource) {
		return $resource('api/napi', {}, {
			'saveHtml': {
				method: 'POST',
				url: 'api/napi/saveHtml'
			},
			'saveHtmlAuto': {
				method: 'POST',
				url: 'api/napi/saveHtmlAuto'
			},
			'validateHtml': {
				method: 'POST',
				url: 'api/napi/validateHtml'
			},
			'getTempoSvgAuto': {
				method: 'GET',
				url: 'api/napi/tempoSvgAuto'
			},
			'getProlexisWsUrl': {
				method: 'GET',
				url: 'api/napi/prolexiswsurl',
				transformResponse: function (data) {
					data = { url: data };
					return data;
				}
			},
			'startEdition': {
				method: 'POST',
				params: {
					id: '@id',
					subid: '@subid'
				},
				url: 'api/napi/startEdition/:id/:subid'
			},
			'editReadonly': {
				method: 'POST',
				params: {
					id: '@id',
					subid: '@subid'
				},
				url: 'api/napi/editReadonly/:id/:subid'
			},
			'cancelEdition': {
				method: 'POST',
				params: {
					id: '@id',
					subid: '@subid'
				},
				url: 'api/napi/cancelEdition/:id/:subid'
			},
			'endEdition': {
				method: 'POST',
				url: 'api/napi/endEdition'
			},
			'searchTargetLinksByQuery': {
				method: 'POST',
				params: {
					eeFlashId: '@eeFlashId',
					anchorHtmlContent: '@anchorHtmlContent'
				},
				url: 'api/napi/searchlinks/:eeFlashId'
			},
			'getMacroList': {
				url: 'api/napi/macro/list',
				method: 'GET',
				isArray: true
			},
			'applyMacro': {
				url: 'api/napi/macro/transformation',
				method: 'POST',
				transformResponse: function (data) {
					data = { html: data };
					return data;
				},
			},
			'wordPasteTransformation': {
				url: 'api/napi/wordPaste/transformation',
				method: 'POST',
				transformResponse: function (data) {
					data = { html: data };
					return data;
				}
			},
			'getTableTemplateList': {
				url: 'api/napi/template/table',
				method: 'GET',
				isArray: true
			},
			'getTableTemplateListByProduct': {
				url: 'api/napi/template/tablebyproduct',
				method: 'GET',
				isArray: true
			},
		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp').factory('editorMediaResource', EditorMediaResource);

	/** @ngInject */
	function EditorMediaResource($resource) {
		return $resource('api/media', {}, {
			'list': {
				method: 'GET',
				url: 'api/media/list'
			},
			'searchFile': {
				method: 'GET',
				url: 'api/media/searchFile'
			},
			'upload': {
				method: 'POST',
				headers: { 'Content-Type': undefined },
				url: 'api/media/upload'
			},
			'createDirectory': {
				method: 'GET',
				url: 'api/media/directory/create'
			},
			'renameFile': {
				method: 'GET',
				url: 'api/media/file/rename'
			},
			'exists': {
				method: 'POST',
				url: 'api/media/exists',
				params: {
					path: '@path',
					fileName: '@fileName'
				},
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return { isExist: data };
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('userApp').component("endMessageComponent", {
		templateUrl: 'scripts/pre-upgrade/components/editor/popup/end-message.html',
		controller: endMessageController,
		bindings: {
			modalInstance: "<",
			resolve: "<"
		}
	});

	/** @ngInject */
	function endMessageController(EditorResource) {
		var ctrl = this;
		var error = ctrl.resolve.error;
		var rawContent = ctrl.resolve.rawContent;

		//error detail message (stack trace)
		ctrl.errorMsg = error.txt;

		//html content processed and analysed by the server
		ctrl.htmlContent = error.htmlContent;

		//by default, error detail is hide
		ctrl.isShowErrorDetail = false;

		// toggle state to show or hide error detail
		ctrl.toggleShowErrorDetail = function () {
			ctrl.isShowErrorDetail = !ctrl.isShowErrorDetail;
		};

		ctrl.save = function () {
			rawContent.status = error.status;
			EditorResource.saveHtml(rawContent);
			ctrl.modalInstance.close({$value: "SAVE"});
		};

		ctrl.continue = function () {
			ctrl.modalInstance.dismiss('cancel');
		};

		ctrl.cancel = function () {
			rawContent.status = "NONE";
			EditorResource.cancelEdition({id: rawContent.id});
			ctrl.modalInstance.close({$value: "CANCEL"});
		};

		ctrl.messages = {
			'content': 'userApp.editor.invalid.edition.content',
			'display': 'userApp.editor.invalid.display',
			'hide': 'userApp.editor.invalid.hide',
			'title': 'userApp.editor.invalid.html.title'
		};
	}

})();

(function () {
	'use strict';

	angular.module('userApp').component("startMessageComponent", {
		templateUrl: 'scripts/pre-upgrade/components/editor/popup/start-message.html',
		controller: startMessageController,
		bindings: {
			modalInstance: "<",
			resolve: "<"
		}
	});

	/** @ngInject */
	function startMessageController($stateParams, $log) {
		var ctrl = this;

		// contains the result of EE transformation to edit when an error occured.
		var result = ctrl.resolve.result;

		//error detail message (stack trace)
		if (angular.isDefined(result) && result !== null) {
			ctrl.error = result.error;
		}

		//by default, error detail is hide
		ctrl.isShowErrorDetail = false;

		// messages to display : common part between HTML and XML
		ctrl.messages = {
			'display': 'userApp.editor.invalid.display',
			'hide': 'userApp.editor.invalid.hide',
			'title': 'userApp.editor.invalid.html.title'
		};

		// messages to display based on return editionStatus
		if (angular.isDefined(result) && result !== null && result.editionStatus === "TECHNICAL_ERROR") {
			addTechnicalErrorMessages();
		} else if (angular.isDefined(result) && result !== null && result.editionStatus === "INVALID") {
			addErrorMessages();
		} else if (angular.isDefined(result) && result !== null) {
			$log.error("unknown edition status : " + result.errorStatus);
		}

		// messages specific to HTML errors
		function addErrorMessages() {
			ctrl.messages.title = 'userApp.editor.invalid.html.title';
			ctrl.messages.msg = 'userApp.editor.invalid.html.msg';
		}

		// messages specific to XML errors
		function addTechnicalErrorMessages() {
			ctrl.messages.title = 'userApp.editor.invalid.xml.title';
			ctrl.messages.msg = 'userApp.editor.invalid.xml.msg';
		}


		// toggle state to show or hide error detail
		ctrl.toggleShowErrorDetail = function () {
			ctrl.isShowErrorDetail = !ctrl.isShowErrorDetail;
		};


		// close modal, passing EE ID to reload it.
		ctrl.continue = function () {
			ctrl.modalInstance.close(result.id);
		};

		ctrl.cancel = function () {
			ctrl.modalInstance.dismiss('cancel');
		};

	}

})();


(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('validateHtmlContentModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editor/popup/validate-html-content.html',
			controller: ValidateHtmlContentModalComponentController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function ValidateHtmlContentModalComponentController() {
		var ctrl = this;


		////////////////

		ctrl.$onInit = function () {
			ctrl.errors = ctrl.resolve.errors;
		};

		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestroy = function () { };

		ctrl.save = function () {
			ctrl.close();
		};

		ctrl.cancel = function () {
			ctrl.dismiss();
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('validateHtmlContentModalService', validateHtmlContentModalService);



	/**
	 * Service used to display html validation error
	 */
	/** @ngInject */
	function validateHtmlContentModalService($uibModal) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal(errors) {

			var modalInstance = $uibModal.open({
				component: 'validateHtmlContentModalComponent',
				resolve: {
					errors: function () { return errors; }
				},
				backdrop: 'static'
			});

			return modalInstance.result;
		}


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorLinkService', EditorLinkService);


	/** @ngInject */
	function EditorLinkService($log, $q, $uibModal, EditorResource, editorResultFormatService, createLinkService, createIntraLinkService, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			getTargetLinkWithFragment: getTargetLinkWithFragment,
			openLinkingWizardModal: openLinkingWizardModal,
			openLinkingIntraWizardModal: openLinkingIntraWizardModal
		};

		/*
		 get target link auto
		 */
		function getTargetLinkWithFragment(eeID, tr, fragment) {
			var napiResult = EditorResource.searchTargetLinksByQuery({ eeFlashId: eeID }, fragment).$promise;
			var formatter = function (data) {
				return {
					"status": EDITORIAL_RESPONSE_STATUS.OK,
					"data": _.map(data.listResultat, function (item) {
						return {
							"eeId": eeID,
							"eeTargetId": item.FLASH_ID,
							"eeTargetName": item.HTML_MULTI_SYSTEMTITLE,
							"eeSubTargetId": "",
							"eeSubTargetName": "",
							"codeTR": item.EE_DOC_TYPE,
							"typeTR": ''//link.className
						};
					})
				};
			};
			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}


		//create relation using  post link.
		function openLinkingWizardModal(text, sourceFlashId, rtCode) {
			var deferred = $q.defer();
			//Call the wizard
			var modalInstance = $uibModal.open(createLinkService.getConfigForTextEditor(rtCode, sourceFlashId, text, true));

			modalInstance.result.then(function (relations) {

				var relation = relations[0];

				var result = {
					"status": EDITORIAL_RESPONSE_STATUS.OK
				};
				result.data = {
					"eeId": relation.eeSourceFlashId,
					"eeTargetId": relation.eeTargetFlashId,
					"eeTargetName": relation.wording,
					"eeSubTargetId": relation.subElementEeTargetFlashId,
					"eeSubTargetName": "",
					"codeTR": relation.eeTargetCode,
					"typeTR": "",
					"verbalisation": _.concat([], relation.verbalization || [])
				};
				deferred.resolve(result);
			}, function () {
				deferred.resolve({
					"status": EDITORIAL_RESPONSE_STATUS.CANCEL
				});
			});
			return deferred.promise;
		}


		//	create relation using intra post link.
		function openLinkingIntraWizardModal(text/*Not necessary*/, sourceFlashId, rtCode) {

			$log.info('Call intra link using trCode ' + rtCode);
			var deferred = $q.defer();
			var modalInstance = $uibModal.open(createIntraLinkService.getIntraLinkConfiguration(rtCode, sourceFlashId));
			modalInstance.result.then(function (relation) {

				var result = {
					"status": EDITORIAL_RESPONSE_STATUS.OK
				};
				result.data = {
					"eeId": relation.eeSourceFlashId,
					"eeTargetId": relation.eeTargetFlashId,
					"eeTargetName": relation.wording,
					"codeTR": relation.eeTargetCode,
					"eeSubTargetId": "",
					"eeSubTargetName": "",
					"typeTR": "",
					"verbalisation": _.concat([], relation.verbalization || [])
				};
				deferred.resolve(result);
			}, function () {
				deferred.resolve({
					"status": EDITORIAL_RESPONSE_STATUS.CANCEL
				});
			});
			return deferred.promise;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorMacroService', EditorMacroService);

	/** @ngInject */
	function EditorMacroService(EditorResource, Language, editorResultFormatService, EDITORIAL_RESPONSE_STATUS, $translate) {

		//service operations exposed
		return {
			getMacroList: getMacroList,
			applyMacro: applyMacro
		};


		/**
		 *  Get the list of available macros
		 */
		function getMacroList(id_doc) {
			var lang = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

			if (angular.isUndefined(lang)) {
				lang = 'fr';
			}
			var napiResult = EditorResource.getMacroList({ flashId: id_doc, langKey: lang }).$promise;

			var formatter = function (data) {
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}


		/**
		 * Apply macro transformation.
		 */
		function applyMacro(key, id_doc, htmlContent) {
			var napiResult = EditorResource.applyMacro({ flashId: id_doc, code: key }, htmlContent).$promise;

			var formatter = function (data) {
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data.html
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorMediaService', EditorMediaService);

	/** @ngInject */
	function EditorMediaService($location, editorMediaResource, editorResultFormatService, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			listEditorMedia: listEditorMedia,
			uploadEditorMedia: uploadEditorMedia,
			createDirectoryForEditorMedia: createDirectoryForEditorMedia,
			renameMediaFile: renameMediaFile,
			isExistMedia: isExistMedia
		};

		/*
		 list all resources in the directory supplied.
		 */
		function listEditorMedia(eeId, directoryName, search, limit, offset, extensionFilters) {
			var napiResult;
			if (!search) {
				napiResult = editorMediaResource.list({ "id": eeId, "directoryName": directoryName, "limit": limit, "offset": offset, "extensionFilters": extensionFilters }).$promise;
			} else {
				//Do search
				napiResult = editorMediaResource.searchFile({ "search": search, "limit": limit, "offset": offset, "extensionFilters": extensionFilters }).$promise;
			}

			var formatter = function (data) {
				data.files = _.map(data.files, extendMediaUrl);
				return {
					"status": EDITORIAL_RESPONSE_STATUS.OK,
					"data": data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

		function isExistMedia(path, fileName) {
			var napiResult = editorMediaResource.exists({
				"path": path,
				"fileName": fileName
			}).$promise;

			var formatter = function (data) {
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

		/*
		 upload one file from the editor to ECM.
		*/
		function uploadEditorMedia(eeId, path, filename, file, originalFilename) {

			var napiResult = editorMediaResource.upload(buildRequestParams()).$promise;

			//build metadata + file to sent to ECM server
			function buildRequestParams() {
				var fd = new FormData();
				fd.append('id', eeId);
				fd.append('path', path);
				fd.append('fileName', filename);
				fd.append('originalFileName', angular.isUndefined(originalFilename) ? filename : originalFilename);
				fd.append('file', file);
				return fd;
			}

			var formatter = function (data) {
				data = extendMediaUrl(data);
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

		/*
		 Create an empty directory
		 */
		function createDirectoryForEditorMedia(eeId, path, directoryName) {

			var napiResult = editorMediaResource.createDirectory({
				"id": eeId,
				"path": path,
				"directoryName": directoryName
			}).$promise;

			return editorResultFormatService.processResultWithoutCondition(napiResult, noDataFormatter);
		}

		/*
		 move media file to another directory
		 */
		function renameMediaFile(eeId, idFile, newName) {
			var napiResult = editorMediaResource.renameFile({
				"id": eeId,
				"idFile": idFile,
				"newName": newName
			}).$promise;

			return editorResultFormatService.processResultWithoutCondition(napiResult, noDataFormatter);
		}

		// operation succeed and there is no data to transfer to the editor.
		function noDataFormatter() {
			return {
				status: EDITORIAL_RESPONSE_STATUS.OK
			};
		}

		/*
		 add URL context part to the original and miniature links of the received media
		 */
		function extendMediaUrl(m) {
			var baseUrl = $location.absUrl();
			var context = getContextfromUrl(baseUrl);
			var preUrl = (angular.isUndefined(context) || context === null || context === "/" || 0 === context.length) ? "" : '/' + context;

			m.miniatureLink = preUrl + m.miniatureLink;
			m.originalLink = preUrl + m.originalLink;
			return m;
		}

		/*
		 Extract context from an URL.
		 URL = http://localhost:8081/Flash-Ecm-User/#/editor/123456  => Context = Flash-Ecm-User
		 */
		function getContextfromUrl(url) {
			var match = url.match(/^(?:([^:/?#]+):)?(?:\/\/([^/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
			return match[3].substring(1, (match[3].length - 1));
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorMetadataService', EditorMetadataService);

	/** @ngInject */
	function EditorMetadataService($q, EDITORIAL_ELEMENT_TYPE, EDITORIAL_RESPONSE_STATUS, editMetaDataModalService, editorResultFormatService, MetadataService, metadataResource) {

		//service operations exposed
		return {
			getMeta: getMeta,
			openEditMetaModal: openEditMetaModal,
			getInfoMeta: getInfoMeta
		};


		/*
		 service to modify the editorial entity metadata
		 */
		function openEditMetaModal(eeID) {
			var deferred = $q.defer();
			editMetaDataModalService.openEditEntityMetaModal(eeID)
				.then(function () {
					deferred.resolve({
						"status": EDITORIAL_RESPONSE_STATUS.OK
					});
				}, function () {
					deferred.resolve({
						"status": EDITORIAL_RESPONSE_STATUS.CANCEL
					});
				});
			return deferred.promise;
		}

		/*
		 get the editorial entity metadata
		 */
		function getMeta(eeId) {
			var napiResult = metadataResource.getMetaInstanceToEdit({
				id: eeId,
				type: EDITORIAL_ELEMENT_TYPE.entity
			}).$promise;

			var formatter = function (data) {
				data = MetadataService.formatForEditor(data);
				return {
					"status": EDITORIAL_RESPONSE_STATUS.OK,
					"data": data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

		/*
		 [SIETRAINT1-56] Get the editorial entity valuated information metadata instances
		 */
		function getInfoMeta(eeId) {
			var napiResult = MetadataService.getValuatedInformationMetaDataInstances(eeId);

			var formatter = function (data) {
				var preformatData = [
					{
						metaGroupName: "",
						metaDataInstanceDTOList: data
					}
				];
				data = MetadataService.formatForEditor(preformatData);
				return {
					"status": EDITORIAL_RESPONSE_STATUS.OK,
					"data": data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorResultFormatService', EditorResultFormatService);


	/** @ngInject */
	function EditorResultFormatService($log, $q, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			processResultWithoutData: processResultWithoutData,
			processResultWithoutCondition: processResultWithoutCondition
		};

		/*
		 Process asynchronous results from ECM rest API.
		 */
		function processResult(promise, predicat, resultBuilder){
			//communicate with the editor via promise.
			//this one allows us to format for the editor the asynchronous results coming from ECM API.
			var deferred = $q.defer();

			//to conform to the promise API, we need to pass single argument function to the then function.
			//so, we curry an partially apply our format function (which need several arguments).
			var curried = _.curry(format);
			var partial = curried(deferred)(predicat);

			//"process" the promise
			promise.then(partial, error);

			//return the formatted result asynchronously.
			return deferred.promise;

			/*
			 Format ECM results to be compliant with the editor.
			 The result depends of the edition status (and if it match the predicate or not).
			 */
			function format(defer, pred ,data){
				if (pred(data.editionStatus)) {
					defer.resolve(resultBuilder(data));
				} else {
					defer.reject({
						"status": EDITORIAL_RESPONSE_STATUS.KO
					});
				}
			}

			/*
			 Error function for promise API.
			 It's log the error and propagate the reject status to the editor.
			 */
			function error(err) {
				$log.error(err);
				deferred.reject({
					"status": EDITORIAL_RESPONSE_STATUS.KO
				});
			}
		}

		/*
		 Process asynchronous results from ECM rest API that do not return data to the editor instance.
		 */
		function processResultWithoutData(promise, predicat){
			return processResult(promise,
				predicat,
				function(){
					return {
						"status": EDITORIAL_RESPONSE_STATUS.OK
					};
				});
		}

		/*
		 Process asynchronous results from ECM rest API whatever the edition status returned.
		 */
		function processResultWithoutCondition(promise, resultBuilder){
			return processResult(promise,
				function(){return true;},
				resultBuilder);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorSaveService', EditorSaveService);


	/** @ngInject */
	function EditorSaveService($uibModal, $q, $rootScope, $state, blockUI, $log, editorResultFormatService, EditorResource, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			saveRawContent: saveRawContent,
			saveRawContentAuto: saveRawContentAuto,
			saveContent: saveContent,
			saveContentWithoutValidation: saveContentWithoutValidation
		};


		/*
		 save editor HTML content on an user'action (even if the content is not valid).
		 */
		function saveRawContent(rawHtml) {
			var napiResult = function (_rawHtml) {
				_rawHtml.status = "SAVED_MAN";
				return EditorResource.saveHtml(_rawHtml).$promise;
			};

			var predicate = function (status) {
				return status === "SAVED_MAN";
			};

			return editorResultFormatService.processResultWithoutData(napiResult(rawHtml), predicate);
		}


		/*
		 automatic editor HTML content backup, executed in background, without any validation.
		 */
		function saveRawContentAuto(rawHtml) {
			var napiResult = function (_rawHtml) {
				return EditorResource.saveHtmlAuto(_rawHtml).$promise;
			};

			var predicate = function (status) {
				return status !== "TECHNICAL_ERROR" && status !== "INVALID";
			};

			return editorResultFormatService.processResultWithoutData(napiResult(rawHtml), predicate);
		}

		function startEdition(rawHtmlDTO) {
			var deferred = $q.defer();

			EditorResource.startEdition({ id: rawHtmlDTO.id, subid: rawHtmlDTO.subid }).$promise
				.then(function (response) {
					if (response.editionStatus === "TECHNICAL_ERROR") {
						deferred.reject(response);
					}
					else {
						deferred.resolve(response);
					}
				});

			return deferred.promise;
		}

		function endEdition(rawHtmlDTO) {
			var deferred = $q.defer();


			EditorResource.endEdition(rawHtmlDTO).$promise.then(function (data) {
				if (data.editionStatus === "TECHNICAL_ERROR") {
					deferred.reject({
						"status": EDITORIAL_RESPONSE_STATUS.KO
					});
				}
				else {
					// if saveAndContinue we chain with startEdition, else we return an ok result
					deferred.resolve({
						"status": data.editionStatus
					});
				}
			});

			return deferred.promise;
		}

		/*
		 save editor's content, without displaying validation modal
		 */
		function saveContentWithoutValidation(rawHtmlDTO) {
			if (rawHtmlDTO.status === 'DONE') {
				return startEdition(rawHtmlDTO).then(function () { return endEdition(rawHtmlDTO); });
			}

			return endEdition(rawHtmlDTO);
		}

		/*
		 save editor's content, applying all treatment supply by the Napi layer (HTML -> XML conversion, validation, ...)
		 */
		function saveContent(rawHtmlDTO, editorID) {
			blockUI.start();
			var deferred = $q.defer();
			if(rawHtmlDTO.readOnly){
				blockUI.stop();
				deferred.resolve({
					"status": EDITORIAL_RESPONSE_STATUS.OK
				});
				navigate(rawHtmlDTO);
			} else {
				EditorResource.endEdition(rawHtmlDTO).$promise.then(
					function (data) {
						blockUI.stop();
						// IGNORE VALIDATION ERROR IF OVERWRITE FALSE
						var editionStatus = rawHtmlDTO.overwrite ? data.editionStatus : "DONE";
						if (editionStatus === "TECHNICAL_ERROR" || editionStatus === "INVALID") {
							deferred.reject({
								"status": EDITORIAL_RESPONSE_STATUS.KO
							});
	
							var modalInstance = $uibModal.open({
								component: "endMessageComponent",
								size: 'lg',
								backdrop: 'static',
								resolve: {
									error: function () {
										var error = {};
										error.status = editionStatus;
										error.txt = data.error;
										error.htmlContent = data.htmlContent;
										return error;
									},
									rawContent: function () {
										return rawHtmlDTO;
									},
									mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
										$translatePartialLoader.addPart('editor');
										return $translate.refresh();
									}]
								}
							});
	
							modalInstance.result.then(function (selectedItem) {
								if (selectedItem.$value === "SAVE") {
									
									/**
									 * TODO / SIETRAINT1-5615 :
									 * ========================
									 *
									 * This service should NOT be aware of the actual TinyMCE Editor instance,
									 * and even less of the TinyMCE plugins !
									 *
									 * We should use a generic wrapper function, passed via
									 * ecmEditorWrapperController (editorConfiguration)
									 * to trigger localautosave clear.
									*/
									var editor = tinymce.get(editorID);
									if (editor) {
										editor.plugins.localautosave.clearSaveAuto();
									}
									navigate(rawHtmlDTO);
								}
								if (selectedItem.$value === "CANCEL") {
									navigate(rawHtmlDTO);
								}
							});
						} else if (editionStatus === "DONE") {
							deferred.resolve({
								"status": EDITORIAL_RESPONSE_STATUS.OK
							});
							navigate(rawHtmlDTO);
						}
					},
					function (error) {
						blockUI.stop();
						$log.log(error);
					});
			}


			return deferred.promise;
		}


		/*
		get back to the previous page depending on editorial entity type (EE vs Node)
		 */
		function doQuitEditor(rawHtml) {
			if (angular.isDefined(rawHtml.subid)) {
				//Tree ee edition : node content edition
				$state.go('treeEEEdition', {
					id: rawHtml.id,
					editionMode: 'STRUCTURE'
				});
			} else {
				//ST ee edition
				$state.go('editorialEntity', {
					id: rawHtml.id
				});
			}
		}

		/**
		 * Go back to previous state .
		 */
		function navigate(rawHtml) {
			if ($rootScope.previousStateName) {
				$state.go($rootScope.previousStateName, $rootScope.previousStateNameParams);
			} else {
				doQuitEditor(rawHtml);
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorTableTemplateService', EditorTableTemplateService);

	/** @ngInject */
	function EditorTableTemplateService(EditorResource, editorResultFormatService, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			getTableTemplateList: getTableTemplateList,
			getTableTemplateListByProduct: getTableTemplateListByProduct
		};

		function returnResult(napiResult) {
			var formatter = function (data) {
				data = _.map(data, function (d) {
					return {
						"libelle": d.title,
						"html": d.content,
						"description": d.description,
						"metaData": d.metaData
					};
				});
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

		/**
		 *  Get the list of available tables models
		 */
		function getTableTemplateList(id_doc) {
			var napiResult = EditorResource.getTableTemplateList({ flashId: id_doc }).$promise;

			return returnResult(napiResult);
		}

		/**
		*  Get the list of available tables models by product code
		*/
		function getTableTemplateListByProduct(productCode) {
			var napiResult = EditorResource.getTableTemplateListByProduct({ productCode: productCode }).$promise;

			return returnResult(napiResult);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorValidationService', EditorValidationService);

	/** @ngInject */
	function EditorValidationService(EditorResource, editorResultFormatService, EDITORIAL_RESPONSE_STATUS) {

		//service operations exposed
		return {
			validateHtmlContent: validateHtmlContent
		};


		function validateHtmlContent(rawHtml, scenario) {
			var napiResult = function (_rawHtml, _scenario) {
				var dto = _.cloneDeep(_rawHtml);
				dto.status = "IN_PROGRESS";
				return EditorResource.validateHtml({ scenario: _scenario }, dto).$promise;
			};

			var formatter = function (data) {
				//handle validation api response
				if (_.has(data, 'validation-reports')) {
					return data;
				} else {
					return {
						"status": EDITORIAL_RESPONSE_STATUS.OK,
						"error": data.result
					};
				}
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult(rawHtml, scenario), formatter);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editorWordService', EditorWordService);

	/** @ngInject */
	function EditorWordService(EditorResource, editorResultFormatService, EDITORIAL_RESPONSE_STATUS, $translate) {

		//service operations exposed
		return {
			wordPasteTransformation: wordPasteTransformation
		};

		/**
		 * Apply word paste transformation.
		 */
		function wordPasteTransformation(id_doc, wordContent) {
			var napiResult = EditorResource.wordPasteTransformation({ flashId: id_doc }, wordContent).$promise;

			var formatter = function (data) {
				return {
					status: EDITORIAL_RESPONSE_STATUS.OK,
					data: data
				};
			};

			return editorResultFormatService.processResultWithoutCondition(napiResult, formatter);
		}

	}
})();

(function () {
	'use strict';

	angular.module('userApp').component("debugLogComponent", {
		templateUrl: 'scripts/pre-upgrade/components/debug/debug-log/debug-log.component.html',
		controller: DebugLogComponent,
		bindings: {

		}
	});

	/** @ngInject */
	function DebugLogComponent(debugService, $log) {
		var ctrl = this;

		ctrl.numberOfLine = 100;//DEFAULT TO 100;
		ctrl.fileName = '';
		ctrl.logFiles = [];

		ctrl.logResult = undefined;

		ctrl.$onInit = function () {

			//INITIATE LOG FILES
			ctrl.getLogFile();
		};

		ctrl.getLogFile = function () {

			debugService.getLogFiles().then(function (data) {
				ctrl.logFiles = data;
			});
		};

		ctrl.getLogFileContent = function () {

			debugService.getLogFileContent(ctrl.numberOfLine, ctrl.fileName).then(function (data) {
				ctrl.logResult = data;
			});
		};


		ctrl.selectFileLog = function (file) {
			ctrl.fileName = file;
		};

	}

})();

(function () {
	'use strict';

	angular.module('userApp').component("debugMariaComponent", {
		templateUrl: 'scripts/pre-upgrade/components/debug/debug-maria/debug-maria.component.html',
		controller: DebugMariaComponent,
		bindings: {

		}
	});

	/** @ngInject */
	function DebugMariaComponent(debugService, $log) {
		var ctrl = this;

		ctrl.sqlRequest = '';

		ctrl.sqlResult = undefined;

		ctrl.$onInit = function () {
		};

		ctrl.sendMariaRequest = function () {

			debugService.sendMariaRequest(ctrl.sqlRequest).then(function (data) {
				ctrl.sqlResult = data;
			});
		};
	}

})();

(function () {
	'use strict';

	angular.module('userApp').component("debugSolrComponent", {
		templateUrl: 'scripts/pre-upgrade/components/debug/debug-solr/debug-solr.component.html',
		controller: DebugSolrComponent,
		bindings: {

		}
	});

	/** @ngInject */
	function DebugSolrComponent(debugService, $log) {
		var ctrl = this;

		ctrl.solrRequest = '';

		ctrl.solrResult = undefined;

		ctrl.$onInit = function () {
		};

		ctrl.sendSolrRequest = function () {

			debugService.sendSolrRequest(ctrl.solrRequest).then(function (data) {
				ctrl.solrResult = data;
			});
		};
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('connect', {
				parent: 'site',
				abstract: true,
				data: {
					authorities: ['ROLE_ADMIN_SI', 'ROLE_ADMIN_HOUSE', 'ROLE_USER']
				},
				templateUrl: 'scripts/pre-upgrade/components/layout/connect/connect.html'
			});
	}

})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('myGroups', {
			templateUrl: 'scripts/pre-upgrade/components/home/my-groups/my-groups.html',
			controller: MyGroupsController,
			controllerAs: '$ctrl'
		});

	/** @ngInject */
	function MyGroupsController(myGroupsService) {
		var $ctrl = this;
		$ctrl.categories = [];
		$ctrl.zoomClass = '';

		////////////////

		$ctrl.$onInit = function () {

			myGroupsService.getGroupsByCategory()
				.then(function (data) {
					$ctrl.categories = data;
				});
		};

		$ctrl.zoom = function (category) {
			$ctrl.selectedCategory = category;
		};

		$ctrl.closeZoom = function () {
			$ctrl.selectedCategory = null;
		};
		//$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	/**
	 * service for my-groups component.
	 */
	angular
		.module('userApp')
		.factory('myGroupsService', myGroupsService);

	/** @ngInject */
	function myGroupsService(userGroupResource) {
		var service = {
			getGroupsByCategory: getGroupsByCategory
		};

		return service;

		function getGroupsByCategory() {
			return userGroupResource.getUserGroupByCategory().$promise;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('mainLayout', {
				parent: 'site',
				abstract: true,
				templateUrl: 'scripts/pre-upgrade/components/layout/main/main.html'
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('main', {
				parent: 'mainLayout',
				abstract: true,
				data: {
					authorities: ['ROLE_ADMIN_SI', 'ROLE_ADMIN_HOUSE', 'ROLE_USER']
				},
				views: {
					navbar: {
						component: 'navbar'
					},
					'navbar-left': {
						component: 'navbarLeft'
					},
					statusbar: {
						templateUrl: 'scripts/components/statusbar/statusbar.html',
						controller: 'StatusBarController'
					}
				},
				resolve: {
					authorize: ['Auth',
						function (Auth) {
							return Auth.authorize();
						}
					],
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					mainTranslatePartialLoader: ['$translate',
						'$translatePartialLoader',
						function ($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('main');
							return $translate.refresh();
						}]
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('createEntityModal', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-entity-modal/create-entity-modal.html',
			controller: CreateEntityModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function CreateEntityModalController() {

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('createEntityModalService', CreateEntityModalService);


	/** @ngInject */
	function CreateEntityModalService(entityTemplateResource, blockUI, $uibModal, modelService) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal(codeTEE, currentUser, modelId, ownerGroup) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'createEntityModal',
				windowClass: 'editor-zindex',
				resolve: {
					entity: function (entityTemplateResource) {
						return entityTemplateResource.getEET({
							codeTEE: codeTEE
						}).$promise;
					},
					currentUser: currentUser,
					modelId: function () { return modelId; },
					ownerGroup: function () { return ownerGroup; },
					maxSizeMedia: function (entityTemplateResource) {
						return entityTemplateResource.getMaxSize().$promise;
					},
					allModelsList: function () {
						return modelService.getAllModels({
							codeTEE: codeTEE
						}).$promise;
					},
					metaInstanceListModel: function () {
						return modelService.loadMetaInstantiation({
							codeTEE: codeTEE
						}).$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('datepicker');
						$translatePartialLoader.addPart('global');
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('createEntityForm', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-entity-form/create-entity-form.html',
			controller: CreateEntityFormController,
			bindings: {
				entity: '<',
				currentUser: '<',
				maxSizeMedia: '<',
				allModelsList: '<',
				metaInstanceListModel: '<',
				close: '&',
				modelId: '<',
				ownerGroup: '<?'
			},
		});

	/** @ngInject */
	function CreateEntityFormController($sce, $rootScope, $translate, $state, $log, $scope, $filter, EditorialEntityService, $http, modelService, blockUI, moment, entityAuthorizeService, entityTemplateService, TirFilterSharedService, metaMediaService, treeAutoMountService, validateEntityService) {
		var ctrl = this;


		ctrl.$onInit = function () {
			ctrl.titleMaxLengthViolation = false;
			ctrl.allModels = [];
			ctrl.permissions = [];
			ctrl.initModels();
			ctrl.allModelsSize = Object.keys(ctrl.allModels).length;
			ctrl.lang = $translate.use();
			ctrl.maxSizeMedia = ctrl.maxSizeMedia.maxSize;
			ctrl.editorialEntity = {};
			ctrl.editorialEntity.editorialEntityTemplate = ctrl.entity;
			ctrl.editorialEntity.metaInstanceList = ctrl.entity.metaDataInstanceDTOList;
			ctrl.filterDTO = [];
			ctrl.rawFilters = [];
			ctrl.showAdvanced = false;
			ctrl.exactMatch = [];
			ctrl.exactMatchSelected = [];
			ctrl.exactFiltersDisplay = [];
			ctrl.approximateMatch = [];
			ctrl.approximateMatchSelected = [];
			ctrl.preview = {};
			ctrl.isAllMasked = false;
			ctrl.errorExistEntityWithSomeMetaDiscriminants = false;

			moment.locale(ctrl.lang);

			ctrl.editorialEntity.ownerGroup = ctrl.currentUser.userGroups.length === 1 ? ctrl.currentUser.userGroups[0].code.toString() : '';

			ctrl.loadModel();

			//INITIALIZE WITH MODEL			
			if (ctrl.modelId) {
				ctrl.editorialEntity.modelFlashId = ctrl.modelId;
				ctrl.loadMetaInstance(ctrl.modelId);
			}
			else if (ctrl.editorialEntity.modelFlashId !== 'NOMODEL') {
				ctrl.loadMetaInstance(ctrl.editorialEntity.modelFlashId);
			}

			if (ctrl.editorialEntity.editorialEntityTemplate.contentType === 'TREE' && ctrl.editorialEntity.editorialEntityTemplate.automaticMounting) {
				ctrl.showAutoMountingFilters = true;
				ctrl.loadAutoMountingFilters();
				ctrl.mountingRt = ctrl.editorialEntity.editorialEntityTemplate.defaultMountingTR.id;
			}

			ctrl.isMedia = isMedia();
		};

		ctrl.initModels = function () {
			var mapAllModels = _.mapValues(_.keyBy(ctrl.allModelsList, 'flashId'), function (m) {
				//add model visibility to label
				if (m.modelVisibility) {
					var isDefault = m.defaultModel ? '*' : '';
					var visibility = $filter('translate')(m.modelVisibility === 'SHARED' ? m.modelVisibility + '_SHORT' : m.modelVisibility);
					return visibility + ' - ' + m.name + isDefault;
				}
				return m.name;
			});
			ctrl.allModels = mapAllModels;
		};

		ctrl.loadAutoMountingFilters = function () {
			treeAutoMountService.loadAutoMountingFilters(ctrl.editorialEntity.editorialEntityTemplate.code).then(function (result) {
				ctrl.filterDTO = angular.copy(result);
				ctrl.mappedFilters();
			});
		};

		ctrl.mappedFilters = function () {
			ctrl.filterDTO = treeAutoMountService.mappedFilters(ctrl.filterDTO, false);
			ctrl.rawFilters = _.flatMap(ctrl.filterDTO, ctrl.getfilter);
			ctrl.isAllMasked = treeAutoMountService.isAllMasked(ctrl.rawFilters);
		};

		ctrl.getfilter = function (f) {
			return f.filter;
		};

		function setDefaultModelFlashId() {
			var sharedDefaultModels = _.filter(ctrl.allModelsList, function (model) {
				return model.defaultModel;
			});
			if (sharedDefaultModels.length > 0) {
				return sharedDefaultModels[0].flashId;
			}
			else {
				return ctrl.allModelsList[0].flashId;
			}
		}

		ctrl.loadModel = function () {
			ctrl.editorialEntity.modelFlashId = setDefaultModelFlashId();
			if (ctrl.metaInstanceListModel.length > 0) {
				ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList = ctrl.metaInstanceListModel;
				ctrl.editorialEntity.metaInstanceList = ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList;
			}
		};

		ctrl.loadMetaInstance = function (modelId) {
			modelService.loadMetaInstantiation({
				codeTEE: ctrl.editorialEntity.editorialEntityTemplate.code,
				modelFlashId: modelId
			}).$promise.then(function (data) {
				ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList = data;
				ctrl.editorialEntity.metaInstanceList = ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList;
				ctrl.editorialEntity.ownerGroup = ctrl.currentUser.userGroups.length === 1 ? ctrl.currentUser.userGroups[0].code.toString() : '';
				//get owner group and system title from model when a model is chosen
				modelService.getModel({
					modelFlashId: modelId
				}).$promise.then(function (data) {
					// get model title when editTitle = true
					if (ctrl.editorialEntity.editorialEntityTemplate.editedTitel) {
						ctrl.htmlTitle = data.system ? data.system.systemTitle : '';
					}
					if (data && data.system && data.system.systemOwnerGroup) {
						ctrl.editorialEntity.ownerGroup = data.system.systemOwnerGroup;
						$rootScope.ownerGroup = data.system.systemOwnerGroup;
						$rootScope.$broadcast("load_product_associations");
						$rootScope.$broadcast("load_product");
					}
				});
			});

		};

		//verify if all the metaDataInstances "MEDIA" are not assigned	
		function getListMetaInstanceMedia() {
			var listMEDIA = [];
			if (ctrl.editorialEntity.metaInstanceList !== null && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized) {
						listMEDIA.push(metaInstanceDto);
					}
				}
			}
			return listMEDIA;
		}

		ctrl.isNotAllMediasAssigned = function () {
			var listMEDIA = getListMetaInstanceMedia();
			var isAllAssigned;
			var size = 0;
			if (listMEDIA === null || listMEDIA.length === 0) {
				isAllAssigned = false;
			} else if (listMEDIA !== null && listMEDIA.length > 0) {
				for (var i = 0, len = listMEDIA.length; i <= len - 1; i++) {
					var metaInstanceDto = listMEDIA[i];
					if (angular.isDefined(metaInstanceDto.listMediaFiles) && angular.isDefined(metaInstanceDto.temporraryListFile) && (Object.keys(metaInstanceDto.listMediaFiles).length > 0 || metaInstanceDto.temporraryListFile.length > 0)) {
						size++;
					}
				}
				if (size === listMEDIA.length) {
					isAllAssigned = false;
				} else {
					isAllAssigned = true;
				}
			}
			return isAllAssigned;
		};


		ctrl.next = function () {
			ctrl.exactFiltersDisplay = TirFilterSharedService.extractFilters(ctrl.rawFilters);
			blockUI.start();
			entityTemplateService.searchTargetEntities(ctrl.editorialEntity.editorialEntityTemplate.code, ctrl.editorialEntity.ownerGroup || '', ctrl.filterDTO)
				.then(function (result) {
					ctrl.exactMatch = getLockState(result.exactMatch, ctrl.exactMatchSelected);
					ctrl.approximateMatch = getLockState(result.approximateMatch);
					ctrl.columns = result.columns;

					ctrl.showAdvanced = true;
					$translate.refresh();
					blockUI.stop();
				}).catch(function (err) {
					blockUI.stop();
				});

		};

		function getLockState(rows, checkboxModel) {
			rows.forEach(function (r) {
				if (checkboxModel) {
					checkboxModel[r.FLASH_ID] = true;
				}
				if (r.LOCK_STATE) {
					var s = r.LOCK_STATE.split('#');
					r.padlock = {
						color: s[0],
						closed: s[1],
						owner: s[2]
					};
				}
			});
			return rows;
		}

		ctrl.previous = function () {
			ctrl.exactMatchSelected = [];
			ctrl.approximateMatchSelected = [];
			ctrl.showAdvanced = false;
		};

		ctrl.setAutoMountingIds = function () {
			if (ctrl.showAutoMountingFilters) {
				var selectedExact = _.pickBy(ctrl.exactMatchSelected, function (val) { return val; });
				var selectedApprox = _.pickBy(ctrl.approximateMatchSelected, function (val) { return val; });

				var allSelected = _.merge(selectedExact, selectedApprox);

				ctrl.editorialEntity.targetEntitiesFlashIds = _.keys(allSelected);
			}
		};

		//Reset error msg of all discriminant meta data if already shown
		$rootScope.$on('$destroy', $rootScope.$on('reset_discriminant_meta_value_error_msg', function () {
			//if error messages shown, rest all them
			if (ctrl.errorExistEntityWithSomeMetaDiscriminants) {
				_.each(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
					ctrl.errorExistEntityWithSomeMetaDiscriminants = false;
					if (metaInstance.discriminant === true) {
						metaInstance.errorExistMetaDiscriminants = false;
					}
				});
			}
		}));


		ctrl.save = function (createAndEdit) {

			var discriminantsMetas = _.filter(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
				return metaInstance.discriminant === true;
			});

			if (discriminantsMetas.length > 0) {
				validateEntityService.checkIfEntityExistWithSomeDiscriminants(ctrl.editorialEntity.metaInstanceList, ctrl.editorialEntity.editorialEntityTemplate.code)
					.$promise.then(function (data) {
						ctrl.errorExistEntityWithSomeMetaDiscriminants = data.exist;
						if (!ctrl.errorExistEntityWithSomeMetaDiscriminants) {
							ctrl.doSave(createAndEdit);
						} else {
							//set form prestine to force form to be unsubmitted and keep save button enabled
							$scope.createForm.$setPristine();
							_.each(ctrl.editorialEntity.metaInstanceList, function (metaInstance) {
								if (metaInstance.discriminant === true) {
									metaInstance.errorExistMetaDiscriminants = true;
								}
							});
						}
					});

			} else {
				ctrl.doSave(createAndEdit);
			}
		};



		ctrl.doSave = function (createAndEdit) {
			blockUI.start();
			ctrl.setAutoMountingIds();
			ctrl.editorialEntity.titleSystem = ctrl.htmlTitle;
			metaMediaService.createMetaDataMedia(ctrl.editorialEntity.metaInstanceList).then(function () {
				return EditorialEntityService.save(ctrl.editorialEntity).$promise.then(function (data) {
					return data;
				}).then(function (ee) {
					//Verify creation mode.
					if (createAndEdit) {

						switch (ctrl.editorialEntity.editorialEntityTemplate.contentType) {
							case 'TREE':
								$state.go('treeEEEdition', {
									id: ee.identifier,
									editionMode: 'STRUCTURE',
									returnToEE: true
								});
								break;
							case 'MEDIA':
								$state.go('editorialEntity', {
									id: ee.identifier,
									eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
									contentType: ctrl.editorialEntity.editorialEntityTemplate.contentType,
									editEntity: true
								});
								break;
							case 'STRUCTUREDTEXT':
								if (ctrl.editorialEntity.editorialEntityTemplate.formular) {
									$rootScope.showEditModalOnLoad = true;
									$state.go('editorialEntity', {
										id: ee.identifier
									});
								}
								else {
									$state.go('editorialEntityEdit', {
										id: ee.identifier
									});
								}
								break;
							default:
								$state.go('editorialEntity', {
									id: ee.identifier
								});
								break;
						}
					} else {
						$state.go('editorialEntity', {
							id: ee.identifier,
							eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
							contentType: ctrl.editorialEntity.editorialEntityTemplate.contentType
						});

						treeAutoMountService.saveFilterInSession(ctrl.filterDTO, ee.identifier);

					}
					ctrl.close({
						$value: true
					});
					blockUI.stop();

				}).catch(function (error) {
					//Set the $submitted state to false
					ctrl.createForm.$setPristine();
					blockUI.stop();
				});
			});
		};

		ctrl.closePreview = function (id) {
			ctrl.preview.flashId = null;
		};

		ctrl.showPreview = function (id) {
			ctrl.preview = {
				opened: true,
				flashId: id
			};
		};

		ctrl.refreshAllTable = function () {
			ctrl.refreshApproxTable();
			ctrl.refreshExactTable();
		};

		ctrl.refreshApproxTable = function (tableState) {
			if (tableState) {
				ctrl.sortColumn(tableState, ctrl.approximateMatch);
			}
		};

		ctrl.refreshExactTable = function (tableState) {
			if (tableState) {
				ctrl.sortColumn(tableState, ctrl.exactMatch);
			}
		};

		ctrl.sortColumn = function (tableState, list) {
			var pred = tableState.sort.predicate;
			var reverse = tableState.sort.reverse;

			list = list.sort(function (a, b) {
				var result = a[pred] < b[pred] ? -1 : 1;

				if (reverse) result = result * -1;

				return result;
			});

		};

		//verify if all the metaDataInstances "Repository"  type tree are not assigned	 
		ctrl.isNotTreeAssigned = function () {
			var authorizedTree = false;
			if (ctrl.editorialEntity.metaInstanceList !== null && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "REPOSITORY" && _.get(metaInstanceDto.metaDataDTO.referential, 'type') === "TREE" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized && (metaInstanceDto.referentialValueDTOList === null || !metaInstanceDto.referentialValueDTOList.length > 0 || angular.isUndefined(metaInstanceDto.referentialValueDTOList))) {
						authorizedTree = true;
						break;
					}
				}
			}
			return authorizedTree;
		};

		ctrl.isNotMultiSelectListAssigned = function () {
			var authorizedList = false;
			if (ctrl.editorialEntity.metaInstanceList !== null && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "REPOSITORY" && _.get(metaInstanceDto.metaDataDTO.referential, 'type') === "LIST" && metaInstanceDto.mandatory && metaInstanceDto.metaDataDTO.authorized && (metaInstanceDto.referentialTypeListDTOList === null || !metaInstanceDto.referentialTypeListDTOList.length > 0 || angular.isDefined(metaInstanceDto.referentialTypeListDTOList))) {
						authorizedList = true;
						break;
					}
				}
			}
			return authorizedList;
		};


		ctrl.cancel = function () {
			var listMediaIds = [];
			if (ctrl.editorialEntity.metaInstanceList !== null && ctrl.editorialEntity.metaInstanceList.length > 0) {
				for (var i = 0, len = ctrl.editorialEntity.metaInstanceList.length; i <= len - 1; i++) {
					var metaInstanceDto = ctrl.editorialEntity.metaInstanceList[i];
					if (metaInstanceDto !== null && metaInstanceDto.metaDataDTO.metaDataType === "MEDIA") {
						if (metaInstanceDto.listFiles !== null) {
							for (var file in metaInstanceDto.listFiles) {
								listMediaIds.push(file);
							}
						}
					}
				}
			}
			if (listMediaIds !== null && listMediaIds.length > 0) {
				for (i = 0, len = listMediaIds.length; i <= len - 1; i++) {
					var fileId = listMediaIds[i];
					$http({
						url: 'api/editorialEntities/deleteFile/' + fileId,
						method: 'DELETE',
						data: {
							idMedia: fileId
						}
					});
				}
			}
			ctrl.close({
				$value: false
			});
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.onChangeProductGroup = function (ownerGroup) {

			// RESET PERMISSION OF PREVIOUS GROUP
			ctrl.permissions = [];
			if (ownerGroup) {
				entityAuthorizeService.entityTemplatepermissions(ctrl.entity.code, ownerGroup)
					.then(function (permissions) {
						$log.info("group change " + permissions);
						ctrl.permissions = permissions;
					});
			}

			//emit event to system author component when owner group change
			$scope.$broadcast('ownerGroupUpdated', ownerGroup);
		};

		ctrl.isNotEditPossible = function () {
			// CHECK THAT EDIT IS NOT PRESENT AMONG THE LIST 
			return ctrl.permissions.indexOf('EDIT') === -1;
		};

		$scope.$on('titleMaxLengthViolation', function (event, data) {
			ctrl.titleMaxLengthViolation = data;
		});


		// Return true if there is one or more metadata where value not unique constraint is violated
		ctrl.isMetadataUniqueValueViolated = function () {
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		};

		function isMedia() {
			return ctrl.editorialEntity.editorialEntityTemplate.contentType === 'MEDIA';
		}

		//check if all mandatory mounting meta are mentioned
		ctrl.isMandatoryMountingFiltersEmpty = function () {
			return TirFilterSharedService.isMandatoryFiltersEmpty(ctrl.rawFilters);
		};
	}
})();

/* eslint-disable indent */
(function () {
	'use strict';


	angular
		.module('userApp')
		.component('createLink', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-link/create-link.component.html',
			controller: CreateLink,
			bindings: {
				resolve: "<",
				close: '&',
				dismiss: '&',
			},
		});

	/** @ngInject */
	function CreateLink(entityLinkingResource, $log, $sce, relationTemplateResource, blockUI, $filter, $rootScope, LinkEeWizardModalService, EditorialEntityService, $q, MetadataService, SYSTEM_METADATA_IDENTIFIERS, relationshipTemplateWizardService, relationResource) {
		var ctrl = this;

		ctrl.$onInit = function () {
			$log.info("Init create link component");
			ctrl.isLinkedRelation = false;
			ctrl.breadCrumb = [];
			ctrl.searchSolr = undefined;
			ctrl.eeListChecked = [];
			//duplicate meta properties selected on all relations associated to target ee list
			ctrl.multiRelation = true;
			ctrl.enableMultiEETargetSelection = ctrl.resolve.enableMultiEETargetSelection;

			ctrl.rtCode = ctrl.resolve.rtCode;
			ctrl.eeSourceFlashId = ctrl.resolve.eeSourceFlashId;
			ctrl.eeSourceFlashIdTemplateId = ctrl.resolve.eeSourceFlashIdTemplateId;
			ctrl.searchFlashId = ctrl.resolve.searchFlashId;
			ctrl.nodeFlashId = ctrl.resolve.nodeFlashId;
			ctrl.ownerGroup = ctrl.resolve.ownerGroup;
			//
			ctrl.hideMetaDataStep = ctrl.resolve.hideMetaDataStep;
			ctrl.isConfigForReferenceNodeCreation = ctrl.resolve.isConfigForReferenceNodeCreation;
			ctrl.isContainer = ctrl.resolve.isContainer;
			ctrl.linkText = ctrl.resolve.linkText;
			ctrl.nextDisabled = true;
			ctrl.pointToSubElement = {
				value: "not_display"
			};
			ctrl.eeSelected = null;
			ctrl.selected = {
				value: ""
			};
			ctrl.desiredPublicationDate = {
				value: new Date()
			};
			ctrl.selectedValue = {
				id: null
			};

			ctrl.metaDataInstanceDTOList = [];
			initData();

			//WHEN THE STATE IS BEING CHANGED, THE POPUP SHOULD BE CLOSED.
			ctrl.handler = $rootScope.$on('$locationChangeSuccess', function () {
				ctrl.close();
			});
		};

		/**
		 * init ee source details
		 */
		function initEeSourceDetails() {
			if (ctrl.eeSourceFlashId) {
				EditorialEntityService.getEEById({
					id: ctrl.eeSourceFlashId
				}, function (eeSource) {
					ctrl.eeSourceDetails = {
						container: eeSource.editorialEntityTemplate.container,
						metaInstanceList: eeSource.metaInstanceList,
						flashId: eeSource.identifier,
						subNodesId: eeSource.subNodesId
					};
				});
			}
		}

		/**
		 * called when the user selects an entity from tir table (called only when one ee target select enabled).
		 */
		ctrl.eeTargetChosen = function (eeTarget) {
			ctrl.eeTargetSelectedId = eeTarget;
			if (!ctrl.enableMultiEETargetSelection) {
				ctrl.nextDisabled = false;
			}
			checkTargetEEContainsSubElement(eeTarget);
		};

		/**
		 * return targetEntities objects
		 * @param eeFlashIds target entity Id
		 */
		function prepareTargetEntities(eeFlashIds) {

			var deferred = $q.defer();

			blockUI.start();
			entityLinkingResource.verifyLinkConditions({
				eeFlashIds: eeFlashIds
			}).$promise.then(function (response) {
				blockUI.stop();
				//Launch link ee wizard
				var entities = [];
				angular.forEach(response.targetEntities, function (targetEe) {
					entities.push({
						flashId: targetEe.identifier,
						eetCode: targetEe.editorialEntityTemplate.code,
						metaInstanceList: targetEe.metaInstanceList,
						system: targetEe.system
					});
				});
				ctrl.targetEntities = entities;
				deferred.resolve(entities);
			}, function () {
				blockUI.stop();
			});

			return deferred.promise;
		}

		//Function fired when check or uncheck all rows of a page
		ctrl.onSelectAllChange = function () {
			ctrl.onSelectRowChange();
		};

		//Function fired when check ou uncheck row
		ctrl.onSelectRowChange = function (row) {
			var checkedTargetEEIds = ctrl.getTargetEEIds();

			//If one or more EE are checked, then enable next button
			ctrl.nextDisabled = checkedTargetEEIds.length === 0;
			ctrl.pointToSubElement.value = 'not_display';
			if (row) {
				//Set the ee target to display in brandcrumb with the last tee target selected one
				ctrl.eeTargetsWording = row.HTML_MULTI_SYSTEMTITLE;

				//If there is only one target ee, then check id display or not subelement step if this one has subelement
				if (checkedTargetEEIds.length === 1) {
					checkTargetEEContainsSubElement(row.FLASH_ID);
				}
			}

		};

		//Get target ee ids since checked ee list and update next button status
		ctrl.getTargetEEIds = function () {
			var eeTargets = [];
			if (ctrl.enableMultiEETargetSelection) {
				//init ee target list with all ee target checked
				return _.keys(_.pickBy(ctrl.eeListChecked), true);
			} else {
				//init ee target list with the only ee target selected
				if (angular.isDefined(ctrl.eeTargetSelectedId)) {
					eeTargets.push(ctrl.eeTargetSelectedId);
				}

			}
			return eeTargets;
		};

		//
		ctrl.formatSystemTitle = function (titleSystem) {
			return $sce.trustAsHtml(titleSystem);
		};
		ctrl.updateTargetEntities = function () {
			blockUI.start();
			ctrl.isLinkedRelation = false;
			ctrl.multiRelation = true;
			if (ctrl.isContainer) {
				var targetEntityFlashIds = _.map(ctrl.targetEntities, function (targetEntity) {
					return targetEntity.flashId;
				});
				if (targetEntityFlashIds) {
					return relationResource.getContainerSourcesByEntityTarget({
						eeTargetFlashIds: targetEntityFlashIds
					}).$promise.then(function (data) {
						var containerSourcesByEntityTarget = data;
						blockUI.stop();
						_.each(ctrl.targetEntities, function (targetEntity) {
							var targetEntityInfo = _.find(containerSourcesByEntityTarget, function (targetEntityInfo) {
								return targetEntityInfo.eeTargetFlashId === targetEntity.flashId;
							});
							targetEntity.containerSources = targetEntityInfo.containerSources;
							targetEntity.display = targetEntityInfo.suggestedPublicationDate ? true : false;
							if (ctrl.targetEntities.length > 1 && targetEntity.display === true) {
								ctrl.isLinkedRelation = true;
								ctrl.multiRelation = false;
							} else if (ctrl.targetEntities.length === 1) {
								ctrl.isLinkedRelation = false;
								ctrl.multiRelation = true;
							}
							targetEntity.desiredPublicationDate = targetEntityInfo.suggestedPublicationDate ? targetEntityInfo.suggestedPublicationDate : new Date();
						});
						return ctrl.targetEntities;
					});
				}
			}
		};
		/**
 * Go forward or back.
 */
		ctrl.gotoStep = function (newStep) {


			var current = ctrl.currentStep;
			if (newStep === 1) {
				ctrl.eeSelected = null;
				ctrl.nextDisabled = true;
				//CHECK IF THE RT CODE IS PASSED THROUGHT THE PARAMS OR THE NUMBER OF RELATIONS IS EQUAL TO 1
				var isMulti = ctrl.rtCode || (ctrl.relationshipTemplateList && ctrl.relationshipTemplateList.length === 1);
				processSteps(!isMulti);
			}
			if (newStep === 1 && ctrl.withMultipleRelationShips) {
				ctrl.nextDisabled = false;
				ctrl.currentStep = getStepByOrder(newStep);
			} else if (newStep === 2 && !ctrl.getTargetEEIds().length > 0 && ctrl.withMultipleRelationShips) {
				ctrl.nextDisabled = true;
				ctrl.currentStep = getStepByOrder(newStep);
			}
			else {
				ctrl.currentStep = getStepByOrder(newStep);
			}

			if (ctrl.relationshipTemplateSel && ctrl.currentStep.name === 'chooseEditorialEntity') {
				//INIT EE TARGETS CHECKED LIST
				ctrl.eeListChecked = [];
				ctrl.nextDisabled = true;
				if (ctrl.relationshipTemplateSel) {
					//IF THE RELATION AND THE TARGET HAS BEEN SELECTED, WE CAN GET META DATA.
					//IF THERE IS NO METADATA, WE SHOULD REMOVE THE LAST STEP
					getLinkMetaData();
				}

			}
			var targetEEIds = ctrl.getTargetEEIds();
			if (ctrl.currentStep.name === 'enterRelationshipMetadatas' || isLastStep(newStep)) {
				prepareTargetEntities(targetEEIds).then(function (targetEntities) {
					ctrl.targetEntities = targetEntities;
					var referenceNodeCreation = ctrl.targetEntities.length === 1 && ctrl.isConfigForReferenceNodeCreation;
					var subElementEeTargetFlashId = (ctrl.pointToSubElement.value === 'display') && ctrl.targetEntities.length === 1 ? ctrl.selected.value : "";
					if (ctrl.isContainer && ctrl.targetEntities) {
						ctrl.updateTargetEntities().then(function () {
							ctrl.relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationshipTemplateSel, ctrl.metaDataInstanceDTOList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate.value, true, referenceNodeCreation, subElementEeTargetFlashId);
						});
					} else {
						ctrl.relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationshipTemplateSel, ctrl.metaDataInstanceDTOList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate.value, true, referenceNodeCreation, subElementEeTargetFlashId);
					}
				});
			}
			fillBreadCrumValues(current, ctrl.currentStep);

		};

		/**
		 * 
		 */
		ctrl.prepareFirstStep = function (relationshipTemplate) {
			if(ctrl.selectedValue.id) {
				ctrl.searchSolr.searchFullTextDTO = {};
			}
			ctrl.selectedValue.id = relationshipTemplate.id;
			ctrl.relationshipTemplateSel = relationshipTemplate;
			ctrl.pointToSubElement.value = 'not_display';
			//Relationship Metadatas


			//The ability to point to a sub-element. Skip subelement view if the configuration define it or
			//if multiple EE target are selected
			ctrl.skipSecondStep = !relationshipTemplate.subElementsEntityTarget || ctrl.getTargetEEIds().length > 1;

			ctrl.tirId = getTirId(relationshipTemplate);
			ctrl.eeTarget = null;
			ctrl.eeSelected = null;
			ctrl.nextDisabled = false;

			if (ctrl.skipSecondStep) {

				//REMOVE POINT TO SUB ELEMENT STEP
				_.remove(ctrl.steps, function (step) {
					if (step.name === 'pointToSubElement') {
						return step;
					}
				});

				//PUT IN ORDER THE STEPS
				for (var i = 0; i < ctrl.steps.length; i++) {
					ctrl.steps[i].step = i + 1;
				}
			}

		};

		/**
		 * 
		 */
		ctrl.onNodeCheck = function (checkedNode) {
			ctrl.selected.value = checkedNode.id;
		};

		/**
		 * 
		 */
		ctrl.onNodeAction = function (checkedNode) {
			ctrl.selected.value = checkedNode.id;
			ctrl.gotoStep(ctrl.currentStep.step + 1);
		};


		/**
		 * 
		 */
		ctrl.confirm = function () {

			if (ctrl.currentStep.name !== 'enterRelationshipMetadatas') {
				var targetEEIds = ctrl.getTargetEEIds();
				prepareTargetEntities(targetEEIds).then(function (targetEntities) {
					ctrl.targetEntities = targetEntities;
					var referenceNodeCreation = ctrl.targetEntities.length === 1 && ctrl.isConfigForReferenceNodeCreation;
					var subElementEeTargetFlashId = (ctrl.pointToSubElement.value === 'display') && ctrl.targetEntities.length === 1 ? ctrl.selected.value : "";
					ctrl.relations = relationshipTemplateWizardService.initRelations(ctrl.targetEntities, ctrl.relationshipTemplateSel, ctrl.metaDataInstanceDTOList, ctrl.eeSourceDetails, ctrl.multiRelation, ctrl.desiredPublicationDate.value, true, referenceNodeCreation, subElementEeTargetFlashId);
					initAndSaveRelations();
				});
			} else {
				initAndSaveRelations();
			}

		};

		function initAndSaveRelations() {
			//Verify if the targetEE is not already linked to the selected ee.
			var subElementId = angular.isDefined(ctrl.selected.value) && ctrl.selected.value !== null ? ctrl.selected.value : "";
			//Ee source already created.
			if (angular.isDefined(ctrl.eeSourceFlashId) && ctrl.eeSourceFlashId !== null) {
				blockUI.start();
				entityLinkingResource.isLinkedEEList({
					sourceEEFlashId: ctrl.eeSourceFlashId,
					targetEEFlashIds: _.map(ctrl.targetEntities, 'flashId'),
					targetSubElementFlashId: subElementId
				}).$promise.then(function (linksInfoList) {
					blockUI.stop();

					var alreadyLinkedList = [];
					_.each(linksInfoList, function (linksInfos) {
						if (linksInfos !== null && linksInfos.alreadyLinked) {
							alreadyLinkedList.push(linksInfos);
						}
					});

					if (alreadyLinkedList.length > 0) {
						ctrl.isLinkedRelation = true;
						//Launch confirmation modal
						//Report already linked targets only (as a warning)
						LinkEeWizardModalService.openLinkEesWarningModal(alreadyLinkedList, false, null).then(function (confirm) {
							if (confirm) {
								saveRelations();
							}
						});
					} else {
						//Do save the relation
						saveRelations();
					}
				}, function () {
					blockUI.stop();
				});
			} else {
				saveRelations();
			}
		}


		ctrl.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};


		//========================================================================================================================
		//=====================  private function ==> to be transformed in service ============================================
		//========================================================================================================================


		/**
		 * Init data.
		 */
		function initData() {

			initEeSourceDetails();

			if (angular.isDefined(ctrl.rtCode) && ctrl.rtCode !== null) {
				blockUI.start();
				relationTemplateResource.getRelationshipTemplateWithEetMeta({
					rtCode: ctrl.rtCode,
					eeFlashId: ctrl.eeSourceFlashId
				}).$promise.then(function (data) {
					ctrl.relationshipTemplateSel = data;
					processSteps(false);
					blockUI.stop();
				}, function () {
					blockUI.stop();
				});
			} else if (angular.isDefined(ctrl.eeSourceFlashId) && ctrl.eeSourceFlashId !== null) {

				blockUI.start();
				//Get the list of relationships where the editorial entity is source
				relationTemplateResource.getRelationshipTemplateDTOListByEetSource({
					eeSourceFlashId: ctrl.eeSourceFlashId
				}).$promise.then(function (data) {
					ctrl.relationshipTemplateList = data;
					if (ctrl.relationshipTemplateList.length === 1) {
						//The step of selecting a target editorial entity is directly displayed
						ctrl.relationshipTemplateSel = ctrl.relationshipTemplateList[0];
						// ctrl.metaDataInstanceDTOList = ctrl.relationshipTemplateSel.metaInstanceList;
						processSteps(false);
					} else {
						processSteps(true);
					}
					blockUI.stop();
				}, function () {
					blockUI.stop();
				});
				//Get ee source system title
				blockUI.start();
				MetadataService.getSystemMetaValue(SYSTEM_METADATA_IDENTIFIERS.systemTitle, ctrl.eeSourceFlashId, 'ENTITY').$promise.then(function (data) {
					ctrl.eeSourceSystemTitle = data.body;
					blockUI.stop();
				}, function () {
					blockUI.stop();
				});
			}
			ctrl.show = true;
		}

		/**
 * If there is custom tir found for eeSource return it otherwise retour default tir one
		 * @param relationshipTemplate
		 * @returns {*}
		 */
		function getTirId(relationshipTemplate) {

			var customTirFound = _.find(relationshipTemplate.relationshipTemplateCustomTirs, function (customTir) {
				return customTir.editorialEntityTemplateSourceId === ctrl.eeSourceFlashIdTemplateId;
			});
			return customTirFound ? customTirFound.searchInterfaceTemplateId.toString() : ctrl.relationshipTemplateSel.idTIR;
		}


		/**
		 * Process the steps based on type of relation ship.
		 */
		function processSteps(isMulti) {
			if (!isMulti) {
				ctrl.skipSecondStep = !ctrl.relationshipTemplateSel.subElementsEntityTarget;
				ctrl.tirId = getTirId(ctrl.relationshipTemplateSel);
				if (ctrl.skipSecondStep) {
					prepareSteps(["chooseEditorialEntity", "enterRelationshipMetadatas"], false);
				} else {
					prepareSteps(["chooseEditorialEntity", "pointToSubElement", "enterRelationshipMetadatas"], false);
				}
				ctrl.withOneRelationShip = true;

				//IF THERE'S ONE RELATION SHIP, ==> WE CAN START LOOKING FOR THE METADATA
				getLinkMetaData();

			} else {
				prepareSteps(["chooseRelationship", "chooseEditorialEntity", "pointToSubElement", "enterRelationshipMetadatas"], true);
				ctrl.withMultipleRelationShips = true;
			}

		}

		/**
		 * Prepare list of steps
		 */
		function prepareSteps(steps, isMulti) {
			ctrl.steps = [];
			var i = 1;
			_.forEach(steps, function (s) {
				ctrl.steps.push({
					step: i,
					name: s
				});
				i += 1;
			});
			ctrl.currentStep = ctrl.steps[0];
			if (angular.isDefined(ctrl.hideMetaDataStep) && ctrl.hideMetaDataStep === true) {
				//Hide entering metadatas step
				ctrl.steps.pop();
			}

			//INTI BREADCRUM VALUES
			initBreadCrumb(ctrl.steps, isMulti);
		}

		/**
		 * Save the relation
		 */
		function saveRelations() {

			_.each(ctrl.relations, function (relation) {

				if (ctrl.multiRelation) {
					relation.metaInstanceDTOList = angular.copy(ctrl.metaDataInstanceDTOList);
					relation.desiredPublicationDate = angular.copy(ctrl.desiredPublicationDate.value);
				}

				//Display 'no title' for relation wording if EE target has no title
				relation.wording = isEmptyTitle(relation.wording) ?
					'userApp.editorialEntity.home.noTitle' : relation.wording;
			});

			ctrl.close({
				$value: ctrl.relations
			});
		}

		function isLastStep(stepIndex) {
			return ctrl.steps.length === stepIndex;
		}

		function isEmptyTitle(title) {
			return !title || _.isEmpty(_.trim(title));
		}

		/**
		 * Parse the system title html content.
		 */
		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};


		/**
		 * Get next step
		 */
		function getStepByOrder(step) {
			return _.find(ctrl.steps, ['step', step]);
		}

		/**
		 * Check if the target editorial entity contains structure and content nodes
		 */
		function checkTargetEEContainsSubElement(eeTargetId) {
			ctrl.containsSubElement = {
				contains: false
			};

			blockUI.start();
			EditorialEntityService.getEEWithFirstLevelChildNodesById({
				id: eeTargetId
			}, function (data) {
				ctrl.eeTarget = data;
				ctrl.typeEE = data.editorialEntityTemplate.contentType;
				if (ctrl.typeEE === 'TREE') {
					angular.forEach(ctrl.typeEE.subElements, function (subNode) {
						if (subNode.type === 'STRUCTURAL' || subNode.type === 'CONTENT') {
							ctrl.containsSubElement.contains = true;
							return;
						}
					});
				}
				blockUI.stop();
			}, function () {
				blockUI.stop();
			});
		}

		function getLinkMetaData() {
			blockUI.start();
			MetadataService.linkingMetadata(ctrl.relationshipTemplateSel.code, ctrl.isConfigForReferenceNodeCreation, ctrl.eeSourceFlashId)
				.then(function (data) {
					ctrl.metaDataInstanceDTOList = angular.copy(data);
					//IF THERE IS NO METADATA WE SHOULD SKIP THE LAST STEP.
					if (_.isEmpty(ctrl.metaDataInstanceDTOList)) {
						//CHECK IF THE LAST STEP HAS NOT ALREADY REMOVED
						if (!ctrl.hideMetaDataStep) {
							_.remove(ctrl.steps, function (step) {
								if (step.name === 'enterRelationshipMetadatas') {
									return step;
								}
							});
						}
					}
					blockUI.stop();
			});
		}


		//INTI BREADCRUMB WITH STEPS
		function initBreadCrumb(step, isMulti) {
			ctrl.breadCrumb = [{ step: 'chooseRelationship' }, { step: 'chooseEditorialEntity' }];

			//IF THERE'S ONE RELATION, THE FIRST STEP IS ALWAY SKIPPED
			//WE SHOULD HARD CODED THE VALUE.
			if (!isMulti) {
				ctrl.breadCrumb[0].value = ctrl.relationshipTemplateSel.wording;
			}
		}



		/**
		 * Fill breadCrumb with the new values.
		 */
		function fillBreadCrumValues(currentStep, nextStep) {

			var value = undefined;
			switch (currentStep.name) {
				case 'chooseRelationship': value = ctrl.relationshipTemplateSel.wording; break;
				case 'chooseEditorialEntity':
					if (ctrl.getTargetEEIds().length > 1) {
						value = ctrl.getTargetEEIds().length + " " + $filter('translate')('userApp.searchInterfaceTemplate.home.selectedElements');
					} else {
						value = ctrl.eeTargetsWording ? ctrl.eeTargetsWording.replace(/(<([^>]+)>)/ig, "") : '';
					}
					break;
			}

			ctrl.breadCrumb = _.map(ctrl.breadCrumb, function (s) {
				if ((s.step === currentStep.name) && (currentStep.step < nextStep.step)) {
					return { step: currentStep.name, value: value };
				}
				//IF NEXT STEP MATCH WE SHOULD RESET OLD VALUES
				else if (s.step === nextStep.name) {
					return { step: nextStep.name };
				}
				else {
					return s;
				}
			});

		}

		/**
		 * Return true if there is one or more metadata where value not unique constraint is violated
		 */
		ctrl.isMetadataUniqueValueViolated = function () {

			var metaInstanceList = [];
			//case when have more than one targets and every target has its self relations (!multirelation)
			if (angular.isDefined(ctrl.targetEntities) && ctrl.targetEntities.length > 1 && !ctrl.multiRelation) {
				metaInstanceList = _.flatMap(ctrl.relations, function (relation) {
					return relation.metaInstanceDTOList;
				});
			} else {
				metaInstanceList = ctrl.metaDataInstanceDTOList;
			}
			//return true if exist one or more metadata that constraint value not unique is not respected
			return _.findIndex(metaInstanceList, function (metaInstance) {
				return angular.isDefined(metaInstance.displayNotUniqueValueErrorMsg) && metaInstance.displayNotUniqueValueErrorMsg;
			}) > -1;
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('createLinkService', CreateLinkService);

	/** @ngInject */
	function CreateLinkService() {
		var service = {
			getConfigForEditorialEntityCreation: getConfigForEditorialEntityCreation,
			getConfigForReferenceNodeCreation: getConfigForReferenceNodeCreation,
			deleteHtmlTags: deleteHtmlTags,
			getConfigForTextEditor: getConfigForTextEditor,

		};

		//Return link wizard modal configuration.
		var commonConfig = {
			//templateUrl: 'scripts/components/util/linkingWizard/partials/linkingWizard.html',
			//controller: 'LinkingWizardModalCtrl',
			component: 'createLink',
			windowClass: 'modal-full-screen ecm-content create-link',
			class: 'test',
			backdrop: 'static',
			resolve: {
				currentUser: ['userResource', function (userResource) {
					return userResource.getCurrentUser().$promise;
				}],
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('linkingWizard');
					$translatePartialLoader.addPart('editorialEntity');
					$translatePartialLoader.addPart('searchInterfaceTemplate');
					$translatePartialLoader.addPart('user');
					$translatePartialLoader.addPart('datepicker');
					return $translate.refresh();
				}]
			}
		};

		return service;

		//
		function getConfigForEditorialEntityCreation(eeSourceFlashId, rtCode) {
			return _.merge({}, commonConfig, {
				resolve: {
					rtCode: function () {
						return rtCode;
					},
					eeSourceFlashId: function () {
						return eeSourceFlashId;
					},
					linkText: function () { },
					enableMultiEETargetSelection: function () {
						return false;
					},
					hideMetaDataStep: function () { },
					isConfigForReferenceNodeCreation: function () {
						return false;
					},
					isContainer: function () { },
					searchFlashId: function () { },
					nodeFlashId: function () { },

				}
			});
		}

		function getConfigForReferenceNodeCreation(eeSourceFlashId, isContainer, nodeFlashId /* when the linking took place in structural node*/, ownerGroup, eeSourceFlashIdTemplateId) {
			return _.merge({}, commonConfig, {
				resolve: {
					rtCode: function () { },
					eeSourceFlashIdTemplateId: function () {
						return eeSourceFlashIdTemplateId;
					},
					eeSourceFlashId: function () {
						return eeSourceFlashId;
					},
					ownerGroup: function () {
						return ownerGroup;
					},
					enableMultiEETargetSelection: function () {
						return true;
					},
					linkText: function () { },
					hideMetaDataStep: function () { },
					isConfigForReferenceNodeCreation: function () {
						return true;
					},
					isContainer: function () {
						return isContainer;
					},
					searchFlashId: function () {
						return eeSourceFlashId;
					},
					nodeFlashId: function () {
						return nodeFlashId;
					},
				}
			});
		}


		function deleteHtmlTags(html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "").replace(/&nbsp;/g, '');
			}
		}

		//
		function getConfigForTextEditor(rtCode, eeSourceFlashId, linkText, hideMetaDataStep) {
			return _.merge({}, commonConfig, {
				windowClass: 'modal-full-screen ecm-content ecm-in-editor',
				resolve: {
					rtCode: function () {
						return rtCode;
					},
					eeSourceFlashId: function () {
						return eeSourceFlashId;
					},
					linkText: function () {
						return deleteHtmlTags(linkText);
					},
					enableMultiEETargetSelection: function () {
						return false;
					},
					hideMetaDataStep: function () {
						return hideMetaDataStep;
					},
					isConfigForReferenceNodeCreation: function () {
						return false;
					},
					isContainer: function () { },
					searchFlashId: function () { },
					nodeFlashId: function () { },
				}
			});
		}

	}

})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('createIntraLink', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/create-intra-link/create-intra-link.component.html',
			controller: CreateIntraLink,
			bindings: {
				resolve: "<",
				close: '&',
				dismiss: '&',
			},
		});

	/** @ngInject */
	function CreateIntraLink($log, entityOperationResource) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.trCode = ctrl.resolve.rtCode;
			ctrl.eeSourceFlashId = ctrl.resolve.eeSourceFlashId;
			ctrl.nextDisabled = true;
			ctrl.resolve.trees.$promise.then(function (data) {
				ctrl.parents = data;
				prepareSteps();
			});

			ctrl.resolve.teeCodes.$promise.then(function (data) {
				ctrl.teeCodes = data;
			});


			//LIST OF THE STEPS
			ctrl.steps = [];
			ctrl.selectedParent;
			ctrl.entity;
			ctrl.selectedElement;


		};


		//GET ALL THE ELEMENT OF SELECTED PARENT
		ctrl.getParentStructure = function () {

			if (ctrl.selectedParent) {
				entityOperationResource.getEntityStructure({ flashId: ctrl.selectedParent.identifier })
					.$promise.then(function (data) {
						ctrl.entity = data;
						ctrl.currentStep = findStepByName('chooseEeFromTree');
						ctrl.nextDisabled = false;
					});
			}
		};

		//GO FORWARD AND BACK
		ctrl.gotoStep = function (forward, back) {
			var stepId = ctrl.currentStep.id;
			if (forward && stepId < ctrl.steps.length) {
				var nextStep = findStepByStepId(stepId + 1);
				if (nextStep.name === 'chooseEeFromTree') {
					ctrl.getParentStructure();
				}
				else {
					ctrl.currentStep = nextStep;
				}
			}

			if (back && stepId > 1) {
				var previousStep = findStepByStepId(stepId - 1);
				if (previousStep.name === 'chooseTree') {
					ctrl.nextDisabled = true;
					ctrl.selectedParent = undefined;
				}
				ctrl.currentStep = findStepByStepId(stepId - 1);
			}

		};

		//THE PARENT HAS BEEN CHOSEN
		ctrl.parentChosen = function (selectedParent) {
			if (selectedParent) {
				ctrl.selectedParent = selectedParent;
				ctrl.nextDisabled = false;
			}
		};

		//THE BACK THE CREATED RELATION TO EDITOR
		ctrl.confirm = function () {
			var relation = {};
			relation.eeSourceFlashId = ctrl.eeSourceFlashId;
			relation.eeTargetFlashId = ctrl.selectedElement.targetId;
			relation.wording = ctrl.selectedElement.text; //THE META SYSTEM systemTitle
			relation.eeTargetCode = ctrl.selectedElement.teeCode;
			ctrl.close({
				$value: relation
			});
		};


		//PREPARE THE LIST OF STEPS
		function prepareSteps() {



			if (_.isEmpty(ctrl.parents)) {
				ctrl.noSourceFound = true;
			}

			//IF THERE IS ONE PARENT, THE FIRST STEP WILL BE SKIPPED
			else if (ctrl.parents && ctrl.parents.length === 1) {
				ctrl.selectedParent = ctrl.parents[0];
				ctrl.steps.push({ id: 1, name: 'chooseEeFromTree' });
				ctrl.getParentStructure();
			}
			else {
				ctrl.steps.push({ id: 1, name: 'chooseTree' }, { id: 2, name: 'chooseEeFromTree' });
				//INIT CURRENT STEP
				ctrl.currentStep = ctrl.steps[0];
			}


		}


		function findStepByStepId(stepId) {
			return _.find(ctrl.steps, ['id', stepId]);
		}

		function findStepByName(name) {
			return _.find(ctrl.steps, ['name', name]);
		}


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('createIntraLinkService', CreateIntraLinkService);

	/** @ngInject */
	function CreateIntraLinkService(entityOperationResource) {
		var service = {
			getIntraLinkConfiguration: getIntraLinkConfiguration,

		};

		var commonConfig = {
			component: 'createIntraLink',
			windowClass: 'modal-full-screen ecm-content ecm-in-editor',
			class: 'test',
			backdrop: 'static',
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('linkingWizard');
					return $translate.refresh();
				}]
			}
		};

		return service;



		//CREATE A BUNCH OF CONFIG FOR THE INTRAT LINK MODAL
		function getIntraLinkConfiguration(rtCode, targetFlashId) {
			return _.merge({}, commonConfig, {

				resolve: {
					rtCode: function () {
						return rtCode;
					},
					eeSourceFlashId: function () {
						return targetFlashId;
					},
					trees: function () {
						return entityOperationResource.getListOfParent({ targetFlashId: targetFlashId });
					},
					teeCodes: function () {
						return entityOperationResource.getRelationTargetTeeCode({ rtCode: rtCode });
					}
				}
			});
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editMetadataFormModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/edit-metadata-form-modal.html',
			controller: editMetadataModalController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function editMetadataModalController($log, EDITORIAL_ELEMENT_TYPE, editMetaUseCaseConstants) {

		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.editMetaUseCase = editMetaUseCaseConstants.editMeta;
			ctrl.notUnlockAfterSaveMeta = ctrl.resolve.notUnlockAfterSaveMeta;
			ctrl.maxSizeMedia = ctrl.resolve.maxSizeMedia.maxSize;
			ctrl.metaDataByMetaGroup = ctrl.resolve.metaInstanceByMetaGroup;
			ctrl.flashId = ctrl.resolve.flashId;
			ctrl.isAcceptProposal = ctrl.resolve.isAcceptProposal;
			ctrl.type = ctrl.resolve.type;
			ctrl.isRelation = _.isEqual(ctrl.type, EDITORIAL_ELEMENT_TYPE.relation);
			ctrl.isProduct = _.isEqual(ctrl.type, EDITORIAL_ELEMENT_TYPE.product);
			ctrl.editorialEntity = ctrl.resolve.entity;
			ctrl.productCode = ctrl.resolve.productCode.code;
			ctrl.autoRedirect = ctrl.resolve.autoRedirect;
			if (!ctrl.isRelation && !ctrl.isProduct) {
				ctrl.codeEet = ctrl.resolve.codeEET.eetCode;
				ctrl.eetId = ctrl.resolve.entityTemplateId.eetId;
			}
			ctrl.currentUser = ctrl.resolve.currentUser;
			ctrl.modalTitle = ctrl.resolve.modalTitle;
			ctrl.currentProducts = ctrl.resolve.currentProducts;
			ctrl.allModels = ctrl.resolve.allModels;
			ctrl.productSuggestedPublicationDate = ctrl.resolve.productSuggestedPublicationDate;
			ctrl.lockSource = ctrl.resolve.lockSource;
		};
		ctrl.onClose = function ($value) {
			ctrl.close({ $value: $value });
		};
		ctrl.onDismiss = function ($value) {
			ctrl.dismiss({ $value: $value });
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editMetadataFormComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/edit-metadata-form.html',
			controller: editMetadataFormController,
			bindings: {
				maxSizeMedia: '<',
				metaDataByMetaGroup: '<',
				flashId: '<',
				isAcceptProposal: '<',
				type: '<',
				entity: '<',
				productCode: '<',
				autoRedirect: '<',
				codeEet: '<',
				modalTitle: '<',
				allModels: '<',
				currentProducts: '<',
				lockSource: '<',
				currentUser: '<',
				eetId: '<',
				productSuggestedPublicationDate: '<',
				editMetaUseCase: '<?',
				onEntityConverted: '&?',
				onClose: '&',
				onDismiss: '&',
				notUnlockAfterSaveMeta: '<'
			},
		});

	/** @ngInject */
	function editMetadataFormController($rootScope, $state, $timeout, $scope, $filter, modelService, convertEntityService, EditorialEntityService, entityLockService, entityFetchResource, metadataValidationService, editWorkflowModalService, $translate, $window, editMetaDataModalService, blockUI, EDITORIAL_ELEMENT_TYPE, ENTITY_RESOURCE_TYPE, publishService, editProductsService, metaMediaService, validateHtmlContentModalService, htmlPreviewService, OpenNewTabService, ermService, confirmModalService, validateEntityService, publishEeFormModalService, userPreferenceService, deleteEntityService, editMetaUseCaseConstants) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.lang = $translate.use();
			ctrl.errorExistEntityWithSomeMetaDiscriminants = false;
			ctrl.allOriginalModels = ctrl.allModels;
			ctrl.isRelation = _.isEqual(ctrl.type, EDITORIAL_ELEMENT_TYPE.relation);
			ctrl.isProduct = _.isEqual(ctrl.type, EDITORIAL_ELEMENT_TYPE.product);
			ctrl.isEntity = _.isEqual(ctrl.type, EDITORIAL_ELEMENT_TYPE.entity);
			ctrl.editorialEntity = ctrl.entity;
			ctrl.autoRedirect = angular.isDefined(ctrl.autoRedirect) ? ctrl.autoRedirect : true;
			if (!ctrl.isRelation && !ctrl.isProduct) {
				ctrl.codeEET = ctrl.codeEet;
				ctrl.eetId = ctrl.eetId;
			}
			if (ctrl.isProduct) {
				// Init desired publication date
				ctrl.initSuggestedPublicationDate();
			}
			ctrl.currentUser = ctrl.currentUser;

			// FORM TYPE
			ctrl.isForm = ctrl.editorialEntity && ctrl.editorialEntity.editorialEntityTemplate.formular;
			ctrl.metaDatas = _.flatMap(ctrl.metaDataByMetaGroup, function (metaGroup) { return metaGroup.metaDataInstanceDTOList; });
			ctrl.metaDatas = sortMetaByDisplayOrder(ctrl.metaDatas);
			ctrl.isEmptyMetaDataByMetaGroupList = _.isEmpty(ctrl.metaDataByMetaGroup);
			ctrl.showEmptyMetaDataListMessage = !ctrl.isForm && !ctrl.isProduct && !ctrl.isEntity && ctrl.isEmptyMetaDataByMetaGroupList;

			if (ctrl.isForm) {

				ctrl.entityAlreadySaved = false;

				if (ctrl.modalTitle) {
					ctrl.modalTitle = ctrl.modalTitle;
				} else {
					ctrl.modalTitle = ctrl.isFormEntityCreation() ? 'userApp.editorialEntity.home.createLabel' : 'userApp.editMetaData.home.editLabelForm';
				}

				ctrl.addContentAfterCode = ctrl.editorialEntity.editorialEntityTemplate.addContentLater;

				// ENTITY TITLE
				ctrl.entityTitle = ctrl.editorialEntity.system.systemTitle;

				//if ee formular creation,
				if (ctrl.isFormEntityCreation()) {
					//init principal product if not exist
					if (angular.isUndefined(ctrl.editorialEntity.ownerGroup)) {
						ctrl.editorialEntity.ownerGroup = ctrl.currentUser.userGroups.length === 1 ? ctrl.currentUser.userGroups[0].code.toString() : '';
					}
					if (angular.isUndefined(ctrl.editorialEntity.modelFlashId)) {
						ctrl.editorialEntity.modelFlashId = "NOMODEL";
					}
					//reset systemAuthors to that it can be init correctly
					ctrl.editorialEntity.system.systemAuthors = [];
					//INIT MODEL LIST
					ctrl.initModels();

				}
			} else {
				ctrl.modalTitle = ctrl.modalTitle ? ctrl.modalTitle : 'userApp.editMetaData.home.editLabel';
			}

			//Get all proposal products
			if (ctrl.isEntity && ctrl.codeEET) {
				editProductsService.getProposalProducts(ctrl.codeEET)
					.then(function (data) {
						if (ctrl.isFormEntityCreation()) {
							ctrl.proposalProducts = data;
						} else {
							ctrl.proposalProducts = editProductsService.filterProposals(data, ctrl.currentProducts);
						}
						// INIT PROPOSALS
						ctrl.allProposalProducts = _.cloneDeep(ctrl.proposalProducts);
					});
			}

			//RULE : LOCK ENTITY IF IT'S NOT ALREADY LOCKED
			entityLockService.isSourceEntityLocked(ctrl.flashId, ctrl.type)
				.then(function (locked) {
					ctrl.locked = locked;
					if (!ctrl.locked) {
						entityLockService.lockSourceEntity(ctrl.flashId, ctrl.type);
					}
				});
			//Check if there is a xslt to show preview html content
			if (ctrl.editorialEntity) {
				ermService.checkConfigExits(ctrl.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.proofReading)
					.then(function (data) {
						ctrl.isFullPreviewPossible = data.exist === "true";
					});
			}
			//load data when a default model is selected
			if (ctrl.isFormEntityCreation() && ctrl.editorialEntity.modelFlashId !== 'NOMODEL') {
				ctrl.loadMetaInstance();
			}
		};

		ctrl.initModels = function () {
			var mapAllModels = [];
			if (angular.isDefined(ctrl.allModels)) {
				mapAllModels = _.mapValues(_.keyBy(ctrl.allModels, 'flashId'), function (m) {
					//add model visibility to label
					if (m.modelVisibility) {
						var isDefault = m.defaultModel ? '*' : '';
						var visibility = $filter('translate')(m.modelVisibility === 'SHARED' ? m.modelVisibility + '_SHORT' : m.modelVisibility);
						return visibility + ' - ' + m.name + isDefault;
					}
					return m.name;
				});
			}
			ctrl.allModels = mapAllModels;
			ctrl.allModelsSize = Object.keys(ctrl.allModels).length;
			//if it is workcopy of ee type FORMULAR, then force set default model
			if (ctrl.isFormEntityCreation()) {
				ctrl.editorialEntity.modelFlashId = setDefaultModelFlashId();
			}
		};

		function setDefaultModelFlashId() {
			var sharedDefaultModels = _.filter(ctrl.allOriginalModels, function (model) {
				return model.defaultModel;
			});
			if (sharedDefaultModels.length > 0) {
				return sharedDefaultModels[0].flashId;
			}
			else {
				return 'NOMODEL';
			}
		}

		ctrl.initSuggestedPublicationDate = function () {
			var suggestedPublicationDate = ctrl.productSuggestedPublicationDate.date;
			if (suggestedPublicationDate) {
				ctrl.productSuggestedPublicationDate = new Date(suggestedPublicationDate);
			} else if (ctrl.isAcceptProposal) {
				ctrl.productSuggestedPublicationDate = new Date();
			}
		};

		//Remove principal product (by code) from proposal list
		function refreshProposals(proposals, principalProductCode) {
			return _.filter(proposals, function (p) {
				return p.id !== principalProductCode;
			});
		}

		ctrl.onChangeProductGroup = function (ownerGroup) {
			if (ctrl.isForm && ctrl.productCode !== ctrl.editorialEntity.ownerGroup) {
				//Delete all associations from db and reset proposals table
				if (ctrl.proposalProducts.length > 0) {
					editProductsService.deleteProposals(ctrl.editorialEntity.identifier)
						.then(function (result) {
							ctrl.currentProducts = [];
							// Refresh proposal dropdown list
							ctrl.proposalProducts = refreshProposals(ctrl.allProposalProducts, ownerGroup);
						});
				}

				//emit event to system author component when owner group change
				$rootScope.$broadcast('ownerGroupUpdated', ownerGroup);

				//UPDATE PRODUCT CODE
				ctrl.productCode = ownerGroup;
				$timeout(function () {
					if (ctrl.contentAdapter) {
						ctrl.contentAdapter.refreshTabModels();
					}
				});
			}
		};

		function isContextualProduct() {

			return userPreferenceService.getUserGlobalPreference('OwnerGroup') &&
				ctrl.editorialEntity.ownerGroup === userPreferenceService.getUserGlobalPreference('OwnerGroup');
		}


		//When model change, reload associated meta metas and ownerGroup
		ctrl.loadMetaInstance = function () {
			ctrl.loaded = false;
			modelService.loadMetaInstantiation({
				codeTEE: ctrl.editorialEntity.editorialEntityTemplate.code,
				modelFlashId: ctrl.editorialEntity.modelFlashId,
				allMetas: true
			}).$promise.then(function (data) {
				ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList = data;
				ctrl.metaDatas = ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList;
				//Force save entity to refresh ee form content
				ctrl.saveEntityForm(true).then(function () {
					if (ctrl.editorialEntity.modelFlashId && ctrl.editorialEntity.modelFlashId !== '' && ctrl.editorialEntity.modelFlashId !== 'NOMODEL') {
						//get owner group from model when a model is chosen
						modelService.getModel({
							modelFlashId: ctrl.editorialEntity.modelFlashId
						}).$promise.then(function (data) {
							//Override entity owne rgroup by model owner group only if entity
							// owner group is not equal contextual product
							if (!isContextualProduct()) {
								ctrl.editorialEntity.ownerGroup = data.system.systemOwnerGroup;
								$rootScope.$broadcast("load_product_associations");
							}
							ctrl.metaDatas = sortMetaByDisplayOrder(ctrl.metaDatas);
						});
					} else {
						ctrl.editorialEntity.ownerGroup = undefined;
					}
					if (ctrl.isForm) {
						$rootScope.$broadcast("refresh_editor", ctrl.editorialEntity.modelFlashId);
					}
				});
			});
		};

		ctrl.isFormEntityCreation = function () {
			return ctrl.editorialEntity && ctrl.editorialEntity.editorialEntityTemplate.formular && ctrl.editorialEntity.workCopy && ctrl.editorialEntity.deleted;
		};

		ctrl.isEntityPublished = function () {
			return ctrl.editorialEntity && ctrl.editorialEntity.system && ctrl.editorialEntity.system.systemPublished;
		};

		// To know if load meta data is called
		ctrl.isMetaInstanceReloaded = function () {
			return ctrl.isFormEntityCreation() && ctrl.editorialEntity && ctrl.editorialEntity.modelFlashId !== "NOMODEL";
		};

		//Reset error msg of all discriminant meta data if already shown
		$rootScope.$on('$destroy', $rootScope.$on('reset_discriminant_meta_value_error_msg', function () {

			//if error messages shown, rest all them
			if (ctrl.errorExistEntityWithSomeMetaDiscriminants) {
				_.each(ctrl.metaDatas, function (metaInstance) {
					ctrl.errorExistEntityWithSomeMetaDiscriminants = false;
					if (metaInstance.discriminant === true) {
						metaInstance.errorExistMetaDiscriminants = false;
					}
				});
			}
		}));

		ctrl.saveEntityForm = function (keepMetaModalOpen, openPreviewTab) {
			ctrl.editorialEntity.metaInstanceList = ctrl.metaDatas;
			ctrl.editorialEntity.titleSystem = ctrl.htmlTitle;
			return metaMediaService.createMetaDataMedia(ctrl.editorialEntity.metaInstanceList).then(function () {
				return EditorialEntityService.save(ctrl.editorialEntity).$promise.then(function (data) {
					return data;
				}).then(function (ee) {
					blockUI.stop();
					// $rootScope.$broadcast("refresh_entity", {eeFlashId: ee.identifier});
					if (openPreviewTab) {
						$rootScope.$broadcast("open_preview_tab_after_refresh_entity");
					}

					if (!keepMetaModalOpen) {
						if (ctrl.autoRedirect) {
							$state.go('editorialEntity', {
								id: ee.identifier
							});
						}
						//Close modal
						ctrl.onClose({ $value: ee });
					}

					return true;
				});

			}).catch(function (error) {
				$scope.editForm.$setPristine();
				blockUI.stop();
			});
		};

		ctrl.$onDestroy = function () {
		};
		ctrl.isNotAllMediasAssigned = function () {
			return metadataValidationService.isNotAllMediasAssigned(ctrl.metaDataByMetaGroup);
		};

		ctrl.isMetadataUniqueValueViolated = function () {
			return metadataValidationService.isMetadataUniqueValueViolated(ctrl.metaDataByMetaGroup);
		};


		//verify if all the metaDataInstances "Repository"  type tree are not assigned
		ctrl.isNotTreeAssigned = function () {
			return metadataValidationService.isNotTreeAssigned(ctrl.metaDataByMetaGroup);
		};

		ctrl.isNotMultiSelectListAssigned = function () {
			return false;
		};

		ctrl.isInputTouched = false;

		ctrl.validateAndSave = function (keepMetaModalOpen, openPreviewTab, form) {

			var discriminantsMetas = _.filter(ctrl.metaDatas, function (metaInstance) {
				return metaInstance.discriminant === true;
			});

			if (discriminantsMetas.length > 0) {
				blockUI.start();
				validateEntityService.checkIfEntityExistWithSomeDiscriminants(ctrl.metaDatas, ctrl.editorialEntity.editorialEntityTemplate.code, ctrl.flashId)
					.$promise.then(function (data) {
						ctrl.errorExistEntityWithSomeMetaDiscriminants = data.exist;
						if (!ctrl.errorExistEntityWithSomeMetaDiscriminants) {
							ctrl.save(keepMetaModalOpen, openPreviewTab, form);
						} else {
							_.each(ctrl.metaDatas, function (metaInstance) {
								if (metaInstance.discriminant === true) {
									metaInstance.errorExistMetaDiscriminants = true;
								}
							});
							blockUI.stop();
						}
					});

			} else {
				blockUI.start();
				ctrl.save(keepMetaModalOpen, openPreviewTab, form);
			}
		};

		ctrl.save = function (keepMetaModalOpen, openPreviewTab, form) {
			if (!form || !ctrl.saveDisabled(form)) {
				//DISABLE SAVE IF VALIDATION UNICITY TAGS FAILS
				ctrl.isInputTouched = $rootScope.isInputTouched;
				if (ctrl.isInputTouched !== true) {
					ctrl.isInputTouched = false;
					//RULE : CANCEL LOCK WHEN FINISH AND LOCKED FOR THIS EDITION

					if (ctrl.locked && !ctrl.notUnlockAfterSaveMeta && !ctrl.isForm) {
						return entityLockService.unlockSourceEntity(ctrl.flashId, ctrl.type)
							.then(function () {
								return ctrl.onSave(keepMetaModalOpen, openPreviewTab);
							});
					} else {
						return ctrl.onSave(keepMetaModalOpen, openPreviewTab);
					}
				}
				ctrl.isInputTouched = false;
			}
			else {
				blockUI.stop();
			}
		};

		ctrl.setContentAdapter = function (adapter) {
			ctrl.contentAdapter = adapter;
		};

		ctrl.saveMetadata = function (keepMetaModalOpen, openPreviewTab) {
			return metaMediaService.editMetaMediaByGroup(ctrl.metaDataByMetaGroup).then(function (data) {
				//SAVE METADATA
				return editMetaDataModalService.saveMetadata(ctrl.flashId, ctrl.type, ctrl.metaDataByMetaGroup, ctrl.productSuggestedPublicationDate)
					.then(function (metadataInstances) {
						blockUI.stop();
						if (ctrl.editMetaUseCase === editMetaUseCaseConstants.editMeta) {
							$rootScope.$broadcast("refresh_entity");
							$rootScope.$broadcast("refresh_preview");
							$rootScope.$broadcast("refresh_overloaded_preview");
							if (openPreviewTab) {
								$rootScope.$broadcast("open_preview_tab_after_refresh_entity");
							}
							if (angular.isUndefined(keepMetaModalOpen) || !keepMetaModalOpen) {
								ctrl.onClose({
									$value: {
										metaDataByMetaGroup: ctrl.metaDataByMetaGroup,
										metadataInstances: metadataInstances,
										productSuggestedPublicationDate: ctrl.productSuggestedPublicationDate
									}
								});
							}
							return true;
						} else {
							ctrl.onEntityConverted();
							$state.go('editorialEntity', { id: ctrl.flashId }, { reload: true });
							ctrl.onDismiss({ $value: false });
						}
					});
			});
		};

		ctrl.saveForm = function (content, keepMetaModalOpen, openPreviewTab) {
			return ctrl.contentAdapter.saveContentWithoutValidation(content, keepMetaModalOpen).then(function (result) {
				if (ctrl.isForm) {
					//flag workCopy to false and deleted to false to persist entity as valid rather than draft
					ctrl.editorialEntity.workCopy = false;
					ctrl.editorialEntity.deleted = false;
					ctrl.entityAlreadySaved = true;
					return ctrl.saveEntityForm(keepMetaModalOpen, openPreviewTab);
				} else {
					return ctrl.saveMetadata(keepMetaModalOpen, openPreviewTab);
				}
			}).finally(function () {
				blockUI.stop();
			});
		};

		ctrl.saveContent = function (keepMetaModalOpen, openPreviewTab) {
			var content = ctrl.contentAdapter.getCleanedContent();
			if (keepMetaModalOpen) {
				return ctrl.saveForm(content, keepMetaModalOpen, openPreviewTab);
			}
			else {
				return ctrl.contentAdapter.validateHtmlContent(content).then(function (result) {
					if (result) {
						if (_.isEmpty(result)) {
							return ctrl.saveForm(content, keepMetaModalOpen, openPreviewTab);
						}
						else {
							blockUI.stop();
							return validateHtmlContentModalService.openModal(result).then(function (response) {
								blockUI.start();
								return ctrl.saveForm(content, keepMetaModalOpen, openPreviewTab);
							});
						}
					}
				});
			}
		};

		ctrl.onSave = function (keepMetaModalOpen, openPreviewTab) {
			if (ctrl.editMetaUseCase === editMetaUseCaseConstants.convertCreatingNewEntity ||
				ctrl.editMetaUseCase === editMetaUseCaseConstants.convertOverwritingExistingEntity) {
				return ctrl.saveEntityWithMetadataAndContent(false, false);
			} else {
				if (ctrl.isForm && ctrl.contentAdapter) {
					return ctrl.saveContent(keepMetaModalOpen, openPreviewTab);
				} else {
					return ctrl.saveMetadata(keepMetaModalOpen, openPreviewTab);
				}
			}
		};

		ctrl.cancel = function () {
			var isDraftEntity = angular.isDefined(ctrl.editorialEntity) && Boolean(ctrl.editorialEntity.workCopy) && Boolean(ctrl.editorialEntity.deleted);

			if (isDraftEntity || ctrl.editMetaUseCase === editMetaUseCaseConstants.convertCreatingNewEntity) {
				deleteEntityService.forceDeleteEntity(ctrl.flashId).then(function () {
					ctrl.onDismiss();
				});
			}

			else if (ctrl.editMetaUseCase === editMetaUseCaseConstants.convertOverwritingExistingEntity) {
				$state.go('editorialEntity', { id: ctrl.flashId }, { reload: true });
				ctrl.onDismiss({ $value: false });
			}
			else {
				//RULE : CANCEL LOCK WHEN FINISH AND LOCKED FOR THIS EDITION
				if (ctrl.locked && !ctrl.notUnlockAfterSaveMeta && !ctrl.isForm) {
					entityLockService.unlockSourceEntity(ctrl.flashId, ctrl.type)
						.then(function () {
							ctrl.onCancel();
						});
				} else {
					ctrl.onCancel();
				}
				//Go to entity if it was already save
				if (ctrl.entityAlreadySaved) {
					$rootScope.$broadcast('refresh_tree');
					ctrl.redirectToEntityAndRefresh(ctrl.flashId);
				}
			}
		};

		ctrl.onCancel = function () {
			//REFRESH ENTITY PADLOCK

			$rootScope.$broadcast("refresh_entity");
			ctrl.onDismiss();
		};

		ctrl.showCancelButton = function () {
			return ctrl.editMetaUseCase !== editMetaUseCaseConstants.convertOverwritingExistingEntity;
		};

		/**
			* Display Workflow actions bar
			*/
		ctrl.displayStepsButtons = function () {
			return (ctrl.isForm && ctrl.editorialEntity.workFlowHistoryDTO.workflowConstraint &&
				angular.isDefined(ctrl.editorialEntity.workFlowHistoryDTO.currentStep.nextSteps) &&
				ctrl.editorialEntity.workFlowHistoryDTO.currentStep.nextSteps.length > 0);
		};


		ctrl.saveMetasAndGoNextStep = function (step) {
			blockUI.start();
			ctrl.save(ctrl.displayStepsButtons()).then(function (result) {
				goNextStep(step);
			});
		};

		ctrl.saveDisabled = function (form) {
			return form.$invalid || ctrl.isNotAllMediasAssigned() || ctrl.isNotTreeAssigned() || ctrl.isNotMultiSelectListAssigned() || ctrl.isMetadataUniqueValueViolated() || ctrl.isInputTouched;
		};

		ctrl.previewDisable = function (form) {
			return !ctrl.isFullPreviewPossible || ctrl.saveDisabled(form);
		};

		ctrl.saveEntityWithMetadataAndContent = function (keepMetaModalOpen, openPreviewTab) {
			ctrl.editorialEntity.workCopy = false;
			ctrl.editorialEntity.deleted = false;
			ctrl.entityAlreadySaved = true;
			return EditorialEntityService.save(ctrl.editorialEntity).$promise.then(function (data) {
			}).then(function () {
				if (ctrl.isForm && ctrl.contentAdapter) {
					return ctrl.saveContent(keepMetaModalOpen, openPreviewTab);
				}
			}).then(function () {
				return ctrl.saveMetadata(keepMetaModalOpen, openPreviewTab);
			}).finally(function () {
				blockUI.stop();
			});
		};
		/**
			* Open full preview html modal.
			*/
		ctrl.openPreviewTab = function () {
			blockUI.start();
			ctrl.save(true, true);
		};

		$scope.$on('$destroy', $scope.$on('open_preview_tab_after_refresh_entity', function () {
			htmlPreviewService.updatePreview(ctrl.editorialEntity.identifier, 'COMPLETE')
				.then(function (result) {
					if (result) {
						OpenNewTabService.openNewTab(result.htmlPreview, $window.open());
					}
				});
		}));

		//SHOW CONFIRM DIALOG BOX IF FORM CHANGE AND USER CLICK ESC BUTTON
		$scope.$on('modal.closing', function (event, reason, closed) {
			if (reason === 'escape key press') {
				//Prevent the close of parent modal when confirmation one is open
				event.preventDefault();
				if (authorizeModalClosingOnEscKeyPressed()) {
					if (ctrl.isForm && $scope.editForm.$dirty) {
						confirmModalService.openModal('userApp.editorialEntity.msg.confirmCancelMessage', undefined, undefined,
							'userApp.editorialEntity.action.exit', 'userApp.editorialEntity.action.goBackForm').then(function (result) {
								if (result) {
									ctrl.cancel();
								}
							});
					}
					else {
						ctrl.cancel();
					}
				}
			}
		});

		function authorizeModalClosingOnEscKeyPressed() {
			return ctrl.editMetaUseCase !== editMetaUseCaseConstants.convertOverwritingExistingEntity;
		}

		/**
	* Redirect to editorial entity + refresh info and actio bar
	*/
		ctrl.redirectToEntityAndRefresh = function (id) {
			if (ctrl.autoRedirect) {
				$state.go('editorialEntity', {
					id: id
				});
				$rootScope.$broadcast("refresh_entity", { eeFlashId: id });
			}

			$rootScope.$broadcast('refresh_action_bar');
		};

		/**
			* Refresh entity data after save metas and go Next step
			*/
		function goNextStep(step) {
			blockUI.start();
			entityFetchResource.getByFlashId({ flashId: ctrl.flashId }).$promise.then(function (editorialEntity) {
				//open edit workflow modal to complete fields
				if (editWorkflowModalService.displayEditWorkflowModal(step)) {
					blockUI.stop();
					editWorkflowModalService.openWorkflowModal(editorialEntity, ctrl.currentUser, false, step)
						.then(function (data) {
							blockUI.stop();
							if (data) {
								// Redirect to entity after completing step fields
								ctrl.redirectToEntityAndRefresh(editorialEntity.identifier);
								ctrl.onClose({ $value: data });
							}
						});
					//No need to complete step fields, so don't display edit workflow modal, rather directly validate next step
				} else {
					//Get complete selected step data before proceed
					var selectedStep = _.find(editorialEntity.workFlowHistoryDTO.stepsDTO, function (s) {
						return s.id === step.id;
					});

					editorialEntity.workFlowHistoryDTO.selectedStep = selectedStep;
					if (selectedStep.autoPublishing) {
						blockUI.stop();
						//Call publish form modal
						publishEeFormModalService.openPublishFormModal(editorialEntity, false, true, ctrl.editorialEntity.ownerGroup, undefined, true).then(function (publishDto) {
							if (publishDto) {
								editMetaDataModalService.initDefaultRole(editorialEntity, selectedStep);
								saveWorkflow(editorialEntity, publishDto);
							}
						});
					}
					else {
						blockUI.stop();
						editMetaDataModalService.initDefaultRole(editorialEntity, selectedStep);
						saveWorkflow(editorialEntity);
					}
				}
			});
		}

		function sortMetaByDisplayOrder(meta) {
			return _.sortBy(meta, ['displayOrder']);
		}
		/**
	* @description save the workflow and redirect to entity after changing workflow step
	* @param {object} editorialEntity 
	*/
		function saveWorkflow(editorialEntity, publishDto) {
			blockUI.start();
			editWorkflowModalService.saveWorkflow(editorialEntity, ctrl.autoRedirect, publishDto).then(function (data) {
				blockUI.stop();
				if (data) {
					// Redirect to entity after changing workflow step
					ctrl.redirectToEntityAndRefresh(editorialEntity.identifier);
					ctrl.onClose({ $value: data });
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editMetaDataModalService', EditMetaDataModalService);


	/** @ngInject */
	function EditMetaDataModalService(entityLockService, $filter, infoModalService, entityAuthorizeService, authorizeConstants, metadataResource, MetadataService, blockUI, $uibModal, entityTemplateResource, entityFetchResource, userResource, productResource, EDITORIAL_ELEMENT_TYPE, editProductsService, modelService) {

		var service = {
			openEditEntityMetaModal: openEditEntityMetaModal,
			openEditProductMetaModal: openEditProductMetaModal,
			openEditEntitiesMetaModal: openEditEntitiesMetaModal,
			openEditMetaModalByFlashId: openEditMetaModalByFlashId,
			saveMetadata: saveMetadata,
			editMultiple: editMultiple,
			initDefaultRole: initDefaultRole
		};

		return service;


		function openEditEntitiesMetaModal(flashIds) {
			blockUI.start();
			return MetadataService.checkPermission(flashIds).then(
				function (response) {
					if (response.valid) {
						//**************************************************************************************************


						var modalInstance = $uibModal.open({
							component: 'editEEsMetadataModalComponent',
							windowClass: 'sidebar-open',
							resolve: {
								flashIds: function () { return flashIds; },
								codeTee: function () { return response.codeTee; },
								idTee: function () { return response.idTee; },
								currentUser: function () {
									return userResource.getCurrentUser().$promise;
								},
								metaInstances: function () {
									return MetadataService.getMetaInstanceListByCodeTee(response.codeTee);
								},
								translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
									$translatePartialLoader.addPart('editMetaData');
									$translatePartialLoader.addPart('datepicker');
									$translatePartialLoader.addPart('global');
									$translatePartialLoader.addPart('metadatas');
									return $translate.refresh();
								}]
							},
							size: 'lg',
							backdrop: 'static'
						});

						modalInstance.opened.then(function () {
							blockUI.stop();
						});

						return modalInstance.result;


						//--------------------------------------------------------------------------------------------------
					} else {
						blockUI.stop();
						infoModalService.openModal(
							"error.conditionViolated.message",
							"error.conditionViolated.title");
					}
				});
		}

		function openEditEntityMetaModal(flashId, entityTemplateCode, isSourceEntityContainer, autoRedirect, modalClass) {
			return openEditMetaModalByFlashId(flashId, EDITORIAL_ELEMENT_TYPE.entity, flashId, true, undefined, modalClass, entityTemplateCode, isSourceEntityContainer, undefined, autoRedirect);
		}

		function openEditProductMetaModal(flashId, modalTitle, modalClass, isAcceptProposal) {
			return openEditMetaModalByFlashId(flashId, EDITORIAL_ELEMENT_TYPE.product, flashId, false, modalTitle, modalClass, null, null, isAcceptProposal);
		}

		function openEditMetaModalByFlashId(flashId, type, entityId, authorize, modalTitle, modalClass, entityTemplateCode, isSourceEntityContainer, isAcceptProposal, autoRedirect, notUnlockAfterSaveMeta) {
			blockUI.start();

			if (authorize) {
				return entityAuthorizeService.authorizeById(entityId, authorizeConstants.editMetadata)
					.then(function (authorized) {
						if (authorized) {
							return openModal(flashId, type, modalTitle, modalClass, entityTemplateCode, isSourceEntityContainer, isAcceptProposal, autoRedirect, notUnlockAfterSaveMeta);
						} else {
							blockUI.stop();
							infoModalService.openModal("error.actionDenied.message", "error.actionDenied.title",
								{
									name: $filter('translate')('entity.actionBar.editMeta'),
									denied: $filter('translate')('error.denied')
								});
						}
					});
			}

			return openModal(flashId, type, modalTitle, modalClass, entityTemplateCode, isSourceEntityContainer, isAcceptProposal, autoRedirect, notUnlockAfterSaveMeta);
		}

		function openModal(flashId, type, modalTitle, modalClass, entityTemplateCode, isSourceEntityContainer, isAcceptProposal, autoRedirect, notUnlockAfterSaveMeta) {
			var isRelation = _.isEqual(type, EDITORIAL_ELEMENT_TYPE.relation);
			var isProduct = _.isEqual(type, EDITORIAL_ELEMENT_TYPE.product);

			var windowClass = 'sidebar-open ' + (modalClass ? modalClass : 'editor-zindex');
			var modalInstance = $uibModal.open({
				component: 'editMetadataFormModalComponent',
				windowClass: windowClass,
				resolve: {
					notUnlockAfterSaveMeta: function () { return notUnlockAfterSaveMeta; },
					isAcceptProposal: function () { return isAcceptProposal; },
					flashId: function () { return flashId; },
					type: function () { return type; },
					modalTitle: function () { return modalTitle; },
					metaInstanceByMetaGroup: function () {
						return metadataResource.getMetaInstanceToEdit({
							id: flashId,
							type: type
						}).$promise;
					},
					currentUser: function () {
						return userResource.getCurrentUser().$promise;
					},
					entityTemplateId: function () {
						if (!isRelation && !isProduct) {
							return entityFetchResource.getEditorialEntityTemplateId({ flashId: flashId }).$promise;
						}
					},
					allModels: function () {
						if (angular.isDefined(entityTemplateCode)) {
							return modelService.getAllModels({
								codeTEE: entityTemplateCode
							}).$promise;
						} else {
							return undefined;
						}
					},
					maxSizeMedia: function () {
						return entityTemplateResource.getMaxSize().$promise;
					},
					codeEET: function () {
						if (!isRelation && !isProduct) {
							return entityFetchResource.getEditorialEntityTemplateCode({ flashId: flashId }).$promise;
						}
					},
					productCode: function () {
						return productResource.getProductCode({ flashId: flashId, type: type }).$promise;
					},
					productSuggestedPublicationDate: function () {
						if (isProduct) {
							return productResource.getSuggestedPublicationDate({ flashId: flashId }).$promise;
						}
					},
					lockSource: function () {
						if (!isProduct) {

							//LOCK SOURCE ENTITY IF IT'S NOT ALREADY LOCKED
							return entityLockService.lockSourceEntity(flashId, type);
						}
					},
					entity: function () {
						if (_.isEqual(type, EDITORIAL_ELEMENT_TYPE.entity)) {
							return entityFetchResource.getByFlashId({
								flashId: flashId
							}).$promise;
						}
					},
					currentProducts: function () {
						if (_.isEqual(type, EDITORIAL_ELEMENT_TYPE.entity)) {
							return editProductsService.getCurrentProducts(flashId);
						}
					},
					autoRedirect: function () {
						return autoRedirect;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editMetaData');
						$translatePartialLoader.addPart('datepicker');
						$translatePartialLoader.addPart('global');
						$translatePartialLoader.addPart('product');
						$translatePartialLoader.addPart('editor');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});

			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function saveMetadata(flashId, type, metaDataByMetaGroup, productSuggestedPublicationDate) {
			return metadataResource.save(
				{
					flashId: flashId,
					type: type,
					productSuggestedPublicationDate: productSuggestedPublicationDate
				}, metaDataByMetaGroup)
				.$promise;
		}

		function editMultiple(flashIds, metaDataInstance) {
			return MetadataService.editMultiple(flashIds, metaDataInstance);
		}
		/**
		 * @description init the default role
		 * @param {object} editorialEntity 
		 * @param {object} selectedStep 
		 */
		function initDefaultRole(editorialEntity, selectedStep) {
			if (angular.isDefined(selectedStep.roles) && selectedStep.roles.length === 1) {
				editorialEntity.workFlowHistoryDTO.selectedStep.assignmentRole = selectedStep.roles[0];
			}
		}
	}
})();

/* eslint-disable indent */
(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editorialEntityEditMenu', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/editorial-entity-edit-menu/editorial-entity-edit-menu.html',
			controller: EditorialEntityEditMenu,
			bindings: {
				editorialEntity: '=',
				permissions: '=',
				showOverloadedView: '=',
				currentUser: '<',
				metaDataByMetaGroup: '<',
				switchDisplay: '&',
				showMetaData: '&',
				openEditMetaModal: '&',
				onRefreshEntity: '&'
			},
		});

	/** @ngInject */
	/* eslint-disable indent */
	function EditorialEntityEditMenu(EDITORIAL_ELEMENT_TYPE, convertModalService, editProductsModalService, entityLinkingResource, nodeEventService, htmlPreviewTabService, workflowHistoryResource, entityLockService, productGroupModalService, exportXMLService, xmlEditionModalService, editWorkflowModalService, validateEntityService, createModelService, blockUI,
		$log, ModalAlertService, $scope, $rootScope, cloneEntityModalService, entityCloneResource,
		$state, $filter, CreateAndHookEeWizardModalService, LinkEeWizardModalService, relationResource, archiveEntityModalService, duplicateEntityModalService, ermService, ENTITY_RESOURCE_TYPE, entityAuthorizeService, publishService, editSystemAuthorService, htmlPreviewService, userPreferenceService) {
		/* eslint-enable */
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.isConversionToNewTeePermittedForContentType = isConversionToNewTeePermittedForContentType();
			if (ctrl.isConversionToNewTeePermittedForContentType) {
				blockUI.start();
				convertModalService.getConvertibleTemplates(ctrl.editorialEntity.editorialEntityTemplate.code, true).then(function (data) {
					blockUI.stop();
					ctrl.convertibleToNewTeeTemplates = data;
				});
			}
			if (_.isUndefined(ctrl.convertibleToNewTeeTemplates)) {
				ctrl.convertibleToNewTeeTemplates = [];
			}

			// Check whether the configuration of full preview exists in ERM.
			ctrl.isFullPreviewPossible = false;
			ctrl.isSummaryViewPossible = false;
			ermService.checkConfigExits(ctrl.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.summary)
				.then(function (data) {
					ctrl.isSummaryViewPossible = (data.exist === "true");
				});

			ermService.checkConfigExits(ctrl.editorialEntity.editorialEntityTemplate.code, ENTITY_RESOURCE_TYPE.proofReading)
				.then(function (data) {
					ctrl.isFullPreviewPossible = (data.exist === "true");
				});

			ctrl.tree = isTree();
			ctrl.isTS = isTS();
			ctrl.isForm = isForm();
			ctrl.isMedia = isMedia();

			// If EE hooks external entities
			ctrl.isHooksExternalEntities = isHooksExternalEntities();
			ctrl.isActivateVersioning = isActivateVersioning();

			//IF EE IS TREE, DISPLAY EE AS TREE VIEW BY DEFAULT
			ctrl.displayMode = 'DISPLAY_METADATA';
			if (ctrl.tree) {
				ctrl.displayMode = 'DISPLAY_TREE_VIEW';
			}
			if (ctrl.isMedia) {
				ctrl.displayMode = 'DISPLAY_MEDIA';
			}
			if (ctrl.isForm) {
				ctrl.displayMode = 'DISPLAY_CONTENT_ONLY';
			}

			ctrl.wfchanged = $rootScope.$on('WfForcedByWarningOrError', function (event, data) {
				ctrl.onRefreshEntity();
			});

			ctrl.countLinkedEEsDTO = {
				eeFlashId: ctrl.editorialEntity.identifier,
				duplicatedEEFlashId: ctrl.editorialEntity.duplicatedEditorialEntityFlashId,
			};

			ctrl.linkInfosMap = {};
			entityLinkingResource.countEeLinkInfos(ctrl.countLinkedEEsDTO).$promise.then(function (result) {
				ctrl.linkInfosMap = result;
			});
		};
		//============================================================================================
		//=================================Menu File =================================================
		//============================================================================================

		ctrl.initWorkflowWithoutMeta = function () {
			blockUI.start();
			workflowHistoryResource.initWFUpdate(ctrl.editorialEntity.workflowInstanceDTO, function (data) {
				ctrl.onRefreshEntity();
				//REFRESH UPDATE
				$rootScope.$emit('refresh_action_bar');
				blockUI.stop();
			});
		};

		/**
			* Duplicate an editorial entity.
			*/
		ctrl.duplicateEEModal = function () {
			duplicateEntityModalService.openModal(ctrl.editorialEntity, true);
		};

		/**
			* Clone an editorial entity
			*/
		ctrl.cloneEEModal = function () {
			blockUI.start();
			entityCloneResource.getCloneableEntityValidationInfoDTO({ flashId: ctrl.editorialEntity.identifier }).$promise.then(function (cloneableEntityValidationInfo) {
				blockUI.stop();
				if (cloneableEntityValidationInfo.subTreeEntities.length > 0 || cloneableEntityValidationInfo.subEntitiesWithDiscriminants.length > 0) {
					cloneEntityModalService.openValidationModal(ctrl.editorialEntity, cloneableEntityValidationInfo.subTreeEntities, cloneableEntityValidationInfo.subEntitiesWithDiscriminants);
				} else {
					cloneEntityModalService.openModal(ctrl.editorialEntity, ctrl.currentUser);
				}
			});

		};

		ctrl.convert = function (createNewEntity) {
			convertModalService.openModal(ctrl.editorialEntity.identifier, null, createNewEntity)
				.then(function () {
					$state.reload();
				});
		};

		ctrl.checkEnablingOfConvert = function () {
			return convertModalService.checkEnablingOfConvert(ctrl.editorialEntity, ctrl.convertibleToNewTeeTemplates);
		};

		ctrl.editProductGroupModal = function () {
			productGroupModalService.openModal(ctrl.editorialEntity)
				.then(function (group) {
					ctrl.editorialEntity.ownerGroup = group.code;
					ctrl.editorialEntity.ownerGroupName = _.isEmpty(group.code) ? "" : group.name;
					$rootScope.ownerGroup = ctrl.editorialEntity.ownerGroup;
					ctrl.onRefreshEntity();
				});
		};

		ctrl.editAuthor = function () {
			editSystemAuthorService.openModal(ctrl.editorialEntity)
				.then(function (authors) {
					ctrl.editorialEntity.authors = authors;
					//	ctrl.onRefreshEntity();
				});
		};

		ctrl.editProducts = function () {
			var entityId = ctrl.editorialEntity.identifier;
			var entityTitle = ctrl.editorialEntity.system.systemTitle;
			var eetCode = ctrl.editorialEntity.editorialEntityTemplate.code;
			//TODO
			editProductsModalService.openModal(entityId, entityTitle, eetCode, !ctrl.hasNoPermission('PUBLISH'))
				.then(function () {

				});
		};

		ctrl.saveEEAsModal = function () {
			createModelService.openModal(ctrl.editorialEntity);
		};

		ctrl.validateEEModal = function () {
			if (ctrl.editorialEntity.editorialEntityTemplate.contentType === 'TREE') {
				validateEntityService.chooseValidationType(ctrl.editorialEntity);
			} else {
				validateEntityService.openModal(ctrl.editorialEntity, false, false, false);
			}

		};

		/**
			* Publishing EE .
			*/
		ctrl.publishModal = function () {

			publishService.publishOrder(ctrl.editorialEntity.identifier, ctrl.editorialEntity);
		};

		ctrl.proofModal = function () {
			if (ctrl.editorialEntity.editorialEntityTemplate.contentType === 'STRUCTUREDTEXT' && ctrl.editorialEntity.editorialEntityTemplate.contextProofingEnabled) {
				//open proofing wizard
				publishService.openContextualProofingWizardModal(ctrl.editorialEntity, ctrl.currentUser, false, true);
			} else {
				publishService.proofModal(ctrl.editorialEntity, ctrl.editorialEntity.editorialEntityTemplate.code);
			}
		};

		/**
			* Open full preview html modal.
			*/
		ctrl.openPreviewTab = function () {
			htmlPreviewTabService.openTabById(ctrl.editorialEntity.identifier, 'ENTITY', false, false);
		};

		/**
			* Export entity in xml
			*/
		ctrl.exportXMLContent = function () {
			exportXMLService.content(ctrl.editorialEntity.identifier);
		};

		/**
			* Edit XML of the entity content node
			*/
		ctrl.openXmlEditModal = function () {
			xmlEditionModalService.openModal(ctrl.editorialEntity.identifier, ctrl.editorialEntity.editorialEntityTemplate.code);
		};

		/**
			* Launch linkin wizard.
			*/
		ctrl.launcherLinkEEWizard = function () {
			var entities = [];
			entities.push({
				flashId: ctrl.editorialEntity.identifier,
				eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
				metaInstanceList: ctrl.editorialEntity.metaInstanceList,
				system: ctrl.editorialEntity.system
			});
			LinkEeWizardModalService.openModal(entities, ctrl.currentUser, false, true);
		};
		/**
			* Launch create and hook e wizard.
			*/
		ctrl.launchCreateAndHookEeWizard = function () {
			var eeSourceDetails = {
				flashId: ctrl.editorialEntity.identifier,
				eetCode: ctrl.editorialEntity.editorialEntityTemplate.code,
				metaInstanceList: ctrl.editorialEntity.metaInstanceList,
				subNodesId: ctrl.editorialEntity.subNodesId,
				systemTitle: ctrl.editorialEntity.titleSystem,
				container: ctrl.editorialEntity.editorialEntityTemplate.container
			};
			CreateAndHookEeWizardModalService.openModal(eeSourceDetails, null, ctrl.currentUser, false, ctrl.editorialEntity).then(function (referenceNode) {
				//Reload the node
				$rootScope.$broadcast("tree_view_add_node", referenceNode);
			});
		};

		/**
			*  Unlock Editorial Entity .
			*/
		ctrl.unlockEditorialEntity = function () {
			entityLockService.unlock(ctrl.editorialEntity.identifier)
				.then(function () {
					if (isMedia()) {
						setEditingMedia(false);
					}
					ctrl.onRefreshEntity();
					//REFRESH UPDATE
					$rootScope.$emit('refresh_action_bar');
					$rootScope.$emit('permissions_changed');
				});
		};

		/**
			* Lock Editorial Entity .
			*/
		ctrl.lockEditorialEntity = function () {
			entityLockService.lock(ctrl.editorialEntity.identifier)
				.then(function () {
					ctrl.editorialEntity.locked = true;
					ctrl.editorialEntity.userLock = ctrl.currentUser;
					ctrl.editorialEntity.padlock.closed = true;
					ctrl.onRefreshEntity();
					//REFRESH UPDATE
					$rootScope.$emit('refresh_action_bar');
					$rootScope.$emit('permissions_changed');
				});

		};

		/**
			* Archive an editorial entity .
			*/
		ctrl.archiveEEModal = function () {
			archiveEntityModalService.openModal(ctrl.editorialEntity);
		};


		//============================================================================================
		//=================================Menu edition =================================================
		//============================================================================================

		/**
			* Open Edit Modal
			*/
		ctrl.onOpenEditMetaModal = function () {
			if (ctrl.openEditMetaModal) {
				if (isMedia()) {
					setEditingMedia(false);
				}
				if (entityAuthorizeService.isInitWorkflowUpdateEnabled(ctrl.permissions)) {
					ctrl.openWorkflowModal().then(function () {
						ctrl.openEditMetaModal();
					});
				}
				else {
					ctrl.openEditMetaModal();
				}
			}
		};

		ctrl.redirectToEditContent = function () {
			if (ctrl.editorialEntity.editorialEntityTemplate.contentType === 'STRUCTUREDTEXT') {
				$state.go('editorialEntityEdit', { 'id': ctrl.editorialEntity.identifier });
			} else if (ctrl.tree) {
				$state.go('treeEEEdition', { id: ctrl.editorialEntity.identifier, editionMode: 'STRUCTURE' });
			}
		};

		ctrl.onEditContent = function () {
			if (entityAuthorizeService.isInitWorkflowUpdateEnabled(ctrl.permissions)) {
				ctrl.openWorkflowModal().then(function () {
					ctrl.redirectToEditContent();
				});
			}
			else {
				ctrl.redirectToEditContent();
			}
		};

		/**
			* Change work flow step
			*/
		ctrl.openWorkflowModal = function () {
			return editWorkflowModalService.openWorkflowModal(ctrl.editorialEntity, ctrl.currentUser, false).then(
				function () {
					//REFRESH ENTITY
					ctrl.onRefreshEntity();
					//REFRESH UPDATE
					$rootScope.$emit('refresh_action_bar');
				}
			);

		};

		//============================================================================================
		//=================================Menu Affichage ============================================
		//============================================================================================

		ctrl.switchDisplayMode = function (display) {
			$log.info("Switch display mode to " + display);

			ctrl.displayMode = display;
			if (display !== 'NONE') {
				updatePreview(ctrl.editorialEntity.identifier, 'RESTRICTED');
				$state.go('editorialEntity');
			}
			ctrl.switchDisplay({
				display: display
			});

		};

		/**
			* Update the html preview.
			*/
		function updatePreview(identifier, typePreview) {
			var contextProductCode = userPreferenceService.getUserGlobalPreference('OwnerGroup');
			htmlPreviewService.getPreview(identifier, typePreview, false, EDITORIAL_ELEMENT_TYPE.entity, contextProductCode)
				.then(function (result) {
					if (result) {
						ctrl.editorialEntity.restrictedHtmlPreview = result.htmlPreview;
					}
				});
		}

		/**
			* Check the current menu in purpose to disbale it.
			*/
		ctrl.isViewSelected = function (displayMode) {
			var state = $state.current.name;
			return ((ctrl.displayMode === displayMode) && (state === 'editorialEntity'));
		};

		/**
		* manage editing media /!\ for media entities only
		*/
		ctrl.manageEditingMedia = function (view) {
			if (!isMedia()) { return; }

			var displayMode;
			if (ctrl.editorialEntity.editingMedia === true || view === true) {
				if (ctrl.editorialEntity.locked === true) {
					ctrl.unlockEditorialEntity();
				}
				setEditingMedia(false);
				displayMode = 'DISPLAY_MEDIA';
			} else {
				if (ctrl.editorialEntity.locked !== true) {
					ctrl.lockEditorialEntity();
				}
				setEditingMedia(true);
				displayMode = 'DISPLAY_EDIT_MEDIA';
			}
			ctrl.switchDisplayMode(displayMode);
		};

		var editMediaEventHandler = $rootScope.$on('editMediaEvent', function (event, id) {
			if (!isMedia() || id !== ctrl.editorialEntity.identifier) { return; }
			ctrl.manageEditingMedia();
		});

		$rootScope.$on('$destroy', function () {
			editMediaEventHandler();
		});

		//============================================================================================================
		//====================================== private methods =====================================================
		//============================================================================================================

		/**
			* check the authority of the user.
			*/
		ctrl.hasNoPermission = function (permision) {
			return angular.isDefined(ctrl.permissions) && ctrl.permissions.indexOf(permision) === -1;
		};

		ctrl.getCurrentState = function () {
			return $state.current.name;
		};

		function setEditingMedia(editingMedia) {
			ctrl.editorialEntity.editingMedia = editingMedia;
		}

		function isTree() {
			return ctrl.editorialEntity.editorialEntityTemplate.contentType === 'TREE';
		}

		function isForm() {
			return ctrl.editorialEntity.editorialEntityTemplate.formular;
		}

		function isMedia() {
			return ctrl.editorialEntity.editorialEntityTemplate.contentType === 'MEDIA';
		}
		function isTS() {
			return ctrl.editorialEntity.editorialEntityTemplate.contentType === 'STRUCTUREDTEXT';
		}
		function isConversionToNewTeePermittedForContentType() {
			return isTS() || isTree();
		}

		ctrl.isTreeOrReferenceNode = function () {
			return (isTree() || ctrl.editorialEntity.editorialEntityTemplate.contentType === 'REFERENCE');
		};

		function isHooksExternalEntities() {
			return ctrl.editorialEntity.editorialEntityTemplate.hooksExternalEntities;
		}

		function isActivateVersioning() {
			return ctrl.editorialEntity.editorialEntityTemplate.activateVersioning;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('editEntityTitle',
		{
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/edit-entity-title/edit-entity-title.html',
			controller: editEntityTitleController,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'
			},
		});

	/** @ngInject */
	function editEntityTitleController($rootScope, $scope, blockUI, MetadataService, SYSTEM_METADATA_IDENTIFIERS) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.entity = ctrl.resolve.entity;
			ctrl.htmlTitle = ctrl.entity.titleSystem;
			ctrl.titleMaxLengthViolation = false;

		};

		ctrl.cancel = function () {
			ctrl.close({
				$value: false
			});
		};

		// save
		ctrl.save = function () {
			blockUI.start();
			MetadataService.updateSystemMetaValue(SYSTEM_METADATA_IDENTIFIERS.systemTitle, ctrl.entity.identifier, 'ENTITY', ctrl.htmlTitle).$promise.then(function () {
				ctrl.entity.titleSystem = ctrl.htmlTitle;
				ctrl.close();
				blockUI.stop();
			});
		};
		// cancel
		ctrl.cancel = function () {
			ctrl.close({
				$value: false
			});
		};

		$scope.$on('titleMaxLengthViolation', function (event, data) {
			ctrl.titleMaxLengthViolation = data;
		});



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('editEntityTitleService', EditEntityTitleService);


	/** @ngInject */
	function EditEntityTitleService(blockUI, $uibModal) {
		var service = {
			openModalEditTitle: openModalEditTitle
		};

		return service;

		function openModalEditTitle(entity) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'editEntityTitle',
				resolve: {
					entity: entity,

					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('datepicker');
						$translatePartialLoader.addPart('global');
						$translatePartialLoader.addPart('editEntityTitle');

						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('eeLinkInfos', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/ee-link-infos/ee-link-infos.html',
			controller: EELinkInfosController,
			bindings: {
				editorialEntity: "=",
				displayMode: "<"
			},
		});

	/** @ngInject */
	function EELinkInfosController(entityLinkingResource, $translate, $sce, $filter, blockUI, productResource, EDITORIAL_ELEMENT_TYPE, OpenNewTabService) {
		var ctrl = this;
		ctrl.lang = $translate.use();
		ctrl.eeList = [];
		ctrl.totalItemCount = 0;
		ctrl.isInit = true;
		ctrl.eetListFilter = [];
		ctrl.statusListFilter = [];
		ctrl.linkInfosType = '';

		// Pagination infos
		ctrl.pagination = {
			// Default page size
			itemByPage: 50,
			// Default initial page
			currentPage: 0
		};

		ctrl.$onInit = function () {
			// HOOKS or DUPLICATES
			ctrl.linkInfosType = ctrl.displayMode;
			productResource.getProductCode({ flashId: ctrl.editorialEntity.identifier, type: EDITORIAL_ELEMENT_TYPE.entity }).$promise
				.then(function (code) {
					ctrl.productCode = code;
				});
		};

		//Search DTO
		ctrl.searchEEsDTO = {
			currentPage: 0,
			itemByPage: ctrl.pagination.itemByPage,
			linkInfosType: ctrl.linkInfosType,
			eeFlashId: ctrl.editorialEntity.identifier,
			duplicatedEEFlashId: ctrl.editorialEntity.duplicatedEditorialEntityFlashId,
			isInit: ctrl.isInit,
			eetCodeFilter: null,
			statusFilter: null,
			sortField: null,
			sortDirection: null
		};

		ctrl.preview = {};

		//Do search
		ctrl.loadEEs = function (searchEEsDTO) {
			//
			ctrl.eeList = [];
			blockUI.start();
			entityLinkingResource.searchEeLinkInfos(searchEEsDTO).$promise.then(function (results) {
				//Read results
				blockUI.stop();
				ctrl.eeList = [].concat(results.eeList);
				//Set title if empty
				angular.forEach(ctrl.eeList, function (ee) {
					if (ee.systemTitle === null || (ee.systemTitle && ee.systemTitle.length === 0)) {
						ee.systemTitle = $filter('translate')('userApp.eeLinkInfos.labels.noEETitle');
					}
				});
				ctrl.totalItemCount = results.totalItemCount;
				//filters values, only on page init.
				if (ctrl.isInit) {
					ctrl.isInit = false;
					ctrl.statusListFilter = [].concat(results.statusListFilter);
					if (ctrl.linkInfosType !== 'DUPLICATES') {
						ctrl.eetListFilter = [].concat(results.eetListFilter);
					}
				}
			},
				//
				function () {
					blockUI.stop();
				});
		};

		ctrl.deleteHtmlTags = function (html) {
			if (angular.isDefined(html) && html !== null) {
				return html.replace(/(<([^>]+)>)/ig, "");
			}
		};

		ctrl.formatSystemTitle = function (systemTitle) {
			return $sce.trustAsHtml(ctrl.deleteHtmlTags(systemTitle));
		};

		// Load a page
		ctrl.pageChanged = function () {
			//init search params
			ctrl.searchEEsDTO.currentPage = (ctrl.pagination.currentPage === 0 ? 0 : ctrl.pagination.currentPage - 1);
			ctrl.searchEEsDTO.itemByPage = ctrl.pagination.itemByPage;
			ctrl.loadEEs(ctrl.searchEEsDTO);
		};

		// Sort table
		ctrl.doSort = function (tableState) {
			// Page init
			ctrl.searchEEsDTO.currentPage = 0;
			ctrl.pagination.currentPage = 0;
			ctrl.searchEEsDTO.itemByPage = ctrl.pagination.itemByPage;
			ctrl.searchEEsDTO.linkInfosType = ctrl.linkInfosType;
			// Default sort option
			ctrl.searchEEsDTO.sortField = null;
			ctrl.searchEEsDTO.sortDirection = null;
			// Custom sort option
			if (angular.isDefined(tableState) &&
				angular.isDefined(tableState.sort) &&
				angular.isDefined(tableState.sort.predicate) &&
				angular.isDefined(tableState.sort.reverse)) {
				ctrl.searchEEsDTO.sortField = tableState.sort.predicate;
				var reverse = angular.isUndefined(tableState.sort.reverse) || Boolean(tableState.sort.reverse);
				ctrl.searchEEsDTO.sortDirection = reverse ? 'DESC' : 'ASC';
			}
			ctrl.loadEEs(ctrl.searchEEsDTO);
		};

		// Apply new filter
		ctrl.doFilter = function () {
			// Page init
			ctrl.searchEEsDTO.currentPage = 0;
			ctrl.pagination.currentPage = 0;
			ctrl.searchEEsDTO.itemByPage = ctrl.pagination.itemByPage;
			ctrl.searchEEsDTO.linkInfosType = ctrl.linkInfosType;
			ctrl.loadEEs(ctrl.searchEEsDTO);
		};

		ctrl.openPreview = function (entity) {
			ctrl.preview = {
				opened: true,
				flashId: entity.flashId,
				relationId: entity.relationId,
				isRelation: true,
				displayMeta: true
			};
		};

		ctrl.redirectToEntity = function (flashId) {
			OpenNewTabService.openEntityNewTab(flashId);
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('entityInfo', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/entity-info/entity-info.html',
			controller: EntityInfoController,
			bindings: {
				entity: '=',
				currentUser: '<',
				permissions: '<',
				onRefreshEntity: '&'
			}
		});

	/** @ngInject */
	function EntityInfoController($q, $log, $scope, $rootScope, confirmModalService, MetadataService, workflowHistoryResource, ModalAlertService, blockUI, $uibModal, $filter, entityLockService, editEntityTitleService, entityValidateResource, validateEntityService, imageUtilService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.tree = isTree();
			ctrl.isOpen = false;
			ctrl.hasLogo = false;
			ctrl.initInfoMetaInstances();

			//GET THE INITAIL STATUS OF THE REPORT.
			ctrl.getReportStatus(true);

			//WHEN THE USER SEND NEW VALIDATION REQUEST? WE SHOULD UPDATE THE REPORT STATUS.
			ctrl.calidationStatus = $rootScope.$on('validationStatusChanged', function (event, data) {
				ctrl.getReportStatus(true);
			});

			// If EE hooks external entities
			ctrl.isHooksExternalEntities = isHooksExternalEntities();

		};

		$scope.$on('$destroy', $scope.$on('refreshInformationMetaDataInstances', function (event, message) {
			ctrl.initInfoMetaInstances();
		}));

		imageUtilService.groupImageExist(ctrl.entity.ownerGroup).then(function (result) {
			ctrl.hasLogo = result;
			ctrl.logoPath = imageUtilService.getGroupLogoPath(ctrl.entity.ownerGroup);
		});

		ctrl.initInfoMetaInstances = function () {
			blockUI.start();
			return MetadataService.getValuatedInformationMetaDataInstances(ctrl.entity.identifier)
				.then(function (data) {
					blockUI.stop();
					ctrl.infoMetaInstances = data;
				});
		};

		ctrl.getMetaValue = function (meta) {
			return MetadataService.getMetaValues(meta);
		};

		ctrl.hasTitle = function () {
			return !_.isEmpty(ctrl.entity.titleSystem);
		};

		ctrl.checkDeleteAssignRole = function () {
			return ctrl.permissions.indexOf('DELETE_ASSIGN_ROLE') !== -1;
		};

		ctrl.checkeditPermission = function () {
			return ctrl.permissions.indexOf('EDIT_META_TITLE') !== -1;
		};

		ctrl.belongToProduct = function () {
			return ctrl.permissions.indexOf('BELONG_TO_PRODUCT') !== -1;
		};

		ctrl.openModalEditTitle = function () {
			editEntityTitleService.openModalEditTitle(ctrl.entity);
		};

		ctrl.deleteAssignRole = function () {
			confirmModalService.openModal("userApp.editorialEntity.msg.deleteAssignRoleConf")
				.then(function (result) {
					if (result) {
						blockUI.start();
						workflowHistoryResource.deleteAssignRole({
							idWfwHistory: ctrl.entity.workFlowHistoryDTO.id
						}).$promise.then(
							function () {
								delete ctrl.entity.workFlowHistoryDTO.currentStep.assignmentRole;
								ctrl.onRefreshEntity();
								//REFRESH UPDATE
								$rootScope.$emit('refresh_action_bar');
								blockUI.stop();
							});
					}
				});

		};


		/**
		 *  broken locked Editorial Entity .
		 */
		ctrl.brokenLockedEditorialEntity = function () {
			confirmModalService.openModal("userApp.editorialEntity.msg.brockenPadlockConfirmMessage")
				.then(function (result) {
					if (result) {
						blockUI.start();
						entityLockService.breakLock(ctrl.entity.identifier)
							.then(function () {
								ctrl.onRefreshEntity();
								//REFRESH UPDATE
								$rootScope.$emit('refresh_action_bar');
								$rootScope.$emit('permissions_changed');
								blockUI.stop();
							});
					}
				});

		};


		ctrl.isLockedByOther = function () {
			var identifier = _.get(ctrl.entity, "userLock.identifier");
			return identifier && identifier !== ctrl.currentUser.identifier;
		};

		ctrl.isLockedByMe = function () {
			var identifier = _.get(ctrl.entity, "userLock.identifier");
			return identifier && identifier === ctrl.currentUser.identifier;
		};

		ctrl.isBrokenlockedDisabled = function () {
			return ctrl.permissions.indexOf('BROKEN_LOCK') === -1;
		};

		ctrl.showComment = function () {
			return ctrl.entity.workFlowHistoryDTO && ctrl.entity.workFlowHistoryDTO.currentStep && !ctrl.entity.workFlowHistoryDTO.currentStep.finalStatus && !_.isEmpty(ctrl.entity.workFlowHistoryDTO.comment);
		};


		/**
			 * Open the generated report.
			 */
		ctrl.openReport = function () {
			ctrl.isOpen = false;
			validateEntityService.openModal(ctrl.entity, true, true, false);
		};

		/**
		 * Get report status
		 */
		ctrl.getReportStatus = function (init) {
			entityValidateResource.checkValidationReportStatus({ flashId: ctrl.entity.identifier })
				.$promise.then(function (data) {
					ctrl.reportStatus = data.status;
					if (!init) {
						ctrl.isOpen = true;
					}

				});
		};


		function isTree() {
			return ctrl.entity.editorialEntityTemplate.contentType === 'TREE';
		}

		function isHooksExternalEntities() {
			return ctrl.entity.editorialEntityTemplate.hooksExternalEntities;
		}


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityInfoService', entityInfoService);


	/** @ngInject */
	function entityInfoService() {

		var service = {


		};

		return service;


	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('mediaEditionForm', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/media-edition-form/media-edition-form.html',
			controller: MediaEditionFormController,
			bindings: {
				editorialEntity: "<",
				permissions: '<'
			}
		});

	/** @ngInject */
	function MediaEditionFormController(confirmModalService, infoModalService, Upload, $rootScope, entityMediaService, blockUI, $filter, ModalAlertService) {
		var ctrl = this;
		var UPLOAD_ACTION = "UPLOAD_ACTION";
		var SAVE_ACTION = "SAVE_ACTION";

		ctrl.$onInit = function () {
		};

		ctrl.canEdit = function () {
			return ctrl.permissions && ctrl.permissions.indexOf('EDIT_CONTENT') !== -1;
		};

		ctrl.deleteFile = function (entityFlashId, fileFormatCode, customFileName, fileId) {
			var modalText = "entity.delete.deleteMediaConfirmation";
			var modalTextParam = { filename: customFileName };
			return confirmModalService.openMessageModal(modalText, modalTextParam)
				.then(function (result) {
					if (result) {
						blockUI.start();
						entityMediaService.deleteMediaAndUpdateEntity(entityFlashId, fileFormatCode, fileId).then(function (data) {
							blockUI.stop();
							ctrl.editorialEntity.fileFormatInstances = data;
							ModalAlertService.success($filter('translate')('userApp.editorialEntity.msg.success'), $filter('translate')('userApp.editorialEntity.msg.removePerformed'));
						});
					}
				});
		};

		ctrl.uploadAndSave = function (entityFlashId, fileFormatInstance, files) {
			uploadAndAction(SAVE_ACTION, entityFlashId, fileFormatInstance, files, false);
		};

		ctrl.uploadAndUpdate = function (entityFlashId, fileFormatInstance, files, idMedia) {
			uploadAndAction(UPLOAD_ACTION, entityFlashId, fileFormatInstance, files, false, idMedia);
		};

		function uploadAndAction(action, entityFlashId, fileFormatInstance, files, forceAction, idMedia) {
			if (files && files.length > 0) {
				switch (action) {
					case UPLOAD_ACTION:
						uploadAndUpdate(action, entityFlashId, fileFormatInstance, files, forceAction, idMedia);
						break;
					case SAVE_ACTION:
						uploadAndSave(action, entityFlashId, fileFormatInstance, files, forceAction);
						break;
				}
			}
		}

		function uploadAndUpdate(action, entityFlashId, fileFormatInstance, files, forceAction, idMedia) {
			blockUI.start();
			Upload.upload({
				url: 'api/editorialEntity/fileFormatInstances/uploadAndUpdate',
				data: {
					entityId: entityFlashId,
					fileFormatCode: fileFormatInstance.code,
					forceAction: forceAction,
					idMedia: idMedia,
					files: files
				}
			}).success(function (data) {
				ctrl.editorialEntity.fileFormatInstances = data;
				blockUI.stop();
				ModalAlertService.success($filter('translate')('userApp.editorialEntity.msg.success'), $filter('translate')('userApp.editorialEntity.msg.updatePerformed'));
			}).error(function (data) {
				manageUpgradeOrSaveErrors(data, action, entityFlashId, fileFormatInstance, files, idMedia);
			});
		}

		function uploadAndSave(action, entityFlashId, fileFormatInstance, files, forceAction) {
			blockUI.start();
			Upload.upload({
				url: 'api/editorialEntity/fileFormatInstances/uploadAndSave',
				data: {
					entityId: entityFlashId,
					fileFormatCode: fileFormatInstance.code,
					forceAction: forceAction,
					files: files,
				}
			}).success(function (data) {
				ctrl.editorialEntity.fileFormatInstances = data;
				blockUI.stop();
				ModalAlertService.success($filter('translate')('userApp.editorialEntity.msg.success'), $filter('translate')('userApp.editorialEntity.msg.updatePerformed'));
			}).error(function (data) {
				manageUpgradeOrSaveErrors(data, action, entityFlashId, fileFormatInstance, files);
			});

		}

		function manageUpgradeOrSaveErrors(data, action, entityFlashId, fileFormatInstance, files, idMedia) {
			blockUI.stop();
			if (data.message === "INVALID_MEDIA" && (data.code === "FILE_EXTENSION_ERROR" || data.code === "FILE_SIZE_ERROR")) {
				displayErrorModal(data, fileFormatInstance);
			} else if (data.message === "INVALID_MEDIA" && data.code === "DUPLICATE_FILE_CHECKSUM_WARNING") {
				confirmModalService.openModal(
					'userApp.editorialEntity.confirmModal.' + data.code,
					'userApp.editorialEntity.confirmModal.title',
					{
						'filenames': data.params.join(", ")
					}).then(function (confirm) {
						if (confirm) {
							uploadAndAction(action, entityFlashId, fileFormatInstance, files, true, idMedia);
						}
					});
			}
		}

		function getOnlyFileExtension(filename) {
			var fileExtRegEx = '[^\.]*$';
			return filename.match(fileExtRegEx)[0];
		}

		function displayErrorModal(data, fileFormatInstance) {
			var specificMessage = "";
			if (data.code === "FILE_EXTENSION_ERROR") {
				specificMessage = fileFormatInstance.extensions.join(', ');
			} else if (data.code === "FILE_SIZE_ERROR") {
				specificMessage = fileFormatInstance.size;
			}

			infoModalService.openModal(
				'userApp.editorialEntity.confirmModal.' + data.code,
				'userApp.editorialEntity.confirmModal.title',
				{
					'filenames': data.params.join(', '),
					'specificMessage': specificMessage
				});
		}

		ctrl.canAdd = function (fileFormatInstance) {
			return fileFormatInstance.multipleValue ||
				(!fileFormatInstance.multipleValue && angular.isUndefined(fileFormatInstance.mediaInfos) || fileFormatInstance.mediaInfos.length === 0);
		};

		ctrl.getExtensionClass = function (file) {
			var filenameParts = file.split('.');
			var ext = filenameParts[filenameParts.length - 1];
			switch (ext) {
				case 'jpg': case 'jpeg': case 'png': return 'fa-file-image-o';
				case 'xls': case 'xlsx': return 'fa-file-excel-o';
				case 'doc': case 'docx': return 'fa-file-word-o';
				case 'ppt': case 'pptx': return 'fa-file-powerpoint-o';
				case 'xml': return 'fa-file-code-o';
				case 'mp4': case 'mov': return 'fa-file-video-o';
				case 'mp3': case 'wav': return 'fa-file-audio-o';
				case 'zip': case 'rar': case 'gz': case 'tar': return 'fa-file-archive-o';
				case 'pdf': return 'fa-file-pdf-o';
				default: return 'fa-file-o';
			}
		};

		ctrl.getJoinedExtensions = function (exts) {
			// for all extensions remove . prefix if exists
			angular.forEach(exts, function (ext) {
				ext = getOnlyFileExtension(ext);
			});
			// /!\ returns all well interpreted extensions by file upload component
			return '.' + exts.join(',.');
		};

		ctrl.toggleMediaEditionMode = function () {
			if (ctrl.canEdit()) {
				$rootScope.$emit('editMediaEvent', ctrl.editorialEntity.identifier);
			}
		};
	}

})();

(function () {
	'use strict';

	// Usage:
	// <publish-proof-history></publish-proof-history>
	// Creates:
	// 

	angular
		.module('userApp')
		.component('publishProofHistory', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/publish-proof-history/publish-proof-history.html',
			controller: PublishProofHistoryController,
			bindings: {
				editorialEntity: "="
			},
		});

	/** @ngInject */
	function PublishProofHistoryController(publishProofHistoryResource, Language, $translate, $filter, $rootScope, blockUI) {
		var ctrl = this;

		ctrl.editorialEntity;
		ctrl.typeList = [];
		ctrl.lang = Language.getCurrent();
		ctrl.typeList = [{
			value: "PUBLISH",
			label: 'userApp.publish.type.PUBLISH'
		}, {
			value: "PROOFING",
			label: 'userApp.publish.type.PROOFING'
		}];


		ctrl.lang = $translate.use();

		ctrl.pagination = {
			itemByPage: 50,
			totalCount: 0,
			currentPage: 1
		};
		ctrl.sortString;
		ctrl.historyDateFilter = {};


		ctrl.popup = {
			opened: false,
			opened1: false,
			opened2: false
		};



		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'creationDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllHistrory();
		};

		ctrl.loadAllHistrory = function () {
			ctrl.isLoading = true;
			blockUI.start();


			publishProofHistoryResource.getHistoryForEE({
				eeFlashId: ctrl.editorialEntity.identifier,
				mapFilters: ctrl.searchMap,
				page: Math.max(ctrl.pagination.currentPage - 1, 0),
				size: ctrl.pagination.itemByPage,
				sort: ctrl.sortString
			}).$promise.then(function (data) {
				ctrl.events = data;
				ctrl.rowCollection = data ? (data.historyPubishAndProof.content ? data.historyPubishAndProof.content : []) : [];
				ctrl.historyList = [].concat(ctrl.rowCollection);
				ctrl.pagination.totalCount = data.historyPubishAndProof.totalElements;
				ctrl.publiePar = data.publiePar.filter(function (v) {
					return v !== null;
				});
				ctrl.version = data.version.filter(function (v) {
					return v !== null;
				});
				ctrl.isLoading = false;
				blockUI.stop();
			}).catch(function (e) {
				ctrl.isLoading = false;
				blockUI.stop();
			});
		};

		ctrl.$onInit = function () {
			ctrl.searchMap = {};
			ctrl.searchMap['author'] = null;
			ctrl.searchMap['type'] = null;
			ctrl.searchMap['version'] = null;

		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('productGroup', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/product-group/product-group.html',
			controller: ProductGroupController,
			bindings: {
				entity: '=',
				teeCode: '<',
				edit: '<',
				isDuplication: '<',
				isImport: '<',
				onChangeProductGroup: '&?',
				ownerGroup: "<?",
				showMetaProduct: '<',
				metasAssociation: '<',
				contentClass: '@?',
				labelClass: '@?',
				displayGroup: '<?'
			}
		});

	/** @ngInject */
	function ProductGroupController(productGroupService, $filter, $rootScope, $timeout, userPreferenceService) {
		var ctrl = this;
		var sessionMap = [];
		ctrl.onChangeProductGroupValue = function () {
			$rootScope.ownerGroup = ctrl.entity.ownerGroup;
			ctrl.isMetaProductVisible = ctrl.showMetaProduct && productGroupService.isAuthorizedMetaAssociation(ctrl.groups, ctrl.entity.ownerGroup);
			var selectedPrincipalProduct = productGroupService.getGroupProduct(ctrl.entity.ownerGroup, ctrl.groups);
			productGroupService.updateSessionFromMetaGrpValue(ctrl.entity.productMetaInstanceByMetaGroupList, sessionMap);
			if (selectedPrincipalProduct) {
				$timeout(function () {
					$rootScope.$broadcast("product-code-change",
						{
							productCode: angular.copy(ctrl.entity.ownerGroup),
							sessionMap: sessionMap,
							productTypology: selectedPrincipalProduct.typology
						});
				}, 100);
			}
			if (ctrl.onChangeProductGroup) {
				ctrl.onChangeProductGroup({ ownerGroup: ctrl.entity.ownerGroup });
			}
			if (!ctrl.isDuplication) {
				$rootScope.$broadcast("principal-product-change", selectedPrincipalProduct);
			}
		};

		ctrl.handler = $rootScope.$on('load_product_associations', function () {
			ctrl.onChangeProductGroupValue();
		});
		ctrl.isContextualTir = function () {
			return angular.isDefined(userPreferenceService.getUserGlobalPreference('OwnerGroup'));
		};

		ctrl.$onInit = function () {
			if (ctrl.isContextualTir()) {
				// SET THE CODE GROUP PRODUCT OF CONTEXT IF EXIST
				ctrl.ownerGroupContextualTir = userPreferenceService.getUserGlobalPreference('OwnerGroup');
			}
			// MANAGEMENT OF OWNERGROUP INTO THIS COMPONENT
			if (_.isUndefined(ctrl.ownerGroup)) {
				ctrl.ownerGroup = "";
			}
			ctrl.isMetaProductVisible = ctrl.showMetaProduct;
			if (angular.isUndefined(ctrl.displayGroup)) {
				ctrl.displayGroup = true;
			}
			if (_.isUndefined(ctrl.entity.ownerGroup)) {
				// IF ctrl.entity.ownerGroup IS UNDEFINED OR EMPTY => THE CASE OF CREATION
				ctrl.entity.ownerGroup = "";
			}
			if (_.isUndefined(ctrl.typology)) {
				ctrl.typology = "";
			}
			if (ctrl.metasAssociation) {
				productGroupService.updateSessionFromMetaGrpValue([{ metaDataInstanceDTOList: ctrl.metasAssociation }], sessionMap);
			}
			// GET GROUPS FOR CURRENT USER & TEE
			// THEN SET THE INITIAL OR THE DEFAULT PRODUCT
			productGroupService.groupsByUserAndTemplate(ctrl.teeCode).then(function (data) {
				if (data) {
					ctrl.groups = data;
					// 0_CASE : IF IT IS A DUPLICATION AND A TARGET PRODUCT IS ALREADY SELECTED
					var selectedProductInAuthorizedCodes = _.filter(ctrl.groups, function (product) { return product.code === ctrl.ownerGroup; });
					if (ctrl.isDuplication && angular.isDefined(selectedProductInAuthorizedCodes) && selectedProductInAuthorizedCodes.length === 1) {
						setProductGroup(selectedProductInAuthorizedCodes[0]);
						ctrl.onChangeProductGroupValue();
					}
					// 1_CASE : IF EE CREATION OR IS DUPLICATION && IT IS A CONTEXTUAL TIR
					else if ((isEntityCreation() || ctrl.isDuplication) && ctrl.isContextualTir()) {
						var groupContext = productGroupService.getGroupProduct(ctrl.ownerGroupContextualTir, ctrl.groups);
						//IF IT IS CONTEXTUALIZED THEN DISPLAY ALWAYS THE CONTEXT PRODUCT
						var previousProductCode = ctrl.entity.ownerGroup;
						if (groupContext) {
							setProductGroup(groupContext);
						} else {
							setProductGroup(ctrl.groups[0]);
						}

						if (previousProductCode !== ctrl.entity.ownerGroup) {
							ctrl.onChangeProductGroupValue();
						}
					}
					// 2_CASE : IF IS NOT A CONTEXTUAL TIR
					else {
						// 1_SUB_CASE : CREATION OF EE
						if (_.isEmpty(ctrl.entity.ownerGroup)) {
							setProductGroup(ctrl.groups[0]);
						}
						// 2_SUB_CASE : EDITION OF EE OR DUPLICATION
						else {
							// TEST IF THE CURRENT USER IS AUTHORIZED ON THE PRODUCT OF EXISTED EE
							var existedGroup = productGroupService.getGroupProduct(ctrl.entity.ownerGroup, ctrl.groups);
							// 2_1_SUB_CASE : EDITION OR CREATION NEW EE TYPE FORM
							if (existedGroup) {
								setProductGroup(existedGroup);
							}
							// 2_2_SUB_CASE : DUPLICATION AND THE CURRENT USER IS NOT AUTHORIZED ON TH EXISTED PRODUCT
							else {
								setProductGroup(ctrl.groups[0]);
							}
						}
					}

					if (ctrl.isImport && ctrl.ownerGroupContextualTir) {
						var importGroup = productGroupService.getGroupProduct(ctrl.ownerGroupContextualTir, ctrl.groups);
						if (importGroup) {
							ctrl.groups = [importGroup];
							setProductGroup(importGroup);
							ctrl.onChangeProductGroupValue();
						}
						ctrl.entity.productSuggestedPublicationDate = new Date();
					}
				}

				$rootScope.ownerGroup = ctrl.entity.ownerGroup;
				//RULE : SINGLE RESULT = > DEFAULT VALUE
				if (data.length === 1) {
					$timeout(function () {
						$rootScope.$broadcast("product-code-change");
					}, 500);
				}

				// CHECK WHETHER THE USER HAS THE AUTHORITY TO EDIT
				if ((!ctrl.entity.productMetaInstanceByMetaGroupList || ctrl.entity.productMetaInstanceByMetaGroupList.length === 0) && ctrl.entity.ownerGroup) {
					if (ctrl.showMetaProduct) {
						ctrl.onChangeProductGroupValue();
					}
					if (ctrl.onChangeProductGroup) {
						ctrl.onChangeProductGroup({
							ownerGroup: ctrl.entity.ownerGroup
						});
					}
				}

				// CHECK IF SHOW META ASSOCIATION
				if (ctrl.isDuplication) {
					ctrl.isMetaProductVisible = ctrl.showMetaProduct && productGroupService.isAuthorizedMetaAssociation(ctrl.groups, ctrl.entity.ownerGroup);
					// INIT DESIRED PUBLICATION DATE
					if (ctrl.isMetaProductVisible) {
						ctrl.entity.productSuggestedPublicationDate = new Date();
					}
				}

			});
		};

		/**
			* Return true if it is creation entity
			* @returns {boolean}
			*/
		function isEntityCreation() {

			return _.isEmpty(ctrl.entity.identifier) || (ctrl.entity.deleted && ctrl.entity.workCopy);
		}

		/**
			* @name setProductGroup
			* @desc set the product's code on entity object
			* @param {object} group
			*/
		function setProductGroup(group) {
			ctrl.entity.ownerGroup = group.code;
			ctrl.typology = group.typology;
			ctrl.ownerGroup = group.code;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('productGroupService', ProductGroupService);

	/** @ngInject */
	function ProductGroupService(userGroupResource) {
		var service = {
			groupsByUserAndTemplate: groupsByUserAndTemplate,
			groupsByTemplate: groupsByTemplate,
			groupsByUser: groupsByUser,
			updateMetaGrpValueFromSession: updateMetaGrpValueFromSession,
			updateSessionFromMetaGrpValue: updateSessionFromMetaGrpValue,
			isAuthorizedMetaAssociation: isAuthorizedMetaAssociation,
			getGroupProduct: getGroupProduct
		};

		return service;

		// GET GROUPS FOR CURRENT USER & TEE
		function groupsByUserAndTemplate(entityTemplateCode) {
			return userGroupResource.groupsByUserAndTemplate({ code: entityTemplateCode }).$promise;
		}

		// GET GROUPS FOR CURRENT USER & TEE
		function groupsByTemplate(entityTemplateCode) {
			return userGroupResource.groupsByTemplate({ code: entityTemplateCode }).$promise;
		}

		// GET GROUPS FOR CURRENT USER & TEE
		function groupsByUser() {
			return userGroupResource.groupsByUser().$promise;
		}

		function updateMetaGrpValueFromSession(productMTGrps, sessionMap) {
			angular.forEach(productMTGrps, function (productMTGrp) {
				angular.forEach(productMTGrp.metaDataInstanceDTOList, function (meta) {
					switch (meta.metaDataDTO.metaDataType) {
						case 'URL':
							if (sessionMap[meta.metaDataDTO.code]) {
								meta.urlDTOList = sessionMap[meta.metaDataDTO.code];
							}
							break;
						case 'REPOSITORY':
							if (sessionMap[meta.metaDataDTO.code]) {
								meta.referentialValueDTOList = sessionMap[meta.metaDataDTO.code]['referentialValueDTOList'];
								meta.listDisplayPathForNode = sessionMap[meta.metaDataDTO.code]['listDisplayPathForNode'];
							}
							break;
						case 'MEDIA':
							if (sessionMap[meta.metaDataDTO.code]) {
								meta.listFiles = sessionMap[meta.metaDataDTO.code];
							}
							break;

						default:
							if (sessionMap[meta.metaDataDTO.code]) {
								meta.value = sessionMap[meta.metaDataDTO.code];
							}
					}
				});
			});
		}

		function updateSessionFromMetaGrpValue(productMTGrps, sessionMap) {
			angular.forEach(productMTGrps, function (productMTGrp) {
				angular.forEach(productMTGrp.metaDataInstanceDTOList, function (meta) {
					switch (meta.metaDataDTO.metaDataType) {
						case 'URL':
							sessionMap[meta.metaDataDTO.code] = meta.urlDTOList;
							break;
						case 'REPOSITORY':
							sessionMap[meta.metaDataDTO.code] = {};
							sessionMap[meta.metaDataDTO.code]['referentialValueDTOList'] = meta.referentialValueDTOList;
							sessionMap[meta.metaDataDTO.code]['listDisplayPathForNode'] = meta.listDisplayPathForNode;
							break;
						case 'MEDIA':
							sessionMap[meta.metaDataDTO.code] = meta.listFiles;
							break;
						default:
							sessionMap[meta.metaDataDTO.code] = meta.value;
					}

				});
			});
		}

		// CHECK IF OWNER GROUP IS AUTHORIZED TO SHOW META ASSOCIATION
		function isAuthorizedMetaAssociation(groups, ownerGroup) {
			if (groups && groups.length > 0) {
				var group = _.find(groups, function (o) {
					return o.code === ownerGroup;
				});
				return group.authorizedMetaAssociation;
			}
			return false;
		}
		/**
		 * @name getGroupProduct
     * @desc get the product group DTO from the list of the authorized product by current user
		 * @param {string} groupCode
		 * @param {array} groups
		 * @return {object} group  
		 */
		function getGroupProduct(groupCode, groups) {
			var groupProduct = _.find(groups, function (o) {
				return o.code === groupCode;
			});
			return groupProduct;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityAuthorizeService', EntityAuthorizeService);


	/** @ngInject */
	function EntityAuthorizeService(entityAuthorizeResource, authorizeConstants, blockUI) {
		var service = {
			authorize: authorize,
			authorizeById: authorizeById,
			secureAction: secureAction,
			permissions: permissions,
			entityTemplatepermissions: entityTemplatepermissions,
			permissionsDTO: permissionsDTO,
			isMetadataEnabled: isMetadataEnabled,
			isInitAndEditMetadataEnabled: isInitAndEditMetadataEnabled,
			isEditContentEnabled: isEditContentEnabled,
			isInitAndEditContentEnabled: isInitAndEditContentEnabled,
			isInitWorkflowUpdateEnabled: isInitWorkflowUpdateEnabled,
			isEditWorkflowEnabled: isEditWorkflowEnabled,
			isControlEnabled: isControlEnabled,
			isPublishEnabled: isPublishEnabled
		};

		return service;

		function authorize(editorialEntity, action) {
			return authorizeById(editorialEntity.identifier, action);
		}

		function authorizeById(id, action) {
			blockUI.start();
			return entityAuthorizeResource.canPerform({
				flashId: id,
				action: action
			}).$promise
				.then(function (data) {
					blockUI.stop();
					return data.body === "true";
				});
		}

		function secureAction(id, action) {
			blockUI.start();
			return entityAuthorizeResource.secureAction({
				flashId: id,
				action: action
			}).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		function permissions(flashId) {
			return entityAuthorizeResource.permissions({
				id: flashId
			}).$promise;
		}

		function permissionsDTO(flashId) {
			return entityAuthorizeResource.permissionsDTO({
				id: flashId
			}).$promise;
		}

		function isMetadataEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.editMetadata) !== -1;
		}

		function isInitAndEditMetadataEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.initAndEditMetadata) !== -1;
		}

		function isEditContentEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.editContent) !== -1;
		}

		function isInitAndEditContentEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.initAndEditContent) !== -1;
		}

		function isInitWorkflowUpdateEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.initWorkflowUpdate) !== -1;
		}

		function isEditWorkflowEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.editWorkflow) !== -1;
		}

		function isControlEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.control) !== -1;
		}

		function isPublishEnabled(permissions) {
			return _.indexOf(permissions, authorizeConstants.publish) !== -1;
		}

		function entityTemplatepermissions(teeCode, ownerGroup) {
			return entityAuthorizeResource.entityTemplatepermissions({
				teeCode: teeCode,
				ownerGroup: ownerGroup
			}).$promise;
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityBuilderService', EntityBuilderService);


	/** @ngInject */
	function EntityBuilderService() {
		var service = {
			buildByFlashId: buildByFlashId
		};

		return service;

		function buildByFlashId(flashId) {
			return { identifier: flashId };
		}

	}

})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityEditorService', EntityEditorService);


	/** @ngInject */
	function EntityEditorService($uibModal, $stateParams, $state, $log, blockUI) {
		var service = {
			errorXmlToHtmlModal: errorXmlToHtmlModal,
			handleStartEditionResponse: handleStartEditionResponse,
			handleStartEditionError: handleStartEditionError
		};

		return service;

		function errorXmlToHtmlModal(result) {
			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'startMessageComponent',
				size: 'lg',
				backdrop: 'static',
				resolve: {

					result: function () { return result; },
					mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editor');
						return $translate.refresh();
					}]
				}
			});

			modalInstance.result.then(
				function (_id) {
					modalInstance = null;
					$state.go('editorialEntity', {
						"id": _id
					});
				});


		}

		function handleStartEditionResponse(response, ee_id) {
			blockUI.stop();
			if (response.forceEdition !== true && response.editionStatus === "TECHNICAL_ERROR" ||
				response.forceEdition !== true && response.editionStatus === "INVALID") {
				var result = {};
				result.editionStatus = response.editionStatus;
				result.error = response.error;
				result.id = ee_id;
				errorXmlToHtmlModal(result);
				blockUI.stop();
				throw "error transformation xml to html from entity flash id : " + ee_id;
			} else {
				return response;
			}
		}

		function handleStartEditionError(err, ee_id) {
			blockUI.stop();
			$log.error(["failed to start edition of entity " + ee_id, err]);
			$state.go('editorialEntity', {
				"id": ee_id
			});
		}





	}

})();










(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityImportService', EntityImportService);


	/** @ngInject */
	function EntityImportService(importArticleModalService, infoModalService, entityValidateResource, entityFetchResource, entityAuthorizeService, blockUI) {
		var service = {
			importEntity: importEntity
		};

		return service;

		function importEntity(selectedEE, contextProduct) {
			//CHECK IF ONLY ONE EE IS SELECTED
			if (selectedEE.length > 1) {
				infoModalService.openModal("error.import.multiSelect", "error.import.title");
			}
			//IF ONLY ONE EE IS SELECTED
			else {
				blockUI.start();
				entityFetchResource.getByFlashId({ flashId: selectedEE[0] })
					.$promise.then(function (entity) {
						//CHECK IF ENTITY PRINCIPAL PRODUCT IS NOT THE CONTEXTUALIZED PRODUCT
						if (contextProduct === entity.ownerGroup) {
							infoModalService.openModal("error.import.sameProduct", "error.import.title");
						}
						//CHECK IF ENTITY IS IN A FINAL STATUS
						else if (!entity.system.systemFinalStatus) {
							infoModalService.openModal("error.import.nonFinalStatus", "error.import.title");
						}
						else {
							//CHECK USER PERMISSION TO IMPORT THE EE
							return entityAuthorizeService.entityTemplatepermissions(entity.editorialEntityTemplate.code, contextProduct)
								.then(function (permissions) {
									if (_.indexOf(permissions, "CREATE") === -1) {
										infoModalService.openModal("error.import.notAuthorized", "error.import.title");
									}
									else {
										//CHECK IF ENTITY HAS ON GOING OR ACCEPTED PROPOSAL
										return entityValidateResource.checkIfEntityHasOnGoingOrAcceptedProposals({ id: entity.identifier, product: contextProduct }).$promise
											.then(function (data) {
												if (data.exist) {
													infoModalService.openModal("error.import.hasOnGoingOrAcceptedProposals", "error.import.title");
												}
												else {
													importArticleModalService.openModal(selectedEE);
												}
											});
									}
								});
						}
					}).finally(function () {
						blockUI.stop();
					});
			}
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityLockService', EntityLockService);


	/** @ngInject */
	function EntityLockService(entityLockResource, entityUpdateResource, blockUI) {
		var service = {
			lock: lock,
			lockSourceEntity: lockSourceEntity,
			unlockSourceEntity: unlockSourceEntity,
			unlock: unlock,
			breakLock: breakLock,
			isLockedByOtherUser: isLockedByOtherUser,
			isLocked: isLocked,
			isSourceEntityLocked: isSourceEntityLocked

		};

		return service;

		function lock(flashId) {
			blockUI.start();
			return entityLockResource.lock({ flashId: flashId }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		function lockSourceEntity(flashId, type) {
			blockUI.start();
			return entityLockResource.lockSourceEntity({ flashId: flashId, type: type }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		function unlockSourceEntity(flashId, type) {
			blockUI.start();
			return entityLockResource.unlockSourceEntity({ flashId: flashId, type: type }).$promise
				.then(function () {
					blockUI.stop();
				});
		}


		function unlock(flashId) {
			blockUI.start();
			return entityLockResource.unlock({ flashId: flashId }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		function breakLock(flashId) {
			blockUI.start();
			return entityLockResource.breakLock({ flashId: flashId }).$promise
				.then(function () {
					blockUI.stop();
				});
		}

		function isLockedByOtherUser(flashId) {
			blockUI.start();
			return entityLockResource.isLockedByOtherUser({ flashId: flashId }).$promise
				.then(function (data) {
					blockUI.stop();
					return data.isLocked;
				});
		}

		function isLocked(flashId) {
			blockUI.start();
			return entityLockResource.isLocked({ flashId: flashId }).$promise
				.then(function (data) {
					blockUI.stop();
					return data.isLocked;
				});
		}

		function isSourceEntityLocked(flashId, type) {
			blockUI.start();
			return entityLockResource.isSourceEntityLocked({ flashId: flashId, type: type }).$promise
				.then(function (data) {
					blockUI.stop();
					return data.isLocked;
				});
		}


	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityMediaService', EntityMediaService);


	/** @ngInject */
	function EntityMediaService(entityMediaResource) {
		var service = {
			deleteMediaAndUpdateEntity: deleteMediaAndUpdateEntity
		};

		return service;

		function deleteMediaAndUpdateEntity(entityId, fileFormatCode, idMedia) {
			return entityMediaResource.deleteMediaAndUpdateEntity({ entityId: entityId, fileFormatCode: fileFormatCode, idMedia: idMedia }).$promise;
		}

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityTemplateService', EntityTemplateService);


	/** @ngInject */
	function EntityTemplateService(entityTemplateResource, entityTreeAutoAssemblingResource) {
		var service = {
			getInfo: getInfo,
			getAutoAssemblingFilters: getAutoAssemblingFilters,
			searchTargetEntities: searchTargetEntities
		};

		return service;

		function getInfo(flashId, type) {
			return entityTemplateResource.info({ flashId: flashId, type: type }).$promise;
		}

		function getAutoAssemblingFilters(code) {
			return entityTreeAutoAssemblingResource.getMountingMetaDataList({ eetCode: code }).$promise;
		}

		function searchTargetEntities(code, productCode, filters, sourceEntityFlashId) {
			return entityTreeAutoAssemblingResource.searchTargetEntities({ eetCode: code, productCode: productCode, sourceEntityFlashId: sourceEntityFlashId }, filters).$promise;
		}
	}

})();

'use strict';

/**
 * @deprecated
 */
angular.module('userApp')
	.factory('EditorialEntityService', function ($resource) {
		return $resource('api/editorialEntities', {}, {
			'getEEWithFirstLevelChildNodesById': {
				method: 'GET',
				url: 'api/editorialEntities/:id/subnodes'
			},
			'getEEById': {
				method: 'GET',
				url: 'api/editorialEntities/:id'
			},
		});

	});


(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('entityUnlockService', EntityUnlockService);


	/** @ngInject */
	function EntityUnlockService(entityLockResource, confirmModalService, blockUI, infoModalService, $filter, $state) {
		var service = {
			confirmUnlock: confirmUnlock,		
			unlockMulti: unlockMulti

		};

		return service;




		function confirmUnlock(entityIds, accept) {
			var message =  "userApp.editorialEntity.msg.acceptUnlock";
			return confirmModalService.openMessageModal(message)
				.then(function (result) {
					if (result) {
						blockUI.start();
						return unlockMulti(entityIds)
							.then(function () {
								blockUI.stop();
								return true;
							});
					}
					return result;
				});
		}


		function unlockMulti(entityIds) {
			return entityLockResource.unlockList({flashIds:entityIds}).$promise
				.then(function () {
					//OPEN MODAL INFO					
					infoModalService.openBulkSucess(
						{
							operation: $filter('translate')('entity.actionBar.workflow.tooltip')
						}
					).then(function () {
						$state.go('myBulkOperations');
					});
				});
		}


	}

})();










(function () {
	'use strict';

	// Usage:
	//<tree-view></tree-view>
	// Creates:
	// 

	angular
		.module('userApp')
		.component('treeViewComp', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view.tpl.html',
			controller: TreeViewController,

			/// 1.API ///
			bindings: {
				editorialEntity: '<',
				readOnly: '<',
				onNodeSelection: '&?',
				showNodesMetaData: '<?',
				treeViewInstance: '=?',
				//Optionel
				isDisplayRadioButton: '@?',
				//Optionel
				onNodeCheck: '&?',
				onNodeAction: '&?',
				radionButtonDisplayOn: '@?',
				handleExternalActionEvent: '<?',
				handleExternalActionAccessor: "<?"
			}
		});

	/** @ngInject */
	function TreeViewController(blockUI, nodeResource) {
		var ctrl = this;

		/// 2.OPERATIONS ///
		//Filter meta datas.
		ctrl.filterMetaData = function (metaInstanceDTOList, metaDataType) {
			var metaData = [];
			if (metaInstanceDTOList !== null && metaInstanceDTOList.length > 0) {
				var count = 0;
				if (metaDataType === 'system') {
					// system meta data
					for (; count < metaInstanceDTOList.length; count++) {
						if (metaInstanceDTOList[count].metaDataDTO.metaSystem) {
							// system meta data
							metaInstanceDTOList[count].value = metaInstanceDTOList[count].value;
							metaData.push(metaInstanceDTOList[count]);
						}
					}
				} else if (metaDataType === 'editorial') {
					// user meta data
					for (; count < metaInstanceDTOList.length; count++) {
						if (!metaInstanceDTOList[count].metaDataDTO.metaSystem) {
							// system meta data
							metaInstanceDTOList[count].value = metaInstanceDTOList[count].value;
							metaData.push(metaInstanceDTOList[count]);
						}
					}
				}
				return metaData;
			}
		};
		//Create a new treeview node.
		ctrl.initTreeNode = function (
			id,
			text,
			hasChildren,
			systemMetaData,
			editorialsMetaData,
			metaInstanceDTOList,
			items,
			type,
			relationStatus,
			xmlContent,
			htmlPreview,
			grayDisplay,
			showSystemMetaData,
			displayOrder,
			path,
			linkedEETitle,
			activated,
			relationId,
			refNodeId,
			subNodesId,
			linkedEESummary,
			showLinkedEESummary,
			desiredPublicationDate
		) {
			var node = {
				id: id,
				text: text,
				hasChildren: hasChildren,
				systemMetaData: systemMetaData,
				editorialsMetaData: editorialsMetaData,
				metaInstanceDTOList: metaInstanceDTOList,
				items: items,
				type: type,
				relationStatus: relationStatus,
				xmlContent: xmlContent,
				htmlPreview: htmlPreview,
				grayDisplay: grayDisplay,
				showSystemMetaData: showSystemMetaData,
				displayOrder: displayOrder,
				path: path,
				linkedEETitle: linkedEETitle,
				activated: activated,
				relationId: relationId,
				refNodeId: refNodeId,
				subNodesId: subNodesId,
				linkedEESummary: linkedEESummary,
				showLinkedEESummary: showLinkedEESummary,
				desiredPublicationDate: desiredPublicationDate
			};
			return node;
		};
		//Map tree view node from dto node.
		ctrl.mapNodes = function (data) {
			var nodes = [];
			if (angular.isDefined(data) && data !== null && (data.length > 0)) {
				var i = 0;
				for (; i < data.length; i++) {
					var node = ctrl.initTreeNode(
						data[i].id,
						data[i].title,
						data[i].subNodesId !== null && data[i].subNodesId.length > 0,
						ctrl.filterMetaData(data[i].metaInstanceDTOList, 'system'),
						ctrl.filterMetaData(data[i].metaInstanceDTOList, 'editorial'),
						data[i].metaInstanceDTOList, [],
						data[i].type,
						data[i].relationStatus,
						(data[i].type === 'CONTENT') ? data[i].xmlContent : null,
						(data[i].type === 'REFERENCE') ? data[i].htmlPreview : null,
						data[i].grayDisplay,
						false,
						data[i].displayOrder,
						data[i].path,
						data[i].linkedEETitle,
						data[i].activated,
						(data[i].type === 'REFERENCE' && data[i].relationDTO !== null) ? data[i].relationDTO.flashId : null,
						data[i].refNodeId,
						data[i].subNodesId,
						null,
						false,
						(data[i].type === 'REFERENCE' && data[i].relationDTO !== null) ? data[i].relationDTO.desiredPublicationDate : null);
					//Expand firt level nodes.
					if (node.path.length === 1 && node.hasChildren) {
						node.expanded = true;
					}
					nodes.push(node);
				}
			}
			return nodes;
		};

		/// 3.INIT BLOC ///
		ctrl.$onInit = function () {

			//Set default values
			ctrl.readOnly = angular.isDefined(ctrl.readOnly) ? ctrl.readOnly : false;
			ctrl.showNodesMetaData = angular.isDefined(ctrl.showNodesMetaData) ? ctrl.showNodesMetaData : false;
			ctrl.options = {
				dragAndDrop: !ctrl.readOnly
			};

			//Tree data source
			ctrl.dataSource = new kendo.data.HierarchicalDataSource({
				sort: {
					field: "displayOrder",
					dir: "asc"
				},
				transport: {
					read: function (options) {
						// Node id
						var id = options.data.id || (angular.isDefined(options.data.data) ? options.data.data.id : null);
						if (!id) {
							// Root node
							options.success(ctrl.mapNodes(ctrl.editorialEntity.subElements));
						} else if (id === ctrl.editorialEntity.id) {
							// Expending of root node
							options.success(ctrl.mapNodes(ctrl.editorialEntity.subElements));
						} else {
							// sub node
							// Load remote child nodes
							var node = ctrl.dataSource.get(id);
							blockUI.start();
							nodeResource.getNodeWithFirstLevelChildNodes({
								id: angular.isDefined(node) ? node.id : ctrl.editorialEntity.identifier,
								grayDisplay: angular.isDefined(node) ? node.grayDisplay : false
							}).$promise.then(function (subnodes) {
								blockUI.stop();
								options.success(ctrl.mapNodes(subnodes));
							}, function () {
								blockUI.stop();
								options.success([]);
							});
						}
					}
				},
				schema: {
					model: {
						id: "id",
						hasChildren: "hasChildren"
					}
				}
			});

		};

		/// 4.HANDLE EXTERNAL CHANGES BLOC ///
		ctrl.$onChanges = function (changesObj) { };

		/// 5.RELEASE RESOURCES BLOC ///
		ctrl.$onDestroy = function () {
			ctrl.treeViewInstance.destroy();
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('treeEEEdition', {
				parent: 'connect',
				url: "/editorialEntity/tree/:id/edit/:editionMode?returnToEE",
				templateUrl: 'scripts/pre-upgrade/components/editorial-entity/tree-view/treeEEEdition/treeEEEdition.tpl.html',
				controller: 'treeEEEditionController',
				controllerAs: 'treeEEEditionCtrl',
				resolve: {
					entity: function (EditorialEntityService, $stateParams, blockUI) {
						blockUI.start();
						return EditorialEntityService.getEEById({
							id: $stateParams.id
						}).$promise.then(function (data) {
							blockUI.stop();
							return data;
						}, function () {
							blockUI.stop();
						});
					},
					secureAction: function (entityAuthorizeService, $stateParams, authorizeConstants) {
						return entityAuthorizeService.secureAction($stateParams.id, authorizeConstants.editContent);
					},
					eEpermissions: function ($stateParams, entityAuthorizeService) {
						return entityAuthorizeService.permissions($stateParams.id);
					},
					currentUser: ['userResource', function (userResource) {
						return userResource.getCurrentUser().$promise;
					}],
					mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editorialEntity');
						$translatePartialLoader.addPart('treeEeedition');
						$translatePartialLoader.addPart('metadatas');
						$translatePartialLoader.addPart('datepicker');
						return $translate.refresh();
					}]
				}
			});
	}

})();


(function () {
	'use strict';

	// Usage:
	// <tree-flat-view></tree-flat-view>
	// Creates:
	// 

	angular
		.module('userApp')
		.component('timelinePageComponent', {
			templateUrl: 'scripts/pre-upgrade/components/editorial-entity/timeline/timeline-page.html',
			controller: TimelinePageComponentController,
			bindings: {
				editorialEntity: "<",
				displayMode: "<"
			},
		});

	/** @ngInject */
	function TimelinePageComponentController($rootScope, blockUI, $sce, timelineService, htmlPreviewService, HTML_PREVIEW_TYPE) {
		var ctrl = this;

		ctrl.versions = [];
		ctrl.$sce = $sce;
		ctrl.leftSideChanges;
		ctrl.leftSideVersion;
		ctrl.rightSideChanges;
		ctrl.rightSideVersion;
		ctrl.warningMessage;
		ctrl.firstClick = true;

		ctrl.refreshVersions = function () {
			timelineService.getVersions(ctrl.editorialEntity.identifier).then(function (data) {
				ctrl.versions = data.slice(0, data.length);

				// TODO
				// USE System ? The system is not refresh in refreshentity function ...
				// Add the current version in the core ?
				var system = ctrl.editorialEntity.system;
				//var qualifiedVersion = [system.systemVersionMaj, system.systemVersionMin, system.systemVersionPatch].join('.');
				var qualifiedVersion = ctrl.editorialEntity.workFlowHistoryDTO.qualifiedVersion;

				ctrl.versions.push({
					qualifiedVersion: qualifiedVersion,
					initiator: system.systemModifier,
					initiationDate: system.systemLastUpdateDate,
					currentUpdate: true
				});

			});
		};

		ctrl.$onInit = function () {
			ctrl.refreshEventDestroy = $rootScope.$on('version_changed', function () {
				ctrl.refreshVersions();
			});

			ctrl.refreshVersions();
		};

		ctrl.$onChanges = function (changesObj) {
		};
		ctrl.$onDestroy = function () {
			if (ctrl.refreshEventDestroy) {
				ctrl.refreshEventDestroy();
			}
		};

		ctrl.getContent = function (flashId, version, current) {
			blockUI.start();
			if (current) {
				return htmlPreviewService.getPreview(flashId, HTML_PREVIEW_TYPE.complete, false)
					.then(function (eePreviewHtml) {
						blockUI.stop();
						return eePreviewHtml.htmlPreview;
					}).finally(function () { blockUI.stop(); });
			}
			else {
				return htmlPreviewService.getVersionedPreview(flashId, version)
					.then(function (data) {
						blockUI.stop();
						return data.htmlContent;
						//	console.log(ctrl.leftSideVersion);
					}).finally(function () { blockUI.stop(); });
			}
		};

		/**
		 * Handles timeline click
		 * @param {*} entry The entry to load
		 */
		ctrl.loadVersion = function (entry) {
			delete ctrl.warningMessage;

			if (ctrl.versions) {
				ctrl.versions.forEach(function (element) {
					if (ctrl.firstClick) {
						delete element.previous;
						delete element.selected; //remove others
					}
				});

				if (ctrl.firstClick) {
					ctrl.leftSideVersion = entry;
					ctrl.getContent(ctrl.editorialEntity.identifier, entry.qualifiedVersion, entry.currentUpdate).then(function (content) { ctrl.leftSideChanges = content; });
					entry.selected = true;
					ctrl.rightSideVersion = null;
					ctrl.rightSideChanges = null;
					ctrl.showCompare = false;
				}
				else {
					ctrl.rightSideVersion = entry;
					entry.previous = true;
					ctrl.getContent(ctrl.editorialEntity.identifier, entry.qualifiedVersion, entry.currentUpdate).then(function (content) { ctrl.rightSideChanges = content; });
				}

				ctrl.firstClick = !ctrl.firstClick;
			}
		};

		ctrl.compare = function () {
			if (ctrl.showCompare) {
				ctrl.showCompare = false;
			}
			else {
				blockUI.start();
				timelineService.getComparison(ctrl.leftSideChanges, ctrl.rightSideChanges).then(function (diff) {
					blockUI.stop();
					ctrl.compareHtml = diff;
					ctrl.showCompare = true;
				});
			}
		};
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('timelineService', TimelineService);

	/** @ngInject */
	function TimelineService($q, versioningResource) {
		var service = {
			getVersions: getVersions,
			getComparison: getComparison
		};

		// var OPERATIONS = {
		// 	EQUAL: 0,
		// 	INSERT: 1,
		// 	DELETE: -1
		// };

		return service;


		function getVersions(flashId) {
			return versioningResource.getAvailableVersion({ flashId: flashId }).$promise;
		}

		function getComparison(dataFileLeft, dataFileRight) {
			// var diffMatchPatch = new diff_match_patch(); //eslint-disable-line

			// var l1 = dataFileLeft.indexOf("</style>");
			// var l2 = dataFileLeft.indexOf("</body>");

			// var dataFileLeftMod = dataFileLeft.substring(l1 + 8, l2);

			// var r1 = dataFileRight.indexOf("</style>");
			// var r2 = dataFileRight.indexOf("</body>");

			// var dataFileRightHead = dataFileRight.substring(0, r1 + 8);
			// var dataFileRightMod = dataFileRight.substring(r1 + 8, r2);
			// var dataFileRightTail = dataFileRight.substring(r2);

			// var deltas = diffMatchPatch.diff_main(dataFileLeftMod, dataFileRightMod);

			// diffMatchPatch.diff_cleanupSemantic(deltas);

			// var differences = deltas.map(function (diff) {
			// 	return { operation: diff[0], text: diff[1] };
			// });

			// differences.unshift({ operation: OPERATIONS.EQUAL, text: dataFileRightHead });
			// differences.push({ operation: OPERATIONS.EQUAL, text: dataFileRightTail });

			//	var output = parseChanges(differences);
			var defer = $q.defer();

			var blob = new Blob(["(" + htmldiffwrapper.toString() + ").call(this);" + "onmessage = function(e) { postMessage(htmldiff(e.data.left, e.data.right)); }"]); //eslint-disable-line
			var blobURL = URL.createObjectURL(blob);

			var worker = new Worker(blobURL);
			worker.onmessage = function (e) {
				defer.resolve(e.data);
				URL.revokeObjectURL(blobURL);
				worker.terminate();
			};
			worker.postMessage({ left: dataFileLeft, right: dataFileRight });

			//	defer.resolve(t(dataFileLeft, dataFileRight));
			return defer.promise;
		}

		// function parseChanges(differences) {

		// 	var output = "";

		// 	var check = {
		// 		totalFacts: [],
		// 		totalOpenDivs: 0, totalCloseDivs: 0,
		// 		totalOpenSpans: 0, totalCloseSpans: 0
		// 	};


		// 	//ensure closed tags
		// 	for (var i = 0; i < differences.length; i++) {

		// 		//Case 1, end tag not closed
		// 		var le = differences[i].text.lastIndexOf('>');
		// 		var ls = differences[i].text.lastIndexOf('<');

		// 		//comparison
		// 		if (le < ls) {
		// 			//console.log('Mismatch1:', differences[i].operation, { data: differences[i].text }, ls, le);

		// 			differences[i].hasIssues = true;

		// 			//attempt restoration
		// 			if (differences[i].operation === OPERATIONS.EQUAL && (
		// 				(differences[i + 1].operation === OPERATIONS.DELETE && differences[i + 2].operation === OPERATIONS.INSERT)
		// 				|| differences[i + 2].operation === OPERATIONS.DELETE && differences[i + 1].operation === OPERATIONS.INSERT)) {

		// 				//console.log('Starting Fix1:', { s: ls, end: le, e: differences[i].text, e1: differences[i + 1].text, e2: differences[i + 2].text });

		// 				var missing = differences[i].text.substr(ls, differences[i].text.length - ls);
		// 				differences[i].text = differences[i].text.substr(0, ls);
		// 				differences[i + 1].text = missing + differences[i + 1].text;
		// 				differences[i + 2].text = missing + differences[i + 2].text;

		// 				differences[i].hasIssues = false;
		// 				//console.log('Fixed1:', { m: missing, e: differences[i].text, e1: differences[i + 1].text, e2: differences[i + 2].text });

		// 			}

		// 		}

		// 		//Case 2, start tag already open
		// 		var se = differences[i].text.indexOf('>');
		// 		var ss = differences[i].text.indexOf('<');

		// 		//console.log(ss, se);


		// 		if ((ss === -1 && se > -1) || (se < ss)) {
		// 			//console.log('Mismatch2:', differences[i].operation, { data: differences[i].text }, ss, se);

		// 			differences[i].hasIssues = true;

		// 			var sMissing = differences[i].text.substr(0, se + 1);
		// 			differences[i].text = differences[i].text.substr(se + 1);

		// 			if (differences[i].operation === OPERATIONS.EQUAL && differences[i - 1].hasIssues) {
		// 				//	console.log('Starting Fix2:', { m: sMissing, e: differences[i].text, e1: differences[i - 1].text });
		// 				differences[i - 1].text += sMissing;
		// 				differences[i - 1].hasIssues = false;
		// 				//console.log('Fixed2:', { m: sMissing, e: differences[i].text, e1: differences[i - 1].text });
		// 			}

		// 			if (differences[i].operation === OPERATIONS.EQUAL && differences[i - 2].hasIssues) {
		// 				//	console.log('Starting Fix2:', { m: sMissing, e: differences[i].text, e1: differences[i - 2].text });
		// 				differences[i - 2].text += sMissing;
		// 				differences[i - 2].hasIssues = false;
		// 				//	console.log('Fixed2:', { m: sMissing, e: differences[i].text, e1: differences[i - 2].text });
		// 			}

		// 		}

		// 	}

		// 	//check tags
		// 	differences.forEach(function (item) {
		// 		var facts = {};
		// 		facts.line = item.text.trim();
		// 		facts.operation = item.operation;

		// 		//tags
		// 		facts.divs = facts.line.split('<div').length - 1;
		// 		facts.closeDivs = facts.line.split('</div>').length - 1;
		// 		facts.divMismatch = facts.divs !== facts.closeDivs;
		// 		facts.spans = facts.line.split('<span').length - 1;
		// 		facts.closeSpans = facts.line.split('</span>').length - 1;
		// 		facts.spanMismatch = facts.spans !== facts.closeSpans;

		// 		facts.openTags = facts.line.match('<[a-zA-Z]+(>|.*?[^?]>)');
		// 		facts.closingTags = facts.line.match('</[a-zA-Z]+(>|.*?[^?]>)');


		// 		//first word
		// 		var i = facts.line.indexOf(" ");

		// 		if (i > -1)
		// 			facts.firstWord = facts.line.substr(0, i);

		// 		//end word
		// 		i = facts.line.lastIndexOf('</');
		// 		var j = facts.line.lastIndexOf('>');

		// 		if (i > -1 && j > -1)
		// 			facts.endWord = facts.line.substr(i, j);

		// 		if (facts.divMismatch)
		// 			// console.log(facts);

		// 			check.totalFacts.push(facts);
		// 		check.totalOpenDivs += facts.divs;
		// 		check.totalCloseDivs += facts.closeDivs;
		// 		check.totalOpenSpans += facts.spans;
		// 		check.totalCloseSpans += facts.closeSpans;


		// 	});

		// 	// console.log(`DIV Report: ${check.totalOpenDivs} vs ${check.totalCloseDivs}`);
		// 	// console.log(`SPAN Report: ${check.totalOpenSpans} vs ${check.totalCloseSpans}`);

		// 	// if (check.totalOpenDivs !== check.totalCloseDivs)
		// 	// 	ctrl.warningMessage = `DIV mismatch detected: ${check.totalOpenDivs} vs ${check.totalCloseDivs}`;

		// 	// if (check.totalOpenSpans !== check.totalCloseSpans)
		// 	// 	ctrl.warningMessage = `SPAN mismatch detected: ${check.totalOpenSpans} vs ${check.totalCloseSpans}`;


		// 	console.log(differences);
		// 	differences.forEach(function (diff, i) {
		// 		switch (diff.operation) {
		// 			case OPERATIONS.EQUAL: output += addSpans('', diff.text, ''); break;
		// 			case OPERATIONS.DELETE: output += addSpans('<span class="comparison-deleted">', diff.text, "</span>"); break;
		// 			case OPERATIONS.INSERT: output += addSpans('<span class="comparison-added">', diff.text, "</span>"); break;
		// 			//case OPERATIONS.DELETE: output += detectInnerTag(`*ddd*"`, diff.text, "/*ddd*/"); break;
		// 			//case OPERATIONS.INSERT: output += detectInnerTag(`*aaa*`, diff.text, "/*aaa*/"); break;
		// 		}
		// 	});

		// 	return output;
		// }

		// function addSpans(startSpan, line, endSpan) {

		// 	var output = startSpan + line.replace(/<p>/g, '<p>' + startSpan).replace(/<\/p>/g, endSpan + '</p>') + endSpan;

		// 	return output;

		// }
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('loginFormComponent', {
			templateUrl: 'scripts/pre-upgrade/components/login/login-form/login-form.html',
			controller: loginFormController,
			bindings: {
				modal: '<',
				close: '&'
			}
		});

	/** @ngInject */
	function loginFormController(loginService, $state, $timeout, Auth, Principal, configurationLocalUserService) {
		var ctrl = this;

		ctrl.login = function (event) {
			event.preventDefault();
			Auth.login({
				username: ctrl.model.username,
				password: ctrl.model.password,
				rememberMe: ctrl.rememberMe
			}).then(function () {
				ctrl.authenticationError = false;
				configurationLocalUserService.updateSession();
				if (angular.isDefined(ctrl.modal)) {

					ctrl.close();
					loginService.navigate();

				} else {
					loginService.back();
				}
			}).catch(function (error) {
				ctrl.authenticationError = true;
				var head = error.headers();
				if (head) {
					ctrl.messageAuthentication = head.errormessage;
					return;
				}

			});
		};

		ctrl.$onInit = function () {
			ctrl.model = {
				username: null,
				password: null
			};

			if (ctrl.modal) {
				Principal.identity().then(function (data) {
					if (data) {
						ctrl.model.username = data.login;
						ctrl.usernameDisabled = true;
					}
				});
			}
			ctrl.errors = {};
			ctrl.rememberMe = true;
			$timeout(function () { angular.element('[ng-model="username"]').focus(); });
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('loginModalComponent', {
			templateUrl: 'scripts/pre-upgrade/components/login/login-modal/login-modal.html',
			controller: LoginModalComponent,
			bindings: {
				resolve: '<',
				close: '&',
				dismiss: '&'				
			},
		});

	/** @ngInject */
	function LoginModalComponent() {
	}
})();

'use strict';

angular.module('userApp')
	.factory('LoginService', function ($uibModal, $injector) {
		var service = {
			open: open
		};

		var modalInstance = null;
		var resetModal = function () {
			modalInstance = null;
		};

		return service;

		function open() {
			if (modalInstance !== null) return;
			modalInstance = $uibModal.open({
				size: 'login',
				backdrop: 'static',
				animation: true,
				keyboard: false,
				// templateUrl: 'scripts/pre-upgrade/components/login/login-modal/login-modal.html',
				// controller: 'LoginController',
				component: 'loginModalComponent',
				resolve:
				{
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('login');
						return $translate.refresh();
					}]
				}
			});
			modalInstance.result.then(
				resetModal,
				resetModal
			);
		}
	});



(function () {
	'use strict';

	angular
		.module('userApp')
		.component('createModelComponent', {
			templateUrl: 'scripts/pre-upgrade/components/model/create-model/create-model.html',
			controller: createModelController,
			bindings: {
				resolve: '<',
				close: '&'
			}
		});


	/** @ngInject */
	function createModelController(modelService, ModalAlertService, $filter) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.eeFlashId = ctrl.resolve.eeFlashId;
			ctrl.manageDefaultModelPermitted = ctrl.resolve.manageDefaultModelPermitted; 
			ctrl.modelDTO = {};
			ctrl.visibilityMap = [];
			angular.forEach(angular.fromJson(angular.toJson(ctrl.resolve.allModelVisibility)), function (value, key) {
				ctrl.visibilityMap.push({
					name: key,
					value: value
				});
			});
		};

		ctrl.save = function () {
			ctrl.modelDTO.flashIdEE = ctrl.eeFlashId;
			modelService.saveModel(ctrl.modelDTO, function (data) {
				ctrl.modelDTOSaved = data;
				ModalAlertService.info('info', $filter('translate')('userApp.model.msg.savedModel'), '');
			});

			ctrl.cancel();
		};


		ctrl.cancel = function () {
			ctrl.close({ $value: true });
		};

		ctrl.resetDefaultModel = function () {
			ctrl.modelDTO.defaultModel = false;
		};


		ctrl.$onChanges = function (changesObj) { };
		ctrl.$onDestory = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('createModelService', CreateModelService);


	/** @ngInject */
	function CreateModelService(blockUI, $uibModal, modelService) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal(editorialEntity, currentUser) {
			blockUI.start();
			var modalInstance = $uibModal.open({
				component: 'createModelComponent',
				resolve: {
					eeFlashId: function () {
						return editorialEntity.identifier;
					},
					manageDefaultModelPermitted: function () {
						var eetCode = editorialEntity.system.systemTee;
						var productCode = editorialEntity.system.systemOwnerGroup;
						return modelService.checkManageDefaultModelPermission({ eetCode: eetCode, productCode: productCode }).$promise.then(function (data) {
							return data.permission;
						});
					},
					allModelVisibility: function ($resource) {
						return modelService.allModelVisibility().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('model');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('appHealth', {
			templateUrl: 'scripts/pre-upgrade/components/monitoring/app-health/app-health.html',
			controller: AppHealthController,
			bindings: {
				app: '<'
			},
		});

	/** @ngInject */

	function AppHealthController(monitoringResource, blockUI) {
		var ctrl = this;
		var block = blockUI.instances.get(ctrl.app.name);


		////////////////

		ctrl.$onInit = function () {
			block.start("Chargement en cours" + ctrl.app.name);
			monitoringResource.getAppHealth({ appName: ctrl.app.name }).$promise.then(function (appHealth) {
				ctrl.appHealth = appHealth;
				var instance = _.find(ctrl.appHealth, function (instance) {
					return instance.validFunctionalStatus === true;
				});
				ctrl.isAppValidFunctionalStatus = angular.isDefined(instance);
				block.stop();
			}, function () {
				block.stop();
			});
		};

		ctrl.isAppUP = function () {
			var instance = _.find(ctrl.appHealth, function (instance) {
				return instance.status === "UP";
			});
			return angular.isDefined(instance);
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('listModelsComponent', {
			templateUrl: 'scripts/pre-upgrade/components/model/list-models/list-models.html',
			controller: ListModelsController,
			bindings: {
				currentUser: '<',
				editable: '<',
				withListFilters: '<?', //need for contextual proofing wizard (if true show filters)
				eetCodesFilters: '<?', //need for contextual proofing wizard (filter model list by this tee codes)
				productCodeFilter: '<?', //need for contextual proofing wizard (filter model list by this product code)
				publicationChannelCodeFilter: '<?', //need for contextual proofing wizard (event fired when select model)
				onModelSourceSelected: '&?' //need for contextual proofing wizard (event fired when select model)
			}
		});

	/** @ngInject */
	function ListModelsController(editMetaDataModalService, confirmModalService, modelService, $state, blockUI, $uibModal, entityTemplateResource, ModalAlertService, $filter, EditorialEntityService, $sce, createEntityModalService) {
		var ctrl = this;

		ctrl.refreshDate = function () {
			ctrl.dateTest = new Date();
		};

		// INIT
		ctrl.$onInit = function () {

			ctrl.searchMap = {};
			ctrl.searchMap['author'] = null;
			ctrl.searchMap['type'] = null;
			ctrl.searchMap['startCreationDate'] = null;
			ctrl.searchMap['endCreationDate'] = null;

			ctrl.creationDateFilter = {};

			ctrl.pagination = {
				itemByPage: 50,
				totalCount: 0,
				currentPage: 1
			};

			ctrl.sortString;

			ctrl.editNameModel = false;
			ctrl.modelToEditName;

			ctrl.visibilityMap = [];
			getAllModelVisibility();

			ctrl.preview = {
				opened: false
			};
		};

		function getAllModelVisibility() {
			modelService.allModelVisibility().$promise.then(
				function (data) {
					ctrl.mapVisibilities = data;
					angular.forEach(angular.fromJson(angular.toJson(ctrl.mapVisibilities)), function (value, key) {
						ctrl.visibilityMap.push({
							name: key,
							value: value
						});
					});
				}
			);
		}

		ctrl.getModelPreview = function (modelDTO) {
			ctrl.modelSelected = modelDTO;
			ctrl.preview = {
				opened: true,
				flashId: ctrl.modelSelected.flashId,
				entityType: ctrl.modelSelected.entityType
			};
		};

		ctrl.openCreateEEModal = function (codeTEE, modelFlashId) {
			createEntityModalService.openModal(codeTEE, ctrl.currentUser, modelFlashId, undefined);
		};

		ctrl.create = function (modelFlashId) {
			modelService.getModel({
				modelFlashId: modelFlashId
			}).$promise
				.then(function (data) {
					ctrl.modelSelected = data;
					ctrl.modelFlashId = ctrl.modelSelected.flashId;
					ctrl.codeTEE = ctrl.modelSelected.codeTEE;

					if (!ctrl.modelSelected.editorialEntityTemplate.formular) {
						ctrl.openCreateEEModal(ctrl.codeTEE, ctrl.modelFlashId);
					} else {
						var editorialEntity = {
							editorialEntityTemplate: ctrl.modelSelected.editorialEntityTemplate,
							modelFlashId: ctrl.modelFlashId,
							ownerGroup: ctrl.modelSelected.system.systemOwnerGroup,
							system: {
								systemAuthors: [{
									login: ctrl.currentUser.login,
									fullName: ctrl.currentUser.fullName
								}]
							}
						};
						blockUI.start();
						EditorialEntityService.save(editorialEntity).$promise.then(function (data) {
							return data;
						}).then(function (ee) {
							editMetaDataModalService.openEditEntityMetaModal(ee.identifier, ee.editorialEntityTemplate.code);
							blockUI.stop();
						});
					}
				});

		};

		ctrl.selectModelSource = function (model) {

			if (ctrl.onModelSourceSelected) {
				ctrl.onModelSourceSelected({ selectedModel: model, launchNextStep: true, accessedSelectModelSourceStep: true });
			}
		};

		ctrl.changeVisibilityModel = function (modelDTOAfter, modelDTOBefore) {
			ctrl.modelOld = modelDTOBefore;
			ctrl.modelNew = modelDTOAfter;
			ctrl.deletePopup = false;
			ctrl.modelSaved = false;

			confirmModalService.openMessageModal("userApp.model.msg.changeConf", {
				name: ctrl.modelNew.name,
				visibility: ctrl.modelNew.modelVisibility
			}).then(function (result) {
				if (result) {
					blockUI.start();
					if (ctrl.modelNew.modelVisibility !== "SHARED") {
						ctrl.modelNew.defaultModel = false;
					}
					modelService.saveModel(ctrl.modelNew).$promise
						.then(function () {
							ctrl.modelSaved = true;
							blockUI.stop();
						});
				} else {
					if (ctrl.models.indexOf(modelDTOAfter) > -1) {
						var modelObj = $filter("filter")(ctrl.models, { flashId: modelDTOAfter.flashId })[0];
						modelObj.modelVisibility = modelDTOBefore;
					}
				}
			});
		};

		ctrl.toggle = function (modelDTO) {
			ctrl.editNameModel = ctrl.models.indexOf(modelDTO) > -1;
			ctrl.modelToEditName = angular.copy(modelDTO);
		};

		ctrl.saveNameModel = function (modelDTO) {
			modelService.saveModel(modelDTO, function (data) {
				ctrl.modelDTOSaved = data;
				ctrl.editNameModel = false;
				ctrl.modelToEditName = {};
			});
		};

		ctrl.cancelNameModel = function (modelDTO) {
			ctrl.editNameModel = false;
			ctrl.modelToEditName = {};
		};

		ctrl.delete = function (model) {
			ctrl.deletedModel = false;
			ctrl.modelSaved = false;
			var modalText = "userApp.model.msg.deleteConf";
			var modalTextParam = { name: model.name };
			var modalTitle = "userApp.model.confirmModal.title";
			confirmModalService.openModal(modalText, modalTitle, modalTextParam)
				.then(function (result) {
					if (result) {
						deleteRow(model);
					}
				});

			function deleteRow(model) {
				blockUI.start();
				modelService.deleteModel({
					modelFlashId: model.flashId
				}).$promise.then(function () {
					ctrl.modelSaved = true;
					ctrl.deletedModel = true;
					ctrl.loadAllModels();
					blockUI.stop();
				}).catch(
					function (e) {
						blockUI.stop();
					});
			}
		};

		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'creationDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllModels();
		};

		ctrl.queryAndloadAllModels = function () {
			/* Forces to go back to the first page when applying a filter for the first time */
			ctrl.pagination.currentPage = 1;
			ctrl.loadAllModels();
		};

		ctrl.loadAllModels = function () {
			ctrl.isLoading = true;
			blockUI.start();

			ctrl.searchMap['startCreationDate'] = ctrl.creationDateFilter.startDate || null;
			ctrl.searchMap['endCreationDate'] = ctrl.creationDateFilter.endDate || null;
			ctrl.sortString = ctrl.sortString ? ctrl.sortString : 'creationDate,asc';
			modelService.query({
				mapFilters: ctrl.searchMap,
				eetCodesFilters: ctrl.eetCodesFilters,
				productCodeFilter: ctrl.productCodeFilter,
				publicationChannelCodeFilter: ctrl.publicationChannelCodeFilter,
				page: Math.max(ctrl.pagination.currentPage - 1, 0),
				size: ctrl.pagination.itemByPage,
				sort: ctrl.sortString
			}).$promise
				.then(function (data) {
					var rowCollection = data ? (data.modelDTOList ? data.modelDTOList : []) : [];

					ctrl.models = [].concat(rowCollection);

					ctrl.pagination.totalCount = data.totalElements;
					ctrl.authorFilterList = data.modelFiltersDTO.authorFilterList;
					ctrl.typeFilterList = data.modelFiltersDTO.typeFilterList;

					ctrl.isLoading = false;
					blockUI.stop();
					if (ctrl.deletedModel) {
						ctrl.deletedModel = false;
					}
				})
				.catch(function (e) {
					ctrl.isLoading = false;
					blockUI.stop();
				});
		};

		//update default model option
		ctrl.setDefaultModel = function (model) {
			ctrl.modelSaved = false;
			var msg = model.defaultModel ? "userApp.model.msg.setDefaultModel" : "userApp.model.msg.unSetDefaultModel";
			confirmModalService.openMessageModal(msg, {
				name: model.name,
				default: model.defaultModel
			}).then(function (result) {
				if (result) {
					blockUI.start();
					modelService.saveModel(model).$promise
						.then(function () {
							ctrl.modelSaved = true;
							blockUI.stop();
						});
				} else {
					if (ctrl.models.indexOf(model) > -1) {
						var modelObj = $filter("filter")(ctrl.models, { flashId: model.flashId })[0];
						modelObj.defaultModel = !model.defaultModel;
					}
				}
			});
		};


	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('myModelsComponent', {
			templateUrl: 'scripts/pre-upgrade/components/model/list-models/my-models.component.html',
			controller: MyModelsController,
			bindings: {
				currentUser: '<'
			}
		});

    /** @ngInject */
	function MyModelsController() {

		var ctrl = this;

        // INIT
		ctrl.$onInit = function () {
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('navbarCreateEntity', {
			templateUrl: 'scripts/pre-upgrade/components/navbar/navbar-create-entity/navbar-create-entity.html',
			controller: NavbarCreateEntityController,
			bindings: {
				currentUser: '<'
			},
		});

	/** @ngInject */
	function NavbarCreateEntityController($scope, entityTemplateResource, blockUI, $uibModal, $log, $rootScope, $state, $transitions, modelService, createEntityModalService, editMetaDataModalService, EditorialEntityService, userResource, $timeout, userPreferenceService) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.elligibleStates = ['productDashboard', 'editorialEntity', 'searchInterfacesTemplate'];
			init();

			searchInstantiablesEETList();

			ctrl.setContextualizationOff = $rootScope.$on('setContextualizationOff', function () {
				ctrl.instantiablesEETList = ctrl.initialList;
				ctrl.ownerGroup = '';
			});
		};

		ctrl.$onDestroy = function () {
			if (ctrl.setContextualizationOff) {
				ctrl.setContextualizationOff();
			}
		};

		//checks if the current TIR is Contextualized
		function isContextualTir() {
			return angular.isDefined(userPreferenceService.getUserGlobalPreference('OwnerGroup'));
		}

		function initCurrentUser() {
			userResource.getCurrentUser().$promise.then(function (currentUser) {
				ctrl.currentUser = currentUser;
			});
		}

		function checkList() {
			ctrl.ownerGroup = isContextualTir() ? userPreferenceService.getUserGlobalPreference('OwnerGroup') : '';

			ctrl.instantiablesEETList = [];

			// force refresh of the scrollbar
			ctrl.hide = true;

			$timeout(function () {
				if (isContextualTir()) {
					filterResult();
				}
				else {
					ctrl.instantiablesEETList = ctrl.initialList;
				}
				ctrl.hide = false;
			});
		}

		$transitions.onSuccess({}, function (transition) {
			// let time for init to set the ownergroup ...
			$timeout(function () {
				checkList();
			}, 200);
		});

		// reset list to all when transition start
		$transitions.onStart({}, function (transition) {
			ctrl.instantiablesEETList = ctrl.initialList;
			ctrl.isAllShown = true;
		});

		ctrl.openCreateEEModal = function (entityTemplate) {
			var ownerGroup;

			if (!entityTemplate.formular) {
				if (ctrl.elligibleStates.indexOf($state.current.name) !== -1) {
					ownerGroup = ctrl.ownerGroup;
				}
				createEntityModalService.openModal(entityTemplate.code, ctrl.currentUser, undefined, ownerGroup);
			} else {
				var editorialEntity = {
					editorialEntityTemplate: entityTemplate,
					saveWithDraftStep: entityTemplate.formular,
					metaInstanceList: [],
					modelFlashId: "NOMODEL",
					system: {
						systemAuthors: [{
							login: ctrl.currentUser.login,
							fullName: ctrl.currentUser.fullName
						}]
					}
				};

				if (_.indexOf(entityTemplate.groups, ownerGroup) >= 0) {
					editorialEntity.ownerGroup = ownerGroup;
				}
				blockUI.start();
				EditorialEntityService.save(editorialEntity).$promise.then(function (ee) {
					blockUI.stop();
					return editMetaDataModalService.openEditEntityMetaModal(ee.identifier, ee.editorialEntityTemplate.code);
				});
			}
		};

		// DIPLAY THE ENTIRE LIST OF EE
		ctrl.showALl = function () {
			ctrl.instantiablesEETList = ctrl.allEE;
			ctrl.isAllShown = true;
		};

		function searchInstantiablesEETList() {
			ctrl.isLoading = true;

			entityTemplateResource.getInstantiablesEET().$promise
				.then(function (data) {
					if (!_.isEmpty(data)) {
						ctrl.instantiablesEETList = data;
						ctrl.initialList = data;
						ctrl.allEE = data;

						checkList();
					}
				}).finally(function () {
					ctrl.isLoading = false;
				});
		}

		function init() {
			ctrl.limit = undefined;
			ctrl.isAllShown = true;
			initCurrentUser();
		}


		function filterResult() {
			ctrl.instantiablesEETList = _.filter(ctrl.allEE, function (o) {
				return o.groups.indexOf(ctrl.ownerGroup) !== -1;
			});
			if (_.isEmpty(ctrl.instantiablesEETList)) {
				ctrl.instantiablesEETList = ctrl.allEE;
				ctrl.isAllShown = true;
			}
			else {
				ctrl.allEE = _.sortBy(ctrl.allEE, function (o) {
					return o.groups.indexOf(ctrl.ownerGroup) === -1;
				});
				ctrl.isAllShown = false;
			}
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('myTrashMainComponent', {
			templateUrl: 'scripts/pre-upgrade/components/my-trash/my-trash-main/my-trash-main.component.html',
			controller: MyTrashMainController,
			bindings: {
				tableId: '<?',
				currentUser: '<',
				displayMode: '<?',
				onRowSelected: '&?',
				getAdapter: '&?',
				userGroup: '<?',
				hidePagination: '<?',
				pageSize: '<?'
			},
		});

	/** @ngInject */
	function MyTrashMainController($sce, $state, trashService, blockUI, $timeout) {
		var ctrl = this;


		ctrl.$onInit = function () {
			//ENTITIES TO SHOW
			ctrl.entities = [];

			if (!ctrl.tableId) {
				ctrl.tableId = 'myTrashTable';
			}
			ctrl.creationDateFilter = null;
			ctrl.suppressionDateFilter = null;
			//SEARCH CRITERIAS
			if (!ctrl.filterSearchParam) {
				ctrl.filterSearchParam = {};
				ctrl.filterSearchParam.eetCode = null;
				ctrl.filterSearchParam.sort = null;
				ctrl.filterSearchParam.fieldSort = null;
				ctrl.filterSearchParam.systemCreationDate = null;
				ctrl.filterSearchParam.systemLastUpdateDate = null;
			}

			ctrl.allFilters = {};
			trashService.getAllFilters().then(function (data) {
				ctrl.allFilters = data.filters;
			});

			//PAGINATION
			if (!ctrl.pagination) {
				ctrl.initPagination(50);
				if (ctrl.displayMode === 'LIGHT') {
					ctrl.pagination.itemByPage = 10;
				}
			}
			if (ctrl.getAdapter) {
				ctrl.getAdapter({
					adapter: {
						reload: function () {
							$timeout(function () {
								ctrl.loadAllee();
							});
						},
						clearSelection: function () {
							ctrl.selectedEE = null;
						},
						pagination: ctrl.pagination
					}
				});
			}

		};
		ctrl.$onChanges = function (changesObj) {
			if (changesObj.pageSize) {
				ctrl.initPagination(changesObj.pageSize.currentValue);
			}
		};
		ctrl.$onDestroy = function () { };

		ctrl.initPagination = function (size) {
			ctrl.pagination = {
				itemByPage: size,
				totalCount: 0,
				currentPage: 1
			};
		};

		var trusted = {};
		ctrl.trustAsHtml = function (string) {
			return trusted[string] || (trusted[string] = $sce.trustAsHtml(string));
		};

		ctrl.navigateToEE = function (idEE) {
			$state.go('editorialEntity', {
				id: idEE
			});
		};

		ctrl.rowSelected = function (ee) {
			ctrl.selectedEE = ee.identifier;

			if (ctrl.onRowSelected) {
				ctrl.onRowSelected({ row: ee });
			}
		};

		ctrl.isEESelected = function (idEE) {
			return idEE === ctrl.selectedEE;
		};
		ctrl.loadTable = function (tableState) {
			//Sort option
			if (angular.isDefined(tableState)) {
				var reverse = angular.isUndefined(tableState.sort.reverse) || Boolean(tableState.sort.reverse);
				ctrl.filterSearchParam.fieldSort = tableState.sort.predicate || 'systemLastUpdateDate';
				ctrl.filterSearchParam.sort = reverse ? 'DESC' : 'ASC';
			}
			ctrl.loadAllee();
		};

		ctrl.loadAllee = function () {
			blockUI.start();
			ctrl.filterSearchParam.currentPage = Math.max(ctrl.pagination.currentPage - 1, 0);
			ctrl.filterSearchParam.itemByPage = ctrl.pagination.itemByPage;
			ctrl.filterSearchParam.systemCreationDate = ctrl.creationDateFilter;
			ctrl.filterSearchParam.systemLastUpdateDate = ctrl.suppressionDateFilter;
			trashService.getAll(
				ctrl.filterSearchParam
			).then(function (data) {
				ctrl.events = data;
				ctrl.rowCollection = data ? (data.results ? data.results : []) : [];
				ctrl.entities = []
					.concat(ctrl.rowCollection);

				ctrl.pagination.totalCount = data.totalElements;
				ctrl.isLoading = false;

				blockUI.stop();
			}).catch(function (e) {
				blockUI.stop();
			});
		};
	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('navbarAccount', {
			templateUrl: 'scripts/pre-upgrade/components/navbar/navbar-account/navbar-account.html',
			controller: NavbarAccountController,
			bindings: {
			},
		});

	/** @ngInject */
	function NavbarAccountController(confirmModalService, Auth, $uibModal, $state, $sessionStorage, Principal, configurationLocalUserService, userModalService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			Principal.identity().then(function (account) {
				ctrl.account = account;
			});
		};

		ctrl.logout = function () {
			Auth.logout();
			$state.go('login');
			$sessionStorage.$reset();
		};


		ctrl.reset = function () {
			confirmModalService.openMessageModal("global.menu.configuration.question")
				// eslint-disable-next-line indent
				.then(function (ok) {
					if (ok) {
						configurationLocalUserService.reinitialiser();
					}
				});


		};
		ctrl.openConfirmLogout = function () {
			confirmModalService.openMessageModal("global.menu.modalLogout.question")
				.then(function (ok) {
					if (ok) {
						ctrl.logout();
					}
				});

		};

		ctrl.openUserDetails = function () {
			userModalService.openModal();
		};

	}

})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('navbarLeft', {
			templateUrl: 'scripts/pre-upgrade/components/navbar/navbar-left/navbar-left.component.html',
			controller: navbarLeftController,
			bindings: {
				currentUser: "="
			},
		});

	/** @ngInject */
	function navbarLeftController($rootScope, menuService, $transitions, $state, $timeout, productDashboardService, productSearchService, userGroupResource, userPreferenceService, $location) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.initMenu();
			// disable contextualization if there is the event setContextualizationOff
			ctrl.setContextualizationOff = $rootScope.$on('setContextualizationOff', function () {
				ctrl.disableContextualization();
			});
		};

		ctrl.$onDestroy = function () {
			if (ctrl.setContextualizationOff) {
				ctrl.setContextualizationOff();
			}
		};


		ctrl.disableContextualization = function () {
			// remove OwnerGroup from local storage
			userPreferenceService.removeFromUserGlobalPreference('OwnerGroup');
			// refresh menu
			ctrl.initMenu();
			// remove owner group name from header
			$rootScope.$broadcast('setOwnerGroupName', '');
			// go to home if in contextualization mode
			if (location.hash.indexOf('searchInterfacesTemplate') !== -1 && location.href.indexOf('productCode') !== -1 || location.hash.indexOf('productdashboard') !== -1) {
				$location.path("/login");
			}
		};
		ctrl.purgeContextualization = function () {
			$rootScope.$broadcast('setContextualizationOff', '');
		};
		ctrl.initMenu = function () {
			ctrl.currentOwnerGroup = {};
			ctrl.ownerGroup = '';
			ctrl.ownerGroupData = '';
			ctrl.virtualCE = {
				virtual: true,
				groups: []
			};

			menuService.getMenu().then(function (data) {
				if (data) {
					data.splice(1, 0, ctrl.virtualCE);
				}
				ctrl.listeMenuAdmin = data;
			});

			$timeout(ctrl.addVirtualCE, 400);
		};

		ctrl.refreshMenu = $rootScope.$on('refreshMenu', function (event, data) {
			ctrl.initMenu();
		});

		$transitions.onSuccess({}, function (transition) {
			$timeout(ctrl.addVirtualCE, 400);
		});


		function setVirtualCE(virtualCE, currentOwnerGroup) {
			//send owner group name to header
			$rootScope.$broadcast('setOwnerGroupName', ctrl.ownerGroupData ? ctrl.ownerGroupData.name : '');
			virtualCE.groups = [{
				isOpen: true,
				childs: _.map(currentOwnerGroup.searchs, function (s) {
					return {
						uiSref: 'searchInterfacesTemplate',
						identifier: s.idSit,
						savedSearchId: s.savedSearchId,
						translate: s.name,
						productCode: s.code,
						contextualized: s.contextualized,
						proposalsProduct: s.proposalsProduct
					};
				}),
				group: {
					uiSref: '',
					translate: currentOwnerGroup.name,
					productCode: currentOwnerGroup.code
				}
			}];
		}

		ctrl.addVirtualCE = function () {
			//ctrl.virtualCE.groups = [];
			ctrl.ownerGroup = userPreferenceService.getUserGlobalPreference('OwnerGroup');
			if (ctrl.ownerGroup) {
				// refresh only if the current owner group changed
				// maybe create one service to get the name and the search ids ?
				if (!ctrl.currentOwnerGroup || ctrl.currentOwnerGroup.code !== ctrl.ownerGroup) {
					// check if current user has the group
					userGroupResource.groupsByUser().$promise.then(function (userGroups) {
						var result = _.find(userGroups, { 'code': ctrl.ownerGroup });

						if (result) {
							productDashboardService.getGroup(ctrl.ownerGroup).then(function (ownerGroupData) {
								ctrl.ownerGroupData = ownerGroupData;
								ctrl.currentOwnerGroup = {
									code: ctrl.ownerGroup,
									name: ownerGroupData.name
								};

								productSearchService.findByCode({ code: ctrl.currentOwnerGroup.code }).then(function (data) {
									ctrl.currentOwnerGroup.searchs = data;
									setVirtualCE(ctrl.virtualCE, ctrl.currentOwnerGroup);
								});
							});
						}
					});
				}
				else {
					setVirtualCE(ctrl.virtualCE, ctrl.currentOwnerGroup);
				}


			}
		};

		ctrl.toggleMenu = function (item) {
			item.isOpen = !item.isOpen;
			menuService.saveMenu(item.group.translate, item.isOpen);
		};

		ctrl.lockMenu = function () {
			$rootScope.lockMenu();
		};

		ctrl.hoverNavLeft = function () {
			$rootScope.hoverNavLeft();
		};

		ctrl.outNavLeft = function () {
			$rootScope.outNavLeft();
		};

		ctrl.goToDashBoard = function (productCode) {
			$state.go('productDashboard', {
				"code": productCode
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('userModal', {
			templateUrl: 'scripts/pre-upgrade/components/navbar/user-modal/user-modal.html',
			controller: UserModalController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function UserModalController(userResource, ModalAlertService, $filter) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.currentUser = ctrl.resolve.currentUser;
		};

		ctrl.save = function () {
			userResource.saveUserInfo({ signature: ctrl.currentUser.signature }).$promise
				.then(function (data) {
					if (data.saved) {
						ModalAlertService.success('', $filter('translate')('userApp.user.msg.PROFILE_SAVED'));
					}
					else {
						ModalAlertService.error('', $filter('translate')('userApp.user.msg.ERROR_TECH'));
					}
				});
			ctrl.close();
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('userModalService', UserModalService);


	/** @ngInject */
	function UserModalService(blockUI, $uibModal) {
		var service = {
			openModal: openModal
		};

		return service;

		function openModal() {
			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'userModal',
				resolve: {
					currentUser: function (userResource) {
						return userResource.getCurrentUser().$promise;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('user');
						return $translate.refresh();
					}]
				},
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;

		}

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrContainer', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-container/search-container.component.html',
			controller: SearchSolrContainerController,
			bindings: {
				editTirInModal: "=",
				pagination: "=",
				currentUser: "=",
				searchSolr: "=",
				resultat: "=",
				hideMassOperationContainer: "<",
				//todo rename variables selectedEE and eeSelected to prevent confusion
				selectedEE: "=?", //checked ee
				eeSelected: "=", //clicked ee
				onSelectRowChange: "&?", //event fired when check or uncheck ee from list
				onSelectAllChange: "&?", //event fired when check or uncheck all ee
				getData: "&",
				eeTargetChosen: "&?",
				tirId: "<",
				multiSelect: "<",
				productCode: "<?"
			},
		});

	/** @ngInject */
	function SearchSolrContainerController(entityLinkingResource, $log, $filter, $state, editWorkflowModalService, EditorialEntityService, archiveEntityModalService, blockUI, EDITORIAL_ELEMENT_TYPE, LinkEeWizardModalService, ModalAlertService, SearchSolrService, entityTemplateResource, htmlPreviewService, HTML_PREVIEW_TYPE, entityUnlockService, productGroupManyEEService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.facetVisibility = true;
			ctrl.actionList = [{
				name: 'userApp.searchInterfaceTemplate.menuAction.WORKFLOW',
				value: 'WORKFLOW'
			},
			{
				name: 'userApp.searchInterfaceTemplate.menuAction.LINK',
				value: 'LINK'
			},
			{
				name: 'userApp.searchInterfaceTemplate.menuAction.PRODUCT_GROUP',
				value: 'PRODUCT_GROUP'
			},
			{
				name: 'userApp.searchInterfaceTemplate.menuAction.ARCHIVE',
				value: 'ARCHIVE'
			},
			{
				name: 'userApp.searchInterfaceTemplate.menuAction.unlock',
				value: 'UNLOCK'
			}


			];

			ctrl.showByList = [{
				name: 'LIST',
				value: false
			}, {
				name: 'PLAN',
				value: true
			}];


			ctrl.finalStatusList = [{
				name: 'userApp.searchInterfaceTemplate.home.finalStatus',
				value: 'FINAL'
			}];

			ctrl.statusList = [{
				name: 'userApp.searchInterfaceTemplate.home.AllStatus',
				value: null
			}, {
				name: 'userApp.searchInterfaceTemplate.home.initialStatus',
				value: 'INITIAL'
			}, {
				name: 'userApp.searchInterfaceTemplate.home.noFinalStatus',
				value: 'NON FINAL'
			}, {
				name: 'userApp.searchInterfaceTemplate.home.finalStatus',
				value: 'FINAL'
			}];

			ctrl.eeSel = {
				id: ""
			};
		};

		ctrl.facetVisibilityChanged = function (visibility) {
			ctrl.facetVisibility = visibility;
		};

		ctrl.getSelectedEE = function () {
			var selectedEE = _.keys(_.pickBy(ctrl.selectedEE), true);

			return selectedEE;
		};

		ctrl.clearSelection = function () {
			ctrl.selectedEE = [];
		};

		ctrl.applyAction = function (action) {
			var selectedEE = ctrl.getSelectedEE();
			ctrl.editorialEntitiesList = angular.toJson(selectedEE);
			if (selectedEE && selectedEE.length > 0) {
				switch (action) {
					case 'WORKFLOW':
						//EDIT WORKFLOW
						editWorkflowModalService.openMultiEdit(selectedEE, ctrl.currentUser);
						break;
					case 'ARCHIVE':
						//Archive selected editorial entities
						archiveEEModal(ctrl.editorialEntitiesList);
						break;
					case 'PRODUCT_GROUP':
						//update product group of selected editorial entities
						productGroupEEModal(selectedEE);
						break;
					case 'LINK':
						//hook selected editorial entities
						if (ctrl.editorialEntitiesList.length > 0) {
							linkEes(selectedEE);
						}
						break;
					case 'UNLOCK':
						//unlock selected editorial entities
						unlockEEModal(selectedEE);
						break;

				}
			}
		};



		ctrl.changeView = function () {
			ctrl.getData();
		};

		ctrl.changeFacet = function () {
			ctrl.pagination.currentPage = 1;
			ctrl.getData();
		};

		/**
		 * check whether the list of facet is empty.
		 */
		ctrl.isFacetNotEmpty = function (f) {
			return !_.isNull(f.values) && !_.isEmpty(f.values);
		};

		ctrl.showFacet = function () {
			if (ctrl.searchSolr) {
				var listFacet = ctrl.searchSolr.listFacet;

				if (angular.isDefined(listFacet) && listFacet.length > 0 &&
					_.some(listFacet, ctrl.isFacetNotEmpty)) {
					return true;
				}
			}
			return false;
		};

		function archiveEEModal(eeTargetFlashIdList) {
			archiveEntityModalService.openModalMulti(eeTargetFlashIdList);
		}

		function unlockEEModal(eeTargetFlashIdList) {
			entityUnlockService.confirmUnlock(eeTargetFlashIdList);
		}


		function productGroupEEModal(eeFlashIds) {
			productGroupManyEEService.openModal(eeFlashIds);
		}

		function linkEes(eeFlashIds) {
			blockUI.start();
			entityLinkingResource.verifyLinkConditions({
				eeFlashIds: eeFlashIds
			}).$promise.then(function (response) {
				blockUI.stop();
				if (response.editContentEnabled && response.existCommonTargetsTR) {
					//Launch link ee wizard
					var entities = [];
					angular.forEach(response.targetEntities, function (targetEe) {
						entities.push({
							flashId: targetEe.identifier,
							eetCode: targetEe.editorialEntityTemplate.code,
							metaInstanceList: targetEe.metaInstanceList,
							system: targetEe.system
						});
					});
					LinkEeWizardModalService.openModal(entities, ctrl.currentUser);
				} else if (!response.editContentEnabled) {
					//Display error msg.
					ModalAlertService.error('error', $filter('translate')('userApp.searchInterfaceTemplate.home.unauthorizedEditContent'), '');
				} else if (!response.existCommonTargetsTR) {
					//Diplay error msg.
					ModalAlertService.error('error', $filter('translate')('userApp.searchInterfaceTemplate.home.noCommonTr'), '');
				}
			}, function () {
				blockUI.stop();
			});
		}

		ctrl.navigateToEE = function (id) {
			if (ctrl.editTirInModal && ctrl.eeSel.id) {
				if (ctrl.currentStep !== ctrl.steps.length) {
					ctrl.gotoStep(ctrl.currentStep + 1);
				} else {
					ctrl.confirm();
				}
			}
			if (id && !ctrl.editTirInModal) {
				$state.go('editorialEntity', {
					id: id
				});
			}
		};

		ctrl.setTargetPreview = function (idEE) {
			var previewUI = blockUI.instances.get('previewUI');
			previewUI.start();

			htmlPreviewService.getPreview(idEE, HTML_PREVIEW_TYPE.complete, false, EDITORIAL_ELEMENT_TYPE.entity, ctrl.productCode)
				.then(function (eePreviewHtml) {
					ctrl.eeTarget.completeHtmlPreview = eePreviewHtml.htmlPreview;
					ctrl.eeTarget.type = eePreviewHtml.type;
					previewUI.stop();
				});
		};

		ctrl.getEESelected = function (idEE, editEnabled, isLocked, entityTemplateCode) {
			if (ctrl.editTirInModal && idEE !== ctrl.eeSel.id) {
				getEETarget(idEE).then(function () {
					ctrl.setTargetPreview(idEE);
				});
			} else if (!ctrl.editTirInModal) {

				ctrl.eeSelected = idEE;
				ctrl.editEnabled = editEnabled;
				ctrl.isLocked = isLocked;
				ctrl.listEE = [];
				ctrl.eeTarget = {
					completeHtmlPreview: '',
					type: ''
				};

				ctrl.setTargetPreview(idEE);
			}
		};



		ctrl.closePreviewEE = function () {
			ctrl.eeSelected = '';
			ctrl.eeSel.id = '';
			ctrl.eeTarget = null;
		};

		function getEETarget(idEE) {
			ctrl.listEE = [];
			ctrl.eeSel.id = idEE;
			ctrl.eeSelected = idEE;
			blockUI.start();
			return EditorialEntityService.getEEById({
				id: idEE
			}, function (data) {
				ctrl.eeTarget = data;
				blockUI.stop();
			}, function () {
				blockUI.stop();
			}).$promise;
		}

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrEePreview', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-ee-preview/search-ee-preview.component.html',
			controller: searchSolrEePreviewController,
			bindings: {
				eeSelected: "=",
				eeTarget: "=",
				closePreviewEe: "&",
				searchTerms: "<?",
				openOnNewTab: '<?',
				hlEnabled: '<?',
				productCode: "<?"
			},
		});

	/** @ngInject */
	function searchSolrEePreviewController($sce, EDITORIAL_ELEMENT_TYPE, blockUI, editMetaDataModalService, htmlPreviewService, $state) {
		var ctrl = this;

		ctrl.$onInit = function () { };

		ctrl.trustAsHtml = function (string) {
			return (angular.isDefined(string) && string !== '') ? $sce.trustAsHtml(string) : '';
		};

		ctrl.reloadPreview = function (flashId, typePreview, productCode) {
			var previewUI = blockUI.instances.get('previewUI');
			previewUI.start();
			htmlPreviewService.reloadEntityPreview(flashId, typePreview, productCode)
				.then(function (result) {
					if (result) {
						ctrl.newHtmlPreview = result;
						if (ctrl.eeTarget) {
							ctrl.eeTarget.completeHtmlPreview = "";
							ctrl.eeTarget.completeHtmlPreview = ctrl.newHtmlPreview.htmlPreview;
							previewUI.stop();
						}
					}
				});
		};

		ctrl.openEditMetaModal = function (flashId) {
			var modalClass;
			if (ctrl.eeTarget.editorialEntityTemplate && !ctrl.eeTarget.editorialEntityTemplate.formular) {
				modalClass = 'no-editor';
			}

			editMetaDataModalService.openEditEntityMetaModal(flashId, undefined, undefined, undefined, modalClass).then(function (selectedItem) {
				ctrl.reloadPreview(flashId, 'COMPLETE', ctrl.productCode);
			});
		};

		ctrl.startEdition = function (flashId) {
			if (ctrl.eeTarget.type === 'TREE') {
				$state.go("treeEEEdition", {
					id: flashId,
					editionMode: 'STRUCTURE'
				});
			} else {
				$state.go("editorialEntityEdit", {
					id: flashId
				});
			}

		};

		ctrl.closePreviewEE = function () {
			ctrl.eeSelected = '';
			//ctrl.eeSel.id = null;
			ctrl.eeTarget = null;
		};


	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrFacet', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-facet/search-facet.component.html',
			controller: SearchSolrFacetController,
			bindings: {
				listFacet: "=",
				changeFacet: '&?',
				tirId: "<",
				onFacetVisibilityChanged: "&?"
			},
		});

	/** @ngInject */
	function SearchSolrFacetController(FACETCONFIG, userPreferenceService, configurationLocalUserService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.facetVisibility = true;
			ctrl.facetShowLimit = FACETCONFIG.showLimit;
			ctrl.facetShowAllMap = [];
			ctrl.facetMap = {};
			ctrl.facetCollapseMap = userPreferenceService.getUserFacetPreference(ctrl.tirId);
		};

		ctrl.toggleFacetVisibility = function () {
			ctrl.facetVisibility = !ctrl.facetVisibility;
			if (ctrl.onFacetVisibilityChanged) {
				ctrl.onFacetVisibilityChanged({
					'visibility': ctrl.facetVisibility
				});
			}
		};

		var toggleAllElement = function (facetValue) {
			_.each(facetValue.children, function (child) {
				child.enabled = facetValue.enabled;
				if (child.children.length > 0) {
					toggleAllElement(child);
				}
			});
		};

		ctrl.clearAll = function () {
			_.forEach(ctrl.listFacet, function (facet) {
				_.forEach(facet.values, function (fValue) {
					fValue.enabled = false;
					toggleAllElement(fValue);
				});
			});

			ctrl.onChangeFacet();
		};

		ctrl.toggleFacet = function (facetCode) {
			ctrl.facetCollapseMap[facetCode] = !ctrl.facetCollapseMap[facetCode];
		};

		ctrl.toggle = function (facetCode, value) {
			var collapsed = ctrl.facetMap[facetCode][value];
			ctrl.facetMap[facetCode][value] = !collapsed;
		};

		function checkChildValues(child) {
			if (!_.isEmpty(child)) {
				return _.some(child, function (c) {
					return c.enabled || checkChildValues(c.children);
				});
			}
			return false;
		}

		ctrl.facetSelected = function (facet) {
			if (facet && facet.values) {
				return _.some(facet.values, function (v) {
					return v.enabled || checkChildValues(v.children);
				});
			}
			return false;
		};

		ctrl.toggleAll = function (facetValue) {
			toggleAllElement(facetValue);
			ctrl.onChangeFacet();
			ctrl.toggleFacet(facetValue);
		};

		ctrl.toggleChildren = function (facetValue, parent) {
			facetValue.enabled = false;
			if (parent) {
				parent.enabled = false;
			}
			ctrl.onChangeFacet();
		};

		ctrl.onChangeFacet = function () {
			if (ctrl.changeFacet) {
				ctrl.changeFacet();
			}
		};

		ctrl.isCollapsed = function (facetCode, value) {
			if (!ctrl.facetMap[facetCode]) {
				ctrl.facetMap[facetCode] = {};
			}
			return !ctrl.facetMap[facetCode][value];
		};

		/**
		 * check whether the list of facet is empty.
		 */
		ctrl.isFacetNotEmpty = function (f) {
			return !_.isNull(f.values) && !_.isEmpty(f.values);
		};

		/**
		 * get the length of facet list.
		 */
		ctrl.facetLength = function (facet) {
			return _.size(facet);
		};

		ctrl.trackByFacetCodeValue = function (code, value) {
			return code + '_' + value;
		};

		ctrl.getFacetId = function (facet) {
			return facet.identifier + facet.code;
		};

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrFilter', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-filter/search-filter.component.html',
			controller: searchSolrFilterController,
			bindings: {
				filters: "<",
				checkLengthFilter: "=",
				submitFilters: "&?",
				productCode: '<',
				isContextualizedSearch: '<?',
				searchTemplateId: '<?',
				mountingRt: "=?"
			},
		});

	/** @ngInject */
	function searchSolrFilterController($resource, $translate, $translatePartialLoader, productDashboardService, TirFilterSharedService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.dateOperatorOptions = [];
			ctrl.operatorOptions = [];

			ctrl.lang = $translate.use();
			if (ctrl.productCode) {
				productDashboardService.getGroup(ctrl.productCode).then(function (ownerGroupData) {
					ctrl.productLabel = ownerGroupData.shortName;
				});
			}

			//Retrieve stored values for filter on products
			ctrl.productFilterValues = TirFilterSharedService.getStoredProductFilterValues(ctrl.searchTemplateId);

			$resource('api/allMetaOperators').get().$promise.then(function (data) {
				angular.forEach(angular.fromJson(angular.toJson(data)), function (value, key) {
					ctrl.operatorOptions.push({
						name: key,
						value: value
					});
				});
			});


			$resource('api/allDateOperators').get().$promise.then(function (data) {
				angular.forEach(angular.fromJson(angular.toJson(data)), function (value, key) {
					ctrl.dateOperatorOptions.push({
						name: key,
						value: value
					});
				});
			});

			//Order by displayorder and filter type (TEE filters, extended filters then associated filters)
			var filterGroups = _.groupBy(ctrl.filters, 'type');
			var directFilters = _.sortBy(filterGroups.DirectFilter, 'displayOrder');
			var extendedFilters = _.sortBy(filterGroups.ExtendedFilter, 'displayOrder');
			var associatedFilters = _.sortBy(filterGroups.AssociatedFilter, 'displayOrder');
			ctrl.filters = [].concat(directFilters, extendedFilters, associatedFilters);
			// Refresh translations for filters
			$translatePartialLoader.addPart('editorialEntity');
			$translatePartialLoader.addPart('searchInterfaceTemplate');
			$translatePartialLoader.addPart('datepicker');
			$translatePartialLoader.addPart('daterangepicker');
			$translate.refresh();
		};

		/**
			* Add the given value to product filter values if it does not already exists
			* @param {String} selectedProductLabel 
			*/
		ctrl.onProductSelect = function (selectedProductLabel) {
			if(_.indexOf(ctrl.productFilterValues) === -1){
				ctrl.productFilterValues.push(selectedProductLabel);
				TirFilterSharedService.setProductFilterValues(ctrl.searchTemplateId, ctrl.productFilterValues);
			}
		};
		/**
			* Remove the given value from product filter values
			* @param {String} removedProductLabel 
			*/
		ctrl.onProductRemove = function (removedProductLabel) {
			_.remove(ctrl.productFilterValues, function (productLabel) { return productLabel === removedProductLabel; });
			TirFilterSharedService.setProductFilterValues(ctrl.searchTemplateId, ctrl.productFilterValues);
		};
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrFilterField', {
			template: '<div ng-include="$ctrl.templateUrl">',
			controller: searchSolrFilterFieldController,
			require: {
				form: '^form'
			},
			bindings: {
				filter: "<",
				lang: "=",
				dateOperatorOptions: "=",
				operatorOptions: "=",
				checkLengthFilter: "=",
				submitFilters: "&?",
				productCode: '<',
				productLabel: '<',
				isContextualizedSearch: '<?',
				productFilterValues: '<',
				mountingRt: "=?",
				onProductSelect: "&",
				onProductRemove: "&",
				searchTemplateId: '<?',
			},
		});

	/** @ngInject */
	function searchSolrFilterFieldController(TirFilterSharedService, $log, $uibModal, blockUI, metadataValidationService, metaDataReferentielService, metadataSystemService, $filter, $scope, $timeout) {
		var ctrl = this;

		ctrl.$onInit = function () {

			ctrl.currentPage = -1;
			ctrl.itemsPerPage = 50;
			ctrl.display = true;
			ctrl.listMetaDataSystemValues = [];
			if ((angular.isDefined(ctrl.filter.value) && ctrl.filter.value !== "") || (angular.isDefined(ctrl.filter.multiValuesList) && ctrl.filter.multiValuesList.length > 0)) {
				ctrl.loadMetaDataSystemValues(ctrl.filter);
			}

			//Default value is true for contains
			if (angular.isDefined(ctrl.filter.contains)) {
				ctrl.filter.contains = ctrl.filter.contains.toString();
			} else {
				ctrl.filter.contains = "true";
			}

			ctrl.type = ctrl.filter.metaDataDTO.metaDataType.toLowerCase();
			ctrl.templateUrl = 'scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-' + ctrl.type + ".html";

			ctrl.metaDataFieldPattern = new RegExp(metadataValidationService.validateMetDataNumeric(ctrl.filter.metaDataDTO));

			if (ctrl.type === 'numeric') {
				if (ctrl.filter.multiValuesList && ctrl.filter.multiValuesList.length > 0) {
					ctrl.filter.multiValuesList.forEach(function (item) {
						item ? item.text = _.toNumber(item.text) : item;
					});
				} else {
					ctrl.filter.value = ctrl.filter.value ? _.toNumber(ctrl.filter.value) : ctrl.filter.value;
				}

				if (ctrl.filter.defaultValue && !ctrl.filter.metaDataOperator) {
					ctrl.filter.metaDataOperator = "EQUAL";
				}

			}
			if (ctrl.type === 'boolean' && ctrl.filter.metaDataDTO.selectionFormat === "CHECKBOX" && angular.isUndefined(ctrl.filter.value)) {
				ctrl.filter.value = 'false';
			}



			if ((ctrl.type === 'list' || ctrl.type === 'repository') && !ctrl.filter.multiValuesList) {
				ctrl.filter.multiValuesList = [];
			}

			if (ctrl.type === 'date') {
				setDateModel();
			}
		};

		ctrl.$onChanges = function (changes) {
			//Default value is true for contains
			if (angular.isDefined(ctrl.filter.contains)) {
				ctrl.filter.contains = ctrl.filter.contains.toString();
			} else {
				ctrl.filter.contains = "true";
			}
			ctrl.type = ctrl.filter.metaDataDTO.metaDataType.toLowerCase();
			if (ctrl.type === 'date') {
				setDateModel();
			}
		};

		/**
			* Collect selected values if the we do a select on the filter represeneting entities products
			* Call an output to update selected product list
			* @param {object} item: selected item in system meta data values list 
			*/
		ctrl.onSelectSyetemMetaValueCallback = function (item) {
			if (ctrl.filter.metaDataDTO.code === 'systemOwnerGroup' || ctrl.filter.metaDataDTO.code === 'systemProducts') {
				ctrl.onProductSelect({ selectedProductLabel: item.text });
			}
		};

		/**
			* Update selected values if we remove a value from the filter represeneting entities products
			* Call an output to update selected product list
			* @param {object} item: removed item in system meta data values list 
			*/
		ctrl.onRemoveSyetemMetaValueCallback = function (item) {
			if (ctrl.filter.metaDataDTO.code === 'systemOwnerGroup' || ctrl.filter.metaDataDTO.code === 'systemProducts') {
				ctrl.onProductRemove({ removedProductLabel: item.text });
			}
		};

		/**
			* Initialise items attribute on select object if items attribute is undefined 
			* Workaround to fix SIETRAINPR-1800 : angular-ui-select evaluates length on items without checking if items is undefined
			* @param {*} select 
			*/
		ctrl.fixItemsValue = function (select) {
			if (!select.items) {
				select.items = [];
			}
		};

		ctrl.checkInputKey = function (event) {
			// check enter
			if (event && event.keyCode === 13) {
				ctrl.onSubmitFilter();
			}
		};

		ctrl.onSubmitFilter = function () {
			if (ctrl.submitFilters) {
				ctrl.submitFilters({
					filter: ctrl.filter
				});
			}
		};

		ctrl.openTreeModal = function () {

			ctrl.modalInstance = $uibModal.open({
				templateUrl: 'scripts/components/util/metadata/repository/modalTree.html',
				//scope: scope,
				controller: 'ModalTreeRepositoryController',

				resolve: {
					metaDataInstance: function () {
						return ctrl.filter;
					},
					referentialValueDisplay: function () {
						return ctrl.filter.listDisplayPathForNode;
					},
					referentialValueDTOList: function () {
						return ctrl.filter.referentialValueDTOList;
					},
					tree: function () {
						return metaDataReferentielService.getReferentialById(ctrl.filter.metaDataDTO.referential.refId, ctrl.codeTee, ctrl.filter.metaDataDTO.code);
					},
					multiple: function () {
						return ctrl.filter.multiValued;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('editMetaData');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});


			ctrl.modalInstance.result.then(function (selectedItem) {
				if (ctrl.filter.multiValued) {
					var values = [];
					//check if there is a former filter matching a filter from BDD 
					angular.forEach(selectedItem.filterValues, function (refValue) {
						var valToSet = {};
						valToSet.text = refValue;
						values.push(valToSet);
					});
					ctrl.filter.multiValuesList = values;
				} else {
					ctrl.filter.value = selectedItem.filterValues[0];
				}
				ctrl.filter.referentialValueDisplay = selectedItem.referentialValueDisplay;
				ctrl.filter.listDisplayPathForNode = selectedItem.referentialValueDisplay;
				ctrl.filter.referentialValueDTOList = selectedItem.referentialValueDTOList;
			});
		};

		ctrl.highlightText = function (meta, term) {
			var label;
			if (ctrl.filter.multiValued) {
				label = meta.text;
			} else {
				label = ctrl.lang === 'fr' ? meta.labelFR : meta.labelEN;
			}
			if (!_.isEmpty(term)) {
				var first = ctrl.filter.metaDataDTO.searchType && ctrl.filter.metaDataDTO.searchType === 'STARTSWITH';
				return $filter('highlightFirst')(label, term, first);
			}
			return label;
		};

		ctrl.filterMetaValues = function (actual, expected) {
			if (!_.isEmpty(expected) && !_.isEmpty(actual)) {
				if (ctrl.filter.metaDataDTO.searchType && ctrl.filter.metaDataDTO.searchType === 'STARTSWITH') {
					return actual.toLowerCase().indexOf(expected.toLowerCase()) === 0;
				}
				return actual.toLowerCase().contains(expected.toLowerCase());
			}
			return true;
		};


		ctrl.checkNumbers = function () {
			if (ctrl.type === 'numeric' && ctrl.filter.multiValuesList && ctrl.filter.multiValuesList[0] && ctrl.filter.multiValuesList[1]) {
				if (parseFloat(ctrl.filter.multiValuesList[0].text) > parseFloat(ctrl.filter.multiValuesList[1].text)) {
					ctrl.checkNumbersFilter.validNumbers = false;
					ctrl.message = 'userApp.searchInterfaceTemplate.listFilterTir.validNumber';
					return ctrl.checkNumbersFilter.validNumbers;
				} else {
					ctrl.message = "";
					ctrl.checkNumbersFilter.validNumbers = true;
				}
				ctrl.message = "";
				return ctrl.checkNumbersFilter.validNumbers;
			}
			ctrl.message = "";
			return ctrl.checkNumbersFilter.validNumbers;
		};

		ctrl.updateNumbers = function (newValue, oldValue) {
			if (oldValue === 'BETWEEN') {

				ctrl.filter.value = ctrl.filter.multiValuesList[0].text;
			} else if (newValue === 'BETWEEN') {
				ctrl.filter.multiValuesList[0] = {
					text: ctrl.filter.value
				};
			}
		};

		ctrl.updateBoolean = function () {
			if (ctrl.type === 'boolean') {
				ctrl.filter.value = "";
				ctrl.filter.multiValuesList = [];
			}
		};

		//scope.validDates = true;
		ctrl.checkDates = function () {
			if (ctrl.type === 'date' && ctrl.filter.multiValuesList && ctrl.filter.multiValuesList[0] && ctrl.filter.multiValuesList[1]) {
				var num1 = ctrl.filter.multiValuesList[0].text;
				var num2 = ctrl.filter.multiValuesList[1].text;
				if (new Date(num1) > new Date(num2)) {
					ctrl.checkDatesFilter.validDates = false;
					ctrl.message = 'userApp.searchInterfaceTemplate.listFilterTir.validDate';
					return ctrl.checkDatesFilter.validDates;
				} else {
					ctrl.checkDatesFilter.validDates = true;
				}
				ctrl.message = "";
				return ctrl.checkDatesFilter.validDates;
			}
			ctrl.message = "";
			return ctrl.checkDatesFilter.validDates;
		};

		// scope.validation = true;

		ctrl.validPattern = true;
		ctrl.filterPattern = function (tag) {
			var textEntered = tag.text;
			var regex = new RegExp(ctrl.filter.filterFieldPattern);
			ctrl.validPattern = regex.test(textEntered);
			return ctrl.validPattern;
		};

		ctrl.getMaxLength = function () {
			return ctrl.filter.metaDataDTO.textLength;
		};

		ctrl.dateChanged = function (startDate, endDate) {

			if (_.isUndefined(startDate) && _.isUndefined(endDate)) {
				var selectedOperator = ctrl.filter.dateOperator;
				TirFilterSharedService.clearFilter(ctrl.filter, ctrl.searchTemplateId);
				ctrl.filter.dateOperator = selectedOperator;
			}
			if (!ctrl.filter.multiValuesList && ctrl.filter.multiValuesList.length !== 2) {
				ctrl.filter.multiValuesList = [];
			}

			if (startDate || endDate) {
				ctrl.filter.multiValuesList[0] = {
					text: startDate
				};
				ctrl.filter.multiValuesList[1] = {
					text: endDate
				};
			} else {
				ctrl.filter.multiValuesList = [];
			}
		};

		ctrl.addItem = function () {
			if (ctrl.filter.multiValued) {
				var exist = false;
				if (ctrl.filter.multiValuesList !== null && angular.isDefined(ctrl.filter.value) && ctrl.filter.value !== "") {
					for (var i = 1, len = ctrl.filter.multiValuesList.length; i <= len; i++) {
						if (ctrl.filter.multiValuesList[i - 1].text === ctrl.filter.value)
							exist = true;
					}

				}
				if (!exist && angular.isDefined(ctrl.filter.value) && ctrl.filter.value !== "" && ctrl.filter.value !== null) {
					var object = {
						text: ctrl.filter.value
					};
					ctrl.filter.multiValuesList.push(angular.copy(object));
				}
			}
		};

		ctrl.removeValue = function (selectedValue) {
			var index = ctrl.filter.multiValuesList.indexOf(selectedValue);
			ctrl.filter.multiValuesList.splice(index, 1);
		};

		function setDateModel() {
			ctrl.dateModel = {};
			if (!ctrl.filter.multiValued) {
				if (ctrl.filter.value) {
					ctrl.dateModel.startDate = ctrl.filter.value;
					ctrl.dateModel.endDate = ctrl.filter.value;
				}
			} else {
				if (ctrl.filter.multiValuesList && ctrl.filter.multiValuesList.length === 1) {
					ctrl.dateModel.startDate = ctrl.filter.multiValuesList[0].text;
					ctrl.dateModel.endDate = ctrl.filter.multiValuesList[0].text;
				}
				if (ctrl.filter.multiValuesList && ctrl.filter.multiValuesList.length > 1) {
					ctrl.dateModel.startDate = ctrl.filter.multiValuesList[0].text;
					ctrl.dateModel.endDate = ctrl.filter.multiValuesList[1].text;
				}
			}
		}

		ctrl.loadMetaDataSystemValues = function () {
			if (ctrl.listMetaDataSystemValues.length === 0) {
				blockUI.start();
				metadataSystemService.getSystemFilterValues(ctrl.filter, ctrl.mountingRt)
					.then(function (data) {
						ctrl.listMetaDataSystemValues = _.map(data, function (o) {
							var item = o.name;
							item.translatedText = $filter("translate")(item.text);
							return item;
						});
						blockUI.stop();
					});
			}
		};

		function broadCastUISelectDataReady() {
			$timeout(function () {
				$scope.$broadcast("UISelect_Data_Ready");
			});
		}

		/**
			* CALL THIS FUNCTION TO GET NEXT PAGE OF UI SELECT LIST
			* Referential values are filtered by product codes following rules mentioned in SIETRAINMQ-933	
			* @param {*} $select 
			*/
		ctrl.fetch = function ($select) {
			if (ctrl.isContextualizedSearch && !_.isEmpty(ctrl.productCode)) {
				ctrl.fetchByProductCodes($select, [ctrl.productCode]);
			}
			else if (_.isEmpty(ctrl.productFilterValues)) {
				ctrl.fetchByProductCodes($select, []);
			} else {
				blockUI.start();
				TirFilterSharedService.getPorductCodesByNameIn(ctrl.productFilterValues).then(function (productCodes) {
					blockUI.stop();
					ctrl.fetchByProductCodes($select, productCodes);
				}).finally(blockUI.stop);
			}
		};

		ctrl.fetchByProductCodes = function ($select, productCodes) {
			if (!ctrl.allowFetch) {
				broadCastUISelectDataReady();
				return;
			}
			ctrl.currentPage++;
			if (ctrl.currentPage >= 0) {
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.filter.metaDataDTO.referential.refId, productCodes, $select.search, ctrl.filter.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						if (refList.length === 0) {
							ctrl.allowFetch = false;
							broadCastUISelectDataReady();
							return;
						}
						var values = ctrl.filter.multiValued ? ctrl.transformData(refList) : refList;
						if (ctrl.currentPage === 0) {
							ctrl.referentialValueLis = values;
						} else {
							ctrl.referentialValueLis = ctrl.referentialValueLis.concat(values);
						}
						broadCastUISelectDataReady();

					});
			}
		};

		/**
			* SEARCH REFERENTIAL BY INPUT TEXT AND GET FIRST PAGE 
			* Referential values are filtered by product codes following rules mentioned in SIETRAINMQ-933	
			* @param {*} $select 
			*/
		ctrl.searchRef = function ($select) {
			if (ctrl.isContextualizedSearch && !_.isEmpty(ctrl.productCode)) {
				ctrl.searchRefByProductCodes($select, [ctrl.productCode]);
			}
			else if (_.isEmpty(ctrl.productFilterValues)) {
				ctrl.searchRefByProductCodes($select, []);
			} else {
				blockUI.start();
				TirFilterSharedService.getPorductCodesByNameIn(ctrl.productFilterValues).then(function (productCodes) {
					blockUI.stop();
					ctrl.searchRefByProductCodes($select, productCodes);
				}).finally(blockUI.stop);
			}
		};

		ctrl.searchRefByProductCodes = function ($select, productCodes) {
			ctrl.allowFetch = true;
			if (ctrl.currentPage !== -1) {
				if (!$select.search) {
					ctrl.referentialValueLis = [];
				}
				ctrl.currentPage = 0;
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.filter.metaDataDTO.referential.refId, productCodes, $select.search, ctrl.filter.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						ctrl.referentialValueLis = ctrl.filter.multiValued ? ctrl.transformData(refList) : refList;
						broadCastUISelectDataReady();
					});
			}
		};

		/**
			* INITIALIZE UI ON OPEN/CLOSE EVENT
			* Referential values are filtered by product codes following rules mentioned in SIETRAINMQ-933	
			* @param {*} $select 
			* @param {*} isOpen 
			*/
		ctrl.initializeSelect = function ($select, isOpen) {
			if (ctrl.isContextualizedSearch && !_.isEmpty(ctrl.productCode)) {
				ctrl.initializeSelectByProductCodes($select, isOpen, [ctrl.productCode]);
			}
			else if (_.isEmpty(ctrl.productFilterValues)) {
				ctrl.initializeSelectByProductCodes($select, isOpen, []);
			} else {
				blockUI.start();
				TirFilterSharedService.getPorductCodesByNameIn(ctrl.productFilterValues).then(function (productCodes) {
					blockUI.stop();
					ctrl.initializeSelectByProductCodes($select, isOpen, productCodes);
				}).finally(blockUI.stop);
			}
		};

		ctrl.initializeSelectByProductCodes = function ($select, isOpen, productCodes) {
			if (isOpen) {
				ctrl.allowFetch = true;
				ctrl.currentPage = 0;
				return metaDataReferentielService.getReferentialByIdPageable(ctrl.filter.metaDataDTO.referential.refId, productCodes, $select.search, ctrl.filter.metaDataDTO.code, ctrl.lang, ctrl.currentPage, ctrl.itemsPerPage)
					.then(function (refList) {
						ctrl.referentialValueLis = ctrl.filter.multiValued ? ctrl.transformData(refList) : refList;
					});
			} else {
				ctrl.referentialValueLis = [];
			}
		};

		// TANSFORM DATA IF MULTIVALUE LIST
		ctrl.transformData = function (list) {
			var values = [];
			angular.forEach(list, function (refValue) {
				var valToSet = {};
				valToSet.text = ctrl.lang === 'fr' ? refValue.labelFR : refValue.labelEN;
				values.push(valToSet);
			});
			return values;
		};


	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrFilterModal', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-filter-modal/search-filter-modal.component.html',
			controller: searchSolrFilterModalController,
			bindings: {
				resolve: "<",
				close: '&',
				dismiss: '&',
			},
		});

	/** @ngInject */
	function searchSolrFilterModalController(openErrorModalService, TirFilterSharedService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.searchTemplateId = ctrl.resolve.searchTemplateId;
			ctrl.productCode = ctrl.resolve.productCode;

			ctrl.checkNumbersFilter = {
				validNumbers: true
			};

			ctrl.checkDatesFilter = {
				validDates: true
			};

			ctrl.checkLengthFilter = {
				validLength: true
			};

			ctrl.isClearFilters = false;

		};

		ctrl.isContextualizedSearch = ctrl.resolve.isContextualizedSearch;

		ctrl.resolve.currentFilters = _.cloneDeep(ctrl.resolve.searchSolr.searchFullTextDTO);

		ctrl.previousFiltersInstance = ctrl.resolve.searchFullText.filterInstanceDTOs;



		var previousFilterInstances = ctrl.resolve.currentFilters.filterInstanceDTOs;

		ctrl.resolve.allFilters.$promise.then(function (data) {

			//if there is no former filters
			if (angular.isUndefined(previousFilterInstances) || previousFilterInstances.length === 0) {
				//take those comming from BDDisy
				ctrl.resolve.currentFilters.filterInstanceDTOs = data;
			} else {
				var filters = [];
				//check if there is a former filter matching a filter from BDD 

				_.forEach(data, function (filter) {
					var existingFilters = _.cloneDeep(previousFilterInstances.filter(function (formerFilter) {
						return angular.isDefined(formerFilter) && (formerFilter.type === filter.type) &&
							(formerFilter.identifier === filter.identifier);
					}));

					//if there is one
					if (existingFilters && existingFilters.length > 0) {
						//keep this one
						//keep this one and set the values
						filter.value = existingFilters[0].value;
						filter.contains = existingFilters[0].contains;
						filter.dateOperator = existingFilters[0].dateOperator;
						filter.metaDataOperator = existingFilters[0].metaDataOperator;
						filter.multiValuesList = existingFilters[0].multiValuesList;
						filter.listDisplayPathForNode= existingFilters[0].listDisplayPathForNode;
						filter.referentialValueDTOList= existingFilters[0].referentialValueDTOList;

						//needed to diplay label
						if (filter.metaDataDTO.metaDataType === "REPOSITORY") {
							filter.multiValuesList.forEach(function (v) { delete v.displayOrder ;});
						}


						filter.nullValue = existingFilters[0].nullValue;
						filter.referentialValueDisplay = existingFilters[0].referentialValueDisplay;
					}
					filters.push(filter);
				});


				//assign 'merged' filters (between BDD and sessionStorage)
				ctrl.resolve.currentFilters.filterInstanceDTOs = filters;
			}
		});

		//ctrl.selectedValues = ctrl.resolve.filter.multiValuesList;

		ctrl.clearModalFilters = function () {
			ctrl.isClearFilters = true;

			_.forEach(ctrl.resolve.currentFilters.filterInstanceDTOs, function (filter) {
				TirFilterSharedService.clearFilter(filter, ctrl.searchTemplateId);
			});

			ctrl.resolve.currentFilters.filterInstanceDTOs = _.cloneDeep(ctrl.resolve.currentFilters.filterInstanceDTOs);
		};

		ctrl.cancelFilterModal = function () {
			ctrl.dismiss();
		};

		ctrl.closeModal = function () {
			ctrl.close({
				$value: ctrl.resolve.currentFilters.filterInstanceDTOs
			});
		};



	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 
	angular
		.module('userApp')
		.component('searchFulltext', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-full-text/search-full-text.tpl.html',
			controller: SearchFulltextController,
			bindings: {
				tirId: "=?",
				saveSession: "<?"
			},
		});

	/** @ngInject */
	function SearchFulltextController($log, $stateParams, TirFilterSharedService, $rootScope, $q, $element, blockUI, SearchSolrService, openErrorModalService) {
		var ctrl = this;

		ctrl.items;

		ctrl.$onInit = function () {

			ctrl.searchOptions = [{
				value: 'userApp.searchInterfaceTemplate.searchOptions.title',
				selected: true
			}, {
				value: 'userApp.searchInterfaceTemplate.searchOptions.abstract',
				selected: true
			}, {
				value: 'userApp.searchInterfaceTemplate.searchOptions.content',
				selected: true
			}, {
				value: 'userApp.searchInterfaceTemplate.searchOptions.metadata',
				selected: true
			}];

			ctrl.clearButtonHashKey = null;

			ctrl.isAllSelected = true;


			ctrl.searchSolrHandler = $rootScope.$on('ChangeSearchSolr', function (event, data) {
				ctrl.searchSolr = data;
				ctrl.searchText = ctrl.searchSolr.searchFullTextDTO.searchFullText;

				// Initialize search options with session values
				if (ctrl.searchText) {
					ctrl.searchOptions[0].selected = ctrl.searchSolr.searchFullTextDTO.titleEditorialEntity;
					ctrl.searchOptions[1].selected = ctrl.searchSolr.searchFullTextDTO.summaryEditorialEntity;
					ctrl.searchOptions[2].selected = ctrl.searchSolr.searchFullTextDTO.contentEditorialEntity;
					ctrl.searchOptions[3].selected = ctrl.searchSolr.searchFullTextDTO.metadataEditorialEntity;
					ctrl.isAllSelected = ctrl.searchOptions.every(function (itm) {
						return itm.selected;
					});
				}

				ctrl.currentTirId = ctrl.searchSolr.searchFullTextDTO.searchInterfaceTemplateId.toString();
			});

			ctrl.currentTirId = angular.isDefined(ctrl.tirId) ? ctrl.tirId : $stateParams.identifier;

		};




		ctrl.$doCheck = function () {
			bindClearButton();
		};

		ctrl.$onChanges = function (changesObj) { };

		ctrl.$onDestroy = function () { };


		function bindClearButton() {
			// find clear btn
			var currentClearButton = $element.find('md-autocomplete button');

			/* eslint-disable angular/no-private-call */
			//if we are already binded or button doesn't exist, we skip
			if (currentClearButton.length > 0) {
				if (!ctrl.clearButtonHashKey || ctrl.clearButtonHashKey !== currentClearButton[0].$$hashKey) {
					ctrl.clearButtonHashKey = currentClearButton[0].$$hashKey;
					currentClearButton.on('click', function () {
						if (angular.isDefined(ctrl.onSearchClear)) {
							ctrl.onSearchClear();
						}
					});
				}
			}
			/* eslint-enable */
		}

		ctrl.selectedItemChange = function (item) {
			if (item) {
				ctrl.searchText = item.value.searchFullText;
				ctrl.searchSolr.searchFullTextDTO = item.value;
				updateScope();
				ctrl.rechercheTIR();
			} else if (_.isEmpty(ctrl.searchText)) {
				ctrl.searchText = '';
				ctrl.searchSolr.searchFullTextDTO.identifier = null;
				ctrl.rechercheTIR();
			}
		};

		ctrl.textChanged = function (text) {
			ctrl.searchText = text;
			if (!_.isEmpty(text)) {
				ctrl.searchSolr.searchFullTextDTO.identifier = null;
			}
		};



		ctrl.searchClick = function () {
			event.target.blur();
			ctrl.rechercheTIR();
		};


		ctrl.getTooltip = function (filters) {
			return filters.length > 0 ? 'scripts/pre-upgrade/components/search/searchFulltext/tooltip.tpl.html' : '';
		};

		var runningSearch = null;

		ctrl.search = function (query) {
			if (ctrl.items) {
				var res = query ? ctrl.items.filter(createFilter(query)) : ctrl.items;
				return res;
			} else {
				if (!runningSearch && ctrl.currentTirId) {
					$q.when([]).then(function (response) {
						var array = response.map(function (data) {
							return {
								value: data,
								display: data.searchFullText === '' ? '\f' : data.searchFullText,
								areas: getSearchAreas(data),
								filters: extractFilters(data)

							};
						});
						ctrl.items = array;
						runningSearch = null;
						return ctrl.items;
					});
				}

				return runningSearch !== null ? runningSearch.then(function (data) {
					return query ? data.filter(createFilter(query)) : data;
				}) : [] /*$q.defer().resolve([])*/;
			}
		};



		ctrl.toggleAll = function () {
			var toggleStatus = !ctrl.isAllSelected;
			angular.forEach(ctrl.searchOptions, function (itm) {
				itm.selected = toggleStatus;
			});
			checkOptions();
			optionChanged();
		};


		ctrl.optionToggled = function () {
			ctrl.isAllSelected = ctrl.searchOptions.every(function (itm) {
				return itm.selected;
			});
			checkOptions();
			optionChanged();
		};


		ctrl.rechercheTIR = function () {
			var searchSolr = createQueryObject();
			if (ctrl.editTirInModal) {
				searchSolr.saveHistory = false;
			}
			searchSolr.pagination.start = 0;
			searchSolr.sortByScore = isSortByScore(searchSolr);
			blockUI.start();
			SearchSolrService.search(searchSolr, function (data) {
				if (ctrl.saveSession) {
					TirFilterSharedService.saveInSession(data);
				}
				$rootScope.$emit('FullTextSearch', data);
				ctrl.searchText = data.searchFullTextDTO.searchFullText;
				blockUI.stop();
			},
				function (error) {
					blockUI.stop();
				});

		};


		ctrl.onOptionChange = function () {
			createQueryObject();
		};

		ctrl.onSearchClear = function () {
			ctrl.searchSolr.searchFullTextDTO.identifier = null;
			ctrl.rechercheTIR();
			ctrl.checkAllSearchOptions();
		};

		ctrl.checkAllSearchOptions = function () {
			ctrl.searchOptions[0].selected = true;
			ctrl.searchOptions[1].selected = true;
			ctrl.searchOptions[2].selected = true;
			ctrl.searchOptions[3].selected = true;
			ctrl.isAllSelected = true;
		};

		function updateScope() {
			var options = ctrl.searchOptions;
			var searchFullTextDTO = ctrl.searchSolr.searchFullTextDTO;
			options[0].selected = searchFullTextDTO.titleEditorialEntity;
			options[1].selected = searchFullTextDTO.summaryEditorialEntity;
			options[2].selected = searchFullTextDTO.contentEditorialEntity;
			options[3].selected = searchFullTextDTO.metadataEditorialEntity;
		}

		function createQueryObject() {

			var options = ctrl.searchOptions;
			var searchFullTextDTO = ctrl.searchSolr.searchFullTextDTO;
			if (ctrl.currentTirId === searchFullTextDTO.searchInterfaceTemplateId.toString()) {
				searchFullTextDTO.searchFullText = ctrl.searchText;

				searchFullTextDTO.allEditorialEntity = options.every(function (itm) {
					return itm.selected;
				});
				searchFullTextDTO.titleEditorialEntity = options[0].selected;
				searchFullTextDTO.summaryEditorialEntity = options[1].selected;
				searchFullTextDTO.contentEditorialEntity = options[2].selected;
				searchFullTextDTO.metadataEditorialEntity = options[3].selected;
			}
			return ctrl.searchSolr;
		}


		function createFilter(query) {
			var lower = _.deburr(angular.lowercase(query));
			return function (value) {
				return (angular.lowercase(_.deburr(value.display)).indexOf(lower) === 0);
			};
		}


		function extractFilters(data) {
			return TirFilterSharedService.extractFilters(data.filterInstanceDTOs);
		}

		function getSearchAreas(data) {
			var areas = [];

			if (data.allEditorialEntity) {
				areas.push('userApp.searchInterfaceTemplate.searchOptions.all');
			} else {
				if (data.titleEditorialEntity) areas.push('userApp.searchInterfaceTemplate.searchOptions.title');
				if (data.summaryEditorialEntity) areas.push('userApp.searchInterfaceTemplate.searchOptions.abstract');
				if (data.contentEditorialEntity) areas.push('userApp.searchInterfaceTemplate.searchOptions.content');
				if (data.metadataEditorialEntity) areas.push('userApp.searchInterfaceTemplate.searchOptions.metadata');
			}

			return areas;
		}

		function optionChanged() {
			if (angular.isDefined(ctrl.onOptionChanged)) {
				ctrl.onOptionChanged();
			}
		}

		function checkOptions() {
			var allUnchecked = ctrl.searchOptions.every(function (itm) {
				return !itm.selected;
			});

			if (allUnchecked) {
				ctrl.searchOptions[0].selected = true;
			}
		}

		function isSortByScore(searchSolr) {
			var searchFullTextDTO = searchSolr.searchFullTextDTO;
			if (searchFullTextDTO) {
				if (searchFullTextDTO.searchFullText && searchFullTextDTO.searchFullText.trim().length > 0) {
					return true;
				}
				if (searchFullTextDTO.filterInstanceDTOs && searchFullTextDTO.filterInstanceDTOs.length > 0) {
					angular.forEach(searchFullTextDTO.filterInstanceDTOs, function (item) {
						if (item.multiValuesList > 0) {
							return true;
						}
					});
				}
			}
			return false;
		}
	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrHeader', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-header/search-header.component.html',
			controller: SearchSolrHeaderController,
			bindings: {
				editTirInModal: "=",
				searchFullText: "=",
				pagination: "=",
				currentFilters: "=",
				searchSolr: "=",
				identifier: "=",
				activeFilters: "<",
				getLibelle: "&",
				getData: "&",
				productCode: '<',
				ingnoreEeAlreadyAttached: '=',
				ignoreEeHookedSameProduct: '=',
				ignoreEeHookedToSameEet: '=',
			},
		});

	/** @ngInject */
	function SearchSolrHeaderController($log, TirFilterSharedService, blockUI, SearchSolrService, $uibModal, $rootScope) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.displayAllFilter = false;
			countActivFilters();
			TirFilterSharedService.setProductFilterValues(ctrl.identifier, []);
		};

		ctrl.$onDestroy = function () {
		};

		ctrl.$onChanges = function () {
			countActivFilters();
		};

		ctrl.showFilter = function () {
			return ctrl.searchSolr.searchFullTextDTO && _.some(ctrl.searchSolr.searchFullTextDTO.filterInstanceDTOs, function (value) {
				return value.visibility;
			});
		};
		ctrl.checkIsSavedSarchAuthorize = function () {
			return TirFilterSharedService.canSaveSearch();
		};


		ctrl.switchFilterDisplay = function () {
			ctrl.displayAllFilter = !ctrl.displayAllFilter;
		};

		ctrl.resetFilters = function () {
			ctrl.pagination.currentPage = 1;
			ctrl.searchSolr.searchFullTextDTO = null;
			ctrl.getData();
		};



		ctrl.showModalSave = function (ev) {

			//var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;

			countActivFilters();

			var modalInstance = $uibModal.open({
				component: 'createSavedSearchComponent',
				resolve: {
					productCode: function () {
						return ctrl.productCode;
					}
				},
				backdrop: 'static'
			});
			modalInstance.result.then(function (answer) {
				if (answer) {
					ctrl.searchSolr.searchFullTextDTO.identifier = null;
					ctrl.pagination.currentPage = 1;
					ctrl.getData();
				}
				ctrl.status = 'You said the information was "' + answer + '".';
			}, function () {
				ctrl.status = 'You cancelled the dialog.';
			});



		};


		var filterModalInstance;
		ctrl.selectFilter = function () {
			if (!ctrl.isFilterModalOpen) {
				blockUI.start();
				filterModalInstance = $uibModal.open({
					component: 'searchSolrFilterModal',
					windowClass: ctrl.editTirInModal ? 'ecm-in-editor-tir-filter' : '',
					resolve: {
						searchFullText: function () {
							return ctrl.searchFullText;
						},
						allFilters: function (searchInterfaceTemplateResource) {
							return searchInterfaceTemplateResource.allFilters({
								identifier: ctrl.identifier
							});
						},
						currentFilters: function () {
							return ctrl.currentFilters;
						},
						productCode: function () {
							return ctrl.productCode;
						},
						searchSolr: function () {
							return ctrl.searchSolr;
						},
						isContextualizedSearch: function (searchInterfaceTemplateResource) {
							if (_.isEmpty(ctrl.productCode)) {
								return false;
							} else {
								return searchInterfaceTemplateResource.isContextualized({
									identifier: ctrl.identifier,
									productCode: ctrl.productCode
								}).$promise.then(function (data) {
									return data.result;
								});
							}
						},
						searchTemplateId: function () {
							return ctrl.identifier;
						}
					},
					size: 'lg',
					backdrop: 'static'
				});

				filterModalInstance.opened.then(function () {
					blockUI.stop();
				});

				filterModalInstance.result.then(function (result) {
					ctrl.searchSolr.searchFullTextDTO.filterInstanceDTOs = result;

					ctrl.searchSolr.searchFullTextDTO.identifier = null;
					ctrl.pagination.currentPage = 1;

					ctrl.getData();
				}, function (reason) { });
			}
		};

		ctrl.removeFilter = function (filter) {
			if (filter) {
				TirFilterSharedService.clearFilter(filter.filterDTORef, ctrl.identifier);
				countActivFilters();
				ctrl.getData();
			}
		};

		ctrl.clearFilters = function () {
			var filtersToClear = _.filter(ctrl.searchFullText.filterInstanceDTOs, function (filter) {
				return filter.visibility || !filter.defaultValue;
			});
			if (filtersToClear) {
				for (var i = 0, len = filtersToClear.length; i <= len - 1; i++) {
					var filter = filtersToClear[i];
					TirFilterSharedService.clearFilter(filter, ctrl.identifier);
				}
			}
			ctrl.pagination.currentPage = 1;
			ctrl.getData();
		};

		function countActivFilters() {
			ctrl.countFilters = 0;
			var filters = [];
			if (ctrl.searchFullText) {
				filters = TirFilterSharedService.extractFilters(ctrl.searchFullText.filterInstanceDTOs);
			}
			ctrl.activeFilters = filters;
			ctrl.countFilters = filters.length;
		}

	}
})();

(function () {
	'use strict';


	angular
		.module('userApp')
		.component('searchSolrMain', {
			templateUrl: 'scripts/pre-upgrade/components/search/search-main/search-main.component.html',
			controller: SearchSolrMainController,
			bindings: {
				savedSearch: "=",
				currentUser: "=",
				tirId: "=?",
				eeTargetChosen: "&?",
				eeListChecked: "=?", //checked ees list
				eeSelected: "=?", //clicked ee
				onSelectRowChange: "&?", //function firen when check or uncheck ee from list
				onSelectAllChange: "&?", //function firen when check or uncheck all list page
				hideMassOperationContainer: "<?",
				editTirInModal: "=?",
				searchFlashId: "=?",
				nodeFlashId: "=?",
				trCode: "=?",
				searchSolr: '=?',
				multiSelect: "<"
			},
		});

	/** @ngInject */
	function SearchSolrMainController($stateParams, $rootScope, $q, blockUI, SearchSolrService, solrResource, TirFilterSharedService, $timeout, relationTemplateResource) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.pagination = {
				itemByPage: 50,
				totalCount: 0,
				currentPage: 1
			};
			ctrl.identifier = angular.isDefined(ctrl.tirId) ? ctrl.tirId : $stateParams.identifier;

			$rootScope.$emit('tirUpdate', ctrl.identifier);

			initSavesearch();

			ctrl.activeFilters = [];
			ctrl.filter = {};
			ctrl.isLoading = false;
			ctrl.savedSarchAuthorize = true;
			ctrl.status = '  ';
			ctrl.currentFilters = [];
			ctrl.productCode = $stateParams.productCode;
			init();

			ctrl.handler = $rootScope.$on('FullTextSearch', function (event, data) {
				ctrl.searchSolr = data;
				bindSearchResult(data);
				ctrl.resultat = data.listResultat;
				ctrl.eeSelected = null;
			});
			//ctrl.ignoreEntitiesAttachedToSource = false;
			if (ctrl.searchFlashId) { ctrl.initEeSourceDetails(); }

		};

		ctrl.getData = function getData() {
			if (!ctrl.searchSolr.searchFullTextDTO || angular.isUndefined(ctrl.searchSolr.searchFullTextDTO.searchInterfaceTemplateId)) {
				initSearch();
			} else {
				blockUI.start();
				ctrl.searchSolr.pagination.start = ctrl.pagination.currentPage - 1;
				ctrl.searchSolr.pagination.limit = ctrl.pagination.itemByPage;
				SearchSolrService.search(ctrl.searchSolr, function (data) {
					// persist filters in session
					if (!ctrl.editTirInModal && !ctrl.savedSearch) {
						TirFilterSharedService.saveInSession(data);
					}
					data.isSavedSearch = false;
					ctrl.savedSarchAuthorize = false;
					ctrl.activeFilters = TirFilterSharedService.extractFilters(data.searchFullTextDTO.filterInstanceDTOs);
					bindSearchResult(data);
					blockUI.stop();

				}, function () {
					blockUI.stop();
				});
			}
		};


		ctrl.getLibelle = function () {

			ctrl.libelleSavedSearch = '';
			ctrl.actifFiltersValues = '';
			var schFull = ctrl.searchSolr.searchFullTextDTO;
			if (schFull.searchFullText) {
				ctrl.libelleSavedSearch = ctrl.searchSolr.searchFullTextDTO.searchFullText + "/";
			}

			for (var i = 0, len = ctrl.activeFilters.length; i <= len - 1; i++) {
				ctrl.libelleSavedSearch += ctrl.activeFilters[i].filterName + ' : ';
				for (var j = 0, size = ctrl.activeFilters[i].filterValues.length; j <= size - 1; j++) {
					ctrl.actifFiltersValues = ctrl.activeFilters[i].filterValues[j];
				}
				ctrl.libelleSavedSearch += ctrl.actifFiltersValues + '  ';


			}
			ctrl.libelleSavedSearch += ctrl.libelleSavedSearch.split('  ').slice(0, -1).toString();
		};
		ctrl.initEeSourceDetails = function () {
			blockUI.start();
			relationTemplateResource.getRelationshipTemplateDTOListByEetSource({
				eeSourceFlashId: ctrl.searchFlashId
			}).$promise.then(function (data) {
				ctrl.relationshipTemplateList = data;
				if (ctrl.relationshipTemplateList.length === 0) {
					ctrl.ignoreEntitiesAttachedToSource = false;
					ctrl.ignoreEntitiesHookedToSameProduct = false;
					ctrl.ignoreEntitiesHookedToSameEet = false;
				} else {
					var currentTr = ctrl.relationshipTemplateList.find(function (tr) {
						return tr.idTIR === ctrl.identifier;
					});
					ctrl.ignoreEntitiesAttachedToSource = angular.isDefined(currentTr) ? currentTr.ignoreEntitiesAttachedToSource : false;
					ctrl.ignoreEntitiesHookedToSameProduct = angular.isDefined(currentTr) ? currentTr.ignoreEntitiesHookedToSameProduct : false;
					ctrl.ignoreEntitiesHookedToSameEet = angular.isDefined(currentTr) ? currentTr.ignoreEntitiesHookedToSameEet : false;
				}
				blockUI.stop();
			});
		};

		function initSearch() {
			blockUI.start();
			if (ctrl.editTirInModal) {
				ctrl.requestOrigin = 'LinkingWizard';
			}

			var searchDto = {
				id: ctrl.identifier,
				requestOrigin: ctrl.requestOrigin,
				pageSize: ctrl.pagination.itemByPage,
				sortPredicate: ctrl.searchSolr.pagination.sortPredicate,
				sortDirection: ctrl.searchSolr.pagination.sortDirection,
				eeSourceFlashId: ctrl.searchFlashId,
				nodeFlashId: ctrl.nodeFlashId,
				trCode: ctrl.trCode,
				searchSolrDTO: ctrl.searchSolr
			};
			return solrResource.initDTO({}, searchDto).$promise.then(function (data) {
				data.showDefaultPlan = !ctrl.hideMassOperationContainer & !ctrl.editTirInModal ? data.showDefaultPlan : false;
				data.plan = true;
				ctrl.activeFilters = TirFilterSharedService.extractFilters(data.searchFullTextDTO.filterInstanceDTOs);

				// Save initial search in session (fisrt click on Search interface template in menu)
				if (!ctrl.editTirInModal && !ctrl.savedSearch) {
					TirFilterSharedService.saveInSession(data);
				}
				bindSearchResult(data);
				blockUI.stop();

			});

		}

		function executeHighlight(selector, searchTerms) {
			angular.element(selector).mark(searchTerms,
				{
					accuracy: {
						value: 'exactly',
						limiters: ['-', '/', '_']
					},
					separateWordSearch: false,
					element: 'ecm-hl',
					className: 'highlight',
				});
		}

		/**
			* Async Highlight
			* @param {*} data 
			*/
		function handleHighlight(data) {
			return $q(function (resolve, reject) {
				$timeout(function () {
					var searchTerms = _.uniq(_.flatMap(_.values(data.highlightMatches)));
					if (!_.isEmpty(searchTerms)) {
						if (data.searchFullTextDTO.titleEditorialEntity) {
							executeHighlight('.mark-title', searchTerms);
						}
					}
					resolve(true);
				});
			});
		}

		function bindSearchResult(data) {
			ctrl.searchSolr = data;
			ctrl.pagination.totalCount = data.pagination.totalItemCount;
			ctrl.searchFullText = ctrl.searchSolr.searchFullTextDTO;
			ctrl.listFacet = ctrl.searchSolr.listFacet;
			ctrl.resultat = ctrl.searchSolr.listResultat ? ctrl.searchSolr.listResultat : [];
			$rootScope.$emit('ChangeSearchSolr', ctrl.searchSolr);
			// ASYNC CALL
			handleHighlight(data);
		}

		function initSavesearch() {
			if (ctrl.savedSearch !== null) {
				ctrl.savedSearch.isSavedSearch = true;
			}
		}


		function init() {

			var stored = !ctrl.editTirInModal ? TirFilterSharedService.getSessionStorage(ctrl.identifier, ctrl.productCode ? ctrl.productCode : null) : {
				filters: {},
				facets: []
			};

			if (angular.isUndefined(ctrl.searchSolr)) {
				ctrl.searchSolr = {
					searchFullTextDTO: ctrl.savedSearch ? ctrl.savedSearch.searchFullTextDTO : stored.filters,
					listFacet: stored.facets,
					listColumn: ctrl.savedSearch ? ctrl.savedSearch.listColumn : [],
					listCodeTEE: ctrl.savedSearch ? ctrl.savedSearch.listCodeTEE : [],
					listResultat: [],
					pagination: ctrl.savedSearch ? ctrl.savedSearch.pagination : {},
					productCode: ctrl.savedSearch ? ctrl.savedSearch.productCode : $stateParams.productCode
				};
			}
		}
	}
})();

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	angular
		.module('userApp')
		.component('tirDisplayFilter', {
			templateUrl: 'scripts/pre-upgrade/components/search/tir-display/tir-display-filter.tpl.html',
			controller: TirDisplayFilterController,
			bindings: {
				filters: '=',
				onRemove: '&?',
				allowRemove: '<?'
			},
		});

	/** @ngInject */
	function TirDisplayFilterController($log) {
		var ctrl = this;

		ctrl.$onInit = function () {
			if (angular.isUndefined(ctrl.allowRemove)) {
				ctrl.allowRemove = true;
			}
		};
		ctrl.$onChanges = function (changesObj) {

		};
		ctrl.$onDestroy = function () { };
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('searchContainer', {
			templateUrl: 'scripts/pre-upgrade/components/searchv2/search-container/search-container.component.html',
			controller: SearchContainerController,
			bindings: {
				tirId: "<",
				searchDto: "=",
				getSearchData: "&"
			}
		});

	/** @ngInject */
	function SearchContainerController() {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.facetVisibility = true;
		};

		ctrl.facetChanged = function () {
			ctrl.getSearchData();
		};

		ctrl.facetVisibilityChanged = function (visibility) {
			ctrl.facetVisibility = visibility;
		};

	}
})();

(function () {
	'use strict';
	angular
		.module('userApp')
		.component('searchFacet', {
			templateUrl: 'scripts/pre-upgrade/components/searchv2/search-facet/search-facet.component.html',
			controller: SearchFacetController,
			bindings: {
				tirId: "<",
				listFacet: "=",
				onFacetChanged: '&?',
				onFacetVisibilityChanged: "&?"
			},
		});

	/** @ngInject */
	function SearchFacetController(FACETCONFIG, SearchFacetService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.facetVisibility = true;
			ctrl.facetShowLimit = FACETCONFIG.showLimit;
			ctrl.facetMapValues = {};
			ctrl.facetCollapseMap = {};
		};

		// Toggle Facet Name
		ctrl.toggleFacet = function (facetCode) {
			ctrl.facetCollapseMap[facetCode] = !ctrl.facetCollapseMap[facetCode];
		};

		// Toggle all facets visibility
		ctrl.toggleFacetVisibility = function () {
			ctrl.facetVisibility = !ctrl.facetVisibility;
			if (ctrl.onFacetVisibilityChanged) {
				ctrl.onFacetVisibilityChanged({
					'visibility': ctrl.facetVisibility
				});
			}
		};

		// Clear all facet values (Uncheck all values)
		ctrl.clearAll = function () {
			_.forEach(ctrl.listFacet, function (facet) {
				_.forEach(facet.values, function (fValue) {
					fValue.checked = false;
					SearchFacetService.updateChildrenValues(fValue);
				});
			});
			// Call on change facet event
			ctrl.facetChanged();
		};

		// Check if facet has at least one facet value selected
		ctrl.isFacetSelected = function (facet) {
			if (facet && facet.values) {
				return _.some(facet.values, function (v) {
					return v.checked || SearchFacetService.checkChildValues(v.children);
				});
			}
			return false;
		};

		// Change facet event
		ctrl.facetChanged = function () {
			if (ctrl.onFacetChanged) {
				ctrl.onFacetChanged();
			}
		};

		// Used to track facet values within ng repeat
		ctrl.trackByCodes = function (code1, code2) {
			return SearchFacetService.trackByCodes(code1, code2);
		};



	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('SearchFacetService', SearchFacetService);


	/** @ngInject */
	function SearchFacetService() {
		var service = {
			trackByCodes: trackByCodes,
			updateChildrenValues: updateChildrenValues,
			checkChildValues: checkChildValues
		};

		return service;

		// returns a new concatenated code 
		function trackByCodes(code1, code2) {
			return code1 + '_' + code2;
		}

		// Update children values recursively when check/uncheck
		function updateChildrenValues(facetValue) {
			_.each(facetValue.children, function (child) {
				child.checked = facetValue.checked;
				if (child.children.length > 0) {
					updateChildrenValues(child);
				}
			});
		}

		// Check if at least one child value is checked recursively
		function checkChildValues(childValues) {
			if (!_.isEmpty(childValues)) {
				return _.some(childValues, function (c) {
					return c.checked || checkChildValues(c.children);
				});
			}
			return false;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('searchMain', {
			templateUrl: 'scripts/pre-upgrade/components/searchv2/search-main/search-main.component.html',
			controller: SearchMainController,
			bindings: {
				tirId: "=?",
				//searchDTO: '=?' // TODO change attribute in parent components
			},
		});

	/** @ngInject */
	// TODO use new Search DTO
	function SearchMainController($stateParams, blockUI, SearchService, TirFilterSharedService) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.identifier = angular.isDefined(ctrl.tirId) ? ctrl.tirId : $stateParams.identifier;
			ctrl.isTirStored = TirFilterSharedService.isTirStored(ctrl.identifier);
			if (angular.isUndefined(ctrl.searchDTO)) {
				var stored = TirFilterSharedService.getSessionStorage(ctrl.identifier);
				ctrl.searchDTO = {
					searchFullTextDTO: stored.filters,
					facetListDTO: stored.facets
				};
			}
		};


		ctrl.getSearchData = function getData() {
			if (!ctrl.isTirStored) {
				initSearch();
			} else {
				blockUI.start();
				// Call search service
				SearchService.search(ctrl.searchDTO, function (data) {
					// TODO Use another logic to persist search dto in session
					TirFilterSharedService.saveInSession(data);
					blockUI.stop();

				}, function () {
					blockUI.stop();
				});
			}
		};

		function initSearch() {
			blockUI.start();
			var initSearchDto = {
				tirId: ctrl.identifier,
				searchFullTextDTO: ctrl.searchDTO.searchFullTextDTO,
				facetListDTO: ctrl.searchDTO.facetListDTO
			};
			return SearchService.initSearch({}, initSearchDto).$promise.then(function (data) {
				// TODO Use another logic to persist search dto in session
				TirFilterSharedService.saveInSession(data);
				blockUI.stop();
			});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('createSavedSearchComponent', {
			templateUrl: 'scripts/pre-upgrade/components/saved-search/create-saved-search/create-saved-search.html',
			controller: createSavedSearchController,
			bindings: {
				resolve: '<',
				close: '&'
			}
		});

	/** @ngInject */
	function createSavedSearchController(SavedSearchService, TirFilterSharedService, ModalAlertService, $filter, $rootScope) {
		var ctrl = this;
		ctrl.$onInit = function () {
			ctrl.savedSearchUserDTO = {};
			ctrl.savedSearchDTO = {};

			var searchSolr = TirFilterSharedService.getSearchSolr();

			if (searchSolr && searchSolr.searchFullTextDTO) {
				ctrl.searchFullText = searchSolr.searchFullTextDTO;
				var labels = [];

				if (!_.isEmpty(ctrl.searchFullText.searchFullText)) {
					labels.push(ctrl.searchFullText.searchFullText);
				}

				var filters = TirFilterSharedService.extractFiltersToString(ctrl.searchFullText.filterInstanceDTOs);
				if (!_.isEmpty(filters)) {
					labels.push(filters);
				}

				ctrl.libelleSavedSearch = _.join(labels, ' / ');
			}
		};

		//SEND EVENT TO MENU COMPONENT REFRESH MENU
		ctrl.refreshMenu = function () {
			$rootScope.$emit('refreshMenu');
		};

		ctrl.allowSave = function () {
			return !_.isEmpty(ctrl.libelleSavedSearch) && ctrl.searchFullText;
		};

		ctrl.save = function () {
			if (ctrl.allowSave()) {
				ctrl.savedSearchDTO.name = ctrl.libelleSavedSearch;
				ctrl.savedSearchDTO.searchFullTextId = ctrl.searchFullText.identifier;
				ctrl.savedSearchDTO.searchInterfaceTemplateId = ctrl.searchFullText.searchInterfaceTemplateId;
				ctrl.savedSearchDTO.productCode = ctrl.resolve.productCode;
				ctrl.savedSearchUserDTO.addToMenu = ctrl.addToMenu;
				ctrl.allowAddMenu = angular.copy(ctrl.addToMenu);
				ctrl.savedSearchUserDTO.shareWithMyGroups = ctrl.shareWithGroups;
				ctrl.savedSearchUserDTO.savedSearchDTO = ctrl.savedSearchDTO;

				if (ctrl.savedSearchDTO.searchInterfaceTemplateId) {
					SavedSearchService.save(ctrl.savedSearchUserDTO, function (data) {
						//$mdDialog.hide();
						ctrl.close({
							$value: true
						});
						ModalAlertService.info('info', $filter('translate')('userApp.searchInterfaceTemplate.saveSearch.msgInfo'), '');
						if (ctrl.allowAddMenu) {
							ctrl.refreshMenu();
						}
					});
				}
				ctrl.savedSearchUserDTO = {};
				ctrl.addToMenu = false;
				ctrl.addToNotification = false;
				ctrl.shareWithGroups = false;
			}
		};

		ctrl.hide = function () {
			//$mdDialog.hide();
			ctrl.close({
				$value: false
			});
			ctrl.savedSearchUserDTO = {};
			ctrl.addToMenu = false;
			ctrl.addToNotification = false;
			ctrl.shareWithGroups = false;

		};

		ctrl.cancel = function () {
			//	$mdDialog.cancel();
			ctrl.close({
				$value: false
			});
			ctrl.savedSearchUserDTO = {};
			ctrl.addToMenu = false;
			ctrl.addToNotification = false;
			ctrl.shareWithGroups = false;
		};

		ctrl.answer = function (answer) {
			//$mdDialog.hide(answer);
			ctrl.close({
				$value: false
			});

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('webImportParameter', {
			templateUrl: 'scripts/pre-upgrade/components/web-import/web-import-parameter/web-import-parameter.html',
			controller: webImportParameterController,
			bindings: {
				webImportParameter: '='
			},
		});

	/** @ngInject */
	function webImportParameterController() {
		var ctrl = this;

		// INIT
		ctrl.$onInit = function () {
			if (ctrl.webImportParameter.parameterType === 'ARRAYLIST') {
				ctrl.webImportParameter.value = ctrl.webImportParameter.parameter.defaultValue[0];
			} else {
				ctrl.webImportParameter.value = null;
			}
		};

		ctrl.initParam = function (file) {
			if (file) {
				ctrl.webImportParameter.value = file;
				ctrl.webImportParameter.importFileName = file.name;
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('listSavedSearchComponent', {
			templateUrl: 'scripts/pre-upgrade/components/saved-search/list-saved-search/list-saved-search.html',
			controller: ListSavedSearchController,
			bindings: {
				currentUser: '<'
			},
		});

	ListSavedSearchController.$inject = ['blockUI', 'SavedSearchService', 'ModalAlertService', '$filter', '$translate', '$state'];
	function ListSavedSearchController(blockUI, SavedSearchService, ModalAlertService, $filter, $translate, $state) {
		var $ctrl = this;

		$ctrl.$onInit = function () {
			$ctrl.searchMap = {};
			$ctrl.searchMap['author'] = null;
			$ctrl.searchMap['startCreationDate'] = null;
			$ctrl.searchMap['endCreationDate'] = null;
			$ctrl.creationDateFilter = {};

			$ctrl.pagination = {
				itemByPage: 50,
				totalCount: 0,
				currentPage: 1
			};

			$ctrl.sortString;
		};

		$ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'creationDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			$ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');

			$ctrl.loadAllSavedSearch();
		};

		$ctrl.loadAllSavedSearch = function () {
			$ctrl.isLoading = true;
			blockUI.start();

			$ctrl.searchMap['startCreationDate'] = $ctrl.creationDateFilter.startDate || null;
			$ctrl.searchMap['endCreationDate'] = $ctrl.creationDateFilter.endDate || null;

			SavedSearchService.getListSavedSearchDTO({
				mapFilters: $ctrl.searchMap,
				page: Math.max($ctrl.pagination.currentPage - 1, 0),
				size: $ctrl.pagination.itemByPage,
				sort: $ctrl.sortString
			}).$promise
				.then(function (data) {
					var rowCollection = data ? (data.savedSearchUserDTOList ? data.savedSearchUserDTOList : []) : [];

					$ctrl.savedSearchs = [].concat(rowCollection);

					$ctrl.pagination.totalCount = data.totalElements;
					//$ctrl.authorFilterList = data.savedSearchFiltersDTO.authorFilterList;
					$ctrl.authorFilterList = [];
					angular.forEach(angular.fromJson(angular.toJson(data.savedSearchFiltersDTO.authorFilterMap)), function (value, key) {
						$ctrl.authorFilterList.push({
							name: key,
							value: value
						});
					});
					$ctrl.isLoading = false;
					blockUI.stop();
				})
				.catch(function (e) {
					$ctrl.isLoading = false;
					blockUI.stop();
				});

		};

		$ctrl.delete = function (savedSearch) {
			blockUI.start();
			SavedSearchService.deleteSavedSearch({
				id: savedSearch.id
			}).$promise.then(function () {
				$ctrl.loadAllSavedSearch();
				blockUI.stop();
			});
		};

		$ctrl.addToMenu = function (savedSearchUser, $event) {
			var isChecked = $event.target.checked;
			if (savedSearchUser.authorOfSavedSearch) {
				blockUI.start();
				SavedSearchService.addToMenu({ id: savedSearchUser.id, checked: isChecked }).
					$promise.then(function () {
						$ctrl.loadAllSavedSearch();
						blockUI.stop();
						if (isChecked) {
							ModalAlertService.info('info', $filter('translate')('userApp.savedSearch.msg.addToMenu', { savedSearchName: savedSearchUser.savedSearchDTO.name }), '');
						} else {
							ModalAlertService.info('info', $filter('translate')('userApp.savedSearch.msg.notAddToMenu', { savedSearchName: savedSearchUser.savedSearchDTO.name }), '');
						}
					});
				blockUI.stop();
			}
			else {
				$event.target.checked = false;
				ModalAlertService.error('error', $filter('translate')('userApp.savedSearch.msg.addToMenuNotAuthorized', { savedSearchName: savedSearchUser.savedSearchDTO.name }), '');
			}

		};

		$ctrl.shareWithMyGroups = function (savedSearchUser, $event) {
			var isChecked = $event.target.checked;
			blockUI.start();
			SavedSearchService.shareWithMyGroups({ id: savedSearchUser.id, checked: isChecked }).
				$promise.then(function () {
					$ctrl.loadAllSavedSearch();
					blockUI.stop();
					if (isChecked) {
						ModalAlertService.info('info', $filter('translate')('userApp.savedSearch.msg.shared', { savedSearchName: savedSearchUser.savedSearchDTO.name }), '');
					} else {
						ModalAlertService.info('info', $filter('translate')('userApp.savedSearch.msg.notShared', { savedSearchName: savedSearchUser.savedSearchDTO.name }), '');
					}
				});
			blockUI.stop();
		};

		$ctrl.executeSavedSearch = function (identifier, savedSearchId) {
			blockUI.start();
			SavedSearchService.getSavedSearch({
				identifier: identifier,
				savedSearchId: savedSearchId
			}).$promise.then(function (response) {
				blockUI.stop();
				if (response.searchFullTextDTO) {
					$state.go('searchInterfacesTemplate', {
						"identifier": identifier,
						"savedSearchId": savedSearchId,
						"productCode": response.productCode
					});
				}
			}).catch(function (e) {
				blockUI.stop();
				ModalAlertService.warn('info', $filter('translate')('userApp.savedSearch.msg.savedSearchFilterError'), '');
			});

		};
		$ctrl.$onChanges = function (changesObj) { };
		$ctrl.$onDestory = function () { };
	}
})();


(function () {
	'use strict';

	angular
		.module('userApp')
		.component('usersCreateComponent', {
			templateUrl: 'scripts/pre-upgrade/components/users/create/users-create.component.html',
			controller: UsersCreateController,
			bindings: {
				roles: "=",
				groups: "=",
				currentUser: "="
			},
		});

	/** @ngInject */
	function UsersCreateController($log, $state, $filter, userLdapResource, userResource, ModalAlertService, modalService) {

		var ctrl = this;

		ctrl.ldapUsers = [];
		ctrl.criteria = {};
		ctrl.selectedUser = {};
		ctrl.selectedUser.userGroups = [];
		ctrl.selectedUser.activated = true;
		ctrl.displayResult = false;
		ctrl.displayCreateForm = false;
		var modalOptions = {
			isConfirm: false,
			closeButtonText: $filter('translate')('userApp.user.action.cancel'),
			actionButtonText: $filter('translate')('userApp.user.action.confirm'),
			headerText: $filter('translate')('userApp.user.header.confirm'),
			bodyText: 'bodyText'
		};


		ctrl.$onInit = function () {
			$log.info("Init user edit component ");

			if (ctrl.currentUser.adminSi) {
				ctrl.filteredRoles = _.sortBy(ctrl.roles, function (role) {
					return role.name;
				});
			}
			else {
				var filteredRoleWithoutSort = _.filter(ctrl.roles, function (role) {
					return role.house === "ELS" || role.house === ctrl.currentUser.house;
				});

				ctrl.filteredRoles = _.sortBy(filteredRoleWithoutSort, function (role) {
					return role.name;
				});
			}

		};


		/**
		 * Search user in LDAP.
		 */
		ctrl.searchLdapUsers = function () {
			ctrl.displayResult = false;
			ctrl.displayCreateForm = false;
			userLdapResource.query(ctrl.criteria).$promise
				.then(function (data) {
					ctrl.ldapUsers = [].concat(data);
					ctrl.displayResult = true;
				});
		};

		/**
		 * This function is called , each time the user select a line from table.
		 */
		ctrl.select = function (row) {
			if (!row.persisted) {
				angular.extend(ctrl.selectedUser, row);
				ctrl.selectedUser.activated = true;
				if (ctrl.selectedUser.userGroups === null) {
					ctrl.selectedUser.userGroups = [];
				}
				ctrl.displayCreateForm = true;
			} else if (row.persisted) {
				ctrl.displayCreateForm = false;
			}
		};

    /**
		 * Leave the page without save and g back to users page.
		 */
		ctrl.cancel = function () {
			$state.go('user');
		};

    /**
		 * Save the affectations.
		 */
		ctrl.save = function () {

			modalOptions.headerText = $filter('translate')('userApp.user.header.alert');
			if (ctrl.selectedUser.userGroups.length === 0) {
				modalOptions.headerText = $filter('translate')('userApp.user.header.alert');
				modalOptions.bodyText = $filter('translate')('userApp.user.msg.ALERT_USER_GROUP_REQUIRED');
				modalService.showModal({}, modalOptions);
			} else {
				userResource.save(ctrl.selectedUser, function () {
					ModalAlertService.info('info', 'Sauvegarde effectuée', '');
					$state.go('user');
				}, function (err) {
					modalOptions.bodyText = $filter('translate')('userApp.user.msg.ERROR_TECH') + err.data.error;
					modalService.showModal({}, modalOptions);
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('usersDisplayComponent', {
			templateUrl: 'scripts/pre-upgrade/components/users/display/users-display.component.html',
			controller: UsersDisplayController,
			bindings: {
				allHouses: "="
			},
		});

	/** @ngInject */
	function UsersDisplayController($log, $scope, $stateParams, $state, $filter, userResource, userGroupResource, roleResource, Principal) {

		var ctrl = this;

		ctrl.houseOptions = [];
		ctrl.lang = 'fr';
		ctrl.users = [];
		ctrl.usersFilterCriteria = "";
		ctrl.selectedGroupId = '';
		ctrl.selectedRoleId = '';


		ctrl.$onInit = function () {
			$log.info("Init user display component ");

			ctrl.sortString;
			ctrl.pagination = {
				itemByPage: 50,
				totalCount: 0,
				currentPage: 1
			};
			ctrl.house = undefined;
		};


		ctrl.loadTable = function (tableState) {
			var sorting = tableState.sort;
			var predicate = sorting.predicate || 'lastModifiedDate';
			var reverse = angular.isUndefined(sorting.reverse) || Boolean(sorting.reverse);
			ctrl.sortString = ctrl.sortString = predicate.concat(reverse ? ',desc' : ',asc');
			ctrl.loadAllUser();
		};

		ctrl.loadAllUser = function (action) {

			var searchCriteria = (ctrl.usersFilterCriteria !== '') ? ctrl.usersFilterCriteria : '';
			if (angular.isDefined(action) && action === 'init') {
				ctrl.pagination.currentPage = 1;
				searchCriteria = '';
				ctrl.usersFilterCriteria = "";
				ctrl.house = undefined;
				ctrl.selectedGroupId = "";
				ctrl.selectedRoleId = "";
			}

			if (angular.isDefined(action) && action === 'filtre') {
				ctrl.pagination.currentPage = 1;
			}

			userResource.query({
				page: Math.max(ctrl.pagination.currentPage - 1, 0),
				size: ctrl.pagination.itemByPage,
				sort: ctrl.sortString,
				house: ctrl.house,
				filterValue: searchCriteria,
				groupId: ctrl.selectedGroupId ? Number(ctrl.selectedGroupId) : Number(0),
				roleId: ctrl.selectedRoleId ? Number(ctrl.selectedRoleId) : Number(0)
			}).$promise.then(function (data) {

				ctrl.rowCollection = data ? (data.content ? data.content : []) : [];
				ctrl.users = [].concat(ctrl.rowCollection);
				ctrl.pagination.totalCount = data.totalElements;

				ctrl.isLoading = false;
				ctrl.refreshData = false;
			});
		};


		ctrl.groupChanged = function () {
			$log.info("The group has been changed ", ctrl.selectedGroupId);
			ctrl.loadAllUser(undefined, 'filter');
		};

		ctrl.roleChanged = function () {
			$log.info("The role has been changed ", ctrl.selectedRoleId);
			ctrl.loadAllUser(undefined, 'filter');
		};

		ctrl.houseChanged = function () {
			$log.info("The house has been changed ", ctrl.house);
			ctrl.loadAllUser(undefined, 'filter');

			// LOAD ALL USER GROUP FOR THE SELECTED HOUSE
			getUserGroups();

			// LOAD ALL ROLES FOR THE SELECTED HOUSE
			getUserRoles();

		};

		function getUserGroups() {
			if (ctrl.house) {
				userGroupResource.getGroupForFilter({ house: ctrl.house }).$promise
					.then(function (data) {
						ctrl.groupFilters = data;
					});
			}
			else {
				ctrl.groupFilters = [];
			}

		}

		function getUserRoles() {

			if (ctrl.house) {
				roleResource.getAllRoleFilter({ house: ctrl.house }).$promise
					.then(function (data) {
						ctrl.roleFilters = data;
					});
			} else {
				ctrl.roleFilters = [];
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('usersEditPageComponent', {
			templateUrl: 'scripts/pre-upgrade/components/users/edit/users-edit-page.component.html',
			controller: UsersEditPageController,
			bindings: {
				roles: "<",
				groups: "<",
				user: "<",
				currentUser: "<"
			},
		});

	/** @ngInject */
	function UsersEditPageController($state, $filter, userResource, modalService, ModalAlertService, importAffectationsModalService) {

		var ctrl = this;

		ctrl.modalOptions = {
			isConfirm: false,
			closeButtonText: $filter('translate')('userApp.user.action.cancel'),
			actionButtonText: $filter('translate')('userApp.user.action.confirm'),
			headerText: $filter('translate')('userApp.user.header.confirm'),
			bodyText: 'bodyText'
		};

		ctrl.showAllRoles = false;

		ctrl.$onInit = function () {
			if (ctrl.currentUser.adminSi) {
				ctrl.filteredRoles = _.sortBy(ctrl.roles, function (role) {
					return role.name;
				});
			}
			else {
				var filteredRoleWithoutSort = _.filter(ctrl.roles, function (role) {
					return role.house === "ELS" || role.house === ctrl.currentUser.house;
				});

				ctrl.filteredRoles = _.sortBy(filteredRoleWithoutSort, function (role) {
					return role.name;
				});
			}
		};

		/**
		 * Cancel edit operation and go back to users page.
		 */
		ctrl.goBack = function () {
			$state.go('user');
		};

		ctrl.import = function () {
			importAffectationsModalService.openModal(ctrl.user).then(function (res) {
				// we change the object to trigger the onChange in usersEditComponent
				ctrl.user = Object.assign({}, ctrl.user);
			});
		};

		ctrl.toggleDisplayRoles = function () {
			ctrl.showAllRoles = !ctrl.showAllRoles;

		};

		/**
		 * Save the modifications and go back to users page.
		 */
		ctrl.save = function () {
			ctrl.modalOptions.headerText = $filter('translate')('userApp.user.header.alert');
			if (ctrl.user.userGroups.length === 0) {
				ctrl.modalOptions.headerText = $filter('translate')('userApp.user.header.alert');
				ctrl.modalOptions.bodyText = $filter('translate')('userApp.user.msg.ALERT_USER_GROUP_REQUIRED');
				modalService.showModal({}, ctrl.modalOptions);
			} else {
				userResource.update(ctrl.user, function () {
					ModalAlertService.info('info', 'Sauvegarde effectuée', '');
				}, function (err) {
					ctrl.modalOptions.bodyText = $filter('translate')('userApp.user.msg.ERROR_TECH') + err.data.error;
					modalService.showModal({}, ctrl.modalOptions);
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('usersEdit', {
			templateUrl: 'scripts/pre-upgrade/components/users/edit/users-edit.component.html',
			controller: UsersEditController,
			bindings: {
				roles: "<",
				groups: "<",
				user: "<",
				currentUser: "<",
				onSave: '&?',
				showAllRoles: "<"
			},
		});

	/** @ngInject */
	function UsersEditController($log, $timeout, confirmModalService) {

		var ctrl = this;

		ctrl.assignedRoles = [];
		ctrl.assignedHouse = [];
		ctrl.edit = false;
		ctrl.groupedRoles = [];
		ctrl.selectedRoles = [];

		ctrl.$onInit = function () {
			$log.info("Init user edit component ");
		};

		ctrl.$onChanges = function (newVal) {
			if (newVal.user) {
				ctrl.selectedRoles = [];

				ctrl.roles.forEach(function (r) {
					r.selectedGroups = [];
					ctrl.updateFlatSelectedGroups(r);
				});
				ctrl.preSelectRoles();
			}
		};

		ctrl.initGroup = function () {

			_.forEach(ctrl.user.userGroups, function (gr) {
				_.forEach(ctrl.groups, function (group) {
					if (group.identifier === gr.identifier) {
						group.roleId = gr.roleId;
					}
				});
			});

		};

		/**
		 * Check whether the target role has been selected.
		 */
		ctrl.preSelectRoles = function () {

			angular.forEach(ctrl.user.userGroups, function (val, i) {

				ctrl.selectedRoles[val.roleId] = true;

				//find associated role and add the group
				var roles = ctrl.roles.filter(function (r) {
					return r.identifier === val.roleId;
				});

				var role = roles[0];

				if (!role.selectedGroups)
					role.selectedGroups = [];

				role.selectedGroups.push(val);
				ctrl.updateFlatSelectedGroups(role);

			});
		};

		ctrl.onSelectRowChange = function () {

		};

		ctrl.edit = function (role) {
			role.isEditing = true;
		};

		ctrl.updateFlatSelectedGroups = function (role) {

			if (role.selectedGroups && role.selectedGroups.length > 0) {

				role.flatSelectedGroups = role.selectedGroups
					.map(function (g) {
						return g.name;
					})
					.join('; ');

			} else {
				role.flatSelectedGroups = '';
			}
		};

		ctrl.delete = function (role) {

			return confirmModalService.openMessageModal("user.deleteGroups.message")
				.then(function (result) {
					if (result) {

						role.selectedGroups = [];
						ctrl.selectedRoles[role.identifier] = false;
						ctrl.updateFlatSelectedGroups(role);
						ctrl.save();
						return true;
					}
					return result;
				});

		};

		/**
		 * Filter roles based on matching search term
		 * @param {Role} role 
		 */
		ctrl.filterRoles = function (role) {

			return (!ctrl.searchRole || ctrl.searchRole.length === 0 ||
				(role.name.toLowerCase().indexOf(ctrl.searchRole.toLowerCase()) !== -1))
				&& (ctrl.showAllRoles || ctrl.user.house === role.house)
				&& (!ctrl.searchGroup || ctrl.searchGroup.length === 0 || (role.flatSelectedGroups && role.flatSelectedGroups.toLowerCase().indexOf(ctrl.searchGroup.toLowerCase()) !== -1));
		};


		/**
		 * Filter groups/products which are not already assigned to a role
		 * @param {Group} product 
		 */
		ctrl.filterProducts = function (product) {

			// only return groups with no matches
			return ctrl.roles.filter(function (r) {

				// find matching names
				return r.selectedGroups.map(function (f) { return f.name; }).indexOf(product.name) > -1;
			}).length === 0;

		};

		ctrl.outsideEdit = function (role) {
			ctrl.completeRowEdit(role);
		};
		/**
		 * Save the modifications and go back to users page.
		 */
		ctrl.completeRowEdit = function (role) {

			ctrl.selectedRoles[role.identifier] = role.selectedGroups.length > 0;

			ctrl.updateFlatSelectedGroups(role);
			role.isEditing = false;
			ctrl.save();
		};

		/**
		 * Save the modifications and go back to users page.
		 */
		ctrl.save = function () {

			var listGroups = [];

			var roles = ctrl.roles.filter(function (r) {
				return ctrl.selectedRoles[r.identifier];
			});

			_.forEach(roles, function (v) {
				if (v.selectedGroups && v.selectedGroups.length > 0) {
					_.forEach(v.selectedGroups, function (group) {
						group.roleId = v.identifier;
						listGroups.push(group);
					});
				}
			});

			ctrl.user.userGroups = listGroups;

			if (ctrl.onSave) {
				ctrl.onSave({ user: ctrl.user });
			}
		};

		/**
		 * user's house roles must appear first in the roles list
		 */
		//
		ctrl.userHouseComparator = function (r1, r2) {
			if (r1.value.house === ctrl.user.house) {
				//if role1 and role2 matches the user's house, then we compare them by name (to keep alphabetical order)
				if (r2.value.house === ctrl.user.house) {
					return r1.value.name.localeCompare(r2.value.name);
				}
				//if role1 matches the user's house and role2 doesn't, then we return -1
				return -1;
			}
			//if role2 matches the user's house and role1 doesn't, then we return 1
			else if (r2.value.house === ctrl.user.house) {
				return 1;
			}
			//if none of the roles matches the user's house, then we compare them by name
			else {
				if (r1.value.name && r2.value.name) {
					return r1.value.name.localeCompare(r2.value.name);
				}
				return -1;
			}
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.component('importAffectationsModal', {
			templateUrl: 'scripts/pre-upgrade/components/users/import-affectations-modal/import-affectations-modal.html',
			controller: ImportAffectationsModalController,
			bindings: {
				resolve: '<',
				close: '&'
			},
		});

	/** @ngInject */
	function ImportAffectationsModalController($filter, $state, importAffectationsModalService, userResource, ModalAlertService, blockUI) {
		var ctrl = this;

		ctrl.$onInit = function () {
			ctrl.user = ctrl.resolve.user;
			ctrl.selectedUser = ctrl.resolve.selectedUser;
		};

		ctrl.cancel = function () {
			ctrl.close({ $value: false });
		};


		ctrl.importAffectation = function () {
			blockUI.start();

			importAffectationsModalService.importAffectation(ctrl.user, ctrl.selectedUser)
				.then(function (usr) {
					ctrl.user = usr;
					ctrl.close({ $value: true });

					blockUI.stop();
					//Display success message	
					ModalAlertService.success("'" + $filter('translate')('userApp.user.msg.successmessage') + "'", $filter('translate')('userApp.user.msg.success'), '');
					//Go to the duplicated editorial entity
					$state.go('editUser', {
						id: usr.identifier
					});
				});
		};

		ctrl.searchUserList = function (select) {

			userResource.query({
				house: "",
				filterValue: select.search,
				page: Number(0),
				roleId: Number(0),
				groupId: Number(0),
				sort: "firstName,asc",
				size: Number(0)
			})
				.$promise
				.then(function (data) {

					ctrl.users = data.content;
				});
		};

	}


})();

(function () {
	'use strict';

	angular
		.module('userApp')
		.factory('importAffectationsModalService', ImportAffectationsModalService);


	/** @ngInject */
	function ImportAffectationsModalService(blockUI, entityOperationResource, userResource, userGroupResource, ModalAlertService, $uibModal, $filter, $state, $q) {

		var service = {
			openModal: openModal,
			importAffectation: importAffectation
		};

		return service;

		function openModal(user) {
			blockUI.start();

			var modalInstance = $uibModal.open({
				component: 'importAffectationsModal',
				resolve: {
					user: function () { return user; },
					translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('importAffectation');
						return $translate.refresh();
					}]
				},
				size: 'lg',
				backdrop: 'static'
			});
			modalInstance.opened.then(function () {
				blockUI.stop();
			});

			return modalInstance.result;
		}

		function importAffectation(user, selectedUser) {
			var deferred = $q.defer();
			userResource.get({
				id: selectedUser.identifier
			}).$promise.then(function (data) {
				var selectedUserGroups = data.userGroups;
				user.userGroups = selectedUserGroups;

				userResource.update(user, function () {
					deferred.resolve(user);
				}, function (err) {
					ModalAlertService.error('error', 'Failed', '');
					deferred.reject(err);
				});
			});
			return deferred.promise;
		}

	}
})();

(function () { 
 return angular.module("userApp")
.constant("ENV", "prod")
.constant("VERSION", "3.5.1")
.constant("TAG", "3.5.1")
.constant("BUILD_TIME", "2023-07-04T14:13:34.095Z")
.constant("EDITOR_VERSION", "file:///D:\\dev\\sie-ecm-tiny-editor\\dist\\sie-ecm-tiny-editor-10.6.0.tgz");

})();

angular.module('userApp').run(['$templateCache', function($templateCache) {$templateCache.put('scripts/components/modal/alertModal.html','<div class="modal-header"> <h3>{{modalOptions.headerText}}</h3> </div> <div class="modal-body"> <p>{{modalOptions.bodyText}}</p> </div> <div class="modal-footer"> <button type="button" class="btn" ng-show="{{modalOptions.isConfirm}}" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button> <button class="btn btn-primary" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}}</button> </div>');
$templateCache.put('scripts/components/modalAlert/modalAlert.html','<div class="modal-body" style="padding:0px"> <div class="alert alert-{{data.mode}}" style="margin-bottom:0px"> <button type="button" class="close" data-ng-click="close()"> <span class="glyphicon glyphicon-remove-circle"></span> </button> <strong>{{data.boldTextTitle}}</strong> {{data.textAlert}} </div> </div> ');
$templateCache.put('scripts/components/statusbar/statusbar.html','<div class="statusbar"> <div class="infos env"> Env: {{env}} | Version: {{version}} <span>&nbsp; <small>(tag: {{tag}}, build: {{build_time | ecmDate:\'short\'}})</small> </span> </div> <div class="infos"> <ul class="clearfix"> <li class="lang dropdown" ng-controller="LanguageController" uib-dropdown="" uib-dropdown-toggle="" style="margin-left: -150px;"> {{language}} <ul class="dropdown-menu" uib-dropdown-menu="" style="bottom : 5px;"> <li ng-repeat="language in languages"> <a href="" ng-click="changeLanguage(language)"> {{language | findLanguageFromKey}}</a> </li> </ul> </li> </ul> </div> </div> ');
$templateCache.put('scripts/app/entities/editorialEntity/editorialEntityEdit.html','<div class="header-doc"> <entity-info entity="editorialEntity" current-user="currentUser" permissions="eEpermissions" on-refresh-entity="refreshEntity()"></entity-info> <editorial-entity-edit-menu editorial-entity="editorialEntity" permissions="eEpermissions" current-user="currentUser" meta-data-by-meta-group="metaDataByMetaGroup" switch-display="switchDisplay(display)" open-edit-meta-modal="openEditMetaModal()" on-refresh-entity="refreshEntity()"></editorial-entity-edit-menu> </div> <div class="page-content"> <div ng-if="getCurrentState() === \'editorialEntity\' || getCurrentState() === \'editorialEntity.treeview\'" class="full-height">  <div ng-if="isTree && (displayMode !=\'DISPLAY_LINK_INFOS\' && displayMode !=\'DISPLAY_PUBLISH_HISTORY\' )" style="height: 100%"> <ng-include src="\'scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view.tpl.html\'"> </ng-include> </div> <form action="" ng-if="!isTree && (displayMode !=\'DISPLAY_LINK_INFOS\' && displayMode !=\'DISPLAY_PUBLISH_HISTORY\')"> <div class="flex-cont bg-white listing-w-preview"> <div class="c-resize c-preview" style="padding: 0 1%" ng-if="displayMode !=\'DISPLAY_CONTENT_ONLY\'"> <div ng-if="displayMode==\'DISPLAY_METADATA\' || isDisplayMedia()" style="padding-top:10px"> <ul ng-repeat="metaDataByGrp in metaDataByMetaGroup"> <div class="panel panel-default meta-group"> <div class="panel-heading clearfix"> <h5 class="panel-title">{{metaDataByGrp.metaGroupName}}</h5> <div class="panel-tools" ng-show="editorialEntity.editMetaEnabled && metaDataByGrp.metaGroupName !== \'CALCULEE\'"> <label ng-click="openEditMetaModal(editorialEntity)"> <a href="" uib-tooltip="Editer" tooltip-placement="top" tooltip-append-to-body="true"> <i class="icon ion-edit"></i> </a> </label> </div> </div> <div class="panel-body" style="padding: 5px;"> <div class="col-sm-12 form-horizontal"> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in metaDataByGrp.metaDataInstanceDTOList track by $index" lang="lang" display="true" readonly="true" product-code="editorialEntity.ownerGroup"></meta-data-field> </div> </div> </div> </ul> </div> <div ng-if="displayMode==\'DISPLAY_TOC\'"> <div style="height: calc(100% - 100px); overflow: auto" block-ui="previewUI"> <ecm-preview-html content="trustAsHtml(summaryEE)" ng-if="summaryEE"></ecm-preview-html> <div style="margin-top:10px;text-align:center" translate="userApp.editorialEntity.home.noSummary" ng-if="!summaryEE"></div> </div> </div> </div> <div ng-mousedown="mdDragBar($event)" ng-show="resize" class="resize-bar" ng-if="editorialEntity.editorialEntityTemplate.contentType !=\'REFERENCE\' && displayMode !=\'DISPLAY_CONTENT_ONLY\'"></div> <div id="idDivContenu" ng-style="{ \'flex-basis\': displayMode !=\'DISPLAY_CONTENT_ONLY\' ? \'60%\' : \'100%\'}" ng-show="resize" class="c-resize c-preview resizable no-padding" ng-if="editorialEntity.editorialEntityTemplate.contentType !=\'REFERENCE\'"> <div ng-if="editorialEntity.editorialEntityTemplate.contentType==\'STRUCTUREDTEXT\'" class="full-height"> <editorial-entity-action-bar class="full-action-bar" content-class="action-bar-content" config="actionBarConfig" current-user="currentUser" flash-id="editorialEntity.identifier" on-edit-meta-data="openEditMetaModal(editorialEntity)" on-refresh-preview="updatePreviewFromEntity(editorialEntity.identifier, \'RESTRICTED\')" on-edit-content="openEditor(editorialEntity.identifier)" on-refresh-page="refreshEntity()" preview-html="editorialEntity.restrictedHtmlPreview"> <div style="height: 100%" block-ui="previewUI"> <ecm-preview-html content="trustAsHtml(editorialEntity.restrictedHtmlPreview)"> </ecm-preview-html> </div> </editorial-entity-action-bar> </div>  <div ng-if="editorialEntity.editorialEntityTemplate.contentType===\'MEDIA\'" class="full-height">   <media-edition-form editorial-entity="editorialEntity" permissions="eEpermissions"> </media-edition-form>  </div> </div> </div> </form> </div> <div class="editorial-entity-content" ui-view="editorialEntityContent" ng-if="getCurrentState() !== \'editorialEntity\' && getCurrentState() !== \'editorialEntity.treeview\'"> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/announcements/announcement.html','<div ng-repeat="announcement in $ctrl.announcements" id="announcements_{{$index}}" class="ecm-notify"> <div ng-switch="announcement.severity"> <div ng-switch-default="" class="note note-info"> <span class="image"> <i class="fa fa-info"></i> </span> <div class="content">{{ announcement.message }}</div> </div> <div ng-switch-when="warning" class="note note-warning"> <span class="image"> <i class="fa fa-warning"></i> </span> <div class="content">{{ announcement.message }}</div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/bulkoperations/bulkoperations.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <h2> <span translate="userApp.bulkoperations.home.title"></span> </h2> <span>{{ \'userApp.bulkoperations.home.lastUpdateDate\' | translate}} {{ $ctrl.lastUpdateDate | ecmDate:\'short\' }}</span> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <div class="clearfix"> <div class="pull-right"> <button class="btn btn-primary" tooltip-placement="bottom" uib-tooltip="{{\'userApp.bulkoperations.home.refreshButton\' | translate}}" aria-label="userApp.bulkoperations.home.refreshButton" ng-click="$ctrl.refresh()"> <span class="glyphicon glyphicon-refresh"></span> <span translate="userApp.bulkoperations.home.refreshButton"></span> </button> <button class="btn btn-primary" tooltip-placement="bottom" uib-tooltip="{{\'userApp.bulkoperations.home.replayKoOperationsButton\' | translate}}" aria-label="userApp.bulkoperations.home.replayKoOperationsButton" ng-disabled="!$ctrl.existsResultInOperations($ctrl.operations, \'KO\')" ng-click="$ctrl.replayFailedOperations()"> <span class="glyphicon glyphicon-play"></span> <span translate="userApp.bulkoperations.home.replayKoOperationsButton"></span> </button> <button class="btn btn-primary" tooltip-placement="bottom" uib-tooltip="{{\'userApp.bulkoperations.home.purgeOkOperationsButton\' | translate}}" aria-label="userApp.bulkoperations.home.purgeOkOperationsButton" ng-disabled="!$ctrl.existsResultInOperations($ctrl.operations, \'OK\')" ng-click="$ctrl.purgeOperations(\'OK\')"> <span class="glyphicon glyphicon-remove"></span> <span translate="userApp.bulkoperations.home.purgeOkOperationsButton"></span> </button> <button class="btn btn-primary" tooltip-placement="bottom" uib-tooltip="{{\'userApp.bulkoperations.home.purgeFailedOperationsButton\' | translate}}" aria-label="userApp.bulkoperations.home.purgeFailedOperationsButton" ng-disabled="!$ctrl.existsResultInOperations($ctrl.operations, \'KO\')" ng-click="$ctrl.purgeOperations(\'KO\')"> <span class="glyphicon glyphicon-remove"></span> <span translate="userApp.bulkoperations.home.purgeFailedOperationsButton"></span> </button> </div> </div>  <form class="ecm-filter-zone"> <div class="form-group form-group-sm"> <label translate="userApp.bulkoperations.home.operationDate"></label> <ecm-datepicker show-operator="false" ng-model="$ctrl.operationDateFilter" model-type="\'RANGE\'" on-start-date-change="$ctrl.loadAllBulkOperations()"></ecm-datepicker> </div> <div class="form-group form-group-sm"> <label translate="userApp.bulkoperations.home.useCase"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'useCase\']" ng-change="$ctrl.loadAllBulkOperations()" ng-options="val | translate for val in $ctrl.useCaseFilterList"> <option value=""></option> </select> </div> </form>  <div ng-if="$ctrl.pagination.totalCount > 0"> <span translate="userApp.bulkoperations.home.totalResult" translate-values="{numberResult:$ctrl.pagination.totalCount}"></span> </div> <table st-pipe="$ctrl.loadTable" st-table="$ctrl.operations" st-set-sort="betterOrderBy" st-set-filter="StrictFilter" class="table table-striped table-bordered table-hover"> <thead> <tr> <th style="width:10%" class="sortable" st-sort="useCase" translate="userApp.bulkoperations.home.useCase"> </th> <th style="width: 20%" class="sortable" st-sort="size" translate="userApp.bulkoperations.home.size"> </th> <th style="width: 20%" class="sortable" st-sort="statusDetails" translate="userApp.bulkoperations.home.status"> </th> <th style="width: 20%" class="sortable" st-sort="operationDate" translate="userApp.bulkoperations.home.operationDate"> </th> <th style="width: 20%" translate="userApp.bulkoperations.home.operationResult"> </th> <th style="width: 10%"> </th> </tr> </thead> <tbody> <tr ng-if="$ctrl.operations.length===0"> <td colspan="6" class="text-center"> <span translate="userApp.bulkoperations.home.NoData"></span> </td> </tr> <tr ng-repeat="row in $ctrl.operations"> <td> {{row.request.useCase | translate}} </td> <td> {{row.resultDetails.length}} </td> <td> {{$ctrl.operationStatus(row) | translate}} </td> <td>{{row.request.operationDate | ecmDate:\'short\' }}</td> <td> <span translate="userApp.bulkoperations.home.detailedResult" translate-values="{ok:$ctrl.okOperationsSize(row), ko: $ctrl.failedOperationsSize(row), inProgress:$ctrl.inProgressOperationsSize(row)}"></span> </td> <td> <span class="glyphicon glyphicon-download-alt" ng-click="$ctrl.downloadLogs(row.logs, row.request.bulkOperationId)"></span> </td> </tr> </tbody> </table>  <div class="text-left"> <ecm-pagination pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllBulkOperations()"></ecm-pagination> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/batch/batch.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <h2> <span translate="userApp.batch.home.title"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-7 col-md-7 col-centered bg-white listing-w-preview"> <div class="alert alert-danger"> <h5> <strong> <p class="text-danger" translate="userApp.batch.home.warning"></p> </strong> <p class="text-danger" translate="userApp.batch.home.warningMessage" translate-values="{login: \'{{$ctrl.currentUser.login}}\'}"></p> <p class="text-danger" translate="userApp.batch.home.solrIndexationWarning"></p> </h5> </div>  <form name="executeBatchForm" class="form-horizontal"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.batch.home.jobName"></span> </label> </div> <div class="col-sm-4"> <select class="form-control" style="width:auto" ng-model="$ctrl.selectedBatchConfig" ng-options="batchConfig as batchConfig.batchName | translate for batchConfig in $ctrl.allConfigs"> <option value=""></option> </select> </div> </div>  <parameter batch-parameter="batchParameter" ng-repeat="batchParameter in $ctrl.selectedBatchConfig.batchParameters"></parameter>  <div class="clearfix"> <div class="pull-left"> <button type="submit" class="btn btn-primary" tooltip-placement="bottom" aria-label="userApp.batch.home.executeButton" ng-click="$ctrl.requestBatchProcess()" ng-disabled="executeBatchForm.$invalid" ng-if="$ctrl.selectedBatchConfig"> <span class="glyphicon glyphicon-play"></span> <span translate="userApp.batch.home.executeButton"></span> </button> </div> </div> </form> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/configuration/configuration.html','<div class="header-filter"> <div class="btn-c clearfix"> <div class="pull-left"> <h2> <span translate="userApp.configuration.home.title"></span> </h2> <h6> <b> <span translate="userApp.configuration.home.version"></span> </b> <span>{{$ctrl.currentConfiguration.version}}</span> &nbsp;&nbsp; <b> <span translate="userApp.configuration.home.creation_date"></span> </b> <span>{{$ctrl.currentConfiguration.creationDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</span> &nbsp; &nbsp; <b> <span translate="userApp.configuration.home.description" ng-show="currentConfiguration.description"></span> </b> <span>{{$ctrl.currentConfiguration.description}}</span> </h6> </div> <div class="pull-right"> <button type="button" class="btn btn-primary" ng-click="$ctrl.ImportConf()"> <span translate="userApp.configuration.home.importConf"></span> </button> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row"> <div class="col-lg-6 col-md-12 col-centered listing-w-preview"> <h2> <span translate="userApp.erm.home.title"></span> </h2> <div class="panel panel-default"> <div class="panel-body"> <b> <span translate="userApp.erm.home.listOfVersion"> </span> </b> <select ng-model="$ctrl.selectedVersion" ng-options="version for version in $ctrl.activeVersions"> <option value="" label="-- Select version --" selected="selected"> </option></select> <button type="button" class="btn btn-primary" ng-click="$ctrl.saveVersion()">Save</button> <br> <br> <div ng-show="$ctrl.currentVersion"> <b> <span translate="userApp.erm.home.currentVersion"></span> </b> <span>{{$ctrl.currentVersion}}</span> &nbsp;&nbsp; </div> </div> </div> <h2> <span translate="userApp.editor.home.title"></span> </h2> <div class="panel panel-default"> <div class="panel-body"> <b> <span translate="userApp.erm.home.currentVersion"></span> </b> <span>{{$ctrl.editorVersion}}</span> </div> </div> <h2> <span>D\xE9pliage automatique</span> </h2> <div class="panel panel-default"> <div class="panel-body"> <div class="row"> <div class="col-sm-6"> <b>Niveau max d\xE9pliage automatique de l\'arbre:</b> </div> <div class="col-sm-4"> <input ng-change="$ctrl.maxAutoExpandChange()" ng-model="$ctrl.maxAutoExpandLevel" type="number"> </div> </div> <div class="row"> <div class="col-sm-6"> <b>Requ\xEAtes simultan\xE9es max:</b> </div> <div class="col-sm-4"> <input ng-change="$ctrl.maxConcurrentRequestsChanged()" ng-model="$ctrl.maxConcurrentRequests" type="number"> </div> </div> </div> </div> <h2> <span translate="userApp.announcements.title"></span> </h2> <div class="panel panel-default"> <div class="panel-body"> <div class="row"> <div class="col-sm-6"> <textarea ng-maxlength="255" ng-model="$ctrl.announcementMessage" style="overflow:auto;resize:none" cols="40" rows="3"></textarea> </div> <div class="col-sm-4"> <div class="row"> <button type="button" class="btn btn-primary pull-right" ng-disabled="!$ctrl.announcementMessage" ng-click="$ctrl.saveAnnouncement()">Save</button> </div> <br> <div class="row"> <button type="button" class="btn btn-primary pull-right" ng-disabled="!$ctrl.currentAnnouncement" ng-click="$ctrl.deleteAllAnnouncements()">Delete</button> </div> </div> </div> </div> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/home/home.html','<div class="home-container"> <div class="header-filter"> <div class="home-title"> <h2> <span translate="home.welcome" translate-values="{ name: $ctrl.userName }"></span> </h2> </div> <div class="home-help" uib-tooltip="{{\'home.help\' | translate}}" tooltip-placement="bottom"> <i class="fa fa-question"></i> </div> </div> <div class="home-body"> <div class="home-flex-container"> <div class="my-groups-container"> <my-groups></my-groups> </div> <div class="my-work-container"> <div class="panel panel-default"> <div class="panel-heading"> <h5 class="panel-title"> <span translate="home.myworksTitle" translate-values="{nb: $ctrl.myWorkAdapter.pagination.itemByPage, total:$ctrl.myWorkAdapter.pagination.totalCount, MORE:$ctrl.isMore($ctrl.myWorkAdapter.pagination)}" translate-interpolation="messageformat"></span> <a ng-if="$ctrl.myWorkAdapter.pagination.totalCount > $ctrl.myWorkAdapter.pagination.itemByPage" class="see-all" ui-sref="mywork" translate="home.showAll"></a> </h5> </div> <div class="panel-body"> <my-work table-id="\'MyWorkTableHome\'" current-user="$ctrl.currentUser" get-adapter="$ctrl.setAdapter(adapter)" on-row-selected="$ctrl.showPreview(row)" display-mode="\'LIGHT\'"></my-work> </div> </div> </div> </div> <closeable-html-preview preview="$ctrl.preview" mode="full" on-refresh-page="$ctrl.reload()" on-close="$ctrl.myWorkPreviewClose()"> </closeable-html-preview></div> </div>');
$templateCache.put('scripts/pre-upgrade/components/in-progress-instances/in-progress-instances.html','<div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <table id="{{$ctrl.tableId}}" st-pipe="$ctrl.loadTable" ecm-ultimate-table="static" st-table="$ctrl.entities" st-set-sort="betterOrderBy" st-set-filter="StrictFilter" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="icon-column-2x" no-drag="" no-resize=""> </th> <th class="col-sm-4" translate="userApp.travaux.wording"> </th> <th translate="userApp.travaux.authors"></th> <th translate="userApp.travaux.change"></th> <th translate="userApp.travaux.booking"></th> <th translate="userApp.travaux.status"></th> <th translate="userApp.travaux.availability"></th> </tr> </thead> <tbody> <tr class="sidebar-open" role="button" ng-click="$ctrl.rowSelected(row)" ng-dblclick="$ctrl.navigateToEE(row.identifier)" ng-class="{\'st-selected\': $ctrl.isEESelected(row.identifier)}" ng-repeat="row in $ctrl.entities"> <td class="text-ellipsis icon-column"> <a style="cursor: pointer" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ui-sref="editorialEntity({ id: row.identifier})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.wording )"> <span ng-bind-html="$ctrl.trustAsHtml( row.wording | validName )"> </span> </td> <td uib-tooltip="{{ row.authors.join() }} {{row.creationDate !=null ? \'le\' :\' \' }} {{ row.creationDate | ecmDate | translate }}"> {{ row.authors.join() }} {{row.creationDate !=null ? \'le\' :\' \' }} {{ row.creationDate | ecmDate | translate }}</td> <td uib-tooltip="{{ row.modifier }} {{row.lastModificationDate !=null ? \'le\' :\' \' }} {{row.lastModificationDate | ecmDate:\'short\' | translate}}">{{ row.modifier }} {{row.lastModificationDate !=null ? \'le\' :\' \' }} {{row.lastModificationDate | ecmDate:\'short\' | translate}}</td> <td uib-tooltip="{{ row.assignmentRole}}"> {{ row.assignmentRole}} </td> <td uib-tooltip="{{row.status | translate}}">{{row.status | translate}}</td> <td> <padlock-icon color="row.padlock.color" closed="row.padlock.closed" owner="row.padlock.owner.fullName" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.entities.length === 0"> <td colspan="7" class="text-center"> <span translate="userApp.travaux.noData"></span> </td> </tr> </tfoot> </table>  <div class="text-left" ng-if="!$ctrl.hidePagination"> <ecm-pagination storage-key="{{$ctrl.getStorageKey(true)}}" pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllee()"></ecm-pagination> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/mass-operation/mass-operation-container.component.html','<select ng-disabled="$ctrl.getSelectedEE().length < 1" ng-class="{\'disabled-node\' :$ctrl.getSelectedEE().length < 1 }" ng-model="$ctrl.selectedAction" ng-options="a.value as a.name | translate for a in $ctrl.actionList"> <option value=""> {{\'userApp.searchInterfaceTemplate.menuAction.SelectAction\' | translate}} </option> </select> <button ng-disabled="$ctrl.getSelectedEE().length < 1 || !$ctrl.selectedAction" type="button" class="btn btn-primary btn-xs action-btn" translate="APPLY" ng-click="$ctrl.applyAction($ctrl.selectedAction)"></button> ');
$templateCache.put('scripts/pre-upgrade/components/login/login.html','<div class="wrapper-login">  <img class="bg-login" src="assets/images/bg_login.jpg" alt="">  <img class="login-overlay" src="assets/images/o50.png" alt=""> <login-form-component></login-form-component> <span class="login-version">Env: {{$ctrl.environnement}} | Version: {{$ctrl.version}} <span>&nbsp; <small>(tag: {{$ctrl.tag}}, build: {{$ctrl.build_time | ecmDate:\'short\'}})</small> </span> </span> </div> ');
$templateCache.put('scripts/pre-upgrade/components/metadata/display-meta-values.html','<span class="ecm-display-meta-zone" ng-if="$ctrl.canDisplay(metadata)" ng-repeat="metadata in $ctrl.metadataList"> <span ng-if="!metadata.multipleOccurrences && metadata.value && metadata.metaDataDTO.metaDataType !== \'LIST\'" class="ecm-display-meta"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span>  <span class="ecm-display-meta-value">{{(metadata.value==\'true\' ? \'global.metadata.booleanValue.yes\' : metadata.value==\'false\' ? \'global.metadata.booleanValue.no\' : metadata.value | translate | ecmDate:\'short\')}}</span> </span> <span ng-if="!metadata.multipleOccurrences && metadata.value && metadata.metaDataDTO.metaDataType === \'LIST\'" class="ecm-display-meta"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value">{{$ctrl.getMetaValueFromList(metadata)}}</span> </span> <span class="ecm-display-meta" ng-if="metadata.multipleOccurrences && metadata.metaDataMultiValuesList != null && metadata.metaDataMultiValuesList.length > 0"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value" ng-repeat="elm in metadata.metaDataMultiValuesList"> {{ elm.wording + ($last ? \'\' :\',\')}} </span> </span> <span class="ecm-display-meta" ng-if="metadata.multipleOccurrences && metadata.multiValuesList != null && metadata.multiValuesList.length > 0"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value" ng-repeat="value in metadata.multiValuesList"> {{ value.text + ($last ? \'\' :\',\')}} </span> </span> <span class="ecm-display-meta" ng-if="!metadata.referentialTypeListDTOList != null && metadata.referentialTypeListDTOList.length > 0 && !metadata.multipleOccurrences"> <span ng-repeat="metadataList in metadata.referentialTypeListDTOList"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value">{{lang==\'fr\' ? metadataList.labelFR : metadataList.labelEN }}</span> </span> </span> <span class="ecm-display-meta" ng-if="metadata.multipleOccurrences && !metadata.referentialTypeListDTOList != null && metadata.referentialTypeListDTOList.length > 0"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value" ng-repeat="metadataList in metadata.referentialTypeListDTOList"> {{lang==\'fr\' ? metadataList.labelFR + ( $last ? \'\' :\',\' ) : metadataList.labelEN + ( $last ? \'\' :\',\' )}} </span> </span> <span class="ecm-display-meta" ng-if="!metadata.listDisplayPathForNode != null && metadata.listDisplayPathForNode.length > 0"> <span class="ecm-display-meta-label">{{metadata.metaDataDTO.name}}: </span> <span class="ecm-display-meta-value" ng-repeat="metadataList in metadata.listDisplayPathForNode"> {{metadataList.path + ($last ? \'\' :\',\')}} </span> </span> </span> ');
$templateCache.put('scripts/pre-upgrade/components/monitoring/monitoring.html','<div class="header-filter"> <div class="btn-c clearfix"> <div class="pull-left"> <h2> <span translate="userApp.monitoring.labels.title"></span> </h2> </div> <div class="pull-right"> <span>{{ \'userApp.monitoring.labels.lastUpdateDate\' | translate}}&nbsp;:&nbsp;{{ $ctrl.lastUpdateDate | ecmDate:\'short\' }} </span> <button type="button" class="btn btn-default" ng-click="$ctrl.getAppsHealth()"> <i class="fa fa-refresh" aria-hidden="true">&nbsp;&nbsp; <span translate="userApp.monitoring.labels.refresh"></span> </i> </button> </div> </div> </div> <div block-ui="monitoringUi" class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview"> <ul ng-repeat="app in $ctrl.apps"> <app-health app="app"></app-health> </ul> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/my-trash/my-trash.component.html','<div class="header-filter"> <div class="btn-c clearfix"> <div class="pull-left"> <h2> <span translate="userApp.trash.home.title"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid my-work-page"> <my-trash-main-component current-user="$ctrl.currentUser" get-adapter="$ctrl.setAdapter(adapter)" on-row-selected="$ctrl.showPreview(row)"></my-trash-main-component> <closeable-html-preview from-trush="true" preview="$ctrl.preview" mode="full" on-refresh-page="$ctrl.reload()" on-close="$ctrl.closePreview()"></closeable-html-preview> </div>');
$templateCache.put('scripts/pre-upgrade/components/mywork/my-work.html','<div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <form ng-if="$ctrl.displayMode != \'LIGHT\' && $ctrl.displayMode != \'GROUP\'" class="ecm-filter-zone"> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.creators && $ctrl.allFilters.creators.length>0"> <label translate="userApp.travaux.creation"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.creatorLogin" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value for val in $ctrl.allFilters.creators"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.authors && $ctrl.allFilters.authors.length>0"> <label translate="userApp.travaux.authors"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.authorLogin" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value for val in $ctrl.allFilters.authors"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.modifiers && $ctrl.allFilters.modifiers.length>0"> <label translate="userApp.travaux.change"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.modifierLogin" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value for val in $ctrl.allFilters.modifiers"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.assignmentRoles &&$ctrl.allFilters.assignmentRoles.length>0"> <label translate="userApp.travaux.booking"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.assignmentRoleCode" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.assignmentRoles"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.initiators && $ctrl.allFilters.initiators.length>0"> <label translate="userApp.travaux.initiateur"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.initiatorLogin" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.initiators"> <option value="" translate="global.all"></option> </select> </div> <div ng-if="$ctrl.displayMode != \'GROUP\'" class="form-group form-group-sm"> <label translate="userApp.travaux.ownerGroup"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.ownerGroupCode" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.ownerGroups"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.status && $ctrl.allFilters.status.length>0"> <label translate="userApp.travaux.status"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.statusId" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.status"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.editorialTemplates && $ctrl.allFilters.editorialTemplates.length>0"> <label translate="userApp.travaux.tee"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.eetCode" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.editorialTemplates"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.lockers && $ctrl.allFilters.lockers.length>0"> <label translate="userApp.travaux.availability"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchFilters.lockerLogin" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.lockers"> <option value="" translate="global.all"></option> </select> </div> </form> <table id="{{$ctrl.tableId}}" st-pipe="$ctrl.loadTable" ecm-ultimate-table="static" st-table="$ctrl.entities" st-set-filter="StrictFilter" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="icon-column-2x" no-drag="" no-resize=""> </th> <th class="sortable" st-sort="systemTitle" translate="userApp.travaux.wording"> </th> <th class="sortable" st-sort="eetCode" translate="userApp.travaux.tee"></th> <th class="sortable" st-sort="systemCreationDate" translate="userApp.travaux.creation" ng-if="$ctrl.displayMode != \'GROUP\' && $ctrl.displayMode != \'LIGHT\'"></th> <th class="sortable" st-sort="systemAuthors" translate="userApp.travaux.authors"></th> <th class="sortable" st-sort="systemLastUpdateDate" translate="userApp.travaux.change"></th> <th translate="userApp.travaux.booking"></th> <th translate="userApp.travaux.initiateur" ng-if="$ctrl.displayMode != \'GROUP\'"></th> <th class="sortable" st-sort="systemOwnerGroup" translate="userApp.travaux.ownerGroup" ng-if="$ctrl.displayMode != \'GROUP\'"></th> <th translate="userApp.travaux.status"></th> <th class="sortable" st-sort="systemLocker" translate="userApp.travaux.availability"></th> </tr> </thead> <tbody> <tr class="sidebar-open" role="button" ng-click="$ctrl.rowSelected(row)" ng-dblclick="$ctrl.navigateToEE(row.identifier)" ng-class="{\'st-selected\': $ctrl.isEESelected(row.identifier)}" ng-repeat="row in $ctrl.entities"> <td class="text-ellipsis icon-column"> <a style="cursor: pointer" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ui-sref="editorialEntity({ id: row.identifier})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.titleSystem )"> <span ng-bind-html="$ctrl.trustAsHtml( row.titleSystem | validName )"> </span> </td> <td uib-tooltip="{{row.eetName}}">{{row.eetName}}</td> <td uib-tooltip="{{ row.creator }} {{row.creationDate !=null ? \'le\' :\' \' }} {{ row.creationDate | ecmDate | translate }}" ng-if="$ctrl.displayMode != \'GROUP\' && $ctrl.displayMode != \'LIGHT\'"> {{ row.creator }} {{row.creationDate !=null ? \'le\' :\' \' }} {{ row.creationDate | ecmDate | translate }}</td> <td uib-tooltip="{{ row.systemAuthors.join() }}"> {{ row.systemAuthors.join() }} </td> <td uib-tooltip="{{ row.updater }} {{row.updateDate !=null ? \'le\' :\' \' }} {{row.updateDate | ecmDate:\'short\' | translate}}"> {{ row.updater }} {{row.updateDate !=null ? \'le\' :\' \' }} {{row.updateDate | ecmDate:\'short\' | translate}} </td> <td uib-tooltip="{{ row.assignmentRole}}"> {{ row.assignmentRole}}</td> <td uib-tooltip="{{ row.initiator }}" ng-if="$ctrl.displayMode != \'GROUP\'"> {{ row.initiator }}</td> <td uib-tooltip="{{row.ownerGroupName | translate}}" ng-if="$ctrl.displayMode != \'GROUP\'">{{row.ownerGroupName | translate}}</td> <td uib-tooltip="{{row.workflowStatus | translate}}">{{row.workflowStatus | translate}}</td> <td> <padlock-icon color="row.padlock.color" closed="row.padlock.closed" owner="row.padlock.owner.fullName" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.entities.length==0"> <td colspan="{{$ctrl.displayMode === \'GROUP\' ? \'10\' : \'11\' }}" class="text-center"> <span translate="userApp.travaux.noData"></span> </td> </tr> </tfoot> </table>  <div ng-if="!$ctrl.hidePagination && $ctrl.displayMode != \'LIGHT\'" class="text-left"> <ecm-pagination storage-key="{{$ctrl.getStorageKey(true)}}" pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllee()"></ecm-pagination> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/mywork/mywork-page.html','<div class="header-filter"> <div class="btn-c clearfix"> <div class="pull-left"> <h2> <span translate="userApp.travaux.works"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid my-work-page"> <my-work current-user="$ctrl.currentUser" get-adapter="$ctrl.setAdapter(adapter)" on-row-selected="$ctrl.showPreview(row)"></my-work> <closeable-html-preview preview="$ctrl.preview" mode="full" on-refresh-page="$ctrl.reload()" on-close="$ctrl.myWorkPreviewClose()"></closeable-html-preview> </div> ');
$templateCache.put('scripts/pre-upgrade/components/navbar/navbar.component.html','<nav class="navbar navbar-default"> <div class="container-fluid"> <div class="tb clearfix">  <navbar-create-entity current-user="$ctrl.currentUser"></navbar-create-entity> <div>  <navbar-account></navbar-account> </div> </div> </div> </nav> ');
$templateCache.put('scripts/pre-upgrade/components/pins/pins.html','<div> <div> <div> <ul class="tabs list-unstyled"> <li class="active"><a href="" translate="main.pins"></a></li> </ul> <div class="table table-condensed table-bordered table-striped" style="height: 600px;">NOT IMPLEMENTED YET!</div> <div class="statusbar"></div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/product-dashboard/product-dashboard.html','<div class="product-dashboard-head" style="border-bottom: 0"> <div class="btn-c clearfix"> <div class="pull-left" style="display: flex"> <div class="info-logo" ng-if="$ctrl.hasLogo"> <img ng-src="{{$ctrl.logoPath}}" alt=""> </div> <div> <h2> <span translate="productDashboard.pageTitle"></span> {{$ctrl.userGroup.name}} </h2> </div> </div> </div> </div> <div class="page-content simple-layout container-fluid product-dashboarb-sb-container"> <div class="product-dashboard-main"> <div ng-if="$ctrl.userGroup.typology !== \'NEWS\'" class="panel panel-default my-work-panel"> <div class="panel-heading"> <h5 class="panel-title"> <span translate="productDashboard.currentInstancesTitle"></span> </h5> </div> <div class="panel-body"> <in-progress-instances table-id="\'InProgressTable_\'+$ctrl.userGroup.code" get-adapter="$ctrl.setAdapter(\'inProgress\', adapter)" on-row-selected="$ctrl.show(\'inProgress\', row)" display-mode="\'GROUP\'" user-group="$ctrl.userGroup.code" hide-pagination="true" page-size="$ctrl.inProgressPageSize"></in-progress-instances> </div> </div>  <product-entity ng-if="$ctrl.userGroup.typology === \'NEWS\' && $ctrl.showProposals" is-news="$ctrl.userGroup.typology === \'NEWS\'" class="my-work-panel" is-proposals="true" association-status="WAITING" publication-filter="" table-id="\'ProductEntity_WAITING_\'+$ctrl.userGroup.code" get-adapter="$ctrl.setAdapter(\'proposals\', adapter)" on-row-selected="$ctrl.show(\'proposals\', row)" user-group="$ctrl.userGroup.code" hide-pagination="true" page-size="$ctrl.entityWaitingForProductAcceptance"> </product-entity>  <product-entity ng-if="$ctrl.userGroup.typology === \'NEWS\'" is-news="$ctrl.userGroup.typology === \'NEWS\'" class="my-work-panel" association-status="VALID" publication-filter="TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED" table-id="\'ProductEntity_TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED_\'+$ctrl.userGroup.code" get-adapter="$ctrl.setAdapter(\'lastPublished\', adapter)" on-row-selected="$ctrl.show(\'lastPublished\', row)" user-group="$ctrl.userGroup.code" hide-pagination="true" page-size="$ctrl.newEntityToPublishAgainSize" sort-string="\'associationSystem.systemPublicationDate\'"></product-entity> <div class="panel panel-default my-work-panel"> <div class="panel-heading"> <h5 class="panel-title"> <span ng-show="$ctrl.hideWorkTablePagination" translate="productDashboard.myworksTitle" translate-values="{ nb:$ctrl.adapters.myWork.pagination.itemByPage, total:$ctrl.adapters.myWork.pagination.totalCount, group: $ctrl.userGroup.name, MORE:$ctrl.isMore($ctrl.adapters.myWork.pagination)}" translate-interpolation="messageformat"></span> <span ng-hide="$ctrl.hideWorkTablePagination" translate="productDashboard.allWorks"></span> </h5> <span ng-show="$ctrl.adapters.myWork.pagination.totalCount > 10"> &nbsp;<strong><a style="cursor: pointer;" translate="home.{{$ctrl.hideWorkTablePagination ? \'showAll\' : \'onlyLastTenOnes\'}}" ng-click="$ctrl.showOrHideWorkAll()"></a> </strong> </span> </div> <div class="panel-body"> <my-work table-id="\'MyWorkTable_\'+$ctrl.userGroup.code" current-user="$ctrl.currentUser" get-adapter="$ctrl.setAdapter(\'myWork\', adapter)" on-row-selected="$ctrl.show(\'myWork\', row)" display-mode="\'GROUP\'" user-group="$ctrl.userGroup.code" hide-pagination="$ctrl.hideWorkTablePagination" page-size="$ctrl.myWorkPageSize"></my-work> </div> </div> </div> <closeable-html-preview preview="$ctrl.currentPreview" mode="full" on-refresh-page="$ctrl.reload()" on-close="$ctrl.close()" product-code="$ctrl.userGroup.code"></closeable-html-preview> </div>');
$templateCache.put('scripts/pre-upgrade/components/product-entity/product-entity.html','<div ng-show="($ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\') || (($ctrl.publicationFilter === \'TO_BE_PUBLISHED\' || $ctrl.publicationFilter === \'TO_BE_REPUBLISHED\') && $ctrl.entities.length !== 0) || ($ctrl.publicationFilter === \'\' && $ctrl.entities.length !== 0)" class="panel panel-default"> <div class="panel-heading"> <h5 class="panel-title"> <span ng-show="$ctrl.publicationFilter === \'\'" translate="productDashboard.proposals"></span> <span ng-show="$ctrl.publicationFilter === \'TO_BE_PUBLISHED\'" translate="productDashboard.contentsWaitingForPublicationTitle"></span> <span ng-show="$ctrl.publicationFilter === \'TO_BE_REPUBLISHED\'" translate="productDashboard.contentsToPublishAgainTitle"></span> <span ng-show="$ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\' && $ctrl.hidePagination && $ctrl.pagination.totalCount > 10" translate="productDashboard.tenLastPublicationsTitle" translate-values=\'{ nb: "10"}\'></span> <span ng-show="$ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\' && (!$ctrl.hidePagination || $ctrl.pagination.totalCount <= 10)" translate="productDashboard.allPublicationsTitle"></span> </h5> <span ng-show="$ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\' && $ctrl.pagination.totalCount > 10"> &nbsp;<strong><a style="cursor: pointer;" translate="home.{{$ctrl.hidePagination ? \'showAll\' : \'onlyLastTenOnes\'}}" ng-click="$ctrl.showOrHideAll()"></a></strong> </span> </div> <div class="panel-body"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview"> <table id="{{$ctrl.tableId}}" ecm-ultimate-table="" st-table="$ctrl.display" set-sort="betterOrderBy" st-safe-src="$ctrl.entities" st-set-filter="StrictFilter" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="icon-column-2x" no-drag="" no-resize=""> </th> <th class="col-sm-4 sortable" st-sort="titleSystem" translate="userApp.travaux.wording"> </th> <th class="col-sm-4 sortable" st-sort="eetName" translate="userApp.travaux.tee"> </th> <th ng-if="!$ctrl.isProposals && !$ctrl.isNews" class="sortable" st-sort="workflowStatus" translate="userApp.travaux.status"></th> <th ng-if="$ctrl.publicationFilter === \'TO_BE_REPUBLISHED\'" translate="userApp.travaux.change"></th> <th ng-if="$ctrl.publicationFilter === \'TO_BE_PUBLISHED\'" translate="userApp.travaux.suggestedPublication"></th> <th ng-if="$ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\'" translate="userApp.travaux.publication"></th> <th translate="userApp.travaux.metaDataInstances"></th> <th ng-if="!$ctrl.isProposals" class="sortable" st-sort="padlock.owner.fullName" translate="userApp.travaux.availability"></th> <th ng-if="$ctrl.isProposals" translate="userApp.travaux.productAllowedActions"></th> </tr> </thead> <tbody> <tr class="sidebar-open" role="button" ng-click="$ctrl.rowSelected(row)" ng-dblclick="$ctrl.navigateToEE(row.identifier)" ng-class="{\'st-selected\': $ctrl.isEESelected(row.identifier), \'disabled\': row.associationStatus === \'DELETED\'}" ng-repeat="row in $ctrl.display"> <td class="text-ellipsis icon-column"> <a style="cursor: pointer" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ui-sref="editorialEntity({ id: row.identifier})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.titleSystem )"> <span ng-bind-html="$ctrl.trustAsHtml( row.titleSystem | validName )"> </span> </td> <td uib-tooltip="{{row.eetName}}">{{row.eetName}}</td> <td ng-if="!$ctrl.isProposals && !$ctrl.isNews" uib-tooltip="{{row.workflowStatus | translate}}">{{row.workflowStatus | translate}} </td> <td ng-if="$ctrl.publicationFilter === \'TO_BE_REPUBLISHED\'" uib-tooltip="{{ row.updater }} {{row.updateDate !=null ? \'le\' :\' \' }} {{row.updateDate | ecmDate:\'short\' | translate}}">{{ row.updater }} {{row.updateDate !=null ? \'le\' :\' \' }} {{row.updateDate | ecmDate:\'short\' | translate}}</td> <td ng-if="$ctrl.publicationFilter === \'TO_BE_PUBLISHED\'" uib-tooltip="{{row.associationSystem.systemSuggestedPublicationDate | ecmDate | translate}}">{{row.associationSystem.systemSuggestedPublicationDate | ecmDate | translate}}</td> <td ng-if="$ctrl.publicationFilter === \'TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED\'" uib-tooltip="{{row.associationSystem.systemPublicationDate | ecmDate | translate}}">{{row.associationSystem.systemPublicationDate | ecmDate | translate}}</td> <td> <div style="display: flex"> <display-product-group-meta class="display-product-meta-inline" product="row" metadata-list="row.metaDataInstances" hide-suggested-publication-date="$ctrl.publicationFilter === \'TO_BE_PUBLISHED\'"></display-product-group-meta> <div style="padding-left: 5px"> <i class="pull-right icon ion-edit" tooltip-placement="bottom" uib-tooltip="{{\'EDIT_META\'|translate}}" aria-hidden="true" ng-if="row.editMetaPermitted && $ctrl.isProposals" ng-click="$ctrl.openEditMetaModal(row.associationFlashId, row.ownerGroupName, $event)"></i> </div> </div> </td> <td ng-if="!$ctrl.isProposals"> <padlock-icon color="row.padlock.color" closed="row.padlock.closed" owner="row.padlock.owner.fullName" size="small"> </padlock-icon> </td> <td ng-if="$ctrl.isProposals" class="ecm-modal-action-links"> <product-actions-bar permitted-actions="row.permittedActions" association-flash-id="row.associationFlashId" on-refresh="$ctrl.refreshProposals()" product-name="row.ownerGroupName" product-code="row.associationProductCode" entity-flash-id="row.identifier" entity-title="row.titleSystem" eet-code="row.eetCode" metas-association="row.metaDataInstances" from-product-entity="true"> </product-actions-bar> </td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.entities.length==0"> <td colspan="6" class="text-center"> <span translate="userApp.travaux.noData"></span> </td> </tr> </tfoot> </table>  <div ng-if="!$ctrl.hidePagination && $ctrl.displayMode != \'LIGHT\'" class="text-left"> <ecm-pagination pagination-sizes="[10, 20, 50]" storage-key="{{$ctrl.getStorageKey(true)}}" pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllee()"></ecm-pagination> </div> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/proofing/proofing.html','<div> <div> <div> <ul class="tabs list-unstyled"> <li class="active"><a href="" translate="main.proofing"></a></li> </ul> <div class="table table-condensed table-bordered table-striped" style="height: 600px;">NOT IMPLEMENTED YET!</div> <div class="statusbar"></div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/publish/proof.html','<div> <div class="modal-header"> <div class="title" translate="userApp.proof.list.title"> </div> </div> <form name="proofForm" role="form" class="form-horizontal" ng-submit="$ctrl.save()"> <div ng-if="!$ctrl.confirm" class="modal-body"> <div class="form-group form-group-sm"> <div class="col-md-10"> <div ng-if="!$ctrl.canalsFromProduct" class="form-group form-group-sm"> <div class="col-md-2"> <label class="control-label"> <span translate="userApp.proof.list.channel"></span> </label> </div> <div class="col-md-10"> <div ng-repeat="channel in $ctrl.publicationChannel" class="radio"> <label><input type="radio" ng-change="$ctrl.selectProofChannel()" ng-model="$ctrl.selectedProofChannel" data-ng-value="channel">&nbsp;{{channel.name}}</label> </div> </div> </div> <div ng-if="$ctrl.canalsFromProduct"> <div class="row"> <div class="col-md-5"> <label> <span charset="UTF-8" translate="userApp.proof.list.channels"></span> </label> </div> </div> <div ng-repeat="item in $ctrl.productChannels"> <fieldset class="ecm-fieldset"> <legend class="no-margin"> <label>{{item.productWording}}</label> </legend> <div class="row"> <div ng-repeat="channel in item.publicationChannel" class="col-md-3"> <label><input type="radio" ng-change="$ctrl.selectProofChannel(item.productCode, item.productWording)" data-ng-model="$ctrl.selectedProofChannel" data-ng-value="channel">&nbsp;{{channel.name}}</label> </div> </div> </fieldset> </div> </div> </div> </div> </div> <div ng-if="$ctrl.confirm" ng-repeat="msg in $ctrl.informatifMessag"> <div style="width:50%;"> <div class="successMsg" ng-show="msg.publishStatus"> {{msg.messageStatus}} : OK</div> <div class="errorMsg" ng-show="! msg.publishStatus"> {{msg.messageStatus}} : KO</div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary" ng-show="!$ctrl.confirm" ng-disabled="!$ctrl.checkedValue"> <span class="glyphicon glyphicon-save"></span> <span translate="userApp.proof.action.proof"></span> </button> <button type="button" class="btn btn-default" ng-show="!$ctrl.confirm" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.proof.action.cancel"></span> </button> <button type="button" class="btn btn-primary" ng-show="$ctrl.confirm" ng-click="$ctrl.closeProofingStatusModal()"> <span translate="userApp.publish.action.close"></span> </button> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/publish/publish.html','<div> <div class="modal-header"> <div class="title" translate="userApp.publish.list.title"></div> </div> <form name="publish" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.save()"> <div class="modal-body"> <div ng-if="! $ctrl.confirm && !$ctrl.forcePublish && $ctrl.allChannel && !$ctrl.canalsFromProduct"> <fieldset class="ecm-fieldset"> <legend class="no-margin"> <span charset="UTF-8" translate="userApp.publish.list.channel"></span> </legend> <div class="row"> <div ng-repeat="item in $ctrl.publicationChannel" class="col-md-2"> <label class="checkbox-inline"> <input type="checkbox" value="item.identifier" ng-model="item.ticked" ng-change="$ctrl.selectChannels()" ng-disabled="item.checkedAndCanNotUncheck">{{item.name}}</label> </div> </div> </fieldset> </div> <div> <div ng-if="! $ctrl.confirm && !$ctrl.forcePublish && $ctrl.canalsFromProduct"> <div class="row"> <div class="col-md-5"> <label> <span charset="UTF-8" translate="userApp.publish.list.channel"></span> </label> </div> </div> <div ng-repeat="item in $ctrl.productChannels"> <fieldset class="ecm-fieldset"> <legend class="no-margin"> <label>{{item.productWording}}</label> </legend> <div class="row"> <div ng-repeat="channel in item.publicationChannel" class="col-md-2"> <label class="checkbox-inline"> <input type="checkbox" value="channel.identifier" ng-model="channel.ticked" ng-change="$ctrl.selectProductChannels(item)" ng-disabled="channel.checkedAndCanNotUncheck">{{channel.name}} </label> </div> </div> </fieldset> </div> </div> </div> </div> <div ng-show="$ctrl.notValidEntitys.length <= 0 && $ctrl.confirm" ng-repeat="msg in $ctrl.informatifMessag"> <div style="width: 50%;"> <div class="successMsg" ng-show="msg.publishStatus"> {{msg.messageStatus}} : OK</div> <div class="errorMsg" ng-show="! msg.publishStatus"> {{msg.messageStatus}} : KO</div> </div> </div> <div ng-show="($ctrl.notValidEntitys.length > 0 || $ctrl.notImportedHistoricalIds.length > 0) && $ctrl.confirm"> <div class="panel panel-default" ng-show="$ctrl.notImportedHistoricalIds.length > 0"> <div class="panel-heading-default"> <h3 class="panel-title" charset="UTF-8" translate="userApp.publish.msg.notYetImported"></h3> </div> </div> <div class="panel panel-default" ng-show="$ctrl.notValidEntitys.length > 0"> <div class="panel-heading-default"> <h3 class="panel-title" charset="UTF-8" translate="userApp.publish.msg.notFinal"></h3> </div> <div class="panel-body"> <ul> <li ng-repeat="msg in $ctrl.notValidEntitys track by $index"> {{$index+1}} : <span ng-bind-html="msg.titleSystem"></span> </li> </ul> </div> </div> <div class="panel-default"> <div class="panel-body"> <h3 translate="userApp.publish.msg.cantPublish"></h3> </div> </div> </div> <div id="infoPublish" ng-show="$ctrl.forcePublish && !$ctrl.confirm"> <div class="panel panel-default" ng-show="$ctrl.notFinalStatusEntities.length > 0"> <div class="panel-heading-default"> <h3 class="panel-title" charset="UTF-8" translate="userApp.publish.msg.notFinal"></h3> </div> <div class="panel-body"> <ul class="ecm-publish-list"> <li ng-repeat="msg in $ctrl.notFinalStatusEntities track by $index"> {{$index+1}} : <span ng-bind-html="msg.titleSystem"></span> </li> </ul> <strong translate="userApp.publish.msg.lastVersion"></strong> </div> </div> <div ng-show="$ctrl.brockenLink.length > 0"> <p class="h2" translate="userApp.publish.msg.wrongLink"></p> <div class="panel panel-default" ng-show="$ctrl.brockenLink.length > 0"> <div class="panel-heading-default"> <div class="row panel-title"> {{brockenLink.length }} <span charset="UTF-8" translate="userApp.publish.msg.brockenLink"></span> </div> </div> <div class="panel-body"> <li ng-repeat="msg in $ctrl.brockenLink track by $index"> {{$index+1}} : <span ng-bind-html="msg.system.systemTitle"></span> </li> </div> </div> </div> </div> <div class="modal-footer"> <button type="submit" class="btn btn-primary" ng-show="!$ctrl.confirm && !$ctrl.forcePublish" ng-disabled="$ctrl.enablePublish || $ctrl.selectedChanels.length<=0"> <span class="glyphicon glyphicon-save"></span> <span translate="userApp.publish.action.publish"></span> </button> <button type="button" ng-click="$ctrl.displayChannel()" class="btn btn-primary" ng-show="$ctrl.forcePublish && !$ctrl.confirm && ! $ctrl.allChannel" ng-disabled="publish.$invalid"> <span class="glyphicon glyphicon-save"></span> <span translate="userApp.publish.action.forcePublish"></span> </button> <button type="button" class="btn btn-default" ng-show="!$ctrl.confirm" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.publish.action.cancel"></span> </button> <button type="button" class="btn btn-primary" ng-show="$ctrl.confirm" ng-click="$ctrl.closePublishStatusModal()"> <span translate="userApp.publish.action.close"></span> </button> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/product-search/product-search.html','<div ng-repeat="productSearch in $ctrl.productSearchs"> <a ui-sref="searchInterfacesTemplate({identifier : productSearch.idSit, productCode: productSearch.code})">{{productSearch.name}}</a> </div>');
$templateCache.put('scripts/pre-upgrade/components/web-import/web-import.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <h2> <span translate="userApp.webImport.home.title"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-7 col-md-7 col-centered bg-white listing-w-preview">  <div ng-if="$ctrl.data"> <div class="alert alert-danger" ng-if="!$ctrl.data.importOk && $ctrl.data.message"> <h5> <p class="text-danger">{{$ctrl.data.message}}</p> </h5> </div> <div class="alert alert-success" ng-if="$ctrl.data.importOk && $ctrl.data.message"> <h5> <p class="text-success">{{$ctrl.data.message}}</p> <p class="text-success" translate="userApp.webImport.home.sendMailNotif"></p> </h5> </div> </div>  <form name="executeWebImportForm" class="form-horizontal"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.webImport.home.jobName"></span> </label> </div> <div class="col-sm-4"> <select class="form-control" style="width:auto" ng-change="$ctrl.reset();" ng-model="$ctrl.selectedWebImportConfig" ng-options="webImportConfig as webImportConfig.webImportEnum | translate for webImportConfig in $ctrl.allConfigs"> <option value=""></option> </select> </div> </div>  <web-import-parameter web-import-parameter="webImportParameter" ng-repeat="webImportParameter in $ctrl.selectedWebImportConfig.webImportParameters"></web-import-parameter>  <div class="clearfix"> <div class="pull-left"> <button type="submit" class="btn btn-primary" tooltip-placement="bottom" aria-label="userApp.webImport.home.executeButton" ng-click="$ctrl.requestWebImportProcess()" ng-disabled="executeWebImportForm.$invalid" ng-if="$ctrl.selectedWebImportConfig"> <span class="glyphicon glyphicon-play"></span> <span translate="userApp.webImport.home.executeButton"></span> </button> </div> </div> </form> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/xml-edition-modal/xml-edition-modal.html','<div class="modal-header"> <div class="title" translate="userApp.xmlEdit.home.title"></div> </div> <form name="xmlEditForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <div class="row"> <div class="col-sm-6 overflow-auto"> <textarea ng-model="$ctrl.xmlEditionModel.xml" name="xml" id="xml" class="required form-control" rows="25" required="true">\t</textarea> </div> <div class="col-sm-6 overflow-auto"> <div class="alert alert-danger" ng-if="!($ctrl.xmlEditionModel.validationReport.errorERM) && $ctrl.xmlEditionModel.validationReport.errorList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li ng-repeat="error in $ctrl.xmlEditionModel.validationReport.errorList"> <i class="glyphicon glyphicon-remove text-danger"></i> <span> {{error}}</span> </li> </ul> </div> <div class="alert alert-warning" ng-if="!($ctrl.xmlEditionModel.validationReport.errorERM) && $ctrl.xmlEditionModel.validationReport.warningList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.warningList"></span> </div> <ul> <li ng-repeat="warning in $ctrl.xmlEditionModel.validationReport.warningList"> <i class="icon ion-alert error"></i> <span> {{warning}} </span> </li> </ul> </div> <div class="alert alert-danger" ng-if="$ctrl.xmlEditionModel.validationReport.errorERM"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li> <i class="glyphicon glyphicon-remove text-danger"></i> <span translate="userApp.editorialEntity.msg.errorERM"></span> </li> </ul> </div> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="button" class="btn btn-primary" ng-click="$ctrl.validate()" ng-disabled="xmlEditForm.$invalid"> <span class="glyphicon glyphicon-ok"></span> <span translate="userApp.xmlEdit.action.validate"></span> </button> <button type="button" class="btn btn-primary" ng-click="$ctrl.save()" ng-disabled="xmlEditForm.$invalid"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/components/util/metadata/meta-data-alphanumeric.html',' <div ng-hide="metaDataInstance.masked" class="form-group form-group-sm required" ng-if="!metaDataInstance.multipleOccurrences && !readonly" ng-class="{ \'has-error\': form[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'].$dirty && form[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'].$invalid }"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8 col-lg-10"> <input ng-if="metaDataInstance.metaDataDTO.textLength && (!metaDataInstance.multiValuesList || metaDataInstance.multiValuesList.length === 0)" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" class="form-control" type="text" ng-model="metaDataInstance.value" name="alphaNumericMetaData{{metaDataInstance.displayOrder}}" plain-text-max-length="metaDataInstance.metaDataDTO.textLength" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-change="checkIsValueUnique()" ng-pattern="metaDataInstance.metaDataDTO.regex" placeholder="{{regexExplainText}}"> <input ng-if="!metaDataInstance.metaDataDTO.textLength && (!metaDataInstance.multiValuesList || metaDataInstance.multiValuesList.length === 0)" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" class="form-control" type="text" ng-model="metaDataInstance.value" name="alphaNumericMetaData{{metaDataInstance.displayOrder}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-change="checkIsValueUnique()" ng-pattern="metaDataInstance.metaDataDTO.regex" placeholder="{{regexExplainText}}"> <select ng-if="!metaDataInstance.metaDataDTO.textLength && metaDataInstance.multiValuesList.length > 0" class="form-control" ng-model="metaDataInstance.value" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}"> <option value=""></option> <option ng-repeat="metaDataOption in metaDataInstance.multiValuesList" value="{{metaDataOption.text}}">{{metaDataOption.text}}</option> </select> <div ng-show="form[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'].$error.pattern" class="text-danger">{{regexExplainText}}</div> <span class="maxlength-msg" ng-show="metaDataInstance.metaDataDTO.textLength && !form[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'].$error.plainTextMaxLength" translate="global.messages.info.maxlength" translate-values="{remainingNumber: (getTextMaxLength(metaDataInstance.metaDataDTO, 100) - metaDataInstance.value.length), maxlength: getTextMaxLength(metaDataInstance.metaDataDTO, 100)}"> </span> <span ng-show="metaDataInstance.metaDataDTO.textLength && form[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'].$error.plainTextMaxLength" class="text-danger maxlength-msg" translate="global.messages.info.maxlength" translate-values="{remainingNumber: $root[\'alphaNumericMetaData{{metaDataInstance.displayOrder}}\'], maxlength: getTextMaxLength(metaDataInstance.metaDataDTO, 100)}"> </span> <span ng-show="metaDataInstance.displayNotUniqueValueErrorMsg" class="text-danger" translate="global.messages.error.notUniqueValue"> </span> <br> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div> </div> <div class="form-group form-group-sm required" ng-if="!metaDataInstance.multipleOccurrences && readonly"> <div class="col-sm-4"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8"> <div class="control-label"> <span ng-bind-html="trustAsHtml(metaDataInstance.value)"></span> </div> </div> </div>  <div class="form-group form-group-sm required" ng-if="metaDataInstance.multipleOccurrences" ng-class="{ \'has-error\': form[\'alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}\'].$dirty && form[\'alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}\'].$invalid }"> <div ng-hide="metaDataInstance.masked && !readonly" class="col-sm-4" ng-class="{\'col-lg-2\': !readonly}"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly && metaDataInstance.dragAndDrop"> <div class="dragula-container" dragula=\'"alphanumeric-meta-bag"\' dragula-model="metaDataInstance.multiValuesList"> <div class="input-group input-group-sm col-sm-12 col-lg-12" style="margin-bottom:10px;" ng-repeat="line in metaDataInstance.multiValuesList track by $index"> <div class="input-group-addon"> <span class="glyphicon glyphicon-move"></span> </div> <input name="{{getAlphaMultiName($index)}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" class="form-control form-control-sm" type="text" ng-model="line.text" ng-keypress="addAlphaElem($event, $index)" ng-keydown="removeAlphaElem($index, $event)"> <span class="input-group-btn"> <button class="btn btn-default" type="button" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" ng-click="removeAlphaElem($index)"> <i class="glyphicon glyphicon-remove"></i> </button> </span> </div> </div> <div class="row"> <div class="col-sm-12"> <button type="button" class="btn btn-success" ng-click="addAlphaElem()"> <i class="fa fa-plus fa-lg" aria-hidden="true"></i> </button> </div> </div> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly && !metaDataInstance.dragAndDrop"> <tags-input tag-class="{tagError: $tag.isNotUnique}" ng-model="metaDataInstance.multiValuesList" name="alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}" min-length="1" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" placeholder="{{(display || !metaDataInstance.metaDataDTO.authorized) ? \'\' : \'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" add-on-comma="false" on-tag-added="checkIsValueUnique($tag)" on-tag-removed="checkIsAllValuesUnique($tag)"></tags-input> <span ng-show="metaDataInstance.displayNotUniqueValueErrorMsg" class="text-danger" translate="global.messages.error.notUniqueValues"> </span> <br> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div> <div class="col-sm-8" ng-if="readonly && metaDataInstance.multiValuesList.length >0"> <div class="control-label"> <div ng-repeat="model in metaDataInstance.multiValuesList"> <span ng-bind-html="trustAsHtml(model.text)"></span> </div> </div> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-boolean.html','<div ng-hide="metaDataInstance.masked" class="form-group form-group-sm required" ng-if="metaDataInstance.metaDataDTO.selectionFormat == \'RADIOBUTTON\' && !readonly"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span>{{metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8 col-lg-10"> <label class="radio-inline"> <input name="radioMetaData{{metaDataInstance.displayOrder}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" type="radio" ng-model="metaDataInstance.value" value="true" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized"> {{metaDataInstance.metaDataDTO.rightWording}}</label> <label class="radio-inline"> <input name="radioMetaData{{metaDataInstance.displayOrder}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" type="radio" ng-model="metaDataInstance.value" value="false"> {{metaDataInstance.metaDataDTO.falseWording}}</label> </div> </div> <div class="form-group form-group-sm required" ng-if="metaDataInstance.metaDataDTO.selectionFormat == \'RADIOBUTTON\' && readonly"> <div class="col-sm-4"> <label class="control-label"> <span>{{metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8"> <div class="control-label"> <span>{{metaDataInstance.value === \'true\' ? metaDataInstance.metaDataDTO.rightWording : metaDataInstance.metaDataDTO.falseWording }} </span> </div> </div> </div> <div ng-hide="metaDataInstance.masked" class="form-group form-group-sm" ng-if="metaDataInstance.metaDataDTO.selectionFormat == \'CHECKBOX\' && !readonly"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> {{metaDataInstance.metaDataDTO.name}} <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8 col-lg-10"> <div class="checkbox"> <label> <input name="checkboxMetaData{{metaDataInstance.displayOrder}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" type="checkbox" ng-model="metaDataInstance.value" ng-true-value="\'true\'" ng-false-value="\'false\'"> </label> </div> </div> </div> <div class="form-group form-group-sm" ng-if="metaDataInstance.metaDataDTO.selectionFormat == \'CHECKBOX\' && readonly"> <div class="col-sm-4"> <label class="control-label">{{metaDataInstance.metaDataDTO.name}}</label> </div> <div class="col-sm-8"> <div class="control-label"> <span>{{metaDataInstance.value | booleanMetaReadOnlyLabel}}</span> </div> </div> </div>  <div class="form-group form-group-sm required" ng-if="metaDataInstance.metaDataDTO.metaSystem"> <div class="col-sm-4"> <label class="control-label"> <span>{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> </label> </div> <div class="col-sm-8"> <div class="control-label"> <span>{{metaDataInstance.value | booleanMetaReadOnlyLabel}}</span> </div> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-calculated.html','<div class="form-group form-group-sm required" ng-if="!readonly"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span>{{metaDataInstance.metaDataDTO.name}}</span> </label> </div> <div class="col-sm-8 col-lg-10">  <input ng-disabled="true" class="form-control" type="text" ng-model="metaDataInstance.value" name="calculatedNumericMetaData{{metaDataInstance.displayOrder}}" ng-maxlength="metaDataInstance.metaDataDTO.textLength" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized"> </div> </div> <div class="form-group form-group-sm required" ng-if="readonly"> <div class="col-sm-4"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> </label> </div> <div class="col-sm-8"> <div class="control-label"> <span ng-bind-html="trustAsHtml(metaDataInstance.value)"></span> </div> </div> </div> ');
$templateCache.put('scripts/components/util/metadata/meta-data-date.html','<div class="form-group form-group-sm required"> <div ng-hide="metaDataInstance.masked && !readonly" class="col-sm-4" ng-class="{\'col-lg-2\': !display}"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div>  <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!metaDataInstance.multipleOccurrences && !readonly && !metaDataInstance.endDateCode"> <ecm-datepicker on-start-date-change="onDateChange()" name="dateMetaData{{metaDataInstance.displayOrder}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-disabled="display || !metaDataInstance.metaDataDTO.authorized" ng-model="metaDataInstance.value"></ecm-datepicker> <span ng-show="!form[\'dateMetaData{{metaDataInstance.displayOrder}}\'].$error.required && form[\'dateMetaData{{metaDataInstance.displayOrder}}\'].$invalid && form[\'dateMetaData{{metaDataInstance.displayOrder}}\'].$touched" class="text-danger" translate="entity.validation.date"></span> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div>  <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!metaDataInstance.multipleOccurrences && !readonly && metaDataInstance.endDateCode"> <ecm-datepicker on-start-date-change="onDateChange()" on-end-date-change="onEndDateChange()" ng-change="periodChanged(periodModel.startDate, periodModel.endDate)" show-operator="false" model-type="\'RANGE\'" ng-disabled="display || !metaDataInstance.metaDataDTO.authorized" ng-model="periodModel" end-date-label="metaDataInstance.endDateMetaDataInstanceDTO.metaDataDTO.name" start-date-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" end-date-required="metaDataInstance.endDateMetaDataInstanceDTO.mandatory && metaDataInstance.endDateMetaDataInstanceDTO.metaDataDTO.authorized" end-date-discriminant="!display && metaDataInstance.endDateMetaDataInstanceDTO.metaDataDTO.authorized && metaDataInstance.endDateMetaDataInstanceDTO.discriminant"></ecm-datepicker> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="metaDataInstance.multipleOccurrences && !readonly"> <div class="input-group input-group-sm meta-multi-date"> <tags-input disabled="true" class="tagsInput" ng-model="metaDataInstance.multiValuesList" name="alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" template="meta-date-multiple-tag-template"></tags-input> <span class="input-group-btn"> <button type="button" class="btn btn-default btn-sm" ng-click="openCalendarModal()"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> </div> <div> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div> </div> <div class="col-sm-4" ng-if="readonly"> <div class="control-label" ng-if="metaDataInstance.value !=null && metaDataInstance.value !=\'undefined\'"> <span>{{metaDataInstance.value | ecmDate}}</span> <span ng-if="metaDataInstance.endDateCode && metaDataInstance.endDateMetaDataInstanceDTO.value"> - {{metaDataInstance.endDateMetaDataInstanceDTO.value | ecmDate}}</span> </div> <div class="control-label" ng-if="metaDataInstance.multiValuesList.length >0"> <div ng-repeat="model in metaDataInstance.multiValuesList"> <span>{{model.text | ecmDate}}</span> </div> </div> </div> </div> <script type="text/ng-template" id="meta-date-multiple-tag-template"> <div class="tag-template"> {{$getDisplayText() | ecmDate}} </div> </script>');
$templateCache.put('scripts/components/util/metadata/meta-data-empty.html','<div class="form-group form-group-sm required"> <div class="col-sm-4"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> </label> </div> <div class="col-sm-8"> <label class="control-label"> <span class="ecm-no-value" translate="userApp.metadatas.labels.noValue"></span> </label> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-html.html','<div ng-hide="metaDataInstance.masked" ng-if="!readonly && !metaDataInstance.multipleOccurrences" class="form-group form-group-sm required" ng-class="{ \'has-error\': form[\'htmlMetaData{{metaDataInstance.displayOrder}}\'].$dirty && form[\'htmlMetaData{{metaDataInstance.displayOrder}}\'].$invalid }"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <i ng-if="metaDataInstance.masterCode && metaDataInstance.masterLinked" class="fa fa-link" uib-tooltip="{{metaDataInstance.masterName}}"></i> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }} </span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8 col-lg-10"> <tiny-mce-light ng-if="metaDataInstance.metaDataDTO.textLength" ng-model="metaDataInstance.value" html-content="metaDataInstance.value" disabled="display || !metaDataInstance.metaDataDTO.authorized || (published && metaDataInstance.nonEditableAfterPublication)" plain-text-max-length="metaDataInstance.metaDataDTO.textLength" tiny-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" name="htmlMetaData{{metaDataInstance.displayOrder}}" on-change="valueChanged(metaDataInstance)"> </tiny-mce-light> <tiny-mce-light ng-if="!metaDataInstance.metaDataDTO.textLength" on-change="valueChanged(metaDataInstance)" html-content="metaDataInstance.value" disabled="display || !metaDataInstance.metaDataDTO.authorized || (published && metaDataInstance.nonEditableAfterPublication)" tiny-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" name="htmlMetaData{{metaDataInstance.displayOrder}}"></tiny-mce-light> <span class="maxlength-msg" ng-show="metaDataInstance.metaDataDTO.textLength && !form[\'htmlMetaData{{metaDataInstance.displayOrder}}\'].$error.plainTextMaxLength && getTextareaRemainingNumber(metaDataInstance, 1000) >= 0" translate="global.messages.info.maxlength" translate-values="{remainingNumber: getTextareaRemainingNumber(metaDataInstance, 1000) , maxlength: getTextMaxLength(metaDataInstance.metaDataDTO, 1000)}"> </span> <span ng-show="metaDataInstance.metaDataDTO.textLength && form[\'htmlMetaData{{metaDataInstance.displayOrder}}\'].$error.plainTextMaxLength" class="text-danger maxlength-msg" translate="global.messages.info.maxlength" translate-values="{remainingNumber: $root[\'htmlMetaData{{metaDataInstance.displayOrder}}\'] , maxlength: getTextMaxLength(metaDataInstance.metaDataDTO, 1000)}"> </span> <span ng-show="metaDataInstance.metaDataDTO.textLength && !form[\'htmlMetaData{{metaDataInstance.displayOrder}}\'].$error.plainTextMaxLength && getTextareaRemainingNumber(metaDataInstance, 1000) < 0" class="text-danger maxlength-msg" translate="global.messages.info.maxlength" translate-values="{remainingNumber: getTextareaRemainingNumber(metaDataInstance, 1000) , maxlength: getTextMaxLength(metaDataInstance.metaDataDTO, 1000)}"> </span> </div> </div> <div ng-if="readonly && !metaDataInstance.multipleOccurrences" class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }} </span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8"> <div class="control-label"> <span ng-bind-html="trustAsHtml(metaDataInstance.value)"></span> </div> </div> </div>  <div class="form-group form-group-sm required" ng-if="metaDataInstance.multipleOccurrences" ng-class="{ \'has-error\': form[\'alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}\'].$dirty && form[\'alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}\'].$invalid }"> <div ng-hide="metaDataInstance.masked && !readonly" class="col-sm-4" ng-class="{\'col-lg-2\': !display}"> <label class="control-label"> <span>{{metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly"> <tags-input class="tagsInput" ng-model="metaDataInstance.multiValuesList" name="alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized || (published && metaDataInstance.nonEditableAfterPublication)}}" placeholder="{{(display || !metaDataInstance.metaDataDTO.authorized) ? \'\' : \'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized"></tags-input> </div> <div class="col-sm-8 col-md-offset-1" ng-if="readonly"> <tags-input class="tagsInput" ng-model="metaDataInstance.multiValuesList" name="alphaNumericTagsMetaData{{metaDataInstance.displayOrder}}" ng-disabled="true"> </tags-input> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-list.html',' <div class="form-group form-group-sm required"> <div ng-hide="metaDataInstance.masked && !readonly" class="col-sm-4" ng-class="{\'col-lg-2\': !display}"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly && !metaDataInstance.multipleOccurrences"> <select class="form-control" ng-model="metaDataInstance.value" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}"> <option value=""></option> <option ng-repeat="metaDataOption in metaDataInstance.metaDataDTO.listMetaDataValues" value="{{metaDataOption.identifier}}">{{metaDataOption.wording}}</option> </select> </div> <div class="col-sm-8" ng-if="readonly"> <div class="control-label"> <span>{{listSelectedValue.wording}}</span> </div> </div>  <div class="col-sm-8" ng-if="readonly && metaDataInstance.multipleOccurrences"> <p ng-repeat="model in metaDataMultiValuesDisplay"> <span> {{model.wording}} <span> </span></span></p> </div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly && metaDataInstance.multipleOccurrences"> <tags-input ng-model="metaDataInstance.metaDataMultiValuesList" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" display-property="wording" replace-spaces-with-dashes="false" tabindex="identifier" key-property="identifier" add-from-autocomplete-only="true" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized"> <auto-complete source="loadTagsForMetaDataList($query)" load-on-empty="true" load-on-focus="true" load-on-down-arrow="true" display-property="wording" key-property="identifier"></auto-complete> </tags-input> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-media.html','<meta-data-media meta-data-instance="metaDataInstance" readonly="readonly" display="display"></meta-data-media> ');
$templateCache.put('scripts/components/util/metadata/meta-data-numeric.html','<div class="form-group form-group-sm required" ng-class="{ \'has-error\': form[\'numericMetaData{{metaDataInstance.displayOrder}}\'].$dirty && form[\'numericMetaData{{metaDataInstance.displayOrder}}\'].$invalid }"> <div ng-hide="metaDataInstance.masked && !readonly" class="col-sm-4" ng-class="{\'col-lg-2\': !display}"> <label class="control-label"> <span ng-if="!metaDataInstance.metaDataDTO.metaSystem">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-if="metaDataInstance.metaDataDTO.metaSystem">{{ metaDataInstance.metaDataDTO.name === metaDataInstance.metaDataDTO.code ? (\'userApp.metadatas.labels.\' + metaDataInstance.metaDataDTO.code | translate ) : metaDataInstance.metaDataDTO.name }}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div> <div ng-hide="metaDataInstance.masked" class="col-sm-8 col-lg-10" ng-if="!readonly && ! metaDataInstance.multipleOccurrences">  <input ng-show="display" ng-disabled="true" ng-if="!readonly && ! metaDataInstance.multipleOccurrences" class="form-control input-xs" ng-model="metaDataInstance.value" name="numericMetaData{{metaDataInstance.displayOrder}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-pattern="regex">  <input type="number" ng-show="!display" ng-if="!readonly && ! metaDataInstance.multipleOccurrences" ng-disabled="{{!metaDataInstance.metaDataDTO.authorized}}" class="form-control input-xs" ng-model="metaDataInstance.value" max="{{numericMetaDataMaxValue}}" name="numericMetaData{{metaDataInstance.displayOrder}}" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" ng-pattern="regex" placeholder="{{ metaDataInstance.metaDataDTO.placeHolderInfoMsgKey | translate}}" ng-change="checkIsValueUnique()"> <span ng-show="form[\'numericMetaData{{metaDataInstance.displayOrder}}\'].$error.pattern" class="text-danger" translate="{{metaDataInstance.metaDataDTO.placeHolderInfoMsgKey}}"></span> <span ng-show="form[\'numericMetaData{{metaDataInstance.displayOrder}}\'].$error.max" class="text-danger" translate="userApp.editorialEntity.validation.max" translate-values="{max: \'{{numericMetaDataMaxValue}}\'}"></span> <span ng-show="metaDataInstance.displayNotUniqueValueErrorMsg" class="text-danger" translate="global.messages.error.notUniqueValue"> </span> <br> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div> <div class="col-sm-8" ng-if="readonly">  <div ng-if="!metaDataInstance.multipleOccurrences"> <span>{{metaDataInstance.value | number}}</span> </div>  <div ng-if="metaDataInstance.multipleOccurrences"> <div class="control-label"> <p ng-repeat="model in metaDataInstance.multiValuesList"> <span>{{model.text}}</span> </p> </div> </div> </div>  <div ng-hide="metaDataInstance.masked" class="col-sm-8" ng-if="!readonly && metaDataInstance.multipleOccurrences"> <div ng-if="!readonly"> <tags-input ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized" tag-class="{tagError: $tag.isNotUnique}" ng-model="metaDataInstance.multiValuesList" name="numericMetaData{{metaDataInstance.displayOrder}}" min-length="1" max-length="{{numericMetaDataMaxValue}}" ng-disabled="{{display || !metaDataInstance.metaDataDTO.authorized}}" placeholder="{{(display || !metaDataInstance.metaDataDTO.authorized) ? \'\' : \'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}" allowed-tags-pattern="{{regex.source}}" add-on-comma="false" ng-keyup="isInputTouched($event.keyCode)" on-tag-added="checkIsAllValuesUnique($tags)" on-tag-removed="checkIsAllValuesUnique($tags)"></tags-input> <span ng-show="metaDataInstance.displayNotUniqueValueErrorMsg" class="text-danger" translate="global.messages.error.notUniqueValues"> </span> <br> <span ng-show="metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"> </span> </div> </div> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-relationship.html','<div class="form-group form-group-sm required"> <div class="col-sm-4" ng-class="{\'col-lg-2\': !display}"> <label class="control-label"> <span style="white-space: pre;">{{metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!display && metaDataInstance.metaDataDTO.authorized && metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div> <div class="col-sm-8 col-lg-10" ng-if="!readonly"> <div class="dragula-container" dragula=\'"relationship-meta-bag"\' dragula-model="metaDataInstance.relationDTOList"> <div class="row" style="margin-bottom: 4px" ng-repeat="relation in metaDataInstance.relationDTOList"> <div class="col-sm-9" ng-if="!relation.deleted"> <div class="input-group input-group-sm"> <div class="input-group-addon"> <span class="glyphicon glyphicon-move"></span> </div> <input class="form-control" value="{{relation.strippedWording | translate}}" ng-readonly="true" ng-required="metaDataInstance.mandatory && metaDataInstance.metaDataDTO.authorized && !relation.eeTargetFlashId" ng-class="{\'ecm-no-title\': relation.wording ===\'userApp.editorialEntity.home.noTitle\'}" ng-show="!relation.deleted || $first"> </div> </div> <div class="col-sm-3" ng-if="!relation.deleted"> <button ng-if="!isCreatingEntity" type="button" class="btn btn-primary" ng-click="setNewTargetEntity(relation, metaDataInstance.relationshipTemplateId)"> <i class="icon ion-edit fa-lg" aria-hidden="true"></i> </button> <button type="button" class="btn btn-primary" ng-click="updateRelation(relation)"> <i class="fa fa-chain fa-lg" aria-hidden="true"></i> </button> <button type="button" class="btn btn-primary" ng-if="relation.eeTargetFlashId" ng-click="deleteRelation(relation)"> <i class="fa fa-trash fa-lg" aria-hidden="true"></i> </button> </div> </div> </div> <div class="row" ng-if="canAddRelation()"> <div class="col-sm-12"> <button type="button" class="btn btn-success" ng-if="metaDataInstance.multipleOccurrences" ng-click="addNewRelation(metaDataInstance.relationDTOList)"> <i class="fa fa-plus fa-lg" aria-hidden="true"></i> </button> </div> </div> </div> <div class="col-sm-8" ng-if="readonly"> <ul> <li ng-repeat="relation in metaDataInstance.relationDTOList"> <div ng-if="!relation.deleted"> <div> <a href="" target="_blank" ui-sref="editorialEntity({id: relation.eeTargetFlashId})"> <span ng-bind-html="relation.wording | translate"></span> </a> </div> <div> <display-meta-values metadata-list="relation.metaInstanceDTOList" include-system="false"></display-meta-values> </div> <div ng-if="relation.metaInstanceDTOList.length === 0"> <display-meta-values meta-data-instance="metaDataInstance" flash-id="relation.flashId" type="\'RELATION\'"></display-meta-values> </div> </div> </li> </ul> </div> </div>');
$templateCache.put('scripts/components/util/metadata/meta-data-repository.html','<meta-data-referential ng-hide="metaDataInstance.masked && !readonly" meta-data-instance="metaDataInstance" readonly="readonly" display="display" lang="lang" filter="[productCode, eetCode]" ee-source-flash-id="eeSourceFlashId"></meta-data-referential>');
$templateCache.put('scripts/components/util/metadata/meta-data-url.html','<meta-data-url ng-hide="metaDataInstance.masked && !readonly" meta-data-instance="metaDataInstance" readonly="readonly" display="display"></meta-data-url>');
$templateCache.put('scripts/components/util/metadata/modalCalendar.html','<div class="modal-header"> <div class="title"> </div> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="saveDate()"> <div class="modal-body col-sm-12"> <multiple-date-picker ng-model="listOfDate" change-year-past="5" change-year-future="10"> </multiple-date-picker></div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-click="ok()"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="reset()"> <span class="glyphicon glyphicon-refresh"></span> <span translate="entity.action.reset"></span> </button> <button type="button" class="btn btn-default" ng-click="cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/app/entities/editorialEntity/eeLinkInfos/linkedEE.tpl.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.eeLinkInfos.labels.linkedEEWarningTitle"></h2> </div> <span class="modal-close" ng-click="linkedEECtrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body">  <div ng-if="linkedEECtrl.alreadyLinkedList.length > 0"> <div class="form-group form-group-sm"> <label ng-if="!linkedEECtrl.hookingFromTarget || !linkedEECtrl.trSelected.ignoreEntitiesAttachedToSource" class="control-label" for="title">{{linkedEECtrl.alreadyLinkedList.length > 1?\'userApp.eeLinkInfos.labels.alreadyLinkedEEs\':\'userApp.eeLinkInfos.labels.alreadyLinkedEE\' | translate}}</label> <label ng-if="linkedEECtrl.trSelected.ignoreEntitiesAttachedToSource" class="control-label" for="title">{{linkedEECtrl.alreadyLinkedList.length > 1?\'userApp.eeLinkInfos.labels.alreadyLinkedEEsWarn\':\'userApp.eeLinkInfos.labels.alreadyLinkedEEWarn\' | translate}}</label> </div> <div class="form-group form-group-sm"> <ul> <li ng-repeat="hookingSource in linkedEECtrl.alreadyLinkedList"> <span>-&nbsp;&nbsp;{{linkedEECtrl.trustAsHtml(hookingSource.wording)}}&nbsp;:</span> <ul> <li ng-repeat="hook in hookingSource.paths"> <span ng-if="part == \'ROOT_LEVEL\'" ng-repeat="part in hook">&nbsp;&nbsp;/</span> <span ng-if="part != \'ROOT_LEVEL\'" ng-repeat="part in hook"> {{ $index == 0 ? \'&nbsp;&nbsp;/\' : \'\'}} {{ \' \' + linkedEECtrl.trustAsHtml(part) + \'&nbsp;/\' }} </span> </li> </ul> </li> </ul> </div> <div class="form-group form-group-sm"> <label ng-if="!linkedEECtrl.trSelected.ignoreEntitiesAttachedToSource" class="control-label" for="title">{{linkedEECtrl.alreadyLinkedList.length > 1?\'userApp.eeLinkInfos.labels.alreadyLinkedEEsConfirmation\':\'userApp.eeLinkInfos.labels.alreadyLinkedEEConfirmation\' | translate}}&nbsp;?</label> </div> </div>  <div ng-if="linkedEECtrl.hookedToSameProductList.length > 0 && linkedEECtrl.trSelected.ignoreEntitiesHookedToSameProduct"> <div class="form-group form-group-sm"> <label class="control-label" for="title">{{linkedEECtrl.hookedToSameProductList.length > 1?\'userApp.eeLinkInfos.labels.hookedToSameProductEEs\':\'userApp.eeLinkInfos.labels.hookedToSameProductEE\' | translate}}</label> </div> <div class="form-group form-group-sm"> <ul> <li ng-repeat="hookingSource in linkedEECtrl.hookedToSameProductList"> <span>-&nbsp;&nbsp;{{linkedEECtrl.trustAsHtml(hookingSource.eeTargetSystemTitle)}}</span> </li> </ul> </div> </div>  <div ng-if="linkedEECtrl.hookedToSameEetList.length > 0 && linkedEECtrl.trSelected.ignoreEntitiesHookedToSameEet"> <div class="form-group form-group-sm"> <label class="control-label" for="title">{{linkedEECtrl.hookedToSameEetList.length > 1?\'userApp.eeLinkInfos.labels.hookedToSameEetEEs\':\'userApp.eeLinkInfos.labels.hookedToSameEetEE\' | translate}}</label> </div> <div class="form-group form-group-sm"> <ul> <li ng-repeat="hookingSource in linkedEECtrl.hookedToSameEetList"> <span>-&nbsp;&nbsp;{{linkedEECtrl.trustAsHtml(hookingSource.eeTargetSystemTitle)}}</span> </li> </ul> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="button" class="btn btn-primary" ng-click="linkedEECtrl.confirm()"> <span translate="userApp.eeLinkInfos.actions.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="linkedEECtrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.eeLinkInfos.actions.cancel"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/blockUI/default.tpl.html','<div class="block-ui-overlay"></div> <div class="block-ui-message-container" aria-live="assertive" aria-atomic="true"> <div class="block-ui-message" ng-class="$_blockUiMessageClass">{{ state.message | translate }}</div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/commons/closeable-html-preview/closeable-html-preview.html','<ecm-sidebar content-class="sibebar-preview-content" allow-close="true" is-open="$ctrl.preview.opened" on-close="$ctrl.close()"> <span class="close-preview" ng-click="$ctrl.closePreview()"> <i class="icon ion-close-round"></i> </span> <div ng-if="$ctrl.mode === \'light\'" style="height: calc(100% - 40px); overflow: auto" class="voffset5" block-ui="previewUI"> <ecm-preview-html content="$ctrl.trustAsHtml($ctrl.editorialEntity.html)"></ecm-preview-html> </div> <editorial-entity-action-bar ng-if="$ctrl.mode === \'full\'" flash-id="$ctrl.currentFlashId" content-class="action-bar-content" from-trush="$ctrl.fromTrush" on-edit-meta-data="$ctrl.openEditMetaModal($ctrl.currentFlashId)" on-refresh-preview="$ctrl.updatePreview($ctrl.currentFlashId,\'COMPLETE\', $ctrl.productCode)" on-edit-content="$ctrl.startEdition($ctrl.currentFlashId)" preview-html="$ctrl.editorialEntity.html" on-refresh-page="$ctrl.onRefreshPage()"> <display-editorial-metadata ng-if="$ctrl.preview.isRelation" flash-id="$ctrl.preview.relationId" is-relation="true" edit-metadata-enabled="$ctrl.isEditMetadata"> </display-editorial-metadata> <div style="height: 100%" block-ui="previewUI"> <ecm-preview-html content="$ctrl.trustAsHtml($ctrl.editorialEntity.html)"></ecm-preview-html> </div> </editorial-entity-action-bar> </ecm-sidebar>');
$templateCache.put('scripts/pre-upgrade/components/commons/confirm-modal/confirm-modal.html','<div> <div class="modal-header"> <div class="title" translate="{{$ctrl.resolve.message.title}}" translate-values="{{$ctrl.resolve.message.params}}"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group" style="word-wrap: break-word;"> <p ng-bind-html="$ctrl.trust($ctrl.resolve.message.text | translate:$ctrl.resolve.message.params)"></p> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-click="$ctrl.confirm()" translate="{{$ctrl.confirmButtonText}}"></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" translate="{{$ctrl.cancelButtontext}}"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/ecm-datepicker/ecm-datepicker.html',' <div class="input-group input-group-sm" ng-if="$ctrl.showOnlyOperator()"> <span class="input-group-btn" uib-dropdown=""> <button type="button" ng-disabled="$ctrl.ngDisabled" class="btn btn-default dropdown-toggle leave-radius" uib-dropdown-toggle="" aria-haspopup="true" aria-expanded="false">{{$ctrl.selectedOperator|translate}} <span class="caret"></span> </button> <ul class="dropdown-menu" uib-dropdown-menu=""> <li ng-repeat="option in $ctrl.operators"> <a ng-click="$ctrl.operatorChanged($ctrl.selectedOperator, option.value)">{{option.name|translate}}</a> </li> </ul> </span> </div>  <div class="input-group input-group-sm" ng-if="$ctrl.showStartInput()"> <span class="input-group-btn" uib-dropdown="" ng-if="$ctrl.showOperator"> <button type="button" ng-disabled="$ctrl.ngDisabled" class="btn btn-default dropdown-toggle" uib-dropdown-toggle="" aria-haspopup="true" aria-expanded="false">{{$ctrl.selectedOperator|translate}} <span class="caret"></span> </button> <ul class="dropdown-menu" uib-dropdown-menu=""> <li ng-repeat="option in $ctrl.operators"> <a ng-click="$ctrl.operatorChanged($ctrl.selectedOperator, option.value)">{{option.name|translate}}</a> </li> </ul> </span> <input name="{{$ctrl.name}}" ng-disabled="$ctrl.ngDisabled" type="text" class="form-control" ng-change="$ctrl.startChanged()" datepicker-append-to-body="true" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="$ctrl.dateOptionsStart" ng-model="$ctrl.startDate" current-text="{{\'datepicker.currentText\'|translate}}" close-text="{{\'datepicker.closeText\'|translate}}" clear-text="{{\'datepicker.clearText\'|translate}}" is-open="$ctrl.startDateOpen"> <span class="input-group-btn append-right"> <button type="button" class="btn btn-default" ng-click="$ctrl.startDateOpen = !$ctrl.startDateOpen"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> </div>  <div class="input-group input-group-sm" ng-if="$ctrl.selectedOperator === \'BETWEEN\'"> <span class="input-group-btn" uib-dropdown="" ng-if="$ctrl.showOperator"> <button type="button" class="btn btn-default dropdown-toggle" ng-disabled="$ctrl.ngDisabled" uib-dropdown-toggle="" aria-haspopup="true" aria-expanded="false">{{$ctrl.selectedOperator|translate}} <span class="caret"></span> </button> <ul class="dropdown-menu" uib-dropdown-menu=""> <li ng-repeat="option in $ctrl.operators"> <a ng-click="$ctrl.operatorChanged($ctrl.selectedOperator, option.value)">{{option.name|translate}}</a> </li> </ul> </span> <input type="text" ng-disabled="$ctrl.ngDisabled" ng-required="$ctrl.startDateRequired" class="form-control" ng-change="$ctrl.startChanged()" datepicker-append-to-body="true" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="$ctrl.dateOptionsStart" ng-model="$ctrl.startDate" current-text="{{\'datepicker.currentText\'|translate}}" close-text="{{\'datepicker.closeText\'|translate}}" clear-text="{{\'datepicker.clearText\'|translate}}" is-open="$ctrl.startDateOpen"> <span class="input-group-btn append-right"> <button type="button" class="btn btn-default" ng-click="$ctrl.startDateOpen = !$ctrl.startDateOpen"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> <div class="input-group-addon between-addon"> {{$ctrl.dateRangeSeparator}} <span ng-show="$ctrl.endDateRequired" class="text-danger font-weight-bold">*</span> <span ng-show="$ctrl.endDateDiscriminant" class="text-danger font-weight-bold" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </div> <input ng-change="$ctrl.endChanged()" type="text" ng-disabled="$ctrl.ngDisabled" ng-required="$ctrl.endDateRequired" uib-datepicker-popup="dd/MM/yyyy" class="form-control" is-open="$ctrl.endDateOpen" datepicker-options="$ctrl.dateOptionsEnd" datepicker-append-to-body="true" ng-model="$ctrl.endDate" current-text="{{\'datepicker.currentText\'|translate}}" close-text="{{\'datepicker.closeText\'|translate}}" clear-text="{{\'datepicker.clearText\'|translate}}"> <span class="input-group-btn append-right"> <button type="button" class="btn btn-default" ng-click="$ctrl.endDateOpen = !$ctrl.endDateOpen"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/ecm-pagination/ecm-page-selector.html','<div class="form-inline"> <span>{{$ctrl.label | translate}}</span> <div class="form-group form-group-sm"> <select class="form-control" ng-model="$ctrl.selectedSize" ng-change="$ctrl.selectedSizeChanged()" ng-options="page for page in $ctrl.paginationSizes"> </select> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/commons/ecm-pagination/ecm-pagination.html','<div class="form-inline ecm-pagination"> <ul uib-pagination="" total-items="$ctrl.paginationModel.totalCount" items-per-page="$ctrl.paginationModel.itemByPage" ng-model="$ctrl.paginationModel.currentPage" ng-change="$ctrl.onChange($ctrl.paginationModel)"></ul> <div class="form-group form-group-sm" ng-if="$ctrl.showPageSizeSelector"> <label translate="global.itemsByPage"></label> <select class="form-control" ng-model="$ctrl.paginationModel.itemByPage" ng-change="$ctrl.onPageSizesChange()" ng-options="page for page in $ctrl.paginationSizes"></select> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/commons/error-modal/error-modal.component.html','<div> <div class="modal-header"> <div class="modal-title" translate="{{$ctrl.resolve.message.title}}"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group" style="word-wrap: break-word;"> <p class="alert alert-danger" translate="{{$ctrl.resolve.message.text}}" translate-values="{{$ctrl.resolve.message.params}}"></p> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" translate="error.preview.confirm"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/info-modal/info-modal.html','<div> <div class="modal-header"> <div class="title" translate="{{$ctrl.resolve.message.title}}"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group" style="word-wrap: break-word;"> <p translate="{{$ctrl.resolve.message.text}}" translate-values="{{$ctrl.resolve.message.params}}"></p> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" translate="error.preview.confirm"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/padlock/padlock.html',' <div ng-if="$ctrl.size === \'big\'" class="{{$ctrl.bigPadlockColorClass()}}"> <i class="{{$ctrl.bigPadlockClass()}}"></i> </div>  <div ng-if="$ctrl.size === \'small\' || $ctrl.size === \'medium\'" class="padlock {{$ctrl.size}}" uib-tooltip="{{$ctrl.owner}}"> <span> <i class="{{$ctrl.smallPadlockClass()}}" aria-hidden="true" style="color: {{$ctrl.color }};"> </i> {{$ctrl.size === \'small\' ? $ctrl.owner : \'\'}} </span> </div> ');
$templateCache.put('scripts/pre-upgrade/components/commons/relation-status-icon/relation-status-icon.html','<i class="ecm-relation-icon" ng-class="$ctrl.getRelationStatusIcon()" aria-hidden="true"> <md-tooltip>{{$ctrl.getRelationStatusTooltip() | translate}}</md-tooltip> </i>');
$templateCache.put('scripts/pre-upgrade/components/commons/sidebar/ecm-sidebar.tpl.html','<div class="ecm-sidebar-container" ng-style="{}" click-outside="$ctrl.close()" outside-if-not="sidebar-open"> <div class="ecm-sidebar" ng-style="{width: $ctrl.width + \'px\', right: $ctrl.isOpen ? 0 : $ctrl.rightSize(),opacity: $ctrl.isOpen ? \'100%\': 0}"> <div ng-mousedown="$ctrl.startResize($event)" class="resize-bar"></div> <div class="sidebar-content" ng-class="$ctrl.contentClass" ng-transclude=""></div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/commons/text-area-with-menu/text-area-with-menu.html','<div class="form-group form-group-sm"> <div class="col-sm-12"> <tiny-mce-light html-content="$ctrl.htmlText" max-length="1000" class="$ctrl.remainingTitleCharacters() >= 0 ? \'form-control\' : \'form-control has-error\'"></tiny-mce-light> <span ng-class="$ctrl.remainingTitleCharacters() >= 0 ? \'maxlength-msg\' : \'text-danger maxlength-msg\'" ng-if="$ctrl.showRemainingCharactersHelper && $ctrl.requiredValidation()" translate="global.messages.info.maxlength" translate-values="{remainingNumber: $ctrl.remainingTitleCharacters(), maxlength: $ctrl.maxlength}"></span> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/commons/tiny-mce-light-modal/tiny-mce-light-modal.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.tinymcelight.labels.title"></h2> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <form name="editForm" role="form" class="form-horizontal"> <div class="modal-body">  <div class="form-group form-group-sm"> <div class="col-sm-3"> <label class="control-label" for="nodeTitle">{{\'userApp.tinymcelight.labels.titleField\' | translate}}&ensp;*</label> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-12"> <tiny-mce-light html-content="$ctrl.htmlContent" max-length="$ctrl.maxLength" lang="$ctrl.lang" tiny-required="$ctrl.required"></tiny-mce-light> </div> </div> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="button" ng-disabled="editForm.$invalid" class="btn btn-primary" ng-click="$ctrl.save()"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/commons/tiny-mce-light/tiny-mce-light.html','<textarea ui-tinymce="$ctrl.tinymceOptions" ng-model="$ctrl.htmlContent" ng-required="$ctrl.tinyRequired" plain-text-max-length="$ctrl.maxLength" ng-disabled="$ctrl.disabled" name="$ctrl.name" ng-change="$ctrl.onChange()" class="$ctrl.class" ng-model-options="{ allowInvalid: true }">\n</textarea> ');
$templateCache.put('scripts/pre-upgrade/components/batch/parameter/parameter.html','<div class="form-group form-group-sm required">  <div class="col-sm-4"> <label class="control-label"> <span>{{$ctrl.batchParameter.parameter.name | translate}}</span> <span ng-if="$ctrl.batchParameter.parameter.required" class="text-danger"> *</span> </label> </div>  <div ng-if="$ctrl.batchParameter.parameterType === \'STRING\'" class="col-sm-3"> <input ng-if="!$ctrl.smallSize" class="form-control" type="text" ng-model="$ctrl.batchParameter.value" name="{{$ctrl.batchParameter.parameter.name}}" ng-required="$ctrl.batchParameter.parameter.required"> </div> <div ng-if="$ctrl.batchParameter.parameterType === \'LONG\'" class="col-sm-3"> <input ng-if="!$ctrl.smallSize" class="form-control" type="number" ng-model="$ctrl.batchParameter.value" name="{{$ctrl.batchParameter.parameter.name}}" ng-required="$ctrl.batchParameter.parameter.required"> </div> <div ng-if="$ctrl.batchParameter.parameterType === \'BOOLEAN\'" class="col-sm-3"> <input ng-if="!$ctrl.smallSize" class="checkbox" type="checkbox" ng-model="$ctrl.batchParameter.value" name="{{$ctrl.batchParameter.parameter.name}}"> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/debug/debug-log/debug-log.component.html','<div> <div> <form> <div class="row"> <div class="col-md-6 form-group"> <label for="exampleFormControlTextarea1">Nombre de ligne</label> <input class="form-control" id="lines" type="text" ng-model="$ctrl.numberOfLine"> </div> <div style="padding-top: 20px;" class="col-md-6 form-group"> <button ng-disabled="!$ctrl.fileName" ng-click="$ctrl.getLogFileContent()" class="btn btn-primary">Envoyer</button> </div> </div> </form> </div> <div class="row"> <div class="col-md-6 form-group"> <div class="list-group"> <a class="list-group-item active"> <span class="glyphicon glyphicon-folder-open"></span> <span> &nbsp; Fichier de log </span> <span class="badge">{{$ctrl.logFiles.lenght}}</span> </a> <a ng-repeat="file in $ctrl.logFiles" ng-click="$ctrl.selectFileLog(file)" class="list-group-item" ng-class="{\'list-group-item-success\': file=== $ctrl.fileName}"> <span class="glyphicon glyphicon-file"></span> {{file}} </a> </div> </div> </div> <div class="row"> <div class="row" ng-show="$ctrl.logResult"> <div class="col-md-8" style="max-height: 400px;overflow-y:scroll;max-width:100%;overflow-x:scroll;"> <pre>{{$ctrl.logResult | json }}</pre> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/debug/debug-maria/debug-maria.component.html','<div class="full-height flex-container-column"> <form> <div class="form-group"> <label for="exampleFormControlTextarea1">Requette Maria</label> <textarea class="form-control" id="solr" rows="5" ng-model="$ctrl.sqlRequest"></textarea> </div> <button type="submit" ng-click="$ctrl.sendMariaRequest()" class="btn btn-primary">Envoyer</button> </form> <div class="row" ng-show="$ctrl.sqlResult"> <div class="col-md-8" style="max-height: 400px;overflow-y:scroll;max-width:1300px;"> <pre>{{$ctrl.sqlResult | json }}</pre> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/debug/debug-solr/debug-solr.component.html','<div class="full-height flex-container-column"> <form> <div class="form-group"> <label for="exampleFormControlTextarea1">Requette solr</label> <textarea class="form-control" id="solr" rows="5" ng-model="$ctrl.solrRequest"></textarea> </div> <button type="submit" ng-click="$ctrl.sendSolrRequest()" class="btn btn-primary">Envoyer</button> </form> <div class="row" ng-show="$ctrl.solrResult"> <div class="col-md-8" style="max-height: 400px;overflow-y:scroll;max-width:1300px;"> <pre>{{$ctrl.solrResult | json }}</pre> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editor/components/ecm-editor-wrapper.component.html','<div class="editor-content"> <div class="loader" ng-if="$ctrl.config !== \'mini\'"> <div class="page-loader"></div> </div> <textarea id="{{$ctrl.editorUniqueID}}" els-editor-tinymce="" els-entity-edited="$ctrl.entityEdited" els-editor-configuration="$ctrl.editorConfiguration" set-adapter="$ctrl.setAdapterInternal">\n  </textarea> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editor/components/ecm-inline-editor.html','<ecm-editor-wrapper ng-if="$ctrl.loaded" save-intervals="$ctrl.saveIntervals" author="$ctrl.author" prolexis-ws-url="$ctrl.prolexisWsUrl" entity-edited="$ctrl.entityEdited" ee-id="$ctrl.id" sub-id="$ctrl.subId" config="mini" inline="true" set-adapter="$ctrl.setAdapterInternal(adapter)" product-code="$ctrl.productCode" editor-height="$ctrl.editorHeight" embeded-in-proofing="$ctrl.embededInProofing"> </ecm-editor-wrapper> <span ng-if="!$ctrl.loaded && $ctrl.valid">{{\'global.LOADING\' | translate}}</span> <input type="text" ng-disabled="true" class="form-control" ng-if="!$ctrl.valid" placeholder="{{\'userApp.editor.invalid.html.title\' | translate}}"> ');
$templateCache.put('scripts/pre-upgrade/components/editor/components/full-page-editor.html','<ecm-editor-wrapper save-intervals="$ctrl.saveIntervals" author="$ctrl.author" prolexis-ws-url="$ctrl.prolexisWsUrl" entity-edited="$ctrl.entityEdited" ee-id="$ctrl.eeId" sub-id="$ctrl.subId" config="{{$ctrl.config}}"></ecm-editor-wrapper> ');
$templateCache.put('scripts/pre-upgrade/components/editor/multi-editor/multi-editor-main.html','<div class="entity-action-bar floating hidden" id="multieditor-action-bar">  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.editInline()" ng-disabled="!($ctrl.subEditorialEntityData.isEditable)" uib-tooltip="{{\'entity.actionBar.editContent.tooltip\'|translate}}"> <i class="fa fa-lg fa-file-text"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ui-sref="editorialEntity({id: $ctrl.subEditorialEntityId})" target="_blank"> <i class="fa fa-lg fa-external-link"></i> </a> <padlock-icon color="$ctrl.subEditorialEntityData.padlock.color" closed="$ctrl.subEditorialEntityData.padlock.closed" owner="$ctrl.subEditorialEntityData.padlock.owner.fullName" size="medium"> </padlock-icon> </div> <div class="full-height"> <div style="height: 100%"> <div class="flex-cont bg-white listing-w-preview" ng-if="displayMode !=\'DISPLAY_FLAT_VIEW\'"> <div class="c-resize c-preview c-tree"> <div class="ecm-tree-container"> <tree-view-actions on-show-meta-data="$ctrl.showMetaData(show)"> </tree-view-actions> <ecm-treeview style="overflow: auto;" flash-id="$ctrl.editorialEntity.identifier" node-selection="$ctrl.nodeSelection(nodeSelected)" editorial-entity="$ctrl.editorialEntity" current-user="$ctrl.currentUser" show-metadata="$ctrl.showNodesMetaData"></ecm-treeview> </div> </div> <div ng-mousedown="$ctrl.mdDragBar($event)" class="resize-bar"></div> <div id="idDivContenu" class="c-resize c-preview resizable no-padding flex-container-column" style="flex-basis:70%;"> <iframe ng-src="{{\'/#/multieditorview/\'+ $ctrl.editorialEntity.identifier}}" style="height: 100%; border: none"></iframe> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editor/multi-editor/multi-editor-view.html','<style>\n  .editorialEntity:hover {\n    background: #ebebeb;\n  }\n\n  .dpdwn-toolbar li {\n    list-style: none;\n  }\n\n  .dpdwn-toolbar ul>li:before,\n  ul.right-click>li:before {\n    content: \'\' !important;\n  }\n\n  .dpdwn-toolbar ul>li,\n  ul.right-click>li {\n    margin-bottom: 0;\n  }\n\n  .dpdwn-toolbar ul>li li,\n  ul.right-click>li li {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  ui-view>div.wrapper {\n    overflow: visible !important;\n  }\n</style> <div ng-bind-html="$ctrl.source"></div> <ecm-inline-editor ng-show="$ctrl.editorLoaded" id="$ctrl.entityEditedId" product-code="$ctrl.productCode" loaded="$ctrl.editorLoaded" set-adapter="$ctrl.setContentAdapter(adapter)" click-outside="$ctrl.outsideEditorClick(event)" outside-if-not="editor-content,mce-container,mce-widget,mce-btn" editor-height="$ctrl.editorHeight" embeded-in-proofing="true"> </ecm-inline-editor> ');
$templateCache.put('scripts/pre-upgrade/components/editor/popup/end-message.html','<div class="modal-header"> <h3 class="modal-title" id="modal-title"> <span translate="userApp.editor.invalid.html.title"></span> </h3> </div> <div class="modal-body" id="modal-body"> <p> <span translate="userApp.editor.invalid.edition.content"></span> </p> <p> <a href="" ng-hide="$ctrl.isShowErrorDetail" ng-click="$ctrl.toggleShowErrorDetail()" translate="{{$ctrl.messages.display}}"></a> </p> <p> <a href="" ng-show="$ctrl.isShowErrorDetail" ng-click="$ctrl.toggleShowErrorDetail()" translate="{{$ctrl.messages.hide}}"></a> </p> <br> <p ng-show="$ctrl.isShowErrorDetail" class="ng-hide" style="white-space: pre-wrap; color: #6f1400"> {{$ctrl.errorMsg}} <br> --------------------------- HTML ------------------------------------------- <br> {{$ctrl.htmlContent}} </p> </div> <div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$ctrl.save()" translate="userApp.editor.invalid.edition.save"></button> <button class="btn btn-default" type="button" ng-click="$ctrl.continue()" translate="userApp.editor.invalid.edition.correct"></button>  </div> ');
$templateCache.put('scripts/pre-upgrade/components/editor/popup/start-message.html','<div class="modal-header"> <h3 class="modal-title" id="modal-title"> <span translate="userApp.editor.invalid.html.title"></span> </h3> </div> <div class="modal-body" id="modal-body"> <span translate="{{$ctrl.messages.msg}}"></span> <p> <a href="" ng-hide="$ctrl.isShowErrorDetail" ng-click="$ctrl.toggleShowErrorDetail()" translate="{{$ctrl.messages.display}}"></a> </p> <p> <a href="" ng-show="$ctrl.isShowErrorDetail" ng-click="$ctrl.toggleShowErrorDetail()" translate="{{$ctrl.messages.hide}}"></a> </p> <br> <p ng-show="$ctrl.isShowErrorDetail" class="ng-hide" style="white-space: pre-wrap; color: #6f1400"> {{$ctrl.error}} </p> </div> <div class="modal-footer"> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.editor.invalid.cancel"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.continue()"> <span class="glyphicon glyphicon-triangle-right"></span> <span translate="userApp.editor.invalid.continue"></span> </button> </div>');
$templateCache.put('scripts/pre-upgrade/components/editor/popup/validate-html-content.html','<div class="modal-header"> <div class="title" translate="userApp.editorialEntity.validationModal.title"></div> </div> <div class="modal-body"> <ul class="validate-errors-list"> <li ng-repeat="error in $ctrl.errors">{{error.error}}</li> </ul> </div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-click="$ctrl.save()"> <span translate="userApp.editorialEntity.validationModal.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.validationModal.cancel"></span> </button> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-entity-form/create-entity-form.html','<div> <div class="modal-header"> <div class="title"> <h5 style="font-size: 24px;"> <span translate="userApp.editorialEntity.home.createLabel" translate-values="{eetWording: \'{{editorialEntity.editorialEntityTemplate.wording}}\'}"></span> <span ng-if="$ctrl.showAdvanced"> - {{ \'entity.home.chooseContent\' | translate}}</span> </h5> </div> </div> <form name="createForm" role="form" class="form-horizontal" novalidate=""> <div class="modal-body">  <div class="alert alert-danger" role="alert" ng-if="$ctrl.errorExistEntityWithSomeMetaDiscriminants"> <span translate="userApp.editorialEntity.msg.errorExistEntityWithSomeMetaDiscriminants"></span> </div>   <div ng-show="!$ctrl.showAdvanced"> <div ng-show="!$ctrl.isMedia" class="form-group form-group-sm required"> <div class="col-sm-4 col-lg-2"> <label for="groupList" class="control-label"> <span translate="userApp.editorialEntity.home.model"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <select class="form-control" ng-model="$ctrl.editorialEntity.modelFlashId" id="modelFlashId" ng-disabled="$ctrl.allModelsSize == 1" ng-change="$ctrl.loadMetaInstance($ctrl.editorialEntity.modelFlashId)" ng-options="key as value|translate for (key,value) in $ctrl.allModels"> </select> </div> </div>  <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" owner-group="$ctrl.ownerGroup" edit="true" show-meta-product="true" display-group="false"></product-group>  <system-author label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" edit-authors="false"></system-author>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.titleField"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <text-area-with-menu html-text="$ctrl.htmlTitle" show-remaining-characters-helper="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.editorialEntity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> </div>  <meta-data-field meta-data-instance="metaDataInstance" ng-repeat="metaDataInstance in $ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList" product-code="$ctrl.editorialEntity.ownerGroup" form="createForm" lang="$ctrl.lang" display="false" max-size-media="$ctrl.maxSizeMedia" eet-id="$ctrl.editorialEntity.editorialEntityTemplate.identifier" current-user="$ctrl.currentUser" is-creating-entity="true"></meta-data-field>  <div ng-if="$ctrl.editorialEntity.editorialEntityTemplate.contentType === \'TREE\' && $ctrl.editorialEntity.editorialEntityTemplate.automaticMounting"> <div class="checkbox" ng-if="!$ctrl.showAutoMountingFilters || $ctrl.isAllMasked"> <label> <input type="checkbox" ng-model="$ctrl.showAutoMountingFilters"> <span translate="entity.home.automaticFilters"></span> </label> </div> <fieldset class="ecm-fieldset" ng-if="$ctrl.showAutoMountingFilters && ! $ctrl.isAllMasked"> <legend> <div class="checkbox"> <label> <input type="checkbox" ng-model="$ctrl.showAutoMountingFilters"> <span translate="entity.home.automaticFilters"></span> </label> </div> </legend> <search-solr-filter ng-if="$ctrl.showAutoMountingFilters" filters="$ctrl.rawFilters" mounting-rt="$ctrl.mountingRt"></search-solr-filter> </fieldset> </div> </div> <entity-auto-mount ng-if="$ctrl.showAdvanced" exact-match="$ctrl.exactMatch" approximate-match="$ctrl.approximateMatch" exact-match-selected="$ctrl.exactMatchSelected" columns="$ctrl.columns" approximate-match-selected="$ctrl.approximateMatchSelected" exact-filters-display="$ctrl.exactFiltersDisplay"></entity-auto-mount> <closeable-html-preview preview="$ctrl.preview" mode="full" on-refresh-page="$ctrl.next()" on-close="$ctrl.closePreview()"></closeable-html-preview> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="button" ng-click="$ctrl.previous()" ng-if="$ctrl.showAutoMountingFilters && $ctrl.showAdvanced" class="btn btn-primary"> <span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.previous"></span> </button> <button ng-click="$ctrl.save(true)" ng-show="( ($ctrl.editorialEntity.editorialEntityTemplate.contentType == \'TREE\' && (!$ctrl.showAutoMountingFilters || $ctrl.showAdvanced)) || ($ctrl.editorialEntity.editorialEntityTemplate.contentType ==\'STRUCTUREDTEXT\' && $ctrl.editorialEntity.editorialEntityTemplate.usedFlashEditor) )" class="btn btn-primary" ng-disabled="createForm.$submitted || createForm.$invalid || $ctrl.isNotAllMediasAssigned() || $ctrl.isNotEditPossible() || $ctrl.isNotTreeAssigned() || $ctrl.isMetadataUniqueValueViolated() || $ctrl.titleMaxLengthViolation"> <span translate="entity.action.createAndEdit"></span> </button> <button ng-click="$ctrl.save(false)" ng-show="!$ctrl.showAutoMountingFilters || $ctrl.showAdvanced" class="btn btn-primary" ng-disabled="createForm.$submitted || createForm.$invalid || $ctrl.isNotAllMediasAssigned() || $ctrl.isNotTreeAssigned() || $ctrl.isMetadataUniqueValueViolated() || $ctrl.titleMaxLengthViolation"> <span translate="entity.action.create"></span> </button> <button type="button" ng-click="$ctrl.next()" ng-if="$ctrl.showAutoMountingFilters && !$ctrl.showAdvanced" class="btn btn-primary" ng-disabled="createForm.$submitted || createForm.$invalid || $ctrl.isNotAllMediasAssigned() || $ctrl.isNotTreeAssigned() || $ctrl.isMetadataUniqueValueViolated() || $ctrl.titleMaxLengthViolation || $ctrl.isMandatoryMountingFiltersEmpty()"> <span translate="entity.action.next"></span> <span class="glyphicon glyphicon-arrow-right"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-entity-modal/create-entity-modal.html','<create-entity-form entity="$ctrl.resolve.entity" current-user="$ctrl.resolve.currentUser" max-size-media="$ctrl.resolve.maxSizeMedia" all-models-list="$ctrl.resolve.allModelsList" meta-instance-list-model="$ctrl.resolve.metaInstanceListModel" close="$ctrl.close()" model-id="$ctrl.resolve.modelId" owner-group="$ctrl.resolve.ownerGroup"></create-entity-form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-intra-link/create-intra-link.component.html','<div class="modal-header">  <h5 style="font-size: 24px;"> {{\'userApp.linkingWizard.home.interLinkingWizard\' | translate}} <h6> <span ng-bind-html="$ctrl.formatSystemTitle($ctrl.eeSourceSystemTitle)"></span> </h6> <h6> {{\'userApp.linkingWizard.home.title\' | translate}} </h6> <div> </div> </h5> </div> <form name="relationForm" class="form-horizontal flex-container-column form-horizontal flex-full" novalidate=""> <div class="modal-body flex-full" ng-switch="$ctrl.currentStep.name"> <div id="wizard-container" class="flex-container-column"> <div id="wizard-content-container" class="flex-full">  <choose-tree ng-switch-when="chooseTree" parents="$ctrl.parents" parent-chosen="$ctrl.parentChosen(slectedParent)"></choose-tree>  <choose-ee-from-tree ng-switch-when="chooseEeFromTree" entity="$ctrl.entity" tee-codes="$ctrl.teeCodes" selected-element="$ctrl.selectedElement" entity-flash-id="$ctrl.eeSourceFlashId"></choose-ee-from-tree> <div ng-if="$ctrl.noSourceFound"> <span translate="userApp.linkingWizard.home.noSourceFound"></span> </div> </div> </div> </div> <div class="modal-footer"> <div class="pull-left" ng-if="$ctrl.currentStep.id>= $ctrl.steps.length"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div id="wizard-navigation-container"> <div class="pull-right"> <button ng-hide="($ctrl.currentStep.id === 1) || $ctrl.noSourceFound" class="btn btn-default sidebar-open" name="previous" type="button" ng-click="$ctrl.gotoStep(false, true)"> <i class="fa fa-arrow-left"></i> <span translate="userApp.linkingWizard.action.previous"></span> </button> <button ng-hide="($ctrl.currentStep.id=== $ctrl.steps.length) || $ctrl.noSourceFound" ng-disabled="$ctrl.nextDisabled" class="btn btn-primary sidebar-open" name="next" type="button" ng-click="$ctrl.gotoStep(true, false)"> <span translate="userApp.linkingWizard.action.next"></span> <i class="fa fa-arrow-right"></i> </button> <button ng-hide="($ctrl.currentStep.id !== $ctrl.steps.length) || $ctrl.noSourceFound" ng-disabled="relationForm.$invalid || !$ctrl.selectedElement" class="btn btn-primary sidebar-open" name="next" type="button" ng-click="$ctrl.confirm()"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.linkingWizard.action.save"></span> </button> <button ng-if="$ctrl.noSourceFound" class="btn btn-primary sidebar-open" name="next" type="button" ng-click="$ctrl.dismiss()"> <i class="glyphicon glyphicon-ok"></i> <span translate="userApp.linkingWizard.action.ok"></span> </button> <button ng-hide="$ctrl.noSourceFound" type="button" class="btn btn-default" ng-click="$ctrl.dismiss()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.linkingWizard.action.cancel"></span> </button> </div> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-link/create-link.component.html','<div class="modal-header"> <div class="title"> <h5 style="font-size: 24px;"> {{\'userApp.linkingWizard.home.linkingWizard\' | translate}} - <span class="ecm-wizard-current-step"> {{\'userApp.linkingWizard.home.\'+$ctrl.currentStep.name | translate}}</span> </h5> <h6 class="ecm-wizard-breadcrumb"> <span ng-bind-html="$ctrl.formatSystemTitle($ctrl.eeSourceSystemTitle)"></span> <span style="font-size:12px; font-weight: bold;" ng-repeat="bc in $ctrl.breadCrumb"> <span ng-if="bc.value" class="text-ellipsis">> {{bc.value}} </span> </span> </h6> </div> </div> <form name="relationForm" class="flex-container-column flex-full" novalidate=""> <div class="modal-body flex-full" ng-switch="$ctrl.currentStep.name"> <div id="wizard-container" class="flex-container-column"> <div id="wizard-content-container" class="flex-full">  <choose-editorial-entity enable-multi-e-e-target-selection="$ctrl.enableMultiEETargetSelection" ng-switch-when="chooseEditorialEntity" tir-id="$ctrl.tirId" ee-target-chosen="$ctrl.eeTargetChosen(eeTarget)" on-select-all-change="$ctrl.onSelectAllChange()" selected-ee="$ctrl.selectEE" ee-list-checked="$ctrl.eeListChecked" on-select-row-change="$ctrl.onSelectRowChange(row)" ee-selected="$ctrl.eeSelected" link-text="$ctrl.linkText" search-flash-id="$ctrl.searchFlashId" node-flash-id="$ctrl.nodeFlashId" tr-code="$ctrl.relationshipTemplateSel.code" bread-crumb="$ctrl.breadCrumb" current-step="$ctrl.currentStep" search-solr="$ctrl.searchSolr"></choose-editorial-entity>  <choose-relationship ng-switch-when="chooseRelationship" relationship-template-list="$ctrl.relationshipTemplateList" selected-value="$ctrl.selectedValue" ee-list-checked="$ctrl.eeListChecked" prepare-first-step="$ctrl.prepareFirstStep(relationshipTemplate)" current-step="$ctrl.currentStep" goto-step="$ctrl.gotoStep(newStep)" bread-crumb="$ctrl.breadCrumb"> </choose-relationship>  <enter-relationship-metadata ng-switch-when="enterRelationshipMetadatas" meta-data="$ctrl.metaDataInstanceDTOList" relation-template="$ctrl.relationshipTemplateSel" multi-relation="$ctrl.multiRelation" target-entities="$ctrl.targetEntities" relations="$ctrl.relations" is-container="$ctrl.isContainer" eet-code="$ctrl.eeTarget.editorialEntityTemplate.code" owner-group="$ctrl.ownerGroup" desired-publication-date="$ctrl.desiredPublicationDate" ee-target-flash-id="$ctrl.eeTarget.identifier" is-linked-relation="$ctrl.isLinkedRelation"></enter-relationship-metadata>  <point-to-sub-element ng-switch-when="pointToSubElement" ee-target="$ctrl.eeTarget" point-to-sub-element="$ctrl.pointToSubElement" type-ee="$ctrl.typeEE" contains-sub-element="$ctrl.containsSubElement" selected="$ctrl.selected" on-node-check="$ctrl.onNodeCheck(checkedNode)" on-node-action="$ctrl.onNodeAction(checkedNode)" wording="$ctrl.eeTarget.system.systemTitle"></point-to-sub-element> </div> </div> </div> <div class="modal-footer"> <div class="pull-left" ng-if="$ctrl.currentStep.step>= $ctrl.steps.length"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div id="wizard-navigation-container"> <div class="pull-right"> <button ng-hide="$ctrl.currentStep.step === 1" class="btn btn-default sidebar-open" name="previous" type="button" ng-click="$ctrl.gotoStep($ctrl.currentStep.step - 1)"> <i class="fa fa-arrow-left"></i> <span translate="userApp.linkingWizard.action.previous"></span> </button> <button ng-hide="$ctrl.currentStep.step=== $ctrl.steps.length" ng-disabled="$ctrl.nextDisabled" class="btn btn-primary sidebar-open" name="next" type="button" ng-click="$ctrl.gotoStep($ctrl.currentStep.step + 1)"> <span translate="userApp.linkingWizard.action.next"></span> <i class="fa fa-arrow-right"></i> </button> <button ng-hide="$ctrl.currentStep.step !== $ctrl.steps.length" ng-disabled="relationForm.$invalid || $ctrl.isMetadataUniqueValueViolated() || $ctrl.nextDisabled" class="btn btn-primary sidebar-open" name="next" type="button" ng-click="$ctrl.confirm()"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.linkingWizard.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.dismiss()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.linkingWizard.action.cancel"></span> </button> </div> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/edit-entity-title/edit-entity-title.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.editEntityTitle.labels.title"></h2> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <form name="editForm" role="form" class="form-horizontal"> <div class="modal-body">  <div class="form-group form-group-sm"> <div class="col-sm-3"> <label class="control-label">{{\'userApp.editEntityTitle.labels.titleField\' | translate}}</label> </div> </div>  <text-area-with-menu html-text="$ctrl.htmlTitle" show-remaining-characters-helper="$ctrl.entity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.entity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> <div class="modal-footer"> <div class="pull-right"> <button type="button" ng-disabled="editForm.$invalid || $ctrl.titleMaxLengthViolation" class="btn btn-primary" ng-click="$ctrl.save()"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/edit-metadata-form-modal.html','<edit-metadata-form-component max-size-media="$ctrl.maxSizeMedia" meta-data-by-meta-group="$ctrl.metaDataByMetaGroup" flash-id="$ctrl.flashId" is-accept-proposal="$ctrl.isAcceptProposal" type="$ctrl.type" entity="$ctrl.editorialEntity" product-code="$ctrl.productCode" auto-redirect="$ctrl.autoRedirect" code-eet="$ctrl.codeEet" eet-id="$ctrl.eetId" current-user="$ctrl.currentUser" modal-title="$ctrl.modalTitle" edit-meta-use-case="$ctrl.editMetaUseCase" current-products="$ctrl.currentProducts" all-models="$ctrl.allModels" product-suggested-publication-date="$ctrl.productSuggestedPublicationDate" on-close="$ctrl.onClose($value)" on-dismiss="$ctrl.onDismiss($value)" not-unlock-after-save-meta="$ctrl.notUnlockAfterSaveMeta"></edit-metadata-form-component>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/edit-metadata-form.html','<div class="edit-meta-modal"> <div class="modal-header edit-meta-modal-header"> <div class="title"> <h2>{{$ctrl.modalTitle | translate}}</h2> </div> </div>  <div class="alert alert-danger" role="alert" ng-if="$ctrl.errorExistEntityWithSomeMetaDiscriminants"> <span translate="userApp.editorialEntity.msg.errorExistEntityWithSomeMetaDiscriminants"></span> </div> <form name="editForm" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.validateAndSave(false, false, editForm)"> <div> <div class="modal-body edit-meta-modal-body" ng-class="{\'bg-white\': $ctrl.isForm || $ctrl.showEmptyMetaDataListMessage}"> <div ng-if="!$ctrl.isForm"> <ul ng-if="metaDataByGrp.metaGroupName != \'CALCULEE\'" ng-repeat="metaDataByGrp in $ctrl.metaDataByMetaGroup"> <div class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title">{{metaDataByGrp.metaGroupName}}</h5> </div> <div class="panel-body"> <div> <meta-data-field meta-data-instance="metaInstance" product-code="$ctrl.productCode" ng-repeat="metaInstance in metaDataByGrp.metaDataInstanceDTOList track by $index" form="editForm" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" ee-source-flash-id="$ctrl.flashId" eet-id="$ctrl.eetId" eet-code="$ctrl.codeEET" current-user="$ctrl.currentUser" published="$ctrl.isEntityPublished()"></meta-data-field> </div> </div> </div> </ul> </div>  <div ng-if="$ctrl.isForm" class="bg-white"> <div ng-if="$ctrl.isFormEntityCreation()" class="form-group form-group-sm required"> <div class="col-sm-4 col-lg-2"> <label for="modelFlashId" class="control-label"> <span translate="userApp.editorialEntity.home.model"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <select class="form-control" ng-model="$ctrl.editorialEntity.modelFlashId" id="modelFlashId" ng-disabled="$ctrl.allModelsSize == 1" ng-change="$ctrl.loadMetaInstance()" ng-options="key as value|translate for (key,value) in $ctrl.allModels"> </select> </div> </div>  <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" owner-group="$ctrl.editorialEntity.ownerGroup" edit="$ctrl.isFormEntityCreation()" show-meta-product="true" display-group="false"></product-group>  <system-author label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" edit-authors="!$ctrl.isFormEntityCreation()"></system-author>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.titleField"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <text-area-with-menu html-text="$ctrl.htmlTitle" show-remaining-characters-helper="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.editorialEntity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> </div> <meta-data-field meta-data-instance="metaInstance" product-code="$ctrl.productCode" ng-repeat-start="metaInstance in $ctrl.metaDatas track by $index" form="editForm" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" ee-source-flash-id="$ctrl.flashId" eet-id="$ctrl.eetId" current-user="$ctrl.currentUser" published="$ctrl.isEntityPublished()" eet-code="$ctrl.codeEET"></meta-data-field> <div ng-if="metaInstance.metaDataDTO.code === $ctrl.addContentAfterCode || (!$ctrl.addContentAfterCode && $last)" ng-repeat-end="">  <div class="form-group form-group-sm"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span>Contenu</span> </label> </div> <div class="col-sm-8 col-lg-10"> <ecm-inline-editor id="$ctrl.flashId" product-code="$ctrl.productCode" loaded="$ctrl.loaded" load-on-init="!$ctrl.isMetaInstanceReloaded()" set-adapter="$ctrl.setContentAdapter(adapter)"> </ecm-inline-editor> </div> </div> </div> <div ng-if="!$ctrl.metaDatas || $ctrl.metaDatas.length===0">  <div class="form-group form-group-sm"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span>Contenu</span> </label> </div> <div class="col-sm-8 col-lg-10"> <ecm-inline-editor id="$ctrl.flashId" product-code="$ctrl.productCode" loaded="$ctrl.loaded" load-on-init="!$ctrl.isMetaInstanceReloaded()" set-adapter="$ctrl.setContentAdapter(adapter)"> </ecm-inline-editor> </div> </div> </div> </div>  <div ng-if="$ctrl.isProduct" class="panel panel-default"> <div class="panel-body"> <div class="form-group form-group-sm"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-4 col-lg-10"> <ecm-datepicker name="productSuggestedPublicationDate" ng-required="true" ng-model="$ctrl.productSuggestedPublicationDate"></ecm-datepicker> </div> </div> </div> </div>  <div ng-if="$ctrl.isEntity"> <div class="panel panel-default"> <div class="panel-heading clearfix"> <legend> <span translate="userApp.product.home.proposalTitle"></span> </legend> </div> <div class="panel-body"> <edit-products entity-flash-id="$ctrl.flashId" entity-title="$ctrl.entityTitle" tee-code="$ctrl.codeEET" current-products="$ctrl.currentProducts" proposal-products="$ctrl.proposalProducts" is-edit-metadata-modal="true" is-form-entity-creation="$ctrl.isFormEntityCreation()" hide-principal-product="$ctrl.isForm"></edit-products> </div> </div> </div> <div ng-if="$ctrl.showEmptyMetaDataListMessage"> <p translate="userApp.editorialEntity.msg.emptyMetaDataList"></p> </div> </div> <div class="modal-footer edit-meta-modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button ng-if="$ctrl.displayStepsButtons()" ng-click="$ctrl.saveMetasAndGoNextStep(step)" ng-repeat="step in $ctrl.editorialEntity.workFlowHistoryDTO.currentStep.nextSteps" type="button" class="btn btn-primary" ng-disabled="$ctrl.saveDisabled(editForm)"> <span>{{step.name}}</span> </button> <button ng-if="$ctrl.isForm" type="button" class="btn btn-primary" ng-disabled="$ctrl.previewDisable(editForm)" ng-click="$ctrl.openPreviewTab()"> <span translate="userApp.editorialEntity.menu.preview"></span> </button> <button ng-if="$ctrl.isForm" type="button" class="btn btn-primary" ng-disabled="$ctrl.saveDisabled(editForm)" ng-click="$ctrl.save(true);"> <span translate="entity.action.saveAndContinue"></span> </button> <button ng-if="!$ctrl.showEmptyMetaDataListMessage" type="submit" class="btn btn-primary" ng-disabled="$ctrl.saveDisabled(editForm)"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button ng-if="$ctrl.showCancelButton()" type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/editorial-entity-edit-menu/editorial-entity-edit-menu.html','<div class="c-submenu clearfix"> <div class="pull-left"> <ul class="submenu list-unstyled"> <li>  <a href="" translate="userApp.editorialEntity.menu.file"></a> <ul class="ecm-submenu-dropdown list-unstyled"> <li ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus"> <a href="" ng-click="$ctrl.openWorkflowModal()" translate="userApp.editorialEntity.menu.init" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'INIT_WFW_UPDATE\')}"></a> </li> <li ng-if="!$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus"> <a href="" ng-click="$ctrl.openWorkflowModal()" translate="userApp.editorialEntity.menu.stepWork" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'CHANGE_WFW_UPDATE\')}"></a> </li> <li class="sep"></li> <li> <a href="" ng-click="$ctrl.editProductGroupModal(editorialEntity)" translate="userApp.editorialEntity.menu.productGroup" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'EDIT_PRODUCT_GROUP\')}"></a> </li> <li> <a href="" ng-click="$ctrl.editAuthor(editorialEntity)" translate="userApp.editorialEntity.menu.editAuthor" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'EDIT_AUTHORS\')}"></a> </li> <li ng-if="!$ctrl.isMedia"> <a href="" ng-click="$ctrl.editProducts()" translate="userApp.editorialEntity.menu.editProducts" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'MANAGE_PRODUCTS\')}"></a> </li> <li> <a href="" ng-click="$ctrl.duplicateEEModal(editorialEntity)" translate="userApp.editorialEntity.menu.dup" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'DUPLICATE\')}"></a> </li> <li ng-if="$ctrl.tree && !$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.cloneEEModal(editorialEntity)" translate="userApp.editorialEntity.menu.clone" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'CLONE\')}"></a> </li> <li ng-if="$ctrl.isConversionToNewTeePermittedForContentType"> <a href="" ng-click="$ctrl.convert(true)" translate="userApp.editorialEntity.menu.convertToNewEntity" ng-class="{\'disabled\': $ctrl.checkEnablingOfConvert()}"></a> </li> <li ng-if="$ctrl.isTS"> <a href="" ng-click="$ctrl.convert(false)" translate="userApp.editorialEntity.menu.convert" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'CONVERT\')}"></a> </li> <li ng-if="!$ctrl.isMedia"> <a href="" ng-click="$ctrl.saveEEAsModal()" translate="userApp.editorialEntity.menu.save" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'SAVE_AS_MODEL\')}"></a> </li> <li class="sep"></li> <li> <a href="" ng-click="$ctrl.validateEEModal()" translate="userApp.editorialEntity.menu.valid" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'VALIDATE_EE\')}"></a> </li> <li ng-if="!$ctrl.isMedia && !$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.publishModal();" translate="userApp.editorialEntity.menu.pub" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'PUBLISH\') }"></a> </li> <li ng-if="!$ctrl.isMedia && !$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.proofModal()" translate="userApp.editorialEntity.menu.proof" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'PROOF\')}"></a> </li> <li ng-if="!$ctrl.isHooksExternalEntities" class="sep"></li> <li ng-if="!$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.exportXMLContent()" translate="userApp.editorialEntity.menu.exportXML"></a> </li>  <li ng-if="!$ctrl.isMedia && !$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.openPreviewTab()" translate="userApp.editorialEntity.menu.preview" ng-class="{\'disabled\': !$ctrl.isFullPreviewPossible}"></a> </li> <li class="sep"></li> <li> <a href="" ng-click="$ctrl.launcherLinkEEWizard()" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'HOOK\') }" translate="userApp.editorialEntity.menu.hang"></a> </li> <li ng-if="!$ctrl.isMedia && !$ctrl.isHooksExternalEntities"> <a href="" ng-click="$ctrl.launchCreateAndHookEeWizard()" ng-disabled="$ctrl.hasNoPermission(\'CREATE_LINK_EE\')" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'CREATE_LINK_EE\')}" translate="userApp.editorialEntity.menu.createAndHook"></a> </li> <li class="sep"></li> <li> <a href="" ng-click="$ctrl.lockEditorialEntity()" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'LOCK\')}" translate="userApp.editorialEntity.menu.verrou"></a> </li> <li> <a href="" ng-click="$ctrl.unlockEditorialEntity()" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'UNLOCK\')}" translate="userApp.editorialEntity.menu.deverrou"></a> </li> <li class="sep"></li> <li> <a href="" ng-click="$ctrl.archiveEEModal()" translate="userApp.editorialEntity.menu.archiv" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'ARCHIVE\')}"></a> </li> </ul> </li> <li>  <a href="" translate="userApp.editorialEntity.menu.edition"></a> <ul class="ecm-submenu-dropdown list-unstyled"> <li class="experimental" ng-if="$ctrl.tree" ui-sref-active="selected"> <a ui-sref=".multiEditorMain" ng-click="$ctrl.switchDisplayMode(\'NONE\')">Edition int\xE9gr\xE9e</a> </li> <li class="sep" ng-if="!$ctrl.isForm"></li> <li> <a href="" ng-click="$ctrl.onOpenEditMetaModal()" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'INIT_AND_EDIT_META\')}"> {{($ctrl.isForm ? \'userApp.editorialEntity.menu.editForm\' : \'userApp.editorialEntity.menu.editMeta\') | translate}} </a> </li> <li class="sep" ng-if="!$ctrl.isForm"></li> <li ng-if="$ctrl.isMedia" ng-class="{selected: $ctrl.editorialEntity.editingMedia === true, \'disabled\':false}"> <a href="" ng-click="$ctrl.manageEditingMedia()" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'EDIT_CONTENT\')}">{{($ctrl.editorialEntity.editingMedia === true ? \'entity.action.leaveEditMedia\' : \'entity.action.editMedia\') | translate}}</a> </li> <li ng-if="!$ctrl.isForm"> <a ng-click="$ctrl.onEditContent()" href="" translate="userApp.editorialEntity.menu.edit" ng-show="$ctrl.editorialEntity.editorialEntityTemplate.contentType === \'STRUCTUREDTEXT\'" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'INIT_AND_EDIT_CONTENT\') || $ctrl.editorialEntity.editorialEntityTemplate.contentType != \'STRUCTUREDTEXT\'}"></a> </li> <li ng-if="$ctrl.tree"> <a ng-click="$ctrl.onEditContent()" href="" translate="userApp.editorialEntity.menu.treeEEStructureEdition" ng-class="{\'disabled\': $ctrl.hasNoPermission(\'INIT_AND_EDIT_CONTENT\') || $ctrl.editorialEntity.editorialEntityTemplate.contentType != \'TREE\'}"></a> </li> </ul> </li> <li ng-if="!$ctrl.isMedia">  <a href="" translate="userApp.editorialEntity.menu.disp"></a> <ul class="ecm-submenu-dropdown list-unstyled"> <li ng-if="$ctrl.tree" ng-class="{selected: $ctrl.isViewSelected(\'DISPLAY_TREE_VIEW\'), \'disabled\':false}"> <a href="" translate="userApp.editorialEntity.menu.treeview" ng-click="$ctrl.switchDisplayMode(\'DISPLAY_TREE_VIEW\')"></a> </li>  <li ng-if="$ctrl.tree && !$ctrl.isHooksExternalEntities" ui-sref-active="selected" ng-class="{\'disabled\':false}"> <a ui-sref=".table" ng-click="$ctrl.switchDisplayMode(\'NONE\')" translate="userApp.editorialEntity.menu.board"></a> </li> <li ng-class="{selected: $ctrl.isViewSelected(\'DISPLAY_METADATA\'), \'disabled\':false}"> <a href="" ng-click="$ctrl.switchDisplayMode(\'DISPLAY_METADATA\')"> <span>{{ ($ctrl.isTreeOrReferenceNode ? \'userApp.editorialEntity.menu.metadata\' : \'userApp.editorialEntity.menu.metadataAndContent\') | translate }}</span> </a> </li>  <li ng-if="$ctrl.editorialEntity.editorialEntityTemplate.contentType == \'STRUCTUREDTEXT\'" ng-class="{selected: $ctrl.displayMode == \'DISPLAY_TOC\', \'disabled\':false}"> <a href="" ng-show="$ctrl.isSummaryViewPossible" translate="userApp.editorialEntity.menu.toc" ng-click="$ctrl.switchDisplayMode(\'DISPLAY_TOC\')"></a> </li>  <li ng-if="$ctrl.editorialEntity.editorialEntityTemplate.contentType == \'STRUCTUREDTEXT\'" ng-class="{selected: $ctrl.displayMode == \'DISPLAY_CONTENT_ONLY\', \'disabled\':false}"> <a href="" ng-click="$ctrl.switchDisplayMode(\'DISPLAY_CONTENT_ONLY\')"> {{($ctrl.isForm ? \'userApp.editorialEntity.menu.contentForm\' : \'userApp.editorialEntity.menu.content\') | translate}} </a> </li>  <li ui-sref-active="selected"> <a ui-sref=".timeline" ng-click="$ctrl.switchDisplayMode(\'NONE\')" ng-class="{\'disabled\': !$ctrl.isActivateVersioning}" translate="userApp.editorialEntity.menu.timeline"></a> </li> </ul> </li> <li>  <a href="" translate="userApp.editorialEntity.menu.links"></a> <ul class="ecm-submenu-dropdown list-unstyled"> <li ui-sref-active="selected"> <a ui-sref=".hooks" ng-click="$ctrl.switchDisplayMode(\'NONE\')" ng-class="{ \'disabled\': ($ctrl.linkInfosMap[\'HOOKS\'] === 0)}">{{\'userApp.editorialEntity.menu.hooks\' | translate}} ({{$ctrl.linkInfosMap[\'HOOKS\']}})</a> </li> <li ui-sref-active="selected"> <a ui-sref=".duplicate" ng-click="$ctrl.switchDisplayMode(\'NONE\')" ng-class="{ \'disabled\': ($ctrl.linkInfosMap[\'DUPLICATES\'] === 0)}">{{\'userApp.editorialEntity.menu.duplicate\' | translate}} ({{$ctrl.linkInfosMap[\'DUPLICATES\']}})</a> </li> </ul> </li> <li ng-if="!$ctrl.isMedia && !$ctrl.isHooksExternalEntities"> <a href="" translate="userApp.editorialEntity.menu.info"></a> <ul class="ecm-submenu-dropdown list-unstyled"> <li ui-sref-active="selected"> <a ui-sref=".proofHistory" ng-click="$ctrl.switchDisplayMode(\'NONE\')" translate="userApp.editorialEntity.menu.pubHist"></a> </li> </ul> </li> <li ng-if="$ctrl.editorialEntity.editorialEntityTemplate.actions"> <a href="" translate="userApp.editorialEntity.menu.tools"></a> <ul class="ecm-submenu-dropdown list-unstyled" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.actions"> <li ng-repeat="action in $ctrl.editorialEntity.editorialEntityTemplate.actions"> <a href="" style="opacity: 0.3;">{{action.name}}</a> </li> </ul> </li> </ul> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/ee-link-infos/ee-link-infos.html','<div class="container-fluid no-padding bg-white listing-w-preview"> <div class="full-height no-overflow"> <div class="col-sm-12 full-height flex-container-column"> <div class="row voffset3"> <div class="col-sm-12 ecm-table-layout">  <form class="ecm-filter-zone"> <div ng-if="$ctrl.linkInfosType != \'DUPLICATES\'" class="form-group form-group-sm"> <label translate="userApp.eeLinkInfos.labels.eet"></label> <select class="form-control" ng-model="$ctrl.searchEEsDTO.eetCodeFilter" ng-change="$ctrl.doFilter()"> <option value="">{{\'userApp.eeLinkInfos.labels.noEetWording\' | translate}}</option> <option ng-repeat="eet in $ctrl.eetListFilter" value="{{eet.code}}">{{eet.wording}}</option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.eeLinkInfos.labels.status"></label> <select class="form-control" ng-model="$ctrl.searchEEsDTO.statusFilter" ng-change="$ctrl.doFilter()"> <option value="">{{\'userApp.eeLinkInfos.labels.noStatus\' | translate}}</option> <option ng-repeat="status in $ctrl.statusListFilter" value="{{status}}">{{status}}</option> </select> </div> </form> </div> </div> <div class="row voffset3"> <div class="col-sm-12"> <p ng-if="$ctrl.totalItemCount > 0"> {{$ctrl.totalItemCount}}&nbsp; <span translate="userApp.eeLinkInfos.labels.resultsNumber"></span> </p> </div> </div> <div class="row flex-full no-overflow"> <div class="col-sm-12 full-height scrollable"> <table id="table_{{$ctrl.linkInfosType}}" ecm-ultimate-table="static" st-pipe="$ctrl.doSort" st-table="$ctrl.eeList" class="table table-striped table-hover table-fixed"> <thead> <tr> <th id="selector" class="icon-column" no-drag="" no-resize=""></th> <th id="relationStatus" ng-if="$ctrl.linkInfosType != \'DUPLICATES\'" class="icon-column-2x" no-drag="" no-resize=""></th> <th id="label" translate="userApp.eeLinkInfos.labels.label"></th> <th id="eet" ng-if="$ctrl.linkInfosType != \'DUPLICATES\'" translate="userApp.eeLinkInfos.labels.eet"></th> <th id="duplication" ng-if="$ctrl.linkInfosType == \'DUPLICATES\'" translate="userApp.eeLinkInfos.labels.duplication"></th> <th id="linkDate" ng-if="$ctrl.linkInfosType != \'DUPLICATES\'" st-sort="linkDate" translate="userApp.eeLinkInfos.labels.linkDate" class="sortable"></th> <th class="col-sm-3" id="linkMetaData" ng-if="$ctrl.linkInfosType != \'DUPLICATES\'" translate="userApp.eeLinkInfos.labels.linkMetaData"></th> <th id="status" translate="userApp.eeLinkInfos.labels.status"></th> <th id="availability" translate="userApp.eeLinkInfos.labels.availability"></th> </tr> </thead> <tbody> <tr ng-repeat="ee in $ctrl.eeList" class="sidebar-open" ng-click="$ctrl.openPreview(ee)" ng-class="{\'disabled-node\' : $ctrl.linkInfosType != \'DUPLICATES\' && !ee.activated}"> <td> <a style="cursor: pointer" uib-tooltip="{{\'userApp.searchInterfaceTemplate.home.goToEE\'|translate}}" ui-sref="editorialEntity({ id: ee.flashId})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td class="icon-column-2x" ng-if="$ctrl.linkInfosType != \'DUPLICATES\'"> <relation-status-icon disabled="!ee.activated" relation-status="ee.relationStatus"></relation-status-icon> </td> <td> <div style="max-width: 500px;" ng-if="ee.flashId != null"> <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"> <span>{{$ctrl.formatSystemTitle(ee.systemTitle)}}</span> <md-tooltip md-delay="100" md-direction="bottom"> {{ $ctrl.formatSystemTitle(ee.systemTitle)}} </md-tooltip> </div> </div> <p ng-bind-html="$ctrl.formatSystemTitle(ee.systemTitle)" ng-if="ee.flashId == null"></p> </td> <td ng-if="$ctrl.linkInfosType != \'DUPLICATES\'"> {{ee.eetWording}} </td> <td ng-if="$ctrl.linkInfosType == \'DUPLICATES\'"> {{\'userApp.eeLinkInfos.labels.\' + ee.duplication | translate}} </td> <td ng-if="$ctrl.linkInfosType != \'DUPLICATES\'"> {{ee.linkDate | ecmDate:\'short\' }} </td> <td ng-if="$ctrl.linkInfosType != \'DUPLICATES\'"> <div class="col-sm-12 form-horizontal meta-group"> <display-meta-values metadata-list="ee.relationMetaInstanceList"></display-meta-values> </div> </td> <td> {{ee.workFlowStepDTO.workFlowStatusName}} </td> <td> <padlock-icon color="ee.padlock.color" closed="ee.padlock.closed" owner="ee.padlock.owner.fullName" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> </tfoot> </table> <div class="text-center" ng-if="!($ctrl.eeList.length > 0)"> <span>{{\'userApp.eeLinkInfos.labels.emptyResults\' | translate}}</span> </div> <div> <ecm-pagination storage-key="eeLinkInfosPagination" total-items="$ctrl.totalItemCount" pagination-model="$ctrl.pagination" on-change="$ctrl.pageChanged()"></ecm-pagination> </div> </div> </div> </div> <closeable-html-preview preview="$ctrl.preview" mode="full"> </closeable-html-preview></div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/entity-info/entity-info.html','<div class="infos-doc"> <div class="info-logo" ng-if="$ctrl.hasLogo"> <a ng-if="$ctrl.belongToProduct()" ui-sref="productDashboard({code: $ctrl.entity.ownerGroup})"> <img ng-src="{{$ctrl.logoPath}}" alt=""> </a> <img ng-if="!$ctrl.belongToProduct()" ng-src="{{$ctrl.logoPath}}" alt=""> </div> <div class="truncate" tooltip-placement="bottom-left" tooltip-trigger="mouseenter" tooltip-class="tt-infos"> <span class="label label-default">{{$ctrl.entity.editorialEntityTemplate.wording}}</span> <div class="id-doc">{{$ctrl.entity.identifier}}</div> <i class="icon ion-information-circled" ng-class="{\'ecm-entity-has-comment\': $ctrl.showComment()}" uib-tooltip-template="\'scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-info-tooltip-light.html\'" tooltip-placement="bottom-left" popover-trigger="\'outsideClick\'" tooltip-class="tt-infos"></i> <a ng-if="$ctrl.tree" ng-click="$ctrl.getReportStatus(false)" tooltip-placement="bottom-left" tooltip-enable="$ctrl.reportStatus === \'NOT_EXIST\'" uib-tooltip="{{\'userApp.editorialEntity.reportValidation.reportNotExists\'|translate}}" uib-popover-template="\'scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-validation-tooltip.html\'" popover-trigger="\'outsideClick\'" popover-enable="$ctrl.reportStatus !== \'NOT_EXIST\'" popover-is-open="$ctrl.isOpen" popover-placement="bottom-left" style="cursor:pointer;"> <i class="icon ion-checkmark-circled"></i> </a> <div class="name-doc"> <a class="edit-title-doc" ng-if="$ctrl.checkeditPermission() && $ctrl.entity.editorialEntityTemplate.editedTitel" ng-click="$ctrl.openModalEditTitle()" href="" uib-tooltip="Editer titre" tooltip-placement="top" tooltip-append-to-body="true"> <span class="glyphicon glyphicon-edit"></span> </a> <span> <span ng-if="!$ctrl.hasTitle()" class="ecm-no-title" translate="userApp.editorialEntity.home.noTitle"></span> <span class="inline-title" ng-bind-html="$ctrl.entity.titleSystem" ng-if="$ctrl.hasTitle()"></span> <md-tooltip ng-if="$ctrl.entity.titleSystem" class="md-subhead"> <div class="infos-doc"> <span ng-bind-html="$ctrl.entity.titleSystem"></span> </div> </md-tooltip> </span> </div> <div class="etat-doc"> <div class="etat-doc-content"> <span ng-if="$ctrl.entity.workFlowHistoryDTO.currentStep" translate="userApp.editorialEntity.home.status"></span> <span ng-if="$ctrl.entity.workFlowHistoryDTO.currentStep">{{$ctrl.entity.workFlowHistoryDTO.currentStep.workflowStatusName}}</span> <span class="note note-warning" ng-if="!$ctrl.entity.workFlowHistoryDTO.currentStep"><i class="fa fa-warning"></i> {{\'userApp.editorialEntity.home.noStepOrStatus\' | translate}} </span> <span translate="userApp.editorialEntity.home.version"></span> <span>{{$ctrl.entity.workFlowHistoryDTO.qualifiedVersion}}</span> <span ng-repeat="metaInfo in $ctrl.infoMetaInstances"> {{metaInfo.metaDataDTO.name}}: <strong> <span ng-repeat="metaValue in $ctrl.getMetaValue(metaInfo) track by $index"> {{metaValue | ecmDate }} <span ng-if="!$last">,</span> </span> </strong> </span> </div> <div> <a href="" uib-tooltip="{{ \'userApp.editorialEntity.home.goToOrigin\'|translate}}" tooltip-placement="top" ng-show="$ctrl.entity.duplicatedEditorialEntityFlashId" ui-sref="editorialEntity({id: $ctrl.entity.duplicatedEditorialEntityFlashId})" tooltip-append-to-body="true"> <span class="glyphicon glyphicon-duplicate"></span> </a> </div> </div> </div> <div class="lock-doc">  <div class="lock-doc-left"> <div ng-show="$ctrl.isLockedByMe()"> <div> <span translate="userApp.editorialEntity.msg.lockedByCurrentUser"></span> </div> </div> <div ng-if="$ctrl.isLockedByOther() && ! $ctrl.isBrokenlockedDisabled()"> <span translate="userApp.editorialEntity.msg.brockenPadlock"></span> <button ng-if="! $ctrl.isBrokenlockedDisabled()" type="button" uib-tooltip="{{ \'userApp.editorialEntity.msg.brockenPadlock\'|translate}}" tooltip-placement="bottom" class="btn btn-primary btn-xs ecm-icon-btn" ng-click="$ctrl.brokenLockedEditorialEntity()"> <i class="fa fa-unlock" aria-hidden="true"></i> </button> </div> <div ng-if="$ctrl.entity.workFlowHistoryDTO.currentStep.assignmentRole"> <span translate="userApp.editorialEntity.msg.assignmentRoleMsg" translate-values=\'{name:"{{$ctrl.entity.workFlowHistoryDTO.currentStep.assignmentRole.name}} "}\'></span> <button type="button" uib-tooltip="{{ \'userApp.editorialEntity.menu.deleteAssignRole\'|translate}}" tooltip-placement="bottom" class="btn btn-primary btn-xs ecm-icon-btn" ng-if="$ctrl.checkDeleteAssignRole()" ng-click="$ctrl.deleteAssignRole()"> <i class="fa fa-times" aria-hidden="true"></i> </button> </div> <div ng-if="$ctrl.isLockedByOther()"> <span translate="userApp.editorialEntity.msg.lockMsg"></span> <span>{{$ctrl.entity.userLock.firstName}} {{$ctrl.entity.userLock.lastName}}</span> </div> </div>  <padlock-icon color="$ctrl.entity.padlock.color" closed="$ctrl.entity.padlock.closed" owner="$ctrl.entity.padlock.owner.fullName" size="big"> </padlock-icon> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-info-tooltip-complete.html',' <div ng-if="$ctrl.isHooksExternalEntities" class="row"> <div class="col-lg-4"> </div> <div class="col-lg-8"> <span class="label label-default-tooltip" translate="userApp.editorialEntity.home.hooksExternalEntities"> </span> </div> </div>  <div class="row"> <div class="col-lg-4" translate="userApp.editorialEntity.home.createInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.creationDate | ecmDate:\'short\'}}</strong> </div> <div> <span translate="userApp.editorialEntity.home.by"></span> {{$ctrl.entity.creator}}</div> </div> </div>  <div class="row"> <div class="col-lg-4" translate="userApp.editorialEntity.home.authorsInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.authors | concatStrings}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.updater"> <div class="col-lg-4" translate="userApp.editorialEntity.home.updateInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.updateDate | ecmDate:\'short\'}}</strong> </div> <div> <span translate="userApp.editorialEntity.home.by"></span> {{$ctrl.entity.updater}}</div> </div> </div>  <div class="row" ng-if="$ctrl.entity.workFlowHistoryDTO.currentStep"> <div class="col-lg-4" translate="userApp.editorialEntity.home.statusAct"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.workFlowHistoryDTO.currentStep.workflowStatusName}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.workFlowHistoryDTO"> <div class="col-lg-4" translate="userApp.editorialEntity.home.version"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.workFlowHistoryDTO.qualifiedVersion}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.editionStatus"> <div class="col-lg-4" translate="userApp.editorialEntity.home.editionStatus"> </div> <div class="col-lg-8"> <div> <strong>{{\'userApp.editorialEntity.editionStatus.\' + $ctrl.entity.editionStatus | translate}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.ownerGroupName"> <div class="col-lg-4" translate="userApp.editorialEntity.home.selectGroupLabel"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.ownerGroupName}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.workFlowHistoryDTO.currentStep && $ctrl.entity.workFlowHistoryDTO.currentStep.assignmentRole"> <div class="col-lg-4" translate="userApp.editorialEntity.msg.assignmentRoleMsg"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.workFlowHistoryDTO.currentStep.assignmentRole.name}}</strong> </div> </div> </div>  <div class="row" ng-if="$ctrl.entity.userLock"> <div class="col-lg-4" translate="userApp.editorialEntity.msg.lockMsg"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.userLock.firstName}} {{$ctrl.entity.userLock.lastName}}</strong> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-info-tooltip-light.html','<div ng-if="$ctrl.isHooksExternalEntities" class="row"> <div class="col-lg-4"> </div> <div class="col-lg-8"> <span class="label label-default-tooltip" translate="userApp.editorialEntity.home.hooksExternalEntities"> </span> </div> </div> <div class="row"> <div class="col-lg-4" translate="userApp.editorialEntity.home.createInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.creationDate | ecmDate:\'short\'}}</strong> </div> <div> <span translate="userApp.editorialEntity.home.by"></span> {{$ctrl.entity.creator}}</div> </div> </div>  <div class="row"> <div class="col-lg-4" translate="userApp.editorialEntity.home.authorsInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.authors | concatStrings}}</strong> </div> </div> </div> <div class="row" ng-if="$ctrl.entity.updater"> <div class="col-lg-4" translate="userApp.editorialEntity.home.updateInfo"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.updateDate | ecmDate:\'short\'}}</strong> </div> <div> <span translate="userApp.editorialEntity.home.by"></span> {{$ctrl.entity.updater}}</div> </div> </div> <div class="row" ng-if="$ctrl.entity.ownerGroupName"> <div class="col-lg-4" translate="userApp.editorialEntity.home.selectGroupLabel"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.ownerGroupName}}</strong> </div> </div> </div> <div class="row" ng-if="$ctrl.entity.editionStatus"> <div class="col-lg-4" translate="userApp.editorialEntity.home.editionStatus"> </div> <div class="col-lg-8"> <div> <strong>{{\'userApp.editorialEntity.editionStatus.\' + $ctrl.entity.editionStatus | translate}}</strong> </div> </div> </div> <div class="row" ng-if="$ctrl.showComment()"> <div class="col-lg-4" translate="userApp.editorialEntity.home.comment"> </div> <div class="col-lg-8"> <div> <strong>{{$ctrl.entity.workFlowHistoryDTO.comment}}</strong> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-validation-tooltip.html','<div class="row"> <div class="col-lg-6"> <strong> <span translate="userApp.editorialEntity.reportValidation.reportStatus"></span> </strong> </div> <div class="col-lg-6"> <div ng-if="$ctrl.reportStatus === \'TERMINATED\'"> <span translate="userApp.editorialEntity.reportValidation.reportExists"></span> <a ng-click="$ctrl.openReport()" style="cursor:pointer;" translate="userApp.editorialEntity.reportValidation.display"></a> </div> <div ng-if="$ctrl.reportStatus === \'NOT_EXIST\'"> <span translate="userApp.editorialEntity.reportValidation.reportNotExists"></span> </div> <div ng-if="$ctrl.reportStatus === \'IN_PROGRESS\'"> <span translate="userApp.editorialEntity.reportValidation.reportInProgress"></span> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/media-edition-form/media-edition-form.html','<div> <div class="entity-action-bar" block-ui="actionBarUI"> <span class="actions-label" translate="entity.actionBar.actionsLabel" ng-hide="$ctrl.isConfifEmpty()"></span> <a class="action-btn btn btn-sm btn-primary" ng-disabled="!$ctrl.canEdit()" uib-tooltip="{{$ctrl.editorialEntity.editingMedia?\'entity.action.exitMediaEdition\':\'entity.action.editMedia\'|translate}}" ng-click="$ctrl.toggleMediaEditionMode()"> <i class="fa fa-lg" ng-class="{\'fa-pencil\': !$ctrl.editorialEntity.editingMedia,\'fa-times\':$ctrl.editorialEntity.editingMedia}"></i> </a> </div> <div class="ecm-media-form" ng-repeat="fileFormatInstance in $ctrl.editorialEntity.fileFormatInstances"> <fieldset class="ecm-fieldset media"> <legend>{{ fileFormatInstance.wording }} ( <span>{{ $ctrl.getJoinedExtensions(fileFormatInstance.extensions) }} </span>) </legend> <div ng-if="$ctrl.editorialEntity.editingMedia && $ctrl.canEdit()"> <i ng-if="!$ctrl.canAdd(fileFormatInstance)" class="fa fa-plus-circle fa-2x pull-right text-muted"></i> <a ng-if="$ctrl.canAdd(fileFormatInstance)" ngf-multiple="fileFormatInstance.multipleValue" ngf-accept="$ctrl.getJoinedExtensions(fileFormatInstance.extensions)" ngf-select="$ctrl.uploadAndSave($ctrl.editorialEntity.identifier, fileFormatInstance, $files)" ngf-model-options="{allowInvalid: false}"> <i class="fa fa-plus-circle fa-2x pull-right" uib-tooltip="{{\'entity.action.addfile\'|translate}}"></i> </a> </div> <div class="ecm-media-block"> <div class="ecm-media-item" ng-repeat="mediaInfo in fileFormatInstance.mediaInfos"> <div class="media-icon"> <i class="fa fa-3x" ng-class="$ctrl.getExtensionClass(mediaInfo.name)"></i> <a href="api/media/displayMedia/{{ mediaInfo.idMedia }}?getOriginalFileName=true" target="_blank"> <i class="fa fa-eye text-info" uib-tooltip="{{\'entity.action.display\'|translate}}"></i> </a> <a ng-if="$ctrl.editorialEntity.editingMedia && $ctrl.canEdit()" href="" ngf-multiple="false" ngf-accept="$ctrl.getJoinedExtensions(fileFormatInstance.extensions)" ngf-select="$ctrl.uploadAndUpdate($ctrl.editorialEntity.identifier, fileFormatInstance, $files, mediaInfo.idMedia)" ngf-model-options="{allowInvalid: false}"> <i class="fa fa-upload text-info" uib-tooltip="{{\'entity.action.update\'|translate}}"></i> </a> <i ng-if="$ctrl.editorialEntity.editingMedia && $ctrl.canEdit()" class="fa fa-trash-o text-info" ng-click="$ctrl.deleteFile($ctrl.editorialEntity.identifier, fileFormatInstance.code, mediaInfo.customFileName, mediaInfo.idMedia)" uib-tooltip="{{\'entity.action.delete\'|translate}}"></i> </div> <div class="media-name"> {{ mediaInfo.customFileName }} </div> </div> </div> </fieldset> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/publish-proof-history/publish-proof-history.html','<div class="container-fluid no-padding bg-white listing-w-preview"> <div class="header-filter"> <div class="btn-c clearfix"> <div class="pull-left"> <h2> <span translate="userApp.publish.history.title"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <form class="ecm-filter-zone"> <div class="form-group form-group-sm"> <label translate="userApp.publish.history.request"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'author\']" ng-change="$ctrl.loadAllHistrory()" ng-options="val for val in $ctrl.publiePar"> <option value=""></option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.publish.history.version"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'version\']" ng-change="$ctrl.loadAllHistrory()" ng-options="val for val in $ctrl.version"> <option value=""></option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.publish.history.type"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'type\']" ng-change="$ctrl.loadAllHistrory()" ng-options="val.value as val.label | translate for val in $ctrl.typeList"> <option value=""></option> </select> </div> </form>  <table st-pipe="$ctrl.loadTable" st-table="$ctrl.historyList" st-set-sort="betterOrderBy" st-set-filter="StrictFilter" class="table table-striped table-bordered table-hover"> <thead> <tr> <th class="sortable" st-sort="channelId.name" translate="userApp.publish.history.moteur"> </th> <th class="sortable" st-sort="version" translate="userApp.publish.history.version"></th> <th class="sortable" st-sort="user.firstName" translate="userApp.publish.history.request"></th> <th class="sortable" st-sort="creationDate" translate="userApp.publish.history.date"></th> <th class="sortable" st-sort="type" translate="userApp.publish.history.type"></th> <th class="sortable" st-sort="status" translate="userApp.publish.history.statut"></th> </tr> </thead> <tbody> <tr ng-show="$ctrl.historyList.length==0"> <td colspan="6" class="text-center"> <span translate="userApp.publish.history.NoData"></span> </td> </tr> <tr ng-repeat="row in $ctrl.historyList track by $index"> <td> {{ row.channelId }} </td> <td>{{row.version }}</td> <td>{{row.user.fullName }}</td> <td>{{row.creationDate | ecmDate:\'short\'}}</td> <td ng-if="row.type==\'PUBLISH\'">{{ \'userApp.publish.type.PUBLISH\' | translate}} </td> <td ng-if="row.type==\'PROOFING\'">{{ \'userApp.publish.type.PROOFING\' | translate }} </td> <td> <i ng-if="row.status==\'OK\'" style="color:green" aria-hidden="true"> OK</i> <i ng-if="row.status==\'KO\'" style="color:red" aria-hidden="true">KO</i> </td> </tr> </tbody> </table>  <div class="text-left"> <ecm-pagination storage-key="publicProofHistoryPagination" pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllHistrory()"></ecm-pagination> </div> </div> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/product-group.html','<div class="form-group form-group-sm"> <div class="col-sm-4" ng-class="$ctrl.labelClass"> <label for="groupList" class="control-label"> <span translate="userApp.editorialEntity.home.selectGroupLabel"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-8" ng-class="$ctrl.contentClass"> <select class="form-control" ng-model="$ctrl.entity.ownerGroup" id="groupList" ng-options="group.code as group.name for group in $ctrl.groups" ng-change="$ctrl.onChangeProductGroupValue()" ng-disabled="!$ctrl.edit" required=""> </select> </div> </div> <div ng-class="{\'col-sm-12\': $ctrl.displayGroup}" ng-if="$ctrl.isMetaProductVisible"> <product-meta-data label-class="col-lg-2" content-class="col-lg-10" ng-if="$ctrl.entity.ownerGroup" product-code="$ctrl.entity.ownerGroup" flash-id="$ctrl.entity.identifier" eet-id="$ctrl.entity.editorialEntityTemplate.identifier" entity="$ctrl.entity" display-group="$ctrl.displayGroup" typology="$ctrl.typology"></product-meta-data> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/timeline/timeline-page.html','<div class="container-fluid no-padding bg-white listing-w-preview"> <div class="full-height no-overflow"> <div class="col-sm-12 full-height flex-container-column ecm-timeline"> <div class="row voffset3">  <div class="col-sm-12"> <div class="container"> <ul class="versions"> <li class="line-start"> </li> <li class="line" ng-class="{\'current\': p.currentUpdate}" ng-click="$ctrl.loadVersion(p)" ng-repeat="p in $ctrl.versions"> <div class="entry" ng-class="{\'selected\': p.selected || p.previous, \'current\': p.currentUpdate, \'not-current\': !p.currentUpdate }"> <div class="label"> <div>{{p.qualifiedVersion}}</div> <div>{{p.initiator}}</div> <div>{{p.initiationDate | date: \'dd-MM-yyyy\'}}</div> </div> <div ng-if="p.selected" class="selection-marker"> <b class="fa fa-arrow-left"></b> Gauche</div> <div ng-if="p.previous" class="selection-marker">Droite <b class="fa fa-arrow-right"></b> </div> <div class="arrow"></div> </div> </li> </ul> </div> </div> </div> <div class="row"> <div class="col-sm-12 compare-btn"> <button ng-disabled="!$ctrl.rightSideVersion" class="btn btn-primary" ng-click="$ctrl.compare()"> {{(!$ctrl.showCompare ? \'timeline.compareBtn\' : \'timeline.backBtn\' ) | translate}} </button> </div> </div> <div ng-if="!$ctrl.showCompare" class="row" style="overflow-y: auto"> <div ng-if="$ctrl.leftSideVersion" class="col-sm-6"> <h2 class="timeline-panel-title" ng-class="{\'current\': $ctrl.leftSideVersion.currentUpdate, \'not-current\': !$ctrl.leftSideVersion.currentUpdate}"> {{$ctrl.leftSideVersion.qualifiedVersion}} | {{$ctrl.leftSideVersion.initiator}} | {{$ctrl.leftSideVersion.initiationDate | date: \'dd-MM-yyyy HH:mm:ss\'}}</h2> <ecm-preview-html content="$ctrl.$sce.trustAsHtml($ctrl.leftSideChanges)" style="display: block; height: auto"></ecm-preview-html> </div> <div ng-if="$ctrl.rightSideVersion" class="col-sm-6"> <h2 class="timeline-panel-title" ng-class="{\'current\': $ctrl.rightSideVersion.currentUpdate, \'not-current\': !$ctrl.rightSideVersion.currentUpdate}"> {{$ctrl.rightSideVersion.qualifiedVersion}} | {{$ctrl.rightSideVersion.initiator}} | {{$ctrl.rightSideVersion.initiationDate | date: \'dd-MM-yyyy HH:mm:ss\'}}</h2> <ecm-preview-html content="$ctrl.$sce.trustAsHtml($ctrl.rightSideChanges)"></ecm-preview-html> </div> </div> <div ng-if="$ctrl.showCompare" style="overflow-y: auto" class="col-sm-offset-3 col-sm-6"> <ecm-preview-html content="$ctrl.$sce.trustAsHtml($ctrl.compareHtml)"></ecm-preview-html> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view.tpl.html',' <div class="flex-cont bg-white listing-w-preview" ng-if="displayMode !=\'DISPLAY_FLAT_VIEW\'"> <div class="c-resize c-preview c-tree">  <div ng-if="displayMode==\'DISPLAY_TREE_VIEW\'" class="ecm-tree-container"> <tree-view-actions on-show-meta-data="showMetaData(show)" is-hooks-external-entities="editorialEntity.editorialEntityTemplate.hooksExternalEntities"> </tree-view-actions>  <tree-view-wrapper mode="getCurrentState() !== \'editorialEntity.treeview\' ? \'V2\' : \'NORMAL\'" editorial-entity="editorialEntity" on-node-selection="onNodeSelection(nodeSelected)" tree-view-instance="treeViewInstance" is-show-nodes-meta-data="isShowNodesMetaData()" edit-metadata-enabled="isMetadataEnabled()" edit-content-enabled="isEditContentEnabled()" current-user="currentUser" show-overloaded-view="showOverloadedView"></tree-view-wrapper> </div>  <div ng-if="displayMode==\'DISPLAY_METADATA\'"> <ul ng-repeat="metaDataByGrp in metaDataByMetaGroup"> <div class="panel panel-default meta-group"> <div class="panel-heading clearfix"> <h5 class="panel-title">{{metaDataByGrp.metaGroupName}}</h5> <div class="panel-tools" ng-show="editorialEntity.editMetaEnabled && metaDataByGrp.metaGroupName !== \'CALCULEE\'"> <label ng-click="openEditMetaModal(editorialEntity)"> <a href="" uib-tooltip="Editer" tooltip-placement="top" tooltip-append-to-body="true"> <i class="icon ion-edit"></i> </a> </label> </div> </div> <div class="panel-body" style="padding: 5px;"> <div class="col-sm-12 form-horizontal"> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in metaDataByGrp.metaDataInstanceDTOList track by $index" lang="lang" display="true" readonly="true" product-code="editorialEntity.ownerGroup"> </meta-data-field> </div> </div> </div> </ul> </div> </div> <div ng-mousedown="mdDragBar($event)" ng-if="displayMode !=\'DISPLAY_METADATA\'" ng-show="resize" class="resize-bar"> </div> <div id="idDivContenu" ng-show="resize" block-ui="previewUI" class="c-resize c-preview resizable no-padding flex-container-column" style="flex-basis: 50%;" ng-if="editorialEntity.editorialEntityTemplate.contentType !=\'REFERENCE\' && displayMode !=\'DISPLAY_METADATA\'"> <div ng-if="editorialEntity.editorialEntityTemplate.contentType==\'TREE\'" class="full-height"> <div ng-if="nodeSelected.type==\'STRUCTURAL\' || nodeSelected.type==\'QUERY\'"> <display-editorial-metadata flash-id="nodeSelected.id" editorial-type="nodeSelected.type" edit-metadata-enabled="isMetadataEnabled()"></display-editorial-metadata> </div> <div ng-if="nodeSelected.type !=\'STRUCTURAL\' && nodeSelected.type !=\'QUERY\'" class="full-height"> <div ng-if="nodeSelected.htmlPreview==\'NO_DISPLAY\'"> {{\'userApp.editorialEntity.menu.noDisplayMessage\' | translate}} </div>  <div ng-if="!nodeSelected.external && nodeSelected.htmlPreview != \'NO_DISPLAY\' && nodeSelected.htmlPreview != null && nodeSelected.type !== \'CONTENT\'" class="full-height"> <editorial-entity-action-bar ng-if="nodeSelected.relationStatus !== \'BROKEN\'" on-refresh-page="refreshEntity()" class="full-action-bar" content-class="action-bar-content" current-user="currentUser" flash-id="nodeSelected.refNodeId" on-refresh-preview="updatePreview(nodeSelected)" on-edit-meta-data="openEditMetaModalTree(nodeSelected.refNodeId, treeActionBarConfig)" on-edit-content="openEditor(nodeSelected)" preview-html="nodeSelected.htmlPreview"> <div style="padding: 10px"> <display-editorial-metadata flash-id="nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="isMetadataEnabled()"> </display-editorial-metadata> </div> <ecm-preview-html content="trustAsHtml(nodeSelected.htmlPreview)"> </ecm-preview-html> </editorial-entity-action-bar>  <div ng-show="nodeSelected.relationStatus === \'BROKEN\'" style="padding: 10px"> <display-editorial-metadata flash-id="nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="isMetadataEnabled()"> </display-editorial-metadata> <ecm-preview-html content="trustAsHtml(nodeSelected.htmlPreview)"> </ecm-preview-html> </div> </div> <div ng-if="nodeSelected.htmlPreview != \'NO_DISPLAY\' && nodeSelected.htmlPreview != null && nodeSelected.type === \'CONTENT\'" class="full-height ecm-preview-content"> <ecm-preview-html content="trustAsHtml(nodeSelected.htmlPreview)"></ecm-preview-html> </div> <div ng-if="nodeSelected.external" class="full-height ecm-preview-content"> <div style="padding: 10px"> <display-editorial-metadata flash-id="nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="isMetadataEnabled()"> </display-editorial-metadata> </div> <ecm-preview-html content="trustAsHtml(nodeSelected.htmlPreview)"></ecm-preview-html> </div> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/home/my-groups/my-groups.html','<div class="container-fluid"> <div class="row"> <div class="col-lg-2 col-sm-4 category-block" ng-class="{zoom: category === $ctrl.selectedCategory}" ng-repeat="category in $ctrl.categories"> <div class="panel panel-default"> <div class="panel-heading" style="display: flex"> <div class="flex-full"> <h5 class="panel-title">{{category.name}}</h5> </div> <div ng-if="category.groups.length > 5"> <button ng-click="$ctrl.zoom(category)" class="btn btn-xs btn-white zoom-open"> <i class="fa fa-expand"></i> </button> </div> </div> <div class="panel-body"> <perfect-scrollbar class="category-content"> <div ng-repeat="group in category.groups | orderBy:\'name\'"> <a ui-sref="productDashboard({code: group.code})" uib-tooltip="{{group.name}}">{{group.shortName ? group.shortName : group.name}}</a> </div> </perfect-scrollbar> </div> </div> </div>  <div class="panel panel-default zoom-panel" click-outside="$ctrl.closeZoom()" outside-if-not="zoom-open" ng-class="{expanded: $ctrl.selectedCategory}"> <div class="panel-heading"> <div class="flex-full"> <h5 class="panel-title">{{$ctrl.selectedCategory.name}}</h5> </div> <div> <button ng-click="$ctrl.closeZoom()" class="btn btn-xs btn-white zoom-open"> <i class="fa fa-times"></i> </button> </div> </div> <div class="panel-body"> <div class="category-content"> <div class="category-item" ng-repeat="group in $ctrl.selectedCategory.groups | orderBy:\'name\'"> <a ui-sref="productDashboard({code: group.code})" uib-tooltip="{{group.name}}">{{group.shortName ? group.shortName : group.name}}</a> </div> </div> </div> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/layout/main/main.html','<div class="ecm wrapper" style="overflow:hidden;"> <div class="editor-content" ui-view="editor"></div> <div ng-class="{\'locked\':menuLock ,\'lockedhover\': classfixmenu}" class="c-wrap" ng-cloak=""> <div ui-view="navbar-left"></div> <div class="col_right"> <announcement></announcement> <div class="wrapper-content" ui-view="content"> </div> <div ui-view="statusbar"> </div> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/layout/connect/connect.html','<div class="wrapper" style="overflow:hidden;"> <ui-view style="height: 100%"></ui-view> </div>');
$templateCache.put('scripts/pre-upgrade/components/login/login-form/login-form.html','<div class="form-login-c"> <img src="assets/images/Flash_logo.png" alt="" class="logo"> <h5 style="color: white; margin-left: 280px; color: #eccf37; font-size: 12px;">{{\'global.title\' | translate}}</h5> <div class="form-login"> <div class="alert alert-danger" ng-show="$ctrl.authenticationError" translate="{{$ctrl.messageAuthentication}}"> </div> <form name="loginForm" class="form" role="form" ng-submit="$ctrl.login($event)"> <div class="form-group has-feedback" ng-class="{ \'has-error\' : loginForm.username.$invalid && !loginForm.username.$pristine }"> <input type="text" name="username" ng-disabled="$ctrl.usernameDisabled" class="form-control" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="$ctrl.model.username" minlength="2" maxlength="20" required=""> <span class="icon ion-person form-control-feedback"></span> <p ng-show="loginForm.username.$invalid && !loginForm.username.$pristine" class="help-block">Veuillez renseigner votre login</p> </div> <div class="form-group has-feedback" ng-class="{ \'has-error\' : loginForm.password.$invalid && !loginForm.password.$pristine }"> <input type="password" name="password" class="form-control" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="$ctrl.model.password" required=""> <span class="icon ion-locked form-control-feedback"></span> <p ng-show="loginForm.password.$invalid && !loginForm.password.$pristine" class="help-block">Veuillez renseigner votre mot de passe </p><p> </p></div> <div class="btn-c"> <button type="submit" class="form-control btn btn-primary" translate="login.form.button">Connexion</button> </div> </form> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/login/login-modal/login-modal.html','<div class="modal-header"> <h4 translate="login.modalTitle"></h4> </div> <div class="modal-body"> <login-form-component close="$ctrl.close()" modal="true"></login-form-component> </div>');
$templateCache.put('scripts/pre-upgrade/components/model/create-model/create-model.html','<div> <div class="modal-header"> <div class="title" translate="userApp.model.home.title"></div> </div> <form name="saveModelForm" role="form" class="form-horizontal meta-group" novalidate="" ng-submit="$ctrl.save()"> <div class="modal-body modal-scrollable"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label for="nameModel" class="control-label"> <span translate="userApp.model.home.nameModel"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-6"> <input class="form-control" type="text" ng-model="$ctrl.modelDTO.name" name="nameModel"> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label for="visibilityModel" class="control-label"> <span translate="userApp.model.home.visibilityModel"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-3"> <select ng-model="$ctrl.modelDTO.modelVisibility" ng-init="$ctrl.modelDTO.modelVisibility = $ctrl.modelDTO.modelVisibility || \'\'" ng-options="option.value as option.name|translate for option in $ctrl.visibilityMap" ng-change="$ctrl.resetDefaultModel()"> </select> </div> <div class="col-sm-5" ng-if="$ctrl.modelDTO.modelVisibility == \'SHARED\' && $ctrl.manageDefaultModelPermitted"> <input type="checkbox" ng-model="$ctrl.modelDTO.defaultModel" class="checkbox-inline"> <label for="defaultModel" translate="userApp.model.home.defaultModel"></label> </div> </div> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.modelDTO.name || !$ctrl.modelDTO.modelVisibility"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/model/list-models/list-models.html','<div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <form class="ecm-filter-zone"> <div class="form-group form-group-sm"> <label translate="userApp.model.home.creationDate"></label> <ecm-datepicker show-operator="false" ng-model="$ctrl.creationDateFilter" model-type="\'RANGE\'" ng-change="$ctrl.queryAndloadAllModels()"></ecm-datepicker> </div> <div class="form-group form-group-sm"> <label translate="userApp.model.home.author"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'author\']" ng-change="$ctrl.queryAndloadAllModels()" ng-options="val for val in $ctrl.authorFilterList | orderBy:val"> <option value=""></option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.model.home.type"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'type\']" ng-change="$ctrl.queryAndloadAllModels()" ng-options="val for val in $ctrl.typeFilterList | orderBy:val"> <option value=""></option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.model.home.defaultModel"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'defaultModel\']" ng-change="$ctrl.queryAndloadAllModels()"> <option value=""></option> <option translate="userApp.model.home.yes" value="true"></option> <option translate="userApp.model.home.no" value="false"></option> </select> </div> <div class="form-group form-group-sm"> <label translate="userApp.model.home.visibilityModel"></label> <select class="form-control" style="min-width: 195px;" ng-model="$ctrl.searchMap[\'modelVisibility\']" ng-change="$ctrl.queryAndloadAllModels()" ng-options="option.value as option.name|translate for option in $ctrl.visibilityMap"> <option value=""></option> </select> </div> </form>  <div ng-if="$ctrl.pagination.totalCount > 0"> <span translate="userApp.model.home.totalResult" translate-values="{numberResult:$ctrl.pagination.totalCount}"></span> </div> <table id="tbl-model" ecm-ultimate-table="static" st-pipe="$ctrl.loadTable" st-table="$ctrl.models" st-set-sort="betterOrderBy" st-set-filter="StrictFilter" class="table table-striped table-bordered table-hover"> <thead> <tr> <th ng-if="!$ctrl.editable" class="icon-column"></th> <th style="width:40%" class="sortable" st-sort="title" translate="userApp.model.home.wording"> </th> <th class="sortable" st-sort="modelVisibility" translate="userApp.model.home.visibilityModel"> </th> <th class="sortable" st-sort="creationDate" translate="userApp.model.home.creationDate"> </th> <th class="sortable" st-sort="author" translate="userApp.model.home.author"> </th> <th class="sortable" st-sort="type" translate="userApp.model.home.type"> </th> <th ng-if="$ctrl.editable" translate="userApp.model.home.defaultModel"> </th> <th ng-if="$ctrl.editable" style="width: 185px" no-drag="" no-resize=""> </th> </tr> </thead> <tbody> <tr ng-repeat="row in $ctrl.models" ng-class="{\'disabled-node\' : row.disable}"> <td ng-if="!$ctrl.editable"> <input ng-click="$ctrl.selectModelSource(row)" ng-disabled="row.disable" type="radio"> </td> <td ng-if="$ctrl.editable" style="max-width: 500px;"> <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" ng-if="!$ctrl.editNameModel || ($ctrl.modelToEditName.flashId !== row.flashId)"> <div ng-if="row.authorOfModel" class="glyphicon glyphicon-pencil" ng-click="$ctrl.toggle(row)"></div> <a class="sidebar-open" href="" ng-click="$ctrl.getModelPreview(row)"> {{ row.name }} <md-tooltip md-delay="100" md-direction="bottom"> {{ row.name }} </md-tooltip> </a> </div> <div ng-if="$ctrl.editNameModel && ($ctrl.modelToEditName.flashId === row.flashId)"> <input style="width: 520px;" type="text" ng-model="row.name" ng-keydown="$event.keyCode == 13 && $ctrl.saveNameModel(row)"> <div class="pull-right"> <div class="glyphicon glyphicon-ok" ng-click="$ctrl.saveNameModel(row)"></div> <div class="glyphicon glyphicon-remove" ng-click="$ctrl.cancelNameModel(row)"></div> </div> </div> </td> <td ng-if="!$ctrl.editable"> <a class="sidebar-open" href="" ng-click="$ctrl.getModelPreview(row)"> {{ row.name }} <md-tooltip md-delay="100" md-direction="bottom"> {{ row.name }} </md-tooltip> </a> </td> <td> <select ng-if="$ctrl.editable && row.authorOfModel" ng-model="row.modelVisibility" ng-init="row.modelVisibility = row.modelVisibility" ng-options="option.value as option.name|translate for option in $ctrl.visibilityMap" ng-change="$ctrl.changeVisibilityModel(row,\'{{row.modelVisibility}}\')"> </select> <span ng-if="!$ctrl.editable || !row.authorOfModel">{{row.modelVisibility | translate}}</span> </td> <td>{{ row.creationDate | ecmDate }}</td> <td> {{ row.author}}</td> <td>{{row.type | translate}}</td> <td ng-if="$ctrl.editable"><input type="checkbox" ng-checked="{{row.defaultModel}}" ng-model="row.defaultModel" ng-change="$ctrl.setDefaultModel(row)" ng-disabled="!row.authorOfModel || row.modelVisibility !== \'SHARED\' || !row.manageDefaultModelPermitted"> </td> <td ng-if="$ctrl.editable"> <button class="btn btn-primary" ng-click="$ctrl.create(row.flashId)"><i class="fa fa-plus fa-lg" aria-hidden="true"></i> </button> <button class="btn btn-primary" ng-click="$ctrl.delete(row)" ng-disabled="!(row.authorOfModel)"> <i class="fa fa-trash-o fa-lg" aria-hidden="true"></i></button> </td> </tr> </tbody> <tfoot> <tr ng-if="$ctrl.models.length==0"> <td colspan="6" class="text-center"> <span translate="userApp.model.home.NoData"></span> </td> </tr> </tfoot> </table>  <div class="text-left"> <ecm-pagination pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllModels()"></ecm-pagination> </div> </div> <closeable-html-preview preview="$ctrl.preview"> </closeable-html-preview></div> </div>');
$templateCache.put('scripts/pre-upgrade/components/model/list-models/my-models.component.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <h2> <span translate="userApp.model.home.models"></span> </h2> </div> </div> </div> <list-models-component current-user="$ctrl.currentUser" editable="true"></list-models-component>');
$templateCache.put('scripts/pre-upgrade/components/monitoring/app-health/app-health.html','<div class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title"> <ul> <li> <div block-ui="$ctrl.app.name"> <span ng-if="!$ctrl.isAppUP()"> <i class="fa fa-circle" style="font-size:24px;color:red"></i> </span> <span ng-if="$ctrl.isAppUP()"> <i class="fa fa-circle" style="font-size:24px;color:#32CD32"></i> </span> </div> <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#{{$ctrl.app.name}}"> <u>{{$ctrl.app.name}}</u> </button> </li> <li ng-if="$ctrl.appHealth"> <i>{{\'userApp.monitoring.labels.functionalStatus\' | translate }}&nbsp;:&nbsp;{{\'userApp.monitoring.labels.status.\' + $ctrl.isAppValidFunctionalStatus | translate}}</i> </li> </ul> </h5> </div> <div id="{{$ctrl.app.name}}" class="panel-body collapse"> <ul> <li ng-repeat="instance in $ctrl.appHealth"> <instance-health instance="instance"></instance-health> </li> </ul> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/my-trash/my-trash-main/my-trash-main.component.html','<div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview"> <div class="pull-right"> <mass-operation-container selected-action="$ctrl.selectedAction" selected-ee="$ctrl.selectedEe" refresh-function="$ctrl.pageChanged()" from-trash="true"></mass-operation-container> </div>  <form class="ecm-filter-zone"> <div class="form-group form-group-sm"> <label translate="userApp.trash.home.creationDate"></label> <ecm-datepicker show-operator="false" ng-model="$ctrl.creationDateFilter" model-type="\'SINGLE\'" ng-change="$ctrl.loadAllee()"></ecm-datepicker> </div> <div class="form-group form-group-sm"> <label translate="userApp.trash.home.suppression"></label> <ecm-datepicker show-operator="false" ng-model="$ctrl.suppressionDateFilter" model-type="\'SINGLE\'" ng-change="$ctrl.loadAllee()"></ecm-datepicker> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.ownerGroupList && $ctrl.allFilters.ownerGroupList.length>0"> <label translate="userApp.trash.home.ownerGroup"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.filterSearchParam.ownergroupCode" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.ownerGroupList"> <option value="" translate="global.all"></option> </select> </div> <div class="form-group form-group-sm" ng-if="$ctrl.allFilters.teeList && $ctrl.allFilters.teeList.length>0"> <label translate="userApp.trash.home.tee"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.filterSearchParam.eetCode" ng-change="$ctrl.loadAllee()" ng-options="val.code as val.value | translate for val in $ctrl.allFilters.teeList"> <option value="" translate="global.all"></option> </select> </div> </form> <table id="{{$ctrl.tableId}}" ecm-ultimate-table="" on-select-row-change="$ctrl.onSelectRowChange({row: row})" resize-mode="overflow" checkbox-model="$ctrl.selectedEe[row.identifier]" multi-select="true" st-pipe="$ctrl.loadTable" st-table="$ctrl.entities" st-set-filter="StrictFilter" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="sortable" st-sort="systemTitle" translate="userApp.trash.home.wording"> </th> <th class="sortable" st-sort="eetCode" translate="userApp.trash.home.tee"></th> <th class="sortable" st-sort="systemCreationDate" translate="userApp.trash.home.creationDate"></th> <th class="sortable" st-sort="systemLastUpdateDate" translate="userApp.trash.home.suppression"></th> <th class="sortable" st-sort="systemOwnerGroup" translate="userApp.trash.home.ownerGroup"></th> </tr> </thead> <tbody> <tr class="sidebar-open" role="button" ng-click="$ctrl.rowSelected(row)" ng-class="{\'st-selected\': $ctrl.isEESelected(row.identifier)}" ng-repeat="row in $ctrl.entities"> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.systemTitle )"> <span ng-bind-html="$ctrl.trustAsHtml( row.systemTitle | validName )"> </span> </td> <td uib-tooltip="{{row.eetName}}">{{row.eetName}}</td> <td uib-tooltip="{{ row.creationDate | ecmDate | translate }}"> {{ row.creationDate | ecmDate | translate }}</td> <td uib-tooltip="{{ row.suppressionDate | ecmDate | translate }}"> {{ row.suppressionDate | ecmDate | translate }}</td> <td uib-tooltip="{{row.ownerGroupName | translate}}">{{row.ownerGroupName | translate}}</td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.entities.length==0"> <td colspan="{{$ctrl.displayMode === \'GROUP\' ? \'10\' : \'7\' }}" class="text-center"> <span translate="userApp.trash.home.noData"></span> </td> </tr> </tfoot> </table>  <div ng-if="!$ctrl.hidePagination && $ctrl.displayMode != \'LIGHT\'" class="text-left"> <ecm-pagination storage-key="{{$ctrl.getStorageKey(true)}}" pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllee()"></ecm-pagination> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/navbar/navbar-account/navbar-account.html','<ul> <li class="tb-btn c-user"> <div class="pic" ng-switch="" on="$ctrl.account.house"> <img ng-switch-when="EFL" src="assets/images/logo/logo_efl48.png" alt=""> <img ng-switch-when="DALLOZ" src="assets/images/logo/logo_dalloz48.png" alt=""> <img ng-switch-when="EL" src="assets/images/logo/logo_el48.png" alt=""> <img ng-switch-default="" src="assets/images/logo/logo_els48.png" alt=""> </div>  <ul class="sb-dropdown"> <li class="sb-row"> <span class="prenom">{{$ctrl.account.firstName}}</span> <span class="nom">{{$ctrl.account.lastName}}</span> </li> <li class="sb-row"> <a href="" ng-click="$ctrl.openUserDetails()" id="profileButton" data-toggle="collapse" data-target=".navbar-collapse.in"> <span class="glyphicon glyphicon-cog"></span>&#xA0; <span translate="global.menu.account.userProfile"></span> </a> </li> <li class="sb-row" ui-sref-active="active"> <a id="reset" data-toggle="collapse" data-target=".navbar-collapse.in" ng-click="$ctrl.reset()"> <span class="fa fa-repeat"></span>&#xA0; <span translate="global.menu.account.reinitialiser">Reinitialiser</span> </a> </li> <li class="sb-row" ui-sref-active="active"> <a id="logout" data-toggle="collapse" data-target=".navbar-collapse.in" ng-click="$ctrl.openConfirmLogout()"> <span class="glyphicon glyphicon-log-out"></span>&#xA0; <span translate="global.menu.account.logout">Sign out</span> </a> </li> </ul> </li> </ul>');
$templateCache.put('scripts/pre-upgrade/components/navbar/navbar-left/navbar-left.component.html','<div class="col_left navbar-default" role="navigation" ng-mouseover="$ctrl.hoverNavLeft()" ng-mouseleave="$ctrl.outNavLeft()"> <div class="nav-top"> <navbar-create-entity current-user="$ctrl.currentUser"></navbar-create-entity> <navbar-account class="flex-full"></navbar-account> </div>  <perfect-scrollbar class="scroll-menu flex-full" id="navbarleft"> <ul class="nav" ng-init="firstGroup = $first" ng-repeat="groups in $ctrl.listeMenuAdmin">  <li ng-if="firstGroup" class="home"> <a ui-sref="home" ui-sref-active="active_nav"> <i class="fa fa-lg fa-home"></i> <span translate="main.home"></span> </a> </li>  <li ng-if="firstGroup && !$first" class="sub" ng-repeat="rootItem in groups.groups[0].childs"> <a ui-sref="{{rootItem.uiSref}}({identifier : rootItem.identifier, savedSearchId : rootItem.savedSearchId, productCode: rootItem.productCode})" translate="{{rootItem.translate}}" ui-sref-active="active_nav"></a> </li>  <li ng-if="group.group && group.group.uiSref == \'\' && group.group.translate != \'\'" class="title accordion" ng-class="{\'expended\':group.isOpen, virtual: groups.virtual}" ng-click="!groups.virtual && $ctrl.toggleMenu(group)" ng-repeat="group in groups.groups"> <a ng-click="groups.virtual && $ctrl.goToDashBoard(group.group.productCode)" translate="{{group.group.translate}}"> </a> <i class="fa fa-times" ng-if="groups.virtual" type="button" ng-click="$ctrl.purgeContextualization()"></i> <ul ng-if="group.childs.length > 0"> <li ng-if="opt.uiSref != \'\' && opt.translate != \'\'" class="sub" ng-repeat="opt in group.childs"> <a ui-sref="{{opt.uiSref}}({identifier : opt.identifier, savedSearchId : opt.savedSearchId, productCode: opt.productCode, proposalsProduct: opt.proposalsProduct})" translate="{{opt.translate}}" ui-sref-active="active_nav" ng-click="$event.stopPropagation()"></a> </li> </ul> </li> <li ng-if="!$last" class="sep"></li> </ul> </perfect-scrollbar>  <span class="btn-resize" ng-click="$ctrl.lockMenu()"> <span class="glyphicon glyphicon-indent-left"></span> </span> </div>');
$templateCache.put('scripts/pre-upgrade/components/navbar/navbar-create-entity/navbar-create-entity.html','<div class="tb-btn c-add"> <i class="icon ion-plus"></i> <div class="sb-dropdown"> <div class="sb-state create clearfix"> <div class="etat pull-left"></div> <div class="opt pull-right"> <a href=""> <i class="icon"></i> </a> </div> </div> <perfect-scrollbar ng-if="!$ctrl.hide" class="sb-list with-sublevel"> <ul ng-if="$ctrl.isLoading" class="loading-entity-list"> <li class="search-title">&nbsp; <i class="fa fa-circle-o-notch fa-2x fa-spin fa-fw"></i> <span class="sr-only">Loading...</span> </li> </ul> <ul ng-repeat="instantiablesEET in $ctrl.instantiablesEETList" class="sb-row"> <li class="search-title" ng-click="$ctrl.openCreateEEModal(instantiablesEET)">{{instantiablesEET.wording}}</li> </ul> <ul ng-hide="$ctrl.isAllShown" class="sb-row"> <li class="search-title" ng-click="$ctrl.showALl()"> <a translate="main.moreDisplay">Voir plus</a> </li> </ul> </perfect-scrollbar> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/navbar/user-modal/user-modal.html','<div> <div class="modal-header"> <div class="title" translate="userApp.user.home.userProfile"></div> </div> <form name="userDetails" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.save()"> <div class="modal-body"> <div class="form-group form-group-sm"> <div class="col-sm-2"> <label class="control-label"> <span translate="userApp.user.home.firstName"></span> </label> </div> <div class="col-sm-8"> <input class="form-control" type="text" ng-model="$ctrl.currentUser.firstName" ng-disabled="true"> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-2"> <label class="control-label"> <span translate="userApp.user.home.lastName"></span> </label> </div> <div class="col-sm-8"> <input class="form-control" type="text" ng-model="$ctrl.currentUser.lastName" ng-disabled="true"> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-2"> <label class="control-label"> <span translate="userApp.user.home.email"></span> </label> </div> <div class="col-sm-8"> <input class="form-control" type="text" ng-model="$ctrl.currentUser.email" ng-disabled="true"> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-2"> <label class="control-label"> <span translate="userApp.user.home.signature"></span> </label> </div> <div class="col-sm-8"> <input class="form-control" type="text" ng-model="$ctrl.currentUser.signature" maxlength="255"> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary"> <span class="glyphicon glyphicon-save"></span> <span translate="userApp.user.action.Save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.close()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.user.action.cancel"></span> </button> </div> </div> </div></form> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-container/search-container.component.html','<div class="container-fluid bg-white tir-container"> <div class="view-mod clearfix"> <div class="pull-left"> <span ng-if="$ctrl.pagination.totalCount" translate="userApp.searchInterfaceTemplate.home.result" translate-values="{NUM:$ctrl.pagination.totalCount}" translate-interpolation="messageformat"></span> <span ng-if="$ctrl.getSelectedEE().length > 0"> <span>&nbsp;&nbsp;{{$ctrl.getSelectedEE().length}} </span> <span translate="userApp.searchInterfaceTemplate.home.selectedElements"></span> <span class="unselect-btn" ng-click="$ctrl.clearSelection()" uib-tooltip="{{\'global.unselectAll\' | translate}}"> <i class="fa fa-times"></i> </span> </span> </div> <div class="pull-right ecm-tir-result-head" ng-if="!$ctrl.editTirInModal && !$ctrl.hideMassOperationContainer"> <mass-operation-container selected-action="$ctrl.selectedAction" is-proposals-product="$ctrl.searchSolr.proposalsProduct" product-code="$ctrl.searchSolr.productCode" selected-ee="$ctrl.selectedEE" current-user="$ctrl.currentUser" sit-id="$ctrl.tirId"></mass-operation-container> <span translate="userApp.searchInterfaceTemplate.home.showBy"></span> <select ng-model="$ctrl.searchSolr.showDefaultPlan" ng-options="o.value as o.name | translate for o in $ctrl.showByList" ng-change="$ctrl.changeView()" ng-disabled="!$ctrl.searchSolr.listClassification || $ctrl.searchSolr.listClassification.length == 0"> </select> <span translate="userApp.searchInterfaceTemplate.home.statusFilter"></span> <select ng-if="$ctrl.searchSolr.finalStatusLimited" ng-model="$ctrl.searchSolr.eeStatus" ng-options="o.value as o.name | translate for o in $ctrl.finalStatusList" ng-change="$ctrl.changeView()"> </select> <select ng-if="!$ctrl.searchSolr.finalStatusLimited" ng-model="$ctrl.searchSolr.eeStatus" ng-options="o.value as o.name | translate for o in $ctrl.statusList" ng-change="$ctrl.changeView()"> </select> </div> </div> <div class="row tir-content flex-full">  <search-solr-facet class="facet-container" ng-class="{\'facet-hidden\': !$ctrl.facetVisibility}" ng-if="!$ctrl.searchSolr.showDefaultPlan && $ctrl.showFacet()" tir-id="$ctrl.tirId" list-facet="$ctrl.searchSolr.listFacet" change-facet="$ctrl.changeFacet()" on-facet-visibility-changed="$ctrl.facetVisibilityChanged(visibility)"></search-solr-facet>  <search-solr-container-list on-select-all-change="$ctrl.onSelectAllChange()" on-select-row-change="$ctrl.onSelectRowChange({row: row})" class="flex-full search-result-container" ng-if="!$ctrl.searchSolr.showDefaultPlan" search-solr="$ctrl.searchSolr" resultat="$ctrl.resultat" get-data="$ctrl.getData()" edit-tir-in-modal="$ctrl.editTirInModal" ee-selected="$ctrl.eeSelected" navigate-to-ee="$ctrl.navigateToEE(id)" get-ee-selected="$ctrl.getEESelected(idEE, editEnabled, isLocked, entityTemplateCode)" pagination="$ctrl.pagination" selected-ee="$ctrl.selectedEE" ee-target-chosen="$ctrl.eeTargetChosen({eeTarget:eeTarget})" show-facet="$ctrl.showFacet()" multi-select="$ctrl.multiSelect"></search-solr-container-list>  <search-solr-container-plan ng-if="$ctrl.searchSolr.showDefaultPlan" search-solr="$ctrl.searchSolr" resultat="$ctrl.resultat" navigate-to-ee="$ctrl.navigateToEE(id)" selected-ee="$ctrl.selectedEE" get-ee-selected="$ctrl.getEESelected(idEE, editEnabled, isLocked, entityTemplateCode)"> </search-solr-container-plan>  <search-solr-ee-preview open-on-new-tab="$ctrl.editTirInModal" hl-enabled="$ctrl.searchSolr.searchFullTextDTO.contentEditorialEntity" search-terms="$ctrl.searchSolr.highlightMatches[$ctrl.eeSelected]" ee-selected="$ctrl.eeSelected" ee-target="$ctrl.eeTarget" close-preview-ee="$ctrl.closePreviewEE()" product-code="$ctrl.productCode" ng-if="$ctrl.eeSelected"></search-solr-ee-preview> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-ee-preview/search-ee-preview.component.html','<ecm-sidebar content-class="sibebar-preview-content" allow-close="true" is-open="$ctrl.eeSelected" on-close="$ctrl.closePreviewEe()"> <span class="close-preview" ng-click="$ctrl.closePreviewEe()"> <i class="icon ion-close-round"></i> </span> <editorial-entity-action-bar flash-id="$ctrl.eeSelected" content-class="action-bar-content" on-edit-meta-data="$ctrl.openEditMetaModal($ctrl.eeSelected)" on-refresh-preview="$ctrl.reloadPreview($ctrl.eeSelected,\'COMPLETE\', $ctrl.productCode)" on-edit-content="$ctrl.startEdition($ctrl.eeSelected)" preview-html="$ctrl.eeTarget.completeHtmlPreview" open-on-new-tab="$ctrl.openOnNewTab"> <div style="height: 100%" block-ui="previewUI"> <ecm-preview-html content="$ctrl.trustAsHtml($ctrl.eeTarget.completeHtmlPreview)" hl-enabled="$ctrl.hlEnabled" search-terms="$ctrl.searchTerms"></ecm-preview-html> </div> </editorial-entity-action-bar> </ecm-sidebar> ');
$templateCache.put('scripts/pre-upgrade/components/search/search-facet/search-facet.component.html','<div style="height: 100%"> <div class="flex-container-column" style="height: 100%"> <div class="facet-header"> <div class="facet-nav-title"> <h5 translate="userApp.searchInterfaceTemplate.home.facetHeader"></h5> <h5 uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.clearAllFacets\' | translate}}"> <span ng-click="$ctrl.clearAll()" class="fa fa-times"></span> </h5> </div>  <div class="facet-resize" ng-click="$ctrl.toggleFacetVisibility()"> <i class="glyphicon" ng-class="{\'glyphicon-indent-left\': $ctrl.facetVisibility, \'glyphicon-indent-right\': !$ctrl.facetVisibility}"></i> </div> </div> <div class="facet-nav col-sm-12"> <div class="facet" ng-repeat="facet in $ctrl.listFacet track by $ctrl.trackByFacetCodeValue($ctrl.getFacetId(facet), $index)" ng-if="$ctrl.isFacetNotEmpty(facet)"> <a ng-class="{\'facet-selected\': $ctrl.facetSelected(facet)}" ng-click="$ctrl.toggleFacet($ctrl.getFacetId(facet))"> <span class="fa" ng-class="{ \'fa-plus-square-o\': $ctrl.facetCollapseMap[$ctrl.getFacetId(facet)], \'fa-minus-square-o\': !$ctrl.facetCollapseMap[$ctrl.getFacetId(facet)] }"></span> <strong>{{facet.name}}</strong> </a> <div uib-collapse="$ctrl.facetCollapseMap[$ctrl.getFacetId(facet)]" class="ecm-custom-tree"> <ol class="ecm-custom-tree-node"> <li ng-repeat="item in facet.values | limitTo: $ctrl.facetShowLimit track by $ctrl.trackByFacetCodeValue($ctrl.getFacetId(facet), item.value)"> <ng-include src="\'facet_renderer.html\'"></ng-include> </li> <div ng-if="$ctrl.facetLength(facet.values) > $ctrl.facetShowLimit"> <div uib-collapse="!$ctrl.facetShowAllMap[$ctrl.getFacetId(facet)]"> <li ng-repeat="item in facet.values track by $ctrl.trackByFacetCodeValue($ctrl.getFacetId(facet), item.value)" ng-if="$index > $ctrl.facetShowLimit - 1"> <ng-include src="\'facet_renderer.html\'"></ng-include> </li> </div> <a ng-if="$ctrl.facetShowAllMap[$ctrl.getFacetId(facet)]" class="ecm-facet-show-btn" ng-click="$ctrl.facetShowAllMap[$ctrl.getFacetId(facet)] = false" translate="userApp.searchInterfaceTemplate.listFilterTir.reduce"></a> <a ng-if="!$ctrl.facetShowAllMap[$ctrl.getFacetId(facet)]" class="ecm-facet-show-btn" ng-click="$ctrl.facetShowAllMap[$ctrl.getFacetId(facet)] = true" translate="userApp.searchInterfaceTemplate.listFilterTir.showAll"></a> </div> </ol> </div> <md-divider ng-if="!$last && $ctrl.isFacetNotEmpty(facet)" style="margin-top:5px"></md-divider> </div> </div> </div> </div> <script type="text/ng-template" id="facet_renderer.html"> <div class="checkbox"> <a ng-if="item.children && item.children.length > 0" ng-click="$ctrl.toggle($ctrl.getFacetId(facet), item.value)"> <span class="fa" ng-class="{ \'fa-plus-square-o\': $ctrl.isCollapsed($ctrl.getFacetId(facet), item.value), \'fa-minus-square-o\': !$ctrl.isCollapsed($ctrl.getFacetId(facet), item.value) }"></span> </a> <label style="cursor: pointer"> <input type="checkbox" ng-model="item.enabled" ng-change="$ctrl.toggleAll(item)"></input> <span class="facet-value"> <span class="facet-text" ng-bind-html="item.value | ecmDate | ecmBoolean"></span>&nbsp;({{item.size}})</span> </label> </div> <ol ng-if="item.children && item.children.length > 0 && !$ctrl.isCollapsed($ctrl.getFacetId(facet), item.value)" class="ecm-custom-tree-node" ng-class="{hidden: $ctrl.isCollapsed($ctrl.getFacetId(facet), item.value)}"> <li ng-repeat="subItem in item.children"> <div ng-if="subItem.children.length > 0" ng-init="item = subItem" ng-include="\'facet_renderer.html\'"></div> <div ng-if="subItem.children.length == 0" class="no-child-node"> <div class="checkbox"> <label style="cursor: pointer"> <input type="checkbox" ng-model="subItem.enabled" ng-change="$ctrl.toggleChildren(item)"></input> <span class="facet-value"> <span class="facet-text" ng-bind-html="subItem.value | ecmDate | ecmBoolean"></span>&nbsp;({{subItem.size}}) </span> </label> </div> </div> </li> </ol> </script>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter/search-filter.component.html','<div class="form-horizontal"> <div ng-repeat="f in $ctrl.filters"> <search-solr-filter-field ng-hide="f.masked" lang="$ctrl.lang" filter="f" date-operator-options="$ctrl.dateOperatorOptions" operator-options="$ctrl.operatorOptions" check-length-filter="$ctrl.checkLengthFilter" product-code="$ctrl.productCode" product-label="$ctrl.productLabel" is-contextualized-search="$ctrl.isContextualizedSearch" product-filter-values="$ctrl.productFilterValues" submit-filters="$ctrl.submitFilters" mounting-rt="$ctrl.mountingRt" on-product-select="$ctrl.onProductSelect(selectedProductLabel)" on-product-remove="$ctrl.onProductRemove(removedProductLabel)" search-template-id="$ctrl.searchTemplateId"></search-solr-filter-field> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-modal/search-filter-modal.component.html','<div> <div class="modal-header"> <div class="title"> <h2> <span translate="entity.action.filter"></span> </h2> </div> </div>  <form name="selectFilterValuesForm" ng-submit="$ctrl.closeModal()" role="form" class="form-horizontal" novalidate=""> <div class="modal-body"> <search-solr-filter filters="$ctrl.resolve.currentFilters.filterInstanceDTOs" product-code="$ctrl.productCode" check-length-filter="$ctrl.checkLengthFilter" submit-filters="$ctrl.closeModal()" is-contextualized-search="$ctrl.isContextualizedSearch" search-template-id="$ctrl.searchTemplateId"></search-solr-filter> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.selectFilterValuesForm.$invalid || !$ctrl.checkNumbersFilter.validNumbers || !$ctrl.checkDatesFilter.validDates || !$ctrl.checkLengthFilter.validLength"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.filter"></span> </button> <button type="button" class="btn btn-primary" ng-click="$ctrl.clearModalFilters()" translate="entity.action.deletFilter"></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancelFilterModal()" translate="global.menu.modalLogout.cancel"></button> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-full-text/search-full-text.tpl.html','<div class="ecm-search-fulltext"> <md-autocomplete md-min-length="0" md-no-cache="true" md-search-text="$ctrl.searchText" md-items="item in $ctrl.search($ctrl.searchText)" md-item-text="item.display" md-search-text-change="$ctrl.textChanged($ctrl.searchText)" md-selected-item-change="$ctrl.selectedItemChange(item)" md-menu-class="ecm-search-fulltext-container" ng-keypress="($event.which === 13)?$ctrl.searchClick($event):0"> <md-item-template> <div class="ecm-search-fulltext-item" tooltip-animation="false" tooltip-placement="bottom" tooltip-append-to-body="true"> <i class="fa fa-search ecm-icon" aria-hidden="true"></i> <div class="ecm-search"> <div class="ecm-text-line"> <div class="ecm-text"> <span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.display}}</span> </div> <div class="ecm-options"> <span translate="userApp.searchInterfaceTemplate.searchOptions.in"></span> <span ng-repeat="area in item.areas">{{area | translate}} <span ng-if="!$last">, </span> </span> </div> <md-tooltip> {{item.display}} </md-tooltip> </div> <div class="ecm-filter-line"> <tir-display-filter filters="item.filters"></tir-display-filter> <md-tooltip> <tir-display-filter filters="item.filters"></tir-display-filter> </md-tooltip> </div> </div> </div> </md-item-template>   </md-autocomplete> <div class="btn-group" uib-dropdown="" auto-close="outsideClick"> <button id="split-button" type="submit" class="btn btn-primary" ng-click="$ctrl.searchClick($event)" style="height: 40px;"> <i class="fa fa-search" aria-hidden="true"></i> </button> <button style="height: 40px;" type="button" class="btn btn-primary" uib-dropdown-toggle=""> <span class="caret"></span> </button> <ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="split-button"> <li role="menuitem" style="padding-left: 12px"> <md-checkbox class="green" ng-click="$ctrl.toggleAll()" ng-model="$ctrl.isAllSelected">{{\'userApp.searchInterfaceTemplate.searchOptions.all\' | translate }}</md-checkbox> </li> <li class="divider"></li> <li role="menuitem" ng-repeat="option in $ctrl.searchOptions" style="padding-left: 12px"> <md-checkbox class="green" ng-model="option.selected" ng-change="$ctrl.optionToggled()"> <span>{{option.value | translate}}</span> </md-checkbox> </li> </ul> </div> <div type="button" class="ms-btn status-btn help_shortcut-button"> <i class="fa fa-keyboard-o"></i> <div class="ms_tooltip_help shortcuts"> <div class="help-shortcut"> <em>" "</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.exact"></div> </div> <div class="help-shortcut"> <em>*</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.any"></div> </div> <div class="help-shortcut"> <em>?</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.unknown"></div> </div> <div class="help-shortcut"> <em>-</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.exclude"></div> </div> <div class="help-shortcut"> <em>{{\'userApp.searchInterfaceTemplate.searchShortcuts.comboValue\' | translate}}1 AND {{\'userApp.searchInterfaceTemplate.searchShortcuts.comboValue\' | translate}}2</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.combo"></div> </div> <div class="help-shortcut"> <em>~</em> <div class="desc-shortcut" translate="userApp.searchInterfaceTemplate.searchShortcuts.approximation"></div> </div> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/search/search-full-text/tooltip.tpl.html','<tir-display-filter filters="item.filters"></tir-display-filter> ');
$templateCache.put('scripts/pre-upgrade/components/search/search-header/search-header.component.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <div class="ecm-search-full" style="display: inline-block; width:600px; margin-left:10px;vertical-align: middle;"> <search-fulltext save-session="!$ctrl.editTirInModal" tir-id="$ctrl.identifier"> </search-fulltext> </div> <button tooltip-placement="bottom" uib-tooltip="{{\'userApp.searchInterfaceTemplate.home.filterButton\' | translate}}" class="btn btn-primary" aria-label="userApp.searchInterfaceTemplate.home.filterButton" ng-disabled="!$ctrl.showFilter()" ng-click="$ctrl.selectFilter(currentFilters)"> <md-icon md-svg-src="assets/images/icons/ic_filter_list_white_24px.svg"></md-icon> <span translate="userApp.searchInterfaceTemplate.home.activeFilter" translate-values="{NUM:$ctrl.countFilters}" translate-interpolation="messageformat"></span> </button> <button class="btn btn-primary" tooltip-placement="bottom" ng-disabled="!$ctrl.showFilter()" uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.deleteFilters\' | translate}}" aria-label="userApp.searchInterfaceTemplate.listFilterTir.deleteFilters" ng-click="$ctrl.clearFilters()"> <md-icon md-svg-src="assets/images/icons/ic_delete_white_24px.svg"></md-icon> </button> </div> <div class="pull-right"> <button class="btn btn-primary" ng-click="$ctrl.showModalSave($event); $ctrl.getLibelle()" ng-disabled="!$ctrl.checkIsSavedSarchAuthorize()" aria-label="userApp.searchInterfaceTemplate.listFilterTir.saveFilter" tooltip-placement="bottom" uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.saveFilter\' | translate }}" ng-hide="$ctrl.editTirInModal"> <md-icon md-svg-src="assets/images/icons/ic_save_white_24px.svg"></md-icon> </button> <button class="btn btn-primary" ng-click="$ctrl.resetFilters()" aria-label="userApp.searchInterfaceTemplate.listFilterTir.resetFilter" tooltip-placement="bottom" uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.resetFilter\' | translate }}"> <md-icon md-svg-src="assets/images/icons/ic_restore_page_white_24px.svg"></md-icon> </button> <button class="btn btn-primary" aria-label="userApp.searchInterfaceTemplate.listFilterTir.favoriteFilter" tooltip-placement="bottom" uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.favoriteFilter\' | translate }}" ng-hide="$ctrl.editTirInModal"> <md-icon md-svg-src="assets/images/icons/ic_star_white_18px.svg"></md-icon> </button> </div> </div> <div class="filter-summary" ng-if="$ctrl.ingnoreEeAlreadyAttached"> <div class="filter-content"> <span style="color:red;"> \u2260 </span> {{ \'userApp.searchInterfaceTemplate.msg.ALERT_IGNORE_EE_ALREADY_ATTACHED\' | translate}} </div> </div> <div class="filter-summary" ng-if="$ctrl.ignoreEeHookedSameProduct"> <div class="filter-content"> <span style="color:red;"> \u2260 </span> {{ \'userApp.searchInterfaceTemplate.msg.ALERT_IGNORE_EE_HOOKED_SAME_PRODUCT\' | translate}} </div> </div> <div class="filter-summary" ng-if="$ctrl.ignoreEeHookedToSameEet"> <div class="filter-content"> <span style="color:red;"> \u2260 </span> {{ \'userApp.searchInterfaceTemplate.msg.ALERT_IGNORE_EE_HOOKED_TO_SAME_EET\' | translate}} </div> </div> <div class="filter-summary" ng-if="$ctrl.countFilters > 0"> <div class="filter-content" ng-class="{\'filter-content-full\': $ctrl.displayAllFilter}" ng-click="$ctrl.switchFilterDisplay()"> <tir-display-filter filters="$ctrl.activeFilters" on-remove="$ctrl.removeFilter(filter)"></tir-display-filter> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-main/search-main.component.html','<div class="full-height flex-container-column"> <search-solr-header get-libelle="$ctrl.getLibelle()" edit-tir-in-modal="$ctrl.editTirInModal" search-full-text="$ctrl.searchFullText" get-data="$ctrl.getData()" pagination="$ctrl.pagination" current-filters="$ctrl.currentFilters" search-solr="$ctrl.searchSolr" identifier="$ctrl.identifier" active-filters="$ctrl.activeFilters" product-code="$ctrl.productCode" ingnore-ee-already-attached="$ctrl.ignoreEntitiesAttachedToSource" ignore-ee-hooked-same-product="$ctrl.ignoreEntitiesHookedToSameProduct" ignore-ee-hooked-to-same-eet="$ctrl.ignoreEntitiesHookedToSameEet"> </search-solr-header> <div class="flex-full no-overflow"> <search-solr-container class="flex-full" edit-tir-in-modal="$ctrl.editTirInModal" pagination="$ctrl.pagination" current-user="$ctrl.currentUser" hide-mass-operation-container="$ctrl.hideMassOperationContainer" selected-e-e="$ctrl.eeListChecked" search-solr="$ctrl.searchSolr" tir-id="$ctrl.identifier" resultat="$ctrl.resultat" get-data="$ctrl.getData()" ee-target-chosen="$ctrl.eeTargetChosen({eeTarget:eeTarget})" on-select-row-change="$ctrl.onSelectRowChange({row: row})" on-select-all-change="$ctrl.onSelectAllChange()" ee-selected="$ctrl.eeSelected" multi-select="$ctrl.multiSelect" product-code="$ctrl.productCode"> </search-solr-container> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/tir-display/tir-display-filter.tpl.html','<span ng-repeat="item in $ctrl.filters"> <b>{{item.filterName}}</b>: <span style="color:red;" ng-if="(!item.contains) && (!item.filterOperator1 || item.filterOperator1 === \'EQUAL\')"> \u2260 </span> <span>{{item.filterOperator1 | translate}}</span> <span ng-if="item.isDate">{{item.filterValues[0] | ecmDate}}</span> <span ng-if="item.isBoolean">{{item.filterValues[0] | translate}}</span> <span ng-if="item.filterDTORef.nullValue" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> <span ng-repeat="val in item.filterValues track by $index" ng-if="!item.isDate && !item.isBoolean">{{val | translate}} <span ng-if="!$last">; <span style="color:red;" ng-if="(!item.contains) && (!item.filterOperator1 || item.filterOperator1 === \'EQUAL\')"> \u2260 </span> </span> </span> {{item.filterOperator2 | translate}} <span ng-if="item.isDate">{{item.filterValue2 | ecmDate}}</span> <span ng-if="!item.isDate">{{item.filterValue2}}</span> <span ng-if="$ctrl.allowRemove" class="unselect-btn" ng-click="$ctrl.onRemove({filter: item});$event.stopPropagation();"> <i class="fa fa-times"></i> </span> <span ng-if="!$last">| </span> </span> ');
$templateCache.put('scripts/pre-upgrade/components/searchv2/search-container/search-container.component.html','<div class="container-fluid bg-white tir-container"> <div class="view-mod clearfix">  </div> <div class="row tir-content flex-full">  <search-facet class="facet-container" ng-class="{\'facet-hidden\': !$ctrl.facetVisibility}" ng-if="$ctrl.searchDto.facetListDTO.length > 0" tir-id="$ctrl.tirId" list-facet="$ctrl.searchDto.facetListDTO" on-facet-changed="$ctrl.facetChanged()" on-facet-visibility-changed="$ctrl.facetVisibilityChanged(visibility)"> </search-facet>  <search-container-list meta-html-title="META_HTML_TITLE" class="flex-full search-result-container"></search-container-list>  </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/searchv2/search-facet/search-facet.component.html','<div class="facet-nav-container flex-container-column"> <div class="facet-header"> <div class="facet-nav-title"> <h5 translate="userApp.searchInterfaceTemplate.home.facetHeader"></h5>  <h5 uib-tooltip="{{\'userApp.searchInterfaceTemplate.listFilterTir.clearAllFacets\' | translate}}"> <span ng-click="$ctrl.clearAll()" class="fa fa-times"></span> </h5> </div>  <div class="facet-resize" ng-click="$ctrl.toggleFacetVisibility()"> <i class="glyphicon" ng-class="{\'glyphicon-indent-left\': $ctrl.facetVisibility, \'glyphicon-indent-right\': !$ctrl.facetVisibility}"></i> </div> </div> <div class="facet-nav col-sm-12">  <div class="facet" ng-repeat="facet in $ctrl.listFacet track by $ctrl.trackByCodes(facet.identifier, $index)" ng-if="facet.values.length > 0"> <a ng-class="{\'facet-selected\': $ctrl.isFacetSelected(facet)}" ng-click="$ctrl.toggleFacet(facet.identifier)"> <span class="fa" ng-class="{ \'fa-plus-square-o\': $ctrl.facetCollapseMap[facet.identifier], \'fa-minus-square-o\': !$ctrl.facetCollapseMap[facet.identifier] }"></span> <strong>{{facet.name}}</strong> </a>  <div uib-collapse="$ctrl.facetCollapseMap[facet.identifier]" class="ecm-custom-tree"> <ol class="ecm-custom-tree-node">  <search-facet-option ng-repeat="item in facet.values | limitTo: $ctrl.facetShowLimit track by $ctrl.trackByCodes(facet.identifier, item.value)" facet="facet" facet-option="item" on-facet-changed="$ctrl.facetChanged()" facet-map-values="$ctrl.facetMapValues"></search-facet-option> <div ng-if="facet.values.length > $ctrl.facetShowLimit"> <div uib-collapse="!$ctrl.showAllFacetValues[facet.identifier]"> <search-facet-option ng-repeat="item in facet.values track by $ctrl.trackByCodes(facet.identifier, item.value)" ng-if="$index > $ctrl.facetShowLimit - 1" facet="facet" facet-option="item" on-facet-changed="$ctrl.facetChanged()" facet-map-values="$ctrl.facetMapValues"></search-facet-option> </div> <a ng-if="$ctrl.showAllFacetValues[facet.identifier]" class="ecm-facet-show-btn" ng-click="$ctrl.showAllFacetValues[facet.identifier] = false" translate="userApp.searchInterfaceTemplate.listFilterTir.reduce"></a> <a ng-if="!$ctrl.showAllFacetValues[facet.identifier]" class="ecm-facet-show-btn" ng-click="$ctrl.showAllFacetValues[facet.identifier] = true" translate="userApp.searchInterfaceTemplate.listFilterTir.showAll"></a> </div> </ol> </div> <md-divider ng-if="!$last" class="facet-divider"></md-divider> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/searchv2/search-main/search-main.component.html','<div class="full-height flex-container-column">  <div class="flex-full no-overflow">  <search-container class="flex-full" search-dto="$ctrl.searchDTO" tir-id="$ctrl.identifier" get-search-data="$ctrl.getSearchData()"> </search-container> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/saved-search/list-saved-search/list-saved-search.html','<div class="header-filter"> <div class="clearfix"> <div class="pull-left"> <h2> <span translate="userApp.savedSearch.home.search"></span> </h2> </div> </div> </div> <div class="page-content simple-layout container-fluid"> <div class="row ecm-table-layout bg-white"> <div class="col-lg-12 col-md-12 col-centered bg-white listing-w-preview">  <form class="ecm-filter-zone"> <div class="form-group form-group-sm"> <label translate="userApp.savedSearch.home.creationDate"></label> <ecm-datepicker show-operator="false" ng-model="$ctrl.creationDateFilter" model-type="\'RANGE\'" ng-change="$ctrl.loadAllSavedSearch()"></ecm-datepicker> </div> <div class="form-group form-group-sm"> <label translate="userApp.savedSearch.home.author"></label> <select class="form-control" style="min-width: 150px;" ng-model="$ctrl.searchMap[\'author\']" ng-change="$ctrl.loadAllSavedSearch()" ng-options="option.name as option.value for option in $ctrl.authorFilterList"> <option value="">Tous les cr\xE9ateurs</option> </select> </div> </form>  <div ng-if="$ctrl.pagination.totalCount > 0"> <span translate="userApp.savedSearch.home.totalResult" translate-values="{numberResult:$ctrl.pagination.totalCount}"></span> </div> <table id="savedSearchTable" ecm-ultimate-table="static" st-pipe="$ctrl.loadTable" st-table="$ctrl.savedSearchs" st-set-sort="betterOrderBy" st-set-filter="StrictFilter" class="table table-striped table-fixed table-bordered table-hover"> <thead> <tr> <th style="width:40%" class="sortable" st-sort="savedSearch.name" translate="userApp.savedSearch.home.wording"> </th> <th class="sortable" st-sort="savedSearch.productName" translate="userApp.savedSearch.home.product"></th> <th class="sortable" st-sort="addToMenu" translate="userApp.savedSearch.home.menu"> </th> <th class="sortable" st-sort="shareWithMyGroups" translate="userApp.savedSearch.home.shared"> </th> <th class="sortable" st-sort="creator.firstName" translate="userApp.savedSearch.home.author"> </th> <th class="sortable" st-sort="creationDate" translate="userApp.savedSearch.home.creationDate"> </th> <th class="sortable" st-sort="savedSearch.searchInterfaceTemplate.name" translate="userApp.savedSearch.home.searchInterfaceTemplate"> </th> <th style="width: 185px"> </th> </tr> </thead> <tbody> <tr ng-repeat="row in $ctrl.savedSearchs"> <td style="max-width: 500px;"> <a class="ecm-tir-ee-title" ng-if="row.savedSearchDTO.name !=\'\'" ng-click="$ctrl.executeSavedSearch(row.savedSearchDTO.searchInterfaceTemplateId,row.savedSearchDTO.id,row.savedSearchDTO.productCode)"> {{ row.savedSearchDTO.name | validName }} </a> <a class="ecm-tir-ee-title" ng-if="row.savedSearchDTO.name ==\'\'">{{ row.savedSearchDTO.name | validName }}</a> </td> <td>{{row.savedSearchDTO.productName}}</td> <td> <input type="checkbox" ng-click="$ctrl.addToMenu(row,$event)" ng-model="row.addToMenu" class="sidebar-open green" aria-label="checkbox"> </td> <td> <input type="checkbox" ng-click="$ctrl.shareWithMyGroups(row,$event)" ng-disabled="!(row.authorOfSavedSearch)" ng-model="row.shareWithMyGroups" class="sidebar-open green" aria-label="checkbox"> </td> <td> {{row.creatorFullName}} </td> <td>{{row.creationDate | ecmDate:\'short\'}}</td> <td>{{row.savedSearchDTO.searchInterfaceTemplateName}}</td> <td> <button class="btn btn-primary" ng-click="$ctrl.delete(row)" ng-disabled="!(row.authorOfSavedSearch)"><i class="fa fa-trash-o fa-lg" aria-hidden="true"></i></button> </td> </tr> </tbody> <tfoot> <tr ng-if="$ctrl.savedSearchs.length==0"> <td colspan="9" class="text-center"> <span translate="userApp.savedSearch.home.NoData"></span> </td> </tr> </tfoot> </table>  <div class="text-left"> <ecm-pagination pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllSavedSearch()"></ecm-pagination> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/saved-search/create-saved-search/create-saved-search.html','<div> <div class="modal-header"> <div class="title" translate="userApp.searchInterfaceTemplate.modalSaveSearch.saveSearch"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <form name="editForm" class="form-horizontal" ng-submit="$ctrl.save()"> <div class="modal-body"> <div class="form-group form-group-sm"> <label for="libelle" class="col-sm-2 control-label"> <span translate="userApp.searchInterfaceTemplate.modalSaveSearch.label"></span><span class="text-danger">*</span> </label> <div class="col-sm-9"> <textarea ng-model="$ctrl.libelleSavedSearch" maxlength="1000" name="Libelle" class="required form-control" rows="5" style="margin: auto; width: 100%;resize: none;" required="true">\t</textarea> <p ng-show="editForm.$invalid && !editForm.$pristine" class="text-danger" translate="userApp.searchInterfaceTemplate.modalSaveSearch.labelControl"></p> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-offset-2 col-sm-9"> <div class="checkbox"> <label> <input type="checkbox" name="checkbox1" class="green" ng-model="$ctrl.addToMenu" aria-label="add To Menu"> {{\'userApp.searchInterfaceTemplate.modalSaveSearch.addToMenu\' | translate}} </label> </div> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-offset-2 col-sm-9"> <div class="checkbox"> <label> <input type="checkbox" name="checkbox3" class="green" ng-model="$ctrl.shareWithGroups" aria-label="share With Groups"> {{\'userApp.searchInterfaceTemplate.modalSaveSearch.shareWithMyGroups\' | translate}} </label> </div> </div> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.allowSave()" ng-click="$ctrl.save()" translate="userApp.searchInterfaceTemplate.modalSaveSearch.save"></button> <button type="button" class="btn btn-default" ng-click="$ctrl.answer(\'not useful\')" translate="userApp.searchInterfaceTemplate.modalSaveSearch.closeButtonText"></button> </div> </form> </div> ');
$templateCache.put('scripts/pre-upgrade/components/users/create/users-create.component.html','<div class="flex-container-column full-height"> <div class="header-filter"> <h2 translate="userApp.user.home.createLabel"></h2> </div> <div class="bg-white flex-full" style="overflow: auto;"> <form name="searchForm" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.searchLdapUsers()"> <div class="col-lg-12 col-centered voffset2"> <h5 translate="userApp.user.home.searchLabel"></h5> <div class="form-group"> <div class="col-sm-2"> <span> <input type="text" class="form-control input-xs" ng-model="$ctrl.criteria.lastName" placeholder="{{ \'userApp.user.home.lastName\' | translate }}" ng-required="!($ctrl.criteria.lastName.length || $ctrl.criteria.firstName.length || $ctrl.criteria.email.length)"> </span> </div> <div class="col-sm-2"> <span> <input type="text" class="form-control input-xs" ng-model="$ctrl.criteria.firstName" placeholder="{{ \'userApp.user.home.firstName\' | translate }}" ng-required="!($ctrl.criteria.lastName.length || $ctrl.criteria.firstName.length || $ctrl.criteria.email.length)"> </span> </div> <div class="col-sm-4"> <span> <input type="text" class="form-control input-xs" ng-model="$ctrl.criteria.email" placeholder="{{ \'userApp.user.home.email\' | translate }}" ng-required="!($ctrl.criteria.lastName.length || $ctrl.criteria.firstName.length || $ctrl.criteria.email.length)"> </span> </div> <div class="col-md-offset-1"> <button type="submit" class="btn btn-primary" ng-disabled="$ctrl.searchForm.$invalid"> <span class="glyphicon glyphicon-search" aria-hidden="true"></span> <span translate="entity.action.search"></span> </button> <button type="button" class="btn btn-default" ng-show="!displayCreateForm" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </div> </form> <div class="col-lg-12 col-md-12 col-centered listing-w-preview" ng-show="$ctrl.displayResult"> <table st-pipe="none" st-table="$ctrl.ldapUsers" class="table table-striped table-bordered table-hover ui-grid uigridTable" ng-show="$ctrl.ldapUsers.length > 0"> <thead> <tr>  <th class="col-lg-1 sortable" st-sort="lastName" translate="userApp.user.home.lastName"></th> <th class="col-lg-1 sortable" st-sort="firstName" translate="userApp.user.home.firstName"></th> <th class="col-lg-2 sortable" st-sort="email" translate="userApp.user.home.email"></th> <th class="col-lg-2 sortable" st-sort="house" translate="userApp.user.home.house"></th> <th class="col-lg-2 sortable" st-sort="persisted" translate="userApp.user.home.registred"></th> </tr> </thead> <tbody> <tr ng-click="$ctrl.select(row)" st-select-mode="single" ng-repeat="row in $ctrl.ldapUsers"> <td>{{row.lastName}}</td> <td>{{row.firstName}}</td> <td>{{row.email}}</td> <td>{{row.house | uppercase}}</td> <td> <label class="glyphicon glyphicon-ok" ng-show="row.persisted"> </label></td> </tr> </tbody> </table> <div ng-show="$ctrl.ldapUsers.length == 0"> <span class="col-sm-2" translate="userApp.user.home.NoData"></span> </div> </div> <div class="col-lg-12 col-centered voffset3" ng-show="$ctrl.displayCreateForm"> <form name="createForm" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.save()"> <div class="form-group"> <label class="col-sm-2" translate="userApp.user.home.selectedUSerLabel"></label> <div class="col-sm-2"> <span>{{$ctrl.selectedUser.firstName}} {{$ctrl.selectedUser.lastName}}</span> </div> <div class="col-sm-3"> <label for="blocked" translate="userApp.user.home.inctivateUserCheckBoxLabel"></label> <input type="checkbox" id="blocked" ng-model="$ctrl.selectedUser.activated" ng-true-value="false" ng-false-value="true" class="checkbox-inline"> </div> </div> <users-edit user="$ctrl.selectedUser" groups="$ctrl.groups" current-user="$ctrl.currentUser" roles="$ctrl.filteredRoles" show-all-roles="true"></users-edit> <div class="pull-right voffset3" style="padding-bottom: 15px"> <button type="submit" class="btn btn-primary" ng-disabled="$ctrl.createForm.$invalid"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </form> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/users/display/users-display.component.html','<div class="flex-container-column full-height"> <div class="header-filter flex-cont" style="flex-shrink: 0"> <div class="flex-full"> <h2> <span translate="userApp.user.home.title"></span> </h2> </div> <div style="align-self: center"> <button type="button" class="btn btn-primary" ui-sref="newUser"> <span class="glyphicon glyphicon-plus"></span> </button> </div> </div> <div class="bg-white"> <form class="form-horizontal" style="padding: 0 15px"> <div class="form-group form-group-sm required voffset2"> <label class="col-sm-2 control-label" style="text-align: left"> <span translate="userApp.user.home.globalSearch"></span> <em>{{\'userApp.user.home.globalSearchCmpl\' | translate}}</em> </label> <div class="col-sm-4"> <input class="form-control" type="text" size="50" ng-model="$ctrl.usersFilterCriteria" ng-model-options="{ debounce: 300 }" ng-change="$ctrl.loadAllUser(\'filtre\')"> </div> <div class="col-sm-3"> <button type="button" class="btn btn-primary" ng-click="$ctrl.loadAllUser(\'init\')" ng-attr-title="{{\'userApp.user.action.refresh\' | translate}}"> <span class="glyphicon glyphicon-refresh"></span> </button> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-2"> <select class="form-control" ng-options="house as house for house in $ctrl.allHouses" ng-change="$ctrl.houseChanged()" ng-model="$ctrl.house"> <option value="">{{\'userApp.user.action.house\' | translate}}</option> </select> </div> <div class="col-sm-2"> <select class="form-control" ng-options="group.id as group.name for group in $ctrl.groupFilters" ng-change="$ctrl.groupChanged()" ng-model="$ctrl.selectedGroupId" ng-disabled="!$ctrl.house"> <option value="">{{\'userApp.user.action.userGroup\' | translate}}</option> </select> </div> <div class="col-sm-2"> <select class="form-control" ng-options="role.id as role.name for role in $ctrl.roleFilters" ng-change="$ctrl.roleChanged()" ng-model="$ctrl.selectedRoleId" ng-disabled="!$ctrl.house"> <option value="">{{\'userApp.user.action.role\' | translate}}</option> </select> </div> </div> </form> </div> <div class="page-content bg-white"> <div class="flex-cont bg-white listing-w-preview"> <div class="c-resize"> <row> <div class="col-lg-12 col-md-12 col-centered listing-w-preview"> <table st-pipe="$ctrl.loadTable" st-table="users" class="table table-striped table-bordered table-hover ui-grid uigridTable"> <thead> <tr> <th class="col-lg-1"></th> <th class="col-lg-1 sortable" st-sort="lastName" translate="userApp.user.home.lastName"></th> <th class="col-lg-1 sortable" st-sort="firstName" translate="userApp.user.home.firstName"></th> <th class="col-lg-2 sortable" st-sort="email" translate="userApp.user.home.email"></th> <th has-authority="ROLE_ADMIN_SI"> <div class="col-lg-1" st-sort="house"> <span translate="userApp.user.home.house"></span> </div>&nbsp;&nbsp;&nbsp;&nbsp;  </th> <th class="col-lg-1" translate="userApp.user.home.admin"></th> <th has-authority="ROLE_ADMIN_HOUSE" class="col-lg-1" st-sort="house" translate="userApp.user.home.house"></th> <th class="col-lg-4" translate="userApp.user.home.affectation"></th> <th class="col-lg-1" st-sort="activated" translate="userApp.user.home.activated"></th> </tr> </thead> <tbody> <tr ng-show="users.length==0"> <td colspan="8" class="text-center"> <span translate="userApp.user.home.NoData"></span> </td> </tr> <tr ng-repeat="row in $ctrl.users"> <td> <div class="btn-group"> <span uib-dropdown=""> <span class="glyphicon glyphicon-option-vertical dropdown-toggle" uib-dropdown-toggle=""></span> <ul class="dropdown-menu" uib-dropdown-menu=""> <li> <a href="#/users/{{row.identifier}}/edit">{{\'userApp.user.action.edit\' | translate}}</a> </li> </ul> </span> </div> </td> <td>{{row.lastName}}</td> <td>{{row.firstName}}</td> <td>{{row.email}}</td> <td>{{row.house | uppercase}}</td> <td>{{row.adminHouse ? (\'userApp.user.home.house\' | translate) : row.adminSi ? "DSI" : ""}}</td>  <td> <span ng-repeat="(key, value) in row.userGroups | groupBy: \'roleName\'"> <span style="font-weight: bold">{{key}}:</span> <span ng-repeat="item in value"> {{item.name}} {{ $last ? \'\' : \', \' }}</span> </span> </td> <td> <input type="checkbox" ng-checked="{{!row.activated}}" ng-disabled="true"> </td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="12" class="text-center">  <ecm-pagination pagination-model="$ctrl.pagination" on-change="$ctrl.loadAllUser()"> </ecm-pagination> </td> </tr> </tfoot> </table> </div> </row> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/users/edit/users-edit-page.component.html','<div class="flex-container-column full-height"> <div class="header-filter"> <h2 translate="userApp.user.home.editLabel"></h2> </div> <div class="page-content bg-white flex-full"> <div class="user-detail-container flex-cont voffset2"> <div class="user-detail"> <span id="lastName">{{$ctrl.user.lastName}}</span> &nbsp; <span id="firstName">{{$ctrl.user.firstName}}</span> </div> <div class="user-detail"> <label for="email" translate="userApp.user.home.email"></label> <span id="email">{{$ctrl.user.email}}</span> </div> <div class="user-detail"> <label for="house" translate="userApp.userGroup.list.house"></label> <span id="house">{{$ctrl.user.house | uppercase}}</span> </div> <div class="user-detail"> <label for="blocked" translate="userApp.user.home.inctivateUserCheckBoxLabel"></label> <input type="checkbox" id="blocked" ng-model="$ctrl.user.activated" ng-change="$ctrl.save()" ng-true-value="false" ng-false-value="true" class="checkbox-inline"> </div> <div class="flex-full"> <button type="button" class="btn btn-primary pull-right" ng-click="$ctrl.import()"> <span class="glyphicon glyphicon-import"></span> <span translate="userApp.user.action.importAffectation"></span> </button> </div> </div> <div class="col-lg-12 col-md-12 col-centered listing-w-preview voffset2"> <users-edit user="$ctrl.user" groups="$ctrl.groups" current-user="$ctrl.currentUser" roles="$ctrl.filteredRoles" on-save="$ctrl.save()" show-all-roles="$ctrl.showAllRoles"></users-edit> </div> <div class="col-lg-12 voffset3" style="padding-bottom: 15px"> <div class="pull-left"> <button type="button" class="btn btn-primary" ng-click="$ctrl.toggleDisplayRoles()"> <i ng-if="!$ctrl.showAllRoles" class="fa fa-chevron-down"></i> <i ng-if="$ctrl.showAllRoles" class="fa fa-chevron-up"></i> <span ng-if="!$ctrl.showAllRoles" translate="userApp.user.action.seeAllRoles"></span> <span ng-if="$ctrl.showAllRoles" translate="userApp.user.action.seeHouseRoles"></span> </button> </div> <div class="pull-right"> <button type="button" class="btn btn-primary" translate="entity.action.back" ng-click="$ctrl.goBack()"> </button> </div> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/users/edit/users-edit.component.html','<table st-pipe="none" ecm-ultimate-table="static" st-table="$ctrl.grpRole" class="table table-striped table-bordered table-hover ui-grid uigridTable" multi-select="true" checkbox-model="$ctrl.selectedRoles[role.identifier]" on-select-row-change="$ctrl.onSelectRowChange()"> <thead> <tr> <th class="col-lg-3"> <span class="col-lg-2" translate="userApp.userGroup.list.role"></span> <input ng-model="$ctrl.searchRole" class="pull-right" type="text"> </th> <th class="col-lg-3"> <span class="col-lg-3" translate="userApp.user.home.affectation"></span> <input ng-model="$ctrl.searchGroup" class="pull-right" type="text"> </th> <th class="col-lg-1" translate="userApp.user.home.actions"></th> </tr> </thead> <tbody> <tr ng-repeat="role in ($ctrl.roles | filter: $ctrl.filterRoles | orderBy:role:false:$ctrl.userHouseComparator)"> <td>{{role.name}} ({{role.house}})</td> <td ng-click="$ctrl.edit(role)"> <span ng-if="!role.isEditing">{{role.flatSelectedGroups}}</span> <ui-select append-to-body="true" ng-if="role.isEditing" multiple="" ng-model="role.selectedGroups" click-outside="$ctrl.outsideEdit(role)" outside-if-not="ui-select-choices"> <ui-select-match> {{$item.name}} </ui-select-match> <ui-select-choices repeat="g in (($ctrl.groups | filter: $ctrl.filterProducts) | orderBy: \'name\' | propsFilter: {name:$select.search}) track by g.identifier"> <span ng-bind-html="g.name | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </td> <td class="col-centered button-group"> <i ng-if="role.isEditing" class="fa fa-floppy-o" ng-click="$ctrl.completeRowEdit(role)"></i> <i ng-if="!role.isEditing" class="fa fa-pencil-square-o" ng-click="$ctrl.edit(role)"></i>&nbsp;&nbsp; <i class="fa fa-trash" ng-click="$ctrl.delete(role)"></i> </td> </tr> </tbody> </table> ');
$templateCache.put('scripts/pre-upgrade/components/users/import-affectations-modal/import-affectations-modal.html','<div class="modal-header"> <div class="title" translate="userApp.user.import.importLabel"></div> </div> <form name="importAffectationForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <span translate="userApp.user.import.chooseLabel"></span> <br> <span class="col-sm-4"> <ui-select append-to-body="true" ng-model="$ctrl.selectedUser"> <ui-select-match> {{$select.selected.fullName}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchUserList($select)" refresh-delay="500" repeat="u in $ctrl.users"> <span ng-bind-html="u.fullName | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </span> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.importAffectation()" ng-disabled="importAffectationForm.$invalid"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.user.action.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/web-import/web-import-parameter/web-import-parameter.html','<div class="form-group form-group-sm required">  <div class="col-sm-4"> <label class="control-label"> <span>{{$ctrl.webImportParameter.parameter.name | translate}}</span> <span ng-if="$ctrl.webImportParameter.parameter.required" class="text-danger"> *</span> </label> </div>  <div ng-if="$ctrl.webImportParameter.parameterType === \'STRING\'" class="col-sm-3"> <input ng-if="!$ctrl.smallSize" class="form-control" type="text" ng-model="$ctrl.webImportParameter.value" name="{{$ctrl.webImportParameter.parameter.name}}" ng-required="$ctrl.webImportParameter.parameter.required"> </div> <div ng-if="$ctrl.webImportParameter.parameterType === \'ARRAYLIST\'" class="col-sm-3"> <select class="form-control" ng-model="$ctrl.webImportParameter.value" ng-options="webImportValue for webImportValue in $ctrl.webImportParameter.parameter.defaultValue"> </select> </div> <div ng-if="$ctrl.webImportParameter.parameterType === \'UPLOAD_FILE\'" class="col-sm-3"> <input type="file" ngf-select="$ctrl.initParam($file)" accept=".xml" class="form-control-file"> </div> </div>');
$templateCache.put('scripts/components/util/metadata/repository/modalTree.html','<div class="modal-header"> <div class="title"> <h2 translate="Arbre R\xE9f\xE9rentiel"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="updateFilterTree()"> <div class="modal-body modal-scrollable" style="display: flex"> <div class="col-sm-7"> <input type="text" class="form-control input-sm" ng-model="treeFilter" ng-change="filterChanged()"> <div class="voffset2" ng-if="filteredNodes.length>0"> <span ng-show="isLoading" translate="global.LOADING"></span>  <script type="text/ng-template" id="nodes_renderer.html"> <div ng-init="initCollapse(node)" class="angular-ui-tree-handle" ng-dblclick="node.collapsed = !node.collapsed"> <a class="" ng-if="node.children && node.children.length > 0" ng-click="node.collapsed = !node.collapsed" style="text-decoration:none;"> <span class="glyphicon" ng-class="{\'glyphicon-chevron-right\': node.collapsed,\'glyphicon-chevron-down\': !node.collapsed}"></span> </a> <span class="node-header" ng-style="{\'margin-left\': node.children && node.children.length === 0 ? \'16px\' : \'0\'}"> <label style="cursor: pointer"> <input type="checkbox" ng-model="refMap[node.refValueId] " ng-click="toggleAll(node)"></input> {{lang==\'fr\' ? node.labelFR : node.labelEN }}</label> </span> </div> <ol ng-model="node.children" ng-if="!node.collapsed" ng-class="{hidden: node.collapsed}" class="angular-ui-tree-nodes"> <li ng-repeat="node in node.children track by trackByRefId(node, $index)" ng-include="\'nodes_renderer.html\'"></li> </ol> </script> <div id="tree-root" data-drag-enabled="false" class="ecm-repo-tree" style="overflow-y: auto; max-height:650px"> <ol class="angular-ui-tree-nodes"> <li ng-repeat="node in filteredNodes track by trackByRefId(node, $index)" ng-include="\'nodes_renderer.html\'"></li> </ol> </div> </div> <div class="voffset2" ng-if="filteredNodes.length==0"> <span translate="userApp.editMetaData.home.noData"></span> </div> </div> <div class="col-sm-5"> <div class="ecm-referential-meta-display"> <div ng-repeat="model in referentialValueDisplay track by $index"> <label style="cursor: pointer"> <input type="checkbox" ng-model="refMap[model.identifier]" ng-click="toggleAll(null, model)"> {{model.path}} </label> </div> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-click="ok()" ng-if="treeNodes.length>0"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="cancel()" ng-if="treeNodes.length==0"> <span class="glyphicon glyphicon-ok"></span> OK </button> <button type="button" class="btn btn-default" ng-click="cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/commons/confirm-modal/confirm-validation/confirm-validation.html','<div> <div class="modal-header"> <div class="title" translate="{{$ctrl.resolve.message.title}}"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group" style="word-wrap: break-word;"> <p translate="{{$ctrl.resolve.message.text}}"></p> </div> </div> <div class="modal-footer" style="font-size:12px;"> <button type="button" class="btn btn-primary" ng-click="$ctrl.confirm(false)" translate="{{$ctrl.onlyEeButtonText}}"></button> <button type="button" class="btn btn-primary" ng-click="$ctrl.confirm(true)" translate="{{$ctrl.includeLinksButtonText}}"></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" translate="{{$ctrl.cancelButtontext}}"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/check-broken-links/check-broken-links.html','<div> <div class="modal-header"> <span class="text-danger" translate="userApp.editorialEntity.home.brokenLinksWarning"></span> <i class="icon ion-alert error text-danger"></i> </div> <div class="modal-body"> <p> <span translate="userApp.editorialEntity.msg.wfBrokenLinksWarning"></span> </p> <p> <ul class="dashed-list"> <li ng-repeat="brokenLinkWording in $ctrl.workflowHistoryDTO.brokenLinksReportDTO.targetEntitiesWordingList"> <span ng-if="$ctrl.isEmptyWording(brokenLinkWording)" translate="userApp.editorialEntity.home.noTitle"></span> <span ng-if="!$ctrl.isEmptyWording(brokenLinkWording)" ng-bind-html="brokenLinkWording"></span> </li> </ul> </p> <p> <span translate="userApp.editorialEntity.msg.wfBrokenLinksWarningQuestion"></span> </p> </div> <div class="modal-footer"> <button class="btn btn-primary" data-ng-click="$ctrl.clore()"> <span translate="entity.action.clore"></span> </button> <button class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/clone-entity-modal/clone-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.cloneEditorialEntity.home.clone"></div> </div> <form name="cloneEditorialEntityForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable">  <div class="alert alert-danger" role="alert" ng-if="$ctrl.errorExistEntityWithSomeMetaDiscriminants"> <span translate="userApp.editorialEntity.msg.errorExistEntityWithSomeMetaDiscriminants"></span> </div> <span translate="userApp.cloneEditorialEntity.home.confirmClone"></span> <label ng-bind-html="$ctrl.editorialEntity.titleSystem"></label> ?  <br> <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" edit="true" show-meta-product="true" is-duplication="true"></product-group> <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.titleField"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <text-area-with-menu html-text="$ctrl.editorialEntity.system.systemTitle" show-remaining-characters-helper="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.editorialEntity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> </div>  <system-author label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" edit-authors="true"></system-author> <meta-data-field meta-data-instance="metaDataInstance" ng-repeat="metaDataInstance in $ctrl.editorialEntity.metaInstanceList" product-code="$ctrl.editorialEntity.ownerGroup" form="cloneEditorialEntityForm" lang="$ctrl.lang" display="false" max-size-media="$ctrl.maxSizeMedia" ee-source-flash-id="$ctrl.flashId" eet-id="$ctrl.editorialEntity.editorialEntityTemplate.identifier" current-user="$ctrl.currentUser" is-creating-entity="false" ng-if="metaDataInstance.instantiation"></meta-data-field> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.validateAndClone()" ng-disabled="cloneEditorialEntityForm.$submitted || cloneEditorialEntityForm.$invalid || $ctrl.isMetadataUniqueValueViolated()"> <i class="glyphicon glyphicon-save"></i> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/clone-entity-modal/validation-clone-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.cloneEditorialEntity.home.clone"></div> </div> <div class="modal-body modal-scrollable"> <br> <div ng-if="$ctrl.subTreeEntities.length > 0"> <span translate="userApp.cloneEditorialEntity.body.existsSubTreeEntities"></span> <ul> <li ng-repeat="subTreeEntity in $ctrl.subTreeEntities"> <a href="" target="_blank" ui-sref="editorialEntity({id: subTreeEntity.identifier})"> <span ng-bind-html="subTreeEntity.system.systemTitle"></span> </a> </li> </ul> </div> <br> <div ng-if="$ctrl.subEntitiesWithDiscriminants.length > 0"> <span translate="userApp.cloneEditorialEntity.body.existsSubEntitiesWithDiscriminants"></span> <ul> <li ng-repeat="subEntityWithDiscriminant in $ctrl.subEntitiesWithDiscriminants"> <a href="" target="_blank" ui-sref="editorialEntity({id: subEntityWithDiscriminant.identifier})"> <span ng-bind-html="subEntityWithDiscriminant.system.systemTitle"></span> </a> </li> </ul> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="button" class="btn btn-primary" ng-click="$ctrl.ok()"> <span translate="entity.action.exit"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/create-and-hook-ee-wizard.tpl.html','<div class="modal-header"> <div class="title"> <h5 style="font-size: 24px;">{{\'userApp.linkAndCreateEeWizard.labels.title\' | translate}} </h5> <h6>{{ $ctrl.currentStep.name | translate: { entityType : $ctrl.rtEet.editorialEntityTemplate.wording } }}</h6> <h6><strong>{{$ctrl.rtBreadcrumb}}</strong></h6> </div> </div> <div class="modal-body flex-full" style="height : auto"> <div id="wizard-container" class="flex-container-column"> <div id="wizard-content-container" class="flex-full"> <div ng-if="$ctrl.errors.length > 0"> <ul ng-repeat="error in $ctrl.errors"> <li>{{error | translate}}</li> </ul> </div>  <rt-eet-selection ng-if="$ctrl.isActiveStep01()" eet-code="$ctrl.eeSourceDetails.eetCode" relation-template-id="$ctrl.eeSourceDetails.relationTemplateId" on-rt-eet-selected="$ctrl.onRtEetSelected(rtEet,launchNextStep,accessedSelectRtEetStep)" relationship-meta-case="$ctrl.relationshipMetaCase"></rt-eet-selection> <create-ee-form ng-if="$ctrl.isActiveStep02()" eet-code="$ctrl.rtEet.editorialEntityTemplate.code" current-user="$ctrl.currentUser" editorial-entity="$ctrl.editorialEntity" on-valid-form="$ctrl.onValidForm(status)" editorial-ee-product="$ctrl.editorialEeProduct"></create-ee-form> <relation-reference-node ng-if="$ctrl.isActiveStep03()" ee-source-details="$ctrl.eeSourceDetails" relation-template-details="$ctrl.relationTemplateDetails" target-entities="$ctrl.targetEntities" on-relations-ref-nodes-initialized="$ctrl.onRelationsRefNodesInitialized(relations,accessedRelationsReferenceNodeStep,referenceNodes)" on-errors="$ctrl.onErrors(errors)" is-reference-nodes-creation="true" relation-meta-datas-list="$ctrl.relationMetaDatasList" sub-element-details="$ctrl.subElementDetails" on-valid-form="$ctrl.onValidForm(status)"></relation-reference-node> </div> </div> </div> <div class="modal-footer"> <div class="pull-left" ng-if="$ctrl.isActiveStep03()"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div id="wizard-navigation-container"> <div class="pull-right"> <button class="btn btn-default" name="previous" ng-show="$ctrl.isPrevious()" type="button" ng-click="$ctrl.previous()"> <i class="fa fa-arrow-left"></i> <span translate="userApp.linkAndCreateEeWizard.action.previous"> </span></button> <button class="btn btn-primary" ng-disabled="!$ctrl.isNext() || !$ctrl.isValidForm || $ctrl.isMetadataUniqueValueViolated($ctrl.editorialEntity.metaInstanceList)|| $ctrl.isMetadataUniqueValueViolated($ctrl.relationMetaDatasList)" name="next" type="button" ng-click="$ctrl.next()"> <span ng-show="!$ctrl.isFinalStep()">{{\'userApp.linkAndCreateEeWizard.action.next\' | translate}}</span> <span ng-show="$ctrl.isFinalStep()">{{\'userApp.linkAndCreateEeWizard.action.save\' | translate}}</span> <i ng-show="!$ctrl.isFinalStep()" class="fa fa-arrow-right"></i> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.dismiss()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.linkAndCreateEeWizard.action.cancel"></span> </button> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/decline-proposal/multi-decline-proposal-modal.html','<div class="modal-header"> <div class="title" translate="userApp.product.multiDeclineProposalModal.title"></div> </div> <form name="multiDeclineProposalForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <div ng-if="$ctrl.proposalsNotToBeDecline.length > 0"> <span translate="userApp.product.multiDeclineProposalModal.body.enableToDeclineProposalsMessage"></span> <ul> <li ng-repeat="proposalNotToBeDecline in $ctrl.proposalsNotToBeDecline"> <strong> <span style="color:#16a085" ng-bind-html="\'\\&#42;\'"></span> <span ng-bind-html="proposalNotToBeDecline.entityName | validName"></span>    </strong> </li> </ul> </div> <br> <div> <span translate="userApp.product.multiDeclineProposalModal.body.{{!$ctrl.isAnyProposalToBeDecline ? \'confirmMessage\' : \'warningMessage\'}}"></span> <ul> <li ng-repeat="proposalToBeDecline in $ctrl.proposalsToBeDecline"> <strong> <span style="color:#16a085" ng-bind-html="\'\\&#42;\'"></span> <span ng-bind-html="proposalToBeDecline.entityName | validName"></span>    </strong> </li> </ul> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" ng-if="!$ctrl.isAnyProposalToBeDecline" type="button" ng-click="$ctrl.declineProposals()"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.product.multiDeclineProposalModal.action.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.product.multiDeclineProposalModal.action.{{!$ctrl.isAnyProposalToBeDecline ? \'cancel\' : \'exit\'}}"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/duplicate-entity-modal/duplicate-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.duplicateEditorialEntity.home.duplicate"></div> </div> <form name="duplicateEditorialEntityForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <div class="form-group form-group-sm"> <div class="col-sm-6"> <span translate="userApp.duplicateEditorialEntity.home.confirmDuplication"></span> <label ng-bind-html="$ctrl.editorialEntity.titleSystem"></label> ? </div> </div>  <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" owner-group="$ctrl.ownerGroup" edit="$ctrl.editOwnerGroup" show-meta-product="true" metas-association="$ctrl.metasAssociation" is-duplication="true"></product-group> <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.titleField"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <text-area-with-menu html-text="$ctrl.editorialEntity.system.systemTitle" show-remaining-characters-helper="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.editorialEntity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> </div>  <system-author label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" edit-authors="false"></system-author> <meta-data-field meta-data-instance="metaDataInstance" ng-repeat="metaDataInstance in $ctrl.editorialEntity.metaInstanceList" product-code="$ctrl.editorialEntity.ownerGroup" form="duplicateEditorialEntityForm" lang="$ctrl.lang" display="false" max-size-media="$ctrl.maxSizeMedia" ee-source-flash-id="$ctrl.flashId" eet-id="$ctrl.editorialEntity.editorialEntityTemplate.identifier" current-user="$ctrl.currentUser" is-creating-entity="false" ng-if="metaDataInstance.instantiation"></meta-data-field> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.duplicateEditorialEntity()" ng-disabled="duplicateEditorialEntityForm.$invalid"> <i class="glyphicon glyphicon-save"></i> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/edit-workflow-modal/edit-workflow-modal.html','<div> <div class="modal-header"> <div class="title" translate="userApp.editorialEntity.menu.stepWork"></div> </div> <form name="editWrkForm" role="form" class="meta-group form-horizontal" autocomplete="off" novalidate="" ng-submit="$ctrl.save($ctrl.workflowHistorySaved, $ctrl.editorialEntity, $ctrl.isMulti, $ctrl.entityIds)"> <div class="modal-body modal-scrollable"> <div ng-if="!$ctrl.isMulti"> <div> <h3 translate="userApp.editorialEntity.home.currentStat"></h3> </div>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.system.systemVersionMaj > 0"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.editorialEntity.home.typeUpdate"></span> </label> </div> <div class="col-sm-6"> <select class="form-control" ng-model="$ctrl.editorialEntity.workFlowHistoryDTO.workflowType" id="typeUpdate"> <option value="MAJOR">{{"MAJOR" | translate}}</option> <option value="MINOR">{{"MINOR" | translate}}</option> </select> </div> </div>  <div class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.editorialEntity.home.statusAct"></span> </label> </div> <div class="col-sm-6"> {{$ctrl.editorialEntity.workFlowHistoryDTO.currentStep ? $ctrl.editorialEntity.workFlowHistoryDTO.currentStep.workflowStatusName : \'userApp.editorialEntity.home.noStatus\'| translate}} </div> </div>  <div class="form-group form-group-sm"> <div class="col-sm-4"> <label for="typeUpdate" class="control-label"> <span translate="userApp.editorialEntity.home.stepwfw"></span> </label> </div> <div class="col-sm-6"> {{$ctrl.editorialEntity.workFlowHistoryDTO.currentStep ? $ctrl.editorialEntity.workFlowHistoryDTO.currentStep.name : \'userApp.editorialEntity.home.noStep\'| translate}} </div> </div>  <div class="form-group form-group-sm"> <div class="col-sm-4"> <label for="typeUpdate" class="control-label"> <span translate="userApp.editorialEntity.home.assign"></span> </label> </div> <div class="col-sm-6"> {{$ctrl.editorialEntity.workFlowHistoryDTO.currentStep.assignmentRole.name}} </div> </div>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.locked"> <div class="col-sm-4"> <label for="typeUpdate" class="control-label"> <span translate="userApp.editorialEntity.home.lockedBy"></span> </label> </div> <div class="col-sm-6">{{$ctrl.editorialEntity.userLock.firstName}} {{$ctrl.editorialEntity.userLock.lastName}} </div> </div>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.currentStep.deadLine"> <div class="col-sm-4"> <label for="typeUpdate" class="control-label"> <span translate="userApp.editorialEntity.home.deadLineActual"></span> </label> </div> <div class="col-sm-6">{{$ctrl.editorialEntity.workFlowHistoryDTO.currentStep.deadLine | ecmDate}} </div> </div>  <div ng-if="$ctrl.editorialEntity.workflowInstanceDTO.workflowId === $ctrl.editorialEntity.workFlowHistoryDTO.workflowId"> <meta-data-field meta-data-instance="wfMetadataInstance" ng-repeat="wfMetadataInstance in $ctrl.editorialEntity.workflowInstanceDTO.wfMetaDataInstanceDTOList" readonly="true" lang="$ctrl.lang" product-code="$ctrl.productCode" display="true"></meta-data-field> </div> </div>  <div class="form-group form-group-sm required"> <div class="col-sm-4"> <label for="stepUpdate" class="control-label"> <span translate="userApp.editorialEntity.home.stepDisp"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-6"> <select ng-disabled="$ctrl.disableSelectStep()" class="form-control" ng-model="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep" id="stepUpdate" ng-change="$ctrl.selectedStepChanged(step.id)" ng-options="step.name disable when (step.currentStep && !$ctrl.isMulti) for step in $ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO" required="true"> <option ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.stepsDTO.length > 1"></option> </select> <div class="alert alert-info" role="alert" ng-show="$ctrl.showMultiAutoPublishingInfoMsg()"> <span translate="userApp.editorialEntity.msg.wfInfoMultiAutoPublishingStep"></span> </div> <div class="alert alert-info" role="alert" ng-show="$ctrl.showAutoPublishingInfoMsg()"> <span translate="userApp.editorialEntity.msg.wfInfoAutoPublishingStep"></span> </div> </div> </div>  <div class="form-group form-group-sm" ng-if="$ctrl.roleSelectDisplay()"> <div class="col-sm-4"> <label for="groupList" class="control-label"> <span translate="userApp.editorialEntity.home.assignedRole"></span> </label> </div> <div class="col-sm-6"> <select ng-disabled="$ctrl.disableSelectRole()" class="form-control" ng-change="$ctrl.roleSelectChanged()" ng-model="$ctrl.selectedRole" id="groupList" ng-options="role as role.name for role in $ctrl.roles"> <option ng-if="$ctrl.roles.length > 1"></option> </select> </div> </div>   <div class="form-group form-group-sm" ng-if="$ctrl.userSelectDisplay()"> <div class="col-sm-4"> <label for="users" class="control-label"> <span translate="userApp.editorialEntity.home.indAssign"></span> </label> </div> <div class="col-sm-6"> <ui-select ng-model="$ctrl.selectedUser" ng-change="$ctrl.onSelect($select.selected);" ng-disabled="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus"> <ui-select-match allow-clear="true" placeholder="{{\'userApp.editorialEntity.home.name\'| translate}}"> {{$select.selected.fullName}} </ui-select-match> <ui-select-choices repeat="user in $ctrl.userList | filter:{fullName: $select.search }"> <span ng-bind-html="user.fullName | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> <span ng-if="!$ctrl.isValidUser" class="text-danger" translate="userApp.editorialEntity.home.errorDefaultUser"></span> </div> </div>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.commentAllowed"> <div class="col-sm-4"> <label for="comment" class="control-label"> <span translate="userApp.editorialEntity.home.comment"></span> </label> </div> <div class="col-sm-6"> <textarea ng-model="$ctrl.editorialEntity.workFlowHistoryDTO.comment" maxlength="1000" name="comment" class="form-control" rows="3">{{$ctrl.editorialEntity.workFlowHistoryDTO.comment}}</textarea> </div> </div> <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.deadlineInstallationAllowed && !$ctrl.isNotValidStep() && !$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus"> <div class="col-sm-4"> <label for="deadLineInput" class="control-label"> <span translate="userApp.editorialEntity.home.deadLine"></span> </label> </div> <div class="col-sm-4"> <ecm-datepicker name="deadLineInput" ng-model="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.deadLine"></ecm-datepicker> <span ng-if="editWrkForm.deadLineInput.$invalid && editWrkForm.deadLineInput.$touched" class="text-danger" translate="entity.validation.date"></span> </div> </div> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-if="$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus"> <span translate="entity.action.clore"></span> </button> <button type="submit" class="btn btn-primary" ng-if="!$ctrl.editorialEntity.workFlowHistoryDTO.selectedStep.finalStatus" ng-disabled="$ctrl.isNotValidStep() || $ctrl.workflowHistorySaved.clore || !$ctrl.isValidRoleAndUser() || editWrkForm.$submitted || editWrkForm.$invalid"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/editorial-entity-action-bar/editorial-entity-action-bar.html','<div class="entity-action-bar" block-ui="actionBarUI" ng-if="!$ctrl.fromTrush"> <span class="actions-label" translate="entity.actionBar.actionsLabel" ng-hide="$ctrl.isConfifEmpty()"></span> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ng-show="$ctrl.config[\'goToEE\'].visible" ng-disabled="$ctrl.config[\'goToEE\'].disabled" ui-sref="editorialEntity({id: $ctrl.flashId})" target="{{$ctrl.openOnNewTab ? \'_blank\' : \'_self\'}}"> <i class="fa fa-lg fa-external-link"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'editContent\'].tooltip}}" ng-show="$ctrl.config[\'editContent\'].visible" ng-disabled="$ctrl.config[\'editContent\'].disabled" ng-click="$ctrl.config[\'editContent\'].disabled || $ctrl.startEdition()"> <i class="fa fa-lg fa-file-text"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'editMeta\'].tooltip}}" ng-click="$ctrl.config[\'editMeta\'].disabled || $ctrl.openEditMetaData()" ng-show="$ctrl.config[\'editMeta\'].visible" ng-disabled="$ctrl.config[\'editMeta\'].disabled"> <i class="fa fa-lg fa-pencil"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'workflow\'].tooltip}}" ng-click="$ctrl.config[\'workflow\'].disabled || $ctrl.openWorkflowModal()" ng-show="$ctrl.config[\'workflow\'].visible && !$ctrl.config[\'workflow\'].extra.showSteps" ng-disabled="$ctrl.config[\'workflow\'].disabled"> <i class="fa fa-lg fa-code-fork"></i> </a> <div class="btn-group" uib-dropdown="" ng-if="$ctrl.config[\'workflow\'].extra.showSteps"> <button id="split-button" type="button" class="btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'workflow\'].tooltip}}" ng-click="$ctrl.config[\'workflow\'].disabled || $ctrl.openWorkflowModal()" ng-show="$ctrl.config[\'workflow\'].visible" ng-disabled="$ctrl.config[\'workflow\'].disabled"> <i class="fa fa-lg fa-code-fork"></i> </button> <button type="button" class="btn btn-sm btn-primary" ng-disabled="$ctrl.config[\'workflow\'].disabled" uib-dropdown-toggle=""> <span class="caret"></span> <span class="sr-only">Split button</span> </button> <ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="split-button"> <li style="cursor: pointer" ng-repeat="step in $ctrl.config.workflow.extra.steps | orderBy:\'name\'" role="menuitem"> <a ng-click="$ctrl.executeWorkflowStep(step)">{{step.name}}</a> </li> </ul> </div> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{\'entity.actionBar.refreshPreview\'|translate}}" ng-click="$ctrl.config[\'refreshPreview\'].disabled || $ctrl.onRefreshPreview()" ng-show="$ctrl.config[\'refreshPreview\'].visible" ng-disabled="$ctrl.config[\'refreshPreview\'].disabled"> <i class="fa fa-lg fa-refresh"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'preview\'].tooltip}}" ng-click="$ctrl.config[\'preview\'].disabled || $ctrl.openPreview()" ng-show="$ctrl.config[\'preview\'].visible" ng-disabled="$ctrl.config[\'preview\'].disabled"> <i class="fa fa-lg fa-file-powerpoint-o"></i> </a> <a class="action-btn btn btn-sm btn-primary" uib-tooltip="{{$ctrl.config[\'control\'].tooltip}}" ng-click="$ctrl.config[\'control\'].disabled || $ctrl.openControl()" ng-show="$ctrl.config[\'control\'].visible" ng-disabled="$ctrl.config[\'control\'].disabled"> <i class="fa fa-lg fa-check-circle"></i> </a>  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.config[\'showInfo\'].disabled || $ctrl.loadEntityInfo()" uib-tooltip="{{\'entity.actionBar.showInfo\'|translate}}" popover-trigger="\'outsideClick\'" popover-enable="!$ctrl.config[\'showInfo\'].disabled" popover-class="complete-info" popover-placement="left-top" uib-popover-template="\'scripts/pre-upgrade/components/editorial-entity/entity-info-tooltip/entity-info-tooltip-complete.html\'" ng-show="$ctrl.config[\'showInfo\'].visible" ng-disabled="$ctrl.config[\'showInfo\'].disabled"> <i class="fa fa-lg fa-question-circle"></i> </a>  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.config[\'print\'].disabled || $ctrl.printPreview()" uib-tooltip="{{\'entity.actionBar.print\'|translate}}" ng-show="$ctrl.config[\'print\'].visible" ng-disabled="$ctrl.config[\'print\'].disabled"> <i class="fa fa-lg fa-print"></i> </a>  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.config[\'publish\'].disabled || $ctrl.openPublishModal()" uib-tooltip="{{$ctrl.config[\'publish\'].tooltip}}" ng-show="$ctrl.config[\'publish\'].visible" ng-disabled="$ctrl.config[\'publish\'].disabled"> <i class="fa fa-lg fa-upload"></i> </a> </div> <div class="entity-action-bar" block-ui="actionBarUI" ng-if="$ctrl.fromTrush"> <span class="actions-label" translate="entity.actionBar.actionsLabel" ng-hide="$ctrl.isConfifEmpty()"></span>  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.deleteEntity()" uib-tooltip="{{\'userApp.trash.menuAction.DELETE\' | translate}}"> <i class="fa fa-lg fa-trash"></i> </a>  <a class="action-btn btn btn-sm btn-primary" ng-click="$ctrl.config[\'restor\'].disabled || $ctrl.restoreEntity()" uib-tooltip="{{\'userApp.trash.menuAction.RESTORE\' | translate}}"> <i class="fa fa-undo"></i> </a> </div> <div ng-class="$ctrl.contentClass" ng-transclude=""> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/import-article-modal/import-article-modal.html','<div class="modal-header"> <div class="title" translate="userApp.importArticle.home.import"></div> </div> <form name="importArticleForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <span translate="userApp.importArticle.home.confirmImport"></span> <label ng-bind-html="$ctrl.editorialEntity.titleSystem"></label> ? <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" owner-group="$ctrl.ownerGroup" edit="true" show-meta-product="true" is-import="true" display-group="false"></product-group> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.importArticle()" ng-disabled="importArticleForm.$invalid"> <i class="glyphicon glyphicon-save"></i> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/init-workflow-modal/init-workflow-modal.html','<div> <div class="modal-header"> <div class="title" translate="userApp.editorialEntity.home.initWorkflow"></div> </div> <br> <div style="padding-left: 10px" translate="userApp.editorialEntity.msg.validateInitWorkflowUpdate"></div> <br> <form name="editWrkForm" role="form" class="form-horizontal meta-group" autocomplete="off" novalidate="" ng-submit="$ctrl.save()"> <div class="modal-body modal-scrollable"> <div> <meta-data-field meta-data-instance="wfMetadataInstance" ng-repeat="wfMetadataInstance in $ctrl.workflowInstanceDTO.wfMetaDataInstanceDTOList" readonly="false" lang="$ctrl.lang" product-code="$ctrl.productCode"></meta-data-field> </div> </div> <div class="modal-footer"> <div ng-if="$ctrl.workflowInstanceDTO.wfMetaDataInstanceDTOList.length > 0" class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="button" class="btn btn-default" ng-click="$ctrl.editReadOnly()" ng-if="$ctrl.isReadonlyEditionAllowed()"> <span class="fa fa-lg fa-file-text"> </span> <span translate="entity.action.editInReadonlyMode"> </span> </button> <button type="submit" class="btn btn-primary" ng-disabled="editWrkForm.$invalid"> <span translate="entity.action.validateInitWorkflowUpdate"> </span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"> </span> <span translate="entity.action.cancel"> </span> </button> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/publish-ee-form-modal/publish-ee-form-modal.html','<div> <div class="modal-header"> <div class="title" translate="global.menu.modalLogout.title"> </div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group" style="word-wrap: break-word;"> <span translate="userApp.editorialEntity.msg.confirmPublicationMessage"></span> </div> <fieldset ng-if="$ctrl.publicationChannels.length > 0" class="ecm-fieldset"> <legend class="no-margin"> <span charset="UTF-8" translate="userApp.publish.list.channel"></span> </legend> <div class="row"> <div ng-repeat="item in $ctrl.publicationChannels" class="col-md-2"> <label class="checkbox-inline"> <input type="checkbox" value="item.identifier" ng-model="item.ticked" ng-change="$ctrl.selectChannels()" ng-disabled="item.checkedAndCanNotUncheck">{{item.name}}</label> </div> </div> </fieldset> <div class="alert alert-danger" role="alert" ng-if="$ctrl.publicationChannels.length === 0"> <span translate="userApp.publish.msg.noChannelsConfigured"></span> </div> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-click="$ctrl.confirmPublish()" translate="userApp.editorialEntity.action.confirm"></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" translate="{{$ctrl.fromForm ? \'userApp.editorialEntity.action.goBackForm\' : \'entity.action.cancel\'}}"></button> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/tree-auto-mount/tree-auto-mount.tpl.html','<div class="modal-header"> <div class="title"> <h5 style="font-size: 24px;"> <span translate="userApp.treeEEEdition.toolbar.automaticMounting"></span> </h5> </div> </div> <form name="selectFilterValuesForm" ng-submit="$ctrl.closeModal()" role="form" class="form-horizontal" novalidate=""> <div class="modal-body"> <search-solr-filter ng-show="$ctrl.showAutoMountingFilters && !$ctrl.showAdvanced" filters="$ctrl.rawFilters" mounting-rt="$ctrl.mountingRt"> </search-solr-filter> <entity-auto-mount ng-if="$ctrl.showAdvanced" exact-match="$ctrl.exactMatch" approximate-match="$ctrl.approximateMatch" columns="$ctrl.columns" show-advanced="$ctrl.showAdvanced" exact-match-selected="$ctrl.exactMatchSelected" approximate-match-selected="$ctrl.approximateMatchSelected" exact-filters-display="$ctrl.exactFiltersDisplay"></entity-auto-mount> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="button" ng-click="$ctrl.previous()" ng-if="$ctrl.showAutoMountingFilters && $ctrl.showAdvanced" class="btn btn-primary"> <span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.previous"></span> </button> <button type="button" ng-click="$ctrl.next()" ng-if="$ctrl.showAutoMountingFilters && !$ctrl.showAdvanced" class="btn btn-primary" ng-disabled="$ctrl.isMandatoryMountingFiltersEmpty()"> <span translate="entity.action.next"></span> <span class="glyphicon glyphicon-arrow-right"></span> </button> <button type="button" ng-click="$ctrl.mount()" class="btn btn-primary" ng-if="$ctrl.showAdvanced" ng-disabled="$ctrl.entityChecked()"> <span translate="userApp.treeEEEdition.labels.mount"></span> <span class="glyphicon"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.close()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-intra-link/choose-ee-from-tree/choose-ee-from-tree.component.html','<div class="container-fluid bg-white listing-w-preview" style="padding: 10px 15px"> <div class="ecm-tree-container"> <div class="k-content" style="min-height: 50px"> <div ng-if="!$ctrl.selectableFound" class="alert alert-warning"> <span translate="userApp.linkingWizard.home.noSelectabeleItem"></span> </div> <div id="treeView" kendo-tree-view="$ctrl.treeview" data-expanded="true" k-data-source="$ctrl.source" k-data-bound="$ctrl.onDataBound" k-on-change="$ctrl.onChange(dataItem)"> <div class="treeView ecm-treeview" k-template="" id="{{dataItem.id}}"> <node-view node="dataItem" read-only="true" show-nodes-meta-data="false" inter-post-link="true" tee-codes="$ctrl.teeCodes" entity-flash-id="$ctrl.entityFlashId" selected-element="$ctrl.selectedElement" show-summary="true"></node-view> </div> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-intra-link/choose-tree/choose-tree.component.html','<table st-table="parentList" class="table bg-white table-striped table-bordered table-hover ui-grid uigridTable center"> <thead> <tr> <th class="text-ellipsis"> </th> <th class="text-ellipsis"> <label translate="userApp.linkingWizard.home.label"></label> </th> <th class="text-ellipsis"> <label translate="userApp.linkingWizard.home.contentType"></label> </th> <th class="text-ellipsis"> <label translate="userApp.linkingWizard.home.status"></label> </th> <th class="text-ellipsis"> <label translate="userApp.linkingWizard.home.availability"></label> </th> </tr> </thead> <tbody> <tr ng-class="{\'st-selected\':$ctrl.selectedParent.identifier === parent.identifier}" ng-repeat="parent in $ctrl.parents"> <td> <input name="selectedParent" type="radio" ng-model="$ctrl.selectedParent" ng-value="parent" ng-change="$ctrl.parentChosen({slectedParent:parent})"> </td> <td>{{ parent.title }}</td> <td>{{ parent.contentType }}</td> <td>{{ parent.status }}</td> <td> <div> <data ng-init="padlock=parent.availability"> <data ng-init="color=(padlock|split:\'#\':0)"> <data ng-init="closed=((padlock|split:\'#\':1)==\'true\')"> <data ng-init="owner=(padlock|split:\'#\':2)"> <padlock-icon color="color" closed="closed" owner="owner" size="small"></padlock-icon> </data></data></data></data></div> </td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="5" class="text-center"> <div st-pagination="" st-items-by-page="20" st-displayed-pages="7"></div> </td> </tr> </tfoot> </table>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-link/choose-editorial-entity/choose-editorial-entity.component.html','<div class="ecm-tir-modal"> <div class="container-fluid bg-white tir-container"> <div> <p ng-if="$ctrl.linkText"><strong translate="userApp.linkingWizard.home.LinkText"></strong> : {{$ctrl.linkText}}</p> </div> <div class="row tir-content"> <search-solr-main ng-if="$ctrl.enableMultiEETargetSelection" class="flex-full no-overflow" saved-search="null" tir-id="$ctrl.tirId" ee-target-chosen="$ctrl.eeTargetChosen({eeTarget:eeTarget})" ee-selected="$ctrl.eeSelected" edit-tir-in-modal="true" hide-mass-operation-container="true" ee-list-checked="$ctrl.eeListChecked" on-select-row-change="$ctrl.onSelectRowChange({row: row})" on-select-all-change="$ctrl.onSelectAllChange()" search-flash-id="$ctrl.searchFlashId" node-flash-id="$ctrl.nodeFlashId" tr-code="$ctrl.trCode" search-solr="$ctrl.searchSolr" multi-select="true"> </search-solr-main>  <search-solr-main ng-if="!$ctrl.enableMultiEETargetSelection" class="flex-full no-overflow" saved-search="null" tir-id="$ctrl.tirId" ee-target-chosen="$ctrl.eeTargetChosen({eeTarget:eeTarget})" ee-selected="$ctrl.eeSelected" edit-tir-in-modal="true" search-flash-id="$ctrl.searchFlashId" node-flash-id="$ctrl.nodeFlashId" tr-code="$ctrl.trCode" search-solr="$ctrl.searchSolr"></search-solr-main> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-link/choose-relationship/choose-relationship.component.html','<table st-table="relationshipTemplateList" ng-if="$ctrl.relationshipTemplateList.length" class="table bg-white table-striped table-bordered table-hover ui-grid uigridTable center"> <thead> <tr> <th width="50%" class="text-ellipsis" st-sort="wording"><label translate="userApp.linkingWizard.home.label"></label></th> <th width="50%" class="text-ellipsis" st-search="description"><label translate="userApp.linkingWizard.home.description"></label></th> </tr> <tr> <th><input st-search="wording"></th> <th></th> </tr> </thead> <tbody> <tr ng-class="{\'st-selected\':$ctrl.selectedValue.id === relationshipTemplate.id}" ng-repeat="relationshipTemplate in $ctrl.relationshipTemplateList" ng-dblclick="$ctrl.gotoStep({newStep:$ctrl.currentStep.step + 1})" ng-click="$ctrl.prepareFirstStep({relationshipTemplate:relationshipTemplate})"> <td>{{ relationshipTemplate.wording }}</td> <td>{{ relationshipTemplate.description }}</td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="5" class="text-center"> <div st-pagination="" st-items-by-page="20" st-displayed-pages="7"></div> </td> </tr> </tfoot> </table> <div align="center" ng-if="$ctrl.relationshipTemplateList.length == 0"> <hr size="10" width="50%"> <strong><span translate="userApp.user.home.NoData"></span></strong> <hr size="10" width="50%"> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-link/enter-relationship-metadata/enter-relationship-metadata.component.html','<div block-ui="displayMetaDataDiv" class="panel panel-default form-horizontal" style="padding: 10px"> <div class="panel-body">  <div class="form-group" ng-if="$ctrl.targetEntities && $ctrl.targetEntities.length > 1 && !$ctrl.isLinkedRelation"> <div class="col-sm-4 col-lg-2"> <label class="control-label" style="text-align: left;"> <span translate="userApp.linkingWizard.home.duplicateMeta"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <div class="checkbox"> <label> <input type="checkbox" ng-model="$ctrl.multiRelation"> </label> </div> </div> </div> <div ng-if="$ctrl.multiRelation" ng-init="parentIndex = $index">  <div class="form-group form-group-sm" ng-show="$ctrl.isContainer"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.linkingWizard.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-3 col-lg-10"> <ecm-datepicker ng-disabled="$ctrl.containerSources.length > 0" ng-model="$ctrl.desiredPublicationDate.value" ng-required="$ctrl.isContainer"></ecm-datepicker> </div> </div>  <div class="form-group form-group-sm" ng-show="$ctrl.containerSources.length > 0"> <div class="col-sm-4 col-md-offset-2"> <label class="control-label"> <span translate="userApp.linkingWizard.home.alreadyHookedToContainerSource"></span> </label> </div> </div> <div class="form-group form-group-sm" ng-show="$ctrl.containerSources.length > 0"> <div class="col-sm-4 col-md-offset-2"> <ul> <li ng-repeat="source in $ctrl.containerSources"> <a href="" target="_blank" ui-sref="editorialEntity({id: source.identifier})"> <span ng-bind-html="source.titleSystem | translate"></span> </a> </li> </ul> </div> </div>  <meta-data-field meta-data-instance="metaData" ng-repeat="metaData in $ctrl.metaData" form="relationForm" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.ownerGroup"> </meta-data-field> </div> <uib-accordion ng-if="!$ctrl.multiRelation"> <div uib-accordion-group="" class="panel-default" style="width: 100%" ng-repeat="relation in $ctrl.relations" is-open="relation.isOpen" ng-init="relation.isOpen = $first"> <uib-accordion-heading> <div style="line-height: 1em;">{{$ctrl.trustAsHtml(relation.wording)}} <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': relation.isOpen, \'glyphicon-chevron-right\': !relation.isOpen}"></i> </div> </uib-accordion-heading> <div class="form-group" ng-show="$ctrl.isContainer"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.linkingWizard.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-8 col-lg-10"> <ecm-datepicker ng-model="relation.desiredPublicationDate" ng-disabled="relation.display" ng-required="$ctrl.isContainer"></ecm-datepicker> </div> </div>  <div class="form-group form-group-sm" ng-show="relation.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <label class="control-label"> <span translate="userApp.linkingWizard.home.alreadyHookedToContainerSource"></span> </label> </div> </div> <div class="form-group form-group-sm" ng-show="relation.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <ul> <li ng-repeat="source in relation.containerSources"> <a href="" target="_blank" ui-sref="editorialEntity({id: source.identifier})"> <span ng-bind-html="source.titleSystem | translate"></span> </a> </li> </ul> </div> </div> <meta-data-field readonly="false" meta-data-instance="metaInstance" form="relationForm" lang="$ctrl.lang" ng-repeat="metaInstance in relation.metaInstanceDTOList" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.ownerGroup"> </meta-data-field> </div> </uib-accordion> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/create-link/point-to-sub-element/point-to-sub-element.component.html','<span translate="userApp.linkingWizard.home.wishPointToSubElement"></span> <strong> <span ng-bind-html="$ctrl.wording"></span> </strong>? <span style="white-space: nowrap"> <label> <input type="radio" name="status" value="display" ng-model="$ctrl.pointToSubElement.value"> {{\'userApp.linkingWizard.home.yes\' | translate}} </label> <label> <input type="radio" name="status" value="not_display" ng-model="$ctrl.pointToSubElement.value"> {{\'userApp.linkingWizard.home.no\' | translate}} </label> </span> <br> <div ng-if="$ctrl.pointToSubElement.value === \'display\'"> <label translate="userApp.linkingWizard.home.chooseSubElement"> </label> <span ng-if="$ctrl.typeEe === \'STRUCTUREDTEXT\'"> <ecm-preview-html content="$ctrl.trustAsHtml($ctrl.eeTarget.restrictedHtmlPreview)" edit="true" selected="$ctrl.selected.value" contains="$ctrl.containsSubElement.contains"></ecm-preview-html> </span> <span ng-if="$ctrl.typeEe === \'TREE\' && $ctrl.containsSubElement.contains"> <tree-view editorial-entity="$ctrl.eeTarget" readonly="true" is-display-radio-button="true" on-node-check="$ctrl.onNodeCheck(checkedNode)" on-node-action="$ctrl.onNodeAction(selectedNode)" radion-button-display-on="[\'STRUCTURAL\',\'CONTENT\']"></tree-view> </span> <div ng-if="!$ctrl.containsSubElement.contains"> <strong> <label translate="userApp.linkingWizard.home.noSubElementToPoint"></label> </strong> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/edit-metadata-modal/bulk/edit-ees-metadata-modal.html','<div> <div class="modal-header"> <div class="title"> <h2 translate="userApp.editEEsMetaData.home.editLabel"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.save()"> <div> <div class="modal-body"> <div class="panel panel-default"> <div class="panel-body"> <div class="col-sm-7"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.editEEsMetaData.home.selectedMetaLabel"></span> </label> </div> <div class="col-sm-8"> <select class="form-control" ng-required="true" display="false" ng-model="$ctrl.selectedMetaInstance" ee-source-flash-id="$ctrl.flashIds[0]" ng-options="metaInstance.metaDataDTO.name for metaInstance in $ctrl.metaInstances"> <option value=""></option> </select> </div> </div> </div> <div class="clearfix"></div> <div class="col-sm-7"> <meta-data-field ng-if="$ctrl.selectedMetaInstance" meta-data-instance="$ctrl.selectedMetaInstance" form="editForm" lang="$ctrl.lang" ee-source-flash-id="$ctrl.flashIds[0]" display="false" editmetaee="true" eet-id="$ctrl.idTee" current-user="$ctrl.currentUser"></meta-data-field> </div> <div class="col-sm-5" ng-if="$ctrl.selectedMetaInstance.multipleOccurrences"> <div class="col-sm-4"> <input name="action" type="radio" ng-model="$ctrl.selectedMetaInstance.purgeList" value="false"> <label translate="userApp.editEEsMetaData.home.add"></label> </div> <div class="col-sm-4"> <input name="action" type="radio" ng-model="$ctrl.selectedMetaInstance.purgeList" value="true"> <label translate="userApp.editEEsMetaData.home.replace"></label> </div> </div> </div> </div> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid"> <span class="glyphicon glyphicon-save"></span> <span translate="userApp.editEEsMetaData.home.boutonOk"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </div> </form> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/link-ee-wizard-form.tpl.html','<div class="modal-header"> <div class="title"> <h5 style="font-size: 24px;">{{!$ctrl.isProofing ? \'userApp.linkEEWizard.labels.title\' : \'userApp.linkEEWizard.labels.proofingTitle\' | translate}} - <span class="ecm-wizard-current-step">{{$ctrl.currentStep.name | translate}}</span> </h5> <h6 class="ecm-wizard-breadcrumb"> <span ng-if="$ctrl.targetSystemTitle" ng-bind-html="$ctrl.formatSystemTitle($ctrl.targetSystemTitle)"></span> <strong>{{$ctrl.rtBreadcrumb}}</strong> </h6> </div> </div> <form name="editForm" role="form" class="flex-container-column form-horizontal flex-full" novalidate=""> <div class="modal-body flex-full" style="height : auto"> <div id="wizard-container" class="flex-container-column"> <div id="wizard-content-container" class="flex-full"> <div ng-if="$ctrl.errors.length > 0"> <ul ng-repeat="error in $ctrl.errors"> <li>{{error | translate}}</li> </ul> </div> <proof-channel-selection ng-if="$ctrl.isActiveStep00()" on-proof-channel-selected="$ctrl.onProofChannelSelected(proofChannelSelected, launchNextStep, accessedSelectProofChannelStep, productCode, productWording)" rt-breadcrumb="$ctrl.rtBreadcrumb" proof-channels="$ctrl.proofChannels" product-channels="$ctrl.productChannels" canals-from-product="$ctrl.canalsFromProduct"></proof-channel-selection>  <tr-selection ng-if="$ctrl.isActiveStep01()" rt-step-elements-selected="$ctrl.rtStepElementsSelected" rt-breadcrumb="ctrl.rtBreadcrumb" relationship-template-list="$ctrl.relationshipTemplateList" on-tr-selected="$ctrl.onTrSelected(trSelected,launchNextStep,accessedSelectTrStep)" current-user="$ctrl.currentUser" target-entities="$ctrl.targetEntities" is-proofing="$ctrl.isProofing"></tr-selection> <ee-source-selection ng-if="$ctrl.isActiveStep02() && !$ctrl.isProofing" rt-step-elements-selected="$ctrl.rtStepElementsSelected" rt-breadcrumb="ctrl.rtBreadcrumb" source-ees-list="$ctrl.sourceEesList" current-user="$ctrl.currentUser" is-linked="$ctrl.isLinked" on-ee-source-selected="$ctrl.onEeSourceSelected(selectedEeSource,launchNextStep,accessedSelectEeSourceStep)" target-entities="$ctrl.targetEntities" relationship-template-list="$ctrl.relationshipTemplateList" tr-selected="$ctrl.trSelected"></ee-source-selection> <list-models-component ng-if="$ctrl.isActiveStep02() && $ctrl.isProofing" current-user="$ctrl.currentUser" on-model-source-selected="$ctrl.onModelSourceSelected(selectedModel,launchNextStep,accessedSelectModelSourceStep)" with-list-filters="false" eet-codes-filters="$ctrl.modelsEetCodesFilters" product-code-filter="$ctrl.modelProductCodeFilter" publication-channel-code-filter="$ctrl.proofChannelSelected.code"></list-models-component> <ee-sub-element-selection ng-if="$ctrl.isActiveStep03()" rt-step-elements-selected="$ctrl.rtStepElementsSelected" rt-breadcrumb="ctrl.rtBreadcrumb" ee-source="$ctrl.selectedEeSource" on-sub-element-selected="$ctrl.onSubElementSelected(subElementDetails,launchNextStep,accessedSelectSubElementStep)"></ee-sub-element-selection> <relation-reference-node ng-if="$ctrl.isActiveStep04()" rt-step-elements-selected="$ctrl.rtStepElementsSelected" rt-breadcrumb="ctrl.rtBreadcrumb" ee-source-details="$ctrl.eeSourceDetails" relation-template-details="$ctrl.relationTemplateDetails" target-entities="$ctrl.targetEntities" source-ees-list="$ctrl.sourceEesList" sub-element-details="$ctrl.subElementDetails" is-linked="$ctrl.isLinked" on-relations-ref-nodes-initialized="$ctrl.onRelationsRefNodesInitialized(relations,accessedRelationsReferenceNodeStep,referenceNodes)" on-errors="$ctrl.onErrors(errors)" multi-relation="$ctrl.multiRelation" is-reference-nodes-creation="true" relation-meta-datas-list="$ctrl.relationMetaDatasList" tr-selected="$ctrl.trSelected"></relation-reference-node> </div> </div> </div> <div class="modal-footer"> <div class="pull-left" ng-if="$ctrl.isActiveStep04()"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div id="wizard-navigation-container"> <div class="pull-right"> <button class="btn btn-default" name="previous" ng-show="$ctrl.isPrevious()" type="button" ng-click="$ctrl.previous()"> <i class="fa fa-arrow-left"></i> <span translate="userApp.linkEEWizard.action.previous"> </span></button> <button ng-show="$ctrl.hideNextStepButton ?!$ctrl.hideNextStepButton : !$ctrl.isFinalStep()" class="btn btn-primary" ng-disabled="!$ctrl.isNext()" name="next" type="button" ng-click="$ctrl.next()"> <span>{{\'userApp.linkEEWizard.action.select\' | translate}}</span> <i ng-show="!$ctrl.isFinalStep()" class="fa fa-arrow-right"></i> </button> <button ng-show="$ctrl.isFinalStep()" class="btn btn-primary" ng-disabled="editForm.$invalid || $ctrl.isMetadataUniqueValueViolated()" name="next" type="button" ng-click="$ctrl.next()"> <span ng-if="!$ctrl.isProofing">{{\'userApp.linkEEWizard.action.validate\' | translate}}</span> <span ng-if="$ctrl.isProofing">{{\'userApp.linkEEWizard.action.proof\' | translate}}</span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.dismiss()"> <span class="glyphicon glyphicon-ban-circle"></span> <span ng-if="!$ctrl.isFinalStep()" translate="userApp.linkEEWizard.action.cancel"></span> <span ng-if="$ctrl.isFinalStep() && !$ctrl.trSelected.ignoreEntitiesHookedToSameProduct && !$ctrl.trSelected.ignoreEntitiesAttachedToSource && !$ctrl.trSelected.ignoreEntitiesHookedToSameEet" translate="userApp.linkEEWizard.action.quit"></span> <span ng-if="$ctrl.isFinalStep() && ($ctrl.trSelected.ignoreEntitiesHookedToSameProduct || $ctrl.trSelected.ignoreEntitiesAttachedToSource || $ctrl.trSelected.ignoreEntitiesHookedToSameEet)" translate="userApp.linkEEWizard.action.cancel"></span> </button> </div> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-modal/link-ee-wizard-modal.tpl.html','<link-ee-wizard-form is-bulk="$ctrl.isBulk" is-from-file-menu="$ctrl.isFromFileMenu" close="$ctrl.close()" proof-channels="$ctrl.proofingChannels" product-channels="$ctrl.productChannels" canals-from-product="$ctrl.canalsFromProduct" target-entities="$ctrl.targetEntities" current-user="$ctrl.currentUser" dismiss="$ctrl.dismiss()" product-code="$ctrl.productCode" is-proofing="$ctrl.isProofing"></link-ee-wizard-form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/metadata/display-editorial-metadata/display-editorial-metadata.html','<div class="ecm-meta-container meta-group" ng-class="{\'ecm-meta-slim\': $ctrl.ecmStyle.slim}"> <ul ng-repeat="metaDataGrp in $ctrl.metaGroupList"> <div ng-if="$ctrl.flashId" class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title"> <span ng-if="metaDataGrp.metaGroupName">{{metaDataGrp.metaGroupName}}</span> </h5> <div ng-if="$ctrl.editMetadataEnabled" class="panel-tools"> <label ng-click="$ctrl.editMetadata()"> <a href="" uib-tooltip="Editer" tooltip-placement="top" tooltip-append-to-body="true"> <i class="icon ion-edit"></i> </a> </label> </div> </div> <div class="panel-body"> <div class="col-sm-12 form-horizontal"> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in metaDataGrp.metaDataInstanceDTOList" display="true" readonly="true" lang="$ctrl.lang"> </meta-data-field> </div> </div> </div> </ul> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/metadata/systemAuthor/system-author.html','<div class="form-group form-group-sm"> <div class="col-sm-4" ng-class="$ctrl.labelClass"> <label class="control-label"> <span translate="userApp.editorialEntity.home.systemAuthorsLabel"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-8" ng-class="$ctrl.contentClass"> <tags-input min-length="1" class="tagsInput" ng-model="$ctrl.entity.system.systemAuthors" name="systemAuthors" ng-disabled="$ctrl.disableSystemAuthors()" placeholder="" ng-required="true" debounce-delay="1000" add-on-comma="false" display-property="fullName" key-property="login" add-from-autocomplete-only="true"> <auto-complete source="$ctrl.getAuthors($query)" display-property="fullName" key-property="login" min-length="1" max-results-to-show="20"></auto-complete> </tags-input> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/display-product-group-meta/display-product-group-meta.html','<div class="display-product-meta-container" uib-tooltip-template="\'product_metadata_component_internal.html\'" tooltip-class="ecm-lg-tooltip meta" ng-include="\'product_metadata_component_internal.html\'"> </div> <script type="text/ng-template" id="product_metadata_component_internal.html"> <!-- System suggested publication date--> <span class="ecm-display-meta-zone"> <span ng-if="$ctrl.product.associationSystem.systemSuggestedPublicationDate && !$ctrl.hideSuggestedPublicationDate" class="ecm-display-meta"> <span translate="userApp.product.associationSystem.suggestedPublicationdate"></span> <span class="ecm-display-meta-value"> {{($ctrl.product.associationSystem.systemSuggestedPublicationDate | ecmDate:\'shortDate\' )}} </span> </span> </span> <!-- editorial meta data list--> <display-meta-values metadata-list="$ctrl.metadataList" include-system="false"></display-meta-values> </script> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/edit-products/edit-products.html','<form class="ecm-filter-zone"> <div> <label ng-if="$ctrl.principalProduct" translate="userApp.product.home.principal"></label> <span>{{$ctrl.principalProduct.name}}</span> </div> <div> <button class="btn btn-primary" ng-click="$ctrl.toggleProducts($event)" ng-disabled="$ctrl.proposalProducts.length === 0">{{\'userApp.product.select.button\' | translate}}</button> <div ng-if="$ctrl.displayProducts"> <input type="text" class="form-control voffset2" placeholder="{{\'userApp.product.select.filter\'|translate}}" ng-model="$ctrl.proposalProductFilter" ng-model-options="{debounce: 200}" ng-change="$ctrl.proposalProductFilterChanged()"> <table class="table table-bordered table-hover"> <tbody class="scrollable-products"> <tr ng-repeat="product in $ctrl.filteredProposalProduct" ng-click="$ctrl.selectProduct(product);" ng-class="{\'st-selected\': $ctrl.selectedProductMap[product.id]}"> <td>{{product.label}}</td> </tr> </tbody> </table> </div> </div> </form>  <div class="row voffset3"> <div class="col-lg-12"> <table id="\'table_products\'" ecm-ultimate-table="static" on-select-row-change="$ctrl.onSelectRowChange(row)" on-select-all-change="$ctrl.onSelectAllChange()" st-pipe="$ctrl.loadTable" st-table="$ctrl.currentProducts" st-set-filter="StrictFilter" class="table table-striped table-bordered table-hover"> <thead> <tr> <th class="col-sm-2" translate="userApp.product.table.product"></th> <th class="icon-column-2x" no-drag="" no-resize=""> </th> <th class="col-sm-4" translate="userApp.product.table.parent"></th> <th class="col-sm-1" translate="userApp.product.table.status"></th> <th translate="userApp.product.table.metadata"></th> <th translate="userApp.product.table.actions"></th> </tr> </thead> <tbody> <tr ng-class="{\'st-selected\': $ctrl.isEESelected(row), \'sidebar-open\': row.eeTargetFlashId !=\'\', \'disabled-row\': row.eeTargetFlashId ===\'\', \'disabled\': row.status === \'DELETED\'}" ng-repeat="row in $ctrl.currentProducts" ng-click="$ctrl.getEEPreview(row)"> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)">  <span style="padding-right: 5px" ng-if="row.undoProposalPermitted"> <i class="pull-left icon ion-close-circled" tooltip-placement="top" uib-tooltip="{{\'TAKE_OFF\'|translate}}" ng-click="$ctrl.undoProposal(row.flashId, $ctrl.entityFlashId);"></i> </span> <span>{{ row.name }}</span> </td> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)" class="text-ellipsis icon-column"> <a ng-if="row.parentEntity.flashId" style="cursor: pointer" uib-tooltip="{{\'entity.actionBar.goToEE\'|translate}}" ui-sref="editorialEntity({ id: row.parentEntity.flashId})" ng-click="$ctrl.close()"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)" tooltip-class="ecm-lg-tooltip" uib-tooltip-html="row.parentEntity.title"> <span ng-if="row.parentEntity.flashId" ng-bind-html="row.parentEntity.title | validName"> </span> </td> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)" class="text-ellipsis"> <span>{{ row.status | translate }}</span> </td> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)"> <div style="display: flex">  <display-product-group-meta style="flex:1" product="row" metadata-list="row.metaInstances"> </display-product-group-meta> <div style="padding-left: 5px"> <i class="pull-right icon ion-edit" tooltip-placement="bottom" uib-tooltip="{{\'EDIT_META\'|translate}}" aria-hidden="true" ng-if="row.editMetaPermitted" ng-click="$ctrl.openEditMetaModal(row.flashId, row.name)"></i> </div> </div> </td> <td ng-if="!($ctrl.hidePrincipalProduct && row.principal)"> <span ng-if="row.principal">N.A</span> <div ng-if="!row.principal" class="ecm-modal-action-links"> <product-actions-bar permitted-actions="row.permittedActions" association-flash-id="row.flashId" on-refresh="$ctrl.refreshProposals()" on-close="$ctrl.close()" product-name="row.name" product-code="row.code" entity-flash-id="$ctrl.entityFlashId" entity-title="$ctrl.entityTitle" eet-code="$ctrl.teeCode" metas-association="row.metaInstances"> </product-actions-bar> </div> </td> </tr> </tbody> </table> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/edit-products-modal/edit-products-modal.html','<div class="modal-header"> <div class="title" translate="userApp.product.home.title"></div> </div> <div class="modal-body">  <edit-products entity-flash-id="$ctrl.resolve.entityFlashId" entity-title="$ctrl.resolve.entityTitle" tee-code="$ctrl.resolve.teeCode" current-products="$ctrl.resolve.currentProducts" proposal-products="$ctrl.resolve.proposalProducts"></edit-products> </div> <div class="modal-footer"> <div class="pull-right"> <button type="button" class="btn btn-primary" ng-click="$ctrl.cancel()"> <span translate="entity.action.exit"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/many-ee/product-group-many-ee.html','<div class="modal-header"> <div class="title" translate="userApp.editorialEntity.menu.productGroup"></div> </div> <form name="modalForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label for="groupList" class="control-label"> <span translate="userApp.editorialEntity.home.selectGroupLabel"></span> </label> </div> <div class="col-sm-8"> <select class="form-control" id="groupList" ng-model="$ctrl.selectedGroup" ng-options="group.code as group.name for group in $ctrl.groups"> </select> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.save()" ng-disabled="modalForm.$invalid"> <i class="glyphicon glyphicon-save"></i> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/product-actions-bar/product-actions-bar.html','<a ng-repeat="action in $ctrl.permittedActions" href="" ng-click="$ctrl.applyAction(action, $event)">{{action !== \'DELETE\' ? action : \'REMOVE\' | translate}}</a> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/product-group-modal/product-group-modal.html','<div class="modal-header"> <div class="title" translate="userApp.editorialEntity.menu.productGroup"></div> </div> <form name="modalForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <product-group entity="$ctrl.editorialEntity" tee-code="$ctrl.editorialEntity.editorialEntityTemplate.code" edit="true"></product-group> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.save()" ng-disabled="modalForm.$invalid"> <i class="glyphicon glyphicon-save"></i><span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/product-group/product-meta-data/product-meta-data.html','<div class="modal-body" ng-class="{\'bg-white\': !$ctrl.displayGroup, \'no-padding\': !$ctrl.displayGroup}">  <div ng-if="$ctrl.displayGroup"> <div class="panel-body"> <ul ng-if="metaDataByGrp.metaGroupName != \'CALCULEE\'" ng-repeat="metaDataByGrp in $ctrl.entity.productMetaInstanceByMetaGroupList"> <div class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title">{{metaDataByGrp.metaGroupName}}</h5> </div> <div class="panel-body"> <div> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in metaDataByGrp.metaDataInstanceDTOList track by $index" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.productCode"></meta-data-field> </div> </div> </div> </ul> <ul> <div class="panel panel-default"> <div class="panel-body"> <div> <div class="form-group form-group-sm">  <div class="col-sm-4" ng-class="$ctrl.labelClass"> <label class="control-label"> <span translate="userApp.editorialEntity.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-8" ng-class="$ctrl.contentClass"> <ecm-datepicker name="productSuggestedPublicationDate" ng-required="true" ng-model="$ctrl.entity.productSuggestedPublicationDate"></ecm-datepicker> </div> </div> </div> </div> </div> </ul> </div> </div> <div ng-if="!$ctrl.displayGroup"> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in $ctrl.metaDatas" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.productCode"></meta-data-field>  <div class="form-group form-group-sm"> <div class="col-sm-4" ng-class="$ctrl.labelClass"> <label class="control-label"> <span translate="userApp.editorialEntity.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-8" ng-class="$ctrl.contentClass"> <ecm-datepicker name="productSuggestedPublicationDate" ng-required="true" ng-model="$ctrl.entity.productSuggestedPublicationDate"></ecm-datepicker> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/add-node-modal/add-node-modal.html','<div class="edit-meta-modal"> <div class="modal-header"> <div class="title"> <h2 translate="{{$ctrl.title}}"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" novalidate="" ng-submit="$ctrl.save()"> <div> <div class="modal-body modal-scrollable"> <ul ng-if="metaDataByGrp.metaGroupName != \'CALCULEE\'" ng-repeat="metaDataByGrp in $ctrl.metaDataByMetaGroup"> <div class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title">{{metaDataByGrp.metaGroupName}}</h5> </div> <div class="panel-body"> <div> <meta-data-field meta-data-instance="metaInstance" ng-repeat="metaInstance in metaDataByGrp.metaDataInstanceDTOList track by $index" form="editForm" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.resolve.productCode"> </meta-data-field> </div> </div> </div> </ul> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || $ctrl.invalidMetadataForm() || $ctrl.isMetadataUniqueValueViolated()"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.add"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/edit-node-title-modal/edit-node-title-modal.html','<div class="modal-header"> <div class="title" translate="userApp.editorialEntity.home.modifyNodeTitle"></div> <span class="modal-close" ng-click="$ctrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="$ctrl.save()"> <div class="modal-body"> <div ng-if="$ctrl.node.type == \'REFERENCE\'" class="form-group form-group-sm"> <div class="col-sm-3"> <label for="modifyNodeTitle" class="control-label" translate="userApp.editorialEntity.home.linkedEETitle"> </label> </div> <div class="col-sm-4"> <p ng-bind-html="$ctrl.node.linkedEETitle"></p> </div> </div> <div class="form-group form-group-sm"> <div class="col-sm-3"> <label for="modifyNodeTitle" class="control-label" translate="userApp.editorialEntity.home.nodeTitle"></label> <span ng-if="$ctrl.titleIsRequired()" class="text-danger" aria-hidden="false"> *</span> </div> <div class="col-sm-4"> <textarea ng-required="$ctrl.titleIsRequired()" class="form-control" ng-model="$ctrl.title" maxlength="1000"></textarea> </div> </div> <div ng-if="$ctrl.node.type == \'REFERENCE\'" class="form-group form-group-sm"> <div class="col-sm-offset-3 col-sm-4" ng-if="$ctrl.loadedTitle !== \'\' && $ctrl.title === \'\'"> <span translate="userApp.editorialEntity.home.titleOverloadWillBeRemmoved"></span> </div> <div class="col-sm-offset-3 col-sm-4"> <div class="checkbox"> <label> <input type="checkbox" ng-model="$ctrl.confirm"> <span translate="userApp.editorialEntity.home.confirmOverloadLinkedEETitle"></span> <span class="text-danger" aria-hidden="false"> *</span> </label> </div> </div> </div> </div> <div class="modal-footer"> <div class="pull-left"> <label> <span class="text-danger">*</span> <span translate="entity.action.required"></span> </label> </div> <div class="pull-right"> <button type="submit" ng-disabled="editForm.$invalid || ($ctrl.node.type == \'REFERENCE\' && !$ctrl.confirm)" class="btn btn-primary"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/edit-structural-node-type/edit-structural-node-type-modal.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.editorialEntity.home.modifyNodeType"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="$ctrl.save()"> <div class="modal-body"> <div class="form-group form-group-sm"> <div class="col-sm-3"> <label class="control-label" for="nodeTitle">{{\'userApp.editorialEntity.home.nodeType\' | translate}}</label> </div> <div class="col-sm-4"> <select ng-if="$ctrl.resolve.nodeTypes.length > 0" ng-required="true" class="form-control" ng-model="$ctrl.type"> <option ng-repeat="nodeType in $ctrl.nodeTypes" value="{{nodeType}}">{{nodeType}}</option> </select> <input ng-if="$ctrl.nodeTypes.length === 0" ng-required="true" class="form-control" ng-model="$ctrl.type"> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/node-view/node-view.tpl.html','<div ng-class="{\'nodeMenu\' : $ctrl.readOnly}">  <span class="ecm-tree-node-content" ng-class="{\'disabled-node\' : $ctrl.node.grayDisplay,\'k-state-disabled\' : $ctrl.isDisabledNode()}" ng-style="$ctrl.nodeStyle()" ng-click="$ctrl.onNodeCheck({checkedNode: $ctrl.node})">  <div class="{{\'ecm-tree-title-\'+ $ctrl.node.type.toLowerCase()}}"> <input ng-if="($ctrl.node.type === \'REFERENCE\') && $ctrl.interPostLink" name="selectedParent" ng-disabled="!$ctrl.showRadioButton($ctrl.node)" type="radio" ng-click="$ctrl.elementChosen($ctrl.node)"> <input ng-if="($ctrl.node.type === \'STRUCTURAL\') && $ctrl.pathFilter" name="selectedPathFilter" type="radio" ng-click="$ctrl.elementChosen($ctrl.node)"> <span ng-switch="" on="$ctrl.node.type" class="ecm-tree-icon" ng-if="$ctrl.node.type == \'REFERENCE\' || $ctrl.node.type == \'QUERY\' || $ctrl.node.type == \'CONTENT\'"> <relation-status-icon relation-status="$ctrl.node.relationStatus" ng-switch-when="REFERENCE"></relation-status-icon> <i class="fa fa-search" ng-switch-when="QUERY" aria-hidden="true"></i> <i class="fa fa-file-text-o" ng-switch-when="CONTENT" aria-hidden="true"></i> </span> <a class="ecm-tree-show-summary-btn" ng-click="$ctrl.getLinkedEEInsertionSummary()" ng-if="$ctrl.showSummary && $ctrl.node.type == \'REFERENCE\' && $ctrl.node.relationStatus !== \'BROKEN\'"> <i class="fa fa-ellipsis-h ecm-summary-transition" ng-class="{\'fa-rotate-90\': $ctrl.node.showLinkedEESummary}" aria-hidden="true"></i> </a> <span class="ecm-tree-title-text" ng-style="{\'text-decoration\': dataItem.deleted ? \'line-through\' : \'none\'}" ng-click="$ctrl.setFocus()" ng-bind-html="$ctrl.trustAsHtml($ctrl.node.text)" ng-dblclick="$ctrl.nodeAction({selectedNode: $ctrl.node})"></span> <span ng-if="dataItem.type == \'CONTENT\' && dataItem.xmlContent == null" class="disabled-node">&#40;{{\'userApp.treeEEEdition.labels.emptyNodeContent\' | translate}}&#41;</span> </div>  <div ecm-collapse="!$ctrl.node.showLinkedEESummary" class="ecm-tree-collapse"> <div class="ecm-tree-zone ecm-tree-zone-summary"> <div ng-bind-html="$ctrl.node.linkedEESummary" class="resume-label"></div> </div> </div>  <div ecm-collapse="!$ctrl.showNodesMetaData" class="ecm-tree-collapse"> <div class="ecm-tree-zone ecm-tree-zone-meta" ng-if="$ctrl.isNodeMetaDatasEmpty()"> <i class="fa fa-info ecm-tree-zone-icon" aria-hidden="true"></i> <div id="node_{{$ctrl.node.id}}_editorials_metadatas" ng-show="$ctrl.node.editorialsMetaData.length > 0"> <span ng-repeat="metadata in $ctrl.node.editorialsMetaData"> <span ng-if="!metadata.multipleOccurrences && metadata.value" class="ecm-tree-meta"> <span>{{metadata.metaDataDTO.name}}: </span> <span class="ecm-tree-meta-value">{{(metadata.value | ecmDate:\'short\' ) + ( $last ? \'\' :\'/\' )}}</span> </span> <span class="ecm-tree-meta" ng-if="metadata.multipleOccurrences && metadata.metaDataMultiValuesList != null && metadata.metaDataMultiValuesList.length > 0"> <span>{{metadata.metaDataDTO.name}}: </span> <span class="ecm-tree-meta-value" ng-repeat="elm in metadata.metaDataMultiValuesList"> {{ elm.wording + ($last ? \'\' :\'/\')}} </span> </span> <span class="ecm-tree-meta" ng-if="!metadata.referentialTypeListDTOList != null && metadata.referentialTypeListDTOList.length > 0 && !metadata.multipleOccurrences"> <span ng-repeat="metadataList in metadata.referentialTypeListDTOList"> <span>{{metadata.metaDataDTO.name}}: </span> <span class="ecm-tree-meta-value">{{lang==\'fr\' ? metadataList.labelFR : metadataList.labelEN }}</span> </span> </span> <span class="ecm-tree-meta" ng-if="metadata.multipleOccurrences && !metadata.referentialTypeListDTOList != null && metadata.referentialTypeListDTOList.length > 0"> <span>{{metadata.metaDataDTO.name}}: </span> <span class="ecm-tree-meta-value" ng-repeat="metadataList in metadata.referentialTypeListDTOList"> {{lang==\'fr\' ? metadataList.labelFR + ( $last ? \'\' :\'/\' ) : metadataList.labelEN + ( $last ? \'\' :\'/\' )}} </span> </span> <span class="ecm-tree-meta" ng-if="!metadata.listDisplayPathForNode != null && metadata.listDisplayPathForNode.length > 0"> <span>{{metadata.metaDataDTO.name}}: </span> <span class="ecm-tree-meta-value" ng-repeat="metadataList in metadata.listDisplayPathForNode"> {{metadataList }} </span> </span> </span> </div> </div> </div> </span> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/tree-flat-view/tree-flat-view.html','<div class="container-fluid bg-white listing-w-preview full-height"> <div class="row ecm-table-layout bg-white"> <div class="col-md-12 listing-w-preview"> <div class="row"> <div class="col-sm-6 ecm-flatview-filters"> <form id="filerForm" class="form-horizontal">  <div class="col-sm-12" ng-show="$ctrl.isContainer()"> <div class="form-group form-group-sm"> <div class="col-sm-4 col-lg-2"> <label class="control-label" for=""> {{\'userApp.treeFlatView.labels.DesiredPulicationDateFilter\' | translate}} </label> </div> <div class="col-sm-10"> <select class="form-control" ng-model="$ctrl.publicationFilterValue" ng-change="$ctrl.doFilterDirectlyFromSelect()"> <option value="{{$ctrl.PUBLICATION_STATUS.ALL}}"> {{\'userApp.treeFlatView.filters.publication.all\' | translate}}</option> <option value="{{$ctrl.PUBLICATION_STATUS.TO_BE_PUBLISHED}}"> {{\'userApp.treeFlatView.filters.publication.ToBePublished\' | translate}}</option> <option value="{{$ctrl.PUBLICATION_STATUS.TO_BE_REPUBLISHED}}"> {{\'userApp.treeFlatView.filters.publication.TobeRepublished\' | translate}}</option> <option value="{{$ctrl.PUBLICATION_STATUS.TO_BE_UNPUBLISHED}}"> {{\'userApp.treeFlatView.filters.publication.TobeUnpublished\' | translate}}</option> <option value="{{$ctrl.PUBLICATION_STATUS.TO_BE_PUBLISHED_AND_TO_BE_REPUBLISHED_AND_TO_BE_UNPUBLISHED}}"> {{\'userApp.treeFlatView.filters.publication.PublishAndTobeRepublishedAndToUnPublished\' | translate}}</option> </select> </div> </div> </div>  <div ng-show="$ctrl.existsParametrizedFilters()" class="col-sm-12" style="min-height:40px" ng-repeat="metaInstance in $ctrl.parameterizedFilters track by $index"> <meta-data-field meta-data-instance="metaInstance" form="filerForm" lang="$ctrl.lang" product-code="$ctrl.editorialEntity.ownerGroup" max-size-media="$ctrl.maxSizeMedia" ee-source-flash-id="$ctrl.editorialEntity.identifier"> </meta-data-field> </div>  <div class="col-sm-12" ng-show="$ctrl.existsParametrizedFilters()"> <div class="form-group form-group-sm"> <div class="col-sm-2"> </div> <div class="col-sm-10"> <button type="button" class="btn btn-primary" ng-click="$ctrl.doFilter()" translate="userApp.treeFlatView.actions.filter"> </button> <button type="button" class="btn btn-default btn-reset" ng-click="$ctrl.resetFilters()" uib-tooltip="{{\'userApp.treeFlatView.actions.reset\' | translate}}"> <md-icon md-svg-src="assets/images/icons/ic_restore_page_white_24px.svg"></md-icon> </button> </div> </div> </div> </form> </div> </div> <div block-ui="resultsDiv"> <div class="row voffset2"> <div class="col-sm-12"> <div class="pull-left"> <div ng-if="$ctrl.results.totalItemCount > 0"> {{$ctrl.results.totalItemCount}}&nbsp; <span translate="userApp.treeFlatView.labels.resultsNumber"></span> </div> </div> <div class="pull-right"> <mass-operation-container current-user="$ctrl.currentUser" current-permissions="$ctrl.eEpermissions" selected-action="$ctrl.selectedAction" from-flat-view="true" selected-ee="$ctrl.selectedEe" selected-nodes-ids="$ctrl.getSelectedReferenceNodesIds()" refresh-function="$ctrl.pageChanged()"></mass-operation-container> </div> </div> </div> <div class="row voffset2"> <div style="padding: 0 10px"> <table checkbox-model="$ctrl.selectedEe[ee.identifier]" multi-select="!$ctrl.editTirInModal" id="{{$ctrl.tableId}}" ecm-ultimate-table="" st-set-filter="StrictFilter" st-set-sort="betterOrderBy" st-pipe="$ctrl.loadTable" st-table="$ctrl.results.hookedEEsList" class="table table-striped table-hover table-fixed"> <thead> <tr> <th class="icon-column" no-resize="" no-drag=""></th> <th class="icon-column-2x" no-resize="" no-drag=""></th>  <th ng-repeat="column in $ctrl.columnsList" ng-class="{\'sortable\': column.sortable}" st-sort="{{column.value}}"> {{ column.systemMeta ? (\'userApp.metadatas.labels.\' + column.title | translate) : column.title }} </th> <th ng-if="!$ctrl.isContainer()"> {{\'userApp.treeFlatView.labels.path\' | translate}} </th> <th class="sortable" ng-if="$ctrl.isContainer()" st-sort="desiredPublicationDate"> {{\'userApp.treeFlatView.labels.publicationDate\' | translate}}</th> <th class="sortable" ng-if="$ctrl.isContainer()" st-sort="effectivePublicationDate"> {{\'userApp.treeFlatView.labels.effectiveDate\' | translate}}</th> <th class="col-dispo sortable" st-sort="availability"> {{\'userApp.treeFlatView.labels.availability\' | translate}} </th> </tr> </thead> <tbody> <tr role="button" ng-click="$ctrl.getEEHtmlPreview(ee)" ng-dblclick="$ctrl.navigateToEE(ee)" ng-class="{\'st-selected\': $ctrl.isEESelected(ee), \'disabled-node\' : !ee.activated}" ng-repeat="ee in $ctrl.results.hookedEEsList" class="sidebar-open"> <td> <a ng-if="ee.relationStatus != \'BROKEN\'" ui-sref="editorialEntity({ id: ee.identifier})" ng-click="$event.stopPropagation();" uib-tooltip="{{\'userApp.treeFlatView.labels.eeFullRecord\' | translate}}"> <i class="fa fa-lg fa-external-link" aria-hidden="true"></i> </a> </td> <td class="icon-column-2x"> <relation-status-icon disabled="!ee.activated" relation-status="ee.relationStatus"></relation-status-icon> </td> <td class="text-ellipsis" ng-repeat="column in $ctrl.columnsList"> <span ng-if="!column.htmlType"> <i ng-if="$ctrl.isMetadataEnabled && $ctrl.isMetaRelation(column,ee)" ng-click="$ctrl.relationMetaQuickEdit(ee,$event)" class="fa fa-pencil-square-o"></i> {{ ee.columnsValues[column.value] | ecmDate:$ctrl.dateFormatForColumn(column)| ecmBoolean }} </span> <span ng-if="column.htmlType && column.value ===\'systemTitle\'" ng-bind-html="$ctrl.trustAsHtml(ee.columnsValues[column.value] | validName)"></span> <span ng-if="column.htmlType && column.value !==\'systemTitle\'" ng-bind-html="$ctrl.trustAsHtml(ee.columnsValues[column.value])"></span> <md-tooltip ng-if="!column.htmlType" md-delay="100"> <div class="infos-doc"> <span>{{ ee.columnsValues[column.value] | ecmDate | ecmBoolean }}</span> </div> </md-tooltip> </td> <td ng-if="!$ctrl.isContainer()" class="text-ellipsis"> <span ng-repeat="title in ee.path"> <span ng-bind-html="$ctrl.formatSystemTitle(title)"></span>{{ $last ? \'\' :\'/\' }} </span> <md-tooltip class="md-tooltip-multiline" md-delay="100" md-direction="bottom"> <span ng-repeat="title in ee.path"> <span ng-bind-html="$ctrl.formatSystemTitle(title)"></span>{{ $last ? \'\' :\'/\' }} </span> </md-tooltip> </td> <td ng-if="$ctrl.isContainer()" class="text-ellipsis"> <i ng-if="ee.relation.desiredPublicationDate" ng-click="$ctrl.editDesiredPublicationDate(ee.relation)" class="fa fa-pencil-square-o"></i> &nbsp;{{ ee.relation.desiredPublicationDate | ecmDate }} </td> <td ng-if="$ctrl.isContainer()" class="text-ellipsis"> {{ ee.relation.effectivePublicationDate | ecmDate }} &nbsp; </td> <td class="text-ellipsis"> <padlock-icon ng-if="ee.relationStatus != \'BROKEN\'" color="ee.padlock.color" closed="ee.padlock.closed" owner="ee.padlock.owner.fullName" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> </tfoot> </table> <div class="text-center" ng-if="$ctrl.results.hookedEEsList.length == 0"> <span>{{\'userApp.treeFlatView.labels.emptyResults\' | translate}}</span> </div> <div ng-show="$ctrl.results.hookedEEsList.length > 0" class="text-left"> <ecm-pagination storage-key="{{$ctrl.paginationPreferenceStorageKey}}" total-items="$ctrl.results.totalItemCount" pagination-model="$ctrl.pagination" on-change="$ctrl.pageChanged()"></ecm-pagination> </div> </div>  </div> </div> </div> <ecm-sidebar content-class="sibebar-preview-content" allow-close="true" ng-if="$ctrl.selectedEE.relationStatus != \'BROKEN\'" is-open="$ctrl.selectedEE && $ctrl.selectedEE.relationStatus != \'BROKEN\'" on-close="$ctrl.sidebarClosed()"> <span class="close-preview" ng-click="$ctrl.selectedEE = null"> <i class="icon ion-close-round"></i> </span> <editorial-entity-action-bar content-class="action-bar-content" flash-id="$ctrl.selectedEE.identifier" on-refresh-preview="$ctrl.updatePreview($ctrl.selectedEE.identifier,\'COMPLETE\')" on-edit-meta-data="$ctrl.openEditMetaModal($ctrl.selectedEE)" on-edit-content="$ctrl.openEditor($ctrl.selectedEE.identifier)" preview-html="$ctrl.selectedEE.htmlPreview"> <div style="padding: 10px"> <display-editorial-metadata flash-id="$ctrl.selectedEE.relation.flashId" is-relation="true" ecm-style="{\'slim\':true}" is-source-entity-container="$ctrl.isContainer()" edit-metadata-enabled="$ctrl.isMetadataEnabled"></display-editorial-metadata> </div>  <div> <ecm-preview-html ng-if="$ctrl.selectedEE != null && $ctrl.selectedEE.htmlPreview != null" content="$ctrl.trustAsHtml($ctrl.selectedEE.htmlPreview)"></ecm-preview-html> </div> </editorial-entity-action-bar> </ecm-sidebar> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view-actions/tree-view-actions.component.html','<div class="ecm-tree-action-bar"> <button class="ecm-te-btn" ng-disabled="$ctrl.isEmpty" ng-click="$ctrl.expandAll()" uib-tooltip="{{\'userApp.editorialEntity.menu.expandAll\' | translate}}"> <i class="fa fa-expand"></i> </button> <button class="ecm-te-btn" ng-disabled="$ctrl.isEmpty" ng-click="$ctrl.collapseAll()" uib-tooltip="{{\'userApp.editorialEntity.menu.collapseAll\' | translate}}"> <i class="fa fa-compress"></i> </button> <button class="ecm-te-btn" ng-disabled="$ctrl.isEmpty" ng-class="{\'ecm-te-active\': $ctrl.showMetaData}" ng-click="$ctrl.toggleMetaData()" uib-tooltip="{{\'userApp.editorialEntity.menu.showAllNodesMetaData\' | translate}}"> <i class="fa fa-tags"></i> </button> <button class="ecm-te-btn" ng-if="!$ctrl.isHooksExternalEntities" ng-disabled="$ctrl.isEmpty" ng-class="{\'ecm-te-active\': $ctrl.showOverloadedView}" ng-click="$ctrl.switchOverloadedPreview()" uib-tooltip="{{(!$ctrl.showOverloadedView ? \'userApp.editorialEntity.menu.showOverloadedView\' : \'userApp.editorialEntity.menu.disableOverloadedView\') | translate}}"> <i class="fa fa-file"></i> </button> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/tree-view-wrapper/tree-view-wrapper.tpl.html','<tree-view ng-if="$ctrl.mode === \'NORMAL\'" editorial-entity="$ctrl.editorialEntity" readonly="true" on-node-selection="$ctrl.nodeSelection(nodeSelected)" tree-view-instance="$ctrl.treeViewInstance" is-show-nodes-meta-data="$ctrl.isShowNodesMetaData" edit-metadata-enabled="$ctrl.editMetadataEnabled" edit-content-enabled="$ctrl.editContentEnabled" show-preview-menu="true" current-user="$ctrl.currentUser" editorial-entity-state="true" show-overloaded-view="$ctrl.showOverloadedView"></tree-view> <ecm-treeview ng-if="$ctrl.mode === \'V2\'" flash-id="$ctrl.editorialEntity.identifier" node-selection="$ctrl.nodeSelection(nodeSelected)" editorial-entity="$ctrl.editorialEntity" current-user="$ctrl.currentUser" show-metadata="$ctrl.isShowNodesMetaData"></ecm-treeview> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/treeEEEdition/treeEEEdition.tpl.html','<div class="tree-editor-header ecm-te-container ecm-te-toolbar ecm-te-stack-layout-item ecm-te-first"> <div class="ms-topbar"> <div class="doc-title inline-title"> <span ng-if="treeEEEditionCtrl.editorialEntity.titleSystem" ng-bind-html="treeEEEditionCtrl.titleSystemasHTML"></span> <span class="ecm-no-title" ng-if="!treeEEEditionCtrl.editorialEntity.titleSystem" translate="userApp.editorialEntity.home.noTitle"></span> <span>({{treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.wording}})</span> <span ng-if="treeEEEditionCtrl.editionMode == \'FULL\'" class="edit-type">{{\'userApp.treeEEEdition.labels.fullEdition\' | translate}}</span> <span ng-if="treeEEEditionCtrl.editionMode == \'STRUCTURE\'" class="edit-type">{{\'userApp.treeEEEdition.labels.structureEdition\' | translate}}</span> </div> </div> <div class="ms-menubar"> <ul class="menu-tabs"> <li class="onglet active"> <a>{{\'userApp.treeEEEdition.labels.manageStructure\' | translate}}</a> </li> </ul> <ul class="menu-tabs is-right"> <li class="primary-btn"> <a ng-click="treeEEEditionCtrl.close()">{{\'userApp.treeEEEdition.labels.quit\' | translate}}</a> </li> </ul> </div> <div class="ecm-te-toolbar-grp ecm-te-container ecm-te-panel ecm-te-stack-layout-item ecm-te-first ms-toolbar"> <div class="ecm-te-container-body ecm-te-stack-layout"> <div class="ecm-te-container ecm-te-flow-layout-item ecm-te-first ecm-te-btn-group ms-big-btn"> <div>  <div class="ecm-te-widget ecm-te-btn ecm-te-first" tooltip="D\xE9plier l\'arbre entier" tooltip-placement="bottom"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.expandAll()"> <i class="ecm-te-ico ecm-te-i-fa fa-expand"></i> <span translate="userApp.treeEEEdition.toolbar.expand"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" tooltip="Replier l\'arbre entier" tooltip-placement="bottom"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.collapseAll()"> <i class="ecm-te-ico ecm-te-i-fa fa-compress"></i> <span translate="userApp.treeEEEdition.toolbar.contract"></span> </button> </div> </div> <span class="desc" translate="userApp.treeEEEdition.toolbar.manage"></span> </div> <div class="ecm-te-container ecm-te-flow-layout-item ecm-te-btn-group ms-big-btn"> <div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-active\': treeEEEditionCtrl.showNodesMetaData}"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.showNodesMetaData = !treeEEEditionCtrl.showNodesMetaData"> <i class="ecm-te-ico ecm-te-i-fa fa-tags"></i> <span translate="userApp.treeEEEdition.toolbar.displayMeta"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-active\': treeEEEditionCtrl.showOverloadedView, \'ecm-te-disabled\' : treeEEEditionCtrl.isHooksExternalEntities}"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.switchOverloadedView()" ng-disabled="treeEEEditionCtrl.isHooksExternalEntities"> <i class="ecm-te-ico ecm-te-i-fa fa-file"></i> <span translate="userApp.treeEEEdition.toolbar.overloadedView"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-active\': treeEEEditionCtrl.showDeletedNodes}"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.toggleDeletedNodes()"> <i class="ecm-te-ico ecm-te-i-fa fa-trash"></i> <span translate="userApp.treeEEEdition.toolbar.deleted"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-active\': treeEEEditionCtrl.hideEmptyStructuralNodes}"> <button role="presentation" type="button" tabindex="-1" ng-click="treeEEEditionCtrl.toggleEmptyStructuralNodes()"> <i class="ecm-te-ico ecm-te-i-fa fa-sitemap"></i> <span translate="userApp.treeEEEdition.toolbar.emptyStructuralNodes"></span> </button> </div>  </div> <span class="desc" translate="userApp.treeEEEdition.toolbar.infos"></span> </div> <div class="ecm-te-container ecm-te-flow-layout-item ecm-te-btn-group ms-big-btn"> <div> <div class="ecm-te-widget ecm-te-btn"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'addReferenceNode\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-chain"></i> <span translate="userApp.treeEEEdition.toolbar.linkNode"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'addStructuralNode\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-sitemap"></i> <span translate="userApp.treeEEEdition.toolbar.structureNode"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-hide="true"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'addQueryNode\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-search"></i> <span translate="userApp.treeEEEdition.toolbar.queryNode"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-disabled\':!treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.usedFlashEditor || treeEEEditionCtrl.isHooksExternalEntities}"> <button role="presentation" type="button" ng-disabled="!treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.usedFlashEditor || treeEEEditionCtrl.isHooksExternalEntities" ng-click="treeEEEditionCtrl.doAction(\'addContentNode\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-file-text"></i> <span translate="userApp.treeEEEdition.toolbar.contentNode"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-disabled\':!treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.automaticMounting}"> <button role="presentation" type="button" ng-disabled="!treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.automaticMounting" ng-click="treeEEEditionCtrl.doAction(\'automaticMounting\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa fa-cogs"></i> <span translate="userApp.treeEEEdition.toolbar.automaticMounting"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-disabled\': treeEEEditionCtrl.isHooksExternalEntities}"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'autoSpread\')" tabindex="-1" ng-disabled="treeEEEditionCtrl.isHooksExternalEntities"> <i class="ecm-te-ico ecm-te-i-fa fa fa-share-alt"></i> <span translate="userApp.treeEEEdition.toolbar.autoSpread"></span> </button> </div> <div ng-class="{\'ecm-te-disabled\': !treeEEEditionCtrl.isPermitted(\'order\')}" class="ecm-te-widget ecm-te-btn"> <button ng-disabled="!treeEEEditionCtrl.isPermitted(\'order\')" role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'order\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fas fa-sort-amount-asc"></i> <span translate="userApp.treeEEEdition.toolbar.order"></span> </button> </div> </div> <span class="desc" translate="userApp.treeEEEdition.toolbar.insert"></span> </div> <div class="ecm-te-container ecm-te-flow-layout-item ecm-te-btn-group ms-big-btn"> <div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-disabled\': treeEEEditionCtrl.hasNoPermission(\'VALIDATE_EE\')}"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.doAction(\'validateEE\')" ng-disabled="treeEEEditionCtrl.hasNoPermission(\'VALIDATE_EE\')" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-check-circle"></i> <span translate="userApp.treeEEEdition.toolbar.valid"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.refresh()" tabindex="-1"> <i class="ecm-te-ico ecm-te-i-fa fa-refresh"></i> <span translate="userApp.treeEEEdition.toolbar.refresh"></span> </button> </div> <div class="ecm-te-widget ecm-te-btn" ng-class="{\'ecm-te-disabled\': treeEEEditionCtrl.isHooksExternalEntities}"> <button role="presentation" type="button" ng-click="treeEEEditionCtrl.openPreview()" tabindex="-1" ng-disabled="treeEEEditionCtrl.isHooksExternalEntities"> <i class="ecm-te-ico ecm-te-i-fa fa-file-powerpoint-o"></i> <span translate="userApp.treeEEEdition.toolbar.preview"></span> </button> </div> </div> <span class="desc" translate="userApp.treeEEEdition.toolbar.otherActions"></span> </div> </div> </div> </div> <div class="tree-editor-content"> <div class="flex-cont bg-white listing-w-preview"> <div id="editTreeDiv" class="c-resize c-preview ng-scope"> <tree-view editorial-entity="treeEEEditionCtrl.editorialEntity" readonly="false" showpreviewmenu="true" on-node-selection="treeEEEditionCtrl.onNodeSelection(nodeSelected)" tree-view-instance="treeEEEditionCtrl.treeViewInstance" is-show-nodes-meta-data="treeEEEditionCtrl.isShowNodesMetaData()" handle-external-action-event="true" node-action-name="treeEEEditionCtrl.nodeActionName" handle-external-action-accessor="treeEEEditionCtrl.externalActionAccessor" current-user="treeEEEditionCtrl.currentUser"> </tree-view> </div> <div ng-mousedown="treeEEEditionCtrl.mdDragBar($event)" ng-show="treeEEEditionCtrl.resize" class="resize-bar"> </div> <div id="idDivContenu" ng-show="treeEEEditionCtrl.resize" class="c-resize c-preview resizable no-padding flex-container-column" style="flex-basis: 50%;"> <span ng-click="treeEEEditionCtrl.closePreview()" class="close-preview"> <i class="icon ion-close-round"></i> </span> <div ng-if="treeEEEditionCtrl.editorialEntity.editorialEntityTemplate.contentType ==\'TREE\'" class="full-height"> <div ng-if="(treeEEEditionCtrl.nodeSelected.type ==\'STRUCTURAL\' || treeEEEditionCtrl.nodeSelected.type ==\'QUERY\') && !treeEEEditionCtrl.nodeSelected.deleted"> <display-editorial-metadata flash-id="treeEEEditionCtrl.nodeSelected.id" editorial-type="treeEEEditionCtrl.nodeSelected.type" edit-metadata-enabled="true" is-editor="true"></display-editorial-metadata> </div>  <div ng-if="treeEEEditionCtrl.nodeSelected.type !=\'STRUCTURAL\' && treeEEEditionCtrl.nodeSelected.type !=\'QUERY\'" class="full-height"> <div ng-if="treeEEEditionCtrl.nodeSelected.htmlPreview == \'NO_DISPLAY\'"> {{\'userApp.editorialEntity.menu.noDisplayMessage\' | translate}} </div>  <div ng-if="!treeEEEditionCtrl.nodeSelected.external && treeEEEditionCtrl.nodeSelected.htmlPreview != \'NO_DISPLAY\' && treeEEEditionCtrl.nodeSelected.type !== \'CONTENT\'" class="full-height"> <editorial-entity-action-bar ng-if="treeEEEditionCtrl.nodeSelected.relationStatus !== \'BROKEN\'" class="full-action-bar" content-class="action-bar-content" flash-id="treeEEEditionCtrl.nodeSelected.refNodeId" on-edit-meta-data="treeEEEditionCtrl.openEditMetaModal(treeEEEditionCtrl.nodeSelected)" on-refresh-preview="treeEEEditionCtrl.updatePreview()" on-edit-content="treeEEEditionCtrl.openEditor(treeEEEditionCtrl.nodeSelected.refNodeId)" preview-html="treeEEEditionCtrl.nodeSelected.htmlPreview"> <div ng-show="!treeEEEditionCtrl.nodeSelected.deleted" style="padding: 10px"> <display-editorial-metadata flash-id="treeEEEditionCtrl.nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="true" is-editor="true"></display-editorial-metadata> </div> <ecm-preview-html content="treeEEEditionCtrl.trustAsHtml(treeEEEditionCtrl.nodeSelected.htmlPreview)"> </ecm-preview-html> </editorial-entity-action-bar>  <div ng-show="treeEEEditionCtrl.nodeSelected.relationStatus === \'BROKEN\'" style="padding: 10px; margin-top: 30px"> <display-editorial-metadata ng-if="!treeEEEditionCtrl.nodeSelected.deleted" flash-id="treeEEEditionCtrl.nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="true" is-editor="true"></display-editorial-metadata> <ecm-preview-html content="treeEEEditionCtrl.trustAsHtml(treeEEEditionCtrl.nodeSelected.htmlPreview)"> </ecm-preview-html> </div> </div>  <div ng-if="treeEEEditionCtrl.nodeSelected.htmlPreview != \'NO_DISPLAY\' && treeEEEditionCtrl.nodeSelected.type === \'CONTENT\'" class="full-height ecm-preview-content"> <ecm-preview-html content="treeEEEditionCtrl.trustAsHtml(treeEEEditionCtrl.nodeSelected.htmlPreview)"> </ecm-preview-html> </div>  <div ng-if="treeEEEditionCtrl.nodeSelected.external" class="full-height ecm-preview-content"> <div ng-show="!treeEEEditionCtrl.nodeSelected.deleted" style="padding: 10px"> <display-editorial-metadata class="ecm-meta-container meta-group" flash-id="treeEEEditionCtrl.nodeSelected.relationId" is-relation="true" ecm-style="{\'slim\':true}" edit-metadata-enabled="true" is-editor="true"> </display-editorial-metadata> </div> <ecm-preview-html content="treeEEEditionCtrl.trustAsHtml(treeEEEditionCtrl.nodeSelected.htmlPreview)"> </ecm-preview-html> </div> </div> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/metadata-instance/components/meta-data-media/meta-data-media.html',' <div class="form-group form-group-sm required" ng-class="{ \'has-error\': form[\'mediaMetaData{{$ctrl.metaDataInstance.displayOrder}}\'].$dirty && form[\'mediaMetaData{{$ctrl.metaDataInstance.displayOrder}}\'].$invalid }">  <div class="col-sm-4" ng-class="{\'col-lg-2\': !$ctrl.display}"> <label class="control-label" style="float: left;"> <span style="white-space: pre;">{{$ctrl.metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!$ctrl.display && $ctrl.metaDataInstance.metaDataDTO.authorized && $ctrl.metaDataInstance.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-8 col-lg-10" ng-if="!$ctrl.display"> <a href="" ngf-multiple="$ctrl.metaDataInstance.multipleOccurrences" ng-model="$ctrl.validFiles" ngf-model-invalid="$ctrl.invalidFiles" ng-disabled="{{!$ctrl.metaDataInstance.metaDataDTO.authorized}}" aria-label="mediaMetaDataBtnSingle{{$ctrl.metaDataInstance.displayOrder}}" ngf-pattern="{{$ctrl.mediaFieldPattern}}" ngf-accept="{{$ctrl.mediaFieldPattern}}" ngf-select="$ctrl.uploadMultiFiles($files)" ngf-model-options="{allowInvalid: true}" ngf-max-size="{{$ctrl.maxSize}}MB"> <span ng-if="!$ctrl.metaDataInstance.multipleOccurrences" translate="userApp.editorialEntity.home.selectFile"></span> <span ng-if="$ctrl.metaDataInstance.multipleOccurrences" translate="userApp.editorialEntity.home.selectMultiFiles"></span> </a>( {{$ctrl.displayMediaExtension($ctrl.metaDataInstance.metaDataDTO.extensionAllowed)}} ) </div> <div ng-if="!$ctrl.display" class="col-sm-8 col-sm-offset-4 col-lg-10 col-lg-offset-2"> <div class="dragula-container" dragula=\'"media-meta-bag"\' dragula-model="$ctrl.metaDataInstance.listMediaFiles"> <div class="input-group input-group-sm" style="margin-bottom: 10px" ng-repeat="file in $ctrl.metaDataInstance.listMediaFiles"> <div class="input-group-addon"> <span class="glyphicon glyphicon-move"></span> </div> <div class="input-group-addon next-addon"> <a ng-if="!file.idMedia" href="{{file | ngfDataUrl}}" target="_blank">{{file.name}}</a> <a ng-if="file.idMedia" href="api/media/displayMedia/{{file.idMedia}}" target="_blank">{{file.name}}</a> </div> <input ng-model="file.customFileName" class="form-control" ng-model-options="{ debounce: 500 }" ng-change="$ctrl.mappedDisplayList(file)" placeholder="{{ \'libelle\' | translate}}" ng-if="file"> <span class="input-group-btn" ng-if="!readonly && file"> <button class="btn btn-default" ng-click="$ctrl.removeMedia(file.idMedia,file.$$hashKey)" type="button"> <i class="glyphicon glyphicon-remove"></i> </button> </span> </div> </div> </div> <div ng-if="!$ctrl.display" class="col-sm-8 col-sm-offset-4 col-lg-10 col-lg-offset-2"> <div style="display: flex;padding: 5px 5px 5px 0;" ng-repeat="f in $ctrl.errorFiles"> <div class="text-danger" style="flex:1;padding-right: 5px">{{f.name}}</div> <div class="text-danger" style="flex:1" ng-if="f.$error == \'maxSize\'"> <span class="text-danger">Taille = {{(f.size/(1024*1024)).toFixed(2) }} MB. Le m&eacute;dia ne doit pas d&eacute;passer : {{f.$errorParam}}</span> </div> <div class="text-danger" style="flex:1" ng-if="f.$error == \'pattern\'"> <span class="text-danger">Les extensions accept&eacute;es sont : {{f.$errorParam}} </span> </div> </div> </div> <div ng-if="$ctrl.display" class="col-sm-8"> <div class="control-label" ng-repeat="file in $ctrl.metaDataInstance.listMediaFiles"> <a href="" ng-click="$ctrl.displayMedia(file.idMedia)">{{file.customFileName?file.customFileName:file.name}}</a> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/metadata-instance/components/meta-data-referential/meta-data-referential.html','<div class="form-group form-group-sm">  <div class="col-sm-4" ng-class="{\'col-lg-2\': !$ctrl.display}"> <label class="control-label"> <span>{{$ctrl.metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!$ctrl.display && $ctrl.metaDataInstance.metaDataDTO.authorized && $ctrl.metaDataInstance.mandatory" class="text-danger"> *</span> <span ng-show="!$ctrl.display && $ctrl.metaDataInstance.metaDataDTO.authorized && $ctrl.metaDataInstance.discriminant" class="text-danger" title="{{\'userApp.editorialEntity.home.discriminantMetadata\' | translate}}"> (D)</span> </label> </div>  <div class="col-sm-8 col-lg-10" ng-if="!$ctrl.readonly && $ctrl.isSelectMulti()"> <ui-select multiple="" class="sidebar-open" ng-model="$ctrl.metaDataInstance.referentialTypeListDTOList" ng-required="$ctrl.metaDataInstance.mandatory && $ctrl.metaDataInstance.metaDataDTO.authorized" ng-init="$ctrl.initLinkedCall()" ng-change="$ctrl.updatelinkedRefs()" ng-disabled="display || !$ctrl.metaDataInstance.metaDataDTO.authorized" uis-open-close="$ctrl.initializeSelect($select, isOpen)"> <ui-select-match> {{$item.labelFR}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption in $ctrl.referentialValueList" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <span ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> <span ng-show="$ctrl.metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"></span> </div>  <div class="col-sm-8 col-lg-10" ng-if="!$ctrl.readonly && $ctrl.isSelectOne()"> <ui-select class="sidebar-open" ng-required="$ctrl.metaDataInstance.mandatory && $ctrl.metaDataInstance.metaDataDTO.authorized" ng-model="$ctrl.metaDataInstance.referentialTypeListDTOList[0]" ng-init="$ctrl.initLinkedCall();" ng-change="$ctrl.updatelinkedRefs();" theme="bootstrap" ng-disabled="display || !$ctrl.metaDataInstance.metaDataDTO.authorized" reset-search-input="true" uis-open-close="$ctrl.initializeSelect($select, isOpen);"> <ui-select-match allow-clear="true"> {{$select.selected.labelEN}}</ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption in $ctrl.referentialValueList" null-option="" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <div ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></div> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> <span ng-show="$ctrl.metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"></span> </div>  <div class="col-sm-8" ng-if="$ctrl.readonly && $ctrl.isList()"> <div class="control-label"> <div ng-repeat="model in $ctrl.metaDataInstance.referentialTypeListDTOList track by $index"> {{$ctrl.getLabel(model)}} </div> </div> </div>  <div class="col-sm-8 col-lg-10" ng-if="!$ctrl.readonly && $ctrl.isTree()"> <div ng-click="$ctrl.openTreeModal()" class="ecm-referential-meta-display-selectable" uib-tooltip="{{ \'global.selectValue(s)\'|translate}}"> <div ng-repeat="model in $ctrl.metaDataInstance.listDisplayPathForNode track by $index"> {{model.path}} </div> </div> <span ng-show="$ctrl.metaDataInstance.errorExistMetaDiscriminants" class="text-danger" translate="userApp.editorialEntity.msg.errorExistMetaDiscriminants"></span> </div>  <div class="col-sm-8" ng-if="$ctrl.readonly && $ctrl.isTree()"> <div ng-repeat="model in $ctrl.metaDataInstance.listDisplayPathForNode track by $index"> {{model.path}} </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/metadata-instance/components/meta-data-url/meta-data-url.html',' <div class="form-group form-group-sm required"> <div class="col-sm-4" ng-class="{\'col-lg-2\': !$ctrl.display}"> <label class="control-label"> <span>{{$ctrl.metaDataInstance.metaDataDTO.name}}</span> <span ng-show="!display && $ctrl.metaDataInstance.metaDataDTO.authorized && $ctrl.metaDataInstance.mandatory && !$ctrl.readonly" class="text-danger"> *</span> </label> </div> <div class="col-sm-8 col-lg-10" ng-if="!$ctrl.readonly"> <div class="dragula-container" dragula=\'"url-meta-bag"\' dragula-model="$ctrl.metaDataInstance.urlDTOList"> <div class="row" ng-repeat="url in $ctrl.metaDataInstance.urlDTOList"> <div class="col-sm-4"> <div class="input-group input-group-sm"> <div class="input-group-addon"> <span class="glyphicon glyphicon-move"></span> </div> <input ng-disabled="{{display || !$ctrl.metaDataInstance.metaDataDTO.authorized}}" class="form-control" type="text" placeholder="{{ \'userApp.metadatas.labels.urlLabel\' | translate}}" ng-model="url.label" name="urlMetaData{{$ctrl.metaDataInstance.displayOrder}}"> </div> </div> <div class="col-sm-5" ng-class="{ \'has-error\': !url.value && $ctrl.metaDataInstance.mandatory && $ctrl.metaDataInstance.metaDataDTO.authorized}"> <input ng-disabled="{{display || !$ctrl.metaDataInstance.metaDataDTO.authorized}}" class="form-control" type="text" placeholder="{{ \'userApp.metadatas.labels.url\' | translate}}" ng-model="url.value" name="urlMetadata{{$index}}" ng-required="$ctrl.metaDataInstance.mandatory && $ctrl.metaDataInstance.metaDataDTO.authorized"> </div> <div class="col-sm-3"> <span class="btn" ng-class="{\'btn-success\': url.checkConnection === true, \'btn-warning\': url.checkConnection === false, \'btn-primary\': url.checkConnection == null || !url.value}" ng-click="$ctrl.checkConnection(url)" ng-disabled="!url.value"> <i class="icon ion-network fa-lg" aria-hidden="true"></i> </span> <span class="btn btn-primary" ng-click="$ctrl.openURL(url)" ng-disabled="!url.value"> <i class="icon ion-android-open fa-lg" aria-hidden="true"></i> </span> <span class="btn btn-primary" ng-click="$ctrl.removeURL(url)" ng-disabled="$ctrl.disableRemoveButton()"> <i class="icon ion-ios-trash fa-lg" aria-hidden="true"></i> </span> </div> <br> <br> </div> </div> <div class="row" ng-if="$ctrl.metaDataInstance.multipleOccurrences"> <div class="col-sm-12"> <button type="button" class="btn btn-success" ng-click="$ctrl.addNewURL()"> <i class="fa fa-plus fa-lg" aria-hidden="true"></i> </button> </div> </div> </div> <div class="col-sm-8" ng-if="$ctrl.readonly"> <div class="control-label" ng-repeat="url in $ctrl.metaDataInstance.urlDTOList"> <a target="_blank" href="{{url.value}}" uib-tooltip="{{url.value}}">{{url.label ? url.label : url.value}}</a> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/monitoring/app-health/instance-health/instance-health.html','<div class="panel panel-default"> <div class="panel-heading clearfix"> <h5 class="panel-title"> <ul> <li> <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#{{$ctrl.instance.name}}-{{$ctrl.instance.instanceIdentifier}}"> <p> <span block-ui="$ctrl.instance.name"> <span ng-if="$ctrl.instance.status == \'DOWN\'"> <i class="fa fa-heartbeat" style="font-size:12px;color:red"></i> </span> <span ng-if="$ctrl.instance.status == \'UP\'"> <i class="fa fa-heartbeat" style="font-size:12px;color:#32CD32"></i> </span> </span> Instance&nbsp;&nbsp;({{$ctrl.instance.instanceName}},&nbsp;version:&nbsp;{{$ctrl.instance.version}}) </p> </button> </li> <li ng-if="$ctrl.instance"> <i>{{\'userApp.monitoring.labels.functionalStatus\' | translate }}&nbsp;:&nbsp;{{\'userApp.monitoring.labels.status.\' + $ctrl.instance.validFunctionalStatus | translate}}</i> </li> <li ng-if="$ctrl.instance.details.length > 0"> <p ng-repeat="detail in $ctrl.instance.details"> <span>{{detail.key + \' : \' + detail.value}}</span> </p> </li> </ul> </h5> </div> <div id="{{$ctrl.instance.name}}-{{$ctrl.instance.instanceIdentifier}}" class="panel-body collapse"> <table class="table table-striped table-bordered table-fixed"> <thead> <th translate="userApp.monitoring.labels.components"></th> <th translate="userApp.monitoring.labels.availability"> </th> <th translate="userApp.monitoring.labels.functionalStatus"> </th> <th translate="userApp.monitoring.labels.details"> </th> </thead> <tbody> <tr ng-if="$ctrl.instance.components.length > 0" ng-repeat="component in $ctrl.instance.components | orderBy: \'name\'"> <td>{{component.name}}</td> <td> <span ng-if="component.status == \'DOWN\'"> <i class="fa fa-circle" style="font-size:24px;color:red"></i> </span> <span ng-if="component.status == \'UP\'"> <i class="fa fa-circle" style="font-size:24px;color:#32CD32"></i> </span> </td> <td> <span ng-if="!component.validFunctionalStatus"> <i class="fa fa-circle" style="font-size:24px;color:red"></i> </span> <span ng-if="component.validFunctionalStatus"> <i class="fa fa-circle" style="font-size:24px;color:#32CD32"></i> </span> </td> <td> <p ng-repeat="detail in component.details"> <span>{{detail.key + \' : \' + detail.value}}</span> </p> </td> </tr> <tr ng-if="$ctrl.instance.components.length == 0"> <td>{{$ctrl.instance.name}}</td> <td> <span ng-if="$ctrl.instance.status == \'DOWN\'"> <i class="fa fa-circle" style="font-size:24px;color:red"></i> </span> <span ng-if="$ctrl.instance.status == \'UP\'"> <i class="fa fa-circle" style="font-size:24px;color:#32CD32"></i> </span> </td> <td> <span ng-if="$ctrl.instance.status == \'DOWN\'"> <i class="fa fa-circle" style="font-size:24px;color:red"></i> </span> <span ng-if="$ctrl.instance.status == \'UP\'"> <i class="fa fa-circle" style="font-size:24px;color:#32CD32"></i> </span> </td> <td> <p ng-repeat="detail in $ctrl.instance.details"> <span>{{detail.key + \' : \' + detail.value}}</span> </p> </td> </tr> </tbody> </table> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-container/search-container-list/search-container-list.component.html','<div class="tir-result"> <div class="tir-list" ng-hide="!$ctrl.resultat || $ctrl.resultat.length == 0"> <table ecm-ultimate-table="" on-select-row-change="$ctrl.onSelectRowChange({row: data})" resize-mode="overflow" checkbox-model="$ctrl.selectedEe[data[\'FLASH_ID\']]" multi-select="!$ctrl.editTirInModal || $ctrl.multiSelect" on-select-all-change="$ctrl.onSelectAllChange()" id="{{$ctrl.tableTirId}}" st-table="$ctrl.resultat" st-pipe="$ctrl.loadResultList" class="table table-striped table-hover table-fixed"> <thead> <tr> <th ng-if="!$ctrl.editTirInModal" class="tir-icon-column" no-drag="" no-resize=""> </th> <th ng-repeat="column in $ctrl.searchSolr.listColumn" st-sort="{{(column.sortable) ? column.value: null}}" ng-if="column.title != \'idEE\' && column.title != \'abstract\'" data-visible="{{column.visible}}" data-default-sort="{{column.defaultSort}} {{column.defaultSortDirection}}" ng-class="{\'col-sm-5\': $index==0 && $ctrl.searchSolr.listColumn.length > 2, \'col-sm-1\': $index==$ctrl.searchSolr.listColumn.length-1, \'sortable\':column.sortable}"> <span>{{column.title | translate}}</span> </th> </tr> </thead> <tbody> <tr ng-repeat="data in $ctrl.resultat" ng-class="{\'st-selected\':data[\'FLASH_ID\'] === $ctrl.eeSelected}" class="sidebar-open" ng-dblclick="$ctrl.navigateToEe({id:data[\'FLASH_ID\']})" ng-click="$ctrl.chooseEE(data)"> <td ng-if="!$ctrl.editTirInModal" class="text-ellipsis tir-icon-column"> <a href="" style="cursor: pointer" uib-tooltip="{{\'userApp.searchInterfaceTemplate.home.goToEE\'|translate}}" ui-sref="editorialEntity({ id: data[\'FLASH_ID\']})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> </td> <td ng-repeat="column in $ctrl.searchSolr.listColumn" class="text-ellipsis" ng-class="{\'ecm-tir-name-column\': column.value === \'NAME\'}"> <ng-switch on="column.value"> <div ng-switch-when="HTML_MULTI_SYSTEMTITLE" tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml(data[$ctrl.SystemTileMetaName] | validName)"> <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"> <span ng-show="data[\'DUPLICATED_EE_FLASH_ID\']" class="glyphicon glyphicon-duplicate"></span> <a ng-if="data[\'HTML_MULTI_SYSTEMABSTRACT\'] && $ctrl.searchSolr.displayResultAbstract" class="ecm-tree-show-summary-btn" ng-click="data.showDetails = !data.showDetails;$event.stopPropagation()" ng-init="data.showDetails = $ctrl.searchSolr.openResultAbstract"> <i class="fa fa-ellipsis-h ecm-summary-transition" ng-class="{\'fa-rotate-90\': data.showDetails}" aria-hidden="true"></i> </a> <span class="mark-title" ng-bind-html="$ctrl.trustAsHtml(data[$ctrl.SystemTileMetaName] | validName)"></span> </div> <div ecm-collapse="!data.showDetails" ng-if="data[\'HTML_MULTI_SYSTEMABSTRACT\'] && $ctrl.searchSolr.displayResultAbstract"> <p class="resume-label mark-summary" ng-bind-html="$ctrl.trustAsHtml(data[\'HTML_MULTI_SYSTEMABSTRACT\'])"></p> </div> </div> <div ng-switch-when="LOCK_STATE"> <data ng-init="padlock=data[\'LOCK_STATE\']"> <data ng-init="color=(padlock|split:\'#\':0)"> <data ng-init="closed=((padlock|split:\'#\':1)==\'true\')"> <data ng-init="owner=(padlock|split:\'#\':2)"> <padlock-icon color="color" closed="closed" owner="owner" size="small"></padlock-icon> </data></data></data></data></div> <span class="mark-meta" tooltip-class="ecm-lg-p-tooltip" ng-switch-default="" ng-if="column.title != \'idEE\' && column.title != \'abstract\'" uib-tooltip-html="$ctrl.trustAsHtml($ctrl.getColumnValue(column, data[column.value]) | ecmBoolean)" ng-bind-html="$ctrl.trustAsHtml($ctrl.getColumnValue(column, data[column.value]) | ecmBoolean)"> </span> </ng-switch> </td> </tr> </tbody> </table> <div class="text-left" ng-hide="!$ctrl.resultat || $ctrl.resultat.length == 0"> <ecm-pagination storage-key="{{$ctrl.tableTirId}}" pagination-model="$ctrl.pagination" on-change="$ctrl.pageChanged()"></ecm-pagination> </div> </div> <div ng-if="$ctrl.resultat.length == 0" class="col-sm-12"> <span translate="global.noresult"></span> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-container/search-container-plan/search-container-plan.component.html',' <div class="col-sm-12 tir-result">  <script type="text/ng-template" id="PlanTree"> <a ng-click="showDetails = !showDetails" style="color: blue;cursor: pointer;" ng-init="showDetails = false"> <i class="fa fa-folder" aria-hidden="true" ng-click="$ctrl.getSubLevel(resultPlan); showDetails = !showDetails" ng-if="!showDetails" style="color: black;cursor: pointer;"></i> <i class="fa fa-folder-open" aria-hidden="true" ng-click="showDetails = !showDetails" ng-if="showDetails" style="color: black;cursor: pointer;"></i> </a> <span> <strong>{{resultPlan.value | validClassifName | ecmDateTir:\'short\'}}</strong> ({{resultPlan.size}})</span> <div class="col-sm-12" ng-if="resultPlan.children" ng-show="showDetails" style="margin-left: 15px;"> <div ng-repeat="resultPlan in resultPlan.children" ng-include="\'PlanTree\'"></div> </div> <div class="col-sm-12" ng-if="resultPlan.listResultat != null && resultPlan.listResultat.length > 0" ng-show="showDetails" style="margin-left: 15px;"> <div class="row" ng-repeat="resultat in resultPlan.listResultat"> <div class="col-sm-6"> <div class="sidebar-open" ng-dblclick="$ctrl.navigateToEe({id:resultat[\'FLASH_ID\']})" ng-click="$ctrl.getEeSelected({ idEE: resultat[\'FLASH_ID\'], editEnabled: resultat[\'editEnabled\'], isLocked: resultat[\'isLocked\'],entityTemplateCode: resultat[\'EE_DOC_TYPE\'] })"> <input type="checkbox" ng-model="$ctrl.selectedEe[resultat[\'FLASH_ID\']]" class="green" aria-label="checkbox"> <a style="cursor: pointer" uib-tooltip="{{\'userApp.searchInterfaceTemplate.home.goToEE\'|translate}}" ui-sref="editorialEntity({ id: resultat[\'FLASH_ID\']})"> <i class="fa fa-external-link fa-lg" aria-hidden="true"></i> </a> <a ng-if="resultat[\'HTML_MULTI_SYSTEMABSTRACT\'] && $ctrl.searchSolr.displayResultAbstract" class="ecm-tree-show-summary-btn" ng-click="resultat.showDetails = !resultat.showDetails;$event.stopPropagation()" ng-init="resultat.showDetails = $ctrl.searchSolr.openResultAbstract"> <i class="fa fa-ellipsis-h ecm-summary-transition" ng-class="{\'fa-rotate-90\': resultat.showDetails}" aria-hidden="true"></i> </a> <a class="ecm-tir-ee-title" md-highlight-text="$ctrl.searchSolr.searchFullTextDTO.searchFullText">{{resultat[\'NAME\'] | validName}}</a> </div> <p ecm-collapse="resultat.showDetails" ng-if="resultat[\'HTML_MULTI_SYSTEMABSTRACT\'] && $ctrl.searchSolr.displayClassificationAbstract" style="margin: 0 0 0px" ng-init="showAbstract = $ctrl.searchSolr.openClassification"> <!--span class="resume-label" md-highlight-text="searchFullText.searchFullText">{{resultat[\'HTML_MULTI_SYSTEMABSTRACT\']}}</span--> <span class="resume-label" ng-bind-html="$ctrl.trustAsHtml(resultat[\'HTML_MULTI_SYSTEMABSTRACT\'])"></span> </p> </div> <div class="col-sm-6"> <data ng-init="padlock=resultat[\'LOCK_STATE\']" /> <data ng-init="color=(padlock|split:\'#\':0)" /> <data ng-init="closed=((padlock|split:\'#\':1)==\'true\')" /> <data ng-init="owner=(padlock|split:\'#\':2)" /> <padlock-icon color="color" closed="$ctrl.closed" owner="owner" size="small"></padlock-icon> </div> </div> </div> </script> <div class="col-sm-12" ng-repeat="resultPlan in $ctrl.searchSolr.listResultatPlan" ng-include="\'PlanTree\'"></div> <div ng-if="$ctrl.searchSolr.listResultatPlan.length == 0" class="col-sm-12"> <span translate="global.noresult"></span> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-alphanumeric.html',' <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && ! $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient </option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input class="form-control" type="text" ng-model="$ctrl.filter.value" name="alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="$ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="$ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="$ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && ! $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': !$ctrl.checkLengthFilter.validLength}"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.getMaxLength()}}" ng-model="$ctrl.filter.multiValuesList" name="alphaNumericTagsMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="!$ctrl.checkLengthFilter.validLength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.freeText && $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.visibility && !$ctrl.filter.multiValued" ng-class="{ \'has-error\': $ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <ui-select ng-model="$ctrl.filter.value" ng-click="$ctrl.loadMetaDataSystemValues($ctrl.filter)" on-select="$ctrl.onSelectSyetemMetaValueCallback($item)" on-remove="$ctrl.onRemoveSyetemMetaValueCallback($item)"> <ui-select-match allow-clear="true"> {{$select.selected.text | translate}} </ui-select-match> <ui-select-choices repeat="metaDataOption.text as metaDataOption in $ctrl.listMetaDataSystemValues | propsFilter: {\'text\':$select.search}"> <span ng-bind-html="metaDataOption.text | translate | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.freeText && $ctrl.filter.visibility && $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.multiValued" ng-class="{ \'has-error\': $ctrl.form[\'alphaNumericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <ui-select multiple="" ng-model="$ctrl.filter.multiValuesList" ng-click="$ctrl.loadMetaDataSystemValues($ctrl.filter)" on-select="$ctrl.onSelectSyetemMetaValueCallback($item)" on-remove="$ctrl.onRemoveSyetemMetaValueCallback($item)"> <ui-select-match allow-clear="true">{{$item.text | translate }}</ui-select-match> <ui-select-choices repeat="metaDataOption as metaDataOption in $ctrl.listMetaDataSystemValues | propsFilter: {\'translatedText\':$select.search}"> <span ng-bind-html="metaDataOption.text | translate | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-boolean.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.metaDataDTO.selectionFormat == \'RADIOBUTTON\'"> <div class="col-sm-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-8"> <input name="radioMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="radio" ng-model="$ctrl.filter.value"> <label translate="userApp.searchInterfaceTemplate.listFilterTir.all"></label> </div> <div class="col-sm-10 col-md-offset-3"> <input name="radioMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="radio" ng-model="$ctrl.filter.value" value="true" class="radio-inline"> <label>{{$ctrl.filter.metaDataDTO.rightWording}}</label> </div> <div class="col-sm-10 col-md-offset-3"> <input name="radioMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="radio" ng-model="$ctrl.filter.value" value="false" class="radio-inline"> <label>{{$ctrl.filter.metaDataDTO.falseWording}}</label> </div> </div> <div class="form-group form-group-sm voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.metaDataDTO.selectionFormat == \'CHECKBOX\'"> <div class="col-sm-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-9"> <div class="checkbox"> <label> <input name="checkboxMetaData{{metaDataInstance.displayOrder}}" type="checkbox" ng-model="$ctrl.filter.value" ng-true-value="\'true\'" ng-false-value="\'false\'"> </label> </div> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-calculated.html',' <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input class="form-control" type="text" ng-model="$ctrl.filter.value" name="calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="form[\'calculatedMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': !$ctrl.checkLengthFilter.validLength}"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{getMaxLength()}}" ng-model="$ctrl.filter.multiValuesList" name="calculatedTagsMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="!$ctrl.checkLengthFilter.validLength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-date.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet"> <div class="col-sm-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.dateOperator!==\'EQUAL\' || $ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.dateOperator!==\'EQUAL\' || $ctrl.filter.nullValue }"> <option value="true">Contient </option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-sm-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <ecm-datepicker show-operator="true" operators="$ctrl.dateOperatorOptions" model-type="\'RANGE\'" selected-operator="$ctrl.filter.dateOperator" ng-change="$ctrl.dateChanged($ctrl.dateModel.startDate, $ctrl.dateModel.endDate)" ng-model="$ctrl.dateModel"></ecm-datepicker> </div> <div class="col-sm-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-html.html',' <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-sm-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-sm-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <textarea class="form-control" ng-model="$ctrl.filter.value" name="htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength">\n\t\t<span ng-show="form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span>\n\t</textarea></div> <div class="col-sm-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="form[\'htmlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': !$ctrl.checkLengthFilter.validLength}"> <div class="col-sm-3"> <label class="control-label" style="float: left;"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-sm-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" on-tag-added="checkTag($tag)" ng-model="$ctrl.filter.multiValuesList" name="htmlTagsMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="!$ctrl.checkLengthFilter.validLength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-sm-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-list.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet"> <div class="col-sm-3"> <label for="name" class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && !$ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="listMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}"> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && $ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="listMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}"></tags-input> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="!$ctrl.filter.freeText && !$ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <ui-select ng-model="$ctrl.filter.value"> <ui-select-match allow-clear="true"> {{$select.selected.wording}} </ui-select-match> <ui-select-choices repeat="item.wording as item in ($ctrl.filter.metaDataDTO.listMetaDataValues | filter: {wording : $select.search }) track by $index"> <span ng-bind-html="item.wording | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="!$ctrl.filter.freeText && $ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <ui-select multiple="" ng-model="$ctrl.filter.multiValuesList"> <ui-select-match> {{$item.wording}} </ui-select-match> <ui-select-choices repeat="{\'text\':item.wording} as item in ($ctrl.filter.metaDataDTO.listMetaDataValues | filter: {wording : $select.search })"> <span ng-bind-html="item.wording | highlight: $select.search"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-media.html','');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-numeric.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet" ng-class="{ \'has-error\': form[\'numericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid || form[\'numericMetaDataBTW1{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid || form[\'numericMetaDataBTW2{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.metaDataOperator!==\'EQUAL\' || $ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.metaDataOperator!==\'EQUAL\' || $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4" ng-show="!$ctrl.filter.nullValue"> <div class="row meta-filter-row"> <div class="col-lg-4"> <select ng-model="$ctrl.filter.metaDataOperator" class="form-control" ng-init="$ctrl.filter.metaDataOperator = $ctrl.filter.metaDataOperator || $ctrl.operatorOptions[0].value" ng-options="option.value as option.name|translate for option in $ctrl.operatorOptions" ng-change="$ctrl.updateNumbers($ctrl.filter.metaDataOperator, \'{{$ctrl.filter.metaDataOperator}}\')"> </select> </div> <div class="col-lg-8" ng-if="$ctrl.filter.metaDataOperator != \'BETWEEN\'"> <input ng-keyup="$ctrl.checkInputKey($event)" ng-if="$ctrl.filter.multiValued" type="number" class="form-control" ng-model="$ctrl.filter.multiValuesList[0].text" name="numericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-pattern="$ctrl.metaDataFieldPattern" placeholder="{{ $ctrl.filter.metaDataDTO.placeHolderInfoMsgKey | translate}}"> <input ng-keyup="$ctrl.checkInputKey($event)" ng-if="!$ctrl.filter.multiValued" type="number" class="form-control" ng-model="$ctrl.filter.value" name="numericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-pattern="$ctrl.metaDataFieldPattern" placeholder="{{ $ctrl.filter.metaDataDTO.placeHolderInfoMsgKey | translate}}"> <span ng-show="form[\'numericMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.pattern" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}"></span> </div> <div class="col-lg-4" ng-if="$ctrl.filter.metaDataOperator == \'BETWEEN\'"> <input type="number" class="form-control" ng-model="$ctrl.filter.multiValuesList[0].text" name="numericMetaDataBTW1{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-pattern="$ctrl.metaDataFieldPattern" placeholder="{{ $ctrl.filter.metaDataDTO.placeHolderInfoMsgKey | translate}}" ng-change="!checkNumbers()"> <span ng-show="form[\'numericMetaDataBTW1{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.pattern" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}"></span> </div> <div class="col-lg-4" ng-if="$ctrl.filter.metaDataOperator == \'BETWEEN\'"> <input type="number" class="form-control" ng-model="$ctrl.filter.multiValuesList[1].text" name="numericMetaDataBTW2{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-pattern="$ctrl.metaDataFieldPattern" placeholder="{{ $ctrl.filter.metaDataDTO.placeHolderInfoMsgKey | translate}}" ng-change="!checkNumbers()"> <span ng-show="form[\'numericMetaDataBTW2{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.pattern" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}"></span> <span class="text-danger" translate="{{message}}"></span> </div> </div> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-relationship.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet"> <div class="col-sm-3"> <label for="name" class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-sm-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && !$ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="listMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}"> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && $ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="listMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}"></tags-input> </div>  <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-repository.html','<div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.visibility && !$ctrl.filter.facet"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && !$ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value"> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.freeText && $ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="repositoryMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}"> </tags-input> </div>   <div class="col-sm-4 meta-filter-padding" ng-if="!$ctrl.filter.freeText && $ctrl.filter.metaDataDTO.referential.type==\'LIST\' && !$ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <ui-select ng-model="$ctrl.filter.value" ng-show="$ctrl.lang == \'fr\'" uis-open-close="$ctrl.initializeSelect($select, isOpen);"> <ui-select-match allow-clear="true"> {{$select.selected.labelFR ? $select.selected.labelFR : $select.selected}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption.labelFR as metaDataOption in $ctrl.referentialValueLis track by $index" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <span ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> <ui-select ng-model="$ctrl.filter.value" ng-show="$ctrl.lang == \'en\'" uis-open-close="$ctrl.initializeSelect($select, isOpen);"> <ui-select-match allow-clear="true"> {{$select.selected.labelEN ? $select.selected.labelEN : $select.selected}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption.labelEN as metaDataOption in $ctrl.referentialValueLis track by $index" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <span ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div>  <div class="col-sm-4 meta-filter-padding" ng-if="!$ctrl.filter.freeText && $ctrl.filter.metaDataDTO.referential.type==\'LIST\' && $ctrl.filter.multiValued" ng-show="!$ctrl.filter.nullValue"> <ui-select multiple="" ng-model="$ctrl.filter.multiValuesList" ng-if="$ctrl.lang === \'fr\'" uis-open-close="$ctrl.initializeSelect($select, isOpen);" ng-mousedown="$ctrl.fixItemsValue($select)"> <ui-select-match> {{$item.text}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption in $ctrl.referentialValueLis" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <span ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> <ui-select multiple="" ng-model="$ctrl.filter.multiValuesList" ng-if="$ctrl.lang === \'en\'" uis-open-close="$ctrl.initializeSelect($select, isOpen)" ng-mousedown="$ctrl.fixItemsValue($select)"> <ui-select-match> {{$item.text}} </ui-select-match> <ui-select-choices refresh="$ctrl.searchRef($select)" refresh-delay="500" repeat="metaDataOption in $ctrl.referentialValueLis" uiselect-scroll-bottom="" callback-fn="$ctrl.fetch($select)"> <span ng-bind-html="$ctrl.highlightText(metaDataOption, $select.search)"></span> </ui-select-choices> <ui-select-no-choice> <span translate="global.noresult"></span> </ui-select-no-choice> </ui-select> </div>   <div class="col-sm-4 meta-filter-padding" ng-if="$ctrl.filter.metaDataDTO.referential.type==\'TREE\' && !$ctrl.filter.freeText" ng-show="!$ctrl.filter.nullValue"> <div ng-click="$ctrl.openTreeModal()" class="ecm-referential-meta-display-selectable" uib-tooltip="{{\'global.selectValue(s)\'|translate}}"> <div ng-repeat="model in $ctrl.filter.listDisplayPathForNode track by $index"> {{model.path}} </div> </div> </div>  <div class="col-sm-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="$ctrl.checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/search/search-filter-field/search-filter-field-templates/filter-url.html',' <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && ! $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient </option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input class="form-control" type="text" ng-model="$ctrl.filter.value" name="urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="$ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.filter.metaDataDTO.textLength}}" ng-model="$ctrl.filter.multiValuesList" name="urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="$ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="!$ctrl.filter.multiValued && $ctrl.filter.visibility && !$ctrl.filter.facet && $ctrl.filter.freeText" ng-class="{ \'has-error\': $ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$invalid }"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <input ng-keyup="$ctrl.checkInputKey($event)" class="form-control" type="text" ng-model="$ctrl.filter.value" name="urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" ng-maxlength="$ctrl.filter.metaDataDTO.textLength"> <span ng-show="$ctrl.form[\'urlMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}\'].$error.maxlength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>  <div class="form-group form-group-sm required voffset1" ng-if="$ctrl.filter.multiValued && ! $ctrl.filter.metaDataDTO.metaSystem && $ctrl.filter.visibility && !$ctrl.filter.facet && !$ctrl.filter.freeText" ng-class="{ \'has-error\': !$ctrl.checkLengthFilter.validLength}"> <div class="col-lg-3"> <label class="control-label"> <span>{{$ctrl.filter.wording}}</span> <span ng-show="$ctrl.filter.mandatory" class="text-danger"> *</span> </label> </div> <div class="col-lg-2"> <select class="form-control" ng-model="$ctrl.filter.contains" ng-disabled="$ctrl.filter.nullValue" ng-class="{\'disabled-node\' : $ctrl.filter.nullValue }"> <option value="true">Contient</option> <option value="false">Ne contient pas</option> </select> </div> <div class="col-lg-4 meta-filter-padding" ng-show="!$ctrl.filter.nullValue"> <tags-input class="tagsInput" max-length="{{$ctrl.getMaxLength()}}" ng-model="$ctrl.filter.multiValuesList" name="alphaNumericTagsMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" placeholder="{{\'userApp.editorialEntity.home.multiValueInputPlaceHolder\' | translate}}"></tags-input> <span ng-show="!$ctrl.checkLengthFilter.validLength" class="text-danger" translate="{{$ctrl.filter.metaDataDTO.placeHolderInfoMsgKey}}" translate-values="{textLength: \'{{$ctrl.filter.metaDataDTO.textLength}}\'}"></span> </div> <div class="col-lg-2 meta-filter-padding" ng-show="!$ctrl.filter.mandatory"> <input name="checkboxMetaData{{$ctrl.filter.displayOrder}}{{$ctrl.filter.type}}{{$ctrl.filter.identifier}}" type="checkbox" ng-model="$ctrl.filter.nullValue"> <label> <span class="between-symbol" translate="userApp.searchInterfaceTemplate.listFilterTir.nullValue"></span> </label> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/searchv2/search-container/search-container-list/search-container-list.component.html','<div class="tir-result"> <div class="tir-list" ng-hide="!$ctrl.searchDto.listResult || $ctrl.searchDto.listResult.length == 0"> <table ecm-ultimate-table="static" resize-mode="overflow" id="{{$ctrl.tableTirId}}" st-table="$ctrl.searchDto.listResult" st-pipe="$ctrl.loadResultList" class="table table-striped table-hover table-fixed"> <thead> <tr> <th ng-repeat="column in $ctrl.searchDto.listColumn" ng-class="{\'col-sm-5\': $index==0 && $ctrl.searchDto.listColumn.length > 2, \'col-sm-1\': $index==$ctrl.searchSolr.listColumn.length-1, \'sortable\': column.sortDirection === null }"> <span>{{column.title}}</span> </th> </tr> </thead> <tbody> <tr ng-repeat="data in $ctrl.searchDto.listResult" ng-class="{\'st-selected\':data[\'identifier\'] === $ctrl.eeSelected}" class="sidebar-open"> <td ng-repeat="column in $ctrl.searchDto.listColumn" class="text-ellipsis" ng-class="{\'ecm-tir-name-column\': column.value === \'NAME\'}"> <ng-switch on="column.value"> <div ng-switch-when="META_HTML_TITLE" tooltip-class="ecm-lg-tooltip" uib-tooltip-html="data[$ctrl.dataTableConfig.META_HTML_TITLE]"> <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"> <span class="mark-title" ng-bind-html="data[$ctrl.dataTableConfig.META_HTML_TITLE]"></span> </div> </div> <span class="mark-meta" tooltip-class="ecm-table-tooltip" ng-switch-default="" uib-tooltip-html="$ctrl.trustAsHtml($ctrl.getColumnValue(column, data[column.value]) | ecmBoolean)" ng-bind-html="$ctrl.trustAsHtml($ctrl.getColumnValue(column, data[column.value]) | ecmBoolean)"> </span> </ng-switch> </td> </tr> </tbody> </table> <div class="text-left" ng-hide="!$ctrl.searchDto.listResult || $ctrl.searchDto.listResult == 0"> <ecm-pagination storage-key="{{$ctrl.tableTirId}}" pagination-model="$ctrl.pagination" on-change="$ctrl.pageChanged()"></ecm-pagination> </div> </div> <div ng-if="$ctrl.searchDto.listResult.length == 0" class="col-sm-12"> <span translate="global.noresult"></span> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/searchv2/search-facet/search-facet-option/search-facet-option.html','<li>  <div class="checkbox" ng-if="$ctrl.facetOption.children && $ctrl.facetOption.children.length > 0"> <a ng-click="$ctrl.toggleCollapse($ctrl.facet.identifier, $ctrl.facetOption.value)"> <span class="fa" ng-class="{ \'fa-plus-square-o\': $ctrl.isCollapsed($ctrl.facet.identifier, $ctrl.facetOption.value), \'fa-minus-square-o\': !$ctrl.isCollapsed($ctrl.facet.identifier, $ctrl.facetOption.value) }"></span> </a> <label> <input type="checkbox" ng-model="$ctrl.facetOption.checked" ng-change="$ctrl.toggleCheck($ctrl.facetOption)"> <span class="facet-value"> <span class="facet-text" ng-bind-html="$ctrl.facetOption.value | ecmDate | ecmBoolean"></span>&nbsp;({{$ctrl.facetOption.size}})</span> </label> </div>  <div ng-if="$ctrl.facetOption.children.length == 0" class="no-child-node"> <div class="checkbox"> <label> <input type="checkbox" ng-model="$ctrl.facetOption.checked" ng-change="$ctrl.toggleCheck($ctrl.facetOption, $ctrl.parentFacetOption)"> <span class="facet-value"> <span class="facet-text" ng-bind-html="$ctrl.facetOption.value | ecmDate | ecmBoolean"></span>&nbsp;({{$ctrl.facetOption.size}}) </span> </label> </div> </div>  <ol ng-if="$ctrl.facetOption.children && $ctrl.facetOption.children.length > 0 && !$ctrl.isCollapsed($ctrl.facet.identifier, $ctrl.facetOption.value)" class="ecm-custom-tree-node" ng-class="{hidden: $ctrl.isCollapsed($ctrl.facet.identifier, $ctrl.facetOption.value)}"> <search-facet-option ng-repeat="subItem in $ctrl.facetOption.children" facet="$ctrl.facet" facet-option="subItem" parent-facet-option="$ctrl.facetOption" facet-map-values="$ctrl.facetMapValues" on-facet-changed="$ctrl.facetChanged()"></search-facet-option> </ol> </li>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/archive-entity-modal/archive-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.archiveEditorialEntity.home.archive"></div> </div> <form name="archiveEditorialEntityForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <span ng-if="$ctrl.eeSourceList.length === 0" translate="userApp.archiveEditorialEntity.home.confirmArchiving"></span> <div ng-if="$ctrl.eeSourceList.length > 0"> <span translate="userApp.archiveEditorialEntity.home.error"></span> <br> <ul> <li ng-repeat="eeSource in $ctrl.eeSourceList"> <a href="" target="_blank" ui-sref="editorialEntity({id: eeSource.flashId})"> <span ng-bind-html="eeSource.title"></span> </a> </li> </ul> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button ng-if="$ctrl.eeSourceList.length === 0" class="btn btn-primary" type="button" ng-click="$ctrl.archiveEditorialEntity()"> <i class="glyphicon glyphicon-save"></i><span translate="userApp.editorialEntity.action.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="{{$ctrl.eeSourceList.length === 0 ? \'userApp.editorialEntity.action.cancel\' : \'userApp.editorialEntity.action.ok\'}}"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/multi-archive-entity-modal/multi-archive-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.archiveEditorialEntity.home.archive"></div> </div> <form name="archiveEditorialEntityForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <div ng-if="$ctrl.entitiesLinkedToSource.length > 0"> <ul> <li ng-repeat="eeTarget in $ctrl.entitiesLinkedToSource"> <div ng-if="eeTarget.eeSourceList.length > 0"> <span style="color:red" ng-bind-html="\'\\u26a0\'"></span> <span translate="userApp.archiveEditorialEntity.home.error" translate-values="{eeTarget: \'{{eeTarget.eeTargetTitle}}\'}"></span> <ol> <li ng-repeat="eeSource in eeTarget.eeSourceList"> <a href="" target="_blank" ui-sref="editorialEntity({id: eeSource.eeSourceFlashId})"> <span ng-bind-html="eeSource.eeSourceTitle"></span> </a> </li> </ol> </div> </li> </ul> </div> <br> <div ng-if="$ctrl.eeTargetListNotToArchive.length > 0"> <span translate="userApp.archiveEditorialEntity.home.alertNotAbleToArchiveEeTargetList"></span> <ul> <ol ng-repeat="eeTarget in $ctrl.eeTargetListNotToArchive"> <div> <strong> <span style="color:#16a085" ng-bind-html="\'\\&#42;\'"></span> </strong> <span><strong>{{eeTarget.eeTargetTitle}}</strong></span> </div> </ol> </ul> </div> <br> <div> <span translate="userApp.archiveEditorialEntity.home.{{!$ctrl.isAnyEntityToArchive ? \'confirmArchivingList\' : \'anyEntityToArchive\'}}"></span> <ul> <ol ng-repeat="eeTarget in $ctrl.allowedEntitiesToBeArchived"> <span ng-bind-html="eeTarget.eeTargetTitle"></span> </ol> </ul> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" ng-if="!$ctrl.isAnyEntityToArchive" type="button" ng-click="$ctrl.archiveEditorialEntities()"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.editorialEntity.action.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.editorialEntity.action.{{!$ctrl.isAnyEntityToArchive ? \'cancel\' : \'exit\'}}"></span> </button> </div> </div> </form> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/archive-entity/multi-delete-entity-modal/multi-delete-entity-modal.html','<div class="modal-header"> <div class="title" translate="userApp.trash.home.definitiveDelete"></div> </div> <div class="modal-body modal-scrollable"> <span translate="userApp.archiveEditorialEntity.home.definitiveDelete"></span> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.deleteEntityMulti()"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.editorialEntity.action.confirm"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/convert-entity-wizard-form.tpl.html','<div ng-if="!$ctrl.isActiveStep02()" class="modal-header"> <div class="title"> <h5 style="font-size: 24px;"> {{\'userApp.editorialEntity.convert.title\' | translate}} - {{$ctrl.currentTemplate}} - <span class="ecm-wizard-current-step">{{$ctrl.currentStep.name | translate}}</span> </h5> </div> </div> <form name="editForm" role="form" class="flex-container-column form-horizontal flex-full" novalidate=""> <div class="modal-body flex-full" style="height : auto"> <div id="wizard-container" class="flex-container-column"> <div id="wizard-content-container" class="flex-full"> <div class="alert alert-danger" role="alert" ng-if="$ctrl.errors.length > 0"> <ul ng-repeat="error in $ctrl.errors"> <li>{{error | translate}}</li> </ul> </div>   <tee-selection ng-if="$ctrl.isActiveStep01()" convertible-templates-list="$ctrl.convertibleTemplatesList" on-tee-selected="$ctrl.onTeeSelected(teeSelected,launchNextStep)"> </tee-selection>  <edit-converted-entity ng-if="$ctrl.isActiveStep02()" infos-for-persist="$ctrl.infosForPersist" tee-code="$ctrl.selectedTemplate.code" close="$ctrl.close()" dismiss="$ctrl.dismiss()" on-entity-converted="$ctrl.onEntityConverted()" edit-meta-use-case="$ctrl.editMetaUseCase"> </edit-converted-entity> </div> </div> </div> <div ng-if="!$ctrl.isActiveStep02()" class="modal-footer"> <div class="pull-right"> <button ng-if="!$ctrl.isActiveStep03()" class="btn btn-primary" type="button" ng-click="$ctrl.convert()" ng-disabled="!$ctrl.templateSelected"> <i class="glyphicon glyphicon-save"></i> <span translate="userApp.editorialEntity.convert.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-modal/convert-modal.html','<convert-entity-wizard-form current-template="$ctrl.currentTemplate" convertible-templates-list="$ctrl.convertibleTemplatesList" source-flash-id="$ctrl.flashId" create-new-entity="$ctrl.createNewEntity" dismiss="$ctrl.cancel()" on-entity-converted="$ctrl.excutePostConversionTasks()"></convert-entity-wizard-form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/create-and-hook-ee-wizard-modal/create-and-hook-ee-wizard-modal.tpl.html','<create-and-hook-ee-wizard ee-source-details="$ctrl.eeSourceDetails" current-user="$ctrl.currentUser" dismiss="$ctrl.dismiss()" close-modal="$ctrl.closeModal(result)" sub-element-details="$ctrl.subElementDetails" relationship-meta-case="$ctrl.relationshipMetaCase" editorial-ee="$ctrl.editorialEe"></create-and-hook-ee-wizard>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/edit-workflow-modal/validate-entity-change-step/validate-entity-change-step.html','<div> <div class="modal-header" ng-if="($ctrl.validation.errorList && $ctrl.validation.errorList.length > 0) || $ctrl.validation.errorERM"> <span class="text-danger" translate="userApp.editorialEntity.home.validateError"></span> <i class="icon ion-alert error text-danger"></i> </div> <div class="modal-header" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length == 0 && $ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <span class="text-danger" translate="userApp.editorialEntity.home.validateWarning"></span> <i class="icon ion-alert error text-danger"></i> </div> <div class="modal-body" ng-show="$ctrl.validation.validFunction"> <p ng-if="!($ctrl.validation.errorERM)"> <span translate="userApp.editorialEntity.msg.notvalideEE"></span> </p> <div class="alert alert-danger" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li ng-repeat="er in $ctrl.validation.errorList"> <i class="glyphicon glyphicon-remove text-danger"></i> <span> {{er | formatValidationError}}</span> </li> </ul> </div> <div class="alert alert-warning" ng-if="$ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.warningList"></span> </div> <ul> <li ng-repeat="er in $ctrl.validation.warningList"> <i class="icon ion-alert error"></i> <span> {{er}}</span> </li> </ul> </div> <div class="alert alert-danger" ng-if="$ctrl.validation.errorERM"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li> <i class="glyphicon glyphicon-remove text-danger"></i> <span translate="userApp.editorialEntity.msg.errorERM"></span> </li> </ul> </div> </div> <div class="modal-body" ng-show="!$ctrl.validation.validFunction"> <p ng-show="($ctrl.validation.wfwError && $ctrl.validation.errorList && $ctrl.validation.errorList.length > 0) || !($ctrl.validation.errorERM)"> <span translate="userApp.editorialEntity.msg.wfError"></span> </p> <div class="alert alert-danger" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length > 0"> <ul> <li ng-repeat="er in $ctrl.validation.errorList"> <i class="glyphicon glyphicon-remove text-danger"></i> <span> {{er | formatValidationError}}</span> </li> </ul> </div> <div class="alert alert-danger" ng-if="$ctrl.validation.errorERM"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li> <i class="glyphicon glyphicon-remove text-danger"></i> <span translate="userApp.editorialEntity.msg.errorERM"></span> </li> </ul> </div> <p ng-if="!$ctrl.validation.wfwError && $ctrl.validation.warningList && $ctrl.validation.errorList && $ctrl.validation.errorList.length== 0 && !$ctrl.validation.errorERM"> <span translate="userApp.editorialEntity.msg.wfWarning"></span> </p> <div class="alert alert-warning" ng-if="$ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <ul> <li ng-repeat="er in $ctrl.validation.warningList"> <i class="icon ion-alert error"></i> <span> {{er}}</span> </li> </ul> </div> </div> <div class="modal-footer" ng-show="$ctrl.validation.validFunction || $ctrl.validation.errorERM"> <button ng-if="$ctrl.validation.errorList.length=== 0 && $ctrl.validation.warningList.length > 0" class="btn btn-primary" data-ng-click="$ctrl.changeStepWarning()"> <span translate="userApp.editorialEntity.action.confirm"></span> </button> <button ng-if="$ctrl.validation.errorList.length > 0" class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.ok"></span> </button> <button ng-if="$ctrl.validation.errorList.length=== 0 && $ctrl.validation.warningList.length > 0" class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> <div class="modal-footer" ng-show="!$ctrl.validation.wfwError && !$ctrl.validation.validFunction && !$ctrl.validation.errorERM"> <button class="btn btn-primary" data-ng-click="$ctrl.clore()"> <span translate="entity.action.clore"></span> </button> <button class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/tree-auto-mount/entity-mounting/entity-mounting.tpl.html','<div> <div> <p> <span translate="entity.home.chooseExactAssemblyCriteria"></span> ({{$ctrl.exactMatch.length}}) : <div> <tir-display-filter allow-remove="false" filters="$ctrl.exactFiltersDisplay"></tir-display-filter> </div> </p> <table id="exactTable" ecm-ultimate-table="static" st-pipe="$ctrl.refreshExactTable" st-table="$ctrl.exactMatch" multi-select="true" on-select-row-change="$ctrl.onSelectRowChange(row)" checkbox-model="$ctrl.exactMatchSelected[row.FLASH_ID]" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="sortable" st-sort="HTML_MULTI_SYSTEMTITLE"> <span translate="global.field.wording"></span> <input ng-model="$ctrl.searchExact" ng-click="$event.stopPropagation()" class="pull-right" type="text"> </th> <th class="sortable col-sm-2" st-sort="{{column.title}}" ng-repeat="column in $ctrl.columns">{{column.value}}</th> <th class="sortable col-sm-2" st-sort="LOCK_STATE" translate="global.field.availability"></th> </tr> </thead> <tbody> <tr ng-class="{\'st-selected\':row.FLASH_ID === $ctrl.preview.flashId}" ng-click="$ctrl.showPreview(row.FLASH_ID)" class="sidebar-open" ng-repeat="row in $ctrl.exactMatch | filter: $ctrl.filterExact"> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.HTML_MULTI_SYSTEMTITLE )"> <span ng-bind-html="$ctrl.trustAsHtml( row.HTML_MULTI_SYSTEMTITLE | validName )"> </span> </td> <td ng-repeat="column in $ctrl.columns" uib-tooltip="{{row[column.title] | ecmDateTir | ecmBoolean}}">{{row[column.title] | ecmDateTir | ecmBoolean}}</td> <td> <padlock-icon color="row.padlock.color" closed="row.padlock.closed" owner="row.padlock.owner" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.exactMatch.length==0"> <td colspan="{{3 + $ctrl.columns.length}}" class="text-center"> <span translate="list.noData"></span> </td> </tr> </tfoot> </table> <p class="voffset3"> <span translate="entity.home.chooseTagsOfInterest"></span> ({{$ctrl.approximateMatch.length}}) : </p> <table id="approxTable" ecm-ultimate-table="static" st-pipe="$ctrl.refreshApproxTable" st-table="$ctrl.approximateMatch" multi-select="true" checkbox-model="$ctrl.approximateMatchSelected[row.FLASH_ID]" class="table table-striped table-bordered table-fixed one-line"> <thead> <tr> <th class="sortable" st-sort="HTML_MULTI_SYSTEMTITLE"> <span translate="global.field.wording"></span> <input ng-model="$ctrl.searchApproximate" ng-click="$event.stopPropagation()" class="pull-right" type="text"> </th> <th class="sortable col-sm-2" st-sort="{{column.title}}" ng-repeat="column in $ctrl.columns">{{column.value}}</th> <th class="sortable col-sm-2" st-sort="LOCK_STATE" translate="global.field.availability"></th> </tr> </thead> <tbody> <tr ng-class="{\'st-selected\':row.FLASH_ID === $ctrl.preview.flashId}" ng-click="$ctrl.showPreview(row.FLASH_ID)" class="sidebar-open" ng-repeat="row in $ctrl.approximateMatch | filter: $ctrl.filterApproximate"> <td tooltip-class="ecm-lg-tooltip" uib-tooltip-html="$ctrl.trustAsHtml( row.HTML_MULTI_SYSTEMTITLE )"> <span ng-bind-html="$ctrl.trustAsHtml( row.HTML_MULTI_SYSTEMTITLE | validName )"> </span> </td> <td ng-repeat="column in $ctrl.columns" uib-tooltip="{{row[column.title] | ecmDateTir | ecmBoolean}}">{{row[column.title] | ecmDateTir | ecmBoolean}}</td> <td> <padlock-icon color="row.padlock.color" closed="row.padlock.closed" owner="row.padlock.owner" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot> <tr ng-show="$ctrl.approximateMatch.length==0"> <td colspan="{{3 + $ctrl.columns.length}}" class="text-center"> <span translate="list.noData"></span> </td> </tr> </tfoot> </table> </div> <closeable-html-preview preview="$ctrl.preview" mode="full" on-refresh-page="$ctrl.next()" on-close="$ctrl.closePreview()"></closeable-html-preview> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/validation/validate-entity/validate-entity.html','<div> <div class="modal-header" ng-if="($ctrl.validation.errorList && $ctrl.validation.errorList.length > 0) || $ctrl.validation.errorERM"> <span class="text-danger" translate="userApp.editorialEntity.home.validateError"></span> <i class="icon ion-alert error text-danger"></i> </div> <div class="modal-header" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length == 0 && $ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <span class="text-danger" translate="userApp.editorialEntity.home.validateWarning"></span> <i class="icon ion-alert error text-danger"></i> </div> <div class="modal-header" ng-if="($ctrl.validation.errorList && $ctrl.validation.errorList.length == 0 && $ctrl.validation.warningList && $ctrl.validation.warningList.length == 0) || ( !$ctrl.validation.errorList && !$ctrl.validation.warningList)"> <div class="title" translate="userApp.editorialEntity.menu.stepWork"></div> </div> <div class="modal-body modal-scrollable" ng-show="$ctrl.validation.validFunction"> <p ng-if="!($ctrl.validation.errorERM)"> <span translate="userApp.editorialEntity.msg.notvalideEE"></span> </p> <div class="alert alert-danger" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li ng-repeat="er in $ctrl.validation.errorList"> <i class="glyphicon glyphicon-remove text-danger"></i> <span> {{er | formatValidationError}}</span> </li> </ul> </div> <div class="alert alert-warning" ng-if="$ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <div> <span translate="userApp.editorialEntity.msg.warningList"></span> </div> <ul> <li ng-repeat="er in $ctrl.validation.warningList"> <i class="icon ion-alert error"></i> <span> {{er}}</span> </li> </ul> </div> <div class="alert alert-danger" ng-if="$ctrl.validation.errorERM"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li> <i class="glyphicon glyphicon-remove text-danger"></i> <span translate="userApp.editorialEntity.msg.errorERM"></span> </li> </ul> </div> </div> <div class="modal-body modal-scrollable" ng-show="!$ctrl.validation.validFunction"> <p ng-if="$ctrl.validation.wfwError && $ctrl.validation.errorList && $ctrl.validation.errorList.length> 0 && !$ctrl.validation.errorERM"> <span translate="userApp.editorialEntity.msg.wfError"></span> </p> <div class="alert alert-danger" ng-if="$ctrl.validation.errorList && $ctrl.validation.errorList.length > 0"> <ul> <li ng-repeat="er in $ctrl.validation.errorList"> <i class="glyphicon glyphicon-remove text-danger"></i> <span> {{er | formatValidationError}}</span> </li> </ul> </div> <div class="alert alert-danger" ng-if="$ctrl.validation.errorERM"> <div> <span translate="userApp.editorialEntity.msg.errorList"></span> </div> <ul> <li> <i class="glyphicon glyphicon-remove text-danger"></i> <span translate="userApp.editorialEntity.msg.errorERM"></span> </li> </ul> </div> <p ng-if="!$ctrl.validation.wfwError && $ctrl.validation.warningList && $ctrl.validation.errorList && $ctrl.validation.errorList.length== 0 && !$ctrl.validation.errorERM && $ctrl.validation.warningList.length > 0"> <b> <span translate="userApp.editorialEntity.msg.wfWarning"></span> </b> </p> <div class="alert alert-warning" ng-if="$ctrl.validation.warningList && $ctrl.validation.warningList.length > 0"> <ul> <li ng-repeat="er in $ctrl.validation.warningList"> <i class="icon ion-alert error"></i> <span> {{er}}</span> </li> </ul> </div> <div ng-if="($ctrl.hasNotFinalEntities && $ctrl.validation.errorList && $ctrl.validation.errorList.length==0 && $ctrl.validation.warningList && $ctrl.validation.warningList.length==0) || (!$ctrl.validation.errorList && !$ctrl.validation.warningList)"> <p> <b> <span translate="userApp.editorialEntity.msg.wfWarning"></span> </b> </p> </div> <div ng-if="$ctrl.hasNotFinalCreatedEntities"> <p> <span translate="userApp.editorialEntity.msg.notFinalCreatedEntities"></span> </p> <p> <ul class="dashed-list"> <li ng-repeat="ee in $ctrl.statusValidation.notFinalCreatedEntities"> <a href="" target="_blank" ui-sref="editorialEntity({id: ee.flashId})"> <span ng-if="$ctrl.isEmptyTitle(ee.title)" translate="userApp.editorialEntity.home.noTitle"></span> <span ng-if="!$ctrl.isEmptyTitle(ee.title)" ng-bind-html="ee.title"></span> </a> ( <span ng-if="ee.systemLocked"> <span translate="userApp.editorialEntity.msg.lockMsg"></span> : {{ee.systemLocker}} &#44; </span> <span ng-if="!ee.systemLocked"> <span translate="userApp.editorialEntity.msg.notLocked"></span> &#44; </span> <span ng-if="ee.path"> <span translate="userApp.editorialEntity.msg.path"></span> {{ee.path}} </span> ) </li> </ul> </p> </div> <div ng-if="$ctrl.hasNotFinalUpdatedEntities"> <p> <span translate="userApp.editorialEntity.msg.notFinalUpdatedEntities"></span> </p> <p> <ul class="dashed-list"> <li ng-repeat="ee in $ctrl.statusValidation.notFinalUpdatedEntities"> <a href="" target="_blank" ui-sref="editorialEntity({id: ee.flashId})"> <span ng-if="$ctrl.isEmptyTitle(ee.title)" translate="userApp.editorialEntity.home.noTitle"></span> <span ng-if="!$ctrl.isEmptyTitle(ee.title)" ng-bind-html="ee.title"></span> </a> ( <span ng-if="ee.systemLocked"> <span translate="userApp.editorialEntity.msg.lockMsg"></span> : {{ee.systemLocker}} &#44; </span> <span ng-if="!ee.systemLocked"> <span translate="userApp.editorialEntity.msg.notLocked"></span> &#44; </span> <span ng-if="ee.path"> <span translate="userApp.editorialEntity.msg.path"></span> {{ee.path}} </span> ) </li> </ul> </p> </div> </div> <div class="modal-footer" ng-show="$ctrl.validation.validFunction || $ctrl.validation.errorERM"> <button class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.confirm"></span> </button> </div> <div class="modal-footer" ng-show="$ctrl.validation.wfwError"> <button class="btn btn-primary" data-ng-click="$ctrl.sendEEToCorrection()"> <span translate="userApp.editorialEntity.action.correctionEE"></span> </button> <button class="btn btn-primary" ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> <div class="modal-footer" ng-show="!$ctrl.validation.wfwError && !$ctrl.validation.validFunction && !$ctrl.validation.errorERM"> <button class="btn btn-primary" data-ng-click="$ctrl.clore()"> <span translate="entity.action.clore"></span> </button> <button class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.cancel"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/validation/validate-tree/validate-tree.component.html','<div> <div class="modal-header"> <span class="text-danger" translate="userApp.editorialEntity.home.report"></span> </div> <div block-ui="validationTreeBlockUI" class="modal-body"> <div> <span ng-if="$ctrl.allValid" type="text" class="btn btn-success" translate="userApp.editorialEntity.msg.valideEE">l\'entit\xE9 est valide </span> <button ng-if="!$ctrl.allValid" type="button" class="btn btn-success" ng-click="$ctrl.expandValid()">Valide <span class="badge">{{$ctrl.report.validEe.length}}</span> </button> <button ng-if="!$ctrl.allValid" type="button" class="btn btn-warning" ng-click="$ctrl.expandWarning()">warning <span class="badge">{{$ctrl.report.warningEe.length}}</span> </button> <button ng-if="!$ctrl.allValid" type="button" class="btn btn-danger" ng-click="$ctrl.expandError()">Errors <span class="badge">{{$ctrl.report.errorEe.length}}</span> </button> <button ng-if="!$ctrl.allValid" type="button" class="btn btn-secondary=" ng-click="$ctrl.expandAll()"> <i class="ecm-te-ico ecm-te-i-fa fa-expand"></i> </button> <button ng-if="!$ctrl.allValid" type="button" class="btn btn-secondary" ng-click="$ctrl.collapseAll()"> <i class="ecm-te-ico ecm-te-i-fa fa-compress"></i> </button> <button type="button" class="btn btn-secondary" ng-click="$ctrl.refresh()"> <i class="fa fa-refresh"></i> <span>Refresh</span> </button> </div> <div ng-if="!$ctrl.allValid" kendo-tree-view="$ctrl.treeview" data-expanded="true" k-data-source="$ctrl.source" k-data-bound="$ctrl.onDataBound" k-on-change="selectedItem = dataItem"> <span k-template=""> <span ng-if="!dataItem.report">{{dataItem.text}}</span> <i ng-if="(dataItem.report.errorList.length === 0 && dataItem.report.warningList.length > 0)" class="fa fa-exclamation-triangle" style="color:orange"></i> <i ng-if="(dataItem.report.validEE && dataItem.report.warningList.length === 0)" class="fa fa-check fa-lg" style="color:green"></i> <i ng-if="dataItem.report && (dataItem.report.errorERM || dataItem.report.errorList.length)" class="fa fa-times fa-lg" style="color:red"></i> <a style="color:black;" ng-if="dataItem.report" ui-sref="editorialEntity({id: dataItem.id})" target="_blank" ng-bind-html="$ctrl.trustAsHtml(dataItem.text)"></a> <a ng-click="$ctrl.openReportModal(dataItem.report)" ng-if="dataItem.report && (dataItem.report.errorERM || dataItem.report.errorList.length >0 || dataItem.report.warningList.length > 0 )" translate="userApp.editorialEntity.home.detail">detail</a> </span> </div> </div> <br> <br> <div class="modal-footer"> <button class="btn btn-primary" data-ng-click="$ctrl.cancel()"> <span translate="userApp.editorialEntity.action.confirm"></span> </button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/metadata/systemAuthor/edit-system-author-modal/edit-system-author-modal.html','<div class="modal-header"> <div class="title" translate="userApp.editorialEntity.menu.editAuthor"></div> </div> <form name="modalForm" class="form-horizontal" novalidate=""> <div class="modal-body modal-scrollable"> <system-author entity="$ctrl.editorialEntity" edit-authors="true"></system-author> </div> <div class="modal-footer"> <div class="pull-right"> <button class="btn btn-primary" type="button" ng-click="$ctrl.save()" ng-disabled="modalForm.$invalid"> <i class="glyphicon glyphicon-save"></i><span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/deactivateNodeConfirmModal.tpl.html','<div> <div class="modal-header"> <div class="title" translate="userApp.editorialEntity.home.deactivateNode"> Confirmation </div> <span class="modal-close" ng-click="deactivateNodeCtrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group form-group-sm"> <label for="deactivateNodeQuestion" class="" translate="userApp.editorialEntity.home.deactivateNodeQuestion"> </label> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-click="deactivateNodeCtrl.ok()" translate="userApp.editorialEntity.home.deleteNodeOk"></button> <button type="button" class="btn btn-default" ng-click="deactivateNodeCtrl.cancel()" translate="userApp.editorialEntity.home.deleteNodeCancel"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/deleteNodeModal.tpl.html','<div> <div class="modal-header"> <div class="title" translate="userApp.editorialEntity.home.deleteNode"> Confirmation </div> <span class="modal-close" ng-click="deleteNodeCtrl.cancel()"> <i class="icon ion-close"></i> </span> </div> <div class="modal-body"> <div class="form-group form-group-sm"> <label for="deleteNodeQuestion" class="" translate="userApp.editorialEntity.home.deleteNodeQuestion"> </label> </div> <div ng-if="deleteNodeCtrl.hasChildren" class="form-group form-group-sm"> <md-checkbox class="control-label green" ng-model="deleteNodeCtrl.deleteChildNodes">{{\'userApp.editorialEntity.home.deleteChildNodes\' | translate}}</md-checkbox> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary" ng-click="deleteNodeCtrl.ok()" translate="userApp.editorialEntity.home.deleteNodeOk"></button> <button type="button" class="btn btn-default" ng-click="deleteNodeCtrl.cancel()" translate="userApp.editorialEntity.home.deleteNodeCancel"></button> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/editDesiredPublicationDateModal.tpl.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.editorialEntity.home.EditDesiredPublicationDate"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="save()"> <div class="modal-body"> <div class="form-group form-group-sm"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.editorialEntity.home.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-4"> <ecm-datepicker name="txtDesiredPublicationDate" ng-required="true" ng-model="desiredPublicationDate.value"></ecm-datepicker> <div ng-show="editForm[\'txtDesiredPublicationDate\'].$invalid" class="text-danger" translate="entity.validation.date"></div> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button ng-disabled="editForm.$invalid" type="submit" class="btn btn-primary"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/modifyNodeTypeModal.tpl.html','<div class="modal-header"> <div class="title"> <h2 translate="userApp.editorialEntity.home.modifyNodeType"></h2> </div> </div> <form name="editForm" role="form" class="form-horizontal" ng-submit="modifyNodeTypeCtrl.save()"> <div class="modal-body"> <div class="form-group form-group-sm"> <div class="col-sm-3"> <label class="control-label" for="nodeTitle">{{\'userApp.editorialEntity.home.nodeType\' | translate}}</label> </div> <div class="col-sm-4"> <select ng-if="modifyNodeTypeCtrl.nodeTypes.length > 0" ng-required="true" class="form-control" ng-model="modifyNodeTypeCtrl.type"> <option ng-repeat="nodeType in modifyNodeTypeCtrl.nodeTypes" value="{{nodeType}}">{{nodeType}}</option> </select> <input ng-if="modifyNodeTypeCtrl.nodeTypes.length === 0" ng-required="true" class="form-control" ng-model="modifyNodeTypeCtrl.type"> </div> </div> </div> <div class="modal-footer"> <div class="pull-right"> <button type="submit" class="btn btn-primary"> <span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save"></span> </button> <button type="button" class="btn btn-default" ng-click="modifyNodeTypeCtrl.cancel()"> <span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel"></span> </button> </div> </div> </form>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/tree-view/directives/templates/treeview.html','<div class="k-content" style="min-height: 50px"> <div id="treeView" class="ecm-treeview" k-on-data-bound="treeViewCtrl.onDataBound(kendoEvent)" k-on-expand="treeViewCtrl.onExpand(kendoEvent)" kendo-tree-view="treeViewInstance" k-data-source="treeViewCtrl.dataSource" k-options="treeViewCtrl.options" k-on-drag="treeViewCtrl.onDrag(kendoEvent)" k-on-change="treeViewCtrl.onNodeSelection(dataItem)" k-on-drop="treeViewCtrl.onNodeDragAndDrop(kendoEvent)"> <div k-template="" id="{{dataItem.id}}" ng-class="{\'nodeMenu\' : !treeViewCtrl.isReadOnly || editorialEntityState}"> <span class="no-child-node" ng-if="!dataItem.hasChildren"></span> <span class="ecm-tree-node-content" ng-class="{\'disabled-node\' : dataItem.grayDisplay,\'k-state-disabled\' : treeViewCtrl.isDisabledNode(dataItem)}" ng-style="treeViewCtrl.nodeStyle(dataItem)" ng-click="treeViewCtrl.checkNode(dataItem.id)">  <div class="{{\'ecm-tree-title-\'+dataItem.type.toLowerCase()}}">   <span ng-switch="" on="dataItem.type" class="ecm-tree-icon" ng-if="dataItem.type == \'REFERENCE\' || dataItem.type == \'QUERY\' || dataItem.type == \'CONTENT\'"> <relation-status-icon disabled="treeViewCtrl.isDisabledNode(dataItem)" relation-status="dataItem.relationStatus" ng-switch-when="REFERENCE"></relation-status-icon> <i class="fa fa-search" ng-switch-when="QUERY" aria-hidden="true"></i> <i class="fa fa-file-text-o" ng-switch-when="CONTENT" aria-hidden="true"></i> </span> <a ng-if="dataItem.type == \'REFERENCE\' && dataItem.relationStatus !== \'BROKEN\'" class="ecm-tree-show-summary-btn" ng-click="treeViewCtrl.getLinkedEEInsertionSummary(dataItem,$event)"> <i class="fa fa-ellipsis-h ecm-summary-transition" ng-class="{\'fa-rotate-90\': dataItem.showLinkedEESummary}" aria-hidden="true"></i> </a>   <span class="ecm-tree-title-text" ng-style="{\'text-decoration\': dataItem.deleted ? \'line-through\' : \'none\'}" ng-click="treeViewCtrl.setFocus()" ng-bind-html="treeViewCtrl.trustAsHtml(dataItem.text)" ng-dblclick="treeViewCtrl.nodeAction(dataItem.id,$event)"></span> <span ng-if="dataItem.type == \'CONTENT\' && dataItem.xmlContent == null" class="disabled-node">&#40;{{\'userApp.treeEEEdition.labels.emptyNodeContent\' | translate}}&#41;</span> <span class="italic" ng-if="dataItem.deleted && dataItem.nodeLastUpdateDate">({{dataItem.nodeLastUpdateDate | date: \'dd/MM/yyyy HH:mm\'}})</span> </div>  <div ecm-collapse="!dataItem.showLinkedEESummary" class="ecm-tree-collapse"> <div class="ecm-tree-zone ecm-tree-zone-summary"> <div ng-bind-html="dataItem.linkedEESummary" class="resume-label"></div> </div> </div>  <div ecm-collapse="!treeViewCtrl.showNodesMetaDatas()" delay="500" class="ecm-tree-collapse"> <div class="ecm-tree-zone ecm-tree-zone-meta"> <i class="fa fa-info ecm-tree-zone-icon" aria-hidden="true"></i> <div id="node_{{dataItem.id}}_editorials_metadatas" ng-if="treeViewCtrl.showNodesMetaDatas()"> <display-meta-values flash-id="dataItem.id" type="dataItem.type"></display-meta-values> </div> </div> </div> </span> </div>  <ul id="nodeLevelContextMenu" ng-if="!treeViewCtrl.isShowPreviewMenu" kendo-context-menu="treeViewCtrl.nodeLevelContextMenu" k-filter="\'.nodeMenu\'" k-on-open="treeViewCtrl.onNodeLevelContextMenuOpen(kendoEvent)" k-close-on-click="true" k-on-select="treeViewCtrl.onContextMenuSelection(kendoEvent)" style="width: 200px" k-hover-delay="500" k-popup-collision="false"> <li ng-class="{\'k-state-disabled\' : treeViewCtrl.isHooksExternalEntities}">{{\'userApp.treeEEEdition.labels.insertNode\' | translate}} <ul> <li>{{\'userApp.treeEEEdition.labels.insertNodeAbove\' | translate}} <ul> <li id="insertBeforeContentNode" ng-class="{\'k-state-disabled\' : ! treeViewCtrl.editContentAuthorized }">{{\'userApp.treeEEEdition.labels.content\' | translate}}</li> <li id="insertBeforeReferenceNode">{{\'userApp.treeEEEdition.labels.link\' | translate}}</li>  <li id="insertBeforeStructuralNode">{{\'userApp.treeEEEdition.labels.structure\' | translate}}</li> </ul> </li> <li ng-class="{\'k-state-disabled\' : !(treeViewCtrl.selectedNode.type === \'STRUCTURAL\') }">{{\'userApp.treeEEEdition.labels.in\' | translate}} <ul> <li id="addChildContentNode" ng-class="{\'k-state-disabled\' : ! treeViewCtrl.editContentAuthorized }">{{\'userApp.treeEEEdition.labels.content\' | translate}}</li> <li id="addChildReferenceNode">{{\'userApp.treeEEEdition.labels.link\' | translate}}</li>  <li id="addChildStructuralNode">{{\'userApp.treeEEEdition.labels.structure\' | translate}}</li> </ul> </li> <li>{{\'userApp.treeEEEdition.labels.insertNodeBelow\' | translate}} <ul> <li id="insertAfterContentNode" ng-class="{\'k-state-disabled\' : ! treeViewCtrl.editContentAuthorized }">{{\'userApp.treeEEEdition.labels.content\' | translate}}</li> <li id="insertAfterReferenceNode">{{\'userApp.treeEEEdition.labels.link\' | translate}}</li>  <li id="insertAfterStructuralNode">{{\'userApp.treeEEEdition.labels.structure\' | translate}}</li> </ul> </li> </ul> </li> <li ng-class="{\'k-state-disabled\' : treeViewCtrl.copiedNode == null || angular.isUndefined(treeViewCtrl.copiedNode)}" id="pastNode">{{\'userApp.treeEEEdition.labels.pastNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.type === \'STRUCTURAL\' && treeViewCtrl.selectedNode.hasChildren && !treeViewCtrl.selectedNode.deleted">{{\'userApp.treeEEEdition.labels.copyNode\' | translate}} <ul> <li id="copyNodeWithChildren" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.includeChildsNode\' | translate}}</li> <li id="copyNode" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.excludeChildsNode\' | translate}}</li> </ul> </li> <li ng-show="(treeViewCtrl.selectedNode.type != \'STRUCTURAL\' || (treeViewCtrl.selectedNode.type == \'STRUCTURAL\' && !treeViewCtrl.selectedNode.hasChildren)) && !treeViewCtrl.selectedNode.deleted" id="copyNode">{{\'userApp.treeEEEdition.labels.copyNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.type === \'STRUCTURAL\' && treeViewCtrl.selectedNode.hasChildren && !treeViewCtrl.selectedNode.deleted">{{\'userApp.treeEEEdition.labels.cutNode\' | translate}} <ul> <li id="cutNodeWithChildren" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.includeChildsNode\' | translate}}</li> <li id="cutNode" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.excludeChildsNode\' | translate}}</li> </ul> </li> <li ng-show="(treeViewCtrl.selectedNode.type != \'STRUCTURAL\' || (treeViewCtrl.selectedNode.type == \'STRUCTURAL\' && !treeViewCtrl.selectedNode.hasChildren)) && !treeViewCtrl.selectedNode.deleted" id="cutNode">{{\'userApp.treeEEEdition.labels.cutNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.hasChildren" id="expandAllSelectedNode">{{\'userApp.treeEEEdition.labels.expandAllSelectedNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.hasChildren" id="collapseAllSelectedNode">{{\'userApp.treeEEEdition.labels.collapseAllSelectedNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.type === \'CONTENT\'" ng-class="{\'k-state-disabled\' : ! treeViewCtrl.editContentAuthorized || treeViewCtrl.selectedNode.deleted}" id="editNodeContent">{{\'userApp.treeEEEdition.labels.editContent\' | translate}}</li>  <li id="editNodeMetaData"> <span ng-show="treeViewCtrl.selectedNode.type != \'REFERENCE\'" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.editMeta\' | translate}}</span> <span ng-show="treeViewCtrl.selectedNode.type === \'REFERENCE\'" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.editRelationMeta\' | translate}}</span> </li> <li id="modifyNodeTitle" ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.deleted || treeViewCtrl.isHooksExternalEntities}">{{\'userApp.treeEEEdition.labels.modifyTitle\' | translate}}</li> <li ng-class="{\'k-state-disabled\' : treeViewCtrl.selectedNode.type !== \'STRUCTURAL\' || treeViewCtrl.selectedNode.deleted}" id="modifyNodeType">{{\'userApp.treeEEEdition.labels.modifyType\' | translate}}</li>  <li ng-class="{\'k-state-disabled\': !treeViewCtrl.authorizedNodeDeactivation || treeViewCtrl.selectedNode.type !== \'REFERENCE\' || treeViewCtrl.selectedNode.activated || treeViewCtrl.selectedNode.deleted}" id="activateNode">{{\'userApp.treeEEEdition.labels.activateNode\' | translate}}</li> <li ng-class="{\'k-state-disabled\' : !treeViewCtrl.authorizedNodeDeactivation || treeViewCtrl.selectedNode.type !== \'REFERENCE\' || !treeViewCtrl.selectedNode.activated || treeViewCtrl.selectedNode.deleted}" id="deactivateNode">{{\'userApp.treeEEEdition.labels.deactivateNode\' | translate}} </li> <li ng-show="treeViewCtrl.container && (treeViewCtrl.selectedNode.type === \'REFERENCE\')" ng-class="{\'k-state-disabled\': treeViewCtrl.selectedNode.deleted}" id="editDesiredPublicationDate"> {{\'userApp.treeEEEdition.labels.editDesiredPublicationDate\' | translate}}</li> <li id="deleteNode" ng-class="{\'k-state-disabled\': treeViewCtrl.selectedNode.deleted}">{{\'userApp.treeEEEdition.labels.deleteNode\' | translate}}</li> <li id="restoreNode" ng-class="{\'k-state-disabled\': !treeViewCtrl.canRestore()}">{{\'userApp.treeEEEdition.labels.restoreNode\' | translate}}</li> <li ng-class="{\'k-state-disabled\': !isFullPreviewPossible || treeViewCtrl.selectedNode.relationStatus === \'BROKEN\' || treeViewCtrl.selectedNode.deleted || treeViewCtrl.isHooksExternalEntities}" id="preview">{{\'userApp.treeEEEdition.labels.preview\' | translate}}</li> <li ng-class="{\'k-state-disabled\': treeViewCtrl.selectedNode.type !== \'STRUCTURAL\' || treeViewCtrl.selectedNode.deleted || treeViewCtrl.isHooksExternalEntities}" id="createAndHook">{{\'userApp.treeEEEdition.labels.createAndHook\' | translate}}</li> </ul>  <ul ng-if="treeViewCtrl.isShowPreviewMenu" id="nodeLevelContextMenu" kendo-context-menu="treeViewCtrl.nodeLevelContextMenu" k-filter="\'.nodeMenu\'" k-on-open="treeViewCtrl.onNodeLevelContextMenuOpen(kendoEvent)" k-close-on-click="true" k-on-select="treeViewCtrl.onContextMenuSelection(kendoEvent)" style="width: 280px" k-hover-delay="500"> <li id="editNodeMetaData"> <span ng-show="treeViewCtrl.selectedNode.type != \'REFERENCE\'">{{\'userApp.treeEEEdition.labels.editMeta\' | translate}} </span> <span ng-show="treeViewCtrl.selectedNode.type === \'REFERENCE\'">{{\'userApp.treeEEEdition.labels.editRelationMeta\' | translate}} </span> </li> <li ng-show="treeViewCtrl.selectedNode.hasChildren" id="expandAllSelectedNode">{{\'userApp.treeEEEdition.labels.expandAllSelectedNode\' | translate}}</li> <li ng-show="treeViewCtrl.selectedNode.hasChildren" id="collapseAllSelectedNode">{{\'userApp.treeEEEdition.labels.collapseAllSelectedNode\' | translate}}</li> <li ng-class="{\'k-state-disabled\': !isFullPreviewPossible || treeViewCtrl.selectedNode.relationStatus === \'BROKEN\'}" id="preview">{{\'userApp.treeEEEdition.labels.preview\' | translate}}</li> <li ng-class="{\'k-state-disabled\': treeViewCtrl.selectedNode.type !== \'STRUCTURAL\' }" id="createAndHook">{{\'userApp.treeEEEdition.labels.createAndHook\' | translate}}</li> <li ng-show="treeViewCtrl.showManageDeleteHook()" id="deleteHook">{{\'userApp.treeEEEdition.labels.deleteHook\' | translate}}</li> </ul>  <ul id="treeLevelContextMenu" kendo-context-menu="treeViewCtrl.treeLevelContextMenu" k-filter="\'#editTreeDiv\'" k-on-open="treeViewCtrl.onTreeLevelContextMenuOpen(kendoEvent)" k-close-on-click="true" k-on-select="treeViewCtrl.onContextMenuSelection(kendoEvent)" style="width: 200px" k-hover-delay="500"> <li>{{\'userApp.treeEEEdition.labels.addNode\' | translate}} <ul> <li id="addFirslLevelContentNode" ng-class="{\'k-state-disabled\' : ! treeViewCtrl.editContentAuthorized }">{{\'userApp.treeEEEdition.labels.content\' | translate}}</li> <li id="addFirslLevelReferenceNode">{{\'userApp.treeEEEdition.labels.link\' | translate}}</li>  <li id="addFirslLevelStructuralNode">{{\'userApp.treeEEEdition.labels.structure\' | translate}}</li> </ul> </li> <li id="createAndHook">{{\'userApp.treeEEEdition.labels.createAndHook\' | translate}}</li> </ul> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/steps/create-ee-form/create-ee-form.tpl.html','<div block-ui="displayEeCreationForm"> <form name="$ctrl.createEntityForm" role="form" class="form-horizontal" novalidate=""> <div class="form-group form-group-sm required"> <div class="col-sm-4 col-lg-2"> <label for="groupList" class="control-label"> <span translate="userApp.editorialEntity.home.model"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <select class="form-control" ng-model="$ctrl.editorialEntity.modelFlashId" id="modelFlashId" ng-disabled="$ctrl.allModelsSize == 1" ng-change="$ctrl.loadMetaInstance()" ng-options="key as value|translate for (key,value) in $ctrl.allModels"> </select> </div> </div>  <product-group label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" tee-code="$ctrl.eetCode" on-change-product-group="$ctrl.onChangeProductGroup(ownerGroup)" edit="true"></product-group>  <system-author label-class="col-lg-2" content-class="col-lg-10" entity="$ctrl.editorialEntity" edit-authors="false"></system-author>  <div class="form-group form-group-sm" ng-if="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel"> <div class="col-sm-4 col-lg-2"> <label class="control-label"> <span translate="userApp.editorialEntity.home.titleField"></span> </label> </div> <div class="col-sm-8 col-lg-10"> <text-area-with-menu html-text="$ctrl.editorialEntity.titleSystem" show-remaining-characters-helper="$ctrl.editorialEntity.editorialEntityTemplate.editedTitel" maxlength="$ctrl.editorialEntity.editorialEntityTemplate.editedTitleMaxLength"> </text-area-with-menu> </div> </div>  <meta-data-field meta-data-instance="metaDataInstance" ng-repeat="metaDataInstance in $ctrl.editorialEntity.editorialEntityTemplate.metaDataInstanceDTOList" form="$ctrl.createEntityForm" lang="$ctrl.lang" display="false" max-size-media="$ctrl.maxSizeMedia" product-code="$ctrl.editorialEntity.ownerGroup" ee-source-flash-id="$ctrl.editorialEntity.identifier" eet-id="$ctrl.editorialEntity.editorialEntityTemplate.identifier" current-user="$ctrl.currentUser" is-creating-entity="true"></meta-data-field> </form> </div> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/create-and-hook-ee-wizard/steps/rt-eet-selection/rt-eet-selection.tpl.html','<div block-ui="displayRtEetDiv"> <span ng-if="$ctrl.rtEets.length === 0" translate="userApp.linkAndCreateEeWizard.labels.noTeeFound"></span> <table ng-if="$ctrl.rtEets.length !== 0" st-table="$ctrl.rtEets" class="table bg-white table-striped table-bordered table-hover table-fixed ui-grid uigridTable"> <thead> <tr> <th class="icon-column"></th> <th>{{\'userApp.linkAndCreateEeWizard.labels.entityType\' | translate}}</th> <th>{{\'userApp.linkAndCreateEeWizard.labels.relation\' | translate}}</th> </tr> </thead> <tbody> <tr ng-repeat="rtEet in $ctrl.rtEets" ng-click="$ctrl.selectEet(rtEet)" ng-dblclick="$ctrl.selectEet(rtEet,true)"> <td><input name="selectEet" type="radio" ng-model="$ctrl.selectedRtEet" ng-value="rtEet"></td> <td class="text-ellipsis"><span uib-tooltip="{{ rtEet.editorialEntityTemplate.wording }}">{{ rtEet.editorialEntityTemplate.wording}}</span></td> <td class="text-ellipsis"><span uib-tooltip="{{ rtEet.relationshipTemplate.wording }}">{{ rtEet.relationshipTemplate.wording}}</span></td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="3" class="text-center"> <div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="10"></div> </td> </tr> </tfoot> </table> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/ee-source-selection/ee-source-selection.tpl.html','<div block-ui="displayEeSourcesListDiv"> <br> <table st-table="$ctrl.sourceEesList" class="table table-striped table-hover table-fixed"> <thead> <tr> <th class="icon-column"></th> <th style="width:50%">{{\'userApp.linkEEWizard.labels.columnTitle\' | translate}}</th> <th>{{\'userApp.linkEEWizard.labels.teeLabel\' | translate}}</th> <th class="col-dispo">{{\'userApp.linkEEWizard.labels.status\' | translate}}</th> <th class="col-dispo">{{\'userApp.linkEEWizard.labels.availability\' | translate}}</th> </tr> <tr> <th class="icon-column"></th> <th> <input st-search="titleSystem"> </th> <th> <input st-search="editorialEntityTemplate.code"> </th> <th> <input st-search="workflowStatus"> </th> <th></th> </tr> </thead> <tbody> <tr ng-repeat="ee in $ctrl.sourceEesList" ng-class="{disabled: ee.disable}" ng-click="$ctrl.selectEeSource(ee,true)" ng-disabled="true" ng-dblclick="$ctrl.selectEeSource(ee, true)"> <td> <input name="selectedEe" type="radio" ng-model="$ctrl.selectedEe" ng-value="ee" ng-disabled="ee.disable"> </td> <td class="text-ellipsis"> <span uib-tooltip-html="ee.titleSystem | translate" ng-bind-html="$ctrl.formatSystemTitle(ee.titleSystem) | translate"></span> </td> <td class="text-ellipsis"> <span uib-tooltip="{{ee.editorialEntityTemplate.wording}}">{{ee.editorialEntityTemplate.wording}}</span> </td> <td>{{ee.workflowStatus}}</td> <td> <padlock-icon color="ee.padlock.color" closed="ee.padlock.closed" owner="ee.padlock.owner.fullName" size="small"> </padlock-icon> </td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="5" class="text-center"> <div st-pagination="" st-items-by-page="10"></div> </td> </tr> <tr ng-if="$ctrl.sourceEesList.length == 0"> <td colspan="5" class="text-center">{{\'userApp.linkEEWizard.labels.noEEFound\' | translate}}</td> </tr> </tfoot> </table> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/ee-sub-element-selection/ee-sub-element-selection.tpl.html','<tree-view editorial-entity="$ctrl.eeSource" readonly="true" is-display-radio-button="true" on-node-check="$ctrl.onNodeCheck(checkedNode)" on-node-action="$ctrl.onNodeAction(selectedNode)"> </tree-view> ');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/proof-channel-selection/proof-channel-selection.tpl.html','<div class="form-group form-group-sm"> <div class="col-md-10"> <div ng-if="!$ctrl.canalsFromProduct" class="form-group form-group-sm"> <div class="col-md-2"> <label class="control-label"> <span translate="userApp.proof.list.channel"></span> </label> </div> <div class="col-md-10"> <div ng-repeat="channel in $ctrl.proofChannels" class="radio"> <label>&nbsp;<input type="radio" name="channel.ticked" ng-change="$ctrl.selectProofChannel()" data-ng-model="$ctrl.selectedProofChannel" data-ng-value="channel" required="">{{channel.name}}</label> </div> </div> </div> <div ng-if="$ctrl.canalsFromProduct"> <div class="row"> <div class="col-md-5"> <label> <span charset="UTF-8" translate="userApp.proof.list.channels"></span> </label> </div> </div> <div ng-repeat="item in $ctrl.productChannels"> <fieldset class="ecm-fieldset"> <legend class="no-margin"> <label>{{item.productWording}}</label> </legend> <div class="row"> <div ng-repeat="channel in item.publicationChannel" class="col-md-2"> <label>&nbsp;<input type="radio" ng-change="$ctrl.selectProofChannel(item.productCode, item.productWording)" data-ng-model="$ctrl.selectedProofChannel" data-ng-value="channel" required="">{{channel.name}}</label> </div> </div> </fieldset> </div> </div> </div> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/relation-reference-node/relation-reference-node.tpl.html','<div block-ui="displayMetaDataDiv" class="panel panel-default form-horizontal" style="padding: 10px"> <form name="$ctrl.relationForm" novalidate=""> <div class="panel-body"> <div class="form-group form-group-sm" ng-if="$ctrl.targetEntities && $ctrl.targetEntities.length > 1 && !$ctrl.isLinked"> <div class="col-sm-4"> <label class="control-label" style="text-align: left;"> <span translate="userApp.linkEEWizard.labels.duplicateMeta"></span> </label> </div> <div class="col-sm-8"> <div class="checkbox"> <label> <input type="checkbox" ng-model="$ctrl.multiRelation" ng-change="$ctrl.initRelations()"> </label> </div> </div> </div> <div ng-if="!$ctrl.isLinked && $ctrl.multiRelation" ng-init="parentIndex = $index"> <div class="form-group form-group-sm" ng-show="$ctrl.isEeSourceContainer()"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.linkEEWizard.labels.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-3"> <ecm-datepicker ng-disabled="$ctrl.containerSources.length > 0" ng-model="$ctrl.desiredPublicationDate" ng-change="$ctrl.userInputChanged()" ng-required="$ctrl.isEeSourceContainer()"></ecm-datepicker> </div> </div>  <div class="form-group form-group-sm" ng-show="$ctrl.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <label class="control-label"> <span translate="userApp.linkEEWizard.labels.alreadyHookedToContainerSource"></span> </label> </div> </div> <div class="form-group form-group-sm" ng-show="$ctrl.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <ul> <li ng-repeat="source in $ctrl.containerSources"> <a href="" target="_blank" ui-sref="editorialEntity({id: source.identifier})"> <span ng-bind-html="source.titleSystem | translate"></span> </a> </li> </ul> </div> </div> <meta-data-field readonly="false" meta-data-instance="metaInstance" ng-repeat="metaInstance in $ctrl.relationMetaDatasList" form="relationForm" lang="$ctrl.lang" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.productCode"> </meta-data-field> </div> <uib-accordion ng-if="!$ctrl.multiRelation || $ctrl.isLinked"> <div uib-accordion-group="" class="panel-default" ng-repeat="relation in $ctrl.relations" is-open="relation.isOpen" ng-init="relation.isOpen = $first"> <uib-accordion-heading> <div style="line-height: 1em;"> {{$ctrl.trustAsHtml(relation.wording)}} <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': relation.isOpen, \'glyphicon-chevron-right\': !relation.isOpen}"></i> </div> </uib-accordion-heading> <div class="form-group form-group-sm" ng-show="$ctrl.isEeSourceContainer()"> <div class="col-sm-4"> <label class="control-label"> <span translate="userApp.linkEEWizard.labels.desiredPublicationDate"></span> <span class="text-danger"> *</span> </label> </div> <div class="col-sm-3"> <ecm-datepicker ng-disabled="relation.display" ng-model="relation.desiredPublicationDate" ng-required="$ctrl.isEeSourceContainer()"></ecm-datepicker> </div> </div>  <div class="form-group form-group-sm" ng-show="relation.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <label class="control-label"> <span translate="userApp.linkEEWizard.labels.alreadyHookedToContainerSource"></span> </label> </div> </div> <div class="form-group form-group-sm" ng-show="relation.containerSources.length > 0 && relation.display"> <div class="col-sm-4 col-md-offset-4"> <ul> <li ng-repeat="source in relation.containerSources"> <a href="" target="_blank" ui-sref="editorialEntity({id: source.identifier})"> <span ng-bind-html="source.titleSystem | translate"></span> </a> </li> </ul> </div> </div> <meta-data-field readonly="false" meta-data-instance="metaInstance" form="relationForm" lang="$ctrl.lang" ng-repeat="metaInstance in relation.metaInstanceDTOList" display="false" max-size-media="maxSizeMedia" editmetaee="true" product-code="$ctrl.productCode"> </meta-data-field> </div> </uib-accordion> </div> </form> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/link-ee-wizard/link-ee-wizard-form/steps/tr-selection/tr-selection.tpl.html','<div block-ui="displayTrListDiv"> <table st-table="$ctrl.relationshipTemplateList" class="table bg-white table-striped table-bordered table-hover table-fixed ui-grid uigridTable"> <thead> <tr> <th class="icon-column"></th> <th>{{\'userApp.linkEEWizard.labels.label\' | translate}}</th> </tr> </thead> <tbody> <tr ng-repeat="relationshipTemplate in $ctrl.relationshipTemplateList" ng-dblclick="$ctrl.selectTr(relationshipTemplate,true)" ng-click="$ctrl.selectTr(relationshipTemplate,true)" ng-class="{\'disabled-node\' : relationshipTemplate.disable}"> <td><input name="selectedTr" type="radio" ng-model="$ctrl.selectedTr" ng-value="relationshipTemplate" ng-disabled="relationshipTemplate.disable"></td> <td class="text-ellipsis"><span uib-tooltip="{{ relationshipTemplate.wording }}">{{ relationshipTemplate.wording }}</span></td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="2" class="text-center"> <div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="10"></div> </td> </tr> <tr ng-if="$ctrl.relationshipTemplateList.length == 0"> <td colspan="2" class="text-center">{{\'userApp.linkEEWizard.labels.noTRFound\' | translate}}</td> </tr> </tfoot> </table> </div>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/steps/edit-meta-target-entity/edit-converted-entity.tpl.html','<edit-metadata-form-component max-size-media="$ctrl.infosForPersist.maxSizeMedia" meta-data-by-meta-group="$ctrl.infosForPersist.metaDataInstancesByGroupDTOs" flash-id="$ctrl.infosForPersist.flashId" is-accept-proposal="$ctrl.isAcceptProposal" type="$ctrl.type" entity="$ctrl.editorialEntity" product-code="$ctrl.infosForPersist.productCode" auto-redirect="$ctrl.autoRedirect" code-eet="$ctrl.infosForPersist.editorialEntityTemplateCode" eet-id="$ctrl.infosForPersist.editorialEntityTemplateCode" current-user="$ctrl.infosForPersist.currentUser" modal-title="$ctrl.modalTitle" current-products="$ctrl.infosForPersist.lisProductDtos" all-models="$ctrl.infosForPersist.allModelList" product-suggested-publication-date="$ctrl.infosForPersist.suggestedPublicationDate" edit-meta-use-case="$ctrl.editMetaUseCase" on-entity-converted="$ctrl.onEntityConverted()" on="" on-close="$ctrl.close()" on-dismiss="$ctrl.dismiss()"></edit-metadata-form-component>');
$templateCache.put('scripts/pre-upgrade/components/editorial-entity/actions/convert-entity/convert-entity-form/steps/tee-selection/tee-selection.tpl.html','<div block-ui="displayTeeListDiv"> <table st-table="$ctrl.convertibleTemplatesList" class="table bg-white table-striped table-bordered table-hover table-fixed ui-grid uigridTable"> <thead> <tr> <th class="icon-column"></th> <th>{{\'userApp.editorialEntity.convert.label\' | translate}}</th> </tr> </thead> <tbody> <tr ng-repeat="convertibleTemplate in $ctrl.convertibleTemplatesList" ng-dblclick="$ctrl.selectTee(convertibleTemplate,true)" ng-click="$ctrl.selectTee(convertibleTemplate,false)" ng-class="{\'disabled-node\' : !convertibleTemplate.authorized}"> <td><input name="selectTee" type="radio" ng-model="$ctrl.selectedTee" ng-value="convertibleTemplate" ng-disabled="!convertibleTemplate.authorized"></td> <td class="text-ellipsis"><span uib-tooltip="{{ convertibleTemplate.wording }}">{{ convertibleTemplate.wording }}</span></td> </tr> </tbody> <tfoot class="bg-white"> <tr> <td colspan="2" class="text-center"> <div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="10"></div> </td> </tr> <tr ng-if="$ctrl.convertibleTemplatesList.length == 0"> <td colspan="2" class="text-center">{{\'userApp.editorialEntity.convert.noTeeTargetFound\' | translate}}</td> </tr> </tfoot> </table> </div>');}]);